(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("@brightcove/studio-icons"), (function webpackLoadOptionalExternalModule() { try { return require("react-dnd"); } catch(e) {} }()), (function webpackLoadOptionalExternalModule() { try { return require("react-dnd-html5-backend"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "@brightcove/studio-icons", "react-dnd", "react-dnd-html5-backend"], factory);
	else if(typeof exports === 'object')
		exports["StudioComponents"] = factory(require("react"), require("react-dom"), require("@brightcove/studio-icons"), (function webpackLoadOptionalExternalModule() { try { return require("react-dnd"); } catch(e) {} }()), (function webpackLoadOptionalExternalModule() { try { return require("react-dnd-html5-backend"); } catch(e) {} }()));
	else
		root["StudioComponents"] = factory(root["react"], root["react-dom"], root["@brightcove/studio-icons"], root["react-dnd"], root["react-dnd-html5-backend"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__125__, __WEBPACK_EXTERNAL_MODULE__200__, __WEBPACK_EXTERNAL_MODULE__218__, __WEBPACK_EXTERNAL_MODULE__527__, __WEBPACK_EXTERNAL_MODULE__528__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var js_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "keycode", function() { return js_util__WEBPACK_IMPORTED_MODULE_0__["keycode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KEYCODES", function() { return js_util__WEBPACK_IMPORTED_MODULE_0__["KEYCODES"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "handleKeyboardClick", function() { return js_util__WEBPACK_IMPORTED_MODULE_0__["handleKeyboardClick"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KeyCode", function() { return js_util__WEBPACK_IMPORTED_MODULE_0__["KeyCode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useGlobalStyles", function() { return js_util__WEBPACK_IMPORTED_MODULE_0__["useGlobalStyles"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "enableSmartFocusOutlines", function() { return js_util__WEBPACK_IMPORTED_MODULE_0__["enableSmartFocusOutlines"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "overrideStudioModuleFontFamily", function() { return js_util__WEBPACK_IMPORTED_MODULE_0__["overrideStudioModuleFontFamily"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "initialize", function() { return js_util__WEBPACK_IMPORTED_MODULE_0__["initialize"]; });

/* harmony import */ var js_components_Accordion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(145);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Accordion", function() { return js_components_Accordion__WEBPACK_IMPORTED_MODULE_1__["Accordion"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AccordionSummary", function() { return js_components_Accordion__WEBPACK_IMPORTED_MODULE_1__["AccordionSummary"]; });

/* harmony import */ var js_components_Alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(229);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return js_components_Alert__WEBPACK_IMPORTED_MODULE_2__["Alert"]; });

/* harmony import */ var js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(235);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Autosave", function() { return js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__["Autosave"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveInput", function() { return js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__["AutosaveInput"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveLoader", function() { return js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__["AutosaveLoader"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveRadioGroup", function() { return js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__["AutosaveRadioGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveSelect", function() { return js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__["AutosaveSelect"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveTextArea", function() { return js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__["AutosaveTextArea"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveTagList", function() { return js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__["AutosaveTagList"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveTagListSuggestions", function() { return js_components_Autosave__WEBPACK_IMPORTED_MODULE_3__["AutosaveTagListSuggestions"]; });

/* harmony import */ var js_components_Async__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(483);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return js_components_Async__WEBPACK_IMPORTED_MODULE_4__["Async"]; });

/* harmony import */ var js_components_Blast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(485);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Blast", function() { return js_components_Blast__WEBPACK_IMPORTED_MODULE_5__["Blast"]; });

/* harmony import */ var js_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(489);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return js_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_6__["Breadcrumbs"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return js_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_6__["BreadcrumbItem"]; });

/* harmony import */ var js_components_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(469);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return js_components_Button__WEBPACK_IMPORTED_MODULE_7__["Button"]; });

/* harmony import */ var js_components_ButtonGroup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(494);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return js_components_ButtonGroup__WEBPACK_IMPORTED_MODULE_8__["ButtonGroup"]; });

/* harmony import */ var js_components_Card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(498);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return js_components_Card__WEBPACK_IMPORTED_MODULE_9__["Card"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return js_components_Card__WEBPACK_IMPORTED_MODULE_9__["CardHeader"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardBody", function() { return js_components_Card__WEBPACK_IMPORTED_MODULE_9__["CardBody"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardFooter", function() { return js_components_Card__WEBPACK_IMPORTED_MODULE_9__["CardFooter"]; });

/* harmony import */ var js_components_Checkbox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(512);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return js_components_Checkbox__WEBPACK_IMPORTED_MODULE_10__["Checkbox"]; });

/* harmony import */ var js_components_CheckboxGroup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(516);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxGroup", function() { return js_components_CheckboxGroup__WEBPACK_IMPORTED_MODULE_11__["CheckboxGroup"]; });

/* harmony import */ var js_components_Collapse__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(159);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return js_components_Collapse__WEBPACK_IMPORTED_MODULE_12__["Collapse"]; });

/* harmony import */ var js_components_CopyField__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(520);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CopyField", function() { return js_components_CopyField__WEBPACK_IMPORTED_MODULE_13__["CopyField"]; });

/* harmony import */ var js_components_Definition__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(225);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Definition", function() { return js_components_Definition__WEBPACK_IMPORTED_MODULE_14__["Definition"]; });

/* harmony import */ var js_components_Draggable__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(524);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContainer", function() { return js_components_Draggable__WEBPACK_IMPORTED_MODULE_15__["DragContainer"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return js_components_Draggable__WEBPACK_IMPORTED_MODULE_15__["DragContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragItem", function() { return js_components_Draggable__WEBPACK_IMPORTED_MODULE_15__["DragItem"]; });

/* harmony import */ var js_components_DropdownButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(537);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownButton", function() { return js_components_DropdownButton__WEBPACK_IMPORTED_MODULE_16__["DropdownButton"]; });

/* harmony import */ var js_components_DropdownMenu__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(504);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return js_components_DropdownMenu__WEBPACK_IMPORTED_MODULE_17__["DropdownMenu"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownMenuItem", function() { return js_components_DropdownMenu__WEBPACK_IMPORTED_MODULE_17__["DropdownMenuItem"]; });

/* harmony import */ var js_components_ExpandableSection__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(542);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpandableSection", function() { return js_components_ExpandableSection__WEBPACK_IMPORTED_MODULE_18__["ExpandableSection"]; });

/* harmony import */ var js_components_Fadeable__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(201);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fadeable", function() { return js_components_Fadeable__WEBPACK_IMPORTED_MODULE_19__["Fadeable"]; });

/* harmony import */ var js_components_Flex__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(195);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Flex", function() { return js_components_Flex__WEBPACK_IMPORTED_MODULE_20__["Flex"]; });

/* harmony import */ var js_components_FlexItem__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(240);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlexItem", function() { return js_components_FlexItem__WEBPACK_IMPORTED_MODULE_21__["FlexItem"]; });

/* harmony import */ var js_components_Form__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(549);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return js_components_Form__WEBPACK_IMPORTED_MODULE_22__["Form"]; });

/* harmony import */ var js_components_FormError__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(252);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormError", function() { return js_components_FormError__WEBPACK_IMPORTED_MODULE_23__["FormError"]; });

/* harmony import */ var js_components_Hideable__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(231);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hideable", function() { return js_components_Hideable__WEBPACK_IMPORTED_MODULE_24__["Hideable"]; });

/* harmony import */ var js_components_Hint__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(256);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hint", function() { return js_components_Hint__WEBPACK_IMPORTED_MODULE_25__["Hint"]; });

/* harmony import */ var js_components_Icon__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(216);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return js_components_Icon__WEBPACK_IMPORTED_MODULE_26__["Icon"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ICONS", function() { return js_components_Icon__WEBPACK_IMPORTED_MODULE_26__["ICONS"]; });

/* harmony import */ var js_components_IconButton__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(242);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IconButton", function() { return js_components_IconButton__WEBPACK_IMPORTED_MODULE_27__["IconButton"]; });

/* harmony import */ var js_components_Input__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(369);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return js_components_Input__WEBPACK_IMPORTED_MODULE_28__["Input"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainInput", function() { return js_components_Input__WEBPACK_IMPORTED_MODULE_28__["PlainInput"]; });

/* harmony import */ var js_components_InputGroup__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(249);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return js_components_InputGroup__WEBPACK_IMPORTED_MODULE_29__["InputGroup"]; });

/* harmony import */ var js_components_Label__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(551);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return js_components_Label__WEBPACK_IMPORTED_MODULE_30__["Label"]; });

/* harmony import */ var js_components_Loader__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(472);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Loader", function() { return js_components_Loader__WEBPACK_IMPORTED_MODULE_31__["Loader"]; });

/* harmony import */ var js_components_Pill__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(555);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pill", function() { return js_components_Pill__WEBPACK_IMPORTED_MODULE_32__["Pill"]; });

/* harmony import */ var js_components_PlusMinusButtons__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(559);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlusMinusButtons", function() { return js_components_PlusMinusButtons__WEBPACK_IMPORTED_MODULE_33__["PlusMinusButtons"]; });

/* harmony import */ var js_components_Portal__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(210);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return js_components_Portal__WEBPACK_IMPORTED_MODULE_34__["Portal"]; });

/* harmony import */ var js_components_Progress__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(563);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return js_components_Progress__WEBPACK_IMPORTED_MODULE_35__["Progress"]; });

/* harmony import */ var js_components_Rule__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(567);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rule", function() { return js_components_Rule__WEBPACK_IMPORTED_MODULE_36__["Rule"]; });

/* harmony import */ var js_components_MenuItem__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(478);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return js_components_MenuItem__WEBPACK_IMPORTED_MODULE_37__["MenuItem"]; });

/* harmony import */ var js_components_Modal__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(571);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return js_components_Modal__WEBPACK_IMPORTED_MODULE_38__["Modal"]; });

/* harmony import */ var js_components_Notice__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(589);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Notice", function() { return js_components_Notice__WEBPACK_IMPORTED_MODULE_39__["Notice"]; });

/* harmony import */ var js_components_Pager__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(591);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pager", function() { return js_components_Pager__WEBPACK_IMPORTED_MODULE_40__["Pager"]; });

/* harmony import */ var js_components_Panel__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(596);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return js_components_Panel__WEBPACK_IMPORTED_MODULE_41__["Panel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelTitleBar", function() { return js_components_Panel__WEBPACK_IMPORTED_MODULE_41__["PanelTitleBar"]; });

/* harmony import */ var js_components_RadioGroup__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(375);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return js_components_RadioGroup__WEBPACK_IMPORTED_MODULE_42__["RadioGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainRadioGroup", function() { return js_components_RadioGroup__WEBPACK_IMPORTED_MODULE_42__["PlainRadioGroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioOption", function() { return js_components_RadioGroup__WEBPACK_IMPORTED_MODULE_42__["RadioOption"]; });

/* harmony import */ var js_components_RadioInput__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(598);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioInput", function() { return js_components_RadioInput__WEBPACK_IMPORTED_MODULE_43__["RadioInput"]; });

/* harmony import */ var js_components_SearchInput__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(600);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SearchInput", function() { return js_components_SearchInput__WEBPACK_IMPORTED_MODULE_44__["SearchInput"]; });

/* harmony import */ var js_components_Select__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(387);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return js_components_Select__WEBPACK_IMPORTED_MODULE_45__["Select"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainSelect", function() { return js_components_Select__WEBPACK_IMPORTED_MODULE_45__["PlainSelect"]; });

/* harmony import */ var js_components_Slider__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(606);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return js_components_Slider__WEBPACK_IMPORTED_MODULE_46__["Slider"]; });

/* harmony import */ var js_components_StreamPanel__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(611);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Drawer", function() { return js_components_StreamPanel__WEBPACK_IMPORTED_MODULE_47__["Drawer"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StreamPanel", function() { return js_components_StreamPanel__WEBPACK_IMPORTED_MODULE_47__["StreamPanel"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StreamStatus", function() { return js_components_StreamPanel__WEBPACK_IMPORTED_MODULE_47__["StreamStatus"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StreamIcon", function() { return js_components_StreamPanel__WEBPACK_IMPORTED_MODULE_47__["StreamIcon"]; });

/* harmony import */ var js_components_Table__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(618);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return js_components_Table__WEBPACK_IMPORTED_MODULE_48__["Table"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableHead", function() { return js_components_Table__WEBPACK_IMPORTED_MODULE_48__["TableHead"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableBody", function() { return js_components_Table__WEBPACK_IMPORTED_MODULE_48__["TableBody"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableRow", function() { return js_components_Table__WEBPACK_IMPORTED_MODULE_48__["TableRow"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableCell", function() { return js_components_Table__WEBPACK_IMPORTED_MODULE_48__["TableCell"]; });

/* harmony import */ var js_components_Tabs__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(626);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return js_components_Tabs__WEBPACK_IMPORTED_MODULE_49__["Tabs"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabList", function() { return js_components_Tabs__WEBPACK_IMPORTED_MODULE_49__["TabList"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return js_components_Tabs__WEBPACK_IMPORTED_MODULE_49__["Tab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SmallTab", function() { return js_components_Tabs__WEBPACK_IMPORTED_MODULE_49__["SmallTab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return js_components_Tabs__WEBPACK_IMPORTED_MODULE_49__["TabPanel"]; });

/* harmony import */ var js_components_Tag__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(448);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tag", function() { return js_components_Tag__WEBPACK_IMPORTED_MODULE_50__["Tag"]; });

/* harmony import */ var js_components_TagList__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(634);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagList", function() { return js_components_TagList__WEBPACK_IMPORTED_MODULE_51__["TagList"]; });

/* harmony import */ var js_components_TagListInput__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(407);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagListInput", function() { return js_components_TagListInput__WEBPACK_IMPORTED_MODULE_52__["TagListInput"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainTagListInput", function() { return js_components_TagListInput__WEBPACK_IMPORTED_MODULE_52__["PlainTagListInput"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosuggestTagListInput", function() { return js_components_TagListInput__WEBPACK_IMPORTED_MODULE_52__["AutosuggestTagListInput"]; });

/* harmony import */ var js_components_Target__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(530);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Target", function() { return js_components_Target__WEBPACK_IMPORTED_MODULE_53__["Target"]; });

/* harmony import */ var js_components_TextArea__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(401);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextArea", function() { return js_components_TextArea__WEBPACK_IMPORTED_MODULE_54__["TextArea"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainTextArea", function() { return js_components_TextArea__WEBPACK_IMPORTED_MODULE_54__["PlainTextArea"]; });

/* harmony import */ var js_components_Toast__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(638);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toaster", function() { return js_components_Toast__WEBPACK_IMPORTED_MODULE_55__["Toaster"]; });

/* harmony import */ var js_components_Thumbnail__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(669);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return js_components_Thumbnail__WEBPACK_IMPORTED_MODULE_56__["Thumbnail"]; });

/* harmony import */ var js_components_ToolTip__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(198);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ToolTip", function() { return js_components_ToolTip__WEBPACK_IMPORTED_MODULE_57__["ToolTip"]; });

/* harmony import */ var js_components_Wizard__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(673);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Wizard", function() { return js_components_Wizard__WEBPACK_IMPORTED_MODULE_58__["Wizard"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WizardStep", function() { return js_components_Wizard__WEBPACK_IMPORTED_MODULE_58__["WizardStep"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WizardControls", function() { return js_components_Wizard__WEBPACK_IMPORTED_MODULE_58__["WizardControls"]; });

/* harmony import */ var js_components_Toggle__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(191);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toggle", function() { return js_components_Toggle__WEBPACK_IMPORTED_MODULE_59__["Toggle"]; });

/* harmony import */ var js_components_FileInput__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(678);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileInput", function() { return js_components_FileInput__WEBPACK_IMPORTED_MODULE_60__["FileInput"]; });

/* harmony import */ var js_components_GaugeChart__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(682);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GaugeChart", function() { return js_components_GaugeChart__WEBPACK_IMPORTED_MODULE_61__["GaugeChart"]; });

/* harmony import */ var js_components_StatBox__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(689);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StatBox", function() { return js_components_StatBox__WEBPACK_IMPORTED_MODULE_62__["StatBox"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StatBoxGroup", function() { return js_components_StatBox__WEBPACK_IMPORTED_MODULE_62__["StatBoxGroup"]; });

/* harmony import */ var js_components_Theme__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(155);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Theme", function() { return js_components_Theme__WEBPACK_IMPORTED_MODULE_63__["Theme"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "provideTheme", function() { return js_components_Theme__WEBPACK_IMPORTED_MODULE_63__["provideTheme"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "themePalette", function() { return js_components_Theme__WEBPACK_IMPORTED_MODULE_63__["themePalette"]; });

/* harmony import */ var js_components_AnimatedIcon__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(265);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimatedIcon", function() { return js_components_AnimatedIcon__WEBPACK_IMPORTED_MODULE_64__["AnimatedIcon"]; });

/* harmony import */ var js_components_ImageUpload__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(698);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageUpload", function() { return js_components_ImageUpload__WEBPACK_IMPORTED_MODULE_65__["ImageUpload"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainImageUpload", function() { return js_components_ImageUpload__WEBPACK_IMPORTED_MODULE_65__["PlainImageUpload"]; });

/* harmony import */ var js_components_TileSelector__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(708);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileSelector", function() { return js_components_TileSelector__WEBPACK_IMPORTED_MODULE_66__["TileSelector"]; });

/* harmony import */ var js_components_TileSelectorGroup__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(712);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileSelectorGroup", function() { return js_components_TileSelectorGroup__WEBPACK_IMPORTED_MODULE_67__["TileSelectorGroup"]; });






































































/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _keycode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "keycode", function() { return _keycode__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KEYCODES", function() { return _keycode__WEBPACK_IMPORTED_MODULE_0__["KEYCODES"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "handleKeyboardClick", function() { return _keycode__WEBPACK_IMPORTED_MODULE_0__["handleKeyboardClick"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KeyCode", function() { return _keycode__WEBPACK_IMPORTED_MODULE_0__["KeyCode"]; });

/* harmony import */ var _useGlobalStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "useGlobalStyles", function() { return _useGlobalStyles__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _enableSmartFocusOutlines__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "enableSmartFocusOutlines", function() { return _enableSmartFocusOutlines__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _overrideStudioModuleFontFamily__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(108);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "overrideStudioModuleFontFamily", function() { return _overrideStudioModuleFontFamily__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _initialize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(114);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "initialize", function() { return _initialize__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(137);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "leftPad", function() { return _string__WEBPACK_IMPORTED_MODULE_5__["leftPad"]; });

/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(142);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatDuration", function() { return _duration__WEBPACK_IMPORTED_MODULE_6__["formatDuration"]; });















/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEYCODES", function() { return KEYCODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return keycode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyCode", function() { return KeyCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleKeyboardClick", function() { return handleKeyboardClick; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _deprecationWarning__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83);











var KEYCODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  pause: 19,
  capsLock: 20,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  insert: 45,
  delete: 46,
  '0': 48,
  '1': 49,
  '2': 50,
  '3': 51,
  '4': 52,
  '5': 53,
  '6': 54,
  '7': 55,
  '8': 56,
  '9': 57,
  colon: 58,
  '@': 64,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  leftWindow: 91,
  rightWindow: 92,
  select: 93,
  numpad0: 96,
  numpad1: 97,
  numpad2: 98,
  numpad3: 99,
  numpad4: 100,
  numpad5: 101,
  numpad6: 102,
  numpad7: 103,
  numpad8: 104,
  numpad9: 105,
  multiply: 106,
  add: 107,
  subtract: 109,
  decimal: 110,
  divide: 111,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  numLock: 144,
  scrollLock: 145,
  semiColon: 186,
  equalSign: 187,
  comma: 188,
  dash: 189,
  period: 190,
  forwardSlash: 191,
  backtick: 192,
  openBracket: 219,
  backSlash: 220,
  closeBraket: 221,
  singleQuote: 222
};
var RE = {
  shift: /^shift\+(\w+)$/
};

var Keycode = /*#__PURE__*/function () {
  function Keycode(event) {
    var _this = this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Keycode);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "handleClickIntent", function (callback) {
      if (_this.is('space enter')) {
        callback(_this.event);
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(this, "_matchDescription", function (desc) {
      if (RE.shift.test(desc)) {
        return _this.isShift(RE.shift.exec(desc)[1]);
      } else if (_this.code) {
        return _this.code.toString() === desc || _this.name === desc;
      }
    });

    this.event = event;
    this.code = event.keyCode || event.which;
    this.name = this.getName(this.code);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Keycode, [{
    key: "is",
    value: function is(description) {
      description = description.toString();
      return description.split(' ').some(this._matchDescription);
    }
  }, {
    key: "on",
    value: function on(handlers) {
      var _this2 = this;

      var matches = Object.keys(handlers).filter(function (description) {
        return _this2.is(description);
      });
      var handler = matches.length > 0 ? handlers[matches[0]] : handlers.default;

      if (handler && typeof handler === 'function') {
        return handler(this);
      }
    }
  }, {
    key: "isShift",
    value: function isShift(description) {
      return Boolean(this.event.shiftKey && this.is(description));
    }
  }, {
    key: "getName",
    value: function getName(code) {
      for (var prop in KEYCODES) {
        if (KEYCODES.hasOwnProperty(prop)) {
          if (KEYCODES[prop] === code) {
            return prop;
          }
        }
      }
    }
  }]);

  return Keycode;
}();

function keycode(event) {
  return new Keycode(event);
}
function KeyCode(event) {
  Object(_deprecationWarning__WEBPACK_IMPORTED_MODULE_10__["default"])('KeyCode is deprecated, use keycode instead');
  return new Keycode(event);
}
function handleKeyboardClick(callback) {
  if (callback && typeof callback === 'function') {
    return function (keyEvent) {
      return keycode(keyEvent).handleClickIntent(callback);
    };
  }
}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var exec = __webpack_require__(51);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var getOwnPropertyDescriptor = __webpack_require__(10).f;
var createNonEnumerableProperty = __webpack_require__(24);
var redefine = __webpack_require__(27);
var setGlobal = __webpack_require__(28);
var copyConstructorProperties = __webpack_require__(38);
var isForced = __webpack_require__(50);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  /* global globalThis -- safe */
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(9)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(11);
var propertyIsEnumerableModule = __webpack_require__(13);
var createPropertyDescriptor = __webpack_require__(14);
var toIndexedObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(19);
var has = __webpack_require__(21);
var IE8_DOM_DEFINE = __webpack_require__(22);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(16);
var requireObjectCoercible = __webpack_require__(18);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);
var classof = __webpack_require__(17);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(11);
var fails = __webpack_require__(12);
var createElement = __webpack_require__(23);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var isObject = __webpack_require__(20);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(11);
var definePropertyModule = __webpack_require__(25);
var createPropertyDescriptor = __webpack_require__(14);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(22);
var anObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(19);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var createNonEnumerableProperty = __webpack_require__(24);
var has = __webpack_require__(21);
var setGlobal = __webpack_require__(28);
var inspectSource = __webpack_require__(29);
var InternalStateModule = __webpack_require__(31);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var createNonEnumerableProperty = __webpack_require__(24);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(30);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var setGlobal = __webpack_require__(28);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(32);
var global = __webpack_require__(8);
var isObject = __webpack_require__(20);
var createNonEnumerableProperty = __webpack_require__(24);
var objectHas = __webpack_require__(21);
var shared = __webpack_require__(30);
var sharedKey = __webpack_require__(33);
var hiddenKeys = __webpack_require__(37);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var inspectSource = __webpack_require__(29);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(34);
var uid = __webpack_require__(36);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(35);
var store = __webpack_require__(30);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.9.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(21);
var ownKeys = __webpack_require__(39);
var getOwnPropertyDescriptorModule = __webpack_require__(10);
var definePropertyModule = __webpack_require__(25);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(40);
var getOwnPropertyNamesModule = __webpack_require__(42);
var getOwnPropertySymbolsModule = __webpack_require__(49);
var anObject = __webpack_require__(26);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(41);
var global = __webpack_require__(8);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);

module.exports = global;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(43);
var enumBugKeys = __webpack_require__(48);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(21);
var toIndexedObject = __webpack_require__(15);
var indexOf = __webpack_require__(44).indexOf;
var hiddenKeys = __webpack_require__(37);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(15);
var toLength = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(47);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(46);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(46);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 49 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__(52);
var stickyHelpers = __webpack_require__(53);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
// eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(26);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__(12);

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(55);
var redefine = __webpack_require__(27);
var toString = __webpack_require__(62);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(56);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var shared = __webpack_require__(34);
var has = __webpack_require__(21);
var uid = __webpack_require__(36);
var NATIVE_SYMBOL = __webpack_require__(57);
var USE_SYMBOL_AS_UID = __webpack_require__(61);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var IS_NODE = __webpack_require__(58);
var V8_VERSION = __webpack_require__(59);
var fails = __webpack_require__(12);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  /* global Symbol -- required for testing */
  return !Symbol.sham &&
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    (IS_NODE ? V8_VERSION === 38 : V8_VERSION > 37 && V8_VERSION < 41);
});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(17);
var global = __webpack_require__(8);

module.exports = classof(global.process) == 'process';


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var userAgent = __webpack_require__(60);

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(40);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(57);

module.exports = NATIVE_SYMBOL
  /* global Symbol -- safe */
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(55);
var classof = __webpack_require__(63);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(55);
var classofRaw = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(56);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__(27);
var anObject = __webpack_require__(26);
var fails = __webpack_require__(12);
var flags = __webpack_require__(52);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(11);
var defineProperty = __webpack_require__(25).f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(67);
var isRegExp = __webpack_require__(68);
var anObject = __webpack_require__(26);
var requireObjectCoercible = __webpack_require__(18);
var speciesConstructor = __webpack_require__(69);
var advanceStringIndex = __webpack_require__(71);
var toLength = __webpack_require__(45);
var callRegExpExec = __webpack_require__(73);
var regexpExec = __webpack_require__(51);
var fails = __webpack_require__(12);

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(6);
var redefine = __webpack_require__(27);
var fails = __webpack_require__(12);
var wellKnownSymbol = __webpack_require__(56);
var regexpExec = __webpack_require__(51);
var createNonEnumerableProperty = __webpack_require__(24);

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var classof = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(56);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var wellKnownSymbol = __webpack_require__(56);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(72).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(46);
var requireObjectCoercible = __webpack_require__(18);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(17);
var regexpExec = __webpack_require__(51);

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $filter = __webpack_require__(75).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(80);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(76);
var IndexedObject = __webpack_require__(16);
var toObject = __webpack_require__(77);
var toLength = __webpack_require__(45);
var arraySpeciesCreate = __webpack_require__(78);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(70);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(18);

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(79);
var wellKnownSymbol = __webpack_require__(56);

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(17);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);
var wellKnownSymbol = __webpack_require__(56);
var V8_VERSION = __webpack_require__(59);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var toObject = __webpack_require__(77);
var nativeKeys = __webpack_require__(82);
var fails = __webpack_require__(12);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(43);
var enumBugKeys = __webpack_require__(48);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return deprecationWarning; });
var prefix = '[studio-components] ';
var issuedMessages = {};
function deprecationWarning(message) {
  if (false) {}
  if (issuedMessages[message]) return;
  issuedMessages[message] = true;
  console.warn("".concat(prefix).concat(message));
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return useGlobalStyles; });
function useGlobalStyles() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'classic';

  __webpack_require__(85)("./".concat(theme, "/globals.sass"));
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./blueSteel/globals.sass": 86,
	"./classic/globals.sass": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(87);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Public+Sans:400,700,800);", ""]);

// module
exports.push([module.i, "*,:after,:before{box-sizing:border-box}*{outline-color:#092dbd}html{-moz-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Public Sans,sans-serif}body,html{margin:0;padding:0}html{font-size:16px}", ""]);

// exports


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(90);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 90 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(92);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700);", ""]);

// module
exports.push([module.i, "*,:after,:before{box-sizing:border-box}*{outline-color:#08b0cc}html{-moz-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Lato,Helvetica,Arial,sans-serif}body,html{margin:0;padding:0}html{font-size:15px}", ""]);

// exports


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return enableSmartFocusOutlines; });
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2);








function hasClass(el, className) {
  return el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}
/**
Focus outlines are the blue (typically) fuzzy outlines you see around elements
in the browser when you focus them. These are particularly useful for people
with vision impairments and people who use a keyboard exclusively to navigate
because the focused element may not be where the user is looking.

These outlines are unnecessary and aesthetically undesireable for people who
use a cursor to navigate. E.g. Showing a focus outline around a button or
input that you just clicked is not very helpful since these components have
hover, focus, and active states of their own to indicate whether they are
interactive or not.

Calling enableSmartFocusOutlines() will set up listeners to toggle showing
focus outlines based on whether the user is using the keyboard to navigate or
the mouse.
*/


function enableSmartFocusOutlines() {
  // Get some global styles
  __webpack_require__(106);

  document.addEventListener('keydown', function (evt) {
    if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_6__["default"])(evt).is('tab')) {
      document.body.className = document.body.className.replace(new RegExp('(?:^|\\s)' + 'hide-focus-outlines' + '(?:\\s|$)'), ' ').trim();
    }
  });
  document.addEventListener('mousedown', function (e) {
    if (!hasClass(document.body, 'hide-focus-outlines')) {
      document.body.className += ' hide-focus-outlines';
    }
  });
}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(67);
var anObject = __webpack_require__(26);
var toLength = __webpack_require__(45);
var requireObjectCoercible = __webpack_require__(18);
var advanceStringIndex = __webpack_require__(71);
var regExpExec = __webpack_require__(73);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(11);
var global = __webpack_require__(8);
var isForced = __webpack_require__(50);
var inheritIfRequired = __webpack_require__(96);
var defineProperty = __webpack_require__(25).f;
var getOwnPropertyNames = __webpack_require__(42).f;
var isRegExp = __webpack_require__(68);
var getFlags = __webpack_require__(52);
var stickyHelpers = __webpack_require__(53);
var redefine = __webpack_require__(27);
var fails = __webpack_require__(12);
var setInternalState = __webpack_require__(31).set;
var setSpecies = __webpack_require__(99);
var wellKnownSymbol = __webpack_require__(56);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || UNSUPPORTED_Y || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (!thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = getFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y && sticky) setInternalState(result, { sticky: sticky });

    return result;
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var setPrototypeOf = __webpack_require__(97);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__(26);
var aPossiblePrototype = __webpack_require__(98);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(40);
var definePropertyModule = __webpack_require__(25);
var wellKnownSymbol = __webpack_require__(56);
var DESCRIPTORS = __webpack_require__(11);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $trim = __webpack_require__(101).trim;
var forcedStringTrimMethod = __webpack_require__(103);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(18);
var whitespaces = __webpack_require__(102);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);
var whitespaces = __webpack_require__(102);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(67);
var anObject = __webpack_require__(26);
var toLength = __webpack_require__(45);
var toInteger = __webpack_require__(46);
var requireObjectCoercible = __webpack_require__(18);
var advanceStringIndex = __webpack_require__(71);
var getSubstitution = __webpack_require__(105);
var regExpExec = __webpack_require__(73);

var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(77);

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(107);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, "body.hide-focus-outlines a:focus,body.hide-focus-outlines button:focus,body.hide-focus-outlines input:focus,body.hide-focus-outlines select:focus,body.hide-focus-outlines textarea:focus{outline:none}body.hide-focus-outlines [tabindex]:focus{outline:none!important}", ""]);

// exports


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return overrideStudioModuleFontFamily; });
function overrideStudioModuleFontFamily() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'classic';

  __webpack_require__(109)("./".concat(theme, "/studioFontFamilyOverrides.sass"));
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./blueSteel/studioFontFamilyOverrides.sass": 110,
	"./classic/studioFontFamilyOverrides.sass": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(111);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700);", ""]);

// module
exports.push([module.i, "body,button,h1,h2,h3,h4,input,select,textarea{font-family:Public Sans,sans-serif}.studioFontFamilyOverrides-regular-2_3_6-5xwiv,.studioFontFamilyOverrides-semibold-2_3_6-2P82N,.studioFontFamilyOverrides-thin-2_3_6-28Mhi{font-family:inherit}", ""]);

// exports
exports.locals = {
	"semibold": "studioFontFamilyOverrides-semibold-2_3_6-2P82N",
	"regular": "studioFontFamilyOverrides-regular-2_3_6-5xwiv",
	"thin": "studioFontFamilyOverrides-thin-2_3_6-28Mhi"
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(113);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700);", ""]);

// module
exports.push([module.i, "body,button,h1,h2,h3,h4,input,select,textarea{font-family:Lato,Helvetica,Arial,sans-serif}.studioFontFamilyOverrides-regular-2_3_6-2owzJ,.studioFontFamilyOverrides-semibold-2_3_6-1Boye,.studioFontFamilyOverrides-thin-2_3_6-3xO2G{font-family:inherit}", ""]);

// exports
exports.locals = {
	"semibold": "studioFontFamilyOverrides-semibold-2_3_6-1Boye",
	"regular": "studioFontFamilyOverrides-regular-2_3_6-2owzJ",
	"thin": "studioFontFamilyOverrides-thin-2_3_6-3xO2G"
};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return initialize; });
/* harmony import */ var js_util_useGlobalStyles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84);
/* harmony import */ var js_util_enableSmartFocusOutlines__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93);
/* harmony import */ var js_util_overrideStudioModuleFontFamily__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(108);
/* harmony import */ var _components_Theme_provideTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(115);




function initialize() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    theme: 'blueSteel'
  };
  Object(js_util_useGlobalStyles__WEBPACK_IMPORTED_MODULE_0__["default"])(options.theme);
  Object(js_util_enableSmartFocusOutlines__WEBPACK_IMPORTED_MODULE_1__["default"])(options.theme);
  Object(js_util_overrideStudioModuleFontFamily__WEBPACK_IMPORTED_MODULE_2__["default"])(options.theme);

  if (options.theme) {
    Object(_components_Theme_provideTheme__WEBPACK_IMPORTED_MODULE_3__["setTheme"])(options.theme);
  }
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTheme", function() { return setTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return provideTheme; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(122);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var js_util_compatibility__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(126);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(128);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(129);







var theme = 'classic';

var getTheme = function getTheme() {
  return theme;
};

var setTheme = function setTheme(value) {
  if (_Theme__WEBPACK_IMPORTED_MODULE_6__["THEMES"].includes(value)) {
    theme = value;
  } else {
    console.warn('The theme name passed is not recognized, using default theme instead.');
  }
};
function provideTheme() {
  return function (Component) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.forwardRef(function (props, ref) {
      if (!Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_4__["hasCreateContext"])()) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
          ref: ref,
          theme: "classic"
        }, props));
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_ThemeContext__WEBPACK_IMPORTED_MODULE_5__["default"].Consumer, null, function (themeName) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
          theme: themeName ? themeName : getTheme(),
          ref: ref
        }, props));
      });
    });
  };
}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $includes = __webpack_require__(44).includes;
var addToUnscopables = __webpack_require__(118);

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(56);
var create = __webpack_require__(119);
var definePropertyModule = __webpack_require__(25);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(26);
var defineProperties = __webpack_require__(120);
var enumBugKeys = __webpack_require__(48);
var hiddenKeys = __webpack_require__(37);
var html = __webpack_require__(121);
var documentCreateElement = __webpack_require__(23);
var sharedKey = __webpack_require__(33);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(11);
var definePropertyModule = __webpack_require__(25);
var anObject = __webpack_require__(26);
var objectKeys = __webpack_require__(82);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(40);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var notARegExp = __webpack_require__(123);
var requireObjectCoercible = __webpack_require__(18);
var correctIsRegExpLogic = __webpack_require__(124);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__(68);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(56);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__125__;

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReact14", function() { return isReact14; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warnReact14", function() { return warnReact14; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasCreateContext", function() { return hasCreateContext; });
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(127);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


function isReact14() {
  return react__WEBPACK_IMPORTED_MODULE_1___default.a.version.startsWith('0.14');
}
function warnReact14(message) {
  if (isReact14() && "none" !== 'production') {
    console.warn(message);
  }
}
function hasCreateContext() {
  return react__WEBPACK_IMPORTED_MODULE_1___default.a.createContext != null;
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var getOwnPropertyDescriptor = __webpack_require__(10).f;
var toLength = __webpack_require__(45);
var notARegExp = __webpack_require__(123);
var requireObjectCoercible = __webpack_require__(18);
var correctIsRegExpLogic = __webpack_require__(124);
var IS_PURE = __webpack_require__(35);

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var js_util_compatibility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(126);


/* harmony default export */ __webpack_exports__["default"] = (Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_1__["hasCreateContext"])() ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext(null) : null);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THEMES", function() { return THEMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Theme; });
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_util_compatibility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(126);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(128);





var THEMES = ['classic', 'blueSteel'];
/**
 * Applies a theme to studio-components
 */

function Theme(props) {
  var children = props.children,
      name = props.name;

  if (!Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_3__["hasCreateContext"])()) {
    return children;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ThemeContext__WEBPACK_IMPORTED_MODULE_4__["default"].Provider, {
    value: name
  }, children);
}
Theme.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,

  /** The theme name to apply */
  name: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(THEMES)
};
Theme.defaultProps = {
  name: 'classic'
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (true) {
  var ReactIs = __webpack_require__(131);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(133)(ReactIs.isElement, throwOnDirectAccess);
} else {}


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(132);
}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (true) {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(131);
var assign = __webpack_require__(134);

var ReactPropTypesSecret = __webpack_require__(135);
var checkPropTypes = __webpack_require__(136);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (true) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (true) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if ( true && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (true) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : undefined;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (true) {
  var ReactPropTypesSecret = __webpack_require__(135);
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (true) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (true) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "leftPad", function() { return leftPad; });
/* harmony import */ var core_js_modules_es_string_pad_start_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_string_pad_start_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_start_js__WEBPACK_IMPORTED_MODULE_0__);

function leftPad(content, desiredLength, padString) {
  return String(content).padStart(desiredLength, padString);
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $padStart = __webpack_require__(139).start;
var WEBKIT_BUG = __webpack_require__(141);

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(45);
var repeat = __webpack_require__(140);
var requireObjectCoercible = __webpack_require__(18);

var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = String(requireObjectCoercible($this));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = toLength(maxLength);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(46);
var requireObjectCoercible = __webpack_require__(18);

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = ''.repeat || function repeat(count) {
  var str = String(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/zloirock/core-js/issues/280
var userAgent = __webpack_require__(60);

// eslint-disable-next-line unicorn/no-unsafe-regex -- safe
module.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SECOND", function() { return SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MINUTE", function() { return MINUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOUR", function() { return HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDuration", function() { return formatDuration; });
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(137);


var SECOND = 1000;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
function formatDuration(duration) {
  var hours = Math.floor(duration / HOUR);
  var hasHours = hours > 0;
  var hoursDuration = hours * HOUR;
  var minutes = Math.floor((duration - hoursDuration) / MINUTE);
  var minutesDuration = minutes * MINUTE;
  var remainingSecondsDuration = duration - hoursDuration - minutesDuration;
  var seconds = Math.round(remainingSecondsDuration / SECOND);
  var formattedMinutes = hasHours ? Object(_string__WEBPACK_IMPORTED_MODULE_1__["leftPad"])(minutes, 2, '0') : minutes;
  var formattedSeconds = Object(_string__WEBPACK_IMPORTED_MODULE_1__["leftPad"])(seconds, 2, '0');
  var parts = [formattedMinutes, formattedSeconds];

  if (hours > 0) {
    parts.unshift(hours);
  }

  return parts.join(':');
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IndexedObject = __webpack_require__(16);
var toIndexedObject = __webpack_require__(15);
var arrayMethodIsStrict = __webpack_require__(144);

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Accordion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(146);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Accordion", function() { return _Accordion__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _SummaryDetail__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(224);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AccordionSummary", function() { return _SummaryDetail__WEBPACK_IMPORTED_MODULE_1__["default"]; });





/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Accordion", function() { return Accordion; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);
/* harmony import */ var _Collapse__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(159);
/* harmony import */ var _Accordion_sass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(189);
/* harmony import */ var _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Accordion_sass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Toggle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(191);












var captureEvent = function captureEvent(event) {
  event.stopPropagation();
};
/**
 * Expandable panel, useful for showing summary information that users can
 * expand for greater detail
 */


function Accordion(_ref) {
  var _cx;

  var action = _ref.action,
      children = _ref.children,
      className = _ref.className,
      defaultOpen = _ref.defaultOpen,
      disabled = _ref.disabled,
      label = _ref.label,
      onToggle = _ref.onToggle,
      open = _ref.open,
      pristine = _ref.pristine,
      summary = _ref.summary,
      helper = _ref.helper,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme,
      showToggle = _ref.showToggle;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(defaultOpen),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_useState, 2),
      internalOpen = _useState2[0],
      setOpen = _useState2[1];

  var isOpen = open != null ? open : internalOpen;

  var toggleState = function toggleState() {
    if (!disabled) {
      if (open != null) {
        onToggle(!open);
      } else {
        setOpen(!internalOpen);
      }
    }
  };

  var handleKey = function handleKey(event) {
    if (event.currentTarget === event.target) {
      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_6__["default"])(event).is('enter space')) {
        event.preventDefault();
        toggleState();
      }
    }
  };

  var containerClasses = classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a[theme], _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.container, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.open, isOpen), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.disabled, disabled), _cx));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    style: style,
    className: containerClasses,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.titleBar, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.noToggle, !showToggle)),
    role: disabled || showToggle ? 'presentation' : 'button',
    "aria-expanded": String(!isOpen),
    "aria-label": label,
    tabIndex: disabled || showToggle ? -1 : 0,
    onClick: showToggle ? null : toggleState,
    onKeyDown: showToggle ? null : handleKey
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.labelContainer
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("h3", {
    className: _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.label
  }, label)), summary ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.summary, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.pristine, pristine))
  }, !isOpen ? summary : null) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.action,
    onClick: captureEvent
  }, showToggle ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Toggle__WEBPACK_IMPORTED_MODULE_10__["Toggle"], {
    disabled: disabled,
    value: isOpen,
    onChange: toggleState,
    "aria-expanded": String(!isOpen),
    "aria-label": label
  }) : action)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Collapse__WEBPACK_IMPORTED_MODULE_8__["Collapse"], {
    show: isOpen
  }, helper ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.helperText
  }, helper) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a.content
  }, children)));
}
Accordion.propTypes = {
  /** Primary action within the panel title bar */
  action: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Whether the accordion will initially be open or closed */
  defaultOpen: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Sets whether the user can expand or collapse the panel */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Panel title */
  label: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /**
   * Callback function that is called when the user clicks on the title bar.
   * Will be called with the expected next state (`true` if it should expand
   * next, `false` if it should collapse next)
   * `(shouldOpen: boolean) => void`
   */
  onToggle: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_5___default()(prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func, function (props) {
    return props.open;
  }),

  /**
   * Use `open` and `onToggle` props to use this component as a controlled
   * component. By default, the accordion will track its collapsed state using
   * internal state. If this prop is provided, the developer will be responsible
   * for tracking collapsed state instead.
   */
  open: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /**
   * If the accordion contains controls to modify an item, specifies that the
   * controls are currently in their default state
   */
  pristine: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Secondary supporting text, often a summary of the panel contents */
  summary: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Show a toggle component to open/close the accordion */
  showToggle: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Show helper information above the content when accordion is open */
  helper: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node
};
Accordion.defaultProps = {
  defaultOpen: false,
  disabled: false,
  pristine: false,
  showToggle: false
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_Accordion_sass__WEBPACK_IMPORTED_MODULE_9___default.a)(Accordion));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(148);

var iterableToArrayLimit = __webpack_require__(149);

var unsupportedIterableToArray = __webpack_require__(150);

var nonIterableRest = __webpack_require__(152);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 149 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(151);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var VALIDATOR_ARG_ERROR_MESSAGE='The typeValidator argument must be a function with the signature function(props, propName, componentName).',MESSAGE_ARG_ERROR_MESSAGE='The error message is optional, but must be a string if provided.',propIsRequired=function propIsRequired(a,b,c,d){if('boolean'==typeof a)return a;return'function'==typeof a?a(b,c,d):!(!0!==!!a)&&!!a},propExists=function propExists(a,b){return Object.hasOwnProperty.call(a,b)},missingPropError=function missingPropError(a,b,c,d){return d?new Error(d):new Error('Required '+a[b]+' `'+b+'`'+(' was not specified in `'+c+'`.'))},guardAgainstInvalidArgTypes=function guardAgainstInvalidArgTypes(a,b){if('function'!=typeof a)throw new TypeError(VALIDATOR_ARG_ERROR_MESSAGE);if(!!b&&'string'!=typeof b)throw new TypeError(MESSAGE_ARG_ERROR_MESSAGE)},isRequiredIf=function isRequiredIf(a,b,c){return guardAgainstInvalidArgTypes(a,c),function(d,e,f){for(var _len=arguments.length,g=Array(3<_len?_len-3:0),_key=3;_key<_len;_key++)g[_key-3]=arguments[_key];return propIsRequired(b,d,e,f)?propExists(d,e)?a.apply(void 0,[d,e,f].concat(g)):missingPropError(d,e,f,c):a.apply(void 0,[d,e,f].concat(g));// Is not required, so just run typeValidator.
}};exports.default=isRequiredIf;

//# sourceMappingURL=isRequiredIf.js.map

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(129);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Theme", function() { return _Theme__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _provideTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(115);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "provideTheme", function() { return _provideTheme__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _ThemePalette__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(156);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "themePalette", function() { return _ThemePalette__WEBPACK_IMPORTED_MODULE_2__["default"]; });








/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return themePalette; });
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _brightcove_studio_design_tokens_themes_classic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(157);
/* harmony import */ var _brightcove_studio_design_tokens_themes_classic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_brightcove_studio_design_tokens_themes_classic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _brightcove_studio_design_tokens_themes_blueSteel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(158);
/* harmony import */ var _brightcove_studio_design_tokens_themes_blueSteel__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_brightcove_studio_design_tokens_themes_blueSteel__WEBPACK_IMPORTED_MODULE_3__);




var THEME_PALETTES = {
  classic: _brightcove_studio_design_tokens_themes_classic__WEBPACK_IMPORTED_MODULE_2___default.a,
  bluesteel: _brightcove_studio_design_tokens_themes_blueSteel__WEBPACK_IMPORTED_MODULE_3___default.a
};
function themePalette(theme) {
  var standarized = theme.replace('-', '').toLowerCase();

  if (THEME_PALETTES[standarized]) {
    return THEME_PALETTES[standarized];
  }

  return _brightcove_studio_design_tokens_themes_classic__WEBPACK_IMPORTED_MODULE_2___default.a;
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true});
var focusOutline = exports.focusOutline = '#08b0cc';
var textPrimaryDark = exports.textPrimaryDark = '#444444';
var textSecondaryDark = exports.textSecondaryDark = '#666666';
var textTertiaryDark = exports.textTertiaryDark = '#888888';
var textPrimaryLight = exports.textPrimaryLight = 'white';
var textSecondaryLight = exports.textSecondaryLight = 'rgba(255, 255, 255, 0.8)';
var textTertiaryLight = exports.textTertiaryLight = '#999999';
var textMedium = exports.textMedium = '#cccccc';
var textTooltip = exports.textTooltip = '#eeeeee';
var contentBg = exports.contentBg = 'white';
var errorColor = exports.errorColor = '#ba2453';
var statusOk = exports.statusOk = '#a2b00c';
var statusAverage = exports.statusAverage = '#079bb3';
var statusPoor = exports.statusPoor = '#d32781';
var linkColorDark = exports.linkColorDark = '#079bb3';
var linkColorLight = exports.linkColorLight = 'white';
var linkColorDisabled = exports.linkColorDisabled = '#aaaaaa';
var alertBg = exports.alertBg = '#fde86a';
var alertBgError = exports.alertBgError = '#d32781';
var alertBgDetails = exports.alertBgDetails = 'rgba(white, 0.1)';
var warningBg = exports.warningBg = '#ef6c2a';
var accountInfo = exports.accountInfo = '#a2b00c';
var iconDisabled = exports.iconDisabled = '#cccccc';
var buttonBgPrimary = exports.buttonBgPrimary = '#079bb3';
var buttonBgSecondary = exports.buttonBgSecondary = '#a2b00c';
var buttonBgDestructive = exports.buttonBgDestructive = '#d32781';
var buttonBgInverse = exports.buttonBgInverse = 'white';
var buttonBgUnselected = exports.buttonBgUnselected = '#eef6f6';
var sidebarBg = exports.sidebarBg = '#333333';
var sidebarHover = exports.sidebarHover = '#484848';
var sidebarSelected = exports.sidebarSelected = 'black';
var borderColor = exports.borderColor = '#dddddd';
var inputBorder = exports.inputBorder = '#aaaaaa';
var inputBorderDisabled = exports.inputBorderDisabled = '#cccccc';
var inputBorderHover = exports.inputBorderHover = '#999999';
var inputBorderActive = exports.inputBorderActive = '#777777';
var inputBorderFocus = exports.inputBorderFocus = '#777777';
var inputBg = exports.inputBg = 'white';
var inputBgDisabled = exports.inputBgDisabled = '#f4f4f4';
var inputDisabled = exports.inputDisabled = '#999999';
var inputShadow = exports.inputShadow = '#aaaaaa';
var highlightPrimary = exports.highlightPrimary = '#dcf3fb';
var highlightSecondary = exports.highlightSecondary = '#effbff';
var labelColor = exports.labelColor = '#666666';
var modalHeaderBg = exports.modalHeaderBg = '#079bb3';
var modalBodyBg = exports.modalBodyBg = 'white';
var modalFooterBg = exports.modalFooterBg = '#dddddd';
var modalOverlay = exports.modalOverlay = 'rgba(47, 79, 79, 0.6)';
var pageHeaderBg = exports.pageHeaderBg = '#079bb3';
var panelHeaderBg = exports.panelHeaderBg = '#f4f4f4';
var tableHeaderBg = exports.tableHeaderBg = '#f4f4f4';
var tableBodyBg = exports.tableBodyBg = 'white';
var tagBgPrimary = exports.tagBgPrimary = '#079bb3';
var imageHoverBg = exports.imageHoverBg = '#dcf3fb';
var contentBgDark = exports.contentBgDark = 'black';
var columnWidth = exports.columnWidth = '8.5%';
var gutterWidth = exports.gutterWidth = '24px';
var paddingSm = exports.paddingSm = '8px';
var paddingMd = exports.paddingMd = '16px';
var inputHeight = exports.inputHeight = '36px';
var buttonHeight = exports.buttonHeight = '36px';
var headingFont = exports.headingFont = 'Lato, Helvetica, Arial, sans-serif';
var headingXlSize = exports.headingXlSize = '1.6875rem';
var headingLgSize = exports.headingLgSize = '1.5rem';
var headingMdSize = exports.headingMdSize = '1.25rem';
var bodyFont = exports.bodyFont = 'Lato, Helvetica, Arial, sans-serif';
var bodyWeightNormal = exports.bodyWeightNormal = '400';
var bodyTextSize = exports.bodyTextSize = '1rem';
var bodyTextLetterSpacing = exports.bodyTextLetterSpacing = 'normal';
var bodySmallWeightNormal = exports.bodySmallWeightNormal = '400';
var bodySmallTextSize = exports.bodySmallTextSize = '0.875rem';
var bodySmallTextLetterSpacing = exports.bodySmallTextLetterSpacing = 'normal';
var labelFont = exports.labelFont = 'Lato, Helvetica, Arial, sans-serif';
var labelFontSize = exports.labelFontSize = '0.933rem';
var labelFontWeight = exports.labelFontWeight = '700';
var labelLineHeight = exports.labelLineHeight = '24px';
var labelLetterSpacing = exports.labelLetterSpacing = 'normal';
var imageBtnFontSize = exports.imageBtnFontSize = '0.75rem';
var inputFontSize = exports.inputFontSize = '1rem';
var buttonFontSize = exports.buttonFontSize = '1rem';
var white = exports.white = 'white';
var black = exports.black = 'black';
var gray10 = exports.gray10 = '#f4f4f4';
var gray15 = exports.gray15 = '#eeeeee';
var gray20 = exports.gray20 = '#dddddd';
var gray30 = exports.gray30 = '#cccccc';
var gray35 = exports.gray35 = '#aaaaaa';
var gray40 = exports.gray40 = '#999999';
var gray50 = exports.gray50 = '#888888';
var gray55 = exports.gray55 = '#777777';
var gray57 = exports.gray57 = '#717171';
var gray60 = exports.gray60 = '#666666';
var gray70 = exports.gray70 = '#484848';
var gray80 = exports.gray80 = '#444444';
var gray90 = exports.gray90 = '#333333';
var whitePartialOpacity = exports.whitePartialOpacity = 'rgba(255, 255, 255, 0.8)';
var blueLightest = exports.blueLightest = '#effbff';
var blueLighter = exports.blueLighter = '#eef6f6';
var blueLight = exports.blueLight = '#dcf3fb';
var navy = exports.navy = '#293b70';
var teal = exports.teal = '#079bb3';
var tealLight = exports.tealLight = '#06b0cc';
var tealLighten05 = exports.tealLighten05 = '#08b0cc';
var tealDarken10 = exports.tealDarken10 = '#057082';
var pink = exports.pink = '#d32781';
var pinkLight = exports.pinkLight = '#f3d7e6';
var pinkLighten05 = exports.pinkLighten05 = '#da398d';
var pinkDarken10 = exports.pinkDarken10 = '#a81f67';
var magenta = exports.magenta = '#ba2453';
var yellowLight = exports.yellowLight = '#fdf0c0';
var gold = exports.gold = '#fde86a';
var orange = exports.orange = '#ef6c2a';
var orangeLighten05 = exports.orangeLighten05 = '#f17c42';
var orangeDarken10 = exports.orangeDarken10 = '#d65210';
var green = exports.green = '#a2b00c';
var greenLighten05 = exports.greenLighten05 = '#b8c80e';
var greenDarken10 = exports.greenDarken10 = '#768009';
var red = exports.red = '#d53c00';
exports.default = { 
  focusOutline: focusOutline,
  textPrimaryDark: textPrimaryDark,
  textSecondaryDark: textSecondaryDark,
  textTertiaryDark: textTertiaryDark,
  textPrimaryLight: textPrimaryLight,
  textSecondaryLight: textSecondaryLight,
  textTertiaryLight: textTertiaryLight,
  textMedium: textMedium,
  textTooltip: textTooltip,
  contentBg: contentBg,
  errorColor: errorColor,
  statusOk: statusOk,
  statusAverage: statusAverage,
  statusPoor: statusPoor,
  linkColorDark: linkColorDark,
  linkColorLight: linkColorLight,
  linkColorDisabled: linkColorDisabled,
  alertBg: alertBg,
  alertBgError: alertBgError,
  alertBgDetails: alertBgDetails,
  warningBg: warningBg,
  accountInfo: accountInfo,
  iconDisabled: iconDisabled,
  buttonBgPrimary: buttonBgPrimary,
  buttonBgSecondary: buttonBgSecondary,
  buttonBgDestructive: buttonBgDestructive,
  buttonBgInverse: buttonBgInverse,
  buttonBgUnselected: buttonBgUnselected,
  sidebarBg: sidebarBg,
  sidebarHover: sidebarHover,
  sidebarSelected: sidebarSelected,
  borderColor: borderColor,
  inputBorder: inputBorder,
  inputBorderDisabled: inputBorderDisabled,
  inputBorderHover: inputBorderHover,
  inputBorderActive: inputBorderActive,
  inputBorderFocus: inputBorderFocus,
  inputBg: inputBg,
  inputBgDisabled: inputBgDisabled,
  inputDisabled: inputDisabled,
  inputShadow: inputShadow,
  highlightPrimary: highlightPrimary,
  highlightSecondary: highlightSecondary,
  labelColor: labelColor,
  modalHeaderBg: modalHeaderBg,
  modalBodyBg: modalBodyBg,
  modalFooterBg: modalFooterBg,
  modalOverlay: modalOverlay,
  pageHeaderBg: pageHeaderBg,
  panelHeaderBg: panelHeaderBg,
  tableHeaderBg: tableHeaderBg,
  tableBodyBg: tableBodyBg,
  tagBgPrimary: tagBgPrimary,
  imageHoverBg: imageHoverBg,
  contentBgDark: contentBgDark,
  columnWidth: columnWidth,
  gutterWidth: gutterWidth,
  paddingSm: paddingSm,
  paddingMd: paddingMd,
  inputHeight: inputHeight,
  buttonHeight: buttonHeight,
  headingFont: headingFont,
  headingXlSize: headingXlSize,
  headingLgSize: headingLgSize,
  headingMdSize: headingMdSize,
  bodyFont: bodyFont,
  bodyWeightNormal: bodyWeightNormal,
  bodyTextSize: bodyTextSize,
  bodyTextLetterSpacing: bodyTextLetterSpacing,
  bodySmallWeightNormal: bodySmallWeightNormal,
  bodySmallTextSize: bodySmallTextSize,
  bodySmallTextLetterSpacing: bodySmallTextLetterSpacing,
  labelFont: labelFont,
  labelFontSize: labelFontSize,
  labelFontWeight: labelFontWeight,
  labelLineHeight: labelLineHeight,
  labelLetterSpacing: labelLetterSpacing,
  imageBtnFontSize: imageBtnFontSize,
  inputFontSize: inputFontSize,
  buttonFontSize: buttonFontSize,
  white: white,
  black: black,
  gray10: gray10,
  gray15: gray15,
  gray20: gray20,
  gray30: gray30,
  gray35: gray35,
  gray40: gray40,
  gray50: gray50,
  gray55: gray55,
  gray57: gray57,
  gray60: gray60,
  gray70: gray70,
  gray80: gray80,
  gray90: gray90,
  whitePartialOpacity: whitePartialOpacity,
  blueLightest: blueLightest,
  blueLighter: blueLighter,
  blueLight: blueLight,
  navy: navy,
  teal: teal,
  tealLight: tealLight,
  tealLighten05: tealLighten05,
  tealDarken10: tealDarken10,
  pink: pink,
  pinkLight: pinkLight,
  pinkLighten05: pinkLighten05,
  pinkDarken10: pinkDarken10,
  magenta: magenta,
  yellowLight: yellowLight,
  gold: gold,
  orange: orange,
  orangeLighten05: orangeLighten05,
  orangeDarken10: orangeDarken10,
  green: green,
  greenLighten05: greenLighten05,
  greenDarken10: greenDarken10,
  red: red,
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true});
var focusOutline = exports.focusOutline = '#092dbd';
var textPrimaryDark = exports.textPrimaryDark = '#01050e';
var textSecondaryDark = exports.textSecondaryDark = '#4d5056';
var textTertiaryDark = exports.textTertiaryDark = '#4d5056';
var textPrimaryLight = exports.textPrimaryLight = '#ffffff';
var textSecondaryLight = exports.textSecondaryLight = '#f9f9f9';
var textTertiaryLight = exports.textTertiaryLight = '#f2f2f3';
var textMedium = exports.textMedium = '#e5e6e6';
var textTooltip = exports.textTooltip = '#f9f9f9';
var contentBg = exports.contentBg = '#ffffff';
var errorColor = exports.errorColor = '#d33d00';
var statusOk = exports.statusOk = '#009E4F';
var statusAverage = exports.statusAverage = '#08088C';
var statusPoor = exports.statusPoor = '#d33d00';
var statusWarning = exports.statusWarning = '#ffba00';
var statusBgDefault = exports.statusBgDefault = '#e5e6e6';
var statusBgInfo = exports.statusBgInfo = '#f2f4f9';
var statusBgSuccess = exports.statusBgSuccess = '#d7f6e6';
var statusBgError = exports.statusBgError = '#fdf6f3';
var statusBgWarning = exports.statusBgWarning = '#fffbf2';
var linkColorDark = exports.linkColorDark = '#08088C';
var linkColorLight = exports.linkColorLight = '#00EAE4';
var linkColorDisabled = exports.linkColorDisabled = '#8e9093';
var alertBg = exports.alertBg = '#fffbf2';
var alertBgError = exports.alertBgError = '#d33d00';
var alertBgDetails = exports.alertBgDetails = 'rgba(white, 0.1)';
var warningBg = exports.warningBg = '#ffba00';
var accountInfo = exports.accountInfo = '#009E4F';
var iconDisabled = exports.iconDisabled = '#f2f2f3';
var buttonBgPrimary = exports.buttonBgPrimary = '#08088C';
var buttonBgSecondary = exports.buttonBgSecondary = '#ffffff';
var buttonBgDestructive = exports.buttonBgDestructive = '#d33d00';
var buttonBgInverse = exports.buttonBgInverse = '#ffffff';
var buttonBgUnselected = exports.buttonBgUnselected = '#f2f4f9';
var sidebarBg = exports.sidebarBg = '#030D28';
var sidebarHover = exports.sidebarHover = '#092dbd';
var sidebarSelected = exports.sidebarSelected = '#08088C';
var borderColor = exports.borderColor = '#e5e6e6';
var inputBorder = exports.inputBorder = '#e5e6e6';
var inputBorderDisabled = exports.inputBorderDisabled = '#f2f2f3';
var inputBorderHover = exports.inputBorderHover = '#8e9093';
var inputBorderActive = exports.inputBorderActive = '#8e9093';
var inputBorderFocus = exports.inputBorderFocus = '#092dbd';
var inputBg = exports.inputBg = '#ffffff';
var inputBgDisabled = exports.inputBgDisabled = '#f2f2f3';
var inputDisabled = exports.inputDisabled = '#8e9093';
var inputShadow = exports.inputShadow = '#e5e6e6';
var highlightPrimary = exports.highlightPrimary = '#f2f4f9';
var highlightSecondary = exports.highlightSecondary = '#f2f4f9';
var labelColor = exports.labelColor = '#01050e';
var modalHeaderBg = exports.modalHeaderBg = '#ffffff';
var modalBodyBg = exports.modalBodyBg = '#f9f9f9';
var modalFooterBg = exports.modalFooterBg = '#ffffff';
var modalOverlay = exports.modalOverlay = 'rgba(0, 0, 0, 0.7)';
var pageHeaderBg = exports.pageHeaderBg = '#f2f4f9';
var panelHeaderBg = exports.panelHeaderBg = '#f2f2f3';
var tableHeaderBg = exports.tableHeaderBg = '#e5e6e6';
var tableBodyBg = exports.tableBodyBg = '#ffffff';
var tagBgPrimary = exports.tagBgPrimary = '#092dbd';
var imageHoverBg = exports.imageHoverBg = 'navy-gray-darker';
var contentBgDark = exports.contentBgDark = '#030D28';
var columnWidth = exports.columnWidth = '8.5%';
var gutterWidth = exports.gutterWidth = '24px';
var paddingSm = exports.paddingSm = '8px';
var paddingMd = exports.paddingMd = '16px';
var inputHeight = exports.inputHeight = '48px';
var buttonHeight = exports.buttonHeight = '32px';
var headingFont = exports.headingFont = '"Public Sans", sans-serif';
var headingWeight = exports.headingWeight = '800';
var headingXxsWeight = exports.headingXxsWeight = '700';
var headingXlSize = exports.headingXlSize = '4.209rem';
var headingXlLineHeight = exports.headingXlLineHeight = '72px';
var headingXlLetterSpacing = exports.headingXlLetterSpacing = '-2px';
var headingLgSize = exports.headingLgSize = '3.157rem';
var headingLgLineHeight = exports.headingLgLineHeight = '56px';
var headingLgLetterSpacing = exports.headingLgLetterSpacing = '-1px';
var headingMdSize = exports.headingMdSize = '2.369rem';
var headingMdLineHeight = exports.headingMdLineHeight = '40px';
var headingMdLetterSpacing = exports.headingMdLetterSpacing = '-0.5px';
var headingSmSize = exports.headingSmSize = '1.777rem';
var headingSmLineHeight = exports.headingSmLineHeight = '36px';
var headingSmLetterSpacing = exports.headingSmLetterSpacing = '-0.5px';
var headingXsSize = exports.headingXsSize = '1.333rem';
var headingXsLineHeight = exports.headingXsLineHeight = '28px';
var headingXsLetterSpacing = exports.headingXsLetterSpacing = '-0.25px';
var headingXxsSize = exports.headingXxsSize = '1rem';
var headingXxsLineHeight = exports.headingXxsLineHeight = '24px';
var headingXxsLetterSpacing = exports.headingXxsLetterSpacing = 'auto';
var headingUpperSize = exports.headingUpperSize = '0.75rem';
var headingUpperLineHeight = exports.headingUpperLineHeight = '16px';
var headingUpperLetterSpacing = exports.headingUpperLetterSpacing = '1px';
var bodyFont = exports.bodyFont = '"Public Sans", sans-serif';
var bodyWeightNormal = exports.bodyWeightNormal = 'normal';
var bodyWeightBold = exports.bodyWeightBold = '700';
var bodyTextSize = exports.bodyTextSize = '1rem';
var bodyTextLineHeight = exports.bodyTextLineHeight = '24px';
var bodyTextLetterSpacing = exports.bodyTextLetterSpacing = 'auto';
var bodySmallWeightNormal = exports.bodySmallWeightNormal = 'normal';
var bodySmallWeightBold = exports.bodySmallWeightBold = '700';
var bodySmallTextSize = exports.bodySmallTextSize = '0.875rem';
var bodySmallTextLineHeight = exports.bodySmallTextLineHeight = '20px';
var bodySmallTextLetterSpacing = exports.bodySmallTextLetterSpacing = 'auto';
var labelFont = exports.labelFont = '"Public Sans", sans-serif';
var labelFontSize = exports.labelFontSize = '0.875rem';
var labelFontWeight = exports.labelFontWeight = '700';
var labelLineHeight = exports.labelLineHeight = '20px';
var labelLetterSpacing = exports.labelLetterSpacing = 'auto';
var imageBtnFontSize = exports.imageBtnFontSize = '0.875rem';
var inputFontSize = exports.inputFontSize = '1rem';
var buttonFontSize = exports.buttonFontSize = '1rem';
var navyDark = exports.navyDark = '#030D28';
var navy = exports.navy = '#08088C';
var navyLight = exports.navyLight = '#092dbd';
var navyGray = exports.navyGray = '#f2f4f9';
var navyGrayDark = exports.navyGrayDark = '#d7dbea';
var black = exports.black = '#01050e';
var white = exports.white = '#ffffff';
var gray40 = exports.gray40 = '#4d5056';
var gray35 = exports.gray35 = '#8e9093';
var gray30 = exports.gray30 = '#e5e6e6';
var gray20 = exports.gray20 = '#f2f2f3';
var gray10 = exports.gray10 = '#f9f9f9';
var cyan = exports.cyan = '#00EAE4';
var cyanMuted = exports.cyanMuted = '#2AC1FF';
var green = exports.green = '#009E4F';
var green05 = exports.green05 = '#d7f6e6';
var yellow = exports.yellow = '#ffba00';
var yellow05 = exports.yellow05 = '#fffbf2';
var red = exports.red = '#d33d00';
var red05 = exports.red05 = '#fdf6f3';
var plum = exports.plum = '#b501da';
exports.default = { 
  focusOutline: focusOutline,
  textPrimaryDark: textPrimaryDark,
  textSecondaryDark: textSecondaryDark,
  textTertiaryDark: textTertiaryDark,
  textPrimaryLight: textPrimaryLight,
  textSecondaryLight: textSecondaryLight,
  textTertiaryLight: textTertiaryLight,
  textMedium: textMedium,
  textTooltip: textTooltip,
  contentBg: contentBg,
  errorColor: errorColor,
  statusOk: statusOk,
  statusAverage: statusAverage,
  statusPoor: statusPoor,
  statusWarning: statusWarning,
  statusBgDefault: statusBgDefault,
  statusBgInfo: statusBgInfo,
  statusBgSuccess: statusBgSuccess,
  statusBgError: statusBgError,
  statusBgWarning: statusBgWarning,
  linkColorDark: linkColorDark,
  linkColorLight: linkColorLight,
  linkColorDisabled: linkColorDisabled,
  alertBg: alertBg,
  alertBgError: alertBgError,
  alertBgDetails: alertBgDetails,
  warningBg: warningBg,
  accountInfo: accountInfo,
  iconDisabled: iconDisabled,
  buttonBgPrimary: buttonBgPrimary,
  buttonBgSecondary: buttonBgSecondary,
  buttonBgDestructive: buttonBgDestructive,
  buttonBgInverse: buttonBgInverse,
  buttonBgUnselected: buttonBgUnselected,
  sidebarBg: sidebarBg,
  sidebarHover: sidebarHover,
  sidebarSelected: sidebarSelected,
  borderColor: borderColor,
  inputBorder: inputBorder,
  inputBorderDisabled: inputBorderDisabled,
  inputBorderHover: inputBorderHover,
  inputBorderActive: inputBorderActive,
  inputBorderFocus: inputBorderFocus,
  inputBg: inputBg,
  inputBgDisabled: inputBgDisabled,
  inputDisabled: inputDisabled,
  inputShadow: inputShadow,
  highlightPrimary: highlightPrimary,
  highlightSecondary: highlightSecondary,
  labelColor: labelColor,
  modalHeaderBg: modalHeaderBg,
  modalBodyBg: modalBodyBg,
  modalFooterBg: modalFooterBg,
  modalOverlay: modalOverlay,
  pageHeaderBg: pageHeaderBg,
  panelHeaderBg: panelHeaderBg,
  tableHeaderBg: tableHeaderBg,
  tableBodyBg: tableBodyBg,
  tagBgPrimary: tagBgPrimary,
  imageHoverBg: imageHoverBg,
  contentBgDark: contentBgDark,
  columnWidth: columnWidth,
  gutterWidth: gutterWidth,
  paddingSm: paddingSm,
  paddingMd: paddingMd,
  inputHeight: inputHeight,
  buttonHeight: buttonHeight,
  headingFont: headingFont,
  headingWeight: headingWeight,
  headingXxsWeight: headingXxsWeight,
  headingXlSize: headingXlSize,
  headingXlLineHeight: headingXlLineHeight,
  headingXlLetterSpacing: headingXlLetterSpacing,
  headingLgSize: headingLgSize,
  headingLgLineHeight: headingLgLineHeight,
  headingLgLetterSpacing: headingLgLetterSpacing,
  headingMdSize: headingMdSize,
  headingMdLineHeight: headingMdLineHeight,
  headingMdLetterSpacing: headingMdLetterSpacing,
  headingSmSize: headingSmSize,
  headingSmLineHeight: headingSmLineHeight,
  headingSmLetterSpacing: headingSmLetterSpacing,
  headingXsSize: headingXsSize,
  headingXsLineHeight: headingXsLineHeight,
  headingXsLetterSpacing: headingXsLetterSpacing,
  headingXxsSize: headingXxsSize,
  headingXxsLineHeight: headingXxsLineHeight,
  headingXxsLetterSpacing: headingXxsLetterSpacing,
  headingUpperSize: headingUpperSize,
  headingUpperLineHeight: headingUpperLineHeight,
  headingUpperLetterSpacing: headingUpperLetterSpacing,
  bodyFont: bodyFont,
  bodyWeightNormal: bodyWeightNormal,
  bodyWeightBold: bodyWeightBold,
  bodyTextSize: bodyTextSize,
  bodyTextLineHeight: bodyTextLineHeight,
  bodyTextLetterSpacing: bodyTextLetterSpacing,
  bodySmallWeightNormal: bodySmallWeightNormal,
  bodySmallWeightBold: bodySmallWeightBold,
  bodySmallTextSize: bodySmallTextSize,
  bodySmallTextLineHeight: bodySmallTextLineHeight,
  bodySmallTextLetterSpacing: bodySmallTextLetterSpacing,
  labelFont: labelFont,
  labelFontSize: labelFontSize,
  labelFontWeight: labelFontWeight,
  labelLineHeight: labelLineHeight,
  labelLetterSpacing: labelLetterSpacing,
  imageBtnFontSize: imageBtnFontSize,
  inputFontSize: inputFontSize,
  buttonFontSize: buttonFontSize,
  navyDark: navyDark,
  navy: navy,
  navyLight: navyLight,
  navyGray: navyGray,
  navyGrayDark: navyGrayDark,
  black: black,
  white: white,
  gray40: gray40,
  gray35: gray35,
  gray30: gray30,
  gray20: gray20,
  gray10: gray10,
  cyan: cyan,
  cyanMuted: cyanMuted,
  green: green,
  green05: green05,
  yellow: yellow,
  yellow05: yellow05,
  red: red,
  red05: red05,
  plum: plum,
};

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Collapse__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return _Collapse__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Collapse; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var global_window__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(181);
/* harmony import */ var global_window__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(global_window__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var js_util_compatibility__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(126);
/* harmony import */ var _Collapse_sass__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(182);
/* harmony import */ var _Collapse_sass__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_Collapse_sass__WEBPACK_IMPORTED_MODULE_20__);















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var ResizeDetector;

if (!Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_19__["isReact14"])()) {
  ResizeDetector = __webpack_require__(184).default;
}

Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_19__["warnReact14"])('Collapse does not fully support React 0.14. Animations will be omitted');
var STATUSES = {
  closed: 'CLOSED',
  opened: 'OPENED',
  transistion: 'TRANSITION'
};
/**
 * **Proposed** | This component is not yet approved by UX and may change.
 *
 * A utility component for collapsing and expanding content.
 *
 * This component is not fully supported in React 0.14 but is used by other
 * components in this library. If you are using React 0.14 this component
 * will omit animations and simply show/hide content.
 */

var Collapse = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(Collapse, _React$Component);

  var _super = _createSuper(Collapse);

  function Collapse() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9___default()(_this), "node", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9___default()(_this), "state", {
      desiredHeight: 'auto',
      status: 'CLOSED'
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9___default()(_this), "adjustDesiredHeight", function () {
      if (!_this.node) {
        return;
      }

      var _this$node$getBoundin = _this.node.getBoundingClientRect(),
          height = _this$node$getBoundin.height;

      if (height !== _this.state.desiredHeight) {
        _this.setState({
          desiredHeight: height,
          status: STATUSES.transistion
        });
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9___default()(_this), "updateStatus", function (width, height) {
      if (typeof _this.state.desiredHeight === 'number' && _this.areHeightsEqual(height, _this.state.desiredHeight)) {
        _this.setState({
          status: STATUSES.opened
        });
      } else if (height === 0) {
        _this.setState({
          status: STATUSES.closed
        });
      }
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.adjustDesiredHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(props, state) {
      if (props != this.props) {
        this.adjustDesiredHeight();
      }
    }
  }, {
    key: "areHeightsEqual",
    value: function areHeightsEqual(a, b) {
      return Math.abs(a - b) < 0.1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          show = _this$props.show,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          testName = _this$props.testName;
      var _this$state = this.state,
          desiredHeight = _this$state.desiredHeight,
          status = _this$state.status;
      var height = show ? desiredHeight : 0;
      var classes = classnames__WEBPACK_IMPORTED_MODULE_18___default()(_Collapse_sass__WEBPACK_IMPORTED_MODULE_20___default.a.collapse, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()({}, _Collapse_sass__WEBPACK_IMPORTED_MODULE_20___default.a.fullyExpanded, show && status === STATUSES.opened));

      if (Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_19__["isReact14"])()) {
        var staticHeight = show ? 'auto' : 0;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement("div", {
          className: classes,
          style: _objectSpread({
            height: staticHeight
          }, style),
          "aria-hidden": !show,
          "data-test-name": testName
        }, show ? children : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement("noscript", null));
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement("div", {
        className: classes,
        style: _objectSpread({
          height: height
        }, style),
        "aria-hidden": !show,
        "data-test-name": testName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement("div", {
        className: _Collapse_sass__WEBPACK_IMPORTED_MODULE_20___default.a.content,
        ref: function ref(node) {
          return _this2.node = node;
        }
      }, !show && status === STATUSES.closed ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement("noscript", null) : children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement(ResizeDetector, {
        handleWidth: true,
        onResize: this.adjustDesiredHeight,
        refreshMode: "debounce",
        refreshRate: 100
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement(ResizeDetector, {
        handleHeight: true,
        onResize: this.updateStatus,
        refreshMode: "debounce",
        refreshRate: 100
      }));
    }
  }]);

  return Collapse;
}(react__WEBPACK_IMPORTED_MODULE_16___default.a.Component);


Collapse.propTypes = {
  /** Content to collapse/expand */
  children: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** Whether or not to show (expand) the contents */
  show: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string
};
Collapse.defaultProps = {
  show: true
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var getBuiltIn = __webpack_require__(40);
var aFunction = __webpack_require__(70);
var anObject = __webpack_require__(26);
var isObject = __webpack_require__(20);
var create = __webpack_require__(119);
var bind = __webpack_require__(162);
var fails = __webpack_require__(12);

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(70);
var isObject = __webpack_require__(20);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var global = __webpack_require__(8);
var getBuiltIn = __webpack_require__(40);
var IS_PURE = __webpack_require__(35);
var DESCRIPTORS = __webpack_require__(11);
var NATIVE_SYMBOL = __webpack_require__(57);
var USE_SYMBOL_AS_UID = __webpack_require__(61);
var fails = __webpack_require__(12);
var has = __webpack_require__(21);
var isArray = __webpack_require__(79);
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(26);
var toObject = __webpack_require__(77);
var toIndexedObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(19);
var createPropertyDescriptor = __webpack_require__(14);
var nativeObjectCreate = __webpack_require__(119);
var objectKeys = __webpack_require__(82);
var getOwnPropertyNamesModule = __webpack_require__(42);
var getOwnPropertyNamesExternal = __webpack_require__(164);
var getOwnPropertySymbolsModule = __webpack_require__(49);
var getOwnPropertyDescriptorModule = __webpack_require__(10);
var definePropertyModule = __webpack_require__(25);
var propertyIsEnumerableModule = __webpack_require__(13);
var createNonEnumerableProperty = __webpack_require__(24);
var redefine = __webpack_require__(27);
var shared = __webpack_require__(34);
var sharedKey = __webpack_require__(33);
var hiddenKeys = __webpack_require__(37);
var uid = __webpack_require__(36);
var wellKnownSymbol = __webpack_require__(56);
var wrappedWellKnownSymbolModule = __webpack_require__(165);
var defineWellKnownSymbol = __webpack_require__(166);
var setToStringTag = __webpack_require__(167);
var InternalStateModule = __webpack_require__(31);
var $forEach = __webpack_require__(75).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(15);
var nativeGetOwnPropertyNames = __webpack_require__(42).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(56);

exports.f = wellKnownSymbol;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(41);
var has = __webpack_require__(21);
var wrappedWellKnownSymbolModule = __webpack_require__(165);
var defineProperty = __webpack_require__(25).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(25).f;
var has = __webpack_require__(21);
var wellKnownSymbol = __webpack_require__(56);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var fails = __webpack_require__(12);
var toIndexedObject = __webpack_require__(15);
var nativeGetOwnPropertyDescriptor = __webpack_require__(10).f;
var DESCRIPTORS = __webpack_require__(11);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var DOMIterables = __webpack_require__(170);
var forEach = __webpack_require__(171);
var createNonEnumerableProperty = __webpack_require__(24);

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(75).forEach;
var arrayMethodIsStrict = __webpack_require__(144);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(11);
var ownKeys = __webpack_require__(39);
var toIndexedObject = __webpack_require__(15);
var getOwnPropertyDescriptorModule = __webpack_require__(10);
var createProperty = __webpack_require__(173);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(19);
var definePropertyModule = __webpack_require__(25);
var createPropertyDescriptor = __webpack_require__(14);

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(176);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(178)["default"];

var assertThisInitialized = __webpack_require__(174);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 179 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var fails = __webpack_require__(12);
var isArray = __webpack_require__(79);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(77);
var toLength = __webpack_require__(45);
var createProperty = __webpack_require__(173);
var arraySpeciesCreate = __webpack_require__(78);
var arrayMethodHasSpeciesSupport = __webpack_require__(80);
var wellKnownSymbol = __webpack_require__(56);
var V8_VERSION = __webpack_require__(59);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(9)))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(183);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Collapse-collapse-2_3_6-2Kwe8{overflow:hidden;transition:height .2s ease-out}.Collapse-fullyExpanded-2_3_6-24kDv{overflow:visible}.Collapse-content-2_3_6-3LUcl{overflow:hidden}.Collapse-content-2_3_6-3LUcl>:first-child{margin-top:0!important}.Collapse-fullyExpanded-2_3_6-24kDv .Collapse-content-2_3_6-3LUcl{overflow:visible}", ""]);

// exports
exports.locals = {
	"collapse": "Collapse-collapse-2_3_6-2Kwe8",
	"fullyExpanded": "Collapse-fullyExpanded-2_3_6-24kDv",
	"content": "Collapse-content-2_3_6-3LUcl"
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResizeDetector = __webpack_require__(185);

var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResizeDetector2.default;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(125);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(130);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(186);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _lodash = __webpack_require__(187);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(188);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };

var styles = {
  position: 'absolute',
  width: 0,
  height: 0,
  visibility: 'hidden',
  display: 'none'
};

var ResizeDetector = function (_PureComponent) {
  _inherits(ResizeDetector, _PureComponent);

  function ResizeDetector(props) {
    _classCallCheck(this, ResizeDetector);

    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));

    _this.createResizeObserver = function (entries) {
      var _this$props = _this.props,
          handleWidth = _this$props.handleWidth,
          handleHeight = _this$props.handleHeight,
          onResize = _this$props.onResize;

      entries.forEach(function (entry) {
        var _entry$contentRect = entry.contentRect,
            width = _entry$contentRect.width,
            height = _entry$contentRect.height;

        var notifyWidth = handleWidth && _this.width !== width;
        var notifyHeight = handleHeight && _this.height !== height;
        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
          onResize(width, height);
        }
        _this.width = width;
        _this.height = height;
        _this.skipOnMount = false;
      });
    };

    var skipOnMount = props.skipOnMount,
        refreshMode = props.refreshMode,
        refreshRate = props.refreshRate;


    _this.width = undefined;
    _this.height = undefined;
    _this.skipOnMount = skipOnMount;

    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;

    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
    return _this;
  }

  _createClass(ResizeDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.observe(resizableElement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.unobserve(resizableElement);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        style: styles,
        ref: function ref(el) {
          _this2.el = el;
        }
      });
    }
  }]);

  return ResizeDetector;
}(_react.PureComponent);

exports.default = ResizeDetector;


ResizeDetector.propTypes = {
  handleWidth: _propTypes2.default.bool,
  handleHeight: _propTypes2.default.bool,
  skipOnMount: _propTypes2.default.bool,
  refreshRate: _propTypes2.default.number,
  refreshMode: _propTypes2.default.string,
  resizableElementId: _propTypes2.default.string,
  onResize: _propTypes2.default.func
};

ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false,
  skipOnMount: false,
  refreshRate: 1000,
  refreshMode: undefined,
  resizableElementId: '',
  onResize: function onResize(e) {
    return e;
  }
};

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(9)))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(9)))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(9)))

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(190);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Accordion-container-2_3_6-EA6y-+.Accordion-container-2_3_6-EA6y-{margin-top:.6666666667rem}.Accordion-classic-2_3_6-19YnT a{color:#079bb3}.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-titleBar-2_3_6-20RYS,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-titleBar-2_3_6-20RYS{cursor:inherit}.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-titleBar-2_3_6-20RYS:hover,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-titleBar-2_3_6-20RYS:hover{border-top:1px solid #ddd;border-bottom:1px solid #ddd}.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8,.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq{cursor:inherit;color:#aaa}.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 a,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 a,.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 button,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 button,.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 input,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 input,.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq a,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq a,.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq button,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq button,.Accordion-classic-2_3_6-19YnT.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq input,.Accordion-classic-2_3_6-19YnT .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq input{cursor:inherit;color:#aaa;pointer-events:none}.Accordion-classic-2_3_6-19YnT .Accordion-titleBar-2_3_6-20RYS{background:#fff;border-top:1px solid #ddd;border-bottom:1px solid #ddd;transition:border .2s ease-in-out;display:-ms-flexbox;display:flex;position:relative;height:3rem;-ms-flex-align:center;align-items:center;padding:0 1rem}.Accordion-classic-2_3_6-19YnT .Accordion-titleBar-2_3_6-20RYS.Accordion-noToggle-2_3_6-yBQ7Y{cursor:pointer}.Accordion-classic-2_3_6-19YnT .Accordion-titleBar-2_3_6-20RYS.Accordion-noToggle-2_3_6-yBQ7Y:hover{border-top:1px solid #999;border-bottom:1px solid #999}.Accordion-classic-2_3_6-19YnT .Accordion-labelContainer-2_3_6-1xr_S{-ms-flex-negative:1;flex-shrink:1;-ms-flex-positive:1;flex-grow:1;position:relative;margin:1rem .6666666667rem .75rem 0;min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.Accordion-classic-2_3_6-19YnT .Accordion-label-2_3_6-NVZsL.Accordion-label-2_3_6-NVZsL{margin:0;max-width:100%;letter-spacing:normal;font-weight:700;font-size:1rem;line-height:1.3333333333rem;text-overflow:ellipsis;overflow:hidden}.Accordion-classic-2_3_6-19YnT .Accordion-label-2_3_6-NVZsL.Accordion-label-2_3_6-NVZsL>*{display:inline-block;margin-top:0;margin-bottom:0}.Accordion-classic-2_3_6-19YnT .Accordion-summary-2_3_6-rj-pq{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-positive:4;flex-grow:4;-ms-flex-negative:1;flex-shrink:1;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;height:2.6666666667rem;margin-right:.3333333333rem;min-width:0;overflow:hidden;text-overflow:ellipsis;color:#666;font-size:.875rem;letter-spacing:normal}@media screen and (max-width:990px){.Accordion-classic-2_3_6-19YnT .Accordion-summary-2_3_6-rj-pq{display:none}}.Accordion-classic-2_3_6-19YnT .Accordion-summary-2_3_6-rj-pq>*{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.Accordion-classic-2_3_6-19YnT .Accordion-summary-2_3_6-rj-pq.Accordion-pristine-2_3_6-1SwGX{color:#666}.Accordion-classic-2_3_6-19YnT .Accordion-action-2_3_6-1bsC8{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;margin:1rem 0 .75rem 1rem;font-weight:700;line-height:1.3333333333rem}.Accordion-classic-2_3_6-19YnT .Accordion-action-2_3_6-1bsC8 a,.Accordion-classic-2_3_6-19YnT .Accordion-action-2_3_6-1bsC8 a:focus,.Accordion-classic-2_3_6-19YnT .Accordion-action-2_3_6-1bsC8 a:hover,.Accordion-classic-2_3_6-19YnT .Accordion-action-2_3_6-1bsC8 a:visited{color:#079bb3;text-decoration:none}.Accordion-classic-2_3_6-19YnT .Accordion-content-2_3_6-Zyxk6{padding:24px 16px;background-color:#fff}.Accordion-classic-2_3_6-19YnT .Accordion-helperText-2_3_6-_vZlT{padding:24px 16px 0;font-size:.875rem;letter-spacing:normal}.Accordion-classic-2_3_6-19YnT.Accordion-summaryDetail-2_3_6-16JpO,.Accordion-classic-2_3_6-19YnT .Accordion-summaryDetail-2_3_6-16JpO{-ms-flex-item-align:start;align-self:flex-start;padding:0 1.3333333333rem;overflow:hidden}.Accordion-classic-2_3_6-19YnT.Accordion-summaryDetail-2_3_6-16JpO+.Accordion-classic-2_3_6-19YnT.Accordion-summaryDetail-2_3_6-16JpO,.Accordion-classic-2_3_6-19YnT.Accordion-summaryDetail-2_3_6-16JpO+.Accordion-classic-2_3_6-19YnT .Accordion-summaryDetail-2_3_6-16JpO,.Accordion-classic-2_3_6-19YnT .Accordion-summaryDetail-2_3_6-16JpO+.Accordion-classic-2_3_6-19YnT.Accordion-summaryDetail-2_3_6-16JpO,.Accordion-classic-2_3_6-19YnT .Accordion-summaryDetail-2_3_6-16JpO+.Accordion-classic-2_3_6-19YnT .Accordion-summaryDetail-2_3_6-16JpO{border-left:1px solid #666}.Accordion-classic-2_3_6-19YnT.Accordion-summaryDetail-2_3_6-16JpO>*,.Accordion-classic-2_3_6-19YnT .Accordion-summaryDetail-2_3_6-16JpO>*{margin:0;padding:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.Accordion-blueSteel-2_3_6-1Ek90 a{color:#08088c}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-titleBar-2_3_6-20RYS,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-titleBar-2_3_6-20RYS{cursor:inherit}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-titleBar-2_3_6-20RYS:hover,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-titleBar-2_3_6-20RYS:hover{border-top:1px solid #e5e6e6;border-bottom:1px solid #e5e6e6}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq{cursor:inherit;color:#8e9093}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 a,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 button,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 input,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq a,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq button,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq input,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 a,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 button,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-action-2_3_6-1bsC8 input,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq a,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq button,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-container-2_3_6-EA6y-.Accordion-disabled-2_3_6-1u8yH .Accordion-summary-2_3_6-rj-pq input{cursor:inherit;color:#8e9093;pointer-events:none}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-titleBar-2_3_6-20RYS{background:#fff;border-top:1px solid #e5e6e6;border-bottom:1px solid #e5e6e6;transition:border .2s ease-in-out;display:-ms-flexbox;display:flex;position:relative;height:3rem;-ms-flex-align:center;align-items:center;padding:0 1rem}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-titleBar-2_3_6-20RYS.Accordion-noToggle-2_3_6-yBQ7Y{cursor:pointer}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-titleBar-2_3_6-20RYS.Accordion-noToggle-2_3_6-yBQ7Y:hover{border-top:1px solid #4d5056;border-bottom:1px solid #4d5056}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-labelContainer-2_3_6-1xr_S{-ms-flex-negative:1;flex-shrink:1;-ms-flex-positive:1;flex-grow:1;position:relative;margin:1rem .6666666667rem .75rem 0;min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-label-2_3_6-NVZsL.Accordion-label-2_3_6-NVZsL{margin:0;max-width:100%;letter-spacing:auto;font-weight:700;font-size:1rem;line-height:1.3333333333rem;text-overflow:ellipsis;overflow:hidden}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-label-2_3_6-NVZsL.Accordion-label-2_3_6-NVZsL>*{display:inline-block;margin-top:0;margin-bottom:0}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summary-2_3_6-rj-pq{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-positive:4;flex-grow:4;-ms-flex-negative:1;flex-shrink:1;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;height:2.6666666667rem;margin-right:.3333333333rem;min-width:0;overflow:hidden;text-overflow:ellipsis;color:#4d5056;font-size:.875rem;letter-spacing:auto;line-height:20px}@media screen and (max-width:990px){.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summary-2_3_6-rj-pq{display:none}}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summary-2_3_6-rj-pq>*{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summary-2_3_6-rj-pq.Accordion-pristine-2_3_6-1SwGX{color:#4d5056}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-action-2_3_6-1bsC8{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;margin:1rem 0 .75rem 1rem;font-weight:700;line-height:1.3333333333rem}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-action-2_3_6-1bsC8 a,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-action-2_3_6-1bsC8 a:focus,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-action-2_3_6-1bsC8 a:hover,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-action-2_3_6-1bsC8 a:visited{color:#08088c;text-decoration:none}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-content-2_3_6-Zyxk6{padding:24px 16px;background-color:#fff}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-helperText-2_3_6-_vZlT{padding:24px 16px 0;font-size:.875rem;letter-spacing:auto;line-height:20px}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summaryDetail-2_3_6-16JpO,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-summaryDetail-2_3_6-16JpO{-ms-flex-item-align:start;align-self:flex-start;padding:0 1.3333333333rem;overflow:hidden}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summaryDetail-2_3_6-16JpO+.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summaryDetail-2_3_6-16JpO,.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summaryDetail-2_3_6-16JpO+.Accordion-blueSteel-2_3_6-1Ek90.Accordion-summaryDetail-2_3_6-16JpO,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-summaryDetail-2_3_6-16JpO+.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summaryDetail-2_3_6-16JpO,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-summaryDetail-2_3_6-16JpO+.Accordion-blueSteel-2_3_6-1Ek90.Accordion-summaryDetail-2_3_6-16JpO{border-left:1px solid #4d5056}.Accordion-blueSteel-2_3_6-1Ek90 .Accordion-summaryDetail-2_3_6-16JpO>*,.Accordion-blueSteel-2_3_6-1Ek90.Accordion-summaryDetail-2_3_6-16JpO>*{margin:0;padding:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
exports.locals = {
	"container": "Accordion-container-2_3_6-EA6y-",
	"classic": "Accordion-classic-2_3_6-19YnT",
	"disabled": "Accordion-disabled-2_3_6-1u8yH",
	"titleBar": "Accordion-titleBar-2_3_6-20RYS",
	"summary": "Accordion-summary-2_3_6-rj-pq",
	"action": "Accordion-action-2_3_6-1bsC8",
	"noToggle": "Accordion-noToggle-2_3_6-yBQ7Y",
	"labelContainer": "Accordion-labelContainer-2_3_6-1xr_S",
	"label": "Accordion-label-2_3_6-NVZsL",
	"pristine": "Accordion-pristine-2_3_6-1SwGX",
	"content": "Accordion-content-2_3_6-Zyxk6",
	"helperText": "Accordion-helperText-2_3_6-_vZlT",
	"summaryDetail": "Accordion-summaryDetail-2_3_6-16JpO",
	"blueSteel": "Accordion-blueSteel-2_3_6-1Ek90"
};

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Toggle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(192);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toggle", function() { return _Toggle__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Toggle", function() { return Toggle; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Toggle_sass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(193);
/* harmony import */ var _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Toggle_sass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(195);
/* harmony import */ var _ToolTip__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(198);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(155);











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









/**
 A component to toggle between On/Off state.

 __Accessibility notes: __
 - The Toggle Component is keyboard focusable and operable.
 - When the user tab focus, it outlines the current selected state. User can toggle between state by clicking Space Bar.
 - Screen readers recognize it as a Toggle Component and also get information whether it's On or Off state.
 **/

var Toggle = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Toggle, _React$Component);

  var _super = _createSuper(Toggle);

  function Toggle() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Toggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "toggle", function (evt) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(!_this.props.value, evt);
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "handleToggle", function (evt) {
      if (evt.currentTarget === evt.target) {
        if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_14__["default"])(evt).is('enter space')) {
          evt.preventDefault();

          _this.toggle(evt);
        }
      }
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Toggle, [{
    key: "render",
    value: function render() {
      var _cx,
          _cx2,
          _this2 = this;

      var _this$props = this.props,
          onLabel = _this$props.onLabel,
          offLabel = _this$props.offLabel,
          disabled = _this$props.disabled,
          testName = _this$props.testName,
          style = _this$props.style,
          className = _this$props.className,
          value = _this$props.value,
          label = _this$props.label,
          helperText = _this$props.helperText,
          tooltip = _this$props.tooltip,
          flexProps = _this$props.flexProps,
          labelClassName = _this$props.labelClassName,
          theme = _this$props.theme;
      var toggleSwitch = classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.switch, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_cx, _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.switchDisabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_cx, _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.off, !value), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_cx, _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.on, value), _cx));
      var toggleSlider = classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.slider, (_cx2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_cx2, _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.sliderDisabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_cx2, _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.off, !value), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_cx2, _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.on, value), _cx2));
      var classNames = classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], className);
      var hasDecorators = Boolean(label || tooltip || onLabel || offLabel || helperText);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", {
        "data-test-name": testName,
        style: style,
        className: classNames
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_15__["Flex"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({}, flexProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.toggleContainer, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()({}, _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.noDecorators, !hasDecorators))
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.labelContainer, labelClassName)
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", {
        className: _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.label
      }, label, " ", tooltip ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_ToolTip__WEBPACK_IMPORTED_MODULE_16__["ToolTip"], {
        content: tooltip
      }) : null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", {
        className: _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.helperText
      }, " ", helperText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("label", {
        role: "switch",
        "aria-label": "Toggle Component is ".concat(value ? onLabel : offLabel),
        tabIndex: 0,
        onKeyDown: this.handleToggle,
        "aria-checked": value,
        className: toggleSwitch
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("input", {
        type: "checkbox",
        checked: value,
        disabled: disabled,
        onChange: function onChange(evt) {
          return _this2.toggle(evt);
        },
        "aria-hidden": "true"
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", {
        className: toggleSlider
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", {
        className: _Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a.text
      }, value ? onLabel : offLabel))))));
    }
  }]);

  return Toggle;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);
Toggle.defaultProps = {
  flexProps: {
    flexDirection: 'column',
    gap: 'sm'
  }
};
Toggle.propTypes = {
  /** For custom styling on the outermost container */
  className: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** To disable the Toggle Component */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /** Callback that is fired when the user clicks the toggle component */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.func,

  /** Label for On state */
  onLabel: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Label for Off state */
  offLabel: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.object,

  /** Current value of the component */
  value: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool.isRequired,

  /** Label for Toggle Component */
  label: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Helper Text for Toggle Component */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** A tooltip to be rendered beside the label */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Props to pass along to `Flex` component */
  flexProps: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.object,

  /** Style for label Component */
  labelClassName: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_17__["provideTheme"])(_Toggle_sass__WEBPACK_IMPORTED_MODULE_11___default.a)(Toggle));

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(194);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Toggle-classic-2_3_6-cG9zz a{color:#079bb3}.Toggle-classic-2_3_6-cG9zz.Toggle-switch-2_3_6-2Obct,.Toggle-classic-2_3_6-cG9zz .Toggle-switch-2_3_6-2Obct{border:.06rem solid #ddd;background:#fff;border-radius:.1rem;width:6.8rem;height:1.8rem}.Toggle-classic-2_3_6-cG9zz.Toggle-slider-2_3_6-2eqqL,.Toggle-classic-2_3_6-cG9zz .Toggle-slider-2_3_6-2eqqL{position:absolute;width:4.45rem;text-align:center;font-size:.9rem;color:#fff;font-family:Lato,Helvetica,Arial,sans-serif;padding:.2rem;top:0;left:0;right:0;bottom:0;transition:transform .5s ease-in-out;background:#a2b00c}.Toggle-classic-2_3_6-cG9zz.Toggle-slider-2_3_6-2eqqL.Toggle-off-2_3_6-xlGVG,.Toggle-classic-2_3_6-cG9zz.Toggle-slider-2_3_6-2eqqL .Toggle-off-2_3_6-xlGVG,.Toggle-classic-2_3_6-cG9zz .Toggle-slider-2_3_6-2eqqL.Toggle-off-2_3_6-xlGVG,.Toggle-classic-2_3_6-cG9zz .Toggle-slider-2_3_6-2eqqL .Toggle-off-2_3_6-xlGVG{background:#444;transform:translateX(2.233rem)}.Toggle-classic-2_3_6-cG9zz.Toggle-switchDisabled-2_3_6-3unkf,.Toggle-classic-2_3_6-cG9zz .Toggle-switchDisabled-2_3_6-3unkf{background:#f4f4f4}.Toggle-classic-2_3_6-cG9zz.Toggle-sliderDisabled-2_3_6-1FsID,.Toggle-classic-2_3_6-cG9zz .Toggle-sliderDisabled-2_3_6-1FsID{background:#ccc}.Toggle-classic-2_3_6-cG9zz.Toggle-labelContainer-2_3_6-3MXO2,.Toggle-classic-2_3_6-cG9zz .Toggle-labelContainer-2_3_6-3MXO2{color:#666;font-size:.9333333333rem}.Toggle-classic-2_3_6-cG9zz.Toggle-switch-2_3_6-2Obct,.Toggle-classic-2_3_6-cG9zz .Toggle-switch-2_3_6-2Obct{position:relative;display:inline-block}.Toggle-classic-2_3_6-cG9zz.Toggle-switch-2_3_6-2Obct:not(.Toggle-switchDisabled-2_3_6-3unkf),.Toggle-classic-2_3_6-cG9zz .Toggle-switch-2_3_6-2Obct:not(.Toggle-switchDisabled-2_3_6-3unkf){cursor:pointer}.Toggle-blueSteel-2_3_6-1guM9 a{color:#08088c}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct,.Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct{display:-ms-inline-flexbox;display:inline-flex;width:1.75rem;height:1rem;background:#fff;border-radius:.5rem}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct:focus,.Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct:focus{outline:none;box-shadow:0 0 0 1px #092dbd}.hide-focus-outlines .Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct:focus,.hide-focus-outlines .Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct:focus{box-shadow:none}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct.Toggle-off-2_3_6-xlGVG,.Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct.Toggle-off-2_3_6-xlGVG{background:#fff;border:1px solid #8e9093}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct.Toggle-off-2_3_6-xlGVG.Toggle-switchDisabled-2_3_6-3unkf,.Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct.Toggle-off-2_3_6-xlGVG.Toggle-switchDisabled-2_3_6-3unkf{border:1px solid #e5e6e6}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct.Toggle-on-2_3_6-13CTr,.Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct.Toggle-on-2_3_6-13CTr{background:#009e4f}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct.Toggle-on-2_3_6-13CTr.Toggle-switchDisabled-2_3_6-3unkf,.Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct.Toggle-on-2_3_6-13CTr.Toggle-switchDisabled-2_3_6-3unkf{background:#e5e6e6}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-toggleContainer-2_3_6-1uP82.Toggle-noDecorators-2_3_6-13TdW{margin:0}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-slider-2_3_6-2eqqL,.Toggle-blueSteel-2_3_6-1guM9.Toggle-slider-2_3_6-2eqqL{position:relative;top:.125rem;background:#009e4f;height:.75rem;width:.75rem;display:block;border-radius:.375rem;box-shadow:0 1px 0 rgba(17,17,26,.05),0 0 8px rgba(17,17,26,.1);background:#fff;transition:transform .2s cubic-bezier(.77,0,.18,1),background .2s cubic-bezier(.77,0,.18,1)}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-slider-2_3_6-2eqqL.Toggle-on-2_3_6-13CTr,.Toggle-blueSteel-2_3_6-1guM9.Toggle-slider-2_3_6-2eqqL.Toggle-on-2_3_6-13CTr{transform:translateX(.875rem)}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-slider-2_3_6-2eqqL.Toggle-on-2_3_6-13CTr.Toggle-sliderDisabled-2_3_6-1FsID,.Toggle-blueSteel-2_3_6-1guM9.Toggle-slider-2_3_6-2eqqL.Toggle-on-2_3_6-13CTr.Toggle-sliderDisabled-2_3_6-1FsID{border:none;box-shadow:0 2px 8px -2px rgba(0,0,0,.5)}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-slider-2_3_6-2eqqL.Toggle-off-2_3_6-xlGVG,.Toggle-blueSteel-2_3_6-1guM9.Toggle-slider-2_3_6-2eqqL.Toggle-off-2_3_6-xlGVG{top:.0625rem;transform:translateX(.0625rem);background:#8e9093}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-slider-2_3_6-2eqqL.Toggle-off-2_3_6-xlGVG.Toggle-sliderDisabled-2_3_6-1FsID,.Toggle-blueSteel-2_3_6-1guM9.Toggle-slider-2_3_6-2eqqL.Toggle-off-2_3_6-xlGVG.Toggle-sliderDisabled-2_3_6-1FsID{box-shadow:none;background:#e5e6e6}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-slider-2_3_6-2eqqL .Toggle-text-2_3_6-A9BTh,.Toggle-blueSteel-2_3_6-1guM9.Toggle-slider-2_3_6-2eqqL .Toggle-text-2_3_6-A9BTh{display:none}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-toggleContainer-2_3_6-1uP82{border-radius:.5rem}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-labelContainer-2_3_6-3MXO2{display:none}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-labelContainer-2_3_6-3MXO2,.Toggle-blueSteel-2_3_6-1guM9.Toggle-labelContainer-2_3_6-3MXO2{color:#4d5056;font-size:.9333333333rem}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct,.Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct{position:relative;display:inline-block}.Toggle-blueSteel-2_3_6-1guM9 .Toggle-switch-2_3_6-2Obct:not(.Toggle-switchDisabled-2_3_6-3unkf),.Toggle-blueSteel-2_3_6-1guM9.Toggle-switch-2_3_6-2Obct:not(.Toggle-switchDisabled-2_3_6-3unkf){cursor:pointer}.Toggle-toggleContainer-2_3_6-1uP82{margin:.3333333333rem 0}.Toggle-switch-2_3_6-2Obct input{position:absolute;opacity:0;width:0;height:0}.Toggle-label-2_3_6-1BavU{font-weight:700;margin-bottom:.13rem}.Toggle-helperText-2_3_6-10_Wj{margin-top:.4rem;line-height:1.25}", ""]);

// exports
exports.locals = {
	"classic": "Toggle-classic-2_3_6-cG9zz",
	"switch": "Toggle-switch-2_3_6-2Obct",
	"slider": "Toggle-slider-2_3_6-2eqqL",
	"off": "Toggle-off-2_3_6-xlGVG",
	"switchDisabled": "Toggle-switchDisabled-2_3_6-3unkf",
	"sliderDisabled": "Toggle-sliderDisabled-2_3_6-1FsID",
	"labelContainer": "Toggle-labelContainer-2_3_6-3MXO2",
	"blueSteel": "Toggle-blueSteel-2_3_6-1guM9",
	"on": "Toggle-on-2_3_6-13CTr",
	"toggleContainer": "Toggle-toggleContainer-2_3_6-1uP82",
	"noDecorators": "Toggle-noDecorators-2_3_6-13TdW",
	"text": "Toggle-text-2_3_6-A9BTh",
	"label": "Toggle-label-2_3_6-1BavU",
	"helperText": "Toggle-helperText-2_3_6-10_Wj"
};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(196);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Flex", function() { return _Flex__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Flex", function() { return Flex; });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(155);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var GAPS_CLASSIC = {
  no: '0px',
  none: '0px',
  xs: '5px',
  xsmall: '5px',
  sm: '10px',
  small: '10px',
  md: '20px',
  med: '20px',
  medium: '20px',
  lg: '30px',
  large: '30px',
  xl: '40px',
  xlarge: '40px'
};
var GAPS_BLUESTEEL = {
  no: '0px',
  none: '0px',
  xs: '4px',
  xsmall: '4px',
  sm: '8px',
  small: '8px',
  md: '12px',
  med: '12px',
  medium: '12px',
  lg: '16px',
  large: '16px',
  xl: '24px',
  xlarge: '24px'
};
/**
A flex container for laying out children. This component provides most flex
container functionality with the added ability to specify an internal `gap`
between items.

For more help with flexbox see: https://css-tricks.com/snippets/css/a-guide-to-flexbox/

__NOTE:__ When a Flex is used around a [Hideable](#hideable), the flex styles
will be passed through to the Hideable's children when visible. Conflicting
styles on the child will take precedence over the styles applied by the `Flex`.
*/

function Flex(_ref) {
  var alignItems = _ref.alignItems,
      alignContent = _ref.alignContent,
      className = _ref.className,
      flexDirection = _ref.flexDirection,
      flexWrap = _ref.flexWrap,
      inline = _ref.inline,
      justifyContent = _ref.justifyContent,
      gap = _ref.gap,
      testName = _ref.testName,
      style = _ref.style,
      children = _ref.children,
      theme = _ref.theme;
  var GAPS = theme === 'blueSteel' ? GAPS_BLUESTEEL : GAPS_CLASSIC;
  style = _objectSpread({
    display: inline ? 'inline-flex' : 'flex',
    alignItems: alignItems,
    alignContent: alignContent,
    flexDirection: flexDirection,
    flexWrap: flexWrap,
    justifyContent: justifyContent
  }, style);
  var isReversed = flexDirection && flexDirection.indexOf('reverse') != -1;
  var isRow = flexDirection !== 'column' && flexDirection !== 'column-reverse';
  var childrenArray = react__WEBPACK_IMPORTED_MODULE_8___default.a.Children.toArray(children).filter(Boolean);

  var getChildStyle = function getChildStyle(index) {
    if (gap == null) {
      return {};
    } // If wrapping is enabled we just apply right and bottom margins on all
    // items since we can't know if they've wrapped or not.


    if (flexWrap === 'wrap' || flexWrap === 'wrap-reverse') {
      return {
        marginRight: GAPS[gap],
        marginBottom: GAPS[gap]
      };
    } // Trim off end margins


    if (isReversed) {
      if (index === 0) {
        return {};
      }
    } else {
      if (index === childrenArray.length - 1) {
        return {};
      }
    } // Items in a row get a right margin. Items in column get bottom margin.


    if (isRow) {
      return {
        marginRight: GAPS[gap]
      };
    } else {
      return {
        marginBottom: GAPS[gap]
      };
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("div", {
    style: style,
    className: className,
    "data-test-name": testName
  }, childrenArray.map(function (child, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.cloneElement(child, {
      style: _objectSpread(_objectSpread({}, getChildStyle(i)), child.props.style),
      key: i
    });
  }));
}
Flex.propTypes = {
  /** This defines the default behaviour for how flex items are laid out along the cross axis on the current line. Think of it as the justify-content version for the cross-axis (perpendicular to the main-axis). */
  alignItems: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),

  /** This aligns a flex container's lines within when there is extra space in the cross-axis, similar to how justify-content aligns individual items within the main-axis. Note: this property has no effect when there is only one line of flex items. */
  alignContent: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'stretch']),

  /** Component contents. __Note__: You cannot pass plain text nodes to this component. */
  children: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.element, prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.element)]),

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** This establishes the main-axis, thus defining the direction flex items are placed in the flex container. Flexbox is (aside from optional wrapping) a single-direction layout concept. Think of flex items as primarily laying out either in horizontal rows or vertical columns. */
  flexDirection: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /** By default, flex items will all try to fit onto one line. You can change that and allow the items to wrap as needed with this property. */
  flexWrap: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /** If true the container will be set to `display: inline-flex` instead of `display: flex`. */
  inline: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool,

  /** This defines the alignment along the main axis. It helps distribute extra free space left over when either all the flex items on a line are inflexible, or are flexible but have reached their maximum size. It also exerts some control over the alignment of items when they overflow the line. */
  justifyContent: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']),

  /** Margin between items. */
  gap: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(Object.keys(GAPS_CLASSIC)),

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_10__["provideTheme"])()(Flex));

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $map = __webpack_require__(75).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(80);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ToolTip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ToolTip", function() { return _ToolTip__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToolTip", function() { return ToolTip; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(117);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(122);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(200);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var js_components_Fadeable__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(201);
/* harmony import */ var _Layer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(206);
/* harmony import */ var _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(214);
/* harmony import */ var _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_ToolTip_sass__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(155);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(216);












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }











function ToolTipIcon() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement("div", {
    className: _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a.tooltipIcon
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_19__["Icon"], {
    name: _Icon__WEBPACK_IMPORTED_MODULE_19__["ICONS"].INFO,
    padRight: true
  }));
}

var positionMap = {
  'top left': {
    layerPlacement: 'top left',
    position: 'topLeft',
    animation: 'up',
    flippedPosition: 'bottomLeft',
    flippedAnimation: 'down'
  },
  top: {
    layerPlacement: 'top center',
    position: 'top',
    animation: 'up',
    flippedPosition: 'bottom',
    flippedAnimation: 'down'
  },
  'top right': {
    layerPlacement: 'top right',
    position: 'topRight',
    animation: 'up',
    flippedPosition: 'bottomRight',
    flippedAnimation: 'down'
  },
  'right top': {
    layerPlacement: 'right top',
    position: 'rightTop',
    animation: 'left',
    flippedPosition: 'leftTop',
    flippedAnimation: 'right'
  },
  right: {
    layerPlacement: 'right middle',
    position: 'right',
    animation: 'left',
    flippedPosition: 'left',
    flippedAnimation: 'right'
  },
  'right bottom': {
    layerPlacement: 'right bottom',
    position: 'rightBottom',
    animation: 'left',
    flippedPosition: 'leftBottom',
    flippedAnimation: 'right'
  },
  'bottom left': {
    layerPlacement: 'bottom left',
    position: 'bottomLeft',
    animation: 'down',
    flippedPosition: 'topLeft',
    flippedAnimation: 'up'
  },
  bottom: {
    layerPlacement: 'bottom center',
    position: 'bottom',
    animation: 'down',
    flippedPosition: 'top',
    flippedAnimation: 'up'
  },
  'bottom right': {
    layerPlacement: 'bottom right',
    position: 'bottomRight',
    animation: 'down',
    flippedPosition: 'topRight',
    flippedAnimation: 'up'
  },
  'left top': {
    layerPlacement: 'left top',
    position: 'leftTop',
    animation: 'right',
    flippedPosition: 'rightTop',
    flippedAnimation: 'left'
  },
  left: {
    layerPlacement: 'left middle',
    position: 'left',
    animation: 'right',
    flippedPosition: 'right',
    flippedAnimation: 'left'
  },
  'left bottom': {
    layerPlacement: 'left bottom',
    position: 'leftBottom',
    animation: 'right',
    flippedPosition: 'rightBottom',
    flippedAnimation: 'left'
  }
};
/**
A simple ToolTip component shown on hover and on touch.

Note: This component requires React >= 0.14.9
*/

var ToolTip = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ToolTip, _React$Component);

  var _super = _createSuper(ToolTip);

  function ToolTip() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ToolTip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "childrenContainerNode", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "state", {
      visible: false,
      flipped: false
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "show", function () {
      return _this.setState({
        visible: true
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "hide", function () {
      return _this.setState({
        visible: false
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "handleTouch", function () {
      _this.show();

      _this.assignOutsideTouchHandler();
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "handleFlip", function () {
      _this.setState({
        flipped: !_this.state.flipped
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "assignOutsideTouchHandler", function () {
      var handler = function handler(e) {
        var currentNode = e.target;
        var componentNode = react_dom__WEBPACK_IMPORTED_MODULE_12___default.a.findDOMNode(_this.instance);

        while (currentNode.parentNode) {
          if (currentNode === componentNode) {
            return;
          }

          currentNode = currentNode.parentNode;
        }

        if (currentNode !== document) {
          return;
        }

        _this.hide();

        document.removeEventListener('touchstart', handler);
      };

      document.addEventListener('touchstart', handler);
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "setChildrenContainerRef", function (element) {
      _this.childrenContainerNode = element;
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "setTooltipInnerRef", function (element) {
      _this.tooltipInnerNode = element;
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "setWrapperRef", function (element) {
      _this.instance = element;
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "calculateDynamicArrowStyles", function () {
      var styles = {};
      var flipped = _this.state.flipped;
      var _positionMap$_this$pr = positionMap[_this.props.placement],
          position = _positionMap$_this$pr.position,
          flippedPosition = _positionMap$_this$pr.flippedPosition;
      var actualPosition = flipped ? flippedPosition : position;
      var arrowBaseLengthPx = 10;
      var edgeBufferPx = 10;

      var childRect = _this.childrenContainerNode.getBoundingClientRect();

      var tooltipRect = _this.tooltipInnerNode.getBoundingClientRect();

      var widthOrHeight = 'height';
      var xOrY = 'y';
      var leftOrTop = 'top';

      if (['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight'].includes(actualPosition)) {
        widthOrHeight = 'width';
        xOrY = 'x';
        leftOrTop = 'left';
      }

      var offsetToReachMiddlePxOfChild = childRect[xOrY] - tooltipRect[xOrY] + childRect[widthOrHeight] / 2;
      var desiredOffset = offsetToReachMiddlePxOfChild - arrowBaseLengthPx / 2;
      var minOffset = edgeBufferPx;
      var maxOffset = tooltipRect[widthOrHeight] - edgeBufferPx - arrowBaseLengthPx;
      styles[leftOrTop] = Math.max(minOffset, Math.min(desiredOffset, maxOffset)); // hide the arrow entirely if it's as far as it can go and the content being pointed to
      // is too narrow

      if ([maxOffset, minOffset].includes(styles[leftOrTop]) && childRect[widthOrHeight] < arrowBaseLengthPx + edgeBufferPx) {
        styles.display = 'none';
      }

      return styles;
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ToolTip, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _cx;

      var _this$props = this.props,
          addMargin = _this$props.addMargin,
          className = _this$props.className,
          testName = _this$props.testName,
          style = _this$props.style,
          content = _this$props.content,
          children = _this$props.children,
          placement = _this$props.placement,
          tipClassName = _this$props.tipClassName,
          block = _this$props.block,
          theme = _this$props.theme,
          active = _this$props.active,
          reflow = _this$props.reflow,
          portal = _this$props.portal,
          linkInFooter = _this$props.linkInFooter;

      if (!active) {
        return children;
      }

      var flipped = this.state.flipped;
      var _positionMap$placemen = positionMap[placement],
          layerPlacement = _positionMap$placemen.layerPlacement,
          position = _positionMap$placemen.position,
          animation = _positionMap$placemen.animation,
          flippedPosition = _positionMap$placemen.flippedPosition,
          flippedAnimation = _positionMap$placemen.flippedAnimation;
      var contentTag = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(js_components_Fadeable__WEBPACK_IMPORTED_MODULE_15__["Fadeable"], {
        show: this.state.visible,
        onFadeInCompleted: function onFadeInCompleted() {
          return _this2.forceUpdate();
        },
        slideIn: flipped ? flippedAnimation : animation,
        className: classnames__WEBPACK_IMPORTED_MODULE_14___default()(_ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a[theme], _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a.tooltip, tipClassName, _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a[flipped ? flippedPosition : position])
      }, this.tooltipInnerNode && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_11___default.a.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement("div", {
        style: this.calculateDynamicArrowStyles(),
        className: classnames__WEBPACK_IMPORTED_MODULE_14___default()(_ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a[theme], _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a.tooltipArrow)
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement("div", {
        ref: this.setTooltipInnerRef,
        className: _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a.tooltipInner
      }, content));
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_14___default()(_ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a[theme], className, _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a.container, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_cx, _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a.block, block), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_cx, _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a.linkInFooter, linkInFooter), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_cx, _ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a.addMargin, addMargin), _cx)),
        style: style,
        "data-test-name": testName,
        onMouseEnter: this.show,
        onMouseLeave: this.hide,
        onTouchStart: this.handleTouch,
        ref: this.setWrapperRef
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(_Layer__WEBPACK_IMPORTED_MODULE_16__["default"], {
        active: this.state.visible,
        style: {
          display: 'inline-block'
        },
        reflow: reflow,
        position: layerPlacement,
        content: contentTag,
        onFlippedChange: this.handleFlip,
        zIndex: 1070,
        portal: portal
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement("div", {
        ref: this.setChildrenContainerRef
      }, children)));
    }
  }]);

  return ToolTip;
}(react__WEBPACK_IMPORTED_MODULE_11___default.a.Component);
ToolTip.defaultProps = {
  placement: 'right',
  block: false,
  children: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(ToolTipIcon, null),
  active: true,
  reflow: true,
  portal: false,
  linkInFooter: false,
  addMargin: false
};
ToolTip.propTypes = {
  /** Whether or not to add margin (top or left) to next element*/
  addMargin: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /** Whether or not to set `display: block` on the outer element */
  block: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /** Trigger element to show the tooltip on. */
  children: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node.isRequired,

  /** Whether or not to display the tooltip */
  active: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /** class name for the container element */
  className: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Tooltip content */
  content: function content(props, propName, componentName) {
    if (props['active'] && !props[propName]) {
      return new Error("".concat(propName, " is required when active is true in ").concat(componentName, "."));
    }
  },

  /** Where to place the tooltip with respect to the trigger element */
  placement: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.oneOf(['top left', 'top', 'top right', 'right top', 'right', 'right bottom', 'bottom left', 'bottom', 'bottom right', 'left top', 'left', 'left bottom']),

  /**
   * Specifies whether to render the tooltip in a Portal component. This will
   * render the tooltip as a direct child of the body element instead of within
   * the DOM tree of the rest of the components. This can be useful in cases where
   * in-context positioning causes other elements to overlap on top of the tooltip.
   */
  portal: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /**
   * Specifies whether the tooltip should flip to the opposite side if it
   * determines that it will collide with a natural boundary (typically the edge
   * of the window or when its container element has overflow set to hidden).
   * Reflow may need to be disabled in cases where the tooltip is set to render
   * within a Portal and wouldn't be affected by element boundaries.
   */
  reflow: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.object,

  /** test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** class name for the tooltip element */
  tipClassName: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Link should be displayed in block */
  linkInFooter: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_18__["provideTheme"])(_ToolTip_sass__WEBPACK_IMPORTED_MODULE_17___default.a)(ToolTip));

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__200__;

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Fadeable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(202);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fadeable", function() { return _Fadeable__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fadeable; });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(203);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var js_util_compatibility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(126);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_11__["warnReact14"])('Fadeable does not fully support React 0.14. Animations will be omitted');
/**
 * **Proposed** | This component is not yet approved by UX and may change.
 *
 * A utility component for fading content in and out.
 *
 * This component is not fully supported in React 0.14 but is used by other
 * components in this library. If you are using React 0.14 this component
 * will omit animations and simply show/hide content.
 */

function Fadeable(props) {
  var show = props.show,
      inline = props.inline,
      slideIn = props.slideIn,
      slideOut = props.slideOut,
      duration = props.duration,
      className = props.className,
      style = props.style,
      onFadeInCompleted = props.onFadeInCompleted,
      onFadeOutCompleted = props.onFadeOutCompleted;
  var yOffsets = {
    down: -5,
    up: 5
  };
  var xOffsets = {
    left: -5,
    right: 5
  };
  var startX = xOffsets[slideIn] || 0;
  var endX = -xOffsets[slideOut] || 0;
  var startY = yOffsets[slideIn] || 0;
  var endY = -yOffsets[slideOut] || 0;
  var defaultStyle = {
    display: inline ? 'inline' : 'block',
    transition: "opacity ".concat(duration, "ms ease-in-out, transform ").concat(duration, "ms ease-in-out"),
    opacity: 0,
    transform: 'none'
  };
  var transitionStyles = {
    entering: {
      opacity: 0,
      transform: "translate(".concat(startX, "px ,").concat(startY, "px)")
    },
    entered: {
      opacity: 1,
      transform: 'none'
    },
    exiting: {
      opacity: 0,
      transform: "translate(".concat(endX, "px ,").concat(endY, "px)")
    }
  }; // Transition doesn't work in React 0.14

  if (Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_11__["isReact14"])()) {
    var styles = _objectSpread({
      display: inline ? 'inline' : 'block'
    }, style);

    return show ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("div", {
      className: className,
      style: styles
    }, props.children) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("noscript", null);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement(react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_10___default.a, {
    in: show,
    onEntered: onFadeInCompleted,
    onExited: onFadeOutCompleted,
    onEntering: // Force the browser to reflow so entering animation isn't skipped.
    // See: https://github.com/reactjs/react-transition-group/issues/299
    function onEntering(node) {
      return node.offsetHeight;
    },
    timeout: {
      enter: 0,
      exit: duration
    },
    unmountOnExit: true,
    mountOnEnter: true
  }, function (state) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("div", {
      className: className,
      style: _objectSpread(_objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state]), style)
    }, props.children);
  });
}
Fadeable.defaultProps = {
  inline: false,
  duration: 200,
  onFadeInCompleted: function onFadeInCompleted() {},
  onFadeOutCompleted: function onFadeOutCompleted() {}
};
Fadeable.propTypes = {
  /** Content to fade in/out */
  children: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** Duration of the animation */
  duration: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.number,

  /** Whether the container should be rendered inline or not (block) */
  inline: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool,

  /** Whether or not to show (fade in) the contents */
  show: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool.isRequired,

  /** Add an optional slide animation when animating content in */
  slideIn: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['down', 'up', 'left', 'right']),

  /** Add an optional slide animation when animating content out */
  slideOut: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['down', 'up', 'left', 'right']),

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.object,

  /** Add an optional callback to be invoked after fade in is complete */
  onFadeInCompleted: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.func,

  /** Add an optional callback to be invoked after fade out is complete */
  onFadeOutCompleted: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.func
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(130));

var _react = _interopRequireDefault(__webpack_require__(125));

var _reactDom = _interopRequireDefault(__webpack_require__(200));

var _reactLifecyclesCompat = __webpack_require__(204);

var _PropTypes = __webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  true ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : undefined;

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(130));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  true ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : undefined;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  true ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : undefined;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Layer; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var global_document__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(207);
/* harmony import */ var global_document__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(global_document__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var global_window__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(181);
/* harmony import */ var global_window__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(global_window__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(209);
/* harmony import */ var _Portal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(210);
/* harmony import */ var _Layer_sass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(212);
/* harmony import */ var _Layer_sass__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_Layer_sass__WEBPACK_IMPORTED_MODULE_16__);











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var VIEWPORT_PADDING = 50;
var positionLookup = {
  'top left': 'top-start',
  'top center': 'top',
  'top right': 'top-end',
  'right top': 'right-start',
  'right middle': 'right',
  'right bottom': 'right-end',
  'bottom left': 'bottom-start',
  'bottom center': 'bottom',
  'bottom right': 'bottom-end',
  'left top': 'left-start',
  'left middle': 'left',
  'left bottom': 'left-end',
  default: 'right'
};

function calcMaxHeight(originalHeight, currentHeight, positionTop, position) {
  var windowHeight = global_window__WEBPACK_IMPORTED_MODULE_11___default.a.innerHeight || 0;
  var documentHeight = 0;

  if (global_document__WEBPACK_IMPORTED_MODULE_10___default.a.documentElement) {
    documentHeight = global_document__WEBPACK_IMPORTED_MODULE_10___default.a.documentElement.clientHeight;
  }

  if (position === 'fixed') {
    return null;
  }

  var viewportHeight = Math.max(documentHeight, windowHeight);
  return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - VIEWPORT_PADDING ? viewportHeight - 15 : null;
}

var Layer = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Layer, _React$Component);

  var _super = _createSuper(Layer);

  function Layer() {
    var _defineProperty2;

    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Layer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "contentRef", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "targetRef", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "state", (_defineProperty2 = {
      hasSetStyles: false,
      position: null,
      transform: null,
      flipped: false,
      actualPosition: null,
      offsets: {
        popper: {
          left: -9999,
          top: -9999
        }
      },
      originalPosition: null
    }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_defineProperty2, "position", 'absolute'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_defineProperty2, "originalHeight", null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_defineProperty2, "maxHeight", null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_defineProperty2, "fixedOffset", null), _defineProperty2));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "setStyles", function (popperState) {
      if (!popperState || _this.props.active === false) {
        return;
      }

      var contentHeight = popperState.offsets.popper.height;
      var left = Math.round(popperState.offsets.popper.left);
      var contentPosition = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(popperState.offsets.popper.position) === 'object' ? popperState.offsets.popper.position.position : popperState.offsets.popper.position;
      var contentTop = popperState.offsets.popper.top;
      var top = contentTop >= 0 || contentPosition !== 'fixed' ? Math.round(contentTop) : 0;
      var originalHeight = _this.state.originalHeight || contentHeight;
      var maxHeight = calcMaxHeight(originalHeight, contentHeight, top, contentPosition);

      _this.setState({
        contentPosition: contentPosition,
        hasSetStyles: true,
        contentTransform: "translate(".concat(left, "px, ").concat(top, "px)"),
        flipped: Boolean(popperState.flipped),
        actualPosition: popperState.position,
        originalPosition: popperState.originalPosition,
        originalHeight: originalHeight,
        maxHeight: maxHeight
      });
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Layer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupPopper(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.setupPopper(props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.flipped !== this.state.flipped && this.props.onFlippedChange) {
        this.props.onFlippedChange();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.popper) {
        this.popper.destroy();
      }
    }
  }, {
    key: "setupPopper",
    value: function setupPopper(props) {
      if (!this.contentRef || !this.targetRef) {
        return;
      }

      if (this.popper) {
        this.popper.destroy();
      }

      if (!props.content) {
        return;
      }

      var options = {
        placement: positionLookup[props.position] || positionLookup.default,
        onCreate: this.setStyles,
        onUpdate: this.setStyles,
        modifiers: {
          applyStyle: {
            enabled: false
          },
          flip: {
            enabled: props.reflow,
            flipVariations: true,
            padding: 0
          },
          hide: {
            enabled: false
          },
          offset: {
            enabled: true
          },
          preventOverflow: {
            enabled: props.reflow,
            escapeWithReference: false
          }
        }
      };
      this.popper = new popper_js__WEBPACK_IMPORTED_MODULE_14__["default"](this.targetRef.firstChild, this.contentRef, options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          content = _this$props.content,
          testName = _this$props.testName,
          zIndex = _this$props.zIndex,
          portal = _this$props.portal;
      var Container = portal ? _Portal__WEBPACK_IMPORTED_MODULE_15__["Portal"] : react__WEBPACK_IMPORTED_MODULE_12___default.a.Fragment;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        "data-test-name": testName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        ref: function ref(node) {
          _this2.targetRef = node;
        }
      }, children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement(Container, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        className: _Layer_sass__WEBPACK_IMPORTED_MODULE_16___default.a.content,
        style: {
          position: this.state.contentPosition,
          transform: this.state.contentTransform,
          opacity: this.state.contentOpacity,
          maxHeight: this.state.maxHeight || undefined,
          zIndex: zIndex
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        ref: function ref(node) {
          _this2.contentRef = node;
        }
      }, content))));
    }
  }]);

  return Layer;
}(react__WEBPACK_IMPORTED_MODULE_12___default.a.Component);


Layer.propTypes = {
  active: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,
  reflow: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node.isRequired,
  content: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node.isRequired,
  position: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.oneOf(['top left', 'top center', 'top right', 'right top', 'right middle', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left middle', 'left bottom']),
  testName: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,
  zIndex: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.number
};
Layer.defaultProps = {
  reflow: true
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var topLevel = typeof global !== 'undefined' ? global :
    typeof window !== 'undefined' ? window : {}
var minDoc = __webpack_require__(208);

var doccy;

if (typeof document !== 'undefined') {
    doccy = document;
} else {
    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];

    if (!doccy) {
        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
    }
}

module.exports = doccy;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(9)))

/***/ }),
/* 208 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(9)))

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Portal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(211);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return _Portal__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var global_document__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(207);
/* harmony import */ var global_document__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(global_document__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(200);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





/**
 * Helper component to render elements as immediate descendants of the document
 * `body` element. This can be useful for modals and other modal-like components
 */

var Portal = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "el", global_document__WEBPACK_IMPORTED_MODULE_9___default.a.createElement('div'));

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      global_document__WEBPACK_IMPORTED_MODULE_9___default.a.body.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      global_document__WEBPACK_IMPORTED_MODULE_9___default.a.body.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_11___default.a.createPortal(this.props.children, this.el);
    }
  }]);

  return Portal;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(Portal, "propTypes", {
  /**
   * Portal contents - will be rendered within a div that is an immediate
   * child of the document body
   */
  children: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.node
});

/* harmony default export */ __webpack_exports__["default"] = (Portal);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(213);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Layer-content-2_3_6-2TBMj{top:0;left:0}", ""]);

// exports
exports.locals = {
	"content": "Layer-content-2_3_6-2TBMj"
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(215);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".ToolTip-classic-2_3_6-ys5kG a{color:#079bb3}.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipIcon-2_3_6-23tvi{background-color:#079bb3;color:#fff;font-size:13px}.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipIcon-2_3_6-23tvi:hover{background-color:#057182}.ToolTip-classic-2_3_6-ys5kG.ToolTip-container-2_3_6-1FjDO,.ToolTip-classic-2_3_6-ys5kG .ToolTip-container-2_3_6-1FjDO{display:inline-block}.ToolTip-classic-2_3_6-ys5kG.ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp,.ToolTip-classic-2_3_6-ys5kG .ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp{display:block}.ToolTip-classic-2_3_6-ys5kG.ToolTip-container-2_3_6-1FjDO.ToolTip-addMargin-2_3_6-3uGvY+.ToolTip-addMargin-2_3_6-3uGvY,.ToolTip-classic-2_3_6-ys5kG .ToolTip-container-2_3_6-1FjDO.ToolTip-addMargin-2_3_6-3uGvY+.ToolTip-addMargin-2_3_6-3uGvY{margin-left:.3333333333rem}.ToolTip-classic-2_3_6-ys5kG.ToolTip-container-2_3_6-1FjDO.ToolTip-addMargin-2_3_6-3uGvY+.ToolTip-block-2_3_6-3yCjp,.ToolTip-classic-2_3_6-ys5kG .ToolTip-container-2_3_6-1FjDO.ToolTip-addMargin-2_3_6-3uGvY+.ToolTip-block-2_3_6-3yCjp,.ToolTip-classic-2_3_6-ys5kG.ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp+.ToolTip-addMargin-2_3_6-3uGvY,.ToolTip-classic-2_3_6-ys5kG .ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp+.ToolTip-addMargin-2_3_6-3uGvY,.ToolTip-classic-2_3_6-ys5kG.ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp.ToolTip-addMargin-2_3_6-3uGvY+button,.ToolTip-classic-2_3_6-ys5kG .ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp.ToolTip-addMargin-2_3_6-3uGvY+button,button+.ToolTip-classic-2_3_6-ys5kG.ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp.ToolTip-addMargin-2_3_6-3uGvY,button+.ToolTip-classic-2_3_6-ys5kG .ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp.ToolTip-addMargin-2_3_6-3uGvY{margin-left:0;margin-top:.5rem}.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipIcon-2_3_6-23tvi{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;box-sizing:border-box;border-radius:.5rem;display:inline-block;width:.875rem;text-align:center;line-height:.8;font-weight:400;vertical-align:-.07rem}.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI{font-family:Lato,Helvetica,Arial,sans-serif;font-style:normal;line-break:auto;line-height:1.33333333;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;position:relative;display:block;font-size:.875rem;text-align:left;color:#eee;font-weight:400;overflow-wrap:break-word;letter-spacing:normal}.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI a,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI a,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI a:active,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI a:active,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI a:hover,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI a:hover,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI a:link,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI a:link,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI a:visited,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI a:visited{color:#fff;text-decoration:none}.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-top-2_3_6-3mJ_z,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-top-2_3_6-3mJ_z,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-topLeft-2_3_6-3SR54,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-topLeft-2_3_6-3SR54,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-topRight-2_3_6-23Gld,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-topRight-2_3_6-23Gld{bottom:3px;padding:5px 0}.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-bottom-2_3_6-1zOme,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-bottom-2_3_6-1zOme,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-bottomLeft-2_3_6-Mg4aQ,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-bottomLeft-2_3_6-Mg4aQ,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-bottomRight-2_3_6-1gBQJ,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-bottomRight-2_3_6-1gBQJ{top:3px;padding:5px 0}.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-right-2_3_6-j-cPb,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-right-2_3_6-j-cPb,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-rightBottom-2_3_6-278hS,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-rightBottom-2_3_6-278hS,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-rightTop-2_3_6-iWpmp,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-rightTop-2_3_6-iWpmp{left:3px;padding:0 5px}.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-left-2_3_6-2HCJF,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-left-2_3_6-2HCJF,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-leftBottom-2_3_6-FosXL,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-leftBottom-2_3_6-FosXL,.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltip-2_3_6-UishI.ToolTip-leftTop-2_3_6-3hgkW,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltip-2_3_6-UishI.ToolTip-leftTop-2_3_6-3hgkW{right:3px;padding:0 5px}.ToolTip-classic-2_3_6-ys5kG.ToolTip-linkInFooter-2_3_6-1BlCk a{display:block;margin-top:4px}.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipInner-2_3_6-cb72Q{max-width:200px;padding:.5rem .7rem .6rem;background-color:#444;border-radius:1px}.ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.ToolTip-top-2_3_6-3mJ_z .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-top-2_3_6-3mJ_z .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-topLeft-2_3_6-3SR54 .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-topLeft-2_3_6-3SR54 .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-topRight-2_3_6-23Gld .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-topRight-2_3_6-23Gld .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU{bottom:0;border-width:5px 5px 0;border-top-color:#444;left:calc(50% - 5px)}.ToolTip-right-2_3_6-j-cPb .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-right-2_3_6-j-cPb .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-rightBottom-2_3_6-278hS .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-rightBottom-2_3_6-278hS .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-rightTop-2_3_6-iWpmp .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-rightTop-2_3_6-iWpmp .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU{left:0;border-width:5px 5px 5px 0;border-right-color:#444}.ToolTip-left-2_3_6-2HCJF .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-left-2_3_6-2HCJF .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-leftBottom-2_3_6-FosXL .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-leftBottom-2_3_6-FosXL .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-leftTop-2_3_6-3hgkW .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-leftTop-2_3_6-3hgkW .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU{right:0;border-width:5px 0 5px 5px;border-left-color:#444}.ToolTip-bottom-2_3_6-1zOme .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottom-2_3_6-1zOme .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottomLeft-2_3_6-Mg4aQ .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottomLeft-2_3_6-Mg4aQ .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottomRight-2_3_6-1gBQJ .ToolTip-classic-2_3_6-ys5kG.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottomRight-2_3_6-1gBQJ .ToolTip-classic-2_3_6-ys5kG .ToolTip-tooltipArrow-2_3_6-1ieTU{top:0;border-width:0 5px 5px;border-bottom-color:#444;left:calc(50% - 5px)}.ToolTip-blueSteel-2_3_6-hIeRb a{color:#08088c}.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipIcon-2_3_6-23tvi{background-color:#fff;color:#08088c}.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipIcon-2_3_6-23tvi:hover{background-color:#e6e6e6}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-container-2_3_6-1FjDO,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-container-2_3_6-1FjDO{display:inline-block}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp{display:block}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-container-2_3_6-1FjDO.ToolTip-addMargin-2_3_6-3uGvY+.ToolTip-addMargin-2_3_6-3uGvY,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-container-2_3_6-1FjDO.ToolTip-addMargin-2_3_6-3uGvY+.ToolTip-addMargin-2_3_6-3uGvY{margin-left:.3333333333rem}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-container-2_3_6-1FjDO.ToolTip-addMargin-2_3_6-3uGvY+.ToolTip-block-2_3_6-3yCjp,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-container-2_3_6-1FjDO.ToolTip-addMargin-2_3_6-3uGvY+.ToolTip-block-2_3_6-3yCjp,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp+.ToolTip-addMargin-2_3_6-3uGvY,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp+.ToolTip-addMargin-2_3_6-3uGvY,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp.ToolTip-addMargin-2_3_6-3uGvY+button,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp.ToolTip-addMargin-2_3_6-3uGvY+button,button+.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp.ToolTip-addMargin-2_3_6-3uGvY,button+.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-container-2_3_6-1FjDO.ToolTip-block-2_3_6-3yCjp.ToolTip-addMargin-2_3_6-3uGvY{margin-left:0;margin-top:.5rem}.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipIcon-2_3_6-23tvi{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;box-sizing:border-box;border-radius:.5rem;display:inline-block;width:.875rem;text-align:center;line-height:.8;font-weight:400;vertical-align:-.07rem}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI{font-family:Public Sans,sans-serif;font-style:normal;letter-spacing:normal;line-break:auto;line-height:1.33333333;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;position:relative;display:block;font-size:.875rem;text-align:left;color:#f9f9f9;font-weight:400;overflow-wrap:break-word;letter-spacing:auto;line-height:20px}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI a,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI a,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI a:active,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI a:active,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI a:hover,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI a:hover,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI a:link,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI a:link,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI a:visited,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI a:visited{color:#00eae4;text-decoration:none}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-top-2_3_6-3mJ_z,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-top-2_3_6-3mJ_z,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-topLeft-2_3_6-3SR54,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-topLeft-2_3_6-3SR54,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-topRight-2_3_6-23Gld,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-topRight-2_3_6-23Gld{bottom:3px;padding:5px 0}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-bottom-2_3_6-1zOme,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-bottom-2_3_6-1zOme,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-bottomLeft-2_3_6-Mg4aQ,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-bottomLeft-2_3_6-Mg4aQ,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-bottomRight-2_3_6-1gBQJ,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-bottomRight-2_3_6-1gBQJ{top:3px;padding:5px 0}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-right-2_3_6-j-cPb,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-right-2_3_6-j-cPb,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-rightBottom-2_3_6-278hS,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-rightBottom-2_3_6-278hS,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-rightTop-2_3_6-iWpmp,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-rightTop-2_3_6-iWpmp{left:3px;padding:0 5px}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-left-2_3_6-2HCJF,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-left-2_3_6-2HCJF,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-leftBottom-2_3_6-FosXL,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-leftBottom-2_3_6-FosXL,.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltip-2_3_6-UishI.ToolTip-leftTop-2_3_6-3hgkW,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltip-2_3_6-UishI.ToolTip-leftTop-2_3_6-3hgkW{right:3px;padding:0 5px}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-linkInFooter-2_3_6-1BlCk a{display:block;margin-top:4px}.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipInner-2_3_6-cb72Q{max-width:200px;padding:.5rem .7rem .6rem;background-color:#01050e;border-radius:1px}.ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.ToolTip-top-2_3_6-3mJ_z .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-top-2_3_6-3mJ_z .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-topLeft-2_3_6-3SR54 .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-topLeft-2_3_6-3SR54 .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-topRight-2_3_6-23Gld .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-topRight-2_3_6-23Gld .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU{bottom:0;border-width:5px 5px 0;border-top-color:#01050e;left:calc(50% - 5px)}.ToolTip-right-2_3_6-j-cPb .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-right-2_3_6-j-cPb .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-rightBottom-2_3_6-278hS .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-rightBottom-2_3_6-278hS .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-rightTop-2_3_6-iWpmp .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-rightTop-2_3_6-iWpmp .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU{left:0;border-width:5px 5px 5px 0;border-right-color:#01050e}.ToolTip-left-2_3_6-2HCJF .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-left-2_3_6-2HCJF .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-leftBottom-2_3_6-FosXL .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-leftBottom-2_3_6-FosXL .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-leftTop-2_3_6-3hgkW .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-leftTop-2_3_6-3hgkW .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU{right:0;border-width:5px 0 5px 5px;border-left-color:#01050e}.ToolTip-bottom-2_3_6-1zOme .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottom-2_3_6-1zOme .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottomLeft-2_3_6-Mg4aQ .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottomLeft-2_3_6-Mg4aQ .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottomRight-2_3_6-1gBQJ .ToolTip-blueSteel-2_3_6-hIeRb.ToolTip-tooltipArrow-2_3_6-1ieTU,.ToolTip-bottomRight-2_3_6-1gBQJ .ToolTip-blueSteel-2_3_6-hIeRb .ToolTip-tooltipArrow-2_3_6-1ieTU{top:0;border-width:0 5px 5px;border-bottom-color:#01050e;left:calc(50% - 5px)}", ""]);

// exports
exports.locals = {
	"classic": "ToolTip-classic-2_3_6-ys5kG",
	"tooltipIcon": "ToolTip-tooltipIcon-2_3_6-23tvi",
	"container": "ToolTip-container-2_3_6-1FjDO",
	"block": "ToolTip-block-2_3_6-3yCjp",
	"addMargin": "ToolTip-addMargin-2_3_6-3uGvY",
	"tooltip": "ToolTip-tooltip-2_3_6-UishI",
	"top": "ToolTip-top-2_3_6-3mJ_z",
	"topLeft": "ToolTip-topLeft-2_3_6-3SR54",
	"topRight": "ToolTip-topRight-2_3_6-23Gld",
	"bottom": "ToolTip-bottom-2_3_6-1zOme",
	"bottomLeft": "ToolTip-bottomLeft-2_3_6-Mg4aQ",
	"bottomRight": "ToolTip-bottomRight-2_3_6-1gBQJ",
	"right": "ToolTip-right-2_3_6-j-cPb",
	"rightTop": "ToolTip-rightTop-2_3_6-iWpmp",
	"rightBottom": "ToolTip-rightBottom-2_3_6-278hS",
	"left": "ToolTip-left-2_3_6-2HCJF",
	"leftTop": "ToolTip-leftTop-2_3_6-3hgkW",
	"leftBottom": "ToolTip-leftBottom-2_3_6-FosXL",
	"linkInFooter": "ToolTip-linkInFooter-2_3_6-1BlCk",
	"tooltipInner": "ToolTip-tooltipInner-2_3_6-cb72Q",
	"tooltipArrow": "ToolTip-tooltipArrow-2_3_6-1ieTU",
	"blueSteel": "ToolTip-blueSteel-2_3_6-hIeRb"
};

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(217);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return _Icon__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _IconNames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(221);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ICONS", function() { return _IconNames__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return Icon; });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(218);
/* harmony import */ var _brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _Icon_sass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(219);
/* harmony import */ var _Icon_sass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_Icon_sass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(155);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








/**
 * A simple icon component that inherits its styles from the dom like text.
 * Icons are rendered at 0.82 opacity by default unless a color is provided.
 *
 * **Note:** This component requires a peerDependency of
 * [@brightcove/studio-icons](https://www.npmjs.com/package/@brightcove/studio-icons)
 * and
 * [studio-colors](https://bithub.brightcove.com/studio-ui-kit/studio-colors/).
 *
 * **Note:** The `ICONS` object in the examples is a lookup utility within the
 * studio-components library that proxies icons in the studio-icons library. To
 * use the `ICONS` object, import it from the studio-components library:
 *
 * ```js
 * import { Icon, ICONS } from '@brightcove/studio-components'
 * ```
 */

function Icon(_ref) {
  var _cx;

  var className = _ref.className,
      color = _ref.color,
      flip = _ref.flip,
      name = _ref.name,
      padRight = _ref.padRight,
      rotate = _ref.rotate,
      spin = _ref.spin,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;
  var ICONS_FOR_THEME = _brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11__["ICONS"];

  if (_brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11__["BLUE_STEEL"] && _brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11__["CLASSIC"]) {
    ICONS_FOR_THEME = theme === 'blueSteel' ? _brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11__["BLUE_STEEL"] : _brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11__["CLASSIC"];
  }

  var iconName = name.toUpperCase();

  if (!_brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_11__["ICONS"].hasOwnProperty(iconName)) {
    if (false) {}

    throw new Error("Icon named '".concat(iconName, "' does not exist."));
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("svg", {
    "aria-hidden": "true",
    role: "img",
    style: _objectSpread({
      fill: Object(_Theme__WEBPACK_IMPORTED_MODULE_13__["themePalette"])(theme)[color] || color || 'currentColor'
    }, style),
    className: classnames__WEBPACK_IMPORTED_MODULE_10___default()(_Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a.inlineIcon, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a["rotate".concat(rotate)], rotate), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a["flip".concat(flip)], flip), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a.padRight, padRight), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a.spin, !flip && spin), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a.spinFlip, flip && spin), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a.pulse, iconName === 'SPINNER' && spin), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a.semiTransparent, !color), _cx)),
    viewBox: "0 0 1024 1024",
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("path", {
    d: ICONS_FOR_THEME[iconName]
  }));
}
Icon.propTypes = {
  /** Class to apply to the icon SVG. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** Icon will inherit its color from the page but you may alternately specify a color name from the studio-colors project or any hex value. */
  color: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** Whether to flip the icon vertically or horizontally. */
  flip: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['horizontal', 'vertical']),

  /** Name of the icon to use from studio-icons (case insensitive). */
  name: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string.isRequired,

  /** If true a right margin will be applied to separate this icon from adjacent inline content. */
  padRight: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool,

  /** Angle in degrees to rotate the icon. */
  rotate: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['90', '180', '270']),

  /** Spin the icon. */
  spin: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.bool,

  /** Style attribute on the icon SVG. */
  style: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.any,

  /** Test name for end to end testing */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_13__["provideTheme"])(_Icon_sass__WEBPACK_IMPORTED_MODULE_12___default.a)(Icon));

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__218__;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(220);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Icon-inlineIcon-2_3_6-1eq2-{display:inline-block;font-size:inherit;height:1.0666666667em;width:1.0666666667em;overflow:visible;vertical-align:-.125em}.Icon-semiTransparent-2_3_6-3VhrN{opacity:.82}.Icon-rotate90-2_3_6-1VMRA{transform:rotate(90deg);filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1)}.Icon-rotate180-2_3_6-2QBpw{transform:rotate(180deg);filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2)}.Icon-rotate270-2_3_6-irCBZ{transform:rotate(270deg);filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3)}.Icon-fliphorizontal-2_3_6-LERv9{transform:scaleX(-1)}.Icon-flipvertical-2_3_6-3nlVN{transform:scaleY(-1)}.Icon-spin-2_3_6-1An-q{animation:Icon-spin-2_3_6-1An-q 2s infinite linear}.Icon-spinFlip-2_3_6-EnT0_{animation:Icon-spinFlip-2_3_6-EnT0_ 2s infinite linear}@keyframes Icon-spin-2_3_6-1An-q{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.Icon-pulse-2_3_6-3_dSe{animation:Icon-spinFlip-2_3_6-EnT0_ 1s infinite steps(8);transform-origin:48.6% 51.6%}@keyframes Icon-spinFlip-2_3_6-EnT0_{0%{transform:rotate(0deg) scaleX(-1)}to{transform:rotate(1turn) scaleX(-1)}}.Icon-padRight-2_3_6-KvxXE{margin-right:.3333333333em}", ""]);

// exports
exports.locals = {
	"inlineIcon": "Icon-inlineIcon-2_3_6-1eq2-",
	"semiTransparent": "Icon-semiTransparent-2_3_6-3VhrN",
	"rotate90": "Icon-rotate90-2_3_6-1VMRA",
	"rotate180": "Icon-rotate180-2_3_6-2QBpw",
	"rotate270": "Icon-rotate270-2_3_6-irCBZ",
	"fliphorizontal": "Icon-fliphorizontal-2_3_6-LERv9",
	"flipvertical": "Icon-flipvertical-2_3_6-3nlVN",
	"spin": "Icon-spin-2_3_6-1An-q",
	"spinFlip": "Icon-spinFlip-2_3_6-EnT0_",
	"pulse": "Icon-pulse-2_3_6-3_dSe",
	"padRight": "Icon-padRight-2_3_6-KvxXE"
};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(222);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(218);
/* harmony import */ var _brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_2__);



/**
A KeyMirror of icon names so we can use the following syntax:
```
<Icon name={ICONS.BELL} />
```
This makes icon names discoverable in IDEs.
*/

/* harmony default export */ __webpack_exports__["default"] = (Object.keys(_brightcove_studio_icons__WEBPACK_IMPORTED_MODULE_2__["ICONS"]).reduce(function (nameMap, name) {
  nameMap[name] = name;
  return nameMap;
}, {}));

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $reduce = __webpack_require__(223).left;
var arrayMethodIsStrict = __webpack_require__(144);
var CHROME_VERSION = __webpack_require__(59);
var IS_NODE = __webpack_require__(58);

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(70);
var toObject = __webpack_require__(77);
var IndexedObject = __webpack_require__(16);
var toLength = __webpack_require__(45);

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(155);
/* harmony import */ var _Definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(225);
/* harmony import */ var _Accordion_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(189);
/* harmony import */ var _Accordion_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Accordion_sass__WEBPACK_IMPORTED_MODULE_5__);







var SummaryDetail = function SummaryDetail(_ref) {
  var className = _ref.className,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme,
      label = _ref.label,
      value = _ref.value;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Definition__WEBPACK_IMPORTED_MODULE_4__["Definition"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Accordion_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], _Accordion_sass__WEBPACK_IMPORTED_MODULE_5___default.a.summaryDetail, className),
    style: style,
    testName: testName,
    theme: theme,
    label: label,
    value: value
  });
};

SummaryDetail.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_3__["provideTheme"])(_Accordion_sass__WEBPACK_IMPORTED_MODULE_5___default.a)(SummaryDetail));

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(226);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Definition", function() { return _Definition__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Definition", function() { return Definition; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Definition_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(227);
/* harmony import */ var _Definition_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Definition_sass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);





/**
 * A Definition is used to describe a key-value pair of data.
 */

function Definition(props) {
  var className = props.className,
      label = props.label,
      testName = props.testName,
      value = props.value,
      style = props.style,
      theme = props.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Definition_sass__WEBPACK_IMPORTED_MODULE_2___default.a[theme], className),
    "data-test-name": testName,
    style: style
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Definition_sass__WEBPACK_IMPORTED_MODULE_2___default.a[theme], _Definition_sass__WEBPACK_IMPORTED_MODULE_2___default.a.label)
  }, label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: _Definition_sass__WEBPACK_IMPORTED_MODULE_2___default.a.value
  }, value));
}
Definition.propTypes = {
  /** An optional CSS class name to add to the definition's containing div */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** The name of the pair */
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** The description or value of the pair */
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_4__["provideTheme"])(_Definition_sass__WEBPACK_IMPORTED_MODULE_2___default.a)(Definition));

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(228);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI{border:1px solid #aaa;font-size:1rem;font-family:Lato,Helvetica,Arial,sans-serif;background-color:#fff}.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI .Definition-disabled-2_3_6-kCBd4:not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP),.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI .Definition-disabled-2_3_6-kCBd4:not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP),.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:disabled:not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP),.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:disabled:not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP){background-color:#f4f4f4;border:1px solid #ccc;color:#999}.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP).Definition-hasError-2_3_6-tt1KP,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP).Definition-hasError-2_3_6-tt1KP,.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) .Definition-hasError-2_3_6-tt1KP,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) .Definition-hasError-2_3_6-tt1KP{border-color:#ba2453;outline:none}.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):active,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):active,.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):active,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):active,.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):focus,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):focus,.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):focus,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):focus,.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):hover,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):hover,.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):hover,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):hover{border-color:#999;color:#444}.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI.Definition-readOnly-2_3_6-WUEJP,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI.Definition-readOnly-2_3_6-WUEJP,.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI[readonly],.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI[readonly]{color:#666;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI{color:#444;border-radius:0;padding:8px;width:100%;max-width:100%;line-height:18px}.Definition-classic-2_3_6-1VYT-.Definition-input-2_3_6-1lNpI::-ms-clear,.Definition-classic-2_3_6-1VYT- .Definition-input-2_3_6-1lNpI::-ms-clear{display:none}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI{border:1px solid #e5e6e6;font-size:1rem;font-family:Public Sans,sans-serif;background-color:#fff}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI .Definition-disabled-2_3_6-kCBd4:not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP),.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI .Definition-disabled-2_3_6-kCBd4:not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP),.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:disabled:not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP),.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:disabled:not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP){background-color:#f2f2f3;border:1px solid #f2f2f3;color:#8e9093}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP).Definition-hasError-2_3_6-tt1KP,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP).Definition-hasError-2_3_6-tt1KP,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) .Definition-hasError-2_3_6-tt1KP,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) .Definition-hasError-2_3_6-tt1KP{border-color:#d33d00;outline:none}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):active,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):active,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):active,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):active,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):focus,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):focus,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):focus,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):focus,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):hover,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):not(.Definition-hasError-2_3_6-tt1KP):hover,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):hover,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP) :not(.Definition-hasError-2_3_6-tt1KP):hover{border-color:#8e9093;color:#01050e}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI.Definition-readOnly-2_3_6-WUEJP,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI.Definition-readOnly-2_3_6-WUEJP,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI[readonly],.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI[readonly]{color:#4d5056;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI{color:#4d5056;border-radius:3px;margin:1px;padding:11px}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP).Definition-hasError-2_3_6-tt1KP,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP).Definition-hasError-2_3_6-tt1KP,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):active,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):active,.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):focus,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI:not(:disabled):not(.Definition-disabled-2_3_6-kCBd4):not([readonly]):not(.Definition-readOnly-2_3_6-WUEJP):focus{border-width:2px;margin:0}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI{width:100%;max-width:100%;line-height:24px}.Definition-blueSteel-2_3_6-eKPaZ.Definition-input-2_3_6-1lNpI::-ms-clear,.Definition-blueSteel-2_3_6-eKPaZ .Definition-input-2_3_6-1lNpI::-ms-clear{display:none}.Definition-classic-2_3_6-1VYT- a{color:#079bb3}.Definition-classic-2_3_6-1VYT- .Definition-label-2_3_6-GoqC7{color:#666;font-size:.9333333333rem;font-weight:700;margin-bottom:2px}.Definition-classic-2_3_6-1VYT- .Definition-value-2_3_6-DlVkJ{color:#444;font-size:1rem;margin:0 0 1rem;word-break:break-word;border:none;padding:0}.Definition-blueSteel-2_3_6-eKPaZ a{color:#08088c}.Definition-blueSteel-2_3_6-eKPaZ .Definition-label-2_3_6-GoqC7{color:#4d5056;font-size:.9333333333rem;font-weight:700;margin-bottom:2px}.Definition-blueSteel-2_3_6-eKPaZ .Definition-value-2_3_6-DlVkJ{color:#01050e;font-size:1rem;margin:0 0 1rem;word-break:break-word;border:none;padding:0}", ""]);

// exports
exports.locals = {
	"classic": "Definition-classic-2_3_6-1VYT-",
	"input": "Definition-input-2_3_6-1lNpI",
	"readOnly": "Definition-readOnly-2_3_6-WUEJP",
	"disabled": "Definition-disabled-2_3_6-kCBd4",
	"hasError": "Definition-hasError-2_3_6-tt1KP",
	"blueSteel": "Definition-blueSteel-2_3_6-eKPaZ",
	"label": "Definition-label-2_3_6-GoqC7",
	"value": "Definition-value-2_3_6-DlVkJ"
};

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Alert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(230);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return _Alert__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return Alert; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(216);
/* harmony import */ var _Fadeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(201);
/* harmony import */ var _Hideable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(231);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(155);
/* harmony import */ var _Alert_sass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(233);
/* harmony import */ var _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Alert_sass__WEBPACK_IMPORTED_MODULE_11__);












var types = {
  info: 'info',
  notice: 'info',
  warning: 'warning',
  error: 'ban',
  success: 'ok_circled'
};
/**
 * An Alert.
 */

function Alert(_ref) {
  var _cx;

  var block = _ref.block,
      children = _ref.children,
      className = _ref.className,
      onClose = _ref.onClose,
      style = _ref.style,
      testName = _ref.testName,
      title = _ref.title,
      text = _ref.text,
      type = _ref.type,
      button1Text = _ref.button1Text,
      onClickButton1 = _ref.onClickButton1,
      button2Text = _ref.button2Text,
      onClickButton2 = _ref.onClickButton2,
      details = _ref.details,
      theme = _ref.theme;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_useState, 2),
      showDetails = _useState2[0],
      setShowDetails = _useState2[1];

  var toggleDetails = function toggleDetails() {
    setShowDetails(!showDetails);
  };

  var getIcon = function getIcon(type) {
    return types[type];
  };

  var message = text || children;
  var detail = typeof details === 'string' ? details : JSON.stringify(details);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.container, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a[type], true), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.block, block), _cx));
  var ariaMessage = !detail ? message : message + ' Click show details for more.';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: classes,
    style: style,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.contents
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.iconContainer
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_7__["Icon"], {
    name: getIcon(type)
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.alertText,
    role: "alert",
    "aria-label": ariaMessage
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.title
  }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.message
  }, message)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_9__["Hideable"], {
    show: Boolean(button1Text || button2Text)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.buttonContainer
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_9__["Hideable"], {
    show: Boolean(button1Text)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("a", {
    tabIndex: 0,
    role: "button",
    onClick: onClickButton1
  }, button1Text)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_9__["Hideable"], {
    show: Boolean(button2Text)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("a", {
    tabIndex: 0,
    role: "button",
    onClick: onClickButton2
  }, button2Text)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_9__["Hideable"], {
    show: Boolean(onClose)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
    tabIndex: 0,
    role: "button",
    "aria-label": "dismiss message",
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.closeBtn,
    onClick: onClose,
    onKeyDown: function onKeyDown(evt) {
      return Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_6__["default"])(evt).handleClickIntent(onClose);
    }
  }, "\xD7"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_9__["Hideable"], {
    show: Boolean(detail)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("a", {
    tabIndex: 0,
    role: "button",
    onClick: toggleDetails,
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.showDetailsLink,
    onKeyDown: function onKeyDown(evt) {
      return Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_6__["default"])(evt).handleClickIntent(toggleDetails);
    }
  }, showDetails ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_7__["Icon"], {
    name: "triangle_down"
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_7__["Icon"], {
    name: "triangle_right"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Fadeable__WEBPACK_IMPORTED_MODULE_8__["Fadeable"], {
    show: showDetails
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a.details
  }, detail)));
}
Alert.propTypes = {
  /** Whether this component should be full-width. */
  block: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Class to apply to the animation vector. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Alert body. You may alternately use the `text` prop for plain text. */
  children: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_4___default()(prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node, function (props) {
    return !props.text;
  }),

  /** Technical details of the message. These are optional and hidden by default */
  details: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object]),

  /**
   * Handler for when the close button is clicked. If this function is not
   * provided, the close button will not be shown.
   */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,

  /** Container element styles */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Alert title [BlueSteel Only] */
  title: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Alert text. You can also pass this in via `children` */
  text: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_4___default()(prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node, function (props) {
    return !props.children;
  }),

  /**
   * **Error** alerts are used to call attention to errors on a page or within a large area. Use them in combination with field-level error text. They usually appear centered near the top of a page, but may also appear in a local area such as a panel.<br>
   * **Info** alerts are used to confirm or prompt an action, such as publishing a player that has changes. They are temporary, and often disappear automatically. Users can always dismiss them. They usually appear centered on top of the page header.<br>
   * **Notices** appear inline, and are used to highlight important information. They should not be dismissible.
   */
  type: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOf(['error', 'warning', 'info', 'notice', 'success']),

  /** Action button 1 text [BlueSteel Only] */
  button1Text: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Callback that is fired when the user clicks on action button 1 [BlueSteel Only] */
  onClickButton1: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,

  /** Action button 2 text [BlueSteel Only] */
  button2Text: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Callback that is fired when the user clicks on action button 1 [BlueSteel Only] */
  onClickButton2: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};
Alert.defaultProps = {
  block: false,
  type: 'error'
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_10__["provideTheme"])(_Alert_sass__WEBPACK_IMPORTED_MODULE_11___default.a)(Alert));

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Hideable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(232);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hideable", function() { return _Hideable__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Hideable; });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/**
 * A utility component for hiding content.
 *
 * __NOTE:__ When a [Flex](#flex) is used around a Hideable, the flex styles
 * will be passed through to the Hideable's children when visible. Conflicting
 * styles on the child will take precedence over the styles applied by the
 * `Flex`.
 */

function Hideable(props) {
  var children = props.children,
      show = props.show,
      style = props.style;

  if (!show) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("noscript", null);
  }

  if (children == null) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("noscript", null);
  }

  return children.length > 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
    style: style
  }, children) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.cloneElement(children, {
    style: _objectSpread(_objectSpread({}, style), children.props.style)
  });
}
Hideable.propTypes = {
  /** Content to show/hide */
  children: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.node,

  /** Whether or not to show the given content */
  show: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /**
   * Style attribute - applied to the container if multiple child nodes are
   * provided or directly merged onto the child node if only a single child is
   * provided. Child styles take precedence over hideable styles. It is
   * recommended to apply styles directly to the children when possible instead
   * of using this prop.
   */
  style: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(234);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Alert-classic-2_3_6-3ZDVH a{color:#079bb3}.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1,.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1{border-radius:4px;display:inline-block;position:relative;margin-bottom:.3333333333rem;padding:.8rem;color:#fff}.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1+.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1:not(.Alert-block-2_3_6-14Y4F),.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1+.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1:not(.Alert-block-2_3_6-14Y4F),.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1+.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1:not(.Alert-block-2_3_6-14Y4F),.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1+.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1:not(.Alert-block-2_3_6-14Y4F){margin-left:.3333333333rem}.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1 a,.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1 a,.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1 a:focus,.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1 a:focus,.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1 a:hover,.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1 a:hover,.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1 a:visited,.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1 a:visited{border-bottom:1px dotted;text-decoration:none;color:#fff}.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1 a:focus,.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1 a:focus,.Alert-classic-2_3_6-3ZDVH.Alert-container-2_3_6-33Jt1 a:hover,.Alert-classic-2_3_6-3ZDVH .Alert-container-2_3_6-33Jt1 a:hover{border-bottom:1px solid}.Alert-classic-2_3_6-3ZDVH .Alert-buttonContainer-2_3_6-2CiUj,.Alert-classic-2_3_6-3ZDVH.Alert-iconContainer-2_3_6-x6Bau,.Alert-classic-2_3_6-3ZDVH .Alert-iconContainer-2_3_6-x6Bau,.Alert-classic-2_3_6-3ZDVH .Alert-title-2_3_6-2QaDF{display:none}.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2{background-color:#dcf3fb}.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2,.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2 a,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2 a,.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2 a:focus,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2 a:focus,.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2 a:hover,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2 a:hover,.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2 a:visited,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2 a:visited{color:#444}.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK{background-color:#fde86a}.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK,.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK a,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK a,.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK a:focus,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK a:focus,.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK a:hover,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK a:hover,.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK a:visited,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK a:visited{color:#444}.Alert-classic-2_3_6-3ZDVH.Alert-warning-2_3_6-1COlz,.Alert-classic-2_3_6-3ZDVH .Alert-warning-2_3_6-1COlz{background-color:#ef6c2a;font-weight:700}.Alert-classic-2_3_6-3ZDVH.Alert-error-2_3_6-1DfSL,.Alert-classic-2_3_6-3ZDVH .Alert-error-2_3_6-1DfSL{background-color:#d32781;font-weight:700}.Alert-classic-2_3_6-3ZDVH.Alert-block-2_3_6-14Y4F,.Alert-classic-2_3_6-3ZDVH .Alert-block-2_3_6-14Y4F{display:block}.Alert-classic-2_3_6-3ZDVH.Alert-alertText-2_3_6-3BszY,.Alert-classic-2_3_6-3ZDVH .Alert-alertText-2_3_6-3BszY{margin-right:1.2rem}.Alert-classic-2_3_6-3ZDVH.Alert-showDetailsLink-2_3_6-3PDwH,.Alert-classic-2_3_6-3ZDVH .Alert-showDetailsLink-2_3_6-3PDwH{cursor:pointer;display:inline-block;font-weight:400;font-size:.8rem;margin-top:.5rem}.Alert-error-2_3_6-1DfSL .Alert-classic-2_3_6-3ZDVH.Alert-showDetailsLink-2_3_6-3PDwH,.Alert-error-2_3_6-1DfSL .Alert-classic-2_3_6-3ZDVH .Alert-showDetailsLink-2_3_6-3PDwH,.Alert-warning-2_3_6-1COlz .Alert-classic-2_3_6-3ZDVH.Alert-showDetailsLink-2_3_6-3PDwH,.Alert-warning-2_3_6-1COlz .Alert-classic-2_3_6-3ZDVH .Alert-showDetailsLink-2_3_6-3PDwH{color:#fff}.Alert-classic-2_3_6-3ZDVH.Alert-showDetailsLink-2_3_6-3PDwH:focus,.Alert-classic-2_3_6-3ZDVH .Alert-showDetailsLink-2_3_6-3PDwH:focus,.Alert-classic-2_3_6-3ZDVH.Alert-showDetailsLink-2_3_6-3PDwH:hover,.Alert-classic-2_3_6-3ZDVH .Alert-showDetailsLink-2_3_6-3PDwH:hover{text-decoration:underline}.Alert-classic-2_3_6-3ZDVH.Alert-details-2_3_6-1nv32,.Alert-classic-2_3_6-3ZDVH .Alert-details-2_3_6-1nv32{font-family:monospace,monospace;font-weight:400;font-size:.8rem;white-space:normal;word-wrap:break-word;max-height:10rem;overflow:auto;margin:.5rem 0 0;background:hsla(0,0%,100%,.1);padding:.5rem}.Alert-classic-2_3_6-3ZDVH.Alert-closeBtn-2_3_6-1dcEX,.Alert-classic-2_3_6-3ZDVH .Alert-closeBtn-2_3_6-1dcEX{font-weight:400;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:1;position:absolute;top:0;right:0;cursor:pointer;padding:.5rem;font-size:1.5rem;color:#fff;opacity:.8;transition:transform .1s ease-in-out,opacity .1s ease-in-out}.Alert-classic-2_3_6-3ZDVH.Alert-closeBtn-2_3_6-1dcEX:active,.Alert-classic-2_3_6-3ZDVH .Alert-closeBtn-2_3_6-1dcEX:active,.Alert-classic-2_3_6-3ZDVH.Alert-closeBtn-2_3_6-1dcEX:focus,.Alert-classic-2_3_6-3ZDVH .Alert-closeBtn-2_3_6-1dcEX:focus,.Alert-classic-2_3_6-3ZDVH.Alert-closeBtn-2_3_6-1dcEX:hover,.Alert-classic-2_3_6-3ZDVH .Alert-closeBtn-2_3_6-1dcEX:hover{transform:scale(1.2);opacity:1;color:#fff}.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK .Alert-closeBtn-2_3_6-1dcEX,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK .Alert-closeBtn-2_3_6-1dcEX,.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2 .Alert-closeBtn-2_3_6-1dcEX,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2 .Alert-closeBtn-2_3_6-1dcEX{color:#444}.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK .Alert-closeBtn-2_3_6-1dcEX:active,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK .Alert-closeBtn-2_3_6-1dcEX:active,.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK .Alert-closeBtn-2_3_6-1dcEX:focus,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK .Alert-closeBtn-2_3_6-1dcEX:focus,.Alert-classic-2_3_6-3ZDVH.Alert-info-2_3_6-1U4iK .Alert-closeBtn-2_3_6-1dcEX:hover,.Alert-classic-2_3_6-3ZDVH .Alert-info-2_3_6-1U4iK .Alert-closeBtn-2_3_6-1dcEX:hover,.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2 .Alert-closeBtn-2_3_6-1dcEX:active,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2 .Alert-closeBtn-2_3_6-1dcEX:active,.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2 .Alert-closeBtn-2_3_6-1dcEX:focus,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2 .Alert-closeBtn-2_3_6-1dcEX:focus,.Alert-classic-2_3_6-3ZDVH.Alert-notice-2_3_6-13bh2 .Alert-closeBtn-2_3_6-1dcEX:hover,.Alert-classic-2_3_6-3ZDVH .Alert-notice-2_3_6-13bh2 .Alert-closeBtn-2_3_6-1dcEX:hover{color:#222}.Alert-blueSteel-2_3_6-Kpkjf a{color:#08088c}.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1,.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1{display:inline-block;position:relative;margin-bottom:.3333333333rem;padding:1rem 1rem 1rem 25px;color:#01050e}.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1+.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1:not(.Alert-block-2_3_6-14Y4F),.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1+.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1:not(.Alert-block-2_3_6-14Y4F),.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1+.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1:not(.Alert-block-2_3_6-14Y4F),.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1+.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1:not(.Alert-block-2_3_6-14Y4F){margin-left:.3333333333rem}.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1 a,.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1 a,.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1 a:focus,.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1 a:focus,.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1 a:hover,.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1 a:hover,.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1 a:visited,.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1 a:visited{border-bottom:1px dotted;text-decoration:none;color:#08088c}.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1 a:focus,.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1 a:focus,.Alert-blueSteel-2_3_6-Kpkjf.Alert-container-2_3_6-33Jt1 a:hover,.Alert-blueSteel-2_3_6-Kpkjf .Alert-container-2_3_6-33Jt1 a:hover{border-bottom:1px solid}.Alert-blueSteel-2_3_6-Kpkjf.Alert-success-2_3_6-AJJXf,.Alert-blueSteel-2_3_6-Kpkjf .Alert-success-2_3_6-AJJXf{background-color:#d7f6e6;border-left:4px solid #009e4f}.Alert-blueSteel-2_3_6-Kpkjf.Alert-success-2_3_6-AJJXf .Alert-iconContainer-2_3_6-x6Bau,.Alert-blueSteel-2_3_6-Kpkjf .Alert-success-2_3_6-AJJXf .Alert-iconContainer-2_3_6-x6Bau{color:#009e4f}.Alert-blueSteel-2_3_6-Kpkjf.Alert-success-2_3_6-AJJXf a,.Alert-blueSteel-2_3_6-Kpkjf .Alert-success-2_3_6-AJJXf a,.Alert-blueSteel-2_3_6-Kpkjf.Alert-success-2_3_6-AJJXf a:focus,.Alert-blueSteel-2_3_6-Kpkjf .Alert-success-2_3_6-AJJXf a:focus,.Alert-blueSteel-2_3_6-Kpkjf.Alert-success-2_3_6-AJJXf a:hover,.Alert-blueSteel-2_3_6-Kpkjf .Alert-success-2_3_6-AJJXf a:hover,.Alert-blueSteel-2_3_6-Kpkjf.Alert-success-2_3_6-AJJXf a:visited,.Alert-blueSteel-2_3_6-Kpkjf .Alert-success-2_3_6-AJJXf a:visited{color:#08088c}.Alert-blueSteel-2_3_6-Kpkjf.Alert-info-2_3_6-1U4iK,.Alert-blueSteel-2_3_6-Kpkjf .Alert-info-2_3_6-1U4iK{background-color:#f2f4f9;border-left:4px solid #092dbd;color:#01050e}.Alert-blueSteel-2_3_6-Kpkjf.Alert-info-2_3_6-1U4iK .Alert-iconContainer-2_3_6-x6Bau,.Alert-blueSteel-2_3_6-Kpkjf .Alert-info-2_3_6-1U4iK .Alert-iconContainer-2_3_6-x6Bau{color:#092dbd}.Alert-blueSteel-2_3_6-Kpkjf.Alert-info-2_3_6-1U4iK a,.Alert-blueSteel-2_3_6-Kpkjf .Alert-info-2_3_6-1U4iK a,.Alert-blueSteel-2_3_6-Kpkjf.Alert-info-2_3_6-1U4iK a:focus,.Alert-blueSteel-2_3_6-Kpkjf .Alert-info-2_3_6-1U4iK a:focus,.Alert-blueSteel-2_3_6-Kpkjf.Alert-info-2_3_6-1U4iK a:hover,.Alert-blueSteel-2_3_6-Kpkjf .Alert-info-2_3_6-1U4iK a:hover,.Alert-blueSteel-2_3_6-Kpkjf.Alert-info-2_3_6-1U4iK a:visited,.Alert-blueSteel-2_3_6-Kpkjf .Alert-info-2_3_6-1U4iK a:visited{color:#08088c}.Alert-blueSteel-2_3_6-Kpkjf.Alert-warning-2_3_6-1COlz,.Alert-blueSteel-2_3_6-Kpkjf .Alert-warning-2_3_6-1COlz{background-color:#fffbf2;border-left:4px solid #ffba00}.Alert-blueSteel-2_3_6-Kpkjf.Alert-warning-2_3_6-1COlz .Alert-iconContainer-2_3_6-x6Bau,.Alert-blueSteel-2_3_6-Kpkjf .Alert-warning-2_3_6-1COlz .Alert-iconContainer-2_3_6-x6Bau{color:#4d5056}.Alert-blueSteel-2_3_6-Kpkjf.Alert-warning-2_3_6-1COlz a,.Alert-blueSteel-2_3_6-Kpkjf .Alert-warning-2_3_6-1COlz a,.Alert-blueSteel-2_3_6-Kpkjf.Alert-warning-2_3_6-1COlz a:focus,.Alert-blueSteel-2_3_6-Kpkjf .Alert-warning-2_3_6-1COlz a:focus,.Alert-blueSteel-2_3_6-Kpkjf.Alert-warning-2_3_6-1COlz a:hover,.Alert-blueSteel-2_3_6-Kpkjf .Alert-warning-2_3_6-1COlz a:hover,.Alert-blueSteel-2_3_6-Kpkjf.Alert-warning-2_3_6-1COlz a:visited,.Alert-blueSteel-2_3_6-Kpkjf .Alert-warning-2_3_6-1COlz a:visited{color:#08088c}.Alert-blueSteel-2_3_6-Kpkjf.Alert-error-2_3_6-1DfSL,.Alert-blueSteel-2_3_6-Kpkjf .Alert-error-2_3_6-1DfSL{background-color:#fdf6f3;border-left:4px solid #d33d00}.Alert-blueSteel-2_3_6-Kpkjf.Alert-error-2_3_6-1DfSL .Alert-iconContainer-2_3_6-x6Bau,.Alert-blueSteel-2_3_6-Kpkjf .Alert-error-2_3_6-1DfSL .Alert-iconContainer-2_3_6-x6Bau{color:#d33d00}.Alert-blueSteel-2_3_6-Kpkjf.Alert-error-2_3_6-1DfSL a,.Alert-blueSteel-2_3_6-Kpkjf .Alert-error-2_3_6-1DfSL a,.Alert-blueSteel-2_3_6-Kpkjf.Alert-error-2_3_6-1DfSL a:focus,.Alert-blueSteel-2_3_6-Kpkjf .Alert-error-2_3_6-1DfSL a:focus,.Alert-blueSteel-2_3_6-Kpkjf.Alert-error-2_3_6-1DfSL a:hover,.Alert-blueSteel-2_3_6-Kpkjf .Alert-error-2_3_6-1DfSL a:hover,.Alert-blueSteel-2_3_6-Kpkjf.Alert-error-2_3_6-1DfSL a:visited,.Alert-blueSteel-2_3_6-Kpkjf .Alert-error-2_3_6-1DfSL a:visited{color:#08088c}.Alert-blueSteel-2_3_6-Kpkjf.Alert-contents-2_3_6-1kQVM,.Alert-blueSteel-2_3_6-Kpkjf .Alert-contents-2_3_6-1kQVM{display:-ms-flexbox;display:flex}.Alert-blueSteel-2_3_6-Kpkjf.Alert-block-2_3_6-14Y4F,.Alert-blueSteel-2_3_6-Kpkjf .Alert-block-2_3_6-14Y4F{display:block}.Alert-blueSteel-2_3_6-Kpkjf.Alert-iconContainer-2_3_6-x6Bau,.Alert-blueSteel-2_3_6-Kpkjf .Alert-iconContainer-2_3_6-x6Bau{margin-right:24px;display:inline}.Alert-blueSteel-2_3_6-Kpkjf.Alert-alertText-2_3_6-3BszY,.Alert-blueSteel-2_3_6-Kpkjf .Alert-alertText-2_3_6-3BszY{display:inline;-ms-flex-positive:1;flex-grow:1;margin-right:32px}.Alert-blueSteel-2_3_6-Kpkjf.Alert-alertText-2_3_6-3BszY.Alert-title-2_3_6-2QaDF,.Alert-blueSteel-2_3_6-Kpkjf.Alert-alertText-2_3_6-3BszY .Alert-title-2_3_6-2QaDF,.Alert-blueSteel-2_3_6-Kpkjf .Alert-alertText-2_3_6-3BszY.Alert-title-2_3_6-2QaDF,.Alert-blueSteel-2_3_6-Kpkjf .Alert-alertText-2_3_6-3BszY .Alert-title-2_3_6-2QaDF{display:inline;margin-right:3px;font-weight:700}.Alert-blueSteel-2_3_6-Kpkjf.Alert-alertText-2_3_6-3BszY.Alert-message-2_3_6-9UU1A,.Alert-blueSteel-2_3_6-Kpkjf.Alert-alertText-2_3_6-3BszY .Alert-message-2_3_6-9UU1A,.Alert-blueSteel-2_3_6-Kpkjf .Alert-alertText-2_3_6-3BszY.Alert-message-2_3_6-9UU1A,.Alert-blueSteel-2_3_6-Kpkjf .Alert-alertText-2_3_6-3BszY .Alert-message-2_3_6-9UU1A{display:inline-block;font-weight:400}.Alert-blueSteel-2_3_6-Kpkjf.Alert-showDetailsLink-2_3_6-3PDwH,.Alert-blueSteel-2_3_6-Kpkjf .Alert-showDetailsLink-2_3_6-3PDwH{cursor:pointer;display:inline-block;font-weight:400;font-size:.8rem;margin-top:.5rem}.Alert-error-2_3_6-1DfSL .Alert-blueSteel-2_3_6-Kpkjf.Alert-showDetailsLink-2_3_6-3PDwH,.Alert-error-2_3_6-1DfSL .Alert-blueSteel-2_3_6-Kpkjf .Alert-showDetailsLink-2_3_6-3PDwH,.Alert-warning-2_3_6-1COlz .Alert-blueSteel-2_3_6-Kpkjf.Alert-showDetailsLink-2_3_6-3PDwH,.Alert-warning-2_3_6-1COlz .Alert-blueSteel-2_3_6-Kpkjf .Alert-showDetailsLink-2_3_6-3PDwH{color:#fff}.Alert-blueSteel-2_3_6-Kpkjf.Alert-showDetailsLink-2_3_6-3PDwH:focus,.Alert-blueSteel-2_3_6-Kpkjf .Alert-showDetailsLink-2_3_6-3PDwH:focus,.Alert-blueSteel-2_3_6-Kpkjf.Alert-showDetailsLink-2_3_6-3PDwH:hover,.Alert-blueSteel-2_3_6-Kpkjf .Alert-showDetailsLink-2_3_6-3PDwH:hover{text-decoration:underline}.Alert-blueSteel-2_3_6-Kpkjf.Alert-details-2_3_6-1nv32,.Alert-blueSteel-2_3_6-Kpkjf .Alert-details-2_3_6-1nv32{font-family:monospace,monospace;font-weight:400;font-size:.8rem;white-space:normal;word-wrap:break-word;max-height:10rem;overflow:auto;margin:.5rem 0 0;background:hsla(0,0%,100%,.1);padding:.5rem}.Alert-blueSteel-2_3_6-Kpkjf.Alert-closeBtn-2_3_6-1dcEX,.Alert-blueSteel-2_3_6-Kpkjf .Alert-closeBtn-2_3_6-1dcEX{font-weight:400;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:.8;cursor:pointer;font-size:1.5rem;color:#092dbd}.Alert-blueSteel-2_3_6-Kpkjf.Alert-buttonContainer-2_3_6-2CiUj,.Alert-blueSteel-2_3_6-Kpkjf .Alert-buttonContainer-2_3_6-2CiUj{display:-ms-flexbox;display:flex;padding-top:1px;padding-left:64px}.Alert-blueSteel-2_3_6-Kpkjf.Alert-buttonContainer-2_3_6-2CiUj a,.Alert-blueSteel-2_3_6-Kpkjf .Alert-buttonContainer-2_3_6-2CiUj a{border-bottom:none;text-decoration:none;cursor:pointer;margin:0 24px 0 0}.Alert-blueSteel-2_3_6-Kpkjf.Alert-buttonContainer-2_3_6-2CiUj a:focus,.Alert-blueSteel-2_3_6-Kpkjf .Alert-buttonContainer-2_3_6-2CiUj a:focus,.Alert-blueSteel-2_3_6-Kpkjf.Alert-buttonContainer-2_3_6-2CiUj a:hover,.Alert-blueSteel-2_3_6-Kpkjf .Alert-buttonContainer-2_3_6-2CiUj a:hover,.Alert-blueSteel-2_3_6-Kpkjf.Alert-buttonContainer-2_3_6-2CiUj a:visited,.Alert-blueSteel-2_3_6-Kpkjf .Alert-buttonContainer-2_3_6-2CiUj a:visited{border-bottom:none;text-decoration:none}", ""]);

// exports
exports.locals = {
	"classic": "Alert-classic-2_3_6-3ZDVH",
	"container": "Alert-container-2_3_6-33Jt1",
	"block": "Alert-block-2_3_6-14Y4F",
	"iconContainer": "Alert-iconContainer-2_3_6-x6Bau",
	"title": "Alert-title-2_3_6-2QaDF",
	"buttonContainer": "Alert-buttonContainer-2_3_6-2CiUj",
	"notice": "Alert-notice-2_3_6-13bh2",
	"info": "Alert-info-2_3_6-1U4iK",
	"warning": "Alert-warning-2_3_6-1COlz",
	"error": "Alert-error-2_3_6-1DfSL",
	"alertText": "Alert-alertText-2_3_6-3BszY",
	"showDetailsLink": "Alert-showDetailsLink-2_3_6-3PDwH",
	"details": "Alert-details-2_3_6-1nv32",
	"closeBtn": "Alert-closeBtn-2_3_6-1dcEX",
	"blueSteel": "Alert-blueSteel-2_3_6-Kpkjf",
	"success": "Alert-success-2_3_6-AJJXf",
	"contents": "Alert-contents-2_3_6-1kQVM",
	"message": "Alert-message-2_3_6-9UU1A"
};

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Autosave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(236);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Autosave", function() { return _Autosave__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _AutosaveInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(366);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveInput", function() { return _AutosaveInput__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _AutosaveRadioGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(374);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveRadioGroup", function() { return _AutosaveRadioGroup__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _AutosaveSelect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(386);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveSelect", function() { return _AutosaveSelect__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _AutosaveTextArea__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(400);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveTextArea", function() { return _AutosaveTextArea__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _AutosaveTagList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(406);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveTagList", function() { return _AutosaveTagList__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _AutosaveLoader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(264);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveLoader", function() { return _AutosaveLoader__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _AutosaveTagListSuggestions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(482);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosaveTagListSuggestions", function() { return _AutosaveTagListSuggestions__WEBPACK_IMPORTED_MODULE_7__["default"]; });


















/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(195);
/* harmony import */ var _FlexItem__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(240);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(242);
/* harmony import */ var _InputGroup__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(249);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(155);
/* harmony import */ var _RemainingChars__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(262);
/* harmony import */ var _AutosaveLoader__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(264);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _Autosave_sass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(364);
/* harmony import */ var _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_Autosave_sass__WEBPACK_IMPORTED_MODULE_23__);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















/**
 * A11y notes:
 *   - The cancel button is not tabbable (per UX team's direction).
 *   - Users can hit "Escape" any time to cancel editing.
 *   - "Tab/Shift+Tab" blurs the component and moves focus to the next tabbable component.
 *   - "Enter" triggers "onSave".
 *   - Component blur invokes either onCancel or onSave, depending on if there were changes.
 *
 * Component states:
 *   - "focused":
 *     - Styling will be match that of the Child form element and theme.
 *     - Tab/Shit+Tab will set the container to focused, but the component is not in edit mode.
 *     - After "Tab/Shift+Tab", users can hit "Enter" to invoke onStartEditing().
 *     - On a mouse click, form element passes directly to editing mode, if allowed.
 *
 *   - "editing":
 *     - Styling will be match that of the Child form element and theme.
 *     - Hitting "Enter" will invoke onSave
 *     - Hitting "Escape" or clicking the cancel button will invoke onCancel
 *     - Blurring via mouse or keyboard will trigger either onSave or onCancel depending on whether changes have
 *       been made to the value or not.
 *
 *   - "error"
 *     - Styling will be match that of the Child form element and theme.
 *     - The intended usage is that the error prop is set only when the component is also in "editing" mode.
 *     - Hitting "Enter" will not trigger onSave in this state. Neither will clicking outside of the component.
 *     - Users have to hit "Escape" to cancel, or need to fix the error to exit this state.
 *
 *   - "saving"
 *     - The spinner is displayed and onStartEditing() can not be invoked until saving is complete.
 *     - Child form element focus will still be allowed, but editing will not.
 */

Autosave.propTypes = {
  /*
   * Child form element to which the Autosave applies.
   */
  Component: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.elementType.isRequired,

  /**
   * Hint text to be rendered in parentheses beside the label
   */
  description: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.node,

  /**
   * Component disabled setting
   */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.bool,

  /**
   * True if the component is currently being edited
   */
  editing: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.bool.isRequired,

  /**
   * Identifies the type of field interaction expected by the wrapper component.
   */
  fieldType: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.oneOf(['input', 'textarea', 'select', 'radio', 'taglist', 'autosuggest-taglist']).isRequired,

  /**
   * A unique identifier for input and textarea fields. Internally this property is used to set data-* attributes on DOM elements
   * to help keystroke handlers identify which elements caused certain events.
   */
  fieldId: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.string,

  /**
   * Rendered beneath the field (except when an error is present)
   */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.node,

  /**
   * A label for the InputGroup
   */
  label: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.string.isRequired,

  /**
   * Adjusts display of input group for read-only inputs
   */
  readOnly: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.bool,

  /**
   * Set to true to put the component in the "saving" state.
   */
  saving: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.bool.isRequired,

  /**
   * Set to true to put the component in the "saved" state.
   */
  saved: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.bool.isRequired,

  /**
   * Current text value
   */
  value: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.array, prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.number]).isRequired,

  /**
   * Called each time the inner input value is updated.
   * You can use this to run error handling code each time the inner input value changes.
   * Note: do not change the value prop when this function is called. You should only update value if onSave is called.
   */
  onCachedValueChanged: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.func,

  /**
   * This function is called when a cancel operation should be performed.
   * This indicates that the user either hit the "escape" key, or blurred the
   * field and the cached input value is the same as the value prop.
   */
  onCancel: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.func,

  /**
   * Called when a save operation should be performed. This indicates that the user has changed the value and either
   * blurred the field or manually triggered a save by hitting "Enter"
   */
  onSave: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.func.isRequired,

  /**
   * Called when the user clicks the container or hits "Enter" when the container is focused.
   */
  onStartEditing: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.func,

  /**
   * If true, the field wont allow to save changes until error is fixed.
   */
  preventBlurOnError: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.bool,

  /**
   * CSS class name attribute for the container
   */
  className: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.string,

  /**
   * Optional contentRight prop passed to the inputGroup
   */
  contentRight: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.node,

  /**
   * If this value is the empty string or undefined then this component will not be in an error state.
   * To put this component in an error state, set this prop to the error message that you would like to display.
   */
  error: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.node,

  /**
   * If provided the number of remaining characters will be passed in the InputGroup contentRight prop.
   * If the cached value's char count is longer than maxChars then the remaining character count will be rendered in error color.
   */
  maxChars: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.number,

  /**
   * Whether or the input is a number. In this case, non-numeric characters are automatically stripped from the input.
   * This prop is only applicable to the Input case
   */
  number: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.bool,

  /**
   * A style object which will be added to the main container
   */
  style: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.object,
  suggestions: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.object, prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.string])),

  /**
   * A test name for automation
   */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.string,

  /**
   * A theme to apply to this component
   */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.string,

  /**
   * A tooltip to be rendered beside the label
   */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_14___default.a.node
};
/**
 * A wrapper around a React component that provides event methods for autosaving user entry. In almost all
 * cases the Autosave wrapper is wrapped around a Studio UI Kit component as shown in the cases that follow.
 * However the generic wrapper may be used to define new module-specific components not currently implemented
 * in the Kit.
 *
 * The `Autosave` component controls its interaction with an application store by attaching autosave logic to
 * the form field's blur event handler. The event handler can inspect the event object and check state variables
 * to determine why the blur occurred and react accordingly. It can decide to re-focus the input imperatively
 * and bail before the user notices anything, or it can decide to call onSave, onCancel, etc..
 *
 * DOM event bubbling is ordered as `keyDown` → `blur`, so keyDown handlers have a chance to set state variables
 * before the blur handler is run.
 *
 * In addition to setting state variables, the container, the form field element and the cancel button are tagged
 * with unique `data-*` attributes. This allows the blur event handler to examine `event.relatedTarget` to determine
 * for example, whether the cancel button was the reason that the blur event happened.
 *
 * Autosave must be implemented as a [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
 */

function Autosave(_ref) {
  var _cx;

  var Component = _ref.Component,
      description = _ref.description,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      editing = _ref.editing,
      error = _ref.error,
      _ref$fieldId = _ref.fieldId,
      fieldId = _ref$fieldId === void 0 ? '' : _ref$fieldId,
      fieldType = _ref.fieldType,
      helperText = _ref.helperText,
      label = _ref.label,
      value = _ref.value,
      _ref$onCachedValueCha = _ref.onCachedValueChanged,
      onCachedValueChanged = _ref$onCachedValueCha === void 0 ? function () {} : _ref$onCachedValueCha,
      onStartEditing = _ref.onStartEditing,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      saved = _ref.saved,
      saving = _ref.saving,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      _ref$preventBlurOnErr = _ref.preventBlurOnError,
      preventBlurOnError = _ref$preventBlurOnErr === void 0 ? true : _ref$preventBlurOnErr,
      className = _ref.className,
      contentRight = _ref.contentRight,
      maxChars = _ref.maxChars,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? false : _ref$number,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      testName = _ref.testName,
      theme = _ref.theme,
      tooltip = _ref.tooltip,
      componentProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8___default()(_ref, ["Component", "description", "disabled", "editing", "error", "fieldId", "fieldType", "helperText", "label", "value", "onCachedValueChanged", "onStartEditing", "readOnly", "saved", "saving", "onSave", "onCancel", "preventBlurOnError", "className", "contentRight", "maxChars", "number", "style", "testName", "theme", "tooltip"]);

  var lowerCaseFieldId = fieldId.toLowerCase();
  var fieldRef = Object(react__WEBPACK_IMPORTED_MODULE_13__["useRef"])(null);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_13__["useState"])(false),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7___default()(_useState, 2),
      containerFocused = _useState2[0],
      setContainerFocused = _useState2[1];

  var acceptsInput = fieldType === 'input' || fieldType === 'textarea';
  var acceptsRadioInput = fieldType === 'radio';
  var acceptsSelection = fieldType === 'select';
  var acceptsTagList = fieldType === 'taglist' || fieldType === 'autosuggest-taglist';
  var controlProps = {
    asAutosave: true,
    description: description,
    error: error,
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement("label", {
      htmlFor: fieldId
    }, label),
    helperText: helperText,
    readOnly: readOnly,
    style: style,
    theme: theme,
    tooltip: tooltip
  };

  var fieldProps = _objectSpread({
    disabled: disabled,
    readOnly: readOnly
  }, componentProps); // The keydown handler sets this flag to true to be checked in the blur handler


  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_13__["useState"])(false),
      _useState4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7___default()(_useState3, 2),
      tabPressedWhileInputFocused = _useState4[0],
      setTabPressedWhileInputFocused = _useState4[1]; // The keydown handler sets this flag to true to be checked in the blur handler


  var _useState5 = Object(react__WEBPACK_IMPORTED_MODULE_13__["useState"])(false),
      _useState6 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7___default()(_useState5, 2),
      cancelInProgress = _useState6[0],
      setCancelInProgress = _useState6[1];

  Object(react__WEBPACK_IMPORTED_MODULE_13__["useEffect"])(function () {
    // The reason we're using an effect here instead of just calling blurField in the keyDown handler is because
    // react setState calls are async/ run in batch and may occur after the blur handler runs.
    // So the keydown handler cannot just call setCancelInProgress(true); blurField(); becuase the state wont reliably
    // be set by the time the handler runs. So, we use the effect to make sure the state is set before blurring the input.
    if (cancelInProgress) {
      blurField();
    }
  }, [cancelInProgress]); // imperatively focus or blur the input when the editing/error props change
  // the reason we have "error" in the dependencies array here is as follows:
  // when onSave is called the input is blurred, but after the input is blurred,
  // the consuming component may run validation and decide that theres an error, so
  // editing will not change (from true), but error will change from falsey to truthy

  Object(react__WEBPACK_IMPORTED_MODULE_13__["useEffect"])(function () {
    var fieldHasFocus = doesFieldHaveFocus();

    if (!editing && fieldHasFocus) {
      blurField();
    } else if (editing && !fieldHasFocus) {
      focusField();
    }
  }, [editing, error]);

  var _useState7 = Object(react__WEBPACK_IMPORTED_MODULE_13__["useState"])(value),
      _useState8 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7___default()(_useState7, 2),
      cachedValue = _useState8[0],
      setCachedValue = _useState8[1];

  Object(react__WEBPACK_IMPORTED_MODULE_13__["useEffect"])(function () {
    if (!saving) {
      setCachedValue(value);
    }
  }, [value]); // fieldRef will be applied as a ref for class-based components. For function-based
  // components, fieldRef must be passed into the component using the forwardRef prop.

  var refProp;
  var fieldClassName = '';

  switch (fieldType) {
    case 'select':
      refProp = {
        selectRef: fieldRef
      };
      fieldClassName = _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.select;
      break;

    case 'radio':
      refProp = null;
      fieldClassName = _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.radio;
      break;

    case 'taglist':
      fieldClassName = _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.taglist;
      refProp = {
        ref: fieldRef
      };
      break;

    case 'autosuggest-taglist':
      fieldClassName = _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.taglist;
      refProp = {
        inputRef: fieldRef
      };
      break;

    default:
      refProp = {
        ref: fieldRef
      };
  }

  var classes = classnames__WEBPACK_IMPORTED_MODULE_22___default()(_Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a[theme], _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.autosave, className);
  var cssState = error ? _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.hasError : saving ? _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.isSaving : editing ? _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.activeState : containerFocused ? _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.focusedState : null;

  var _useState9 = Object(react__WEBPACK_IMPORTED_MODULE_13__["useState"])(false),
      _useState10 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_7___default()(_useState9, 2),
      enterWasPressed = _useState10[0],
      setEnterWasPressed = _useState10[1];

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_InputGroup__WEBPACK_IMPORTED_MODULE_18__["InputGroup"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5___default()({}, controlProps, {
    showOnHover: !(saving || editing || containerFocused),
    contentRight: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_15__["Flex"], {
      gap: "xs",
      alignItems: "center"
    }, acceptsInput && maxChars && editing ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_FlexItem__WEBPACK_IMPORTED_MODULE_16__["FlexItem"], null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_RemainingChars__WEBPACK_IMPORTED_MODULE_20__["CharCountDisplay"], {
      max: maxChars,
      count: cachedValue.length
    })) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_FlexItem__WEBPACK_IMPORTED_MODULE_16__["FlexItem"], null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_AutosaveLoader__WEBPACK_IMPORTED_MODULE_21__["default"], {
      isSaving: saving,
      isSaved: saved
    })), (acceptsInput || acceptsTagList) && editing && !saving && cachedValue !== value ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_FlexItem__WEBPACK_IMPORTED_MODULE_16__["FlexItem"], null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_17__["IconButton"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5___default()({
      theme: theme,
      link: true,
      name: "reply",
      tabIndex: "-1"
    }, !!lowerCaseFieldId && _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()({}, "data-".concat(lowerCaseFieldId, "-cancel-button"), true), {
      onClick: function onClick() {},
      style: {
        zIndex: 1
      }
    }))) : null, contentRight ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(_FlexItem__WEBPACK_IMPORTED_MODULE_16__["FlexItem"], {
      className: _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.action
    }, contentRight) : null),
    className: classnames__WEBPACK_IMPORTED_MODULE_22___default()(classes, cssState, _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.inputGroup)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement("div", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5___default()({
    tabIndex: "0",
    onKeyDown: handleContainerKeyDown,
    onKeyDownCapture: handleContainerKeyDownCapture,
    onFocus: handleContainerFocus,
    onBlur: handleContainerBlur
  }, !!lowerCaseFieldId && _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()({}, "data-".concat(lowerCaseFieldId, "-container"), true), {
    className: classnames__WEBPACK_IMPORTED_MODULE_22___default()(cssState, _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.stateWrapper, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.readOnly, readOnly), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_cx, _Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a.disabled, disabled), _cx))
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5___default()({}, testName && {
    testName: testName
  }, {
    id: fieldId,
    tabIndex: "-1",
    theme: theme,
    value: cachedValue,
    onClick: handleFieldClick,
    onChange: handleFieldChange,
    onKeyDown: handleFieldKeyEntry,
    onBlur: handleFieldBlur,
    className: fieldClassName
  }, refProp, fieldProps, acceptsTagList && {
    inputBlock: true,
    placeholder: saving ? null : fieldProps.placeholder
  }))));

  function handleFieldChange(event) {
    switch (fieldType) {
      case 'input':
      case 'textarea':
        handleInputChange(event);
        break;

      case 'select':
      case 'radio':
        handleSelectChange(event);
        break;

      case 'taglist':
      case 'autosuggest-taglist':
        handleTagListChange(event);
        break;

      default:
        console.warn("This component's fieldType is not supported.");
    }
  }

  function handleFieldKeyEntry(event) {
    if (acceptsTagList && event.key === 'Backspace') {
      return;
    }

    if (event.key === 'Enter' && (!error || !preventBlurOnError) && !(event.shiftKey && fieldType === 'textarea') && !(acceptsTagList && !enterWasPressed)) {
      blurField();
    } else if (event.key === 'Escape') {
      setCancelInProgress(true);
    } else if (event.key === 'Tab') {
      setTabPressedWhileInputFocused(true);
    }

    if (enterWasPressed) {
      setEnterWasPressed(false);
    }
  }

  function handleFieldBlur(_, event) {
    var tagRemoveButtonCausedBlur = isElementTagRemoveButton(event.relatedTarget);

    if (tagRemoveButtonCausedBlur) {
      return;
    }

    switch (fieldType) {
      case 'input':
      case 'textarea':
      case 'select':
      case 'taglist':
      case 'autosuggest-taglist':
        handleInputBlur(event);
        break;

      case 'radio':
        break;

      default:
        console.warn("This component's fieldType is not supported.");
    }
  } // If radio is saving, prevent keyboard navigation between ratio options.


  function handleContainerKeyDownCapture(event) {
    if (acceptsRadioInput && saving) {
      var keyCode = event.keyCode; // control arrow key navigation within radio group

      if (keyCode === 37 || keyCode === 38 || keyCode === 39 || keyCode === 40) {
        event.preventDefault();
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
      }
    }
  }

  function handleContainerKeyDown(event) {
    if (containerFocused && !saving && !editing) {
      // 'Spacebar' is for IE11 support
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        onStartEditing();
        event.preventDefault();
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
      }
    }
  }

  function handleContainerFocus() {
    if (!editing) {
      setContainerFocused(true);
    }
  }

  function handleContainerBlur() {
    setContainerFocused(false);
  }

  function handleFieldClick() {
    if (!saving) {
      onStartEditing();
    }
  }

  function doesFieldHaveFocus() {
    return document.activeElement && fieldRef && fieldRef.current && document.activeElement === fieldRef.current.instance;
  }

  function focusField() {
    if (acceptsSelection && fieldRef && fieldRef.current) {
      fieldRef.current.focus();
    } else if (fieldRef && fieldRef.current && fieldRef.current.instance) {
      fieldRef.current.instance.focus();
    } else if (fieldRef && fieldRef.current && fieldRef.current.inputRef) {
      fieldRef.current.inputRef.focus();
    }
  }

  function blurField() {
    if (fieldRef && fieldRef.current) {
      var _fieldRef$current = fieldRef.current,
          instance = _fieldRef$current.instance,
          inputRef = _fieldRef$current.inputRef;
      var element = instance ? instance : inputRef;

      if (element) {
        element.blur();
      }
    }
  }

  function cancel() {
    setCachedValue(value);
    onCancel(value);
  }

  function save() {
    onSave(cachedValue);
  }

  function handleSelectChange(value) {
    setCachedValue(value);
    onSave(value);
  }

  function handleInputChange(newCachedValue) {
    var processedCachedValue = newCachedValue;

    if (number) {
      processedCachedValue = newCachedValue.replace(/[^0-9]/g, '');
    }

    setCachedValue(processedCachedValue);
    onCachedValueChanged(processedCachedValue);
  }

  function handleTagListChange(newCachedValue) {
    setEnterWasPressed(true);
    setCachedValue(newCachedValue);
    onCachedValueChanged(newCachedValue);
  } // This wil be fire only for fields that take keyboard input


  function handleInputBlur(event) {
    if (cancelInProgress) {
      // Input keyboard event (Esc) triggered explicit cancel
      cancel();
      setCancelInProgress(false);
      return;
    }

    var cancelButtonCausedBlur = !!event.relatedTarget && !!event.relatedTarget.getAttribute("data-".concat(lowerCaseFieldId, "-cancel-button"));

    if (cancelButtonCausedBlur) {
      cancel();
      return;
    }

    if (error && preventBlurOnError) {
      focusField();
      return;
    }

    var autosuggestSelectionCausedBlur = !!event.relatedTarget && event.relatedTarget.getAttribute('data-autosuggest-option');
    var containerCausedBlur = !!event.relatedTarget && !!event.relatedTarget.getAttribute("data-".concat(lowerCaseFieldId, "-container"));

    if ((containerCausedBlur || autosuggestSelectionCausedBlur) && !tabPressedWhileInputFocused) {
      focusField();
      return;
    }

    if (tabPressedWhileInputFocused) {
      setTabPressedWhileInputFocused(false);
    }

    if (cachedValue === value) {
      cancel();
    } else {
      save();
    }
  }

  function isElementTagRemoveButton(el) {
    if (el) {
      return el.getAttribute('aria-label') === 'remove';
    }
  }
}

/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_19__["provideTheme"])(_Autosave_sass__WEBPACK_IMPORTED_MODULE_23___default.a)(Autosave));

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(238);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 238 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(11);
var global = __webpack_require__(8);
var has = __webpack_require__(21);
var isObject = __webpack_require__(20);
var defineProperty = __webpack_require__(25).f;
var copyConstructorProperties = __webpack_require__(38);

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _FlexItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(241);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlexItem", function() { return _FlexItem__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FlexItem; });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




/**
A component for use with [`<Flex>`](/#!/Flex) or within any dom node with
`display: flex`. This component provides props for all flex item properties.

For more help with flexbox see: https://css-tricks.com/snippets/css/a-guide-to-flexbox/
*/

function FlexItem(_ref) {
  var alignSelf = _ref.alignSelf,
      children = _ref.children,
      className = _ref.className,
      flex = _ref.flex,
      flexBasis = _ref.flexBasis,
      flexGrow = _ref.flexGrow,
      flexShrink = _ref.flexShrink,
      order = _ref.order,
      style = _ref.style,
      testName = _ref.testName;
  flex = flex != null ? flex : "".concat(flexGrow, " ").concat(flexShrink, " ").concat(flexBasis);
  style = _objectSpread({
    alignSelf: alignSelf,
    flex: flex,
    order: order
  }, style);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("div", {
    style: style,
    className: className,
    "data-test-name": testName
  }, children);
}
FlexItem.defaultProps = {
  flexGrow: 0,
  flexShrink: 1,
  flexBasis: 'auto'
};
FlexItem.propTypes = {
  /** This allows the default alignment (or the one specified by align-items on
  a flex container) to be overridden for individual flex items. */
  alignSelf: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch']),

  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** This is the shorthand for flexGrow, flexShrink and flexBasis combined.
  The second and third parameters (flexShrink and flexBasis) are optional.
  Default is `0 1 auto`. */
  flex: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** This defines the default size of an element before the remaining space is
  distributed. It can be a length (e.g. 20%, 5rem, etc.) or a keyword. The auto
  keyword means "look at my width or height property". */
  flexBasis: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string,

  /** This defines the ability for a flex item to grow if necessary. It accepts
  a unitless value that serves as a proportion. It dictates what amount of the
  available space inside the flex container the item should take up.
   If all items have flex-grow set to 1, the remaining space in the container
  will be distributed equally to all children. If one of the children has a
  value of 2, the remaining space would take up twice as much space as the
  others (or it will try to, at least). */
  flexGrow: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.number]),

  /** This defines the ability for a flex item to shrink if necessary. */
  flexShrink: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.number]),

  /** By default, flex items are laid out in the source order. However, the
  order prop controls the order in which they appear in the flex container. */
  order: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.number]),

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string
};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(243);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IconButton", function() { return _IconButton__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IconButton", function() { return IconButton; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(244);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _IconButton_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(247);
/* harmony import */ var _IconButton_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_IconButton_sass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(216);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(155);












/**
 An button component that displays an interactable icon
*/

function IconButton(_ref) {
  var _cx;

  var name = _ref.name,
      label = _ref.label,
      disabled = _ref.disabled,
      flip = _ref.flip,
      link = _ref.link,
      className = _ref.className,
      style = _ref.style,
      iconStyle = _ref.iconStyle,
      iconClassName = _ref.iconClassName,
      rotate = _ref.rotate,
      padRight = _ref.padRight,
      onClick = _ref.onClick,
      testName = _ref.testName,
      theme = _ref.theme,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["name", "label", "disabled", "flip", "link", "className", "style", "iconStyle", "iconClassName", "rotate", "padRight", "onClick", "testName", "theme"]);

  var buttonClasses = classnames__WEBPACK_IMPORTED_MODULE_7___default()(_IconButton_sass__WEBPACK_IMPORTED_MODULE_8___default.a[theme], _IconButton_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconButton, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _IconButton_sass__WEBPACK_IMPORTED_MODULE_8___default.a.link, link), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _IconButton_sass__WEBPACK_IMPORTED_MODULE_8___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _IconButton_sass__WEBPACK_IMPORTED_MODULE_8___default.a.padRight, padRight), _cx));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement("div", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    role: "button",
    "aria-label": label,
    "aria-disabled": disabled,
    tabIndex: disabled ? -1 : 0,
    className: buttonClasses,
    style: style,
    onClick: disabled ? null : onClick,
    onKeyDown: disabled ? null : Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_10__["handleKeyboardClick"])(onClick),
    "data-test-name": testName
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_9__["Icon"], {
    name: name,
    flip: flip,
    rotate: rotate,
    className: iconClassName,
    style: iconStyle
  }));
}
IconButton.propTypes = {
  /** Name of the icon to use */
  name: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string.isRequired,

  /** Aria label for the icon */
  label: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string,

  /** Whether the icon button is disabled */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,

  /* Treat the icon as a link, not as a button */
  link: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,

  /** Whether to flip the icon vertically or horizontally. */
  flip: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.oneOf(['horizontal', 'vertical']),

  /** Angle in degrees to rotate the icon. */
  rotate: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.oneOf(['90', '180', '270']),

  /** Container style attribute */

  /** If true a right margin will be applied to separate this icon from adjacent inline content. */
  padRight: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string,

  /** Style attribute on the button. */
  style: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.object,

  /** Icon class name */
  iconClassName: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string,

  /** Style to set on the icon */
  iconStyle: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.object,

  /** Click handler for button */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.func.isRequired,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_11__["provideTheme"])(_IconButton_sass__WEBPACK_IMPORTED_MODULE_8___default.a)(IconButton));

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var createHTML = __webpack_require__(245);
var forcedStringHTMLMethod = __webpack_require__(246);

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(18);

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(248);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".IconButton-classic-2_3_6-3z5uX a{color:#079bb3}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK{color:#079bb3;background-color:transparent;border:1px solid transparent;line-height:16px;padding:5px;position:relative;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:3px;font-family:Lato,Helvetica,Arial,sans-serif;font-size:1rem;display:inline-block;text-align:center;margin:0;white-space:nowrap}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK+.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK,.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK+.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK+.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK+.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK{margin-left:.3333333333rem}.IconButton-block-2_3_6-3mmro+.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK,.IconButton-block-2_3_6-3mmro+.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK{margin-left:0;margin-top:.5rem}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK.IconButton-disabled-2_3_6-bQSTK:not(.IconButton-link-2_3_6-unath),.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK.IconButton-disabled-2_3_6-bQSTK:not(.IconButton-link-2_3_6-unath){pointer-events:none;background-color:#fff!important;color:#ccc}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):active,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):active,.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):hover,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):hover,.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):active,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):active,.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):hover,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):hover{background-color:#fff;transform:none!important;border:1px solid #ddd;border-radius:3px}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):focus-visible,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):focus-visible,.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):focus-visible,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):focus-visible{outline:1px solid #777;outline-offset:1px}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath{border:none;padding:0}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath.IconButton-disabled-2_3_6-bQSTK,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath.IconButton-disabled-2_3_6-bQSTK{pointer-events:none;color:#aaa}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath.IconButton-active-2_3_6-3ZXrx,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath.IconButton-active-2_3_6-3ZXrx,.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath:hover,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath:hover{border:none;transform:none!important;color:#079bb3!important}.IconButton-classic-2_3_6-3z5uX.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath:focus-visible,.IconButton-classic-2_3_6-3z5uX .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath:focus-visible{outline:1px solid #777;outline-offset:1px}.IconButton-classic-2_3_6-3z5uX .IconButton-padRight-2_3_6-7oRsM{margin-right:.3333333333em}.IconButton-blueSteel-2_3_6-1_SSr a{color:#08088c}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK{color:#08088c;background-color:transparent;border:1px solid transparent;line-height:16px;padding:5px;position:relative;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:3px;font-family:Public Sans,sans-serif;font-size:1rem;display:inline-block;text-align:center;margin:0;white-space:nowrap}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK+.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK,.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK+.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK+.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK+.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK{margin-left:.3333333333rem}.IconButton-block-2_3_6-3mmro+.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK,.IconButton-block-2_3_6-3mmro+.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK{margin-left:0;margin-top:.5rem}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK.IconButton-disabled-2_3_6-bQSTK:not(.IconButton-link-2_3_6-unath),.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK.IconButton-disabled-2_3_6-bQSTK:not(.IconButton-link-2_3_6-unath){pointer-events:none;background-color:#fff!important;color:#f2f2f3}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):active,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):active,.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):hover,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):hover,.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):active,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):active,.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):hover,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):hover{background-color:#fff;transform:none!important;border:1px solid #e5e6e6;border-radius:3px}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):focus-visible,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-disabled-2_3_6-bQSTK):focus-visible,.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):focus-visible,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK:not(.IconButton-link-2_3_6-unath):focus-visible{outline:1px solid #092dbd;outline-offset:1px}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath{border:none;padding:0}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath.IconButton-disabled-2_3_6-bQSTK,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath.IconButton-disabled-2_3_6-bQSTK{pointer-events:none;color:#8e9093}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath.IconButton-active-2_3_6-3ZXrx,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath.IconButton-active-2_3_6-3ZXrx,.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath:hover,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath:hover{border:none;transform:none!important;color:#08088c!important}.IconButton-blueSteel-2_3_6-1_SSr.IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath:focus-visible,.IconButton-blueSteel-2_3_6-1_SSr .IconButton-iconButton-2_3_6-1mTzK.IconButton-link-2_3_6-unath:focus-visible{outline:1px solid #092dbd;outline-offset:1px}.IconButton-blueSteel-2_3_6-1_SSr .IconButton-padRight-2_3_6-7oRsM{margin-right:.3333333333em}", ""]);

// exports
exports.locals = {
	"classic": "IconButton-classic-2_3_6-3z5uX",
	"iconButton": "IconButton-iconButton-2_3_6-1mTzK",
	"block": "IconButton-block-2_3_6-3mmro",
	"disabled": "IconButton-disabled-2_3_6-bQSTK",
	"link": "IconButton-link-2_3_6-unath",
	"active": "IconButton-active-2_3_6-3ZXrx",
	"padRight": "IconButton-padRight-2_3_6-7oRsM",
	"blueSteel": "IconButton-blueSteel-2_3_6-1_SSr"
};

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _InputGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(250);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return _InputGroup__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return InputGroup; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_components_ToolTip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(198);
/* harmony import */ var _BottomContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(251);
/* harmony import */ var _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(260);
/* harmony import */ var _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_InputGroup_sass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(155);










/**
 * A wrapper for form controls that includes optional dressings for a `label`,
 * `description`, `required` (asterisk), `tooltip`, `helperText`, and `error`.
 */

function InputGroup(_ref) {
  var _cx, _cx2;

  var asAutosave = _ref.asAutosave,
      asFieldset = _ref.asFieldset,
      children = _ref.children,
      className = _ref.className,
      contentRight = _ref.contentRight,
      description = _ref.description,
      error = _ref.error,
      helperText = _ref.helperText,
      label = _ref.label,
      readOnly = _ref.readOnly,
      required = _ref.required,
      showOnHover = _ref.showOnHover,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme,
      tooltip = _ref.tooltip;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_5___default()(_InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a[theme], _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.control, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.withError, Boolean(error)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.asFieldset, asFieldset), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.readOnly, readOnly), _cx));
  var descriptionTag = description ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.description, (_cx2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx2, _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.alwaysShow, !showOnHover), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx2, _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.noPad, !label), _cx2))
  }, "(", description, ")") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("noscript", null);
  var tooltipTag = tooltip ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.tooltip, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.alwaysShow, !showOnHover))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(js_components_ToolTip__WEBPACK_IMPORTED_MODULE_6__["ToolTip"], {
    content: tooltip,
    theme: theme
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("noscript", null);
  var bottomContent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_BottomContent__WEBPACK_IMPORTED_MODULE_7__["default"], {
    error: error,
    helperText: helperText,
    theme: theme
  });

  if (label || description) {
    var WrapperComponent = asAutosave ? 'div' : asFieldset ? 'fieldset' : 'label';
    var LabelComponent = asFieldset ? 'legend' : 'div';
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(WrapperComponent, {
      className: classes,
      style: style,
      "data-test-name": testName
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(LabelComponent, {
      className: _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.labelWrap
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
      className: _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.labelText
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
      className: _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.labelLeft
    }, label, required ? ' *' : '', descriptionTag, tooltipTag), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
      className: _InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a.labelRight
    }, contentRight))), children, bottomContent);
  } else {
    var _WrapperComponent = asFieldset ? 'fieldset' : 'div';

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_WrapperComponent, {
      className: classes,
      style: style,
      "data-test-name": testName
    }, children, bottomContent);
  }
}
InputGroup.propTypes = {
  /** Whether the component is being used within an Autosave context. This ensures the <label> is encapsulated separately from other clickable actions */
  asAutosave: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Whether to render the component as a `<fieldset>` with its label in a `<legend>`. This is mainly for use with `<RadioGroup>` and `<RadioInput>`. */
  asFieldset: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Your input field. e.g. `<Input>`, `<Select>`, etc */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Apply a custom class to the outermost element. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Content justified to the right of the label. This space is used for remaining characters and sometimes actions. */
  contentRight: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Hint text to be rendered in parentheses beside the label */
  description: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** An error message to be rendered beneath the field. */
  error: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Rendered beneath the field (except when an error is present) */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Label text. */
  label: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node]),

  /** Adjusts display of input group for read-only inputs */
  readOnly: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Whether or not to render an asterisk beside the label */
  required: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Whether or not to only show hint and tooltip on hover (used for autosave styling) */
  showOnHover: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** A tooltip to be rendered beside the label */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_9__["provideTheme"])(_InputGroup_sass__WEBPACK_IMPORTED_MODULE_8___default.a)(InputGroup));

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return BottomContent; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var js_components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(216);
/* harmony import */ var js_components_FormError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(252);
/* harmony import */ var js_components_Hint__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(256);
/* harmony import */ var _InputGroup_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(260);
/* harmony import */ var _InputGroup_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_InputGroup_sass__WEBPACK_IMPORTED_MODULE_5__);






function BottomContent(_ref) {
  var helperText = _ref.helperText,
      error = _ref.error,
      theme = _ref.theme;
  // for BlueSteel inputGroup, assume no padding for bottom content as a default
  var noPad = theme === 'blueSteel' ? true : null;

  if (error) {
    var errorMsg = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(js_components_Icon__WEBPACK_IMPORTED_MODULE_2__["Icon"], {
      name: "warning",
      padRight: true,
      className: _InputGroup_sass__WEBPACK_IMPORTED_MODULE_5___default.a.errorIcon
    }), error);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(js_components_FormError__WEBPACK_IMPORTED_MODULE_3__["FormError"], {
      className: _InputGroup_sass__WEBPACK_IMPORTED_MODULE_5___default.a.error,
      error: errorMsg,
      theme: theme
    });
  }

  if (helperText) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(js_components_Hint__WEBPACK_IMPORTED_MODULE_4__["Hint"], {
      className: _InputGroup_sass__WEBPACK_IMPORTED_MODULE_5___default.a.helperText,
      theme: theme,
      noPad: noPad
    }, helperText);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("noscript", null);
}
BottomContent.propTypes = {
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _FormError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(253);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormError", function() { return _FormError__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormError", function() { return FormError; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_components_Hideable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(231);
/* harmony import */ var _FormError_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(254);
/* harmony import */ var _FormError_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_FormError_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(155);






/**
 * This is mostly used by our different form components, but you can use it to provide the same error styles anywhere.
 *
 * If no `error` prop is provided then the error will be completely hidden.
 */

function FormError(_ref) {
  var className = _ref.className,
      children = _ref.children,
      error = _ref.error,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;
  var content = children || error;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_3__["Hideable"], {
    show: Boolean(content)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_FormError_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme], _FormError_sass__WEBPACK_IMPORTED_MODULE_4___default.a.error, className),
    style: style,
    "data-test-name": testName
  }, content));
}
FormError.propTypes = {
  /** The error message */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** The error message */
  error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_5__["provideTheme"])(_FormError_sass__WEBPACK_IMPORTED_MODULE_4___default.a)(FormError));

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(255);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".FormError-classic-2_3_6-3sPPm a{color:#079bb3}.FormError-classic-2_3_6-3sPPm.FormError-error-2_3_6-22W_S,.FormError-classic-2_3_6-3sPPm .FormError-error-2_3_6-22W_S{line-height:1.25;color:#ba2453;font-weight:700;font-size:.9333333333rem}.FormError-blueSteel-2_3_6-2622t a{color:#08088c}.FormError-blueSteel-2_3_6-2622t.FormError-error-2_3_6-22W_S,.FormError-blueSteel-2_3_6-2622t .FormError-error-2_3_6-22W_S{color:#d33d00;font-weight:700;font-size:.9333333333rem}", ""]);

// exports
exports.locals = {
	"classic": "FormError-classic-2_3_6-3sPPm",
	"error": "FormError-error-2_3_6-22W_S",
	"blueSteel": "FormError-blueSteel-2_3_6-2622t"
};

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Hint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(257);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hint", function() { return _Hint__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hint", function() { return Hint; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Hint_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(258);
/* harmony import */ var _Hint_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Hint_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(155);







/**
 * A form hint.
 */

function Hint(_ref) {
  var className = _ref.className,
      children = _ref.children,
      noPad = _ref.noPad,
      style = _ref.style,
      testName = _ref.testName,
      text = _ref.text,
      theme = _ref.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Hint_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], _Hint_sass__WEBPACK_IMPORTED_MODULE_5___default.a.hint, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Hint_sass__WEBPACK_IMPORTED_MODULE_5___default.a.noPad, noPad)),
    style: style,
    "data-test-name": testName
  }, text || children);
}
Hint.propTypes = {
  /** Hint content. You may alternately pass this in through `text`. */
  children: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default()(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node, function (props) {
    return !props.text;
  }),

  /** Class name for the Hint. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Whether or not to omit the bottom margin. */
  noPad: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Hint text. You may alternately pass this in through children. */
  text: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default()(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node, function (props) {
    return !props.children;
  }),

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_6__["provideTheme"])(_Hint_sass__WEBPACK_IMPORTED_MODULE_5___default.a)(Hint));

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(259);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Hint-classic-2_3_6-2SA3W a{color:#079bb3}.Hint-classic-2_3_6-2SA3W.Hint-hint-2_3_6-3uEfn,.Hint-classic-2_3_6-2SA3W .Hint-hint-2_3_6-3uEfn{color:#888;font-size:.9333333333rem;font-weight:400;margin-bottom:1rem}.Hint-classic-2_3_6-2SA3W.Hint-noPad-2_3_6-3O83o,.Hint-classic-2_3_6-2SA3W .Hint-noPad-2_3_6-3O83o{margin-bottom:0}.Hint-blueSteel-2_3_6-2eNR- a{color:#08088c}.Hint-blueSteel-2_3_6-2eNR-.Hint-hint-2_3_6-3uEfn,.Hint-blueSteel-2_3_6-2eNR- .Hint-hint-2_3_6-3uEfn{color:#4d5056;font-size:.9333333333rem;font-weight:400;margin-bottom:1rem}.Hint-blueSteel-2_3_6-2eNR-.Hint-noPad-2_3_6-3O83o,.Hint-blueSteel-2_3_6-2eNR- .Hint-noPad-2_3_6-3O83o{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"classic": "Hint-classic-2_3_6-2SA3W",
	"hint": "Hint-hint-2_3_6-3uEfn",
	"noPad": "Hint-noPad-2_3_6-3O83o",
	"blueSteel": "Hint-blueSteel-2_3_6-2eNR-"
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(261);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".InputGroup-classic-2_3_6-fQVNa a{color:#079bb3}.InputGroup-classic-2_3_6-fQVNa .InputGroup-errorIcon-2_3_6-1aq7v{display:none}.InputGroup-classic-2_3_6-fQVNa .InputGroup-helperText-2_3_6-t7kAt{line-height:1.25}.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelWrap-2_3_6-WwYny{padding:0}.InputGroup-classic-2_3_6-fQVNa.InputGroup-control-2_3_6-2dRRo,.InputGroup-classic-2_3_6-fQVNa .InputGroup-control-2_3_6-2dRRo{margin-bottom:1.3333333333rem;display:block}.InputGroup-classic-2_3_6-fQVNa.InputGroup-control-2_3_6-2dRRo:hover .InputGroup-description-2_3_6-39FSw,.InputGroup-classic-2_3_6-fQVNa .InputGroup-control-2_3_6-2dRRo:hover .InputGroup-description-2_3_6-39FSw,.InputGroup-classic-2_3_6-fQVNa.InputGroup-control-2_3_6-2dRRo:hover .InputGroup-tooltip-2_3_6-2rPdd,.InputGroup-classic-2_3_6-fQVNa .InputGroup-control-2_3_6-2dRRo:hover .InputGroup-tooltip-2_3_6-2rPdd{display:initial}.InputGroup-classic-2_3_6-fQVNa.InputGroup-asFieldset-2_3_6-rMvPm,.InputGroup-classic-2_3_6-fQVNa .InputGroup-asFieldset-2_3_6-rMvPm{border:0;padding:.01em 0 1.3333333333rem;margin:0;min-width:0}.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelWrap-2_3_6-WwYny{width:100%}.InputGroup-asFieldset-2_3_6-rMvPm .InputGroup-classic-2_3_6-fQVNa .InputGroup-labelWrap-2_3_6-WwYny{display:table}.InputGroup-readOnly-2_3_6-24ieN .InputGroup-classic-2_3_6-fQVNa .InputGroup-labelWrap-2_3_6-WwYny{margin-bottom:2px}.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelText-2_3_6-9gx-G{display:-ms-flexbox;display:flex;font-family:Lato,Helvetica,Arial,sans-serif;font-size:.933rem;font-weight:700;line-height:24px;letter-spacing:normal;color:#666}.InputGroup-classic-2_3_6-fQVNa .InputGroup-description-2_3_6-39FSw{color:#888;font-weight:400}.InputGroup-classic-2_3_6-fQVNa .InputGroup-description-2_3_6-39FSw.InputGroup-noPad-2_3_6-bJgHy{margin-left:0}.InputGroup-classic-2_3_6-fQVNa .InputGroup-description-2_3_6-39FSw a{color:#079bb3;text-decoration:none}.InputGroup-classic-2_3_6-fQVNa .InputGroup-description-2_3_6-39FSw a:active,.InputGroup-classic-2_3_6-fQVNa .InputGroup-description-2_3_6-39FSw a:focus,.InputGroup-classic-2_3_6-fQVNa .InputGroup-description-2_3_6-39FSw a:hover{text-decoration:underline}.InputGroup-classic-2_3_6-fQVNa .InputGroup-description-2_3_6-39FSw,.InputGroup-classic-2_3_6-fQVNa .InputGroup-tooltip-2_3_6-2rPdd{display:none;margin-left:8px}.InputGroup-classic-2_3_6-fQVNa .InputGroup-description-2_3_6-39FSw.InputGroup-alwaysShow-2_3_6--POnG,.InputGroup-classic-2_3_6-fQVNa .InputGroup-tooltip-2_3_6-2rPdd.InputGroup-alwaysShow-2_3_6--POnG{display:initial}.InputGroup-classic-2_3_6-fQVNa .InputGroup-helperText-2_3_6-t7kAt{padding-top:.25rem;line-height:24px}.InputGroup-readOnly-2_3_6-24ieN .InputGroup-classic-2_3_6-fQVNa .InputGroup-helperText-2_3_6-t7kAt{padding-top:2px}.InputGroup-classic-2_3_6-fQVNa .InputGroup-error-2_3_6-1_nOO{padding-top:.25rem}readOnly .InputGroup-classic-2_3_6-fQVNa .InputGroup-error-2_3_6-1_nOO{padding-top:2px}.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelLeft-2_3_6-3sadw{-ms-flex:1 1 auto;flex:1 1 auto}.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelRight-2_3_6-3Z8MJ{-ms-flex:0 0 auto;flex:0 0 auto;font-weight:400;-ms-flex-item-align:end;align-self:flex-end;margin-left:2rem}.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelRight-2_3_6-3Z8MJ a{color:#079bb3;text-decoration:none}.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelRight-2_3_6-3Z8MJ a:active,.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelRight-2_3_6-3Z8MJ a:focus,.InputGroup-classic-2_3_6-fQVNa .InputGroup-labelRight-2_3_6-3Z8MJ a:hover{text-decoration:underline}.InputGroup-blueSteel-2_3_6-1i3_J a{color:#08088c}.InputGroup-blueSteel-2_3_6-1i3_J:not(.InputGroup-readOnly-2_3_6-24ieN) .InputGroup-labelWrap-2_3_6-WwYny{padding:0 0 .4rem}.InputGroup-blueSteel-2_3_6-1i3_J.InputGroup-control-2_3_6-2dRRo,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-control-2_3_6-2dRRo{padding-bottom:16px;display:block}.InputGroup-blueSteel-2_3_6-1i3_J.InputGroup-control-2_3_6-2dRRo:hover .InputGroup-description-2_3_6-39FSw,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-control-2_3_6-2dRRo:hover .InputGroup-description-2_3_6-39FSw,.InputGroup-blueSteel-2_3_6-1i3_J.InputGroup-control-2_3_6-2dRRo:hover .InputGroup-tooltip-2_3_6-2rPdd,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-control-2_3_6-2dRRo:hover .InputGroup-tooltip-2_3_6-2rPdd{display:initial}.InputGroup-blueSteel-2_3_6-1i3_J.InputGroup-asFieldset-2_3_6-rMvPm,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-asFieldset-2_3_6-rMvPm{border:0;padding:.01em 0 1.3333333333rem;margin:0;min-width:0}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelWrap-2_3_6-WwYny{width:100%}.InputGroup-asFieldset-2_3_6-rMvPm .InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelWrap-2_3_6-WwYny{display:table}.InputGroup-readOnly-2_3_6-24ieN .InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelWrap-2_3_6-WwYny{margin-bottom:2px}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelText-2_3_6-9gx-G{display:-ms-flexbox;display:flex;font-family:Public Sans,sans-serif;font-size:.875rem;font-weight:700;line-height:20px;letter-spacing:auto;color:#01050e}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-description-2_3_6-39FSw{color:#4d5056;font-weight:400}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-description-2_3_6-39FSw.InputGroup-noPad-2_3_6-bJgHy{margin-left:0}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-description-2_3_6-39FSw a{color:#08088c;text-decoration:none}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-description-2_3_6-39FSw a:active,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-description-2_3_6-39FSw a:focus,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-description-2_3_6-39FSw a:hover{text-decoration:underline}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-description-2_3_6-39FSw,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-tooltip-2_3_6-2rPdd{display:none;margin-left:8px}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-description-2_3_6-39FSw.InputGroup-alwaysShow-2_3_6--POnG,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-tooltip-2_3_6-2rPdd.InputGroup-alwaysShow-2_3_6--POnG{display:initial}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-helperText-2_3_6-t7kAt{padding-top:.25rem;line-height:20px}.InputGroup-readOnly-2_3_6-24ieN .InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-helperText-2_3_6-t7kAt{padding-top:2px}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-error-2_3_6-1_nOO{padding-top:.25rem}readOnly .InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-error-2_3_6-1_nOO{padding-top:2px}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelLeft-2_3_6-3sadw{-ms-flex:1 1 auto;flex:1 1 auto}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelRight-2_3_6-3Z8MJ{-ms-flex:0 0 auto;flex:0 0 auto;font-weight:400;-ms-flex-item-align:end;align-self:flex-end;margin-left:2rem}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelRight-2_3_6-3Z8MJ a{color:#08088c;text-decoration:none}.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelRight-2_3_6-3Z8MJ a:active,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelRight-2_3_6-3Z8MJ a:focus,.InputGroup-blueSteel-2_3_6-1i3_J .InputGroup-labelRight-2_3_6-3Z8MJ a:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"classic": "InputGroup-classic-2_3_6-fQVNa",
	"errorIcon": "InputGroup-errorIcon-2_3_6-1aq7v",
	"helperText": "InputGroup-helperText-2_3_6-t7kAt",
	"labelWrap": "InputGroup-labelWrap-2_3_6-WwYny",
	"control": "InputGroup-control-2_3_6-2dRRo",
	"description": "InputGroup-description-2_3_6-39FSw",
	"tooltip": "InputGroup-tooltip-2_3_6-2rPdd",
	"asFieldset": "InputGroup-asFieldset-2_3_6-rMvPm",
	"readOnly": "InputGroup-readOnly-2_3_6-24ieN",
	"labelText": "InputGroup-labelText-2_3_6-9gx-G",
	"noPad": "InputGroup-noPad-2_3_6-bJgHy",
	"alwaysShow": "InputGroup-alwaysShow-2_3_6--POnG",
	"error": "InputGroup-error-2_3_6-1_nOO",
	"labelLeft": "InputGroup-labelLeft-2_3_6-3sadw",
	"labelRight": "InputGroup-labelRight-2_3_6-3Z8MJ",
	"blueSteel": "InputGroup-blueSteel-2_3_6-1i3_J"
};

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RemainingChars", function() { return RemainingChars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CharCountDisplay", function() { return CharCountDisplay; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _brightcove_studio_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(263);
/* harmony import */ var _brightcove_studio_colors__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_brightcove_studio_colors__WEBPACK_IMPORTED_MODULE_2__);



function RemainingChars(_ref) {
  var children = _ref.children;
  return children < 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
    style: {
      color: _brightcove_studio_colors__WEBPACK_IMPORTED_MODULE_2___default.a.errorColor
    }
  }, children) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null, children);
}
RemainingChars.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
};
function CharCountDisplay(_ref2) {
  var max = _ref2.max,
      count = _ref2.count;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
    style: {
      color: count > max ? _brightcove_studio_colors__WEBPACK_IMPORTED_MODULE_2___default.a.errorColor : _brightcove_studio_colors__WEBPACK_IMPORTED_MODULE_2___default.a.textSecondaryDark
    }
  }, count, " / ", max);
}
CharCountDisplay.propTypes = {
  max: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired,
  count: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true});
var textPrimaryDark = exports.textPrimaryDark = '#01050e';
var textSecondaryDark = exports.textSecondaryDark = '#4d5056';
var textTertiaryDark = exports.textTertiaryDark = '#4d5056';
var textPrimaryLight = exports.textPrimaryLight = '#ffffff';
var textSecondaryLight = exports.textSecondaryLight = '#f9f9f9';
var textTertiaryLight = exports.textTertiaryLight = '#f2f2f3';
var textTooltip = exports.textTooltip = '#f9f9f9';
var errorColor = exports.errorColor = '#d33d00';
var linkColorDark = exports.linkColorDark = '#072290';
var linkColorLight = exports.linkColorLight = '#ffffff';
var alertBg = exports.alertBg = '#fffbf2';
var alertBgError = exports.alertBgError = '#d33d00';
var warningBg = exports.warningBg = '#ffba00';
var accountInfo = exports.accountInfo = '#00B057';
var buttonBgPrimary = exports.buttonBgPrimary = '#072290';
var buttonBgSecondary = exports.buttonBgSecondary = '#ffffff';
var buttonBgDestructive = exports.buttonBgDestructive = '#d33d00';
var sidebarBg = exports.sidebarBg = '#030D28';
var sidebarHover = exports.sidebarHover = '#092dbd';
var sidebarSelected = exports.sidebarSelected = '#072290';
var borderColor = exports.borderColor = '#e5e6e6';
var inputBorder = exports.inputBorder = '#e5e6e6';
var inputBorderDisabled = exports.inputBorderDisabled = '#f2f2f3';
var inputBorderHover = exports.inputBorderHover = '#4d5056';
var inputBorderFocus = exports.inputBorderFocus = '#4d5056';
var highlightPrimary = exports.highlightPrimary = '#f2f4f9';
var highlightSecondary = exports.highlightSecondary = '#f2f4f9';
var pageHeaderBg = exports.pageHeaderBg = '#f2f4f9';
var panelHeaderBg = exports.panelHeaderBg = '#f2f2f3';
var tableHeaderBg = exports.tableHeaderBg = '#e5e6e6';
var navyDark = exports.navyDark = '#030D28';
var navy = exports.navy = '#072290';
var navyLight = exports.navyLight = '#092dbd';
var navyGray = exports.navyGray = '#f2f4f9';
var black = exports.black = '#01050e';
var white = exports.white = '#ffffff';
var gray50 = exports.gray50 = '#4d5056';
var gray40 = exports.gray40 = '#8e9093';
var gray30 = exports.gray30 = '#e5e6e6';
var gray20 = exports.gray20 = '#f2f2f3';
var gray10 = exports.gray10 = '#f9f9f9';
var cyan = exports.cyan = '#2ac1ff';
var green = exports.green = '#00B057';
var yellow = exports.yellow = '#ffba00';
var yellow05 = exports.yellow05 = '#fffbf2';
var red = exports.red = '#d33d00';
var red05 = exports.red05 = '#fdf6f3';
var plum = exports.plum = '#8f14cc';
exports.default = { 
  textPrimaryDark: textPrimaryDark,
  textSecondaryDark: textSecondaryDark,
  textTertiaryDark: textTertiaryDark,
  textPrimaryLight: textPrimaryLight,
  textSecondaryLight: textSecondaryLight,
  textTertiaryLight: textTertiaryLight,
  textTooltip: textTooltip,
  errorColor: errorColor,
  linkColorDark: linkColorDark,
  linkColorLight: linkColorLight,
  alertBg: alertBg,
  alertBgError: alertBgError,
  warningBg: warningBg,
  accountInfo: accountInfo,
  buttonBgPrimary: buttonBgPrimary,
  buttonBgSecondary: buttonBgSecondary,
  buttonBgDestructive: buttonBgDestructive,
  sidebarBg: sidebarBg,
  sidebarHover: sidebarHover,
  sidebarSelected: sidebarSelected,
  borderColor: borderColor,
  inputBorder: inputBorder,
  inputBorderDisabled: inputBorderDisabled,
  inputBorderHover: inputBorderHover,
  inputBorderFocus: inputBorderFocus,
  highlightPrimary: highlightPrimary,
  highlightSecondary: highlightSecondary,
  pageHeaderBg: pageHeaderBg,
  panelHeaderBg: panelHeaderBg,
  tableHeaderBg: tableHeaderBg,
  navyDark: navyDark,
  navy: navy,
  navyLight: navyLight,
  navyGray: navyGray,
  black: black,
  white: white,
  gray50: gray50,
  gray40: gray40,
  gray30: gray30,
  gray20: gray20,
  gray10: gray10,
  cyan: cyan,
  green: green,
  yellow: yellow,
  yellow05: yellow05,
  red: red,
  red05: red05,
  plum: plum, 
};

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _AnimatedIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(265);




function AutosaveLoader(_ref) {
  var _ref$isSaved = _ref.isSaved,
      isSaved = _ref$isSaved === void 0 ? false : _ref$isSaved,
      _ref$isSaving = _ref.isSaving,
      isSaving = _ref$isSaving === void 0 ? false : _ref$isSaving;
  return isSaving ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_AnimatedIcon__WEBPACK_IMPORTED_MODULE_2__["AnimatedIcon"], {
    name: "loader"
  }) : isSaved ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_AnimatedIcon__WEBPACK_IMPORTED_MODULE_2__["AnimatedIcon"], {
    name: "checkmark",
    width: 17,
    height: 17,
    loop: false
  }) : null;
}

AutosaveLoader.propTypes = {
  /** if true and 'isSaving' is false, the checkmark animation will play */
  isSaved: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,

  /** if true, the loader animation will play */
  isSaving: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};
/* harmony default export */ __webpack_exports__["default"] = (AutosaveLoader);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _AnimatedIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(266);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimatedIcon", function() { return _AnimatedIcon__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimatedIcon", function() { return AnimatedIcon; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_lottie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(267);
/* harmony import */ var react_lottie__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_lottie__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _AnimatedIcon_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(359);
/* harmony import */ var _AnimatedIcon_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_AnimatedIcon_sass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);
/* harmony import */ var _animations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(361);









var AnimatedIcon = function AnimatedIcon(_ref) {
  var autoplay = _ref.autoplay,
      className = _ref.className,
      isPaused = _ref.isPaused,
      isStopped = _ref.isStopped,
      loop = _ref.loop,
      name = _ref.name,
      padRight = _ref.padRight,
      _ref$segments = _ref.segments,
      segments = _ref$segments === void 0 ? [] : _ref$segments,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      testName = _ref.testName,
      theme = _ref.theme,
      width = _ref.width,
      height = _ref.height;
  var animation = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);

  var onLoaded = function onLoaded() {
    var anim = animation.current.anim;
    anim.playSegments(segments, true);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_AnimatedIcon_sass__WEBPACK_IMPORTED_MODULE_6___default.a[name], _AnimatedIcon_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme], className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _AnimatedIcon_sass__WEBPACK_IMPORTED_MODULE_6___default.a.padRight, padRight)),
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(react_lottie__WEBPACK_IMPORTED_MODULE_4___default.a, {
    isPaused: isPaused,
    isStopped: isStopped,
    isClickToPauseDisabled: true,
    ref: animation,
    segments: segments,
    options: {
      loop: loop,
      autoplay: autoplay,
      animationData: _animations__WEBPACK_IMPORTED_MODULE_8__["default"][name]
    },
    height: height,
    width: width,
    eventListeners: [{
      eventName: 'DOMLoaded',
      callback: onLoaded
    }]
  }));
};
AnimatedIcon.propTypes = {
  /** If true the animation will play once it was rendered */
  autoplay: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Class to apply to the animation vector. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Height of the animation in pixels */
  height: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,

  /** If true the animation pauses */
  isPaused: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** If true the animation stops */
  isStopped: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** If true the animation will play in loop */
  loop: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Name of the animated icon (case insensitive). */
  name: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string.isRequired,

  /** If true a right margin will be applied to separate this icon from adjacent inline content. */
  padRight: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Segments of the animation to be played, provide a range, e.g. [0,10] */
  segments: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number),

  /** Style attribute on the animation vector. */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Width of the animation in pixels */
  width: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number
};
AnimatedIcon.defaultProps = {
  autoplay: true,
  height: 16,
  isPaused: false,
  isStopped: false,
  loop: true,
  padRight: false,
  width: 16
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_AnimatedIcon_sass__WEBPACK_IMPORTED_MODULE_6___default.a)(AnimatedIcon));

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(268);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(307);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(312);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(317);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(350);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(125);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(130);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lottieWeb = __webpack_require__(358);

var _lottieWeb2 = _interopRequireDefault(_lottieWeb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Lottie = function (_React$Component) {
  (0, _inherits3.default)(Lottie, _React$Component);

  function Lottie() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Lottie);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, _getPrototypeOf2.default)(Lottie)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickToPause = function () {
      // The pause() method is for handling pausing by passing a prop isPaused
      // This method is for handling the ability to pause by clicking on the animation
      if (_this.anim.isPaused) {
        _this.anim.play();
      } else {
        _this.anim.pause();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Lottie, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          options = _props.options,
          eventListeners = _props.eventListeners;
      var loop = options.loop,
          autoplay = options.autoplay,
          animationData = options.animationData,
          rendererSettings = options.rendererSettings,
          segments = options.segments;


      this.options = {
        container: this.el,
        renderer: 'svg',
        loop: loop !== false,
        autoplay: autoplay !== false,
        segments: segments !== false,
        animationData: animationData,
        rendererSettings: rendererSettings
      };

      this.options = (0, _extends3.default)({}, this.options, options);

      this.anim = _lottieWeb2.default.loadAnimation(this.options);
      this.registerEvents(eventListeners);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps /* , nextState */) {
      /* Recreate the animation handle if the data is changed */
      if (this.options.animationData !== nextProps.options.animationData) {
        this.deRegisterEvents(this.props.eventListeners);
        this.destroy();
        this.options = (0, _extends3.default)({}, this.options, nextProps.options);
        this.anim = _lottieWeb2.default.loadAnimation(this.options);
        this.registerEvents(nextProps.eventListeners);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isStopped) {
        this.stop();
      } else if (this.props.segments) {
        this.playSegments();
      } else {
        this.play();
      }

      this.pause();
      this.setSpeed();
      this.setDirection();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.deRegisterEvents(this.props.eventListeners);
      this.destroy();
      this.options.animationData = null;
      this.anim = null;
    }
  }, {
    key: 'setSpeed',
    value: function setSpeed() {
      this.anim.setSpeed(this.props.speed);
    }
  }, {
    key: 'setDirection',
    value: function setDirection() {
      this.anim.setDirection(this.props.direction);
    }
  }, {
    key: 'play',
    value: function play() {
      this.anim.play();
    }
  }, {
    key: 'playSegments',
    value: function playSegments() {
      this.anim.playSegments(this.props.segments);
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.anim.stop();
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (this.props.isPaused && !this.anim.isPaused) {
        this.anim.pause();
      } else if (!this.props.isPaused && this.anim.isPaused) {
        this.anim.pause();
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.anim.destroy();
    }
  }, {
    key: 'registerEvents',
    value: function registerEvents(eventListeners) {
      var _this2 = this;

      eventListeners.forEach(function (eventListener) {
        _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
      });
    }
  }, {
    key: 'deRegisterEvents',
    value: function deRegisterEvents(eventListeners) {
      var _this3 = this;

      eventListeners.forEach(function (eventListener) {
        _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height,
          ariaRole = _props2.ariaRole,
          ariaLabel = _props2.ariaLabel,
          isClickToPauseDisabled = _props2.isClickToPauseDisabled,
          title = _props2.title;


      var getSize = function getSize(initial) {
        var size = void 0;

        if (typeof initial === 'number') {
          size = initial + 'px';
        } else {
          size = initial || '100%';
        }

        return size;
      };

      var lottieStyles = (0, _extends3.default)({
        width: getSize(width),
        height: getSize(height),
        overflow: 'hidden',
        margin: '0 auto',
        outline: 'none'
      }, this.props.style);

      var onClickHandler = isClickToPauseDisabled ? function () {
        return null;
      } : this.handleClickToPause;

      return (
        // Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        _react2.default.createElement('div', {
          ref: function ref(c) {
            _this4.el = c;
          },
          style: lottieStyles,
          onClick: onClickHandler,
          title: title,
          role: ariaRole,
          'aria-label': ariaLabel,
          tabIndex: '0'
        })
      );
    }
  }]);
  return Lottie;
}(_react2.default.Component);

exports.default = Lottie;


Lottie.propTypes = {
  eventListeners: _propTypes2.default.arrayOf(_propTypes2.default.object),
  options: _propTypes2.default.object.isRequired,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  isStopped: _propTypes2.default.bool,
  isPaused: _propTypes2.default.bool,
  speed: _propTypes2.default.number,
  segments: _propTypes2.default.arrayOf(_propTypes2.default.number),
  direction: _propTypes2.default.number,
  ariaRole: _propTypes2.default.string,
  ariaLabel: _propTypes2.default.string,
  isClickToPauseDisabled: _propTypes2.default.bool,
  title: _propTypes2.default.string
};

Lottie.defaultProps = {
  eventListeners: [],
  isStopped: false,
  isPaused: false,
  speed: 1,
  ariaRole: 'button',
  ariaLabel: 'animation',
  isClickToPauseDisabled: false,
  title: ''
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(269);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(270), __esModule: true };

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(271);
module.exports = __webpack_require__(274).Object.assign;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(272);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(288) });


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(273);
var core = __webpack_require__(274);
var ctx = __webpack_require__(275);
var hide = __webpack_require__(277);
var has = __webpack_require__(287);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 273 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 274 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(276);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(278);
var createDesc = __webpack_require__(286);
module.exports = __webpack_require__(282) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(279);
var IE8_DOM_DEFINE = __webpack_require__(281);
var toPrimitive = __webpack_require__(285);
var dP = Object.defineProperty;

exports.f = __webpack_require__(282) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(280);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(282) && !__webpack_require__(283)(function () {
  return Object.defineProperty(__webpack_require__(284)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(283)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(280);
var document = __webpack_require__(273).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(280);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 287 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(282);
var getKeys = __webpack_require__(289);
var gOPS = __webpack_require__(304);
var pIE = __webpack_require__(305);
var toObject = __webpack_require__(306);
var IObject = __webpack_require__(292);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(283)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(290);
var enumBugKeys = __webpack_require__(303);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(287);
var toIObject = __webpack_require__(291);
var arrayIndexOf = __webpack_require__(295)(false);
var IE_PROTO = __webpack_require__(299)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(292);
var defined = __webpack_require__(294);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(293);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(291);
var toLength = __webpack_require__(296);
var toAbsoluteIndex = __webpack_require__(298);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(297);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 297 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(297);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(300)('keys');
var uid = __webpack_require__(302);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(274);
var global = __webpack_require__(273);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(301) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 303 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 304 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(294);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(308), __esModule: true };

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(309);
module.exports = __webpack_require__(274).Object.getPrototypeOf;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(306);
var $getPrototypeOf = __webpack_require__(310);

__webpack_require__(311)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(287);
var toObject = __webpack_require__(306);
var IE_PROTO = __webpack_require__(299)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(272);
var core = __webpack_require__(274);
var fails = __webpack_require__(283);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(314);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(315), __esModule: true };

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(316);
var $Object = __webpack_require__(274).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(272);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(282), 'Object', { defineProperty: __webpack_require__(278).f });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(318);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(319);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(337);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(320), __esModule: true };

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(321);
__webpack_require__(332);
module.exports = __webpack_require__(336).f('iterator');


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(322)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(323)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(297);
var defined = __webpack_require__(294);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(301);
var $export = __webpack_require__(272);
var redefine = __webpack_require__(324);
var hide = __webpack_require__(277);
var Iterators = __webpack_require__(325);
var $iterCreate = __webpack_require__(326);
var setToStringTag = __webpack_require__(330);
var getPrototypeOf = __webpack_require__(310);
var ITERATOR = __webpack_require__(331)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(277);


/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(327);
var descriptor = __webpack_require__(286);
var setToStringTag = __webpack_require__(330);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(277)(IteratorPrototype, __webpack_require__(331)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(279);
var dPs = __webpack_require__(328);
var enumBugKeys = __webpack_require__(303);
var IE_PROTO = __webpack_require__(299)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(284)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(329).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(278);
var anObject = __webpack_require__(279);
var getKeys = __webpack_require__(289);

module.exports = __webpack_require__(282) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(273).document;
module.exports = document && document.documentElement;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(278).f;
var has = __webpack_require__(287);
var TAG = __webpack_require__(331)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(300)('wks');
var uid = __webpack_require__(302);
var Symbol = __webpack_require__(273).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(333);
var global = __webpack_require__(273);
var hide = __webpack_require__(277);
var Iterators = __webpack_require__(325);
var TO_STRING_TAG = __webpack_require__(331)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(334);
var step = __webpack_require__(335);
var Iterators = __webpack_require__(325);
var toIObject = __webpack_require__(291);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(323)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(331);


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(338), __esModule: true };

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(339);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
module.exports = __webpack_require__(274).Symbol;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(273);
var has = __webpack_require__(287);
var DESCRIPTORS = __webpack_require__(282);
var $export = __webpack_require__(272);
var redefine = __webpack_require__(324);
var META = __webpack_require__(340).KEY;
var $fails = __webpack_require__(283);
var shared = __webpack_require__(300);
var setToStringTag = __webpack_require__(330);
var uid = __webpack_require__(302);
var wks = __webpack_require__(331);
var wksExt = __webpack_require__(336);
var wksDefine = __webpack_require__(341);
var enumKeys = __webpack_require__(342);
var isArray = __webpack_require__(343);
var anObject = __webpack_require__(279);
var isObject = __webpack_require__(280);
var toObject = __webpack_require__(306);
var toIObject = __webpack_require__(291);
var toPrimitive = __webpack_require__(285);
var createDesc = __webpack_require__(286);
var _create = __webpack_require__(327);
var gOPNExt = __webpack_require__(344);
var $GOPD = __webpack_require__(346);
var $GOPS = __webpack_require__(304);
var $DP = __webpack_require__(278);
var $keys = __webpack_require__(289);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(345).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(305).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(301)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(277)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(302)('meta');
var isObject = __webpack_require__(280);
var has = __webpack_require__(287);
var setDesc = __webpack_require__(278).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(283)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(273);
var core = __webpack_require__(274);
var LIBRARY = __webpack_require__(301);
var wksExt = __webpack_require__(336);
var defineProperty = __webpack_require__(278).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(289);
var gOPS = __webpack_require__(304);
var pIE = __webpack_require__(305);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(293);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(291);
var gOPN = __webpack_require__(345).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(290);
var hiddenKeys = __webpack_require__(303).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(305);
var createDesc = __webpack_require__(286);
var toIObject = __webpack_require__(291);
var toPrimitive = __webpack_require__(285);
var has = __webpack_require__(287);
var IE8_DOM_DEFINE = __webpack_require__(281);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(282) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 347 */
/***/ (function(module, exports) {



/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(341)('asyncIterator');


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(341)('observable');


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(351);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(355);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(318);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(352), __esModule: true };

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(353);
module.exports = __webpack_require__(274).Object.setPrototypeOf;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(272);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(354).set });


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(280);
var anObject = __webpack_require__(279);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(275)(Function.call, __webpack_require__(346).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(356), __esModule: true };

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(357);
var $Object = __webpack_require__(274).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(272);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(327) });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(typeof navigator !== "undefined") && (function(root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            return factory(root);
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}((window || {}), function(window) {
	/* global locationHref:writable, animationManager, subframeEnabled:writable, defaultCurveSegments:writable, roundValues,
expressionsPlugin:writable, PropertyFactory, ShapePropertyFactory, Matrix */
/* exported locationHref, subframeEnabled, expressionsPlugin */

'use strict';

/* exported svgNS, locationHref, initialDefaultFrame */

var svgNS = 'http://www.w3.org/2000/svg';

var locationHref = '';

var initialDefaultFrame = -999999;

/* global createSizedArray */
/* exported subframeEnabled, expressionsPlugin, isSafari, cachedColors, bmPow, bmSqrt, bmFloor, bmMax, bmMin, ProjectInterface,
defaultCurveSegments, degToRads, roundCorner, bmRnd, styleDiv, BMEnterFrameEvent, BMCompleteEvent, BMCompleteLoopEvent,
BMSegmentStartEvent, BMDestroyEvent, BMRenderFrameErrorEvent, BMConfigErrorEvent, BMAnimationConfigErrorEvent, createElementID,
addSaturationToRGB, addBrightnessToRGB, addHueToRGB, rgbToHex */

var subframeEnabled = true;
var expressionsPlugin;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var cachedColors = {};
var bmRnd;
var bmPow = Math.pow;
var bmSqrt = Math.sqrt;
var bmFloor = Math.floor;
var bmMax = Math.max;
var bmMin = Math.min;

var BMMath = {};
(function () {
  var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
  var i;
  var len = propertyNames.length;
  for (i = 0; i < len; i += 1) {
    BMMath[propertyNames[i]] = Math[propertyNames[i]];
  }
}());

function ProjectInterface() { return {}; }

BMMath.random = Math.random;
BMMath.abs = function (val) {
  var tOfVal = typeof val;
  if (tOfVal === 'object' && val.length) {
    var absArr = createSizedArray(val.length);
    var i;
    var len = val.length;
    for (i = 0; i < len; i += 1) {
      absArr[i] = Math.abs(val[i]);
    }
    return absArr;
  }
  return Math.abs(val);
};
var defaultCurveSegments = 150;
var degToRads = Math.PI / 180;
var roundCorner = 0.5519;

function roundValues(flag) {
  if (flag) {
    bmRnd = Math.round;
  } else {
    bmRnd = function (val) {
      return val;
    };
  }
}
roundValues(false);

function styleDiv(element) {
  element.style.position = 'absolute';
  element.style.top = 0;
  element.style.left = 0;
  element.style.display = 'block';
  element.style.transformOrigin = '0 0';
  element.style.webkitTransformOrigin = '0 0';
  element.style.backfaceVisibility = 'visible';
  element.style.webkitBackfaceVisibility = 'visible';
  element.style.transformStyle = 'preserve-3d';
  element.style.webkitTransformStyle = 'preserve-3d';
  element.style.mozTransformStyle = 'preserve-3d';
}

function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
  this.type = type;
  this.currentTime = currentTime;
  this.totalTime = totalTime;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMCompleteEvent(type, frameMultiplier) {
  this.type = type;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
  this.type = type;
  this.currentLoop = currentLoop;
  this.totalLoops = totalLoops;
  this.direction = frameMultiplier < 0 ? -1 : 1;
}

function BMSegmentStartEvent(type, firstFrame, totalFrames) {
  this.type = type;
  this.firstFrame = firstFrame;
  this.totalFrames = totalFrames;
}

function BMDestroyEvent(type, target) {
  this.type = type;
  this.target = target;
}

function BMRenderFrameErrorEvent(nativeError, currentTime) {
  this.type = 'renderFrameError';
  this.nativeError = nativeError;
  this.currentTime = currentTime;
}

function BMConfigErrorEvent(nativeError) {
  this.type = 'configError';
  this.nativeError = nativeError;
}

function BMAnimationConfigErrorEvent(type, nativeError) {
  this.type = type;
  this.nativeError = nativeError;
}

var createElementID = (function () {
  var _count = 0;
  return function createID() {
    _count += 1;
    return '__lottie_element_' + _count;
  };
}());

function HSVtoRGB(h, s, v) {
  var r;
  var g;
  var b;
  var i;
  var f;
  var p;
  var q;
  var t;
  i = Math.floor(h * 6);
  f = h * 6 - i;
  p = v * (1 - s);
  q = v * (1 - f * s);
  t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0: r = v; g = t; b = p; break;
    case 1: r = q; g = v; b = p; break;
    case 2: r = p; g = v; b = t; break;
    case 3: r = p; g = q; b = v; break;
    case 4: r = t; g = p; b = v; break;
    case 5: r = v; g = p; b = q; break;
    default: break;
  }
  return [r,
    g,
    b];
}

function RGBtoHSV(r, g, b) {
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var d = max - min;
  var h;
  var s = (max === 0 ? 0 : d / max);
  var v = max / 255;

  switch (max) {
    case min: h = 0; break;
    case r: h = (g - b) + d * (g < b ? 6 : 0); h /= 6 * d; break;
    case g: h = (b - r) + d * 2; h /= 6 * d; break;
    case b: h = (r - g) + d * 4; h /= 6 * d; break;
    default: break;
  }

  return [
    h,
    s,
    v,
  ];
}

function addSaturationToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[1] += offset;
  if (hsv[1] > 1) {
    hsv[1] = 1;
  } else if (hsv[1] <= 0) {
    hsv[1] = 0;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

function addBrightnessToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[2] += offset;
  if (hsv[2] > 1) {
    hsv[2] = 1;
  } else if (hsv[2] < 0) {
    hsv[2] = 0;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

function addHueToRGB(color, offset) {
  var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
  hsv[0] += offset / 360;
  if (hsv[0] > 1) {
    hsv[0] -= 1;
  } else if (hsv[0] < 0) {
    hsv[0] += 1;
  }
  return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}

var rgbToHex = (function () {
  var colorMap = [];
  var i;
  var hex;
  for (i = 0; i < 256; i += 1) {
    hex = i.toString(16);
    colorMap[i] = hex.length === 1 ? '0' + hex : hex;
  }

  return function (r, g, b) {
    if (r < 0) {
      r = 0;
    }
    if (g < 0) {
      g = 0;
    }
    if (b < 0) {
      b = 0;
    }
    return '#' + colorMap[r] + colorMap[g] + colorMap[b];
  };
}());

function BaseEvent() {}
BaseEvent.prototype = {
  triggerEvent: function (eventName, args) {
    if (this._cbs[eventName]) {
      var len = this._cbs[eventName].length;
      for (var i = 0; i < len; i += 1) {
        this._cbs[eventName][i](args);
      }
    }
  },
  addEventListener: function (eventName, callback) {
    if (!this._cbs[eventName]) {
      this._cbs[eventName] = [];
    }
    this._cbs[eventName].push(callback);

    return function () {
      this.removeEventListener(eventName, callback);
    }.bind(this);
  },
  removeEventListener: function (eventName, callback) {
    if (!callback) {
      this._cbs[eventName] = null;
    } else if (this._cbs[eventName]) {
      var i = 0;
      var len = this._cbs[eventName].length;
      while (i < len) {
        if (this._cbs[eventName][i] === callback) {
          this._cbs[eventName].splice(i, 1);
          i -= 1;
          len -= 1;
        }
        i += 1;
      }
      if (!this._cbs[eventName].length) {
        this._cbs[eventName] = null;
      }
    }
  },
};

/* exported createTypedArray, createSizedArray */

var createTypedArray = (function () {
  function createRegularArray(type, len) {
    var i = 0;
    var arr = [];
    var value;
    switch (type) {
      case 'int16':
      case 'uint8c':
        value = 1;
        break;
      default:
        value = 1.1;
        break;
    }
    for (i = 0; i < len; i += 1) {
      arr.push(value);
    }
    return arr;
  }
  function createTypedArrayFactory(type, len) {
    if (type === 'float32') {
      return new Float32Array(len);
    } if (type === 'int16') {
      return new Int16Array(len);
    } if (type === 'uint8c') {
      return new Uint8ClampedArray(len);
    }
    return createRegularArray(type, len);
  }
  if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
    return createTypedArrayFactory;
  }
  return createRegularArray;
}());

function createSizedArray(len) {
  return Array.apply(null, { length: len });
}

/* global svgNS */
/* exported createNS */

function createNS(type) {
  // return {appendChild:function(){},setAttribute:function(){},style:{}}
  return document.createElementNS(svgNS, type);
}

/* exported createTag */

function createTag(type) {
  // return {appendChild:function(){},setAttribute:function(){},style:{}}
  return document.createElement(type);
}

function DynamicPropertyContainer() {}
DynamicPropertyContainer.prototype = {
  addDynamicProperty: function (prop) {
    if (this.dynamicProperties.indexOf(prop) === -1) {
      this.dynamicProperties.push(prop);
      this.container.addDynamicProperty(this);
      this._isAnimated = true;
    }
  },
  iterateDynamicProperties: function () {
    this._mdf = false;
    var i;
    var len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
      if (this.dynamicProperties[i]._mdf) {
        this._mdf = true;
      }
    }
  },
  initDynamicPropertyContainer: function (container) {
    this.container = container;
    this.dynamicProperties = [];
    this._mdf = false;
    this._isAnimated = false;
  },
};

/* exported getBlendMode */

var getBlendMode = (function () {
  var blendModeEnums = {
    0: 'source-over',
    1: 'multiply',
    2: 'screen',
    3: 'overlay',
    4: 'darken',
    5: 'lighten',
    6: 'color-dodge',
    7: 'color-burn',
    8: 'hard-light',
    9: 'soft-light',
    10: 'difference',
    11: 'exclusion',
    12: 'hue',
    13: 'saturation',
    14: 'color',
    15: 'luminosity',
  };

  return function (mode) {
    return blendModeEnums[mode] || '';
  };
}());

/* global createTypedArray */

/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */

/**
 * 2D transformation matrix object initialized with identity matrix.
 *
 * The matrix can synchronize a canvas context by supplying the context
 * as an argument, or later apply current absolute transform to an
 * existing context.
 *
 * All values are handled as floating point values.
 *
 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
 * @prop {number} a - scale x
 * @prop {number} b - shear y
 * @prop {number} c - shear x
 * @prop {number} d - scale y
 * @prop {number} e - translate x
 * @prop {number} f - translate y
 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
 * @constructor
 */

var Matrix = (function () {
  var _cos = Math.cos;
  var _sin = Math.sin;
  var _tan = Math.tan;
  var _rnd = Math.round;

  function reset() {
    this.props[0] = 1;
    this.props[1] = 0;
    this.props[2] = 0;
    this.props[3] = 0;
    this.props[4] = 0;
    this.props[5] = 1;
    this.props[6] = 0;
    this.props[7] = 0;
    this.props[8] = 0;
    this.props[9] = 0;
    this.props[10] = 1;
    this.props[11] = 0;
    this.props[12] = 0;
    this.props[13] = 0;
    this.props[14] = 0;
    this.props[15] = 1;
    return this;
  }

  function rotate(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  function rotateX(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
  }

  function rotateY(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
  }

  function rotateZ(angle) {
    if (angle === 0) {
      return this;
    }
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }

  function shear(sx, sy) {
    return this._t(1, sy, sx, 1, 0, 0);
  }

  function skew(ax, ay) {
    return this.shear(_tan(ax), _tan(ay));
  }

  function skewFromAxis(ax, angle) {
    var mCos = _cos(angle);
    var mSin = _sin(angle);
    return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
      ._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
      ._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
  }

  function scale(sx, sy, sz) {
    if (!sz && sz !== 0) {
      sz = 1;
    }
    if (sx === 1 && sy === 1 && sz === 1) {
      return this;
    }
    return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
  }

  function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
    this.props[0] = a;
    this.props[1] = b;
    this.props[2] = c;
    this.props[3] = d;
    this.props[4] = e;
    this.props[5] = f;
    this.props[6] = g;
    this.props[7] = h;
    this.props[8] = i;
    this.props[9] = j;
    this.props[10] = k;
    this.props[11] = l;
    this.props[12] = m;
    this.props[13] = n;
    this.props[14] = o;
    this.props[15] = p;
    return this;
  }

  function translate(tx, ty, tz) {
    tz = tz || 0;
    if (tx !== 0 || ty !== 0 || tz !== 0) {
      return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
    }
    return this;
  }

  function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
    var _p = this.props;

    if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
      // NOTE: commenting this condition because TurboFan deoptimizes code when present
      // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
      _p[12] = _p[12] * a2 + _p[15] * m2;
      _p[13] = _p[13] * f2 + _p[15] * n2;
      _p[14] = _p[14] * k2 + _p[15] * o2;
      _p[15] *= p2;
      // }
      this._identityCalculated = false;
      return this;
    }

    var a1 = _p[0];
    var b1 = _p[1];
    var c1 = _p[2];
    var d1 = _p[3];
    var e1 = _p[4];
    var f1 = _p[5];
    var g1 = _p[6];
    var h1 = _p[7];
    var i1 = _p[8];
    var j1 = _p[9];
    var k1 = _p[10];
    var l1 = _p[11];
    var m1 = _p[12];
    var n1 = _p[13];
    var o1 = _p[14];
    var p1 = _p[15];

    /* matrix order (canvas compatible):
         * ace
         * bdf
         * 001
         */
    _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
    _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
    _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
    _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;

    _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
    _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
    _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
    _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;

    _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
    _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
    _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
    _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;

    _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
    _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
    _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
    _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;

    this._identityCalculated = false;
    return this;
  }

  function isIdentity() {
    if (!this._identityCalculated) {
      this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
      this._identityCalculated = true;
    }
    return this._identity;
  }

  function equals(matr) {
    var i = 0;
    while (i < 16) {
      if (matr.props[i] !== this.props[i]) {
        return false;
      }
      i += 1;
    }
    return true;
  }

  function clone(matr) {
    var i;
    for (i = 0; i < 16; i += 1) {
      matr.props[i] = this.props[i];
    }
    return matr;
  }

  function cloneFromProps(props) {
    var i;
    for (i = 0; i < 16; i += 1) {
      this.props[i] = props[i];
    }
  }

  function applyToPoint(x, y, z) {
    return {
      x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
      y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
      z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14],
    };
    /* return {
         x: x * me.a + y * me.c + me.e,
         y: x * me.b + y * me.d + me.f
         }; */
  }
  function applyToX(x, y, z) {
    return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
  }
  function applyToY(x, y, z) {
    return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
  }
  function applyToZ(x, y, z) {
    return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
  }

  function getInverseMatrix() {
    var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
    var a = this.props[5] / determinant;
    var b = -this.props[1] / determinant;
    var c = -this.props[4] / determinant;
    var d = this.props[0] / determinant;
    var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
    var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
    var inverseMatrix = new Matrix();
    inverseMatrix.props[0] = a;
    inverseMatrix.props[1] = b;
    inverseMatrix.props[4] = c;
    inverseMatrix.props[5] = d;
    inverseMatrix.props[12] = e;
    inverseMatrix.props[13] = f;
    return inverseMatrix;
  }

  function inversePoint(pt) {
    var inverseMatrix = this.getInverseMatrix();
    return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
  }

  function inversePoints(pts) {
    var i;
    var len = pts.length;
    var retPts = [];
    for (i = 0; i < len; i += 1) {
      retPts[i] = inversePoint(pts[i]);
    }
    return retPts;
  }

  function applyToTriplePoints(pt1, pt2, pt3) {
    var arr = createTypedArray('float32', 6);
    if (this.isIdentity()) {
      arr[0] = pt1[0];
      arr[1] = pt1[1];
      arr[2] = pt2[0];
      arr[3] = pt2[1];
      arr[4] = pt3[0];
      arr[5] = pt3[1];
    } else {
      var p0 = this.props[0];
      var p1 = this.props[1];
      var p4 = this.props[4];
      var p5 = this.props[5];
      var p12 = this.props[12];
      var p13 = this.props[13];
      arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
      arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
      arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
      arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
      arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
      arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
    }
    return arr;
  }

  function applyToPointArray(x, y, z) {
    var arr;
    if (this.isIdentity()) {
      arr = [x, y, z];
    } else {
      arr = [
        x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
        x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
        x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14],
      ];
    }
    return arr;
  }

  function applyToPointStringified(x, y) {
    if (this.isIdentity()) {
      return x + ',' + y;
    }
    var _p = this.props;
    return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
  }

  function toCSS() {
    // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
    /* if(this.isIdentity()) {
            return '';
        } */
    var i = 0;
    var props = this.props;
    var cssValue = 'matrix3d(';
    var v = 10000;
    while (i < 16) {
      cssValue += _rnd(props[i] * v) / v;
      cssValue += i === 15 ? ')' : ',';
      i += 1;
    }
    return cssValue;
  }

  function roundMatrixProperty(val) {
    var v = 10000;
    if ((val < 0.000001 && val > 0) || (val > -0.000001 && val < 0)) {
      return _rnd(val * v) / v;
    }
    return val;
  }

  function to2dCSS() {
    // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
    /* if(this.isIdentity()) {
            return '';
        } */
    var props = this.props;
    var _a = roundMatrixProperty(props[0]);
    var _b = roundMatrixProperty(props[1]);
    var _c = roundMatrixProperty(props[4]);
    var _d = roundMatrixProperty(props[5]);
    var _e = roundMatrixProperty(props[12]);
    var _f = roundMatrixProperty(props[13]);
    return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
  }

  return function () {
    this.reset = reset;
    this.rotate = rotate;
    this.rotateX = rotateX;
    this.rotateY = rotateY;
    this.rotateZ = rotateZ;
    this.skew = skew;
    this.skewFromAxis = skewFromAxis;
    this.shear = shear;
    this.scale = scale;
    this.setTransform = setTransform;
    this.translate = translate;
    this.transform = transform;
    this.applyToPoint = applyToPoint;
    this.applyToX = applyToX;
    this.applyToY = applyToY;
    this.applyToZ = applyToZ;
    this.applyToPointArray = applyToPointArray;
    this.applyToTriplePoints = applyToTriplePoints;
    this.applyToPointStringified = applyToPointStringified;
    this.toCSS = toCSS;
    this.to2dCSS = to2dCSS;
    this.clone = clone;
    this.cloneFromProps = cloneFromProps;
    this.equals = equals;
    this.inversePoints = inversePoints;
    this.inversePoint = inversePoint;
    this.getInverseMatrix = getInverseMatrix;
    this._t = this.transform;
    this.isIdentity = isIdentity;
    this._identity = true;
    this._identityCalculated = false;

    this.props = createTypedArray('float32', 16);
    this.reset();
  };
}());

/* eslint-disable */
/*
 Copyright 2014 David Bau.

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//
    var global = this,
        width = 256,        // each RC4 output is 0 <= x < 256
        chunks = 6,         // at least six RC4 outputs for each double
        digits = 52,        // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
    function seedrandom(seed, options, callback) {
        var key = [];
        options = (options === true) ? { entropy: true } : (options || {});

        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(
            options.entropy ? [seed, tostring(pool)] :
                (seed === null) ? autoseed() : seed, 3), key);

        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);

        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
                d = startdenom,                 //   and denominator d = 2 ^ 48.
                x = 0;                          //   and no 'extra last byte'.
            while (n < significance) {          // Fill up all significant digits by
                n = (n + x) * width;              //   shifting numerator and
                d *= width;                       //   denominator and generating a
                x = arc4.g(1);                    //   new least-significant-byte.
            }
            while (n >= overflow) {             // To avoid rounding up, before adding
                n /= 2;                           //   last byte, shift everything
                d /= 2;                           //   right using integer math until
                x >>>= 1;                         //   we have exactly the desired bits.
            }
            return (n + x) / d;                 // Form the number within [0, 1).
        };

        prng.int32 = function() { return arc4.g(4) | 0; };
        prng.quick = function() { return arc4.g(4) / 0x100000000; };
        prng.double = prng;

        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);

        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback ||
        function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) { copy(state, arc4); }
                // Only provide the .state method if requested via options.state.
                prng.state = function() { return copy(arc4, {}); };
            }

            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) { math[rngname] = prng; return seed; }

            // Otherwise, it is a newer calling convention, so return the
            // prng directly.
            else return prng;
        })(
            prng,
            shortseed,
            'global' in options ? options.global : (this == math),
            options.state);
    }
    math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
    function ARC4(key) {
        var t, keylen = key.length,
            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

        // The empty key [] is treated as [0].
        if (!keylen) { key = [keylen++]; }

        // Set up S using the standard key scheduling algorithm.
        while (i < width) {
            s[i] = i++;
        }
        for (i = 0; i < width; i++) {
            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
            s[j] = t;
        }

        // The "g" method returns the next (count) outputs as one number.
        me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0,
                i = me.i, j = me.j, s = me.S;
            while (count--) {
                t = s[i = mask & (i + 1)];
                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
            }
            me.i = i; me.j = j;
            return r;
            // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
        };
    }

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
    function flatten(obj, depth) {
        var result = [], typ = (typeof obj), prop;
        if (depth && typ == 'object') {
            for (prop in obj) {
                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
            }
        }
        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
    }

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while (j < stringseed.length) {
            key[mask & j] =
                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
        }
        return tostring(key);
    }

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
    function autoseed() {
        try {
            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
            var out = new Uint8Array(width);
            (global.crypto || global.msCrypto).getRandomValues(out);
            return tostring(out);
        } catch (e) {
            var browser = global.navigator,
                plugins = browser && browser.plugins;
            return [+new Date(), global, plugins, global.screen, tostring(pool)];
        }
    }

//
// tostring()
// Converts an array of charcodes to a string
//
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
    mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//

// End anonymous scope, and pass initial values.
})(
    [],     // pool: entropy pool starts empty
    BMMath    // math: package containing random, pow, and seedrandom
);
/* eslint-disable */
var BezierFactory = (function () {
  /**
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     *
     * Credits: is based on Firefox's nsSMILKeySpline.cpp
     * Usage:
     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
     * spline.get(x) => returns the easing value | x must be in [0, 1] range
     *
     */

  var ob = {};
  ob.getBezierEasing = getBezierEasing;
  var beziers = {};

  function getBezierEasing(a, b, c, d, nm) {
    var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
    if (beziers[str]) {
      return beziers[str];
    }
    var bezEasing = new BezierEasing([a, b, c, d]);
    beziers[str] = bezEasing;
    return bezEasing;
  }

  // These values are established by empiricism with tests (tradeoff: performance VS precision)
  var NEWTON_ITERATIONS = 4;
  var NEWTON_MIN_SLOPE = 0.001;
  var SUBDIVISION_PRECISION = 0.0000001;
  var SUBDIVISION_MAX_ITERATIONS = 10;

  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  var float32ArraySupported = typeof Float32Array === 'function';

  function A(aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
  function B(aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
  function C(aA1) { return 3.0 * aA1; }

  // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
  function calcBezier(aT, aA1, aA2) {
    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
  }

  // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
  function getSlope(aT, aA1, aA2) {
    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
  }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX,
      currentT,
      i = 0;
    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0.0) return aGuessT;
      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }

  /**
     * points is an array of [ mX1, mY1, mX2, mY2 ]
     */
  function BezierEasing(points) {
    this._p = points;
    this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    this._precomputed = false;

    this.get = this.get.bind(this);
  }

  BezierEasing.prototype = {

    get: function (x) {
      var mX1 = this._p[0],
        mY1 = this._p[1],
        mX2 = this._p[2],
        mY2 = this._p[3];
      if (!this._precomputed) this._precompute();
      if (mX1 === mY1 && mX2 === mY2) return x; // linear
      // Because JavaScript number are imprecise, we should guarantee the extremes are right.
      if (x === 0) return 0;
      if (x === 1) return 1;
      return calcBezier(this._getTForX(x), mY1, mY2);
    },

    // Private part

    _precompute: function () {
      var mX1 = this._p[0],
        mY1 = this._p[1],
        mX2 = this._p[2],
        mY2 = this._p[3];
      this._precomputed = true;
      if (mX1 !== mY1 || mX2 !== mY2) { this._calcSampleValues(); }
    },

    _calcSampleValues: function () {
      var mX1 = this._p[0],
        mX2 = this._p[2];
      for (var i = 0; i < kSplineTableSize; ++i) {
        this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    },

    /**
         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
         */
    _getTForX: function (aX) {
      var mX1 = this._p[0],
        mX2 = this._p[2],
        mSampleValues = this._mSampleValues;

      var intervalStart = 0.0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }
      --currentSample;

      // Interpolate to provide an initial guess for t
      var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;

      var initialSlope = getSlope(guessForT, mX1, mX2);
      if (initialSlope >= NEWTON_MIN_SLOPE) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } if (initialSlope === 0.0) {
        return guessForT;
      }
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    },
  };

  return ob;
}());

(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) { // eslint-disable-line no-plusplus
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = setTimeout(function () {
        callback(currTime + timeToCall);
      },
      timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
}());

/* exported extendPrototype, getDescriptor, createProxyFunction */

function extendPrototype(sources, destination) {
  var i;
  var len = sources.length;
  var sourcePrototype;
  for (i = 0; i < len; i += 1) {
    sourcePrototype = sources[i].prototype;
    for (var attr in sourcePrototype) {
      if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
    }
  }
}

function getDescriptor(object, prop) {
  return Object.getOwnPropertyDescriptor(object, prop);
}

function createProxyFunction(prototype) {
  function ProxyFunction() {}
  ProxyFunction.prototype = prototype;
  return ProxyFunction;
}

/* global segmentsLengthPool, defaultCurveSegments, createSizedArray, bmPow, bmSqrt, bmFloor, createTypedArray, bezierLengthPool */
/* exported bez */

function bezFunction() {
  var math = Math;

  function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
    var det1 = (x1 * y2) + (y1 * x3) + (x2 * y3) - (x3 * y2) - (y3 * x1) - (x2 * y1);
    return det1 > -0.001 && det1 < 0.001;
  }

  function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
    if (z1 === 0 && z2 === 0 && z3 === 0) {
      return pointOnLine2D(x1, y1, x2, y2, x3, y3);
    }
    var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
    var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
    var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
    var diffDist;
    if (dist1 > dist2) {
      if (dist1 > dist3) {
        diffDist = dist1 - dist2 - dist3;
      } else {
        diffDist = dist3 - dist2 - dist1;
      }
    } else if (dist3 > dist2) {
      diffDist = dist3 - dist2 - dist1;
    } else {
      diffDist = dist2 - dist1 - dist3;
    }
    return diffDist > -0.0001 && diffDist < 0.0001;
  }

  var getBezierLength = (function () {
    return function (pt1, pt2, pt3, pt4) {
      var curveSegments = defaultCurveSegments;
      var k;
      var i;
      var len;
      var ptCoord;
      var perc;
      var addedLength = 0;
      var ptDistance;
      var point = [];
      var lastPoint = [];
      var lengthData = bezierLengthPool.newElement();
      len = pt3.length;
      for (k = 0; k < curveSegments; k += 1) {
        perc = k / (curveSegments - 1);
        ptDistance = 0;
        for (i = 0; i < len; i += 1) {
          ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
          point[i] = ptCoord;
          if (lastPoint[i] !== null) {
            ptDistance += bmPow(point[i] - lastPoint[i], 2);
          }
          lastPoint[i] = point[i];
        }
        if (ptDistance) {
          ptDistance = bmSqrt(ptDistance);
          addedLength += ptDistance;
        }
        lengthData.percents[k] = perc;
        lengthData.lengths[k] = addedLength;
      }
      lengthData.addedLength = addedLength;
      return lengthData;
    };
  }());

  function getSegmentsLength(shapeData) {
    var segmentsLength = segmentsLengthPool.newElement();
    var closed = shapeData.c;
    var pathV = shapeData.v;
    var pathO = shapeData.o;
    var pathI = shapeData.i;
    var i;
    var len = shapeData._length;
    var lengths = segmentsLength.lengths;
    var totalLength = 0;
    for (i = 0; i < len - 1; i += 1) {
      lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
      totalLength += lengths[i].addedLength;
    }
    if (closed && len) {
      lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
      totalLength += lengths[i].addedLength;
    }
    segmentsLength.totalLength = totalLength;
    return segmentsLength;
  }

  function BezierData(length) {
    this.segmentLength = 0;
    this.points = new Array(length);
  }

  function PointData(partial, point) {
    this.partialLength = partial;
    this.point = point;
  }

  var buildBezierData = (function () {
    var storedData = {};

    return function (pt1, pt2, pt3, pt4) {
      var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
      if (!storedData[bezierName]) {
        var curveSegments = defaultCurveSegments;
        var k;
        var i;
        var len;
        var ptCoord;
        var perc;
        var addedLength = 0;
        var ptDistance;
        var point;
        var lastPoint = null;
        if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
          curveSegments = 2;
        }
        var bezierData = new BezierData(curveSegments);
        len = pt3.length;
        for (k = 0; k < curveSegments; k += 1) {
          point = createSizedArray(len);
          perc = k / (curveSegments - 1);
          ptDistance = 0;
          for (i = 0; i < len; i += 1) {
            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
            point[i] = ptCoord;
            if (lastPoint !== null) {
              ptDistance += bmPow(point[i] - lastPoint[i], 2);
            }
          }
          ptDistance = bmSqrt(ptDistance);
          addedLength += ptDistance;
          bezierData.points[k] = new PointData(ptDistance, point);
          lastPoint = point;
        }
        bezierData.segmentLength = addedLength;
        storedData[bezierName] = bezierData;
      }
      return storedData[bezierName];
    };
  }());

  function getDistancePerc(perc, bezierData) {
    var percents = bezierData.percents;
    var lengths = bezierData.lengths;
    var len = percents.length;
    var initPos = bmFloor((len - 1) * perc);
    var lengthPos = perc * bezierData.addedLength;
    var lPerc = 0;
    if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
      return percents[initPos];
    }
    var dir = lengths[initPos] > lengthPos ? -1 : 1;
    var flag = true;
    while (flag) {
      if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
        lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
        flag = false;
      } else {
        initPos += dir;
      }
      if (initPos < 0 || initPos >= len - 1) {
        // FIX for TypedArrays that don't store floating point values with enough accuracy
        if (initPos === len - 1) {
          return percents[initPos];
        }
        flag = false;
      }
    }
    return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
  }

  function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
    var t1 = getDistancePerc(percent, bezierData);
    var u1 = 1 - t1;
    var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
    var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
    return [ptX, ptY];
  }

  var bezierSegmentPoints = createTypedArray('float32', 8);

  function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
    if (startPerc < 0) {
      startPerc = 0;
    } else if (startPerc > 1) {
      startPerc = 1;
    }
    var t0 = getDistancePerc(startPerc, bezierData);
    endPerc = endPerc > 1 ? 1 : endPerc;
    var t1 = getDistancePerc(endPerc, bezierData);
    var i;
    var len = pt1.length;
    var u0 = 1 - t0;
    var u1 = 1 - t1;
    var u0u0u0 = u0 * u0 * u0;
    var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
    var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
    var t0t0t0 = t0 * t0 * t0;
    //
    var u0u0u1 = u0 * u0 * u1;
    var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
    var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
    var t0t0t1 = t0 * t0 * t1;
    //
    var u0u1u1 = u0 * u1 * u1;
    var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
    var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
    var t0t1t1 = t0 * t1 * t1;
    //
    var u1u1u1 = u1 * u1 * u1;
    var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
    var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
    var t1t1t1 = t1 * t1 * t1;
    for (i = 0; i < len; i += 1) {
      bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
    }

    return bezierSegmentPoints;
  }

  return {
    getSegmentsLength: getSegmentsLength,
    getNewSegment: getNewSegment,
    getPointInSegment: getPointInSegment,
    buildBezierData: buildBezierData,
    pointOnLine2D: pointOnLine2D,
    pointOnLine3D: pointOnLine3D,
  };
}

var bez = bezFunction();

/* exported dataManager */

function dataFunctionManager() {
  // var tCanvasHelper = createTag('canvas').getContext('2d');

  function completeLayers(layers, comps, fontManager) {
    var layerData;
    var i;
    var len = layers.length;
    var j;
    var jLen;
    var k;
    var kLen;
    for (i = 0; i < len; i += 1) {
      layerData = layers[i];
      if (('ks' in layerData) && !layerData.completed) {
        layerData.completed = true;
        if (layerData.tt) {
          layers[i - 1].td = layerData.tt;
        }
        if (layerData.hasMask) {
          var maskProps = layerData.masksProperties;
          jLen = maskProps.length;
          for (j = 0; j < jLen; j += 1) {
            if (maskProps[j].pt.k.i) {
              convertPathsToAbsoluteValues(maskProps[j].pt.k);
            } else {
              kLen = maskProps[j].pt.k.length;
              for (k = 0; k < kLen; k += 1) {
                if (maskProps[j].pt.k[k].s) {
                  convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                }
                if (maskProps[j].pt.k[k].e) {
                  convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                }
              }
            }
          }
        }
        if (layerData.ty === 0) {
          layerData.layers = findCompLayers(layerData.refId, comps);
          completeLayers(layerData.layers, comps, fontManager);
        } else if (layerData.ty === 4) {
          completeShapes(layerData.shapes);
        } else if (layerData.ty === 5) {
          completeText(layerData, fontManager);
        }
      }
    }
  }

  function findCompLayers(id, comps) {
    var i = 0;
    var len = comps.length;
    while (i < len) {
      if (comps[i].id === id) {
        if (!comps[i].layers.__used) {
          comps[i].layers.__used = true;
          return comps[i].layers;
        }
        return JSON.parse(JSON.stringify(comps[i].layers));
      }
      i += 1;
    }
    return null;
  }

  function completeShapes(arr) {
    var i;
    var len = arr.length;
    var j;
    var jLen;
    for (i = len - 1; i >= 0; i -= 1) {
      if (arr[i].ty === 'sh') {
        if (arr[i].ks.k.i) {
          convertPathsToAbsoluteValues(arr[i].ks.k);
        } else {
          jLen = arr[i].ks.k.length;
          for (j = 0; j < jLen; j += 1) {
            if (arr[i].ks.k[j].s) {
              convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
            }
            if (arr[i].ks.k[j].e) {
              convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
            }
          }
        }
      } else if (arr[i].ty === 'gr') {
        completeShapes(arr[i].it);
      }
    }
  }

  function convertPathsToAbsoluteValues(path) {
    var i;
    var len = path.i.length;
    for (i = 0; i < len; i += 1) {
      path.i[i][0] += path.v[i][0];
      path.i[i][1] += path.v[i][1];
      path.o[i][0] += path.v[i][0];
      path.o[i][1] += path.v[i][1];
    }
  }

  function checkVersion(minimum, animVersionString) {
    var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];
    if (minimum[0] > animVersion[0]) {
      return true;
    } if (animVersion[0] > minimum[0]) {
      return false;
    }
    if (minimum[1] > animVersion[1]) {
      return true;
    } if (animVersion[1] > minimum[1]) {
      return false;
    }
    if (minimum[2] > animVersion[2]) {
      return true;
    } if (animVersion[2] > minimum[2]) {
      return false;
    }
    return null;
  }

  var checkText = (function () {
    var minimumVersion = [4, 4, 14];

    function updateTextLayer(textLayer) {
      var documentData = textLayer.t.d;
      textLayer.t.d = {
        k: [
          {
            s: documentData,
            t: 0,
          },
        ],
      };
    }

    function iterateLayers(layers) {
      var i;
      var len = layers.length;
      for (i = 0; i < len; i += 1) {
        if (layers[i].ty === 5) {
          updateTextLayer(layers[i]);
        }
      }
    }

    return function (animationData) {
      if (checkVersion(minimumVersion, animationData.v)) {
        iterateLayers(animationData.layers);
        if (animationData.assets) {
          var i;
          var len = animationData.assets.length;
          for (i = 0; i < len; i += 1) {
            if (animationData.assets[i].layers) {
              iterateLayers(animationData.assets[i].layers);
            }
          }
        }
      }
    };
  }());

  var checkChars = (function () {
    var minimumVersion = [4, 7, 99];
    return function (animationData) {
      if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
        var i;
        var len = animationData.chars.length;
        var j;
        var jLen;
        var pathData;
        var paths;
        for (i = 0; i < len; i += 1) {
          if (animationData.chars[i].data && animationData.chars[i].data.shapes) {
            paths = animationData.chars[i].data.shapes[0].it;
            jLen = paths.length;

            for (j = 0; j < jLen; j += 1) {
              pathData = paths[j].ks.k;
              if (!pathData.__converted) {
                convertPathsToAbsoluteValues(paths[j].ks.k);
                pathData.__converted = true;
              }
            }
          }
        }
      }
    };
  }());

  var checkColors = (function () {
    var minimumVersion = [4, 1, 9];

    function iterateShapes(shapes) {
      var i;
      var len = shapes.length;
      var j;
      var jLen;
      for (i = 0; i < len; i += 1) {
        if (shapes[i].ty === 'gr') {
          iterateShapes(shapes[i].it);
        } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
          if (shapes[i].c.k && shapes[i].c.k[0].i) {
            jLen = shapes[i].c.k.length;
            for (j = 0; j < jLen; j += 1) {
              if (shapes[i].c.k[j].s) {
                shapes[i].c.k[j].s[0] /= 255;
                shapes[i].c.k[j].s[1] /= 255;
                shapes[i].c.k[j].s[2] /= 255;
                shapes[i].c.k[j].s[3] /= 255;
              }
              if (shapes[i].c.k[j].e) {
                shapes[i].c.k[j].e[0] /= 255;
                shapes[i].c.k[j].e[1] /= 255;
                shapes[i].c.k[j].e[2] /= 255;
                shapes[i].c.k[j].e[3] /= 255;
              }
            }
          } else {
            shapes[i].c.k[0] /= 255;
            shapes[i].c.k[1] /= 255;
            shapes[i].c.k[2] /= 255;
            shapes[i].c.k[3] /= 255;
          }
        }
      }
    }

    function iterateLayers(layers) {
      var i;
      var len = layers.length;
      for (i = 0; i < len; i += 1) {
        if (layers[i].ty === 4) {
          iterateShapes(layers[i].shapes);
        }
      }
    }

    return function (animationData) {
      if (checkVersion(minimumVersion, animationData.v)) {
        iterateLayers(animationData.layers);
        if (animationData.assets) {
          var i;
          var len = animationData.assets.length;
          for (i = 0; i < len; i += 1) {
            if (animationData.assets[i].layers) {
              iterateLayers(animationData.assets[i].layers);
            }
          }
        }
      }
    };
  }());

  var checkShapes = (function () {
    var minimumVersion = [4, 4, 18];

    function completeClosingShapes(arr) {
      var i;
      var len = arr.length;
      var j;
      var jLen;
      for (i = len - 1; i >= 0; i -= 1) {
        if (arr[i].ty === 'sh') {
          if (arr[i].ks.k.i) {
            arr[i].ks.k.c = arr[i].closed;
          } else {
            jLen = arr[i].ks.k.length;
            for (j = 0; j < jLen; j += 1) {
              if (arr[i].ks.k[j].s) {
                arr[i].ks.k[j].s[0].c = arr[i].closed;
              }
              if (arr[i].ks.k[j].e) {
                arr[i].ks.k[j].e[0].c = arr[i].closed;
              }
            }
          }
        } else if (arr[i].ty === 'gr') {
          completeClosingShapes(arr[i].it);
        }
      }
    }

    function iterateLayers(layers) {
      var layerData;
      var i;
      var len = layers.length;
      var j;
      var jLen;
      var k;
      var kLen;
      for (i = 0; i < len; i += 1) {
        layerData = layers[i];
        if (layerData.hasMask) {
          var maskProps = layerData.masksProperties;
          jLen = maskProps.length;
          for (j = 0; j < jLen; j += 1) {
            if (maskProps[j].pt.k.i) {
              maskProps[j].pt.k.c = maskProps[j].cl;
            } else {
              kLen = maskProps[j].pt.k.length;
              for (k = 0; k < kLen; k += 1) {
                if (maskProps[j].pt.k[k].s) {
                  maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                }
                if (maskProps[j].pt.k[k].e) {
                  maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                }
              }
            }
          }
        }
        if (layerData.ty === 4) {
          completeClosingShapes(layerData.shapes);
        }
      }
    }

    return function (animationData) {
      if (checkVersion(minimumVersion, animationData.v)) {
        iterateLayers(animationData.layers);
        if (animationData.assets) {
          var i;
          var len = animationData.assets.length;
          for (i = 0; i < len; i += 1) {
            if (animationData.assets[i].layers) {
              iterateLayers(animationData.assets[i].layers);
            }
          }
        }
      }
    };
  }());

  function completeData(animationData, fontManager) {
    if (animationData.__complete) {
      return;
    }
    checkColors(animationData);
    checkText(animationData);
    checkChars(animationData);
    checkShapes(animationData);
    completeLayers(animationData.layers, animationData.assets, fontManager);
    animationData.__complete = true;
  }

  function completeText(data) {
    if (data.t.a.length === 0 && !('m' in data.t.p)) {
      data.singleShape = true;
    }
  }

  var moduleOb = {};
  moduleOb.completeData = completeData;
  moduleOb.checkColors = checkColors;
  moduleOb.checkChars = checkChars;
  moduleOb.checkShapes = checkShapes;
  moduleOb.completeLayers = completeLayers;

  return moduleOb;
}

var dataManager = dataFunctionManager();

/* exported getFontProperties */

function getFontProperties(fontData) {
  var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];

  var fWeight = 'normal'; var
    fStyle = 'normal';
  var len = styles.length;
  var styleName;
  for (var i = 0; i < len; i += 1) {
    styleName = styles[i].toLowerCase();
    switch (styleName) {
      case 'italic':
        fStyle = 'italic';
        break;
      case 'bold':
        fWeight = '700';
        break;
      case 'black':
        fWeight = '900';
        break;
      case 'medium':
        fWeight = '500';
        break;
      case 'regular':
      case 'normal':
        fWeight = '400';
        break;
      case 'light':
      case 'thin':
        fWeight = '200';
        break;
      default:
        break;
    }
  }

  return {
    style: fStyle,
    weight: fontData.fWeight || fWeight,
  };
}

/* global createNS, createTag, getFontProperties */
/* exported FontManager */

var FontManager = (function () {
  var maxWaitingTime = 5000;
  var emptyChar = {
    w: 0,
    size: 0,
    shapes: [],
  };
  var combinedCharacters = [];
  // Hindi characters
  combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366,
    2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379,
    2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);

  function trimFontOptions(font) {
    var familyArray = font.split(',');
    var i;
    var len = familyArray.length;
    var enabledFamilies = [];
    for (i = 0; i < len; i += 1) {
      if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
        enabledFamilies.push(familyArray[i]);
      }
    }
    return enabledFamilies.join(',');
  }

  function setUpNode(font, family) {
    var parentNode = createTag('span');
    parentNode.style.fontFamily = family;
    var node = createTag('span');
    // Characters that vary significantly among different fonts
    node.innerText = 'giItT1WQy@!-/#';
    // Visible - so we can measure it - but not on the screen
    parentNode.style.position = 'absolute';
    parentNode.style.left = '-10000px';
    parentNode.style.top = '-10000px';
    // Large font size makes even subtle changes obvious
    parentNode.style.fontSize = '300px';
    // Reset any font properties
    parentNode.style.fontVariant = 'normal';
    parentNode.style.fontStyle = 'normal';
    parentNode.style.fontWeight = 'normal';
    parentNode.style.letterSpacing = '0';
    parentNode.appendChild(node);
    document.body.appendChild(parentNode);

    // Remember width with no applied web font
    var width = node.offsetWidth;
    node.style.fontFamily = trimFontOptions(font) + ', ' + family;
    return { node: node, w: width, parent: parentNode };
  }

  function checkLoadedFonts() {
    var i;
    var len = this.fonts.length;
    var node;
    var w;
    var loadedCount = len;
    for (i = 0; i < len; i += 1) {
      if (this.fonts[i].loaded) {
        loadedCount -= 1;
      } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
        this.fonts[i].loaded = true;
      } else {
        node = this.fonts[i].monoCase.node;
        w = this.fonts[i].monoCase.w;
        if (node.offsetWidth !== w) {
          loadedCount -= 1;
          this.fonts[i].loaded = true;
        } else {
          node = this.fonts[i].sansCase.node;
          w = this.fonts[i].sansCase.w;
          if (node.offsetWidth !== w) {
            loadedCount -= 1;
            this.fonts[i].loaded = true;
          }
        }
        if (this.fonts[i].loaded) {
          this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
          this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
        }
      }
    }

    if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
      setTimeout(this.checkLoadedFontsBinded, 20);
    } else {
      setTimeout(this.setIsLoadedBinded, 10);
    }
  }

  function createHelper(def, fontData) {
    var tHelper = createNS('text');
    tHelper.style.fontSize = '100px';
    // tHelper.style.fontFamily = fontData.fFamily;

    var fontProps = getFontProperties(fontData);
    tHelper.setAttribute('font-family', fontData.fFamily);
    tHelper.setAttribute('font-style', fontProps.style);
    tHelper.setAttribute('font-weight', fontProps.weight);
    tHelper.textContent = '1';
    if (fontData.fClass) {
      tHelper.style.fontFamily = 'inherit';
      tHelper.setAttribute('class', fontData.fClass);
    } else {
      tHelper.style.fontFamily = fontData.fFamily;
    }
    def.appendChild(tHelper);
    var tCanvasHelper = createTag('canvas').getContext('2d');
    tCanvasHelper.font = fontData.fWeight + ' ' + fontData.fStyle + ' 100px ' + fontData.fFamily;
    // tCanvasHelper.font = ' 100px '+ fontData.fFamily;
    return tHelper;
  }

  function addFonts(fontData, defs) {
    if (!fontData) {
      this.isLoaded = true;
      return;
    }
    if (this.chars) {
      this.isLoaded = true;
      this.fonts = fontData.list;
      return;
    }

    var fontArr = fontData.list;
    var i;
    var len = fontArr.length;
    var _pendingFonts = len;
    for (i = 0; i < len; i += 1) {
      var shouldLoadFont = true;
      var loadedSelector;
      var j;
      fontArr[i].loaded = false;
      fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
      fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
      if (!fontArr[i].fPath) {
        fontArr[i].loaded = true;
        _pendingFonts -= 1;
      } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
        loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

        if (loadedSelector.length > 0) {
          shouldLoadFont = false;
        }

        if (shouldLoadFont) {
          var s = createTag('style');
          s.setAttribute('f-forigin', fontArr[i].fOrigin);
          s.setAttribute('f-origin', fontArr[i].origin);
          s.setAttribute('f-family', fontArr[i].fFamily);
          s.type = 'text/css';
          s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
          defs.appendChild(s);
        }
      } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
        loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

        for (j = 0; j < loadedSelector.length; j += 1) {
          if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
            // Font is already loaded
            shouldLoadFont = false;
          }
        }

        if (shouldLoadFont) {
          var l = createTag('link');
          l.setAttribute('f-forigin', fontArr[i].fOrigin);
          l.setAttribute('f-origin', fontArr[i].origin);
          l.type = 'text/css';
          l.rel = 'stylesheet';
          l.href = fontArr[i].fPath;
          document.body.appendChild(l);
        }
      } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
        loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

        for (j = 0; j < loadedSelector.length; j += 1) {
          if (fontArr[i].fPath === loadedSelector[j].src) {
            // Font is already loaded
            shouldLoadFont = false;
          }
        }

        if (shouldLoadFont) {
          var sc = createTag('link');
          sc.setAttribute('f-forigin', fontArr[i].fOrigin);
          sc.setAttribute('f-origin', fontArr[i].origin);
          sc.setAttribute('rel', 'stylesheet');
          sc.setAttribute('href', fontArr[i].fPath);
          defs.appendChild(sc);
        }
      }
      fontArr[i].helper = createHelper(defs, fontArr[i]);
      fontArr[i].cache = {};
      this.fonts.push(fontArr[i]);
    }
    if (_pendingFonts === 0) {
      this.isLoaded = true;
    } else {
      // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
      // Adding this timeout seems to fix it
      setTimeout(this.checkLoadedFonts.bind(this), 100);
    }
  }

  function addChars(chars) {
    if (!chars) {
      return;
    }
    if (!this.chars) {
      this.chars = [];
    }
    var i;
    var len = chars.length;
    var j;
    var jLen = this.chars.length;
    var found;
    for (i = 0; i < len; i += 1) {
      j = 0;
      found = false;
      while (j < jLen) {
        if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
          found = true;
        }
        j += 1;
      }
      if (!found) {
        this.chars.push(chars[i]);
        jLen += 1;
      }
    }
  }

  function getCharData(char, style, font) {
    var i = 0;
    var len = this.chars.length;
    while (i < len) {
      if (this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font) {
        return this.chars[i];
      }
      i += 1;
    }
    if (((typeof char === 'string' && char.charCodeAt(0) !== 13) || !char)
            && console
            && console.warn // eslint-disable-line no-console
            && !this._warned
    ) {
      this._warned = true;
      console.warn('Missing character from exported characters list: ', char, style, font); // eslint-disable-line no-console
    }
    return emptyChar;
  }

  function measureText(char, fontName, size) {
    var fontData = this.getFontByName(fontName);
    var index = char.charCodeAt(0);
    if (!fontData.cache[index + 1]) {
      var tHelper = fontData.helper;
      // Canvas version
      // fontData.cache[index] = tHelper.measureText(char).width / 100;
      // SVG version
      // console.log(tHelper.getBBox().width)
      if (char === ' ') {
        tHelper.textContent = '|' + char + '|';
        var doubleSize = tHelper.getComputedTextLength();
        tHelper.textContent = '||';
        var singleSize = tHelper.getComputedTextLength();
        fontData.cache[index + 1] = (doubleSize - singleSize) / 100;
      } else {
        tHelper.textContent = char;
        fontData.cache[index + 1] = (tHelper.getComputedTextLength()) / 100;
      }
    }
    return fontData.cache[index + 1] * size;
  }

  function getFontByName(name) {
    var i = 0;
    var len = this.fonts.length;
    while (i < len) {
      if (this.fonts[i].fName === name) {
        return this.fonts[i];
      }
      i += 1;
    }
    return this.fonts[0];
  }

  function getCombinedCharacterCodes() {
    return combinedCharacters;
  }

  function setIsLoaded() {
    this.isLoaded = true;
  }

  var Font = function () {
    this.fonts = [];
    this.chars = null;
    this.typekitLoaded = 0;
    this.isLoaded = false;
    this._warned = false;
    this.initTime = Date.now();
    this.setIsLoadedBinded = this.setIsLoaded.bind(this);
    this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
  };
    // TODO: for now I'm adding these methods to the Class and not the prototype. Think of a better way to implement it.
  Font.getCombinedCharacterCodes = getCombinedCharacterCodes;

  var fontPrototype = {
    addChars: addChars,
    addFonts: addFonts,
    getCharData: getCharData,
    getFontByName: getFontByName,
    measureText: measureText,
    checkLoadedFonts: checkLoadedFonts,
    setIsLoaded: setIsLoaded,
  };

  Font.prototype = fontPrototype;

  return Font;
}());

/* global initialDefaultFrame, BezierFactory, degToRads, bez, createTypedArray */
/* exported PropertyFactory */

var PropertyFactory = (function () {
  var initFrame = initialDefaultFrame;
  var mathAbs = Math.abs;

  function interpolateValue(frameNum, caching) {
    var offsetTime = this.offsetTime;
    var newValue;
    if (this.propType === 'multidimensional') {
      newValue = createTypedArray('float32', this.pv.length);
    }
    var iterationIndex = caching.lastIndex;
    var i = iterationIndex;
    var len = this.keyframes.length - 1;
    var flag = true;
    var keyData;
    var nextKeyData;

    while (flag) {
      keyData = this.keyframes[i];
      nextKeyData = this.keyframes[i + 1];
      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
        if (keyData.h) {
          keyData = nextKeyData;
        }
        iterationIndex = 0;
        break;
      }
      if ((nextKeyData.t - offsetTime) > frameNum) {
        iterationIndex = i;
        break;
      }
      if (i < len - 1) {
        i += 1;
      } else {
        iterationIndex = 0;
        flag = false;
      }
    }

    var k;
    var kLen;
    var perc;
    var jLen;
    var j;
    var fnc;
    var nextKeyTime = nextKeyData.t - offsetTime;
    var keyTime = keyData.t - offsetTime;
    var endValue;
    if (keyData.to) {
      if (!keyData.bezierData) {
        keyData.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
      }
      var bezierData = keyData.bezierData;
      if (frameNum >= nextKeyTime || frameNum < keyTime) {
        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
        kLen = bezierData.points[ind].point.length;
        for (k = 0; k < kLen; k += 1) {
          newValue[k] = bezierData.points[ind].point[k];
        }
        // caching._lastKeyframeIndex = -1;
      } else {
        if (keyData.__fnct) {
          fnc = keyData.__fnct;
        } else {
          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
          keyData.__fnct = fnc;
        }
        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
        var distanceInLine = bezierData.segmentLength * perc;

        var segmentPerc;
        var addedLength = (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastAddedLength : 0;
        j = (caching.lastFrame < frameNum && caching._lastKeyframeIndex === i) ? caching._lastPoint : 0;
        flag = true;
        jLen = bezierData.points.length;
        while (flag) {
          addedLength += bezierData.points[j].partialLength;
          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k];
            }
            break;
          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
            kLen = bezierData.points[j].point.length;
            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
            }
            break;
          }
          if (j < jLen - 1) {
            j += 1;
          } else {
            flag = false;
          }
        }
        caching._lastPoint = j;
        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
        caching._lastKeyframeIndex = i;
      }
    } else {
      var outX;
      var outY;
      var inX;
      var inY;
      var keyValue;
      len = keyData.s.length;
      endValue = nextKeyData.s || keyData.e;
      if (this.sh && keyData.h !== 1) {
        if (frameNum >= nextKeyTime) {
          newValue[0] = endValue[0];
          newValue[1] = endValue[1];
          newValue[2] = endValue[2];
        } else if (frameNum <= keyTime) {
          newValue[0] = keyData.s[0];
          newValue[1] = keyData.s[1];
          newValue[2] = keyData.s[2];
        } else {
          var quatStart = createQuaternion(keyData.s);
          var quatEnd = createQuaternion(endValue);
          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
        }
      } else {
        for (i = 0; i < len; i += 1) {
          if (keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
              perc = 1;
            } else if (frameNum < keyTime) {
              perc = 0;
            } else {
              if (keyData.o.x.constructor === Array) {
                if (!keyData.__fnct) {
                  keyData.__fnct = [];
                }
                if (!keyData.__fnct[i]) {
                  outX = (typeof keyData.o.x[i] === 'undefined') ? keyData.o.x[0] : keyData.o.x[i];
                  outY = (typeof keyData.o.y[i] === 'undefined') ? keyData.o.y[0] : keyData.o.y[i];
                  inX = (typeof keyData.i.x[i] === 'undefined') ? keyData.i.x[0] : keyData.i.x[i];
                  inY = (typeof keyData.i.y[i] === 'undefined') ? keyData.i.y[0] : keyData.i.y[i];
                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                  keyData.__fnct[i] = fnc;
                } else {
                  fnc = keyData.__fnct[i];
                }
              } else if (!keyData.__fnct) {
                outX = keyData.o.x;
                outY = keyData.o.y;
                inX = keyData.i.x;
                inY = keyData.i.y;
                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                keyData.__fnct = fnc;
              } else {
                fnc = keyData.__fnct;
              }
              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            }
          }

          endValue = nextKeyData.s || keyData.e;
          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

          if (this.propType === 'multidimensional') {
            newValue[i] = keyValue;
          } else {
            newValue = keyValue;
          }
        }
      }
    }
    caching.lastIndex = iterationIndex;
    return newValue;
  }

  // based on @Toji's https://github.com/toji/gl-matrix/
  function slerp(a, b, t) {
    var out = [];
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    var bx = b[0];
    var by = b[1];
    var bz = b[2];
    var bw = b[3];

    var omega;
    var cosom;
    var sinom;
    var scale0;
    var scale1;

    cosom = ax * bx + ay * by + az * bz + aw * bw;
    if (cosom < 0.0) {
      cosom = -cosom;
      bx = -bx;
      by = -by;
      bz = -bz;
      bw = -bw;
    }
    if ((1.0 - cosom) > 0.000001) {
      omega = Math.acos(cosom);
      sinom = Math.sin(omega);
      scale0 = Math.sin((1.0 - t) * omega) / sinom;
      scale1 = Math.sin(t * omega) / sinom;
    } else {
      scale0 = 1.0 - t;
      scale1 = t;
    }
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;

    return out;
  }

  function quaternionToEuler(out, quat) {
    var qx = quat[0];
    var qy = quat[1];
    var qz = quat[2];
    var qw = quat[3];
    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
    out[0] = heading / degToRads;
    out[1] = attitude / degToRads;
    out[2] = bank / degToRads;
  }

  function createQuaternion(values) {
    var heading = values[0] * degToRads;
    var attitude = values[1] * degToRads;
    var bank = values[2] * degToRads;
    var c1 = Math.cos(heading / 2);
    var c2 = Math.cos(attitude / 2);
    var c3 = Math.cos(bank / 2);
    var s1 = Math.sin(heading / 2);
    var s2 = Math.sin(attitude / 2);
    var s3 = Math.sin(bank / 2);
    var w = c1 * c2 * c3 - s1 * s2 * s3;
    var x = s1 * s2 * c3 + c1 * c2 * s3;
    var y = s1 * c2 * c3 + c1 * s2 * s3;
    var z = c1 * s2 * c3 - s1 * c2 * s3;

    return [x, y, z, w];
  }

  function getValueAtCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    if (!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))) {
      if (this._caching.lastFrame >= frameNum) {
        this._caching._lastKeyframeIndex = -1;
        this._caching.lastIndex = 0;
      }

      var renderResult = this.interpolateValue(frameNum, this._caching);
      this.pv = renderResult;
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function setVValue(val) {
    var multipliedValue;
    if (this.propType === 'unidimensional') {
      multipliedValue = val * this.mult;
      if (mathAbs(this.v - multipliedValue) > 0.00001) {
        this.v = multipliedValue;
        this._mdf = true;
      }
    } else {
      var i = 0;
      var len = this.v.length;
      while (i < len) {
        multipliedValue = val[i] * this.mult;
        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
          this.v[i] = multipliedValue;
          this._mdf = true;
        }
        i += 1;
      }
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = this._isFirstFrame;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = this.kf ? this.pv : this.data.k;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this._isFirstFrame = false;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  function ValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.mult = mult || 1;
    this.data = data;
    this.v = mult ? data.k * mult : data.k;
    this.pv = data.k;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.vel = 0;
    this.effectsSequence = [];
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function MultiDimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    this.mult = mult || 1;
    this.data = data;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.frameId = -1;
    var i;
    var len = data.k.length;
    this.v = createTypedArray('float32', len);
    this.pv = createTypedArray('float32', len);
    this.vel = createTypedArray('float32', len);
    for (i = 0; i < len; i += 1) {
      this.v[i] = data.k[i] * this.mult;
      this.pv[i] = data.k[i];
    }
    this._isFirstFrame = true;
    this.effectsSequence = [];
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function KeyframedValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.keyframes = data.k;
    this.offsetTime = elem.data.st;
    this.frameId = -1;
    this._caching = {
      lastFrame: initFrame, lastIndex: 0, value: 0, _lastKeyframeIndex: -1,
    };
    this.k = true;
    this.kf = true;
    this.data = data;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.v = initFrame;
    this.pv = initFrame;
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.addEffect = addEffect;
  }

  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    var i;
    var len = data.k.length;
    var s;
    var e;
    var to;
    var ti;
    for (i = 0; i < len - 1; i += 1) {
      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
        s = data.k[i].s;
        e = data.k[i + 1].s;
        to = data.k[i].to;
        ti = data.k[i].ti;
        if ((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2]))) {
          data.k[i].to = null;
          data.k[i].ti = null;
        }
        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
          if (s.length === 2 || (s[2] === e[2] && to[2] === 0 && ti[2] === 0)) {
            data.k[i].to = null;
            data.k[i].ti = null;
          }
        }
      }
    }
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.data = data;
    this.keyframes = data.k;
    this.offsetTime = elem.data.st;
    this.k = true;
    this.kf = true;
    this._isFirstFrame = true;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.frameId = -1;
    var arrLen = data.k[0].s.length;
    this.v = createTypedArray('float32', arrLen);
    this.pv = createTypedArray('float32', arrLen);
    for (i = 0; i < arrLen; i += 1) {
      this.v[i] = initFrame;
      this.pv[i] = initFrame;
    }
    this._caching = { lastFrame: initFrame, lastIndex: 0, value: createTypedArray('float32', arrLen) };
    this.addEffect = addEffect;
  }

  function getProp(elem, data, type, mult, container) {
    var p;
    if (!data.k.length) {
      p = new ValueProperty(elem, data, mult, container);
    } else if (typeof (data.k[0]) === 'number') {
      p = new MultiDimensionalProperty(elem, data, mult, container);
    } else {
      switch (type) {
        case 0:
          p = new KeyframedValueProperty(elem, data, mult, container);
          break;
        case 1:
          p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
          break;
        default:
          break;
      }
    }
    if (p.effectsSequence.length) {
      container.addDynamicProperty(p);
    }
    return p;
  }

  var ob = {
    getProp: getProp,
  };
  return ob;
}());

/* global Matrix, degToRads, PropertyFactory, extendPrototype, DynamicPropertyContainer */
/* exported TransformPropertyFactory */

var TransformPropertyFactory = (function () {
  var defaultVector = [0, 0];

  function applyToMatrix(mat) {
    var _mdf = this._mdf;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || _mdf;
    if (this.a) {
      mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
    }
    if (this.s) {
      mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
    }
    if (this.sk) {
      mat.skewFromAxis(-this.sk.v, this.sa.v);
    }
    if (this.r) {
      mat.rotate(-this.r.v);
    } else {
      mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
        .rotateY(this.or.v[1])
        .rotateX(this.or.v[0]);
    }
    if (this.data.p.s) {
      if (this.data.p.z) {
        mat.translate(this.px.v, this.py.v, -this.pz.v);
      } else {
        mat.translate(this.px.v, this.py.v, 0);
      }
    } else {
      mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
    }
  }
  function processKeys(forceRender) {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    }
    if (this._isDirty) {
      this.precalculateMatrix();
      this._isDirty = false;
    }

    this.iterateDynamicProperties();

    if (this._mdf || forceRender) {
      var frameRate;
      this.v.cloneFromProps(this.pre.props);
      if (this.appliedTransformations < 1) {
        this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      }
      if (this.appliedTransformations < 2) {
        this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      }
      if (this.sk && this.appliedTransformations < 3) {
        this.v.skewFromAxis(-this.sk.v, this.sa.v);
      }
      if (this.r && this.appliedTransformations < 4) {
        this.v.rotate(-this.r.v);
      } else if (!this.r && this.appliedTransformations < 4) {
        this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
          .rotateY(this.or.v[1])
          .rotateX(this.or.v[0]);
      }
      if (this.autoOriented) {
        var v1;
        var v2;
        frameRate = this.elem.globalData.frameRate;
        if (this.p && this.p.keyframes && this.p.getValueAtTime) {
          if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
          } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
            v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / frameRate), 0);
            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
          } else {
            v1 = this.p.pv;
            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
          }
        } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
          v1 = [];
          v2 = [];
          var px = this.px;
          var py = this.py;
          if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
            v2[0] = px.getValueAtTime((px.keyframes[0].t) / frameRate, 0);
            v2[1] = py.getValueAtTime((py.keyframes[0].t) / frameRate, 0);
          } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
            v1[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t / frameRate), 0);
            v1[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t / frameRate), 0);
            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
          } else {
            v1 = [px.pv, py.pv];
            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
          }
        } else {
          v2 = defaultVector;
          v1 = v2;
        }
        this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
      }
      if (this.data.p && this.data.p.s) {
        if (this.data.p.z) {
          this.v.translate(this.px.v, this.py.v, -this.pz.v);
        } else {
          this.v.translate(this.px.v, this.py.v, 0);
        }
      } else {
        this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
    }
    this.frameId = this.elem.globalData.frameId;
  }

  function precalculateMatrix() {
    if (!this.a.k) {
      this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      this.appliedTransformations = 1;
    } else {
      return;
    }
    if (!this.s.effectsSequence.length) {
      this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      this.appliedTransformations = 2;
    } else {
      return;
    }
    if (this.sk) {
      if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
        this.pre.skewFromAxis(-this.sk.v, this.sa.v);
        this.appliedTransformations = 3;
      } else {
        return;
      }
    }
    if (this.r) {
      if (!this.r.effectsSequence.length) {
        this.pre.rotate(-this.r.v);
        this.appliedTransformations = 4;
      }
    } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
      this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2])
        .rotateY(this.or.v[1])
        .rotateX(this.or.v[0]);
      this.appliedTransformations = 4;
    }
  }

  function autoOrient() {
    //
    // var prevP = this.getValueAtTime();
  }

  function addDynamicProperty(prop) {
    this._addDynamicProperty(prop);
    this.elem.addDynamicProperty(prop);
    this._isDirty = true;
  }

  function TransformProperty(elem, data, container) {
    this.elem = elem;
    this.frameId = -1;
    this.propType = 'transform';
    this.data = data;
    this.v = new Matrix();
    // Precalculated matrix with non animated properties
    this.pre = new Matrix();
    this.appliedTransformations = 0;
    this.initDynamicPropertyContainer(container || elem);
    if (data.p && data.p.s) {
      this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
      this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
      if (data.p.z) {
        this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
      }
    } else {
      this.p = PropertyFactory.getProp(elem, data.p || { k: [0, 0, 0] }, 1, 0, this);
    }
    if (data.rx) {
      this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
      this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
      this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
      if (data.or.k[0].ti) {
        var i;
        var len = data.or.k.length;
        for (i = 0; i < len; i += 1) {
          data.or.k[i].to = null;
          data.or.k[i].ti = null;
        }
      }
      this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
      // sh Indicates it needs to be capped between -180 and 180
      this.or.sh = true;
    } else {
      this.r = PropertyFactory.getProp(elem, data.r || { k: 0 }, 0, degToRads, this);
    }
    if (data.sk) {
      this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
      this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
    }
    this.a = PropertyFactory.getProp(elem, data.a || { k: [0, 0, 0] }, 1, 0, this);
    this.s = PropertyFactory.getProp(elem, data.s || { k: [100, 100, 100] }, 1, 0.01, this);
    // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
    if (data.o) {
      this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
    } else {
      this.o = { _mdf: false, v: 1 };
    }
    this._isDirty = true;
    if (!this.dynamicProperties.length) {
      this.getValue(true);
    }
  }

  TransformProperty.prototype = {
    applyToMatrix: applyToMatrix,
    getValue: processKeys,
    precalculateMatrix: precalculateMatrix,
    autoOrient: autoOrient,
  };

  extendPrototype([DynamicPropertyContainer], TransformProperty);
  TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
  TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

  function getTransformProperty(elem, data, container) {
    return new TransformProperty(elem, data, container);
  }

  return {
    getTransformProperty: getTransformProperty,
  };
}());

/* global createSizedArray, createSizedArray, pointPool */

function ShapePath() {
  this.c = false;
  this._length = 0;
  this._maxLength = 8;
  this.v = createSizedArray(this._maxLength);
  this.o = createSizedArray(this._maxLength);
  this.i = createSizedArray(this._maxLength);
}

ShapePath.prototype.setPathData = function (closed, len) {
  this.c = closed;
  this.setLength(len);
  var i = 0;
  while (i < len) {
    this.v[i] = pointPool.newElement();
    this.o[i] = pointPool.newElement();
    this.i[i] = pointPool.newElement();
    i += 1;
  }
};

ShapePath.prototype.setLength = function (len) {
  while (this._maxLength < len) {
    this.doubleArrayLength();
  }
  this._length = len;
};

ShapePath.prototype.doubleArrayLength = function () {
  this.v = this.v.concat(createSizedArray(this._maxLength));
  this.i = this.i.concat(createSizedArray(this._maxLength));
  this.o = this.o.concat(createSizedArray(this._maxLength));
  this._maxLength *= 2;
};

ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
  var arr;
  this._length = Math.max(this._length, pos + 1);
  if (this._length >= this._maxLength) {
    this.doubleArrayLength();
  }
  switch (type) {
    case 'v':
      arr = this.v;
      break;
    case 'i':
      arr = this.i;
      break;
    case 'o':
      arr = this.o;
      break;
    default:
      arr = [];
      break;
  }
  if (!arr[pos] || (arr[pos] && !replace)) {
    arr[pos] = pointPool.newElement();
  }
  arr[pos][0] = x;
  arr[pos][1] = y;
};

ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
  this.setXYAt(vX, vY, 'v', pos, replace);
  this.setXYAt(oX, oY, 'o', pos, replace);
  this.setXYAt(iX, iY, 'i', pos, replace);
};

ShapePath.prototype.reverse = function () {
  var newPath = new ShapePath();
  newPath.setPathData(this.c, this._length);
  var vertices = this.v;
  var outPoints = this.o;
  var inPoints = this.i;
  var init = 0;
  if (this.c) {
    newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
    init = 1;
  }
  var cnt = this._length - 1;
  var len = this._length;

  var i;
  for (i = init; i < len; i += 1) {
    newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
    cnt -= 1;
  }
  return newPath;
};

/* global extendPrototype, roundCorner, BezierFactory, shapePool, degToRads,
  shapeCollectionPool, PropertyFactory, bmMin, DynamicPropertyContainer */
/* exported ShapePropertyFactory */

var ShapePropertyFactory = (function () {
  var initFrame = -999999;

  function interpolateShape(frameNum, previousValue, caching) {
    var iterationIndex = caching.lastIndex;
    var keyPropS;
    var keyPropE;
    var isHold;
    var j;
    var k;
    var jLen;
    var kLen;
    var perc;
    var vertexValue;
    var kf = this.keyframes;
    if (frameNum < kf[0].t - this.offsetTime) {
      keyPropS = kf[0].s[0];
      isHold = true;
      iterationIndex = 0;
    } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
      keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
      /* if(kf[kf.length - 1].s){
                keyPropS = kf[kf.length - 1].s[0];
            }else{
                keyPropS = kf[kf.length - 2].e[0];
            } */
      isHold = true;
    } else {
      var i = iterationIndex;
      var len = kf.length - 1;
      var flag = true;
      var keyData;
      var nextKeyData;
      while (flag) {
        keyData = kf[i];
        nextKeyData = kf[i + 1];
        if ((nextKeyData.t - this.offsetTime) > frameNum) {
          break;
        }
        if (i < len - 1) {
          i += 1;
        } else {
          flag = false;
        }
      }
      isHold = keyData.h === 1;
      iterationIndex = i;
      if (!isHold) {
        if (frameNum >= nextKeyData.t - this.offsetTime) {
          perc = 1;
        } else if (frameNum < keyData.t - this.offsetTime) {
          perc = 0;
        } else {
          var fnc;
          if (keyData.__fnct) {
            fnc = keyData.__fnct;
          } else {
            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
            keyData.__fnct = fnc;
          }
          perc = fnc((frameNum - (keyData.t - this.offsetTime)) / ((nextKeyData.t - this.offsetTime) - (keyData.t - this.offsetTime)));
        }
        keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
      }
      keyPropS = keyData.s[0];
    }
    jLen = previousValue._length;
    kLen = keyPropS.i[0].length;
    caching.lastIndex = iterationIndex;

    for (j = 0; j < jLen; j += 1) {
      for (k = 0; k < kLen; k += 1) {
        vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
        previousValue.i[j][k] = vertexValue;
        vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
        previousValue.o[j][k] = vertexValue;
        vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
        previousValue.v[j][k] = vertexValue;
      }
    }
  }

  function interpolateShapeCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    var lastFrame = this._caching.lastFrame;
    if (!(lastFrame !== initFrame && ((lastFrame < initTime && frameNum < initTime) || (lastFrame > endTime && frameNum > endTime)))) {
      /// /
      this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
      this.interpolateShape(frameNum, this.pv, this._caching);
      /// /
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function resetShape() {
    this.paths = this.localShapeCollection;
  }

  function shapesEqual(shape1, shape2) {
    if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
      return false;
    }
    var i;
    var len = shape1._length;
    for (i = 0; i < len; i += 1) {
      if (shape1.v[i][0] !== shape2.v[i][0]
            || shape1.v[i][1] !== shape2.v[i][1]
            || shape1.o[i][0] !== shape2.o[i][0]
            || shape1.o[i][1] !== shape2.o[i][1]
            || shape1.i[i][0] !== shape2.i[i][0]
            || shape1.i[i][1] !== shape2.i[i][1]) {
        return false;
      }
    }
    return true;
  }

  function setVValue(newPath) {
    if (!shapesEqual(this.v, newPath)) {
      this.v = shapePool.clone(newPath);
      this.localShapeCollection.releaseShapes();
      this.localShapeCollection.addShape(this.v);
      this._mdf = true;
      this.paths = this.localShapeCollection;
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    } if (!this.effectsSequence.length) {
      this._mdf = false;
      return;
    }
    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }
    this.lock = true;
    this._mdf = false;
    var finalValue;
    if (this.kf) {
      finalValue = this.pv;
    } else if (this.data.ks) {
      finalValue = this.data.ks.k;
    } else {
      finalValue = this.data.pt.k;
    }
    var i;
    var len = this.effectsSequence.length;
    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }
    this.setVValue(finalValue);
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function ShapeProperty(elem, data, type) {
    this.propType = 'shape';
    this.comp = elem.comp;
    this.container = elem;
    this.elem = elem;
    this.data = data;
    this.k = false;
    this.kf = false;
    this._mdf = false;
    var pathData = type === 3 ? data.pt.k : data.ks.k;
    this.v = shapePool.clone(pathData);
    this.pv = shapePool.clone(this.v);
    this.localShapeCollection = shapeCollectionPool.newShapeCollection();
    this.paths = this.localShapeCollection;
    this.paths.addShape(this.v);
    this.reset = resetShape;
    this.effectsSequence = [];
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  ShapeProperty.prototype.interpolateShape = interpolateShape;
  ShapeProperty.prototype.getValue = processEffectsSequence;
  ShapeProperty.prototype.setVValue = setVValue;
  ShapeProperty.prototype.addEffect = addEffect;

  function KeyframedShapeProperty(elem, data, type) {
    this.propType = 'shape';
    this.comp = elem.comp;
    this.elem = elem;
    this.container = elem;
    this.offsetTime = elem.data.st;
    this.keyframes = type === 3 ? data.pt.k : data.ks.k;
    this.k = true;
    this.kf = true;
    var len = this.keyframes[0].s[0].i.length;
    this.v = shapePool.newElement();
    this.v.setPathData(this.keyframes[0].s[0].c, len);
    this.pv = shapePool.clone(this.v);
    this.localShapeCollection = shapeCollectionPool.newShapeCollection();
    this.paths = this.localShapeCollection;
    this.paths.addShape(this.v);
    this.lastFrame = initFrame;
    this.reset = resetShape;
    this._caching = { lastFrame: initFrame, lastIndex: 0 };
    this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
  }
  KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
  KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
  KeyframedShapeProperty.prototype.setVValue = setVValue;
  KeyframedShapeProperty.prototype.addEffect = addEffect;

  var EllShapeProperty = (function () {
    var cPoint = roundCorner;

    function EllShapePropertyFactory(elem, data) {
      /* this.v = {
                v: createSizedArray(4),
                i: createSizedArray(4),
                o: createSizedArray(4),
                c: true
            }; */
      this.v = shapePool.newElement();
      this.v.setPathData(true, 4);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.localShapeCollection.addShape(this.v);
      this.d = data.d;
      this.elem = elem;
      this.comp = elem.comp;
      this.frameId = -1;
      this.initDynamicPropertyContainer(elem);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertEllToPath();
      }
    }

    EllShapePropertyFactory.prototype = {
      reset: resetShape,
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();

        if (this._mdf) {
          this.convertEllToPath();
        }
      },
      convertEllToPath: function () {
        var p0 = this.p.v[0];
        var p1 = this.p.v[1];
        var s0 = this.s.v[0] / 2;
        var s1 = this.s.v[1] / 2;
        var _cw = this.d !== 3;
        var _v = this.v;
        _v.v[0][0] = p0;
        _v.v[0][1] = p1 - s1;
        _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.v[1][1] = p1;
        _v.v[2][0] = p0;
        _v.v[2][1] = p1 + s1;
        _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.v[3][1] = p1;
        _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
        _v.i[0][1] = p1 - s1;
        _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.i[1][1] = p1 - s1 * cPoint;
        _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
        _v.i[2][1] = p1 + s1;
        _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.i[3][1] = p1 + s1 * cPoint;
        _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
        _v.o[0][1] = p1 - s1;
        _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
        _v.o[1][1] = p1 + s1 * cPoint;
        _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
        _v.o[2][1] = p1 + s1;
        _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
        _v.o[3][1] = p1 - s1 * cPoint;
      },
    };

    extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);

    return EllShapePropertyFactory;
  }());

  var StarShapeProperty = (function () {
    function StarShapePropertyFactory(elem, data) {
      this.v = shapePool.newElement();
      this.v.setPathData(true, 0);
      this.elem = elem;
      this.comp = elem.comp;
      this.data = data;
      this.frameId = -1;
      this.d = data.d;
      this.initDynamicPropertyContainer(elem);
      if (data.sy === 1) {
        this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
        this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
        this.convertToPath = this.convertStarToPath;
      } else {
        this.convertToPath = this.convertPolygonToPath;
      }
      this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
      this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
      this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.localShapeCollection.addShape(this.v);
      this.paths = this.localShapeCollection;
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertToPath();
      }
    }

    StarShapePropertyFactory.prototype = {
      reset: resetShape,
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        if (this._mdf) {
          this.convertToPath();
        }
      },
      convertStarToPath: function () {
        var numPts = Math.floor(this.pt.v) * 2;
        var angle = (Math.PI * 2) / numPts;
        /* this.v.v.length = numPts;
                this.v.i.length = numPts;
                this.v.o.length = numPts; */
        var longFlag = true;
        var longRad = this.or.v;
        var shortRad = this.ir.v;
        var longRound = this.os.v;
        var shortRound = this.is.v;
        var longPerimSegment = (2 * Math.PI * longRad) / (numPts * 2);
        var shortPerimSegment = (2 * Math.PI * shortRad) / (numPts * 2);
        var i;
        var rad;
        var roundness;
        var perimSegment;
        var currentAng = -Math.PI / 2;
        currentAng += this.r.v;
        var dir = this.data.d === 3 ? -1 : 1;
        this.v._length = 0;
        for (i = 0; i < numPts; i += 1) {
          rad = longFlag ? longRad : shortRad;
          roundness = longFlag ? longRound : shortRound;
          perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
          var x = rad * Math.cos(currentAng);
          var y = rad * Math.sin(currentAng);
          var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
          var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
          x += +this.p.v[0];
          y += +this.p.v[1];
          this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);

          /* this.v.v[i] = [x,y];
                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                    this.v._length = numPts; */
          longFlag = !longFlag;
          currentAng += angle * dir;
        }
      },
      convertPolygonToPath: function () {
        var numPts = Math.floor(this.pt.v);
        var angle = (Math.PI * 2) / numPts;
        var rad = this.or.v;
        var roundness = this.os.v;
        var perimSegment = (2 * Math.PI * rad) / (numPts * 4);
        var i;
        var currentAng = -Math.PI * 0.5;
        var dir = this.data.d === 3 ? -1 : 1;
        currentAng += this.r.v;
        this.v._length = 0;
        for (i = 0; i < numPts; i += 1) {
          var x = rad * Math.cos(currentAng);
          var y = rad * Math.sin(currentAng);
          var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
          var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
          x += +this.p.v[0];
          y += +this.p.v[1];
          this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
          currentAng += angle * dir;
        }
        this.paths.length = 0;
        this.paths[0] = this.v;
      },

    };
    extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);

    return StarShapePropertyFactory;
  }());

  var RectShapeProperty = (function () {
    function RectShapePropertyFactory(elem, data) {
      this.v = shapePool.newElement();
      this.v.c = true;
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.localShapeCollection.addShape(this.v);
      this.paths = this.localShapeCollection;
      this.elem = elem;
      this.comp = elem.comp;
      this.frameId = -1;
      this.d = data.d;
      this.initDynamicPropertyContainer(elem);
      this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
      this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
      if (this.dynamicProperties.length) {
        this.k = true;
      } else {
        this.k = false;
        this.convertRectToPath();
      }
    }

    RectShapePropertyFactory.prototype = {
      convertRectToPath: function () {
        var p0 = this.p.v[0];
        var p1 = this.p.v[1];
        var v0 = this.s.v[0] / 2;
        var v1 = this.s.v[1] / 2;
        var round = bmMin(v0, v1, this.r.v);
        var cPoint = round * (1 - roundCorner);
        this.v._length = 0;

        if (this.d === 2 || this.d === 1) {
          this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
          this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
          if (round !== 0) {
            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
          } else {
            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
          }
        } else {
          this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
          if (round !== 0) {
            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
          } else {
            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
          }
        }
      },
      getValue: function () {
        if (this.elem.globalData.frameId === this.frameId) {
          return;
        }
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        if (this._mdf) {
          this.convertRectToPath();
        }
      },
      reset: resetShape,
    };
    extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);

    return RectShapePropertyFactory;
  }());

  function getShapeProp(elem, data, type) {
    var prop;
    if (type === 3 || type === 4) {
      var dataProp = type === 3 ? data.pt : data.ks;
      var keys = dataProp.k;
      if (keys.length) {
        prop = new KeyframedShapeProperty(elem, data, type);
      } else {
        prop = new ShapeProperty(elem, data, type);
      }
    } else if (type === 5) {
      prop = new RectShapeProperty(elem, data);
    } else if (type === 6) {
      prop = new EllShapeProperty(elem, data);
    } else if (type === 7) {
      prop = new StarShapeProperty(elem, data);
    }
    if (prop.k) {
      elem.addDynamicProperty(prop);
    }
    return prop;
  }

  function getConstructorFunction() {
    return ShapeProperty;
  }

  function getKeyframedConstructorFunction() {
    return KeyframedShapeProperty;
  }

  var ob = {};
  ob.getShapeProp = getShapeProp;
  ob.getConstructorFunction = getConstructorFunction;
  ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
  return ob;
}());

/* global shapeCollectionPool, initialDefaultFrame, extendPrototype, DynamicPropertyContainer */
/* exported ShapeModifiers */

var ShapeModifiers = (function () {
  var ob = {};
  var modifiers = {};
  ob.registerModifier = registerModifier;
  ob.getModifier = getModifier;

  function registerModifier(nm, factory) {
    if (!modifiers[nm]) {
      modifiers[nm] = factory;
    }
  }

  function getModifier(nm, elem, data) {
    return new modifiers[nm](elem, data);
  }

  return ob;
}());

function ShapeModifier() {}
ShapeModifier.prototype.initModifierProperties = function () {};
ShapeModifier.prototype.addShapeToModifier = function () {};
ShapeModifier.prototype.addShape = function (data) {
  if (!this.closed) {
    // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
    data.sh.container.addDynamicProperty(data.sh);
    var shapeData = { shape: data.sh, data: data, localShapeCollection: shapeCollectionPool.newShapeCollection() };
    this.shapes.push(shapeData);
    this.addShapeToModifier(shapeData);
    if (this._isAnimated) {
      data.setAsAnimated();
    }
  }
};
ShapeModifier.prototype.init = function (elem, data) {
  this.shapes = [];
  this.elem = elem;
  this.initDynamicPropertyContainer(elem);
  this.initModifierProperties(elem, data);
  this.frameId = initialDefaultFrame;
  this.closed = false;
  this.k = false;
  if (this.dynamicProperties.length) {
    this.k = true;
  } else {
    this.getValue(true);
  }
};
ShapeModifier.prototype.processKeys = function () {
  if (this.elem.globalData.frameId === this.frameId) {
    return;
  }
  this.frameId = this.elem.globalData.frameId;
  this.iterateDynamicProperties();
};

extendPrototype([DynamicPropertyContainer], ShapeModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, segmentsLengthPool, bez, shapePool, ShapeModifiers */

function TrimModifier() {
}
extendPrototype([ShapeModifier], TrimModifier);
TrimModifier.prototype.initModifierProperties = function (elem, data) {
  this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
  this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
  this.sValue = 0;
  this.eValue = 0;
  this.getValue = this.processKeys;
  this.m = data.m;
  this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
};

TrimModifier.prototype.addShapeToModifier = function (shapeData) {
  shapeData.pathsData = [];
};

TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
  var segments = [];
  if (e <= 1) {
    segments.push({
      s: s,
      e: e,
    });
  } else if (s >= 1) {
    segments.push({
      s: s - 1,
      e: e - 1,
    });
  } else {
    segments.push({
      s: s,
      e: 1,
    });
    segments.push({
      s: 0,
      e: e - 1,
    });
  }
  var shapeSegments = [];
  var i;
  var len = segments.length;
  var segmentOb;
  for (i = 0; i < len; i += 1) {
    segmentOb = segments[i];
    if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
      var shapeS;
      var shapeE;
      if (segmentOb.s * totalModifierLength <= addedLength) {
        shapeS = 0;
      } else {
        shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
      }
      if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
        shapeE = 1;
      } else {
        shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
      }
      shapeSegments.push([shapeS, shapeE]);
    }
  }
  if (!shapeSegments.length) {
    shapeSegments.push([0, 0]);
  }
  return shapeSegments;
};

TrimModifier.prototype.releasePathsData = function (pathsData) {
  var i;
  var len = pathsData.length;
  for (i = 0; i < len; i += 1) {
    segmentsLengthPool.release(pathsData[i]);
  }
  pathsData.length = 0;
  return pathsData;
};

TrimModifier.prototype.processShapes = function (_isFirstFrame) {
  var s;
  var e;
  if (this._mdf || _isFirstFrame) {
    var o = (this.o.v % 360) / 360;
    if (o < 0) {
      o += 1;
    }
    if (this.s.v > 1) {
      s = 1 + o;
    } else if (this.s.v < 0) {
      s = 0 + o;
    } else {
      s = this.s.v + o;
    }
    if (this.e.v > 1) {
      e = 1 + o;
    } else if (this.e.v < 0) {
      e = 0 + o;
    } else {
      e = this.e.v + o;
    }

    if (s > e) {
      var _s = s;
      s = e;
      e = _s;
    }
    s = Math.round(s * 10000) * 0.0001;
    e = Math.round(e * 10000) * 0.0001;
    this.sValue = s;
    this.eValue = e;
  } else {
    s = this.sValue;
    e = this.eValue;
  }
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var pathsData;
  var pathData;
  var totalShapeLength;
  var totalModifierLength = 0;

  if (e === s) {
    for (i = 0; i < len; i += 1) {
      this.shapes[i].localShapeCollection.releaseShapes();
      this.shapes[i].shape._mdf = true;
      this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
      if (this._mdf) {
        this.shapes[i].pathsData.length = 0;
      }
    }
  } else if (!((e === 1 && s === 0) || (e === 0 && s === 1))) {
    var segments = [];
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
      if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
        shapeData.shape.paths = shapeData.localShapeCollection;
      } else {
        shapePaths = shapeData.shape.paths;
        jLen = shapePaths._length;
        totalShapeLength = 0;
        if (!shapeData.shape._mdf && shapeData.pathsData.length) {
          totalShapeLength = shapeData.totalShapeLength;
        } else {
          pathsData = this.releasePathsData(shapeData.pathsData);
          for (j = 0; j < jLen; j += 1) {
            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
            pathsData.push(pathData);
            totalShapeLength += pathData.totalLength;
          }
          shapeData.totalShapeLength = totalShapeLength;
          shapeData.pathsData = pathsData;
        }

        totalModifierLength += totalShapeLength;
        shapeData.shape._mdf = true;
      }
    }
    var shapeS = s;
    var shapeE = e;
    var addedLength = 0;
    var edges;
    for (i = len - 1; i >= 0; i -= 1) {
      shapeData = this.shapes[i];
      if (shapeData.shape._mdf) {
        localShapeCollection = shapeData.localShapeCollection;
        localShapeCollection.releaseShapes();
        // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
        if (this.m === 2 && len > 1) {
          edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
          addedLength += shapeData.totalShapeLength;
        } else {
          edges = [[shapeS, shapeE]];
        }
        jLen = edges.length;
        for (j = 0; j < jLen; j += 1) {
          shapeS = edges[j][0];
          shapeE = edges[j][1];
          segments.length = 0;
          if (shapeE <= 1) {
            segments.push({
              s: shapeData.totalShapeLength * shapeS,
              e: shapeData.totalShapeLength * shapeE,
            });
          } else if (shapeS >= 1) {
            segments.push({
              s: shapeData.totalShapeLength * (shapeS - 1),
              e: shapeData.totalShapeLength * (shapeE - 1),
            });
          } else {
            segments.push({
              s: shapeData.totalShapeLength * shapeS,
              e: shapeData.totalShapeLength,
            });
            segments.push({
              s: 0,
              e: shapeData.totalShapeLength * (shapeE - 1),
            });
          }
          var newShapesData = this.addShapes(shapeData, segments[0]);
          if (segments[0].s !== segments[0].e) {
            if (segments.length > 1) {
              var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
              if (lastShapeInCollection.c) {
                var lastShape = newShapesData.pop();
                this.addPaths(newShapesData, localShapeCollection);
                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
              } else {
                this.addPaths(newShapesData, localShapeCollection);
                newShapesData = this.addShapes(shapeData, segments[1]);
              }
            }
            this.addPaths(newShapesData, localShapeCollection);
          }
        }
        shapeData.shape.paths = localShapeCollection;
      }
    }
  } else if (this._mdf) {
    for (i = 0; i < len; i += 1) {
      // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
      // Don't remove this even if it's losing cached info.
      this.shapes[i].pathsData.length = 0;
      this.shapes[i].shape._mdf = true;
    }
  }
};

TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
  var i;
  var len = newPaths.length;
  for (i = 0; i < len; i += 1) {
    localShapeCollection.addShape(newPaths[i]);
  }
};

TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
  shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
  shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
  if (newShape) {
    shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
  }
  shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
};

TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
  shapePath.setXYAt(points[1], points[5], 'o', pos);
  shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
  if (newShape) {
    shapePath.setXYAt(points[0], points[4], 'v', pos);
  }
  shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
};

TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
  var pathsData = shapeData.pathsData;
  var shapePaths = shapeData.shape.paths.shapes;
  var i;
  var len = shapeData.shape.paths._length;
  var j;
  var jLen;
  var addedLength = 0;
  var currentLengthData;
  var segmentCount;
  var lengths;
  var segment;
  var shapes = [];
  var initPos;
  var newShape = true;
  if (!shapePath) {
    shapePath = shapePool.newElement();
    segmentCount = 0;
    initPos = 0;
  } else {
    segmentCount = shapePath._length;
    initPos = shapePath._length;
  }
  shapes.push(shapePath);
  for (i = 0; i < len; i += 1) {
    lengths = pathsData[i].lengths;
    shapePath.c = shapePaths[i].c;
    jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
    for (j = 1; j < jLen; j += 1) {
      currentLengthData = lengths[j - 1];
      if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
        addedLength += currentLengthData.addedLength;
        shapePath.c = false;
      } else if (addedLength > shapeSegment.e) {
        shapePath.c = false;
        break;
      } else {
        if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
          this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
          newShape = false;
        } else {
          segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
          this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
          // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
          newShape = false;
          shapePath.c = false;
        }
        addedLength += currentLengthData.addedLength;
        segmentCount += 1;
      }
    }
    if (shapePaths[i].c && lengths.length) {
      currentLengthData = lengths[j - 1];
      if (addedLength <= shapeSegment.e) {
        var segmentLength = lengths[j - 1].addedLength;
        if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
          this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
          newShape = false;
        } else {
          segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
          this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
          // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
          newShape = false;
          shapePath.c = false;
        }
      } else {
        shapePath.c = false;
      }
      addedLength += currentLengthData.addedLength;
      segmentCount += 1;
    }
    if (shapePath._length) {
      shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
      shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
    }
    if (addedLength > shapeSegment.e) {
      break;
    }
    if (i < len - 1) {
      shapePath = shapePool.newElement();
      newShape = true;
      shapes.push(shapePath);
      segmentCount = 0;
    }
  }
  return shapes;
};

ShapeModifiers.registerModifier('tm', TrimModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, shapePool, roundCorner, ShapeModifiers */

function RoundCornersModifier() {}
extendPrototype([ShapeModifier], RoundCornersModifier);
RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
  this._isAnimated = !!this.rd.effectsSequence.length;
};

RoundCornersModifier.prototype.processPath = function (path, round) {
  var clonedPath = shapePool.newElement();
  clonedPath.c = path.c;
  var i;
  var len = path._length;
  var currentV;
  var currentI;
  var currentO;
  var closerV;
  var distance;
  var newPosPerc;
  var index = 0;
  var vX;
  var vY;
  var oX;
  var oY;
  var iX;
  var iY;
  for (i = 0; i < len; i += 1) {
    currentV = path.v[i];
    currentO = path.o[i];
    currentI = path.i[i];
    if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
      if ((i === 0 || i === len - 1) && !path.c) {
        clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
        /* clonedPath.v[index] = currentV;
                clonedPath.o[index] = currentO;
                clonedPath.i[index] = currentI; */
        index += 1;
      } else {
        if (i === 0) {
          closerV = path.v[len - 1];
        } else {
          closerV = path.v[i - 1];
        }
        distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
        newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
        iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
        vX = iX;
        iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
        vY = iY;
        oX = vX - (vX - currentV[0]) * roundCorner;
        oY = vY - (vY - currentV[1]) * roundCorner;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
        index += 1;

        if (i === len - 1) {
          closerV = path.v[0];
        } else {
          closerV = path.v[i + 1];
        }
        distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
        newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
        oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
        vX = oX;
        oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
        vY = oY;
        iX = vX - (vX - currentV[0]) * roundCorner;
        iY = vY - (vY - currentV[1]) * roundCorner;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
        index += 1;
      }
    } else {
      clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
      index += 1;
    }
  }
  return clonedPath;
};

RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var rd = this.rd.v;

  if (rd !== 0) {
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      localShapeCollection = shapeData.localShapeCollection;
      if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
        localShapeCollection.releaseShapes();
        shapeData.shape._mdf = true;
        shapePaths = shapeData.shape.paths.shapes;
        jLen = shapeData.shape.paths._length;
        for (j = 0; j < jLen; j += 1) {
          localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
        }
      }
      shapeData.shape.paths = shapeData.localShapeCollection;
    }
  }
  if (!this.dynamicProperties.length) {
    this._mdf = false;
  }
};

ShapeModifiers.registerModifier('rd', RoundCornersModifier);

/* global extendPrototype, ShapeModifier, PropertyFactory, shapePool, ShapeModifiers */

function PuckerAndBloatModifier() {}
extendPrototype([ShapeModifier], PuckerAndBloatModifier);
PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
  this._isAnimated = !!this.amount.effectsSequence.length;
};

PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
  var percent = amount / 100;
  var centerPoint = [0, 0];
  var pathLength = path._length;
  var i = 0;
  for (i = 0; i < pathLength; i += 1) {
    centerPoint[0] += path.v[i][0];
    centerPoint[1] += path.v[i][1];
  }
  centerPoint[0] /= pathLength;
  centerPoint[1] /= pathLength;
  var clonedPath = shapePool.newElement();
  clonedPath.c = path.c;
  var vX;
  var vY;
  var oX;
  var oY;
  var iX;
  var iY;
  for (i = 0; i < pathLength; i += 1) {
    vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
    vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
    oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
    oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
    iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
    iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
  }
  return clonedPath;
};

PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
  var shapePaths;
  var i;
  var len = this.shapes.length;
  var j;
  var jLen;
  var amount = this.amount.v;

  if (amount !== 0) {
    var shapeData;
    var localShapeCollection;
    for (i = 0; i < len; i += 1) {
      shapeData = this.shapes[i];
      localShapeCollection = shapeData.localShapeCollection;
      if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
        localShapeCollection.releaseShapes();
        shapeData.shape._mdf = true;
        shapePaths = shapeData.shape.paths.shapes;
        jLen = shapeData.shape.paths._length;
        for (j = 0; j < jLen; j += 1) {
          localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
        }
      }
      shapeData.shape.paths = shapeData.localShapeCollection;
    }
  }
  if (!this.dynamicProperties.length) {
    this._mdf = false;
  }
};
ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);

/* global extendPrototype, ShapeModifier, TransformPropertyFactory, PropertyFactory, Matrix, ShapeModifiers */

function RepeaterModifier() {}
extendPrototype([ShapeModifier], RepeaterModifier);

RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
  this.getValue = this.processKeys;
  this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
  this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
  this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
  this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
  this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
  this.data = data;
  if (!this.dynamicProperties.length) {
    this.getValue(true);
  }
  this._isAnimated = !!this.dynamicProperties.length;
  this.pMatrix = new Matrix();
  this.rMatrix = new Matrix();
  this.sMatrix = new Matrix();
  this.tMatrix = new Matrix();
  this.matrix = new Matrix();
};

RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
  var dir = inv ? -1 : 1;
  var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
  var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
  pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
  rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
  rMatrix.rotate(-transform.r.v * dir * perc);
  rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
  sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
  sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
  sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
};

RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
  this.elem = elem;
  this.arr = arr;
  this.pos = pos;
  this.elemsData = elemsData;
  this._currentCopies = 0;
  this._elements = [];
  this._groups = [];
  this.frameId = -1;
  this.initDynamicPropertyContainer(elem);
  this.initModifierProperties(elem, arr[pos]);
  while (pos > 0) {
    pos -= 1;
    // this._elements.unshift(arr.splice(pos,1)[0]);
    this._elements.unshift(arr[pos]);
  }
  if (this.dynamicProperties.length) {
    this.k = true;
  } else {
    this.getValue(true);
  }
};

RepeaterModifier.prototype.resetElements = function (elements) {
  var i;
  var len = elements.length;
  for (i = 0; i < len; i += 1) {
    elements[i]._processed = false;
    if (elements[i].ty === 'gr') {
      this.resetElements(elements[i].it);
    }
  }
};

RepeaterModifier.prototype.cloneElements = function (elements) {
  var newElements = JSON.parse(JSON.stringify(elements));
  this.resetElements(newElements);
  return newElements;
};

RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
  var i;
  var len = elements.length;
  for (i = 0; i < len; i += 1) {
    elements[i]._render = renderFlag;
    if (elements[i].ty === 'gr') {
      this.changeGroupRender(elements[i].it, renderFlag);
    }
  }
};

RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
  var items;
  var itemsTransform;
  var i;
  var dir;
  var cont;
  if (this._mdf || _isFirstFrame) {
    var copies = Math.ceil(this.c.v);
    if (this._groups.length < copies) {
      while (this._groups.length < copies) {
        var group = {
          it: this.cloneElements(this._elements),
          ty: 'gr',
        };
        group.it.push({
          a: { a: 0, ix: 1, k: [0, 0] }, nm: 'Transform', o: { a: 0, ix: 7, k: 100 }, p: { a: 0, ix: 2, k: [0, 0] }, r: { a: 1, ix: 6, k: [{ s: 0, e: 0, t: 0 }, { s: 0, e: 0, t: 1 }] }, s: { a: 0, ix: 3, k: [100, 100] }, sa: { a: 0, ix: 5, k: 0 }, sk: { a: 0, ix: 4, k: 0 }, ty: 'tr',
        });

        this.arr.splice(0, 0, group);
        this._groups.splice(0, 0, group);
        this._currentCopies += 1;
      }
      this.elem.reloadShapes();
    }
    cont = 0;
    var renderFlag;
    for (i = 0; i <= this._groups.length - 1; i += 1) {
      renderFlag = cont < copies;
      this._groups[i]._render = renderFlag;
      this.changeGroupRender(this._groups[i].it, renderFlag);
      cont += 1;
    }

    this._currentCopies = copies;
    /// /

    var offset = this.o.v;
    var offsetModulo = offset % 1;
    var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    var pProps = this.pMatrix.props;
    var rProps = this.rMatrix.props;
    var sProps = this.sMatrix.props;
    this.pMatrix.reset();
    this.rMatrix.reset();
    this.sMatrix.reset();
    this.tMatrix.reset();
    this.matrix.reset();
    var iteration = 0;

    if (offset > 0) {
      while (iteration < roundOffset) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
        iteration += 1;
      }
      if (offsetModulo) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
        iteration += offsetModulo;
      }
    } else if (offset < 0) {
      while (iteration > roundOffset) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
        iteration -= 1;
      }
      if (offsetModulo) {
        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
        iteration -= offsetModulo;
      }
    }
    i = this.data.m === 1 ? 0 : this._currentCopies - 1;
    dir = this.data.m === 1 ? 1 : -1;
    cont = this._currentCopies;
    var j;
    var jLen;
    while (cont) {
      items = this.elemsData[i].it;
      itemsTransform = items[items.length - 1].transform.mProps.v.props;
      jLen = itemsTransform.length;
      items[items.length - 1].transform.mProps._mdf = true;
      items[items.length - 1].transform.op._mdf = true;
      items[items.length - 1].transform.op.v = this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
      if (iteration !== 0) {
        if ((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
        }
        this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
        this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
        this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

        for (j = 0; j < jLen; j += 1) {
          itemsTransform[j] = this.matrix.props[j];
        }
        this.matrix.reset();
      } else {
        this.matrix.reset();
        for (j = 0; j < jLen; j += 1) {
          itemsTransform[j] = this.matrix.props[j];
        }
      }
      iteration += 1;
      cont -= 1;
      i += dir;
    }
  } else {
    cont = this._currentCopies;
    i = 0;
    dir = 1;
    while (cont) {
      items = this.elemsData[i].it;
      itemsTransform = items[items.length - 1].transform.mProps.v.props;
      items[items.length - 1].transform.mProps._mdf = false;
      items[items.length - 1].transform.op._mdf = false;
      cont -= 1;
      i += dir;
    }
  }
};

RepeaterModifier.prototype.addShape = function () {};

ShapeModifiers.registerModifier('rp', RepeaterModifier);

/* global createSizedArray, shapePool */

function ShapeCollection() {
  this._length = 0;
  this._maxLength = 4;
  this.shapes = createSizedArray(this._maxLength);
}

ShapeCollection.prototype.addShape = function (shapeData) {
  if (this._length === this._maxLength) {
    this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
    this._maxLength *= 2;
  }
  this.shapes[this._length] = shapeData;
  this._length += 1;
};

ShapeCollection.prototype.releaseShapes = function () {
  var i;
  for (i = 0; i < this._length; i += 1) {
    shapePool.release(this.shapes[i]);
  }
  this._length = 0;
};

/* global createSizedArray, createTypedArray, PropertyFactory, extendPrototype, DynamicPropertyContainer */

function DashProperty(elem, data, renderer, container) {
  this.elem = elem;
  this.frameId = -1;
  this.dataProps = createSizedArray(data.length);
  this.renderer = renderer;
  this.k = false;
  this.dashStr = '';
  this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
  this.dashoffset = createTypedArray('float32', 1);
  this.initDynamicPropertyContainer(container);
  var i;
  var len = data.length || 0;
  var prop;
  for (i = 0; i < len; i += 1) {
    prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
    this.k = prop.k || this.k;
    this.dataProps[i] = { n: data[i].n, p: prop };
  }
  if (!this.k) {
    this.getValue(true);
  }
  this._isAnimated = this.k;
}

DashProperty.prototype.getValue = function (forceRender) {
  if (this.elem.globalData.frameId === this.frameId && !forceRender) {
    return;
  }
  this.frameId = this.elem.globalData.frameId;
  this.iterateDynamicProperties();
  this._mdf = this._mdf || forceRender;
  if (this._mdf) {
    var i = 0;
    var len = this.dataProps.length;
    if (this.renderer === 'svg') {
      this.dashStr = '';
    }
    for (i = 0; i < len; i += 1) {
      if (this.dataProps[i].n !== 'o') {
        if (this.renderer === 'svg') {
          this.dashStr += ' ' + this.dataProps[i].p.v;
        } else {
          this.dashArray[i] = this.dataProps[i].p.v;
        }
      } else {
        this.dashoffset[0] = this.dataProps[i].p.v;
      }
    }
  }
};
extendPrototype([DynamicPropertyContainer], DashProperty);

/* global createTypedArray, PropertyFactory, extendPrototype, DynamicPropertyContainer */
function GradientProperty(elem, data, container) {
  this.data = data;
  this.c = createTypedArray('uint8c', data.p * 4);
  var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p * 4) : data.k.k.length - data.p * 4;
  this.o = createTypedArray('float32', cLength);
  this._cmdf = false;
  this._omdf = false;
  this._collapsable = this.checkCollapsable();
  this._hasOpacity = cLength;
  this.initDynamicPropertyContainer(container);
  this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
  this.k = this.prop.k;
  this.getValue(true);
}

GradientProperty.prototype.comparePoints = function (values, points) {
  var i = 0;
  var len = this.o.length / 2;
  var diff;
  while (i < len) {
    diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
    if (diff > 0.01) {
      return false;
    }
    i += 1;
  }
  return true;
};

GradientProperty.prototype.checkCollapsable = function () {
  if (this.o.length / 2 !== this.c.length / 4) {
    return false;
  }
  if (this.data.k.k[0].s) {
    var i = 0;
    var len = this.data.k.k.length;
    while (i < len) {
      if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
        return false;
      }
      i += 1;
    }
  } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
    return false;
  }
  return true;
};

GradientProperty.prototype.getValue = function (forceRender) {
  this.prop.getValue();
  this._mdf = false;
  this._cmdf = false;
  this._omdf = false;
  if (this.prop._mdf || forceRender) {
    var i;
    var len = this.data.p * 4;
    var mult;
    var val;
    for (i = 0; i < len; i += 1) {
      mult = i % 4 === 0 ? 100 : 255;
      val = Math.round(this.prop.v[i] * mult);
      if (this.c[i] !== val) {
        this.c[i] = val;
        this._cmdf = !forceRender;
      }
    }
    if (this.o.length) {
      len = this.prop.v.length;
      for (i = this.data.p * 4; i < len; i += 1) {
        mult = i % 2 === 0 ? 100 : 1;
        val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
        if (this.o[i - this.data.p * 4] !== val) {
          this.o[i - this.data.p * 4] = val;
          this._omdf = !forceRender;
        }
      }
    }
    this._mdf = !forceRender;
  }
};

extendPrototype([DynamicPropertyContainer], GradientProperty);

/* exported buildShapeString */

var buildShapeString = function (pathNodes, length, closed, mat) {
  if (length === 0) {
    return '';
  }
  var _o = pathNodes.o;
  var _i = pathNodes.i;
  var _v = pathNodes.v;
  var i;
  var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
  for (i = 1; i < length; i += 1) {
    shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
  }
  if (closed && length) {
    shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
    shapeString += 'z';
  }
  return shapeString;
};

/* global Howl */
/* exported audioControllerFactory */

var audioControllerFactory = (function () {
  function AudioController(audioFactory) {
    this.audios = [];
    this.audioFactory = audioFactory;
    this._volume = 1;
    this._isMuted = false;
  }

  AudioController.prototype = {
    addAudio: function (audio) {
      this.audios.push(audio);
    },
    pause: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].pause();
      }
    },
    resume: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].resume();
      }
    },
    setRate: function (rateValue) {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].setRate(rateValue);
      }
    },
    createAudio: function (assetPath) {
      if (this.audioFactory) {
        return this.audioFactory(assetPath);
      } if (Howl) {
        return new Howl({
          src: [assetPath],
        });
      }
      return {
        isPlaying: false,
        play: function () { this.isPlaying = true; },
        seek: function () { this.isPlaying = false; },
        playing: function () {},
        rate: function () {},
        setVolume: function () {},
      };
    },
    setAudioFactory: function (audioFactory) {
      this.audioFactory = audioFactory;
    },
    setVolume: function (value) {
      this._volume = value;
      this._updateVolume();
    },
    mute: function () {
      this._isMuted = true;
      this._updateVolume();
    },
    unmute: function () {
      this._isMuted = false;
      this._updateVolume();
    },
    getVolume: function () {
      return this._volume;
    },
    _updateVolume: function () {
      var i;
      var len = this.audios.length;
      for (i = 0; i < len; i += 1) {
        this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
      }
    },
  };

  return function () {
    return new AudioController();
  };
}());

/* global createTag, createNS, isSafari */
/* exported ImagePreloader */

var ImagePreloader = (function () {
  var proxyImage = (function () {
    var canvas = createTag('canvas');
    canvas.width = 1;
    canvas.height = 1;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return canvas;
  }());

  function imageLoaded() {
    this.loadedAssets += 1;
    if (this.loadedAssets === this.totalImages) {
      if (this.imagesLoadedCb) {
        this.imagesLoadedCb(null);
      }
    }
  }

  function getAssetsPath(assetData, assetsPath, originalPath) {
    var path = '';
    if (assetData.e) {
      path = assetData.p;
    } else if (assetsPath) {
      var imagePath = assetData.p;
      if (imagePath.indexOf('images/') !== -1) {
        imagePath = imagePath.split('/')[1];
      }
      path = assetsPath + imagePath;
    } else {
      path = originalPath;
      path += assetData.u ? assetData.u : '';
      path += assetData.p;
    }
    return path;
  }

  function testImageLoaded(img) {
    var _count = 0;
    var intervalId = setInterval(function () {
      var box = img.getBBox();
      if (box.width || _count > 500) {
        this._imageLoaded();
        clearInterval(intervalId);
      }
      _count += 1;
    }.bind(this), 50);
  }

  function createImageData(assetData) {
    var path = getAssetsPath(assetData, this.assetsPath, this.path);
    var img = createNS('image');
    if (isSafari) {
      this.testImageLoaded(img);
    } else {
      img.addEventListener('load', this._imageLoaded, false);
    }
    img.addEventListener('error', function () {
      ob.img = proxyImage;
      this._imageLoaded();
    }.bind(this), false);
    img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
    this._elementHelper.append(img);
    var ob = {
      img: img,
      assetData: assetData,
    };
    return ob;
  }

  function createImgData(assetData) {
    var path = getAssetsPath(assetData, this.assetsPath, this.path);
    var img = createTag('img');
    img.crossOrigin = 'anonymous';
    img.addEventListener('load', this._imageLoaded, false);
    img.addEventListener('error', function () {
      ob.img = proxyImage;
      this._imageLoaded();
    }.bind(this), false);
    img.src = path;
    var ob = {
      img: img,
      assetData: assetData,
    };
    return ob;
  }

  function loadAssets(assets, cb) {
    this.imagesLoadedCb = cb;
    var i;
    var len = assets.length;
    for (i = 0; i < len; i += 1) {
      if (!assets[i].layers) {
        this.totalImages += 1;
        this.images.push(this._createImageData(assets[i]));
      }
    }
  }

  function setPath(path) {
    this.path = path || '';
  }

  function setAssetsPath(path) {
    this.assetsPath = path || '';
  }

  function getImage(assetData) {
    var i = 0;
    var len = this.images.length;
    while (i < len) {
      if (this.images[i].assetData === assetData) {
        return this.images[i].img;
      }
      i += 1;
    }
    return null;
  }

  function destroy() {
    this.imagesLoadedCb = null;
    this.images.length = 0;
  }

  function loaded() {
    return this.totalImages === this.loadedAssets;
  }

  function setCacheType(type, elementHelper) {
    if (type === 'svg') {
      this._elementHelper = elementHelper;
      this._createImageData = this.createImageData.bind(this);
    } else {
      this._createImageData = this.createImgData.bind(this);
    }
  }

  function ImagePreloaderFactory() {
    this._imageLoaded = imageLoaded.bind(this);
    this.testImageLoaded = testImageLoaded.bind(this);
    this.assetsPath = '';
    this.path = '';
    this.totalImages = 0;
    this.loadedAssets = 0;
    this.imagesLoadedCb = null;
    this.images = [];
  }

  ImagePreloaderFactory.prototype = {
    loadAssets: loadAssets,
    setAssetsPath: setAssetsPath,
    setPath: setPath,
    loaded: loaded,
    destroy: destroy,
    getImage: getImage,
    createImgData: createImgData,
    createImageData: createImageData,
    imageLoaded: imageLoaded,
    setCacheType: setCacheType,
  };

  return ImagePreloaderFactory;
}());

/* exported featureSupport */

var featureSupport = (function () {
  var ob = {
    maskType: true,
  };
  if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
    ob.maskType = false;
  }
  return ob;
}());

/* global createNS */
/* exported filtersFactory */

var filtersFactory = (function () {
  var ob = {};
  ob.createFilter = createFilter;
  ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

  function createFilter(filId) {
    var fil = createNS('filter');
    fil.setAttribute('id', filId);
    fil.setAttribute('filterUnits', 'objectBoundingBox');
    fil.setAttribute('x', '0%');
    fil.setAttribute('y', '0%');
    fil.setAttribute('width', '100%');
    fil.setAttribute('height', '100%');
    return fil;
  }

  function createAlphaToLuminanceFilter() {
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
    return feColorMatrix;
  }

  return ob;
}());

/* exported assetLoader */

var assetLoader = (function () {
  function formatResponse(xhr) {
    if (xhr.response && typeof xhr.response === 'object') {
      return xhr.response;
    } if (xhr.response && typeof xhr.response === 'string') {
      return JSON.parse(xhr.response);
    } if (xhr.responseText) {
      return JSON.parse(xhr.responseText);
    }
    return null;
  }

  function loadAsset(path, callback, errorCallback) {
    var response;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', path, true);
    // set responseType after calling open or IE will break.
    try {
      // This crashes on Android WebView prior to KitKat
      xhr.responseType = 'json';
    } catch (err) {} // eslint-disable-line no-empty
    xhr.send();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          response = formatResponse(xhr);
          callback(response);
        } else {
          try {
            response = formatResponse(xhr);
            callback(response);
          } catch (err) {
            if (errorCallback) {
              errorCallback(err);
            }
          }
        }
      }
    };
  }
  return {
    load: loadAsset,
  };
}());

/* global createSizedArray, PropertyFactory, TextAnimatorDataProperty, bez, addHueToRGB,
  addSaturationToRGB, addBrightnessToRGB, LetterProps, Matrix, extendPrototype, DynamicPropertyContainer */

function TextAnimatorProperty(textData, renderType, elem) {
  this._isFirstFrame = true;
  this._hasMaskedPath = false;
  this._frameId = -1;
  this._textData = textData;
  this._renderType = renderType;
  this._elem = elem;
  this._animatorsData = createSizedArray(this._textData.a.length);
  this._pathData = {};
  this._moreOptions = {
    alignment: {},
  };
  this.renderedLetters = [];
  this.lettersChangedFlag = false;
  this.initDynamicPropertyContainer(elem);
}

TextAnimatorProperty.prototype.searchProperties = function () {
  var i;
  var len = this._textData.a.length;
  var animatorProps;
  var getProp = PropertyFactory.getProp;
  for (i = 0; i < len; i += 1) {
    animatorProps = this._textData.a[i];
    this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
  }
  if (this._textData.p && 'm' in this._textData.p) {
    this._pathData = {
      f: getProp(this._elem, this._textData.p.f, 0, 0, this),
      l: getProp(this._elem, this._textData.p.l, 0, 0, this),
      r: this._textData.p.r,
      m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
    };
    this._hasMaskedPath = true;
  } else {
    this._hasMaskedPath = false;
  }
  this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
};

TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
  this.lettersChangedFlag = lettersChangedFlag;
  if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
    return;
  }
  this._isFirstFrame = false;
  var alignment = this._moreOptions.alignment.v;
  var animators = this._animatorsData;
  var textData = this._textData;
  var matrixHelper = this.mHelper;
  var renderType = this._renderType;
  var renderedLettersCount = this.renderedLetters.length;
  var xPos;
  var yPos;
  var i;
  var len;
  var letters = documentData.l;
  var pathInfo;
  var currentLength;
  var currentPoint;
  var segmentLength;
  var flag;
  var pointInd;
  var segmentInd;
  var prevPoint;
  var points;
  var segments;
  var partialLength;
  var totalLength;
  var perc;
  var tanAngle;
  var mask;
  if (this._hasMaskedPath) {
    mask = this._pathData.m;
    if (!this._pathData.n || this._pathData._mdf) {
      var paths = mask.v;
      if (this._pathData.r) {
        paths = paths.reverse();
      }
      // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
      pathInfo = {
        tLength: 0,
        segments: [],
      };
      len = paths._length - 1;
      var bezierData;
      totalLength = 0;
      for (i = 0; i < len; i += 1) {
        bezierData = bez.buildBezierData(paths.v[i],
          paths.v[i + 1],
          [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
          [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
        pathInfo.tLength += bezierData.segmentLength;
        pathInfo.segments.push(bezierData);
        totalLength += bezierData.segmentLength;
      }
      i = len;
      if (mask.v.c) {
        bezierData = bez.buildBezierData(paths.v[i],
          paths.v[0],
          [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
          [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
        pathInfo.tLength += bezierData.segmentLength;
        pathInfo.segments.push(bezierData);
        totalLength += bezierData.segmentLength;
      }
      this._pathData.pi = pathInfo;
    }
    pathInfo = this._pathData.pi;

    currentLength = this._pathData.f.v;
    segmentInd = 0;
    pointInd = 1;
    segmentLength = 0;
    flag = true;
    segments = pathInfo.segments;
    if (currentLength < 0 && mask.v.c) {
      if (pathInfo.tLength < Math.abs(currentLength)) {
        currentLength = -Math.abs(currentLength) % pathInfo.tLength;
      }
      segmentInd = segments.length - 1;
      points = segments[segmentInd].points;
      pointInd = points.length - 1;
      while (currentLength < 0) {
        currentLength += points[pointInd].partialLength;
        pointInd -= 1;
        if (pointInd < 0) {
          segmentInd -= 1;
          points = segments[segmentInd].points;
          pointInd = points.length - 1;
        }
      }
    }
    points = segments[segmentInd].points;
    prevPoint = points[pointInd - 1];
    currentPoint = points[pointInd];
    partialLength = currentPoint.partialLength;
  }

  len = letters.length;
  xPos = 0;
  yPos = 0;
  var yOff = documentData.finalSize * 1.2 * 0.714;
  var firstLine = true;
  var animatorProps;
  var animatorSelector;
  var j;
  var jLen;
  var letterValue;

  jLen = animators.length;

  var mult;
  var ind = -1;
  var offf;
  var xPathPos;
  var yPathPos;
  var initPathPos = currentLength;
  var initSegmentInd = segmentInd;
  var initPointInd = pointInd;
  var currentLine = -1;
  var elemOpacity;
  var sc;
  var sw;
  var fc;
  var k;
  var letterSw;
  var letterSc;
  var letterFc;
  var letterM = '';
  var letterP = this.defaultPropsArray;
  var letterO;

  //
  if (documentData.j === 2 || documentData.j === 1) {
    var animatorJustifyOffset = 0;
    var animatorFirstCharOffset = 0;
    var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
    var lastIndex = 0;
    var isNewLine = true;

    for (i = 0; i < len; i += 1) {
      if (letters[i].n) {
        if (animatorJustifyOffset) {
          animatorJustifyOffset += animatorFirstCharOffset;
        }
        while (lastIndex < i) {
          letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
          lastIndex += 1;
        }
        animatorJustifyOffset = 0;
        isNewLine = true;
      } else {
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.t.propType) {
            if (isNewLine && documentData.j === 2) {
              animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
            }
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
            } else {
              animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
            }
          }
        }
        isNewLine = false;
      }
    }
    if (animatorJustifyOffset) {
      animatorJustifyOffset += animatorFirstCharOffset;
    }
    while (lastIndex < i) {
      letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
      lastIndex += 1;
    }
  }
  //

  for (i = 0; i < len; i += 1) {
    matrixHelper.reset();
    elemOpacity = 1;
    if (letters[i].n) {
      xPos = 0;
      yPos += documentData.yOffset;
      yPos += firstLine ? 1 : 0;
      currentLength = initPathPos;
      firstLine = false;
      if (this._hasMaskedPath) {
        segmentInd = initSegmentInd;
        pointInd = initPointInd;
        points = segments[segmentInd].points;
        prevPoint = points[pointInd - 1];
        currentPoint = points[pointInd];
        partialLength = currentPoint.partialLength;
        segmentLength = 0;
      }
      letterM = '';
      letterFc = '';
      letterSw = '';
      letterO = '';
      letterP = this.defaultPropsArray;
    } else {
      if (this._hasMaskedPath) {
        if (currentLine !== letters[i].line) {
          switch (documentData.j) {
            case 1:
              currentLength += totalLength - documentData.lineWidths[letters[i].line];
              break;
            case 2:
              currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
              break;
            default:
              break;
          }
          currentLine = letters[i].line;
        }
        if (ind !== letters[i].ind) {
          if (letters[ind]) {
            currentLength += letters[ind].extra;
          }
          currentLength += letters[i].an / 2;
          ind = letters[i].ind;
        }
        currentLength += (alignment[0] * letters[i].an) * 0.005;
        var animatorOffset = 0;
        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          if (animatorProps.p.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorOffset += animatorProps.p.v[0] * mult[0];
            } else {
              animatorOffset += animatorProps.p.v[0] * mult;
            }
          }
          if (animatorProps.a.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
            if (mult.length) {
              animatorOffset += animatorProps.a.v[0] * mult[0];
            } else {
              animatorOffset += animatorProps.a.v[0] * mult;
            }
          }
        }
        flag = true;
        while (flag) {
          if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
            matrixHelper.translate((-alignment[0] * letters[i].an) * 0.005, -(alignment[1] * yOff) * 0.01);
            flag = false;
          } else if (points) {
            segmentLength += currentPoint.partialLength;
            pointInd += 1;
            if (pointInd >= points.length) {
              pointInd = 0;
              segmentInd += 1;
              if (!segments[segmentInd]) {
                if (mask.v.c) {
                  pointInd = 0;
                  segmentInd = 0;
                  points = segments[segmentInd].points;
                } else {
                  segmentLength -= currentPoint.partialLength;
                  points = null;
                }
              } else {
                points = segments[segmentInd].points;
              }
            }
            if (points) {
              prevPoint = currentPoint;
              currentPoint = points[pointInd];
              partialLength = currentPoint.partialLength;
            }
          }
        }
        offf = letters[i].an / 2 - letters[i].add;
        matrixHelper.translate(-offf, 0, 0);
      } else {
        offf = letters[i].an / 2 - letters[i].add;
        matrixHelper.translate(-offf, 0, 0);

        // Grouping alignment
        matrixHelper.translate((-alignment[0] * letters[i].an) * 0.005, (-alignment[1] * yOff) * 0.01, 0);
      }

      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.t.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
          if (xPos !== 0 || documentData.j !== 0) {
            if (this._hasMaskedPath) {
              if (mult.length) {
                currentLength += animatorProps.t.v * mult[0];
              } else {
                currentLength += animatorProps.t.v * mult;
              }
            } else if (mult.length) {
              xPos += animatorProps.t.v * mult[0];
            } else {
              xPos += animatorProps.t.v * mult;
            }
          }
        }
      }
      if (documentData.strokeWidthAnim) {
        sw = documentData.sw || 0;
      }
      if (documentData.strokeColorAnim) {
        if (documentData.sc) {
          sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
        } else {
          sc = [0, 0, 0];
        }
      }
      if (documentData.fillColorAnim && documentData.fc) {
        fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.a.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

          if (mult.length) {
            matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
          } else {
            matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
          }
        }
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        if (animatorProps.s.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (mult.length) {
            matrixHelper.scale(1 + ((animatorProps.s.v[0] - 1) * mult[0]), 1 + ((animatorProps.s.v[1] - 1) * mult[1]), 1);
          } else {
            matrixHelper.scale(1 + ((animatorProps.s.v[0] - 1) * mult), 1 + ((animatorProps.s.v[1] - 1) * mult), 1);
          }
        }
      }
      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;
        animatorSelector = animators[j].s;
        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
        if (animatorProps.sk.propType) {
          if (mult.length) {
            matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
          } else {
            matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
          }
        }
        if (animatorProps.r.propType) {
          if (mult.length) {
            matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
          } else {
            matrixHelper.rotateZ(-animatorProps.r.v * mult);
          }
        }
        if (animatorProps.ry.propType) {
          if (mult.length) {
            matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
          } else {
            matrixHelper.rotateY(animatorProps.ry.v * mult);
          }
        }
        if (animatorProps.rx.propType) {
          if (mult.length) {
            matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
          } else {
            matrixHelper.rotateX(animatorProps.rx.v * mult);
          }
        }
        if (animatorProps.o.propType) {
          if (mult.length) {
            elemOpacity += ((animatorProps.o.v) * mult[0] - elemOpacity) * mult[0];
          } else {
            elemOpacity += ((animatorProps.o.v) * mult - elemOpacity) * mult;
          }
        }
        if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
          if (mult.length) {
            sw += animatorProps.sw.v * mult[0];
          } else {
            sw += animatorProps.sw.v * mult;
          }
        }
        if (documentData.strokeColorAnim && animatorProps.sc.propType) {
          for (k = 0; k < 3; k += 1) {
            if (mult.length) {
              sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
            } else {
              sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
            }
          }
        }
        if (documentData.fillColorAnim && documentData.fc) {
          if (animatorProps.fc.propType) {
            for (k = 0; k < 3; k += 1) {
              if (mult.length) {
                fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
              } else {
                fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
              }
            }
          }
          if (animatorProps.fh.propType) {
            if (mult.length) {
              fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
            } else {
              fc = addHueToRGB(fc, animatorProps.fh.v * mult);
            }
          }
          if (animatorProps.fs.propType) {
            if (mult.length) {
              fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
            } else {
              fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
            }
          }
          if (animatorProps.fb.propType) {
            if (mult.length) {
              fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
            } else {
              fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
            }
          }
        }
      }

      for (j = 0; j < jLen; j += 1) {
        animatorProps = animators[j].a;

        if (animatorProps.p.propType) {
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
          if (this._hasMaskedPath) {
            if (mult.length) {
              matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
            } else {
              matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
            }
          } else if (mult.length) {
            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
          } else {
            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
          }
        }
      }
      if (documentData.strokeWidthAnim) {
        letterSw = sw < 0 ? 0 : sw;
      }
      if (documentData.strokeColorAnim) {
        letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
      }
      if (documentData.fillColorAnim && documentData.fc) {
        letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
      }

      if (this._hasMaskedPath) {
        matrixHelper.translate(0, -documentData.ls);

        matrixHelper.translate(0, (alignment[1] * yOff) * 0.01 + yPos, 0);
        if (textData.p.p) {
          tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
          var rot = (Math.atan(tanAngle) * 180) / Math.PI;
          if (currentPoint.point[0] < prevPoint.point[0]) {
            rot += 180;
          }
          matrixHelper.rotate((-rot * Math.PI) / 180);
        }
        matrixHelper.translate(xPathPos, yPathPos, 0);
        currentLength -= (alignment[0] * letters[i].an) * 0.005;
        if (letters[i + 1] && ind !== letters[i + 1].ind) {
          currentLength += letters[i].an / 2;
          currentLength += (documentData.tr * 0.001) * documentData.finalSize;
        }
      } else {
        matrixHelper.translate(xPos, yPos, 0);

        if (documentData.ps) {
          // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
          matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        }
        switch (documentData.j) {
          case 1:
            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
            break;
          case 2:
            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
            break;
          default:
            break;
        }
        matrixHelper.translate(0, -documentData.ls);
        matrixHelper.translate(offf, 0, 0);
        matrixHelper.translate((alignment[0] * letters[i].an) * 0.005, (alignment[1] * yOff) * 0.01, 0);
        xPos += letters[i].l + (documentData.tr * 0.001) * documentData.finalSize;
      }
      if (renderType === 'html') {
        letterM = matrixHelper.toCSS();
      } else if (renderType === 'svg') {
        letterM = matrixHelper.to2dCSS();
      } else {
        letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
      }
      letterO = elemOpacity;
    }

    if (renderedLettersCount <= i) {
      letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
      this.renderedLetters.push(letterValue);
      renderedLettersCount += 1;
      this.lettersChangedFlag = true;
    } else {
      letterValue = this.renderedLetters[i];
      this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
    }
  }
};

TextAnimatorProperty.prototype.getValue = function () {
  if (this._elem.globalData.frameId === this._frameId) {
    return;
  }
  this._frameId = this._elem.globalData.frameId;
  this.iterateDynamicProperties();
};

TextAnimatorProperty.prototype.mHelper = new Matrix();
TextAnimatorProperty.prototype.defaultPropsArray = [];
extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

/* global PropertyFactory, degToRads, TextSelectorProp */
/* exported TextAnimatorDataProperty */

function TextAnimatorDataProperty(elem, animatorProps, container) {
  var defaultData = { propType: false };
  var getProp = PropertyFactory.getProp;
  var textAnimatorAnimatables = animatorProps.a;
  this.a = {
    r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
    rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
    ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
    sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
    sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
    s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
    a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
    o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
    p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
    sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
    sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
    fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
    fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
    fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
    fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
    t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData,
  };

  this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
  this.s.t = animatorProps.s.t;
}

function LetterProps(o, sw, sc, fc, m, p) {
  this.o = o;
  this.sw = sw;
  this.sc = sc;
  this.fc = fc;
  this.m = m;
  this.p = p;
  this._mdf = {
    o: true,
    sw: !!sw,
    sc: !!sc,
    fc: !!fc,
    m: true,
    p: true,
  };
}

LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
  this._mdf.o = false;
  this._mdf.sw = false;
  this._mdf.sc = false;
  this._mdf.fc = false;
  this._mdf.m = false;
  this._mdf.p = false;
  var updated = false;

  if (this.o !== o) {
    this.o = o;
    this._mdf.o = true;
    updated = true;
  }
  if (this.sw !== sw) {
    this.sw = sw;
    this._mdf.sw = true;
    updated = true;
  }
  if (this.sc !== sc) {
    this.sc = sc;
    this._mdf.sc = true;
    updated = true;
  }
  if (this.fc !== fc) {
    this.fc = fc;
    this._mdf.fc = true;
    updated = true;
  }
  if (this.m !== m) {
    this.m = m;
    this._mdf.m = true;
    updated = true;
  }
  if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
    this.p = p;
    this._mdf.p = true;
    updated = true;
  }
  return updated;
};

/* global FontManager, initialDefaultFrame, getFontProperties */
/* exported TextProperty */

function TextProperty(elem, data) {
  this._frameId = initialDefaultFrame;
  this.pv = '';
  this.v = '';
  this.kf = false;
  this._isFirstFrame = true;
  this._mdf = false;
  this.data = data;
  this.elem = elem;
  this.comp = this.elem.comp;
  this.keysIndex = 0;
  this.canResize = false;
  this.minimumFontSize = 1;
  this.effectsSequence = [];
  this.currentData = {
    ascent: 0,
    boxWidth: this.defaultBoxWidth,
    f: '',
    fStyle: '',
    fWeight: '',
    fc: '',
    j: '',
    justifyOffset: '',
    l: [],
    lh: 0,
    lineWidths: [],
    ls: '',
    of: '',
    s: '',
    sc: '',
    sw: 0,
    t: 0,
    tr: 0,
    sz: 0,
    ps: null,
    fillColorAnim: false,
    strokeColorAnim: false,
    strokeWidthAnim: false,
    yOffset: 0,
    finalSize: 0,
    finalText: [],
    finalLineHeight: 0,
    __complete: false,

  };
  this.copyData(this.currentData, this.data.d.k[0].s);

  if (!this.searchProperty()) {
    this.completeTextData(this.currentData);
  }
}

TextProperty.prototype.defaultBoxWidth = [0, 0];

TextProperty.prototype.copyData = function (obj, data) {
  for (var s in data) {
    if (Object.prototype.hasOwnProperty.call(data, s)) {
      obj[s] = data[s];
    }
  }
  return obj;
};

TextProperty.prototype.setCurrentData = function (data) {
  if (!data.__complete) {
    this.completeTextData(data);
  }
  this.currentData = data;
  this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
  this._mdf = true;
};

TextProperty.prototype.searchProperty = function () {
  return this.searchKeyframes();
};

TextProperty.prototype.searchKeyframes = function () {
  this.kf = this.data.d.k.length > 1;
  if (this.kf) {
    this.addEffect(this.getKeyframeValue.bind(this));
  }
  return this.kf;
};

TextProperty.prototype.addEffect = function (effectFunction) {
  this.effectsSequence.push(effectFunction);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.getValue = function (_finalValue) {
  if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
    return;
  }
  this.currentData.t = this.data.d.k[this.keysIndex].s.t;
  var currentValue = this.currentData;
  var currentIndex = this.keysIndex;
  if (this.lock) {
    this.setCurrentData(this.currentData);
    return;
  }
  this.lock = true;
  this._mdf = false;
  var i; var
    len = this.effectsSequence.length;
  var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
  for (i = 0; i < len; i += 1) {
    // Checking if index changed to prevent creating a new object every time the expression updates.
    if (currentIndex !== this.keysIndex) {
      finalValue = this.effectsSequence[i](finalValue, finalValue.t);
    } else {
      finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
    }
  }
  if (currentValue !== finalValue) {
    this.setCurrentData(finalValue);
  }
  this.v = this.currentData;
  this.pv = this.v;
  this.lock = false;
  this.frameId = this.elem.globalData.frameId;
};

TextProperty.prototype.getKeyframeValue = function () {
  var textKeys = this.data.d.k;
  var frameNum = this.elem.comp.renderedFrame;
  var i = 0; var
    len = textKeys.length;
  while (i <= len - 1) {
    if (i === len - 1 || textKeys[i + 1].t > frameNum) {
      break;
    }
    i += 1;
  }
  if (this.keysIndex !== i) {
    this.keysIndex = i;
  }
  return this.data.d.k[this.keysIndex].s;
};

TextProperty.prototype.buildFinalText = function (text) {
  var combinedCharacters = FontManager.getCombinedCharacterCodes();
  var charactersArray = [];
  var i = 0; var
    len = text.length;
  var charCode;
  while (i < len) {
    charCode = text.charCodeAt(i);
    if (combinedCharacters.indexOf(charCode) !== -1) {
      charactersArray[charactersArray.length - 1] += text.charAt(i);
    } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      charCode = text.charCodeAt(i + 1);
      if (charCode >= 0xDC00 && charCode <= 0xDFFF) {
        charactersArray.push(text.substr(i, 2));
        i += 1;
      } else {
        charactersArray.push(text.charAt(i));
      }
    } else {
      charactersArray.push(text.charAt(i));
    }
    i += 1;
  }
  return charactersArray;
};

TextProperty.prototype.completeTextData = function (documentData) {
  documentData.__complete = true;
  var fontManager = this.elem.globalData.fontManager;
  var data = this.data;
  var letters = [];
  var i; var
    len;
  var newLineFlag; var index = 0; var
    val;
  var anchorGrouping = data.m.g;
  var currentSize = 0; var currentPos = 0; var currentLine = 0; var
    lineWidths = [];
  var lineWidth = 0;
  var maxLineWidth = 0;
  var j; var
    jLen;
  var fontData = fontManager.getFontByName(documentData.f);
  var charData; var
    cLength = 0;

  var fontProps = getFontProperties(fontData);
  documentData.fWeight = fontProps.weight;
  documentData.fStyle = fontProps.style;
  documentData.finalSize = documentData.s;
  documentData.finalText = this.buildFinalText(documentData.t);
  len = documentData.finalText.length;
  documentData.finalLineHeight = documentData.lh;
  var trackingOffset = (documentData.tr / 1000) * documentData.finalSize;
  var charCode;
  if (documentData.sz) {
    var flag = true;
    var boxWidth = documentData.sz[0];
    var boxHeight = documentData.sz[1];
    var currentHeight; var
      finalText;
    while (flag) {
      finalText = this.buildFinalText(documentData.t);
      currentHeight = 0;
      lineWidth = 0;
      len = finalText.length;
      trackingOffset = (documentData.tr / 1000) * documentData.finalSize;
      var lastSpaceIndex = -1;
      for (i = 0; i < len; i += 1) {
        charCode = finalText[i].charCodeAt(0);
        newLineFlag = false;
        if (finalText[i] === ' ') {
          lastSpaceIndex = i;
        } else if (charCode === 13 || charCode === 3) {
          lineWidth = 0;
          newLineFlag = true;
          currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
        }
        if (fontManager.chars) {
          charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
          cLength = newLineFlag ? 0 : (charData.w * documentData.finalSize) / 100;
        } else {
          // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
          cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
        }
        if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
          if (lastSpaceIndex === -1) {
            len += 1;
          } else {
            i = lastSpaceIndex;
          }
          currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
          finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r');
          // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
          lastSpaceIndex = -1;
          lineWidth = 0;
        } else {
          lineWidth += cLength;
          lineWidth += trackingOffset;
        }
      }
      currentHeight += (fontData.ascent * documentData.finalSize) / 100;
      if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
        documentData.finalSize -= 1;
        documentData.finalLineHeight = (documentData.finalSize * documentData.lh) / documentData.s;
      } else {
        documentData.finalText = finalText;
        len = documentData.finalText.length;
        flag = false;
      }
    }
  }
  lineWidth = -trackingOffset;
  cLength = 0;
  var uncollapsedSpaces = 0;
  var currentChar;
  for (i = 0; i < len; i += 1) {
    newLineFlag = false;
    currentChar = documentData.finalText[i];
    charCode = currentChar.charCodeAt(0);
    if (charCode === 13 || charCode === 3) {
      uncollapsedSpaces = 0;
      lineWidths.push(lineWidth);
      maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
      lineWidth = -2 * trackingOffset;
      val = '';
      newLineFlag = true;
      currentLine += 1;
    } else {
      val = currentChar;
    }
    if (fontManager.chars) {
      charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
      cLength = newLineFlag ? 0 : (charData.w * documentData.finalSize) / 100;
    } else {
      // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
      // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
      cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
    }

    //
    if (currentChar === ' ') {
      uncollapsedSpaces += cLength + trackingOffset;
    } else {
      lineWidth += cLength + trackingOffset + uncollapsedSpaces;
      uncollapsedSpaces = 0;
    }
    letters.push({
      l: cLength, an: cLength, add: currentSize, n: newLineFlag, anIndexes: [], val: val, line: currentLine, animatorJustifyOffset: 0,
    });
    if (anchorGrouping == 2) { // eslint-disable-line eqeqeq
      currentSize += cLength;
      if (val === '' || val === ' ' || i === len - 1) {
        if (val === '' || val === ' ') {
          currentSize -= cLength;
        }
        while (currentPos <= i) {
          letters[currentPos].an = currentSize;
          letters[currentPos].ind = index;
          letters[currentPos].extra = cLength;
          currentPos += 1;
        }
        index += 1;
        currentSize = 0;
      }
    } else if (anchorGrouping == 3) { // eslint-disable-line eqeqeq
      currentSize += cLength;
      if (val === '' || i === len - 1) {
        if (val === '') {
          currentSize -= cLength;
        }
        while (currentPos <= i) {
          letters[currentPos].an = currentSize;
          letters[currentPos].ind = index;
          letters[currentPos].extra = cLength;
          currentPos += 1;
        }
        currentSize = 0;
        index += 1;
      }
    } else {
      letters[index].ind = index;
      letters[index].extra = 0;
      index += 1;
    }
  }
  documentData.l = letters;
  maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
  lineWidths.push(lineWidth);
  if (documentData.sz) {
    documentData.boxWidth = documentData.sz[0];
    documentData.justifyOffset = 0;
  } else {
    documentData.boxWidth = maxLineWidth;
    switch (documentData.j) {
      case 1:
        documentData.justifyOffset = -documentData.boxWidth;
        break;
      case 2:
        documentData.justifyOffset = -documentData.boxWidth / 2;
        break;
      default:
        documentData.justifyOffset = 0;
    }
  }
  documentData.lineWidths = lineWidths;

  var animators = data.a; var animatorData; var
    letterData;
  jLen = animators.length;
  var based; var ind; var
    indexes = [];
  for (j = 0; j < jLen; j += 1) {
    animatorData = animators[j];
    if (animatorData.a.sc) {
      documentData.strokeColorAnim = true;
    }
    if (animatorData.a.sw) {
      documentData.strokeWidthAnim = true;
    }
    if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
      documentData.fillColorAnim = true;
    }
    ind = 0;
    based = animatorData.s.b;
    for (i = 0; i < len; i += 1) {
      letterData = letters[i];
      letterData.anIndexes[j] = ind;
      if ((based == 1 && letterData.val !== '') || (based == 2 && letterData.val !== '' && letterData.val !== ' ') || (based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))) { // eslint-disable-line eqeqeq
        if (animatorData.s.rn === 1) {
          indexes.push(ind);
        }
        ind += 1;
      }
    }
    data.a[j].s.totalChars = ind;
    var currentInd = -1; var
      newInd;
    if (animatorData.s.rn === 1) {
      for (i = 0; i < len; i += 1) {
        letterData = letters[i];
        if (currentInd != letterData.anIndexes[j]) { // eslint-disable-line eqeqeq
          currentInd = letterData.anIndexes[j];
          newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
        }
        letterData.anIndexes[j] = newInd;
      }
    }
  }
  documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
  documentData.ls = documentData.ls || 0;
  documentData.ascent = (fontData.ascent * documentData.finalSize) / 100;
};

TextProperty.prototype.updateDocumentData = function (newData, index) {
  index = index === undefined ? this.keysIndex : index;
  var dData = this.copyData({}, this.data.d.k[index].s);
  dData = this.copyData(dData, newData);
  this.data.d.k[index].s = dData;
  this.recalculate(index);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.recalculate = function (index) {
  var dData = this.data.d.k[index].s;
  dData.__complete = false;
  this.keysIndex = 0;
  this._isFirstFrame = true;
  this.getValue(dData);
};

TextProperty.prototype.canResizeFont = function (_canResize) {
  this.canResize = _canResize;
  this.recalculate(this.keysIndex);
  this.elem.addDynamicProperty(this);
};

TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
  this.minimumFontSize = Math.floor(_fontValue) || 1;
  this.recalculate(this.keysIndex);
  this.elem.addDynamicProperty(this);
};

/* global extendPrototype, BezierFactory, PropertyFactory, DynamicPropertyContainer */
/* exported TextSelectorProp */

var TextSelectorProp = (function () {
  var max = Math.max;
  var min = Math.min;
  var floor = Math.floor;

  function TextSelectorPropFactory(elem, data) {
    this._currentTextLength = -1;
    this.k = false;
    this.data = data;
    this.elem = elem;
    this.comp = elem.comp;
    this.finalS = 0;
    this.finalE = 0;
    this.initDynamicPropertyContainer(elem);
    this.s = PropertyFactory.getProp(elem, data.s || { k: 0 }, 0, 0, this);
    if ('e' in data) {
      this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
    } else {
      this.e = { v: 100 };
    }
    this.o = PropertyFactory.getProp(elem, data.o || { k: 0 }, 0, 0, this);
    this.xe = PropertyFactory.getProp(elem, data.xe || { k: 0 }, 0, 0, this);
    this.ne = PropertyFactory.getProp(elem, data.ne || { k: 0 }, 0, 0, this);
    this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
    if (!this.dynamicProperties.length) {
      this.getValue();
    }
  }

  TextSelectorPropFactory.prototype = {
    getMult: function (ind) {
      if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
        this.getValue();
      }
      // var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
      var x1 = 0;
      var y1 = 0;
      var x2 = 1;
      var y2 = 1;
      if (this.ne.v > 0) {
        x1 = this.ne.v / 100.0;
      } else {
        y1 = -this.ne.v / 100.0;
      }
      if (this.xe.v > 0) {
        x2 = 1.0 - this.xe.v / 100.0;
      } else {
        y2 = 1.0 + this.xe.v / 100.0;
      }
      var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;

      var mult = 0;
      var s = this.finalS;
      var e = this.finalE;
      var type = this.data.sh;
      if (type === 2) {
        if (e === s) {
          mult = ind >= e ? 1 : 0;
        } else {
          mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
        }
        mult = easer(mult);
      } else if (type === 3) {
        if (e === s) {
          mult = ind >= e ? 0 : 1;
        } else {
          mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
        }

        mult = easer(mult);
      } else if (type === 4) {
        if (e === s) {
          mult = 0;
        } else {
          mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          if (mult < 0.5) {
            mult *= 2;
          } else {
            mult = 1 - 2 * (mult - 0.5);
          }
        }
        mult = easer(mult);
      } else if (type === 5) {
        if (e === s) {
          mult = 0;
        } else {
          var tot = e - s;
          /* ind += 0.5;
                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */
          ind = min(max(0, ind + 0.5 - s), e - s);
          var x = -tot / 2 + ind;
          var a = tot / 2;
          mult = Math.sqrt(1 - (x * x) / (a * a));
        }
        mult = easer(mult);
      } else if (type === 6) {
        if (e === s) {
          mult = 0;
        } else {
          ind = min(max(0, ind + 0.5 - s), e - s);
          mult = (1 + (Math.cos((Math.PI + Math.PI * 2 * (ind) / (e - s))))) / 2; // eslint-disable-line
        }
        mult = easer(mult);
      } else {
        if (ind >= floor(s)) {
          if (ind - s < 0) {
            mult = max(0, min(min(e, 1) - (s - ind), 1));
          } else {
            mult = max(0, min(e - ind, 1));
          }
        }
        mult = easer(mult);
      }
      return mult * this.a.v;
    },
    getValue: function (newCharsFlag) {
      this.iterateDynamicProperties();
      this._mdf = newCharsFlag || this._mdf;
      this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
      if (newCharsFlag && this.data.r === 2) {
        this.e.v = this._currentTextLength;
      }
      var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
      var o = this.o.v / divisor;
      var s = this.s.v / divisor + o;
      var e = (this.e.v / divisor) + o;
      if (s > e) {
        var _s = s;
        s = e;
        e = _s;
      }
      this.finalS = s;
      this.finalE = e;
    },
  };
  extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

  function getTextSelectorProp(elem, data, arr) {
    return new TextSelectorPropFactory(elem, data, arr);
  }

  return {
    getTextSelectorProp: getTextSelectorProp,
  };
}());

/* global createSizedArray, pooling */
/* exported poolFactory */

var poolFactory = (function () {
  return function (initialLength, _create, _release) {
    var _length = 0;
    var _maxLength = initialLength;
    var pool = createSizedArray(_maxLength);

    var ob = {
      newElement: newElement,
      release: release,
    };

    function newElement() {
      var element;
      if (_length) {
        _length -= 1;
        element = pool[_length];
      } else {
        element = _create();
      }
      return element;
    }

    function release(element) {
      if (_length === _maxLength) {
        pool = pooling.double(pool);
        _maxLength *= 2;
      }
      if (_release) {
        _release(element);
      }
      pool[_length] = element;
      _length += 1;
    }

    return ob;
  };
}());

/* global createSizedArray */
/* exported pooling */

var pooling = (function () {
  function double(arr) {
    return arr.concat(createSizedArray(arr.length));
  }

  return {
    double: double,
  };
}());

/* global createTypedArray, poolFactory */
/* exported pointPool */

var pointPool = (function () {
  function create() {
    return createTypedArray('float32', 2);
  }
  return poolFactory(8, create);
}());

/* global ShapePath, pointPool, poolFactory */
/* exported shapePool */

var shapePool = (function () {
  function create() {
    return new ShapePath();
  }

  function release(shapePath) {
    var len = shapePath._length;
    var i;
    for (i = 0; i < len; i += 1) {
      pointPool.release(shapePath.v[i]);
      pointPool.release(shapePath.i[i]);
      pointPool.release(shapePath.o[i]);
      shapePath.v[i] = null;
      shapePath.i[i] = null;
      shapePath.o[i] = null;
    }
    shapePath._length = 0;
    shapePath.c = false;
  }

  function clone(shape) {
    var cloned = factory.newElement();
    var i;
    var len = shape._length === undefined ? shape.v.length : shape._length;
    cloned.setLength(len);
    cloned.c = shape.c;

    for (i = 0; i < len; i += 1) {
      cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
    }
    return cloned;
  }

  var factory = poolFactory(4, create, release);
  factory.clone = clone;

  return factory;
}());

/* global createSizedArray, ShapeCollection, shapePool, pooling */
/* exported shapeCollectionPool */

var shapeCollectionPool = (function () {
  var ob = {
    newShapeCollection: newShapeCollection,
    release: release,
  };

  var _length = 0;
  var _maxLength = 4;
  var pool = createSizedArray(_maxLength);

  function newShapeCollection() {
    var shapeCollection;
    if (_length) {
      _length -= 1;
      shapeCollection = pool[_length];
    } else {
      shapeCollection = new ShapeCollection();
    }
    return shapeCollection;
  }

  function release(shapeCollection) {
    var i;
    var len = shapeCollection._length;
    for (i = 0; i < len; i += 1) {
      shapePool.release(shapeCollection.shapes[i]);
    }
    shapeCollection._length = 0;

    if (_length === _maxLength) {
      pool = pooling.double(pool);
      _maxLength *= 2;
    }
    pool[_length] = shapeCollection;
    _length += 1;
  }

  return ob;
}());

/* global poolFactory, bezierLengthPool */
/* exported segmentsLengthPool */

var segmentsLengthPool = (function () {
  function create() {
    return {
      lengths: [],
      totalLength: 0,
    };
  }

  function release(element) {
    var i;
    var len = element.lengths.length;
    for (i = 0; i < len; i += 1) {
      bezierLengthPool.release(element.lengths[i]);
    }
    element.lengths.length = 0;
  }

  return poolFactory(8, create, release);
}());

/* global createTypedArray, defaultCurveSegments, poolFactory */
/* exported bezierLengthPool */

var bezierLengthPool = (function () {
  function create() {
    return {
      addedLength: 0,
      percents: createTypedArray('float32', defaultCurveSegments),
      lengths: createTypedArray('float32', defaultCurveSegments),
    };
  }
  return poolFactory(8, create);
}());

/* global AudioElement, FontManager */

function BaseRenderer() {}
BaseRenderer.prototype.checkLayers = function (num) {
  var i;
  var len = this.layers.length;
  var data;
  this.completeLayers = true;
  for (i = len - 1; i >= 0; i -= 1) {
    if (!this.elements[i]) {
      data = this.layers[i];
      if (data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st)) {
        this.buildItem(i);
      }
    }
    this.completeLayers = this.elements[i] ? this.completeLayers : false;
  }
  this.checkPendingElements();
};

BaseRenderer.prototype.createItem = function (layer) {
  switch (layer.ty) {
    case 2:
      return this.createImage(layer);
    case 0:
      return this.createComp(layer);
    case 1:
      return this.createSolid(layer);
    case 3:
      return this.createNull(layer);
    case 4:
      return this.createShape(layer);
    case 5:
      return this.createText(layer);
    case 6:
      return this.createAudio(layer);
    case 13:
      return this.createCamera(layer);
    default:
      return this.createNull(layer);
  }
};

BaseRenderer.prototype.createCamera = function () {
  throw new Error('You\'re using a 3d camera. Try the html renderer.');
};

BaseRenderer.prototype.createAudio = function (data) {
  return new AudioElement(data, this.globalData, this);
};

BaseRenderer.prototype.buildAllItems = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    this.buildItem(i);
  }
  this.checkPendingElements();
};

BaseRenderer.prototype.includeLayers = function (newLayers) {
  this.completeLayers = false;
  var i;
  var len = newLayers.length;
  var j;
  var jLen = this.layers.length;
  for (i = 0; i < len; i += 1) {
    j = 0;
    while (j < jLen) {
      if (this.layers[j].id === newLayers[i].id) {
        this.layers[j] = newLayers[i];
        break;
      }
      j += 1;
    }
  }
};

BaseRenderer.prototype.setProjectInterface = function (pInterface) {
  this.globalData.projectInterface = pInterface;
};

BaseRenderer.prototype.initItems = function () {
  if (!this.globalData.progressiveLoad) {
    this.buildAllItems();
  }
};
BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
  var elements = this.elements;
  var layers = this.layers;
  var i = 0;
  var len = layers.length;
  while (i < len) {
    if (layers[i].ind == parentName) { // eslint-disable-line eqeqeq
      if (!elements[i] || elements[i] === true) {
        this.buildItem(i);
        this.addPendingElement(element);
      } else {
        hierarchy.push(elements[i]);
        elements[i].setAsParent();
        if (layers[i].parent !== undefined) {
          this.buildElementParenting(element, layers[i].parent, hierarchy);
        } else {
          element.setHierarchy(hierarchy);
        }
      }
    }
    i += 1;
  }
};

BaseRenderer.prototype.addPendingElement = function (element) {
  this.pendingElements.push(element);
};

BaseRenderer.prototype.searchExtraCompositions = function (assets) {
  var i;
  var len = assets.length;
  for (i = 0; i < len; i += 1) {
    if (assets[i].xt) {
      var comp = this.createComp(assets[i]);
      comp.initExpressions();
      this.globalData.projectInterface.registerComposition(comp);
    }
  }
};

BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
  this.globalData.fontManager = new FontManager();
  this.globalData.fontManager.addChars(animData.chars);
  this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
  this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
  this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
  this.globalData.imageLoader = this.animationItem.imagePreloader;
  this.globalData.audioController = this.animationItem.audioController;
  this.globalData.frameId = 0;
  this.globalData.frameRate = animData.fr;
  this.globalData.nm = animData.nm;
  this.globalData.compSize = {
    w: animData.w,
    h: animData.h,
  };
};

/* global createElementID, extendPrototype, BaseRenderer, NullElement, SVGShapeElement, SVGTextLottieElement,
IImageElement, SVGCompElement, ISolidElement, createNS, locationHref, createSizedArray, expressionsPlugin */

function SVGRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.layers = null;
  this.renderedFrame = -1;
  this.svgElement = createNS('svg');
  var ariaLabel = '';
  if (config && config.title) {
    var titleElement = createNS('title');
    var titleId = createElementID();
    titleElement.setAttribute('id', titleId);
    titleElement.textContent = config.title;
    this.svgElement.appendChild(titleElement);
    ariaLabel += titleId;
  }
  if (config && config.description) {
    var descElement = createNS('desc');
    var descId = createElementID();
    descElement.setAttribute('id', descId);
    descElement.textContent = config.description;
    this.svgElement.appendChild(descElement);
    ariaLabel += ' ' + descId;
  }
  if (ariaLabel) {
    this.svgElement.setAttribute('aria-labelledby', ariaLabel);
  }
  var defs = createNS('defs');
  this.svgElement.appendChild(defs);
  var maskElement = createNS('g');
  this.svgElement.appendChild(maskElement);
  this.layerElement = maskElement;
  this.renderConfig = {
    preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    progressiveLoad: (config && config.progressiveLoad) || false,
    hideOnTransparent: !((config && config.hideOnTransparent === false)),
    viewBoxOnly: (config && config.viewBoxOnly) || false,
    viewBoxSize: (config && config.viewBoxSize) || false,
    className: (config && config.className) || '',
    id: (config && config.id) || '',
    focusable: config && config.focusable,
    filterSize: {
      width: (config && config.filterSize && config.filterSize.width) || '100%',
      height: (config && config.filterSize && config.filterSize.height) || '100%',
      x: (config && config.filterSize && config.filterSize.x) || '0%',
      y: (config && config.filterSize && config.filterSize.y) || '0%',
    },
  };

  this.globalData = {
    _mdf: false,
    frameNum: -1,
    defs: defs,
    renderConfig: this.renderConfig,
  };
  this.elements = [];
  this.pendingElements = [];
  this.destroyed = false;
  this.rendererType = 'svg';
}

extendPrototype([BaseRenderer], SVGRenderer);

SVGRenderer.prototype.createNull = function (data) {
  return new NullElement(data, this.globalData, this);
};

SVGRenderer.prototype.createShape = function (data) {
  return new SVGShapeElement(data, this.globalData, this);
};

SVGRenderer.prototype.createText = function (data) {
  return new SVGTextLottieElement(data, this.globalData, this);
};

SVGRenderer.prototype.createImage = function (data) {
  return new IImageElement(data, this.globalData, this);
};

SVGRenderer.prototype.createComp = function (data) {
  return new SVGCompElement(data, this.globalData, this);
};

SVGRenderer.prototype.createSolid = function (data) {
  return new ISolidElement(data, this.globalData, this);
};

SVGRenderer.prototype.configAnimation = function (animData) {
  this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  if (this.renderConfig.viewBoxSize) {
    this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
  } else {
    this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
  }

  if (!this.renderConfig.viewBoxOnly) {
    this.svgElement.setAttribute('width', animData.w);
    this.svgElement.setAttribute('height', animData.h);
    this.svgElement.style.width = '100%';
    this.svgElement.style.height = '100%';
    this.svgElement.style.transform = 'translate3d(0,0,0)';
  }
  if (this.renderConfig.className) {
    this.svgElement.setAttribute('class', this.renderConfig.className);
  }
  if (this.renderConfig.id) {
    this.svgElement.setAttribute('id', this.renderConfig.id);
  }
  if (this.renderConfig.focusable !== undefined) {
    this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
  }
  this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio);
  // this.layerElement.style.transform = 'translate3d(0,0,0)';
  // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
  this.animationItem.wrapper.appendChild(this.svgElement);
  // Mask animation
  var defs = this.globalData.defs;

  this.setupGlobalData(animData, defs);
  this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
  this.data = animData;

  var maskElement = createNS('clipPath');
  var rect = createNS('rect');
  rect.setAttribute('width', animData.w);
  rect.setAttribute('height', animData.h);
  rect.setAttribute('x', 0);
  rect.setAttribute('y', 0);
  var maskId = createElementID();
  maskElement.setAttribute('id', maskId);
  maskElement.appendChild(rect);
  this.layerElement.setAttribute('clip-path', 'url(' + locationHref + '#' + maskId + ')');

  defs.appendChild(maskElement);
  this.layers = animData.layers;
  this.elements = createSizedArray(animData.layers.length);
};

SVGRenderer.prototype.destroy = function () {
  if (this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  this.layerElement = null;
  this.globalData.defs = null;
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = 0; i < len; i += 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.elements.length = 0;
  this.destroyed = true;
  this.animationItem = null;
};

SVGRenderer.prototype.updateContainerSize = function () {
};

SVGRenderer.prototype.buildItem = function (pos) {
  var elements = this.elements;
  if (elements[pos] || this.layers[pos].ty === 99) {
    return;
  }
  elements[pos] = true;
  var element = this.createItem(this.layers[pos]);

  elements[pos] = element;
  if (expressionsPlugin) {
    if (this.layers[pos].ty === 0) {
      this.globalData.projectInterface.registerComposition(element);
    }
    element.initExpressions();
  }
  this.appendElementInPos(element, pos);
  if (this.layers[pos].tt) {
    if (!this.elements[pos - 1] || this.elements[pos - 1] === true) {
      this.buildItem(pos - 1);
      this.addPendingElement(element);
    } else {
      element.setMatte(elements[pos - 1].layerId);
    }
  }
};

SVGRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
    if (element.data.tt) {
      var i = 0;
      var len = this.elements.length;
      while (i < len) {
        if (this.elements[i] === element) {
          element.setMatte(this.elements[i - 1].layerId);
          break;
        }
        i += 1;
      }
    }
  }
};

SVGRenderer.prototype.renderFrame = function (num) {
  if (this.renderedFrame === num || this.destroyed) {
    return;
  }
  if (num === null) {
    num = this.renderedFrame;
  } else {
    this.renderedFrame = num;
  }
  // console.log('-------');
  // console.log('FRAME ',num);
  this.globalData.frameNum = num;
  this.globalData.frameId += 1;
  this.globalData.projectInterface.currentFrame = num;
  this.globalData._mdf = false;
  var i;
  var len = this.layers.length;
  if (!this.completeLayers) {
    this.checkLayers(num);
  }
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(num - this.layers[i].st);
    }
  }
  if (this.globalData._mdf) {
    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  }
};

SVGRenderer.prototype.appendElementInPos = function (element, pos) {
  var newElement = element.getBaseElement();
  if (!newElement) {
    return;
  }
  var i = 0;
  var nextElement;
  while (i < pos) {
    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
      nextElement = this.elements[i].getBaseElement();
    }
    i += 1;
  }
  if (nextElement) {
    this.layerElement.insertBefore(newElement, nextElement);
  } else {
    this.layerElement.appendChild(newElement);
  }
};

SVGRenderer.prototype.hide = function () {
  this.layerElement.style.display = 'none';
};

SVGRenderer.prototype.show = function () {
  this.layerElement.style.display = 'block';
};

/* global CVContextData, Matrix, extendPrototype, BaseRenderer, CVShapeElement, CVTextElement,
CVImageElement, CVCompElement, CVSolidElement, SVGRenderer, createTag, createSizedArray */

function CanvasRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.renderConfig = {
    clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
    context: (config && config.context) || null,
    progressiveLoad: (config && config.progressiveLoad) || false,
    preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    className: (config && config.className) || '',
    id: (config && config.id) || '',
  };
  this.renderConfig.dpr = (config && config.dpr) || 1;
  if (this.animationItem.wrapper) {
    this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
  }
  this.renderedFrame = -1;
  this.globalData = {
    frameNum: -1,
    _mdf: false,
    renderConfig: this.renderConfig,
    currentGlobalAlpha: -1,
  };
  this.contextData = new CVContextData();
  this.elements = [];
  this.pendingElements = [];
  this.transformMat = new Matrix();
  this.completeLayers = false;
  this.rendererType = 'canvas';
}
extendPrototype([BaseRenderer], CanvasRenderer);

CanvasRenderer.prototype.createShape = function (data) {
  return new CVShapeElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createText = function (data) {
  return new CVTextElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createImage = function (data) {
  return new CVImageElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createComp = function (data) {
  return new CVCompElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createSolid = function (data) {
  return new CVSolidElement(data, this.globalData, this);
};

CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

CanvasRenderer.prototype.ctxTransform = function (props) {
  if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
    return;
  }
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    return;
  }
  this.transformMat.cloneFromProps(props);
  var cProps = this.contextData.cTr.props;
  this.transformMat.transform(cProps[0], cProps[1], cProps[2], cProps[3], cProps[4], cProps[5], cProps[6], cProps[7], cProps[8], cProps[9], cProps[10], cProps[11], cProps[12], cProps[13], cProps[14], cProps[15]);
  // this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
  this.contextData.cTr.cloneFromProps(this.transformMat.props);
  var trProps = this.contextData.cTr.props;
  this.canvasContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
};

CanvasRenderer.prototype.ctxOpacity = function (op) {
  /* if(op === 1){
        return;
    } */
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    this.globalData.currentGlobalAlpha = this.contextData.cO;
    return;
  }
  this.contextData.cO *= op < 0 ? 0 : op;
  if (this.globalData.currentGlobalAlpha !== this.contextData.cO) {
    this.canvasContext.globalAlpha = this.contextData.cO;
    this.globalData.currentGlobalAlpha = this.contextData.cO;
  }
};

CanvasRenderer.prototype.reset = function () {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  this.contextData.reset();
};

CanvasRenderer.prototype.save = function (actionFlag) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.save();
    return;
  }
  if (actionFlag) {
    this.canvasContext.save();
  }
  var props = this.contextData.cTr.props;
  if (this.contextData._length <= this.contextData.cArrPos) {
    this.contextData.duplicate();
  }
  var i;
  var arr = this.contextData.saved[this.contextData.cArrPos];
  for (i = 0; i < 16; i += 1) {
    arr[i] = props[i];
  }
  this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
  this.contextData.cArrPos += 1;
};

CanvasRenderer.prototype.restore = function (actionFlag) {
  if (!this.renderConfig.clearCanvas) {
    this.canvasContext.restore();
    return;
  }
  if (actionFlag) {
    this.canvasContext.restore();
    this.globalData.blendMode = 'source-over';
  }
  this.contextData.cArrPos -= 1;
  var popped = this.contextData.saved[this.contextData.cArrPos];
  var i;
  var arr = this.contextData.cTr.props;
  for (i = 0; i < 16; i += 1) {
    arr[i] = popped[i];
  }
  this.canvasContext.setTransform(popped[0], popped[1], popped[4], popped[5], popped[12], popped[13]);
  popped = this.contextData.savedOp[this.contextData.cArrPos];
  this.contextData.cO = popped;
  if (this.globalData.currentGlobalAlpha !== popped) {
    this.canvasContext.globalAlpha = popped;
    this.globalData.currentGlobalAlpha = popped;
  }
};

CanvasRenderer.prototype.configAnimation = function (animData) {
  if (this.animationItem.wrapper) {
    this.animationItem.container = createTag('canvas');
    var containerStyle = this.animationItem.container.style;
    containerStyle.width = '100%';
    containerStyle.height = '100%';
    var origin = '0px 0px 0px';
    containerStyle.transformOrigin = origin;
    containerStyle.mozTransformOrigin = origin;
    containerStyle.webkitTransformOrigin = origin;
    containerStyle['-webkit-transform'] = origin;
    this.animationItem.wrapper.appendChild(this.animationItem.container);
    this.canvasContext = this.animationItem.container.getContext('2d');
    if (this.renderConfig.className) {
      this.animationItem.container.setAttribute('class', this.renderConfig.className);
    }
    if (this.renderConfig.id) {
      this.animationItem.container.setAttribute('id', this.renderConfig.id);
    }
  } else {
    this.canvasContext = this.renderConfig.context;
  }
  this.data = animData;
  this.layers = animData.layers;
  this.transformCanvas = {
    w: animData.w,
    h: animData.h,
    sx: 0,
    sy: 0,
    tx: 0,
    ty: 0,
  };
  this.setupGlobalData(animData, document.body);
  this.globalData.canvasContext = this.canvasContext;
  this.globalData.renderer = this;
  this.globalData.isDashed = false;
  this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
  this.globalData.transformCanvas = this.transformCanvas;
  this.elements = createSizedArray(animData.layers.length);

  this.updateContainerSize();
};

CanvasRenderer.prototype.updateContainerSize = function () {
  this.reset();
  var elementWidth;
  var elementHeight;
  if (this.animationItem.wrapper && this.animationItem.container) {
    elementWidth = this.animationItem.wrapper.offsetWidth;
    elementHeight = this.animationItem.wrapper.offsetHeight;
    this.animationItem.container.setAttribute('width', elementWidth * this.renderConfig.dpr);
    this.animationItem.container.setAttribute('height', elementHeight * this.renderConfig.dpr);
  } else {
    elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
    elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
  }
  var elementRel;
  var animationRel;
  if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
    var par = this.renderConfig.preserveAspectRatio.split(' ');
    var fillType = par[1] || 'meet';
    var pos = par[0] || 'xMidYMid';
    var xPos = pos.substr(0, 4);
    var yPos = pos.substr(4);
    elementRel = elementWidth / elementHeight;
    animationRel = this.transformCanvas.w / this.transformCanvas.h;
    if ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice')) {
      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
    } else {
      this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
    }

    if (xPos === 'xMid' && ((animationRel < elementRel && fillType === 'meet') || (animationRel > elementRel && fillType === 'slice'))) {
      this.transformCanvas.tx = ((elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2) * this.renderConfig.dpr;
    } else if (xPos === 'xMax' && ((animationRel < elementRel && fillType === 'meet') || (animationRel > elementRel && fillType === 'slice'))) {
      this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
    } else {
      this.transformCanvas.tx = 0;
    }
    if (yPos === 'YMid' && ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice'))) {
      this.transformCanvas.ty = ((elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2) * this.renderConfig.dpr;
    } else if (yPos === 'YMax' && ((animationRel > elementRel && fillType === 'meet') || (animationRel < elementRel && fillType === 'slice'))) {
      this.transformCanvas.ty = ((elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w))) * this.renderConfig.dpr;
    } else {
      this.transformCanvas.ty = 0;
    }
  } else if (this.renderConfig.preserveAspectRatio === 'none') {
    this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
    this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
    this.transformCanvas.tx = 0;
    this.transformCanvas.ty = 0;
  } else {
    this.transformCanvas.sx = this.renderConfig.dpr;
    this.transformCanvas.sy = this.renderConfig.dpr;
    this.transformCanvas.tx = 0;
    this.transformCanvas.ty = 0;
  }
  this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
  /* var i, len = this.elements.length;
    for(i=0;i<len;i+=1){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(this.globalData.transformCanvas);
        }
    } */
  this.ctxTransform(this.transformCanvas.props);
  this.canvasContext.beginPath();
  this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
  this.canvasContext.closePath();
  this.canvasContext.clip();

  this.renderFrame(this.renderedFrame, true);
};

CanvasRenderer.prototype.destroy = function () {
  if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.elements.length = 0;
  this.globalData.canvasContext = null;
  this.animationItem.container = null;
  this.destroyed = true;
};

CanvasRenderer.prototype.renderFrame = function (num, forceRender) {
  if ((this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender) || this.destroyed || num === -1) {
    return;
  }
  this.renderedFrame = num;
  this.globalData.frameNum = num - this.animationItem._isFirstFrame;
  this.globalData.frameId += 1;
  this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
  this.globalData.projectInterface.currentFrame = num;

  // console.log('--------');
  // console.log('NEW: ',num);
  var i;
  var len = this.layers.length;
  if (!this.completeLayers) {
    this.checkLayers(num);
  }

  for (i = 0; i < len; i += 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(num - this.layers[i].st);
    }
  }
  if (this.globalData._mdf) {
    if (this.renderConfig.clearCanvas === true) {
      this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
    } else {
      this.save();
    }
    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
    if (this.renderConfig.clearCanvas !== true) {
      this.restore();
    }
  }
};

CanvasRenderer.prototype.buildItem = function (pos) {
  var elements = this.elements;
  if (elements[pos] || this.layers[pos].ty === 99) {
    return;
  }
  var element = this.createItem(this.layers[pos], this, this.globalData);
  elements[pos] = element;
  element.initExpressions();
  /* if(this.layers[pos].ty === 0){
        element.resize(this.globalData.transformCanvas);
    } */
};

CanvasRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
  }
};

CanvasRenderer.prototype.hide = function () {
  this.animationItem.container.style.display = 'none';
};

CanvasRenderer.prototype.show = function () {
  this.animationItem.container.style.display = 'block';
};

/* global extendPrototype, BaseRenderer, SVGRenderer, SVGShapeElement, HShapeElement, SVGTextLottieElement,
HTextElement, HCameraElement, IImageElement, HImageElement, SVGCompElement, HCompElement, ISolidElement,
HSolidElement, styleDiv, createTag, createNS */

function HybridRenderer(animationItem, config) {
  this.animationItem = animationItem;
  this.layers = null;
  this.renderedFrame = -1;
  this.renderConfig = {
    className: (config && config.className) || '',
    imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
    hideOnTransparent: !(config && config.hideOnTransparent === false),
    filterSize: {
      width: (config && config.filterSize && config.filterSize.width) || '400%',
      height: (config && config.filterSize && config.filterSize.height) || '400%',
      x: (config && config.filterSize && config.filterSize.x) || '-100%',
      y: (config && config.filterSize && config.filterSize.y) || '-100%',
    },
  };
  this.globalData = {
    _mdf: false,
    frameNum: -1,
    renderConfig: this.renderConfig,
  };
  this.pendingElements = [];
  this.elements = [];
  this.threeDElements = [];
  this.destroyed = false;
  this.camera = null;
  this.supports3d = true;
  this.rendererType = 'html';
}

extendPrototype([BaseRenderer], HybridRenderer);

HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;

HybridRenderer.prototype.checkPendingElements = function () {
  while (this.pendingElements.length) {
    var element = this.pendingElements.pop();
    element.checkParenting();
  }
};

HybridRenderer.prototype.appendElementInPos = function (element, pos) {
  var newDOMElement = element.getBaseElement();
  if (!newDOMElement) {
    return;
  }
  var layer = this.layers[pos];
  if (!layer.ddd || !this.supports3d) {
    if (this.threeDElements) {
      this.addTo3dContainer(newDOMElement, pos);
    } else {
      var i = 0;
      var nextDOMElement;
      var nextLayer;
      var tmpDOMElement;
      while (i < pos) {
        if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
          nextLayer = this.elements[i];
          tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
          nextDOMElement = tmpDOMElement || nextDOMElement;
        }
        i += 1;
      }
      if (nextDOMElement) {
        if (!layer.ddd || !this.supports3d) {
          this.layerElement.insertBefore(newDOMElement, nextDOMElement);
        }
      } else if (!layer.ddd || !this.supports3d) {
        this.layerElement.appendChild(newDOMElement);
      }
    }
  } else {
    this.addTo3dContainer(newDOMElement, pos);
  }
};

HybridRenderer.prototype.createShape = function (data) {
  if (!this.supports3d) {
    return new SVGShapeElement(data, this.globalData, this);
  }
  return new HShapeElement(data, this.globalData, this);
};

HybridRenderer.prototype.createText = function (data) {
  if (!this.supports3d) {
    return new SVGTextLottieElement(data, this.globalData, this);
  }
  return new HTextElement(data, this.globalData, this);
};

HybridRenderer.prototype.createCamera = function (data) {
  this.camera = new HCameraElement(data, this.globalData, this);
  return this.camera;
};

HybridRenderer.prototype.createImage = function (data) {
  if (!this.supports3d) {
    return new IImageElement(data, this.globalData, this);
  }
  return new HImageElement(data, this.globalData, this);
};

HybridRenderer.prototype.createComp = function (data) {
  if (!this.supports3d) {
    return new SVGCompElement(data, this.globalData, this);
  }
  return new HCompElement(data, this.globalData, this);
};

HybridRenderer.prototype.createSolid = function (data) {
  if (!this.supports3d) {
    return new ISolidElement(data, this.globalData, this);
  }
  return new HSolidElement(data, this.globalData, this);
};

HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull;

HybridRenderer.prototype.getThreeDContainerByPos = function (pos) {
  var i = 0;
  var len = this.threeDElements.length;
  while (i < len) {
    if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
      return this.threeDElements[i].perspectiveElem;
    }
    i += 1;
  }
  return null;
};

HybridRenderer.prototype.createThreeDContainer = function (pos, type) {
  var perspectiveElem = createTag('div');
  var style;
  var containerStyle;
  styleDiv(perspectiveElem);
  var container = createTag('div');
  styleDiv(container);
  if (type === '3d') {
    style = perspectiveElem.style;
    style.width = this.globalData.compSize.w + 'px';
    style.height = this.globalData.compSize.h + 'px';
    var center = '50% 50%';
    style.webkitTransformOrigin = center;
    style.mozTransformOrigin = center;
    style.transformOrigin = center;
    containerStyle = container.style;
    var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    containerStyle.transform = matrix;
    containerStyle.webkitTransform = matrix;
  }

  perspectiveElem.appendChild(container);
  // this.resizerElem.appendChild(perspectiveElem);
  var threeDContainerData = {
    container: container,
    perspectiveElem: perspectiveElem,
    startPos: pos,
    endPos: pos,
    type: type,
  };
  this.threeDElements.push(threeDContainerData);
  return threeDContainerData;
};

HybridRenderer.prototype.build3dContainers = function () {
  var i;
  var len = this.layers.length;
  var lastThreeDContainerData;
  var currentContainer = '';
  for (i = 0; i < len; i += 1) {
    if (this.layers[i].ddd && this.layers[i].ty !== 3) {
      if (currentContainer !== '3d') {
        currentContainer = '3d';
        lastThreeDContainerData = this.createThreeDContainer(i, '3d');
      }
      lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
    } else {
      if (currentContainer !== '2d') {
        currentContainer = '2d';
        lastThreeDContainerData = this.createThreeDContainer(i, '2d');
      }
      lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
    }
  }
  len = this.threeDElements.length;
  for (i = len - 1; i >= 0; i -= 1) {
    this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
  }
};

HybridRenderer.prototype.addTo3dContainer = function (elem, pos) {
  var i = 0;
  var len = this.threeDElements.length;
  while (i < len) {
    if (pos <= this.threeDElements[i].endPos) {
      var j = this.threeDElements[i].startPos;
      var nextElement;
      while (j < pos) {
        if (this.elements[j] && this.elements[j].getBaseElement) {
          nextElement = this.elements[j].getBaseElement();
        }
        j += 1;
      }
      if (nextElement) {
        this.threeDElements[i].container.insertBefore(elem, nextElement);
      } else {
        this.threeDElements[i].container.appendChild(elem);
      }
      break;
    }
    i += 1;
  }
};

HybridRenderer.prototype.configAnimation = function (animData) {
  var resizerElem = createTag('div');
  var wrapper = this.animationItem.wrapper;
  var style = resizerElem.style;
  style.width = animData.w + 'px';
  style.height = animData.h + 'px';
  this.resizerElem = resizerElem;
  styleDiv(resizerElem);
  style.transformStyle = 'flat';
  style.mozTransformStyle = 'flat';
  style.webkitTransformStyle = 'flat';
  if (this.renderConfig.className) {
    resizerElem.setAttribute('class', this.renderConfig.className);
  }
  wrapper.appendChild(resizerElem);

  style.overflow = 'hidden';
  var svg = createNS('svg');
  svg.setAttribute('width', '1');
  svg.setAttribute('height', '1');
  styleDiv(svg);
  this.resizerElem.appendChild(svg);
  var defs = createNS('defs');
  svg.appendChild(defs);
  this.data = animData;
  // Mask animation
  this.setupGlobalData(animData, svg);
  this.globalData.defs = defs;
  this.layers = animData.layers;
  this.layerElement = this.resizerElem;
  this.build3dContainers();
  this.updateContainerSize();
};

HybridRenderer.prototype.destroy = function () {
  if (this.animationItem.wrapper) {
    this.animationItem.wrapper.innerText = '';
  }
  this.animationItem.container = null;
  this.globalData.defs = null;
  var i;
  var len = this.layers ? this.layers.length : 0;
  for (i = 0; i < len; i += 1) {
    this.elements[i].destroy();
  }
  this.elements.length = 0;
  this.destroyed = true;
  this.animationItem = null;
};

HybridRenderer.prototype.updateContainerSize = function () {
  var elementWidth = this.animationItem.wrapper.offsetWidth;
  var elementHeight = this.animationItem.wrapper.offsetHeight;
  var elementRel = elementWidth / elementHeight;
  var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
  var sx;
  var sy;
  var tx;
  var ty;
  if (animationRel > elementRel) {
    sx = elementWidth / (this.globalData.compSize.w);
    sy = elementWidth / (this.globalData.compSize.w);
    tx = 0;
    ty = ((elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2);
  } else {
    sx = elementHeight / (this.globalData.compSize.h);
    sy = elementHeight / (this.globalData.compSize.h);
    tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
    ty = 0;
  }
  var style = this.resizerElem.style;
  style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
  style.transform = style.webkitTransform;
};

HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

HybridRenderer.prototype.hide = function () {
  this.resizerElem.style.display = 'none';
};

HybridRenderer.prototype.show = function () {
  this.resizerElem.style.display = 'block';
};

HybridRenderer.prototype.initItems = function () {
  this.buildAllItems();
  if (this.camera) {
    this.camera.setup();
  } else {
    var cWidth = this.globalData.compSize.w;
    var cHeight = this.globalData.compSize.h;
    var i;
    var len = this.threeDElements.length;
    for (i = 0; i < len; i += 1) {
      var style = this.threeDElements[i].perspectiveElem.style;
      style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
      style.perspective = style.webkitPerspective;
    }
  }
};

HybridRenderer.prototype.searchExtraCompositions = function (assets) {
  var i;
  var len = assets.length;
  var floatingContainer = createTag('div');
  for (i = 0; i < len; i += 1) {
    if (assets[i].xt) {
      var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
      comp.initExpressions();
      this.globalData.projectInterface.registerComposition(comp);
    }
  }
};

/* global createSizedArray, createElementID, PropertyFactory, ShapePropertyFactory, createNS, locationHref */

function MaskElement(data, element, globalData) {
  this.data = data;
  this.element = element;
  this.globalData = globalData;
  this.storedData = [];
  this.masksProperties = this.data.masksProperties || [];
  this.maskElement = null;
  var defs = this.globalData.defs;
  var i;
  var len = this.masksProperties ? this.masksProperties.length : 0;
  this.viewData = createSizedArray(len);
  this.solidPath = '';

  var path;
  var properties = this.masksProperties;
  var count = 0;
  var currentMasks = [];
  var j;
  var jLen;
  var layerId = createElementID();
  var rect;
  var expansor;
  var feMorph;
  var x;
  var maskType = 'clipPath';
  var maskRef = 'clip-path';
  for (i = 0; i < len; i += 1) {
    if ((properties[i].mode !== 'a' && properties[i].mode !== 'n') || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
      maskType = 'mask';
      maskRef = 'mask';
    }

    if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
      rect = createNS('rect');
      rect.setAttribute('fill', '#ffffff');
      rect.setAttribute('width', this.element.comp.data.w || 0);
      rect.setAttribute('height', this.element.comp.data.h || 0);
      currentMasks.push(rect);
    } else {
      rect = null;
    }

    path = createNS('path');
    if (properties[i].mode === 'n') {
      // TODO move this to a factory or to a constructor
      this.viewData[i] = {
        op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
        prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
        elem: path,
        lastPath: '',
      };
      defs.appendChild(path);
    } else {
      count += 1;

      path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
      path.setAttribute('clip-rule', 'nonzero');
      var filterID;

      if (properties[i].x.k !== 0) {
        maskType = 'mask';
        maskRef = 'mask';
        x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
        filterID = createElementID();
        expansor = createNS('filter');
        expansor.setAttribute('id', filterID);
        feMorph = createNS('feMorphology');
        feMorph.setAttribute('operator', 'erode');
        feMorph.setAttribute('in', 'SourceGraphic');
        feMorph.setAttribute('radius', '0');
        expansor.appendChild(feMorph);
        defs.appendChild(expansor);
        path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
      } else {
        feMorph = null;
        x = null;
      }

      // TODO move this to a factory or to a constructor
      this.storedData[i] = {
        elem: path,
        x: x,
        expan: feMorph,
        lastPath: '',
        lastOperator: '',
        filterId: filterID,
        lastRadius: 0,
      };
      if (properties[i].mode === 'i') {
        jLen = currentMasks.length;
        var g = createNS('g');
        for (j = 0; j < jLen; j += 1) {
          g.appendChild(currentMasks[j]);
        }
        var mask = createNS('mask');
        mask.setAttribute('mask-type', 'alpha');
        mask.setAttribute('id', layerId + '_' + count);
        mask.appendChild(path);
        defs.appendChild(mask);
        g.setAttribute('mask', 'url(' + locationHref + '#' + layerId + '_' + count + ')');

        currentMasks.length = 0;
        currentMasks.push(g);
      } else {
        currentMasks.push(path);
      }
      if (properties[i].inv && !this.solidPath) {
        this.solidPath = this.createLayerSolidPath();
      }
      // TODO move this to a factory or to a constructor
      this.viewData[i] = {
        elem: path,
        lastPath: '',
        op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
        prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
        invRect: rect,
      };
      if (!this.viewData[i].prop.k) {
        this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
      }
    }
  }

  this.maskElement = createNS(maskType);

  len = currentMasks.length;
  for (i = 0; i < len; i += 1) {
    this.maskElement.appendChild(currentMasks[i]);
  }

  if (count > 0) {
    this.maskElement.setAttribute('id', layerId);
    this.element.maskedElement.setAttribute(maskRef, 'url(' + locationHref + '#' + layerId + ')');
    defs.appendChild(this.maskElement);
  }
  if (this.viewData.length) {
    this.element.addRenderableComponent(this);
  }
}

MaskElement.prototype.getMaskProperty = function (pos) {
  return this.viewData[pos].prop;
};

MaskElement.prototype.renderFrame = function (isFirstFrame) {
  var finalMat = this.element.finalTransform.mat;
  var i;
  var len = this.masksProperties.length;
  for (i = 0; i < len; i += 1) {
    if (this.viewData[i].prop._mdf || isFirstFrame) {
      this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
    }
    if (this.viewData[i].op._mdf || isFirstFrame) {
      this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
    }
    if (this.masksProperties[i].mode !== 'n') {
      if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
        this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
      }
      if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
        var feMorph = this.storedData[i].expan;
        if (this.storedData[i].x.v < 0) {
          if (this.storedData[i].lastOperator !== 'erode') {
            this.storedData[i].lastOperator = 'erode';
            this.storedData[i].elem.setAttribute('filter', 'url(' + locationHref + '#' + this.storedData[i].filterId + ')');
          }
          feMorph.setAttribute('radius', -this.storedData[i].x.v);
        } else {
          if (this.storedData[i].lastOperator !== 'dilate') {
            this.storedData[i].lastOperator = 'dilate';
            this.storedData[i].elem.setAttribute('filter', null);
          }
          this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
        }
      }
    }
  }
};

MaskElement.prototype.getMaskelement = function () {
  return this.maskElement;
};

MaskElement.prototype.createLayerSolidPath = function () {
  var path = 'M0,0 ';
  path += ' h' + this.globalData.compSize.w;
  path += ' v' + this.globalData.compSize.h;
  path += ' h-' + this.globalData.compSize.w;
  path += ' v-' + this.globalData.compSize.h + ' ';
  return path;
};

MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
  var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
  var i;
  var len;
  len = pathNodes._length;
  for (i = 1; i < len; i += 1) {
    // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
  }
  // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
  if (pathNodes.c && len > 1) {
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
  }
  // pathNodes.__renderedString = pathString;

  if (viewData.lastPath !== pathString) {
    var pathShapeValue = '';
    if (viewData.elem) {
      if (pathNodes.c) {
        pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
      }
      viewData.elem.setAttribute('d', pathShapeValue);
    }
    viewData.lastPath = pathString;
  }
};

MaskElement.prototype.destroy = function () {
  this.element = null;
  this.globalData = null;
  this.maskElement = null;
  this.data = null;
  this.masksProperties = null;
};

/**
 * @file
 * Handles AE's layer parenting property.
 *
 */

function HierarchyElement() {}

HierarchyElement.prototype = {
  /**
     * @function
     * Initializes hierarchy properties
     *
     */
  initHierarchy: function () {
    // element's parent list
    this.hierarchy = [];
    // if element is parent of another layer _isParent will be true
    this._isParent = false;
    this.checkParenting();
  },
  /**
     * @function
     * Sets layer's hierarchy.
     * @param {array} hierarch
     * layer's parent list
     *
     */
  setHierarchy: function (hierarchy) {
    this.hierarchy = hierarchy;
  },
  /**
     * @function
     * Sets layer as parent.
     *
     */
  setAsParent: function () {
    this._isParent = true;
  },
  /**
     * @function
     * Searches layer's parenting chain
     *
     */
  checkParenting: function () {
    if (this.data.parent !== undefined) {
      this.comp.buildElementParenting(this, this.data.parent, []);
    }
  },
};

/**
 * @file
 * Handles element's layer frame update.
 * Checks layer in point and out point
 *
 */

function FrameElement() {}

FrameElement.prototype = {
  /**
     * @function
     * Initializes frame related properties.
     *
     */
  initFrame: function () {
    // set to true when inpoint is rendered
    this._isFirstFrame = false;
    // list of animated properties
    this.dynamicProperties = [];
    // If layer has been modified in current tick this will be true
    this._mdf = false;
  },
  /**
     * @function
     * Calculates all dynamic values
     *
     * @param {number} num
     * current frame number in Layer's time
     * @param {boolean} isVisible
     * if layers is currently in range
     *
     */
  prepareProperties: function (num, isVisible) {
    var i;
    var len = this.dynamicProperties.length;
    for (i = 0; i < len; i += 1) {
      if (isVisible || (this._isParent && this.dynamicProperties[i].propType === 'transform')) {
        this.dynamicProperties[i].getValue();
        if (this.dynamicProperties[i]._mdf) {
          this.globalData._mdf = true;
          this._mdf = true;
        }
      }
    }
  },
  addDynamicProperty: function (prop) {
    if (this.dynamicProperties.indexOf(prop) === -1) {
      this.dynamicProperties.push(prop);
    }
  },
};

/* global TransformPropertyFactory, Matrix */

function TransformElement() {}

TransformElement.prototype = {
  initTransform: function () {
    this.finalTransform = {
      mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : { o: 0 },
      _matMdf: false,
      _opMdf: false,
      mat: new Matrix(),
    };
    if (this.data.ao) {
      this.finalTransform.mProp.autoOriented = true;
    }

    // TODO: check TYPE 11: Guided elements
    if (this.data.ty !== 11) {
      // this.createElements();
    }
  },
  renderTransform: function () {
    this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
    this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

    if (this.hierarchy) {
      var mat;
      var finalMat = this.finalTransform.mat;
      var i = 0;
      var len = this.hierarchy.length;
      // Checking if any of the transformation matrices in the hierarchy chain has changed.
      if (!this.finalTransform._matMdf) {
        while (i < len) {
          if (this.hierarchy[i].finalTransform.mProp._mdf) {
            this.finalTransform._matMdf = true;
            break;
          }
          i += 1;
        }
      }

      if (this.finalTransform._matMdf) {
        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for (i = 0; i < len; i += 1) {
          mat = this.hierarchy[i].finalTransform.mProp.v.props;
          finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
        }
      }
    }
  },
  globalToLocal: function (pt) {
    var transforms = [];
    transforms.push(this.finalTransform);
    var flag = true;
    var comp = this.comp;
    while (flag) {
      if (comp.finalTransform) {
        if (comp.data.hasMask) {
          transforms.splice(0, 0, comp.finalTransform);
        }
        comp = comp.comp;
      } else {
        flag = false;
      }
    }
    var i;
    var len = transforms.length;
    var ptNew;
    for (i = 0; i < len; i += 1) {
      ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
      // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
      pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
    }
    return pt;
  },
  mHelper: new Matrix(),
};

function RenderableElement() {

}

RenderableElement.prototype = {
  initRenderable: function () {
    // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
    this.isInRange = false;
    // layer's display state
    this.hidden = false;
    // If layer's transparency equals 0, it can be hidden
    this.isTransparent = false;
    // list of animated components
    this.renderableComponents = [];
  },
  addRenderableComponent: function (component) {
    if (this.renderableComponents.indexOf(component) === -1) {
      this.renderableComponents.push(component);
    }
  },
  removeRenderableComponent: function (component) {
    if (this.renderableComponents.indexOf(component) !== -1) {
      this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
    }
  },
  prepareRenderableFrame: function (num) {
    this.checkLayerLimits(num);
  },
  checkTransparency: function () {
    if (this.finalTransform.mProp.o.v <= 0) {
      if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
        this.isTransparent = true;
        this.hide();
      }
    } else if (this.isTransparent) {
      this.isTransparent = false;
      this.show();
    }
  },
  /**
     * @function
     * Initializes frame related properties.
     *
     * @param {number} num
     * current frame number in Layer's time
     *
     */
  checkLayerLimits: function (num) {
    if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
      if (this.isInRange !== true) {
        this.globalData._mdf = true;
        this._mdf = true;
        this.isInRange = true;
        this.show();
      }
    } else if (this.isInRange !== false) {
      this.globalData._mdf = true;
      this.isInRange = false;
      this.hide();
    }
  },
  renderRenderable: function () {
    var i;
    var len = this.renderableComponents.length;
    for (i = 0; i < len; i += 1) {
      this.renderableComponents[i].renderFrame(this._isFirstFrame);
    }
    /* this.maskManager.renderFrame(this.finalTransform.mat);
        this.renderableEffectsManager.renderFrame(this._isFirstFrame); */
  },
  sourceRectAtTime: function () {
    return {
      top: 0,
      left: 0,
      width: 100,
      height: 100,
    };
  },
  getLayerSize: function () {
    if (this.data.ty === 5) {
      return { w: this.data.textData.width, h: this.data.textData.height };
    }
    return { w: this.data.width, h: this.data.height };
  },
};

/* global extendPrototype, RenderableElement, createProxyFunction */

function RenderableDOMElement() {}

(function () {
  var _prototype = {
    initElement: function (data, globalData, comp) {
      this.initFrame();
      this.initBaseData(data, globalData, comp);
      this.initTransform(data, globalData, comp);
      this.initHierarchy();
      this.initRenderable();
      this.initRendererElement();
      this.createContainerElements();
      this.createRenderableComponents();
      this.createContent();
      this.hide();
    },
    hide: function () {
      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
        var elem = this.baseElement || this.layerElement;
        elem.style.display = 'none';
        this.hidden = true;
      }
    },
    show: function () {
      if (this.isInRange && !this.isTransparent) {
        if (!this.data.hd) {
          var elem = this.baseElement || this.layerElement;
          elem.style.display = 'block';
        }
        this.hidden = false;
        this._isFirstFrame = true;
      }
    },
    renderFrame: function () {
      // If it is exported as hidden (data.hd === true) no need to render
      // If it is not visible no need to render
      if (this.data.hd || this.hidden) {
        return;
      }
      this.renderTransform();
      this.renderRenderable();
      this.renderElement();
      this.renderInnerContent();
      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    renderInnerContent: function () {},
    prepareFrame: function (num) {
      this._mdf = false;
      this.prepareRenderableFrame(num);
      this.prepareProperties(num, this.isInRange);
      this.checkTransparency();
    },
    destroy: function () {
      this.innerElem = null;
      this.destroyBaseElement();
    },
  };
  extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
}());

/* exported ProcessedElement */

function ProcessedElement(element, position) {
  this.elem = element;
  this.pos = position;
}

/* global createNS */

function SVGStyleData(data, level) {
  this.data = data;
  this.type = data.ty;
  this.d = '';
  this.lvl = level;
  this._mdf = false;
  this.closed = data.hd === true;
  this.pElem = createNS('path');
  this.msElem = null;
}

SVGStyleData.prototype.reset = function () {
  this.d = '';
  this._mdf = false;
};

function SVGShapeData(transformers, level, shape) {
  this.caches = [];
  this.styles = [];
  this.transformers = transformers;
  this.lStr = '';
  this.sh = shape;
  this.lvl = level;
  // TODO find if there are some cases where _isAnimated can be false.
  // For now, since shapes add up with other shapes. They have to be calculated every time.
  // One way of finding out is checking if all styles associated to this shape depend only of this shape
  this._isAnimated = !!shape.k;
  // TODO: commenting this for now since all shapes are animated
  var i = 0;
  var len = transformers.length;
  while (i < len) {
    if (transformers[i].mProps.dynamicProperties.length) {
      this._isAnimated = true;
      break;
    }
    i += 1;
  }
}

SVGShapeData.prototype.setAsAnimated = function () {
  this._isAnimated = true;
};

/* exported SVGTransformData */

function SVGTransformData(mProps, op, container) {
  this.transform = {
    mProps: mProps,
    op: op,
    container: container,
  };
  this.elements = [];
  this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
}

/* global DashProperty, PropertyFactory, extendPrototype, DynamicPropertyContainer */

function SVGStrokeStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
  this.d = new DashProperty(elem, data.d || {}, 'svg', this);
  this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
  this.style = styleOb;
  this._isAnimated = !!this._isAnimated;
}

extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

/* global PropertyFactory, extendPrototype, DynamicPropertyContainer */

function SVGFillStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
  this.style = styleOb;
}

extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

/* global PropertyFactory, degToRads, GradientProperty, createElementID, createNS, locationHref,
extendPrototype, DynamicPropertyContainer */

function SVGGradientFillStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.initGradientData(elem, data, styleOb);
}

SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
  this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
  this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
  this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
  this.h = PropertyFactory.getProp(elem, data.h || { k: 0 }, 0, 0.01, this);
  this.a = PropertyFactory.getProp(elem, data.a || { k: 0 }, 0, degToRads, this);
  this.g = new GradientProperty(elem, data.g, this);
  this.style = styleOb;
  this.stops = [];
  this.setGradientData(styleOb.pElem, data);
  this.setGradientOpacity(data, styleOb);
  this._isAnimated = !!this._isAnimated;
};

SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
  var gradientId = createElementID();
  var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
  gfill.setAttribute('id', gradientId);
  gfill.setAttribute('spreadMethod', 'pad');
  gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
  var stops = [];
  var stop;
  var j;
  var jLen;
  jLen = data.g.p * 4;
  for (j = 0; j < jLen; j += 4) {
    stop = createNS('stop');
    gfill.appendChild(stop);
    stops.push(stop);
  }
  pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + locationHref + '#' + gradientId + ')');

  this.gf = gfill;
  this.cst = stops;
};

SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
  if (this.g._hasOpacity && !this.g._collapsable) {
    var stop;
    var j;
    var jLen;
    var mask = createNS('mask');
    var maskElement = createNS('path');
    mask.appendChild(maskElement);
    var opacityId = createElementID();
    var maskId = createElementID();
    mask.setAttribute('id', maskId);
    var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    opFill.setAttribute('id', opacityId);
    opFill.setAttribute('spreadMethod', 'pad');
    opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
    jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
    var stops = this.stops;
    for (j = data.g.p * 4; j < jLen; j += 2) {
      stop = createNS('stop');
      stop.setAttribute('stop-color', 'rgb(255,255,255)');
      opFill.appendChild(stop);
      stops.push(stop);
    }
    maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + locationHref + '#' + opacityId + ')');
    this.of = opFill;
    this.ms = mask;
    this.ost = stops;
    this.maskId = maskId;
    styleOb.msElem = maskElement;
  }
};

extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

/* global PropertyFactory, DashProperty, extendPrototype, SVGGradientFillStyleData, DynamicPropertyContainer */

function SVGGradientStrokeStyleData(elem, data, styleOb) {
  this.initDynamicPropertyContainer(elem);
  this.getValue = this.iterateDynamicProperties;
  this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
  this.d = new DashProperty(elem, data.d || {}, 'svg', this);
  this.initGradientData(elem, data, styleOb);
  this._isAnimated = !!this._isAnimated;
}

extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

/* global createNS */
/* exported ShapeGroupData */

function ShapeGroupData() {
  this.it = [];
  this.prevViewData = [];
  this.gr = createNS('g');
}

/* global Matrix, buildShapeString, bmFloor */
/* exported SVGElementsRenderer */

var SVGElementsRenderer = (function () {
  var _identityMatrix = new Matrix();
  var _matrixHelper = new Matrix();

  var ob = {
    createRenderFunction: createRenderFunction,
  };

  function createRenderFunction(data) {
    switch (data.ty) {
      case 'fl':
        return renderFill;
      case 'gf':
        return renderGradient;
      case 'gs':
        return renderGradientStroke;
      case 'st':
        return renderStroke;
      case 'sh':
      case 'el':
      case 'rc':
      case 'sr':
        return renderPath;
      case 'tr':
        return renderContentTransform;
      default:
        return null;
    }
  }

  function renderContentTransform(styleData, itemData, isFirstFrame) {
    if (isFirstFrame || itemData.transform.op._mdf) {
      itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
    }
    if (isFirstFrame || itemData.transform.mProps._mdf) {
      itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
    }
  }

  function renderPath(styleData, itemData, isFirstFrame) {
    var j;
    var jLen;
    var pathStringTransformed;
    var redraw;
    var pathNodes;
    var l;
    var lLen = itemData.styles.length;
    var lvl = itemData.lvl;
    var paths;
    var mat;
    var props;
    var iterations;
    var k;
    for (l = 0; l < lLen; l += 1) {
      redraw = itemData.sh._mdf || isFirstFrame;
      if (itemData.styles[l].lvl < lvl) {
        mat = _matrixHelper.reset();
        iterations = lvl - itemData.styles[l].lvl;
        k = itemData.transformers.length - 1;
        while (!redraw && iterations > 0) {
          redraw = itemData.transformers[k].mProps._mdf || redraw;
          iterations -= 1;
          k -= 1;
        }
        if (redraw) {
          iterations = lvl - itemData.styles[l].lvl;
          k = itemData.transformers.length - 1;
          while (iterations > 0) {
            props = itemData.transformers[k].mProps.v.props;
            mat.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
            iterations -= 1;
            k -= 1;
          }
        }
      } else {
        mat = _identityMatrix;
      }
      paths = itemData.sh.paths;
      jLen = paths._length;
      if (redraw) {
        pathStringTransformed = '';
        for (j = 0; j < jLen; j += 1) {
          pathNodes = paths.shapes[j];
          if (pathNodes && pathNodes._length) {
            pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
          }
        }
        itemData.caches[l] = pathStringTransformed;
      } else {
        pathStringTransformed = itemData.caches[l];
      }
      itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
      itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
    }
  }

  function renderFill(styleData, itemData, isFirstFrame) {
    var styleElem = itemData.style;

    if (itemData.c._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
    }
    if (itemData.o._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
    }
  }

  function renderGradientStroke(styleData, itemData, isFirstFrame) {
    renderGradient(styleData, itemData, isFirstFrame);
    renderStroke(styleData, itemData, isFirstFrame);
  }

  function renderGradient(styleData, itemData, isFirstFrame) {
    var gfill = itemData.gf;
    var hasOpacity = itemData.g._hasOpacity;
    var pt1 = itemData.s.v;
    var pt2 = itemData.e.v;

    if (itemData.o._mdf || isFirstFrame) {
      var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
      itemData.style.pElem.setAttribute(attr, itemData.o.v);
    }
    if (itemData.s._mdf || isFirstFrame) {
      var attr1 = styleData.t === 1 ? 'x1' : 'cx';
      var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
      gfill.setAttribute(attr1, pt1[0]);
      gfill.setAttribute(attr2, pt1[1]);
      if (hasOpacity && !itemData.g._collapsable) {
        itemData.of.setAttribute(attr1, pt1[0]);
        itemData.of.setAttribute(attr2, pt1[1]);
      }
    }
    var stops;
    var i;
    var len;
    var stop;
    if (itemData.g._cmdf || isFirstFrame) {
      stops = itemData.cst;
      var cValues = itemData.g.c;
      len = stops.length;
      for (i = 0; i < len; i += 1) {
        stop = stops[i];
        stop.setAttribute('offset', cValues[i * 4] + '%');
        stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
      }
    }
    if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
      var oValues = itemData.g.o;
      if (itemData.g._collapsable) {
        stops = itemData.cst;
      } else {
        stops = itemData.ost;
      }
      len = stops.length;
      for (i = 0; i < len; i += 1) {
        stop = stops[i];
        if (!itemData.g._collapsable) {
          stop.setAttribute('offset', oValues[i * 2] + '%');
        }
        stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
      }
    }
    if (styleData.t === 1) {
      if (itemData.e._mdf || isFirstFrame) {
        gfill.setAttribute('x2', pt2[0]);
        gfill.setAttribute('y2', pt2[1]);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('x2', pt2[0]);
          itemData.of.setAttribute('y2', pt2[1]);
        }
      }
    } else {
      var rad;
      if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
        rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        gfill.setAttribute('r', rad);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('r', rad);
        }
      }
      if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
        if (!rad) {
          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        }
        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

        var percent = itemData.h.v;
        if (percent >= 1) {
          percent = 0.99;
        } else if (percent <= -1) {
          percent = -0.99;
        }
        var dist = rad * percent;
        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
        gfill.setAttribute('fx', x);
        gfill.setAttribute('fy', y);
        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute('fx', x);
          itemData.of.setAttribute('fy', y);
        }
      }
      // gfill.setAttribute('fy','200');
    }
  }

  function renderStroke(styleData, itemData, isFirstFrame) {
    var styleElem = itemData.style;
    var d = itemData.d;
    if (d && (d._mdf || isFirstFrame) && d.dashStr) {
      styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
      styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
    }
    if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
      styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
    }
    if (itemData.o._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
    }
    if (itemData.w._mdf || isFirstFrame) {
      styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
      if (styleElem.msElem) {
        styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
      }
    }
  }

  return ob;
}());

/* global Matrix */

function ShapeTransformManager() {
  this.sequences = {};
  this.sequenceList = [];
  this.transform_key_count = 0;
}

ShapeTransformManager.prototype = {
  addTransformSequence: function (transforms) {
    var i;
    var len = transforms.length;
    var key = '_';
    for (i = 0; i < len; i += 1) {
      key += transforms[i].transform.key + '_';
    }
    var sequence = this.sequences[key];
    if (!sequence) {
      sequence = {
        transforms: [].concat(transforms),
        finalTransform: new Matrix(),
        _mdf: false,
      };
      this.sequences[key] = sequence;
      this.sequenceList.push(sequence);
    }
    return sequence;
  },
  processSequence: function (sequence, isFirstFrame) {
    var i = 0;
    var len = sequence.transforms.length;
    var _mdf = isFirstFrame;
    while (i < len && !isFirstFrame) {
      if (sequence.transforms[i].transform.mProps._mdf) {
        _mdf = true;
        break;
      }
      i += 1;
    }
    if (_mdf) {
      var props;
      sequence.finalTransform.reset();
      for (i = len - 1; i >= 0; i -= 1) {
        props = sequence.transforms[i].transform.mProps.v.props;
        sequence.finalTransform.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
      }
    }
    sequence._mdf = _mdf;
  },
  processSequences: function (isFirstFrame) {
    var i;
    var len = this.sequenceList.length;
    for (i = 0; i < len; i += 1) {
      this.processSequence(this.sequenceList[i], isFirstFrame);
    }
  },
  getNewKey: function () {
    this.transform_key_count += 1;
    return '_' + this.transform_key_count;
  },
};

/* global ShapePropertyFactory, SVGShapeData */

function CVShapeData(element, data, styles, transformsManager) {
  this.styledShapes = [];
  this.tr = [0, 0, 0, 0, 0, 0];
  var ty = 4;
  if (data.ty === 'rc') {
    ty = 5;
  } else if (data.ty === 'el') {
    ty = 6;
  } else if (data.ty === 'sr') {
    ty = 7;
  }
  this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
  var i;
  var len = styles.length;
  var styledShape;
  for (i = 0; i < len; i += 1) {
    if (!styles[i].closed) {
      styledShape = {
        transforms: transformsManager.addTransformSequence(styles[i].transforms),
        trNodes: [],
      };
      this.styledShapes.push(styledShape);
      styles[i].elements.push(styledShape);
    }
  }
}

CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

/* global LayerExpressionInterface, EffectsExpressionInterface, CompExpressionInterface, ShapeExpressionInterface,
TextExpressionInterface, getBlendMode,createElementID, EffectsManager */

function BaseElement() {
}

BaseElement.prototype = {
  checkMasks: function () {
    if (!this.data.hasMask) {
      return false;
    }
    var i = 0;
    var len = this.data.masksProperties.length;
    while (i < len) {
      if ((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
        return true;
      }
      i += 1;
    }
    return false;
  },
  initExpressions: function () {
    this.layerInterface = LayerExpressionInterface(this);
    if (this.data.hasMask && this.maskManager) {
      this.layerInterface.registerMaskInterface(this.maskManager);
    }
    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
    this.layerInterface.registerEffectsInterface(effectsInterface);

    if (this.data.ty === 0 || this.data.xt) {
      this.compInterface = CompExpressionInterface(this);
    } else if (this.data.ty === 4) {
      this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
      this.layerInterface.content = this.layerInterface.shapeInterface;
    } else if (this.data.ty === 5) {
      this.layerInterface.textInterface = TextExpressionInterface(this);
      this.layerInterface.text = this.layerInterface.textInterface;
    }
  },
  setBlendMode: function () {
    var blendModeValue = getBlendMode(this.data.bm);
    var elem = this.baseElement || this.layerElement;

    elem.style['mix-blend-mode'] = blendModeValue;
  },
  initBaseData: function (data, globalData, comp) {
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.layerId = createElementID();

    // Stretch factor for old animations missing this property.
    if (!this.data.sr) {
      this.data.sr = 1;
    }
    // effects manager
    this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
  },
  getType: function () {
    return this.type;
  },
  sourceRectAtTime: function () {},
};

/* global extendPrototype, BaseElement, TransformElement, HierarchyElement, FrameElement */

function NullElement(data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initFrame();
  this.initTransform(data, globalData, comp);
  this.initHierarchy();
}

NullElement.prototype.prepareFrame = function (num) {
  this.prepareProperties(num, true);
};

NullElement.prototype.renderFrame = function () {
};

NullElement.prototype.getBaseElement = function () {
  return null;
};

NullElement.prototype.destroy = function () {
};

NullElement.prototype.sourceRectAtTime = function () {
};

NullElement.prototype.hide = function () {
};

extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

/* global filtersFactory, featureSupport, filtersFactory, createElementID, createNS, MaskElement, SVGEffects, locationHref */

function SVGBaseElement() {
}

SVGBaseElement.prototype = {
  initRendererElement: function () {
    this.layerElement = createNS('g');
  },
  createContainerElements: function () {
    this.matteElement = createNS('g');
    this.transformedElement = this.layerElement;
    this.maskedElement = this.layerElement;
    this._sizeChanged = false;
    var layerElementParent = null;
    // If this layer acts as a mask for the following layer
    var filId;
    var fil;
    var gg;
    if (this.data.td) {
      if (this.data.td == 3 || this.data.td == 1) { // eslint-disable-line eqeqeq
        var masker = createNS('mask');
        masker.setAttribute('id', this.layerId);
        masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha'); // eslint-disable-line eqeqeq
        masker.appendChild(this.layerElement);
        layerElementParent = masker;
        this.globalData.defs.appendChild(masker);
        // This is only for IE and Edge when mask if of type alpha
        if (!featureSupport.maskType && this.data.td == 1) { // eslint-disable-line eqeqeq
          masker.setAttribute('mask-type', 'luminance');
          filId = createElementID();
          fil = filtersFactory.createFilter(filId);
          this.globalData.defs.appendChild(fil);
          fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
          gg = createNS('g');
          gg.appendChild(this.layerElement);
          layerElementParent = gg;
          masker.appendChild(gg);
          gg.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
        }
      } else if (this.data.td == 2) { // eslint-disable-line eqeqeq
        var maskGroup = createNS('mask');
        maskGroup.setAttribute('id', this.layerId);
        maskGroup.setAttribute('mask-type', 'alpha');
        var maskGrouper = createNS('g');
        maskGroup.appendChild(maskGrouper);
        filId = createElementID();
        fil = filtersFactory.createFilter(filId);
        /// /

        // This solution doesn't work on Android when meta tag with viewport attribute is set
        /* var feColorMatrix = createNS('feColorMatrix');
                feColorMatrix.setAttribute('type', 'matrix');
                feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
                feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
                fil.appendChild(feColorMatrix); */
        /// /
        var feCTr = createNS('feComponentTransfer');
        feCTr.setAttribute('in', 'SourceGraphic');
        fil.appendChild(feCTr);
        var feFunc = createNS('feFuncA');
        feFunc.setAttribute('type', 'table');
        feFunc.setAttribute('tableValues', '1.0 0.0');
        feCTr.appendChild(feFunc);
        /// /
        this.globalData.defs.appendChild(fil);
        var alphaRect = createNS('rect');
        alphaRect.setAttribute('width', this.comp.data.w);
        alphaRect.setAttribute('height', this.comp.data.h);
        alphaRect.setAttribute('x', '0');
        alphaRect.setAttribute('y', '0');
        alphaRect.setAttribute('fill', '#ffffff');
        alphaRect.setAttribute('opacity', '0');
        maskGrouper.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
        maskGrouper.appendChild(alphaRect);
        maskGrouper.appendChild(this.layerElement);
        layerElementParent = maskGrouper;
        if (!featureSupport.maskType) {
          maskGroup.setAttribute('mask-type', 'luminance');
          fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
          gg = createNS('g');
          maskGrouper.appendChild(alphaRect);
          gg.appendChild(this.layerElement);
          layerElementParent = gg;
          maskGrouper.appendChild(gg);
        }
        this.globalData.defs.appendChild(maskGroup);
      }
    } else if (this.data.tt) {
      this.matteElement.appendChild(this.layerElement);
      layerElementParent = this.matteElement;
      this.baseElement = this.matteElement;
    } else {
      this.baseElement = this.layerElement;
    }
    if (this.data.ln) {
      this.layerElement.setAttribute('id', this.data.ln);
    }
    if (this.data.cl) {
      this.layerElement.setAttribute('class', this.data.cl);
    }
    // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
    if (this.data.ty === 0 && !this.data.hd) {
      var cp = createNS('clipPath');
      var pt = createNS('path');
      pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
      var clipId = createElementID();
      cp.setAttribute('id', clipId);
      cp.appendChild(pt);
      this.globalData.defs.appendChild(cp);

      if (this.checkMasks()) {
        var cpGroup = createNS('g');
        cpGroup.setAttribute('clip-path', 'url(' + locationHref + '#' + clipId + ')');
        cpGroup.appendChild(this.layerElement);
        this.transformedElement = cpGroup;
        if (layerElementParent) {
          layerElementParent.appendChild(this.transformedElement);
        } else {
          this.baseElement = this.transformedElement;
        }
      } else {
        this.layerElement.setAttribute('clip-path', 'url(' + locationHref + '#' + clipId + ')');
      }
    }
    if (this.data.bm !== 0) {
      this.setBlendMode();
    }
  },
  renderElement: function () {
    if (this.finalTransform._matMdf) {
      this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
    }
    if (this.finalTransform._opMdf) {
      this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
    }
  },
  destroyBaseElement: function () {
    this.layerElement = null;
    this.matteElement = null;
    this.maskManager.destroy();
  },
  getBaseElement: function () {
    if (this.data.hd) {
      return null;
    }
    return this.baseElement;
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData);
    this.renderableEffectsManager = new SVGEffects(this);
  },
  setMatte: function (id) {
    if (!this.matteElement) {
      return;
    }
    this.matteElement.setAttribute('mask', 'url(' + locationHref + '#' + id + ')');
  },
};

/* global ProcessedElement */

function IShapeElement() {
}

IShapeElement.prototype = {
  addShapeToModifiers: function (data) {
    var i;
    var len = this.shapeModifiers.length;
    for (i = 0; i < len; i += 1) {
      this.shapeModifiers[i].addShape(data);
    }
  },
  isShapeInAnimatedModifiers: function (data) {
    var i = 0;
    var len = this.shapeModifiers.length;
    while (i < len) {
      if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
        return true;
      }
    }
    return false;
  },
  renderModifiers: function () {
    if (!this.shapeModifiers.length) {
      return;
    }
    var i;
    var len = this.shapes.length;
    for (i = 0; i < len; i += 1) {
      this.shapes[i].sh.reset();
    }

    len = this.shapeModifiers.length;
    for (i = len - 1; i >= 0; i -= 1) {
      this.shapeModifiers[i].processShapes(this._isFirstFrame);
    }
  },
  lcEnum: {
    1: 'butt',
    2: 'round',
    3: 'square',
  },
  ljEnum: {
    1: 'miter',
    2: 'round',
    3: 'bevel',
  },
  searchProcessedElement: function (elem) {
    var elements = this.processedElements;
    var i = 0;
    var len = elements.length;
    while (i < len) {
      if (elements[i].elem === elem) {
        return elements[i].pos;
      }
      i += 1;
    }
    return 0;
  },
  addProcessedElement: function (elem, pos) {
    var elements = this.processedElements;
    var i = elements.length;
    while (i) {
      i -= 1;
      if (elements[i].elem === elem) {
        elements[i].pos = pos;
        return;
      }
    }
    elements.push(new ProcessedElement(elem, pos));
  },
  prepareFrame: function (num) {
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
  },
};

/* global TextProperty, TextAnimatorProperty, buildShapeString, LetterProps */

function ITextElement() {
}

ITextElement.prototype.initElement = function (data, globalData, comp) {
  this.lettersChangedFlag = true;
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
  this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
  this.initTransform(data, globalData, comp);
  this.initHierarchy();
  this.initRenderable();
  this.initRendererElement();
  this.createContainerElements();
  this.createRenderableComponents();
  this.createContent();
  this.hide();
  this.textAnimator.searchProperties(this.dynamicProperties);
};

ITextElement.prototype.prepareFrame = function (num) {
  this._mdf = false;
  this.prepareRenderableFrame(num);
  this.prepareProperties(num, this.isInRange);
  if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
    this.buildNewText();
    this.textProperty._isFirstFrame = false;
    this.textProperty._mdf = false;
  }
};

ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
  var j;
  var jLen = shapes.length;
  var pathNodes;
  var shapeStr = '';
  for (j = 0; j < jLen; j += 1) {
    pathNodes = shapes[j].ks.k;
    shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
  }
  return shapeStr;
};

ITextElement.prototype.updateDocumentData = function (newData, index) {
  this.textProperty.updateDocumentData(newData, index);
};

ITextElement.prototype.canResizeFont = function (_canResize) {
  this.textProperty.canResizeFont(_canResize);
};

ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
  this.textProperty.setMinimumFontSize(_fontSize);
};

ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
  if (documentData.ps) {
    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
  }
  matrixHelper.translate(0, -documentData.ls, 0);
  switch (documentData.j) {
    case 1:
      matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
      break;
    case 2:
      matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
      break;
    default:
      break;
  }
  matrixHelper.translate(xPos, yPos, 0);
};

ITextElement.prototype.buildColor = function (colorData) {
  return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
};

ITextElement.prototype.emptyProp = new LetterProps();

ITextElement.prototype.destroy = function () {

};

/* global extendPrototype, BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement */

function ICompElement() {}

extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

ICompElement.prototype.initElement = function (data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initTransform(data, globalData, comp);
  this.initRenderable();
  this.initHierarchy();
  this.initRendererElement();
  this.createContainerElements();
  this.createRenderableComponents();
  if (this.data.xt || !globalData.progressiveLoad) {
    this.buildAllItems();
  }
  this.hide();
};

/* ICompElement.prototype.hide = function(){
    if(!this.hidden){
        this.hideElement();
        var i,len = this.elements.length;
        for( i = 0; i < len; i+=1 ){
            if(this.elements[i]){
                this.elements[i].hide();
            }
        }
    }
}; */

ICompElement.prototype.prepareFrame = function (num) {
  this._mdf = false;
  this.prepareRenderableFrame(num);
  this.prepareProperties(num, this.isInRange);
  if (!this.isInRange && !this.data.xt) {
    return;
  }

  if (!this.tm._placeholder) {
    var timeRemapped = this.tm.v;
    if (timeRemapped === this.data.op) {
      timeRemapped = this.data.op - 1;
    }
    this.renderedFrame = timeRemapped;
  } else {
    this.renderedFrame = num / this.data.sr;
  }
  var i;
  var len = this.elements.length;
  if (!this.completeLayers) {
    this.checkLayers(this.renderedFrame);
  }
  // This iteration needs to be backwards because of how expressions connect between each other
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
      if (this.elements[i]._mdf) {
        this._mdf = true;
      }
    }
  }
};

ICompElement.prototype.renderInnerContent = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].renderFrame();
    }
  }
};

ICompElement.prototype.setElements = function (elems) {
  this.elements = elems;
};

ICompElement.prototype.getElements = function () {
  return this.elements;
};

ICompElement.prototype.destroyElements = function () {
  var i;
  var len = this.layers.length;
  for (i = 0; i < len; i += 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
};

ICompElement.prototype.destroy = function () {
  this.destroyElements();
  this.destroyBaseElement();
};

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, createNS */

function IImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.initElement(data, globalData, comp);
  this.sourceRect = {
    top: 0, left: 0, width: this.assetData.w, height: this.assetData.h,
  };
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

IImageElement.prototype.createContent = function () {
  var assetPath = this.globalData.getAssetsPath(this.assetData);

  this.innerElem = createNS('image');
  this.innerElem.setAttribute('width', this.assetData.w + 'px');
  this.innerElem.setAttribute('height', this.assetData.h + 'px');
  this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
  this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);

  this.layerElement.appendChild(this.innerElem);
};

IImageElement.prototype.sourceRectAtTime = function () {
  return this.sourceRect;
};

/* global extendPrototype, IImageElement, createNS */

function ISolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([IImageElement], ISolidElement);

ISolidElement.prototype.createContent = function () {
  var rect = createNS('rect');
  /// /rect.style.width = this.data.sw;
  /// /rect.style.height = this.data.sh;
  /// /rect.style.fill = this.data.sc;
  rect.setAttribute('width', this.data.sw);
  rect.setAttribute('height', this.data.sh);
  rect.setAttribute('fill', this.data.sc);
  this.layerElement.appendChild(rect);
};

/* global PropertyFactory, extendPrototype, RenderableElement, BaseElement, FrameElement */

function AudioElement(data, globalData, comp) {
  this.initFrame();
  this.initRenderable();
  this.assetData = globalData.getAssetData(data.refId);
  this.initBaseData(data, globalData, comp);
  this._isPlaying = false;
  this._canPlay = false;
  var assetPath = this.globalData.getAssetsPath(this.assetData);
  this.audio = this.globalData.audioController.createAudio(assetPath);
  this._currentTime = 0;
  this.globalData.audioController.addAudio(this);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

AudioElement.prototype.prepareFrame = function (num) {
  this.prepareRenderableFrame(num, true);
  this.prepareProperties(num, true);
  if (!this.tm._placeholder) {
    var timeRemapped = this.tm.v;
    this._currentTime = timeRemapped;
  } else {
    this._currentTime = num / this.data.sr;
  }
};

extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

AudioElement.prototype.renderFrame = function () {
  if (this.isInRange && this._canPlay) {
    if (!this._isPlaying) {
      this.audio.play();
      this.audio.seek(this._currentTime / this.globalData.frameRate);
      this._isPlaying = true;
    } else if (!this.audio.playing()
      || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1
    ) {
      this.audio.seek(this._currentTime / this.globalData.frameRate);
    }
  }
};

AudioElement.prototype.show = function () {
  // this.audio.play()
};

AudioElement.prototype.hide = function () {
  this.audio.pause();
  this._isPlaying = false;
};

AudioElement.prototype.pause = function () {
  this.audio.pause();
  this._isPlaying = false;
  this._canPlay = false;
};

AudioElement.prototype.resume = function () {
  this._canPlay = true;
};

AudioElement.prototype.setRate = function (rateValue) {
  this.audio.rate(rateValue);
};

AudioElement.prototype.volume = function (volumeValue) {
  this.audio.volume(volumeValue);
};

AudioElement.prototype.getBaseElement = function () {
  return null;
};

AudioElement.prototype.destroy = function () {
};

AudioElement.prototype.sourceRectAtTime = function () {
};

AudioElement.prototype.initExpressions = function () {
};

/* global createSizedArray, PropertyFactory, extendPrototype, SVGRenderer, ICompElement, SVGBaseElement */

function SVGCompElement(data, globalData, comp) {
  this.layers = data.layers;
  this.supports3d = true;
  this.completeLayers = false;
  this.pendingElements = [];
  this.elements = this.layers ? createSizedArray(this.layers.length) : [];
  // this.layerElement = createNS('g');
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([SVGRenderer, ICompElement, SVGBaseElement], SVGCompElement);

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, ITextElement, createSizedArray, createNS */

function SVGTextLottieElement(data, globalData, comp) {
  this.textSpans = [];
  this.renderType = 'svg';
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

SVGTextLottieElement.prototype.createContent = function () {
  if (this.data.singleShape && !this.globalData.fontManager.chars) {
    this.textContainer = createNS('text');
  }
};

SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
  var i = 0;
  var len = textArray.length;
  var textContents = [];
  var currentTextContent = '';
  while (i < len) {
    if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
      textContents.push(currentTextContent);
      currentTextContent = '';
    } else {
      currentTextContent += textArray[i];
    }
    i += 1;
  }
  textContents.push(currentTextContent);
  return textContents;
};

SVGTextLottieElement.prototype.buildNewText = function () {
  var i;
  var len;

  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
  if (documentData.fc) {
    this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
  } else {
    this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
  }
  if (documentData.sc) {
    this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
    this.layerElement.setAttribute('stroke-width', documentData.sw);
  }
  this.layerElement.setAttribute('font-size', documentData.finalSize);
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  if (fontData.fClass) {
    this.layerElement.setAttribute('class', fontData.fClass);
  } else {
    this.layerElement.setAttribute('font-family', fontData.fFamily);
    var fWeight = documentData.fWeight;
    var fStyle = documentData.fStyle;
    this.layerElement.setAttribute('font-style', fStyle);
    this.layerElement.setAttribute('font-weight', fWeight);
  }
  this.layerElement.setAttribute('aria-label', documentData.t);

  var letters = documentData.l || [];
  var usesGlyphs = !!this.globalData.fontManager.chars;
  len = letters.length;

  var tSpan;
  var matrixHelper = this.mHelper;
  var shapes;
  var shapeStr = '';
  var singleShape = this.data.singleShape;
  var xPos = 0;
  var yPos = 0;
  var firstLine = true;
  var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
  if (singleShape && !usesGlyphs && !documentData.sz) {
    var tElement = this.textContainer;
    var justify = 'start';
    switch (documentData.j) {
      case 1:
        justify = 'end';
        break;
      case 2:
        justify = 'middle';
        break;
      default:
        justify = 'start';
        break;
    }
    tElement.setAttribute('text-anchor', justify);
    tElement.setAttribute('letter-spacing', trackingOffset);
    var textContent = this.buildTextContents(documentData.finalText);
    len = textContent.length;
    yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
    for (i = 0; i < len; i += 1) {
      tSpan = this.textSpans[i] || createNS('tspan');
      tSpan.textContent = textContent[i];
      tSpan.setAttribute('x', 0);
      tSpan.setAttribute('y', yPos);
      tSpan.style.display = 'inherit';
      tElement.appendChild(tSpan);
      this.textSpans[i] = tSpan;
      yPos += documentData.finalLineHeight;
    }

    this.layerElement.appendChild(tElement);
  } else {
    var cachedSpansLength = this.textSpans.length;
    var shapeData;
    var charData;
    for (i = 0; i < len; i += 1) {
      if (!usesGlyphs || !singleShape || i === 0) {
        tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs ? 'path' : 'text');
        if (cachedSpansLength <= i) {
          tSpan.setAttribute('stroke-linecap', 'butt');
          tSpan.setAttribute('stroke-linejoin', 'round');
          tSpan.setAttribute('stroke-miterlimit', '4');
          this.textSpans[i] = tSpan;
          this.layerElement.appendChild(tSpan);
        }
        tSpan.style.display = 'inherit';
      }

      matrixHelper.reset();
      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
      if (singleShape) {
        if (letters[i].n) {
          xPos = -trackingOffset;
          yPos += documentData.yOffset;
          yPos += firstLine ? 1 : 0;
          firstLine = false;
        }
        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
        xPos += letters[i].l || 0;
        // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
        xPos += trackingOffset;
      }
      if (usesGlyphs) {
        charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        shapeData = (charData && charData.data) || {};
        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
        if (!singleShape) {
          tSpan.setAttribute('d', this.createPathShape(matrixHelper, shapes));
        } else {
          shapeStr += this.createPathShape(matrixHelper, shapes);
        }
      } else {
        if (singleShape) {
          tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
        }
        tSpan.textContent = letters[i].val;
        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
      }
      //
    }
    if (singleShape && tSpan) {
      tSpan.setAttribute('d', shapeStr);
    }
  }
  while (i < this.textSpans.length) {
    this.textSpans[i].style.display = 'none';
    i += 1;
  }

  this._sizeChanged = true;
};

SVGTextLottieElement.prototype.sourceRectAtTime = function () {
  this.prepareFrame(this.comp.renderedFrame - this.data.st);
  this.renderInnerContent();
  if (this._sizeChanged) {
    this._sizeChanged = false;
    var textBox = this.layerElement.getBBox();
    this.bbox = {
      top: textBox.y,
      left: textBox.x,
      width: textBox.width,
      height: textBox.height,
    };
  }
  return this.bbox;
};

SVGTextLottieElement.prototype.renderInnerContent = function () {
  if (!this.data.singleShape) {
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
      this._sizeChanged = true;
      var i;
      var len;
      var renderedLetters = this.textAnimator.renderedLetters;

      var letters = this.textProperty.currentData.l;

      len = letters.length;
      var renderedLetter;
      var textSpan;
      for (i = 0; i < len; i += 1) {
        if (!letters[i].n) {
          renderedLetter = renderedLetters[i];
          textSpan = this.textSpans[i];
          if (renderedLetter._mdf.m) {
            textSpan.setAttribute('transform', renderedLetter.m);
          }
          if (renderedLetter._mdf.o) {
            textSpan.setAttribute('opacity', renderedLetter.o);
          }
          if (renderedLetter._mdf.sw) {
            textSpan.setAttribute('stroke-width', renderedLetter.sw);
          }
          if (renderedLetter._mdf.sc) {
            textSpan.setAttribute('stroke', renderedLetter.sc);
          }
          if (renderedLetter._mdf.fc) {
            textSpan.setAttribute('fill', renderedLetter.fc);
          }
        }
      }
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement,
FrameElement, RenderableDOMElement, Matrix, SVGStyleData, SVGStrokeStyleData, SVGFillStyleData,
SVGGradientFillStyleData, SVGGradientStrokeStyleData, locationHref, getBlendMode, ShapeGroupData,
TransformPropertyFactory, SVGTransformData, ShapePropertyFactory, SVGShapeData, SVGElementsRenderer, ShapeModifiers */

function SVGShapeElement(data, globalData, comp) {
  // List of drawable elements
  this.shapes = [];
  // Full shape data
  this.shapesData = data.shapes;
  // List of styles that will be applied to shapes
  this.stylesList = [];
  // List of modifiers that will be applied to shapes
  this.shapeModifiers = [];
  // List of items in shape tree
  this.itemsData = [];
  // List of items in previous shape tree
  this.processedElements = [];
  // List of animated components
  this.animatedContents = [];
  this.initElement(data, globalData, comp);
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  // List of elements that have been created
  this.prevViewData = [];
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
}

extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

SVGShapeElement.prototype.initSecondaryElement = function () {
};

SVGShapeElement.prototype.identityMatrix = new Matrix();

SVGShapeElement.prototype.buildExpressionInterface = function () {};

SVGShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
  this.filterUniqueShapes();
};

/*
This method searches for multiple shapes that affect a single element and one of them is animated
*/
SVGShapeElement.prototype.filterUniqueShapes = function () {
  var i;
  var len = this.shapes.length;
  var shape;
  var j;
  var jLen = this.stylesList.length;
  var style;
  var tempShapes = [];
  var areAnimated = false;
  for (j = 0; j < jLen; j += 1) {
    style = this.stylesList[j];
    areAnimated = false;
    tempShapes.length = 0;
    for (i = 0; i < len; i += 1) {
      shape = this.shapes[i];
      if (shape.styles.indexOf(style) !== -1) {
        tempShapes.push(shape);
        areAnimated = shape._isAnimated || areAnimated;
      }
    }
    if (tempShapes.length > 1 && areAnimated) {
      this.setShapesAsAnimated(tempShapes);
    }
  }
};

SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
  var i;
  var len = shapes.length;
  for (i = 0; i < len; i += 1) {
    shapes[i].setAsAnimated();
  }
};

SVGShapeElement.prototype.createStyleElement = function (data, level) {
  // TODO: prevent drawing of hidden styles
  var elementData;
  var styleOb = new SVGStyleData(data, level);

  var pathElement = styleOb.pElem;
  if (data.ty === 'st') {
    elementData = new SVGStrokeStyleData(this, data, styleOb);
  } else if (data.ty === 'fl') {
    elementData = new SVGFillStyleData(this, data, styleOb);
  } else if (data.ty === 'gf' || data.ty === 'gs') {
    var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
    elementData = new GradientConstructor(this, data, styleOb);
    this.globalData.defs.appendChild(elementData.gf);
    if (elementData.maskId) {
      this.globalData.defs.appendChild(elementData.ms);
      this.globalData.defs.appendChild(elementData.of);
      pathElement.setAttribute('mask', 'url(' + locationHref + '#' + elementData.maskId + ')');
    }
  }

  if (data.ty === 'st' || data.ty === 'gs') {
    pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
    pathElement.setAttribute('stroke-linejoin', this.ljEnum[data.lj] || 'round');
    pathElement.setAttribute('fill-opacity', '0');
    if (data.lj === 1) {
      pathElement.setAttribute('stroke-miterlimit', data.ml);
    }
  }

  if (data.r === 2) {
    pathElement.setAttribute('fill-rule', 'evenodd');
  }

  if (data.ln) {
    pathElement.setAttribute('id', data.ln);
  }
  if (data.cl) {
    pathElement.setAttribute('class', data.cl);
  }
  if (data.bm) {
    pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
  }
  this.stylesList.push(styleOb);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.createGroupElement = function (data) {
  var elementData = new ShapeGroupData();
  if (data.ln) {
    elementData.gr.setAttribute('id', data.ln);
  }
  if (data.cl) {
    elementData.gr.setAttribute('class', data.cl);
  }
  if (data.bm) {
    elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
  }
  return elementData;
};

SVGShapeElement.prototype.createTransformElement = function (data, container) {
  var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
  var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
  var ty = 4;
  if (data.ty === 'rc') {
    ty = 5;
  } else if (data.ty === 'el') {
    ty = 6;
  } else if (data.ty === 'sr') {
    ty = 7;
  }
  var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
  var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
  this.shapes.push(elementData);
  this.addShapeToModifiers(elementData);
  this.addToAnimatedContents(data, elementData);
  return elementData;
};

SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
  var i = 0;
  var len = this.animatedContents.length;
  while (i < len) {
    if (this.animatedContents[i].element === element) {
      return;
    }
    i += 1;
  }
  this.animatedContents.push({
    fn: SVGElementsRenderer.createRenderFunction(data),
    element: element,
    data: data,
  });
};

SVGShapeElement.prototype.setElementStyles = function (elementData) {
  var arr = elementData.styles;
  var j;
  var jLen = this.stylesList.length;
  for (j = 0; j < jLen; j += 1) {
    if (!this.stylesList[j].closed) {
      arr.push(this.stylesList[j]);
    }
  }
};

SVGShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = true;
  var i;
  var len = this.itemsData.length;
  for (i = 0; i < len; i += 1) {
    this.prevViewData[i] = this.itemsData[i];
  }
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
  this.filterUniqueShapes();
  len = this.dynamicProperties.length;
  for (i = 0; i < len; i += 1) {
    this.dynamicProperties[i].getValue();
  }
  this.renderModifiers();
};

SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
  var ownTransformers = [].concat(transformers);
  var i;
  var len = arr.length - 1;
  var j;
  var jLen;
  var ownStyles = [];
  var ownModifiers = [];
  var currentTransform;
  var modifier;
  var processedPos;
  for (i = len; i >= 0; i -= 1) {
    processedPos = this.searchProcessedElement(arr[i]);
    if (!processedPos) {
      arr[i]._render = render;
    } else {
      itemsData[i] = prevViewData[processedPos - 1];
    }
    if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
      if (!processedPos) {
        itemsData[i] = this.createStyleElement(arr[i], level);
      } else {
        itemsData[i].style.closed = false;
      }
      if (arr[i]._render) {
        container.appendChild(itemsData[i].style.pElem);
      }
      ownStyles.push(itemsData[i].style);
    } else if (arr[i].ty === 'gr') {
      if (!processedPos) {
        itemsData[i] = this.createGroupElement(arr[i]);
      } else {
        jLen = itemsData[i].it.length;
        for (j = 0; j < jLen; j += 1) {
          itemsData[i].prevViewData[j] = itemsData[i].it[j];
        }
      }
      this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
      if (arr[i]._render) {
        container.appendChild(itemsData[i].gr);
      }
    } else if (arr[i].ty === 'tr') {
      if (!processedPos) {
        itemsData[i] = this.createTransformElement(arr[i], container);
      }
      currentTransform = itemsData[i].transform;
      ownTransformers.push(currentTransform);
    } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
      if (!processedPos) {
        itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
      }
      this.setElementStyles(itemsData[i]);
    } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        modifier.init(this, arr[i]);
        itemsData[i] = modifier;
        this.shapeModifiers.push(modifier);
      } else {
        modifier = itemsData[i];
        modifier.closed = false;
      }
      ownModifiers.push(modifier);
    } else if (arr[i].ty === 'rp') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        itemsData[i] = modifier;
        modifier.init(this, arr, i, itemsData);
        this.shapeModifiers.push(modifier);
        render = false;
      } else {
        modifier = itemsData[i];
        modifier.closed = true;
      }
      ownModifiers.push(modifier);
    }
    this.addProcessedElement(arr[i], i + 1);
  }
  len = ownStyles.length;
  for (i = 0; i < len; i += 1) {
    ownStyles[i].closed = true;
  }
  len = ownModifiers.length;
  for (i = 0; i < len; i += 1) {
    ownModifiers[i].closed = true;
  }
};

SVGShapeElement.prototype.renderInnerContent = function () {
  this.renderModifiers();
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    this.stylesList[i].reset();
  }
  this.renderShape();

  for (i = 0; i < len; i += 1) {
    if (this.stylesList[i]._mdf || this._isFirstFrame) {
      if (this.stylesList[i].msElem) {
        this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
        // Adding M0 0 fixes same mask bug on all browsers
        this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
      }
      this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
    }
  }
};

SVGShapeElement.prototype.renderShape = function () {
  var i;
  var len = this.animatedContents.length;
  var animatedContent;
  for (i = 0; i < len; i += 1) {
    animatedContent = this.animatedContents[i];
    if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
      animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
    }
  }
};

SVGShapeElement.prototype.destroy = function () {
  this.destroyBaseElement();
  this.shapesData = null;
  this.itemsData = null;
};

/* global createNS */

function SVGTintFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
  feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f1');
  filter.appendChild(feColorMatrix);
  feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f2');
  filter.appendChild(feColorMatrix);
  this.matrixFilter = feColorMatrix;
  if (filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k) {
    var feMerge = createNS('feMerge');
    filter.appendChild(feMerge);
    var feMergeNode;
    feMergeNode = createNS('feMergeNode');
    feMergeNode.setAttribute('in', 'SourceGraphic');
    feMerge.appendChild(feMergeNode);
    feMergeNode = createNS('feMergeNode');
    feMergeNode.setAttribute('in', 'f2');
    feMerge.appendChild(feMergeNode);
  }
}

SVGTintFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var colorBlack = this.filterManager.effectElements[0].p.v;
    var colorWhite = this.filterManager.effectElements[1].p.v;
    var opacity = this.filterManager.effectElements[2].p.v / 100;
    this.matrixFilter.setAttribute('values', (colorWhite[0] - colorBlack[0]) + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGFillFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
  feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
  filter.appendChild(feColorMatrix);
  this.matrixFilter = feColorMatrix;
}
SVGFillFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var color = this.filterManager.effectElements[2].p.v;
    var opacity = this.filterManager.effectElements[6].p.v;
    this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGGaussianBlurEffect(filter, filterManager) {
  // Outset the filter region by 100% on all sides to accommodate blur expansion.
  filter.setAttribute('x', '-100%');
  filter.setAttribute('y', '-100%');
  filter.setAttribute('width', '300%');
  filter.setAttribute('height', '300%');

  this.filterManager = filterManager;
  var feGaussianBlur = createNS('feGaussianBlur');
  filter.appendChild(feGaussianBlur);
  this.feGaussianBlur = feGaussianBlur;
}

SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    // Empirical value, matching AE's blur appearance.
    var kBlurrinessToSigma = 0.3;
    var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma;

    // Dimensions mapping:
    //
    //   1 -> horizontal & vertical
    //   2 -> horizontal only
    //   3 -> vertical only
    //
    var dimensions = this.filterManager.effectElements[1].p.v;
    var sigmaX = (dimensions == 3) ? 0 : sigma; // eslint-disable-line eqeqeq
    var sigmaY = (dimensions == 2) ? 0 : sigma; // eslint-disable-line eqeqeq

    this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY);

    // Repeat edges mapping:
    //
    //   0 -> off -> duplicate
    //   1 -> on  -> wrap
    var edgeMode = (this.filterManager.effectElements[2].p.v == 1) ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
    this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
  }
};

/* global createNS, createElementID, locationHref, bmFloor */

function SVGStrokeEffect(elem, filterManager) {
  this.initialized = false;
  this.filterManager = filterManager;
  this.elem = elem;
  this.paths = [];
}

SVGStrokeEffect.prototype.initialize = function () {
  var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
  var path;
  var groupPath;
  var i;
  var len;
  if (this.filterManager.effectElements[1].p.v === 1) {
    len = this.elem.maskManager.masksProperties.length;
    i = 0;
  } else {
    i = this.filterManager.effectElements[0].p.v - 1;
    len = i + 1;
  }
  groupPath = createNS('g');
  groupPath.setAttribute('fill', 'none');
  groupPath.setAttribute('stroke-linecap', 'round');
  groupPath.setAttribute('stroke-dashoffset', 1);
  for (i; i < len; i += 1) {
    path = createNS('path');
    groupPath.appendChild(path);
    this.paths.push({ p: path, m: i });
  }
  if (this.filterManager.effectElements[10].p.v === 3) {
    var mask = createNS('mask');
    var id = createElementID();
    mask.setAttribute('id', id);
    mask.setAttribute('mask-type', 'alpha');
    mask.appendChild(groupPath);
    this.elem.globalData.defs.appendChild(mask);
    var g = createNS('g');
    g.setAttribute('mask', 'url(' + locationHref + '#' + id + ')');
    while (elemChildren[0]) {
      g.appendChild(elemChildren[0]);
    }
    this.elem.layerElement.appendChild(g);
    this.masker = mask;
    groupPath.setAttribute('stroke', '#fff');
  } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
    if (this.filterManager.effectElements[10].p.v === 2) {
      elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
      while (elemChildren.length) {
        this.elem.layerElement.removeChild(elemChildren[0]);
      }
    }
    this.elem.layerElement.appendChild(groupPath);
    this.elem.layerElement.removeAttribute('mask');
    groupPath.setAttribute('stroke', '#fff');
  }
  this.initialized = true;
  this.pathMasker = groupPath;
};

SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
  if (!this.initialized) {
    this.initialize();
  }
  var i;
  var len = this.paths.length;
  var mask;
  var path;
  for (i = 0; i < len; i += 1) {
    if (this.paths[i].m !== -1) {
      mask = this.elem.maskManager.viewData[this.paths[i].m];
      path = this.paths[i].p;
      if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
        path.setAttribute('d', mask.lastPath);
      }
      if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
        var dasharrayValue;
        if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
          var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
          var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
          var l = path.getTotalLength();
          dasharrayValue = '0 0 0 ' + l * s + ' ';
          var lineLength = l * (e - s);
          var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          var units = Math.floor(lineLength / segment);
          var j;
          for (j = 0; j < units; j += 1) {
            dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
          }
          dasharrayValue += '0 ' + l * 10 + ' 0 0';
        } else {
          dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
        }
        path.setAttribute('stroke-dasharray', dasharrayValue);
      }
    }
  }
  if (forceRender || this.filterManager.effectElements[4].p._mdf) {
    this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
  }

  if (forceRender || this.filterManager.effectElements[6].p._mdf) {
    this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
  }
  if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
    if (forceRender || this.filterManager.effectElements[3].p._mdf) {
      var color = this.filterManager.effectElements[3].p.v;
      this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
    }
  }
};

/* global createNS */

function SVGTritoneFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var feColorMatrix = createNS('feColorMatrix');
  feColorMatrix.setAttribute('type', 'matrix');
  feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
  feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
  feColorMatrix.setAttribute('result', 'f1');
  filter.appendChild(feColorMatrix);
  var feComponentTransfer = createNS('feComponentTransfer');
  feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
  filter.appendChild(feComponentTransfer);
  this.matrixFilter = feComponentTransfer;
  var feFuncR = createNS('feFuncR');
  feFuncR.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncR);
  this.feFuncR = feFuncR;
  var feFuncG = createNS('feFuncG');
  feFuncG.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncG);
  this.feFuncG = feFuncG;
  var feFuncB = createNS('feFuncB');
  feFuncB.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFuncB);
  this.feFuncB = feFuncB;
}

SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var color1 = this.filterManager.effectElements[0].p.v;
    var color2 = this.filterManager.effectElements[1].p.v;
    var color3 = this.filterManager.effectElements[2].p.v;
    var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
    var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
    var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
    this.feFuncR.setAttribute('tableValues', tableR);
    this.feFuncG.setAttribute('tableValues', tableG);
    this.feFuncB.setAttribute('tableValues', tableB);
    // var opacity = this.filterManager.effectElements[2].p.v/100;
    // this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
  }
};

/* global createNS */

function SVGProLevelsFilter(filter, filterManager) {
  this.filterManager = filterManager;
  var effectElements = this.filterManager.effectElements;
  var feComponentTransfer = createNS('feComponentTransfer');

  if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
    this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
  }
  if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
    this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
  }
  if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
    this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
  }
  if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
    this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
  }

  if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    filter.appendChild(feComponentTransfer);
    feComponentTransfer = createNS('feComponentTransfer');
  }

  if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    filter.appendChild(feComponentTransfer);
    this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
    this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
    this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
  }
}

SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
  var feFunc = createNS(type);
  feFunc.setAttribute('type', 'table');
  feComponentTransfer.appendChild(feFunc);
  return feFunc;
};

SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
  var cnt = 0;
  var segments = 256;
  var perc;
  var min = Math.min(inputBlack, inputWhite);
  var max = Math.max(inputBlack, inputWhite);
  var table = Array.call(null, { length: segments });
  var colorValue;
  var pos = 0;
  var outputDelta = outputWhite - outputBlack;
  var inputDelta = inputWhite - inputBlack;
  while (cnt <= 256) {
    perc = cnt / 256;
    if (perc <= min) {
      colorValue = inputDelta < 0 ? outputWhite : outputBlack;
    } else if (perc >= max) {
      colorValue = inputDelta < 0 ? outputBlack : outputWhite;
    } else {
      colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
    }
    table[pos] = colorValue;
    pos += 1;
    cnt += 256 / (segments - 1);
  }
  return table.join(' ');
};

SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    var val;
    var effectElements = this.filterManager.effectElements;
    if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
      val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
      this.feFuncRComposed.setAttribute('tableValues', val);
      this.feFuncGComposed.setAttribute('tableValues', val);
      this.feFuncBComposed.setAttribute('tableValues', val);
    }

    if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
      val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
      this.feFuncR.setAttribute('tableValues', val);
    }

    if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
      val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
      this.feFuncG.setAttribute('tableValues', val);
    }

    if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
      val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
      this.feFuncB.setAttribute('tableValues', val);
    }

    if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
      val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
      this.feFuncA.setAttribute('tableValues', val);
    }
  }
};

/* global createNS, rgbToHex, degToRads */

function SVGDropShadowEffect(filter, filterManager) {
  var filterSize = filterManager.container.globalData.renderConfig.filterSize;
  filter.setAttribute('x', filterSize.x);
  filter.setAttribute('y', filterSize.y);
  filter.setAttribute('width', filterSize.width);
  filter.setAttribute('height', filterSize.height);
  this.filterManager = filterManager;

  var feGaussianBlur = createNS('feGaussianBlur');
  feGaussianBlur.setAttribute('in', 'SourceAlpha');
  feGaussianBlur.setAttribute('result', 'drop_shadow_1');
  feGaussianBlur.setAttribute('stdDeviation', '0');
  this.feGaussianBlur = feGaussianBlur;
  filter.appendChild(feGaussianBlur);

  var feOffset = createNS('feOffset');
  feOffset.setAttribute('dx', '25');
  feOffset.setAttribute('dy', '0');
  feOffset.setAttribute('in', 'drop_shadow_1');
  feOffset.setAttribute('result', 'drop_shadow_2');
  this.feOffset = feOffset;
  filter.appendChild(feOffset);
  var feFlood = createNS('feFlood');
  feFlood.setAttribute('flood-color', '#00ff00');
  feFlood.setAttribute('flood-opacity', '1');
  feFlood.setAttribute('result', 'drop_shadow_3');
  this.feFlood = feFlood;
  filter.appendChild(feFlood);

  var feComposite = createNS('feComposite');
  feComposite.setAttribute('in', 'drop_shadow_3');
  feComposite.setAttribute('in2', 'drop_shadow_2');
  feComposite.setAttribute('operator', 'in');
  feComposite.setAttribute('result', 'drop_shadow_4');
  filter.appendChild(feComposite);

  var feMerge = createNS('feMerge');
  filter.appendChild(feMerge);
  var feMergeNode;
  feMergeNode = createNS('feMergeNode');
  feMerge.appendChild(feMergeNode);
  feMergeNode = createNS('feMergeNode');
  feMergeNode.setAttribute('in', 'SourceGraphic');
  this.feMergeNode = feMergeNode;
  this.feMerge = feMerge;
  this.originalNodeAdded = false;
  feMerge.appendChild(feMergeNode);
}

SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
  if (forceRender || this.filterManager._mdf) {
    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
      this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
    }
    if (forceRender || this.filterManager.effectElements[0].p._mdf) {
      var col = this.filterManager.effectElements[0].p.v;
      this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
    }
    if (forceRender || this.filterManager.effectElements[1].p._mdf) {
      this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
    }
    if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
      var distance = this.filterManager.effectElements[3].p.v;
      var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
      var x = distance * Math.cos(angle);
      var y = distance * Math.sin(angle);
      this.feOffset.setAttribute('dx', x);
      this.feOffset.setAttribute('dy', y);
    }
    /* if(forceRender || this.filterManager.effectElements[5].p._mdf){
            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
                this.feMerge.removeChild(this.feMergeNode);
                this.originalNodeAdded = false;
            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
                this.feMerge.appendChild(this.feMergeNode);
                this.originalNodeAdded = true;
            }
        } */
  }
};

/* global createElementID, createNS */

var _svgMatteSymbols = [];

function SVGMatte3Effect(filterElem, filterManager, elem) {
  this.initialized = false;
  this.filterManager = filterManager;
  this.filterElem = filterElem;
  this.elem = elem;
  elem.matteElement = createNS('g');
  elem.matteElement.appendChild(elem.layerElement);
  elem.matteElement.appendChild(elem.transformedElement);
  elem.baseElement = elem.matteElement;
}

SVGMatte3Effect.prototype.findSymbol = function (mask) {
  var i = 0;
  var len = _svgMatteSymbols.length;
  while (i < len) {
    if (_svgMatteSymbols[i] === mask) {
      return _svgMatteSymbols[i];
    }
    i += 1;
  }
  return null;
};

SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
  var parentNode = mask.layerElement.parentNode;
  if (!parentNode) {
    return;
  }
  var children = parentNode.children;
  var i = 0;
  var len = children.length;
  while (i < len) {
    if (children[i] === mask.layerElement) {
      break;
    }
    i += 1;
  }
  var nextChild;
  if (i <= len - 2) {
    nextChild = children[i + 1];
  }
  var useElem = createNS('use');
  useElem.setAttribute('href', '#' + symbolId);
  if (nextChild) {
    parentNode.insertBefore(useElem, nextChild);
  } else {
    parentNode.appendChild(useElem);
  }
};

SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
  if (!this.findSymbol(mask)) {
    var symbolId = createElementID();
    var masker = createNS('mask');
    masker.setAttribute('id', mask.layerId);
    masker.setAttribute('mask-type', 'alpha');
    _svgMatteSymbols.push(mask);
    var defs = elem.globalData.defs;
    defs.appendChild(masker);
    var symbol = createNS('symbol');
    symbol.setAttribute('id', symbolId);
    this.replaceInParent(mask, symbolId);
    symbol.appendChild(mask.layerElement);
    defs.appendChild(symbol);
    var useElem = createNS('use');
    useElem.setAttribute('href', '#' + symbolId);
    masker.appendChild(useElem);
    mask.data.hd = false;
    mask.show();
  }
  elem.setMatte(mask.layerId);
};

SVGMatte3Effect.prototype.initialize = function () {
  var ind = this.filterManager.effectElements[0].p.v;
  var elements = this.elem.comp.elements;
  var i = 0;
  var len = elements.length;
  while (i < len) {
    if (elements[i] && elements[i].data.ind === ind) {
      this.setElementAsMask(this.elem, elements[i]);
    }
    i += 1;
  }
  this.initialized = true;
};

SVGMatte3Effect.prototype.renderFrame = function () {
  if (!this.initialized) {
    this.initialize();
  }
};

/* global createElementID, filtersFactory, SVGTintFilter, SVGFillFilter, SVGStrokeEffect, SVGTritoneFilter,
SVGProLevelsFilter, SVGDropShadowEffect, SVGMatte3Effect, SVGGaussianBlurEffect, locationHref */

function SVGEffects(elem) {
  var i;
  var len = elem.data.ef ? elem.data.ef.length : 0;
  var filId = createElementID();
  var fil = filtersFactory.createFilter(filId);
  var count = 0;
  this.filters = [];
  var filterManager;
  for (i = 0; i < len; i += 1) {
    filterManager = null;
    if (elem.data.ef[i].ty === 20) {
      count += 1;
      filterManager = new SVGTintFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 21) {
      count += 1;
      filterManager = new SVGFillFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 22) {
      filterManager = new SVGStrokeEffect(elem, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 23) {
      count += 1;
      filterManager = new SVGTritoneFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 24) {
      count += 1;
      filterManager = new SVGProLevelsFilter(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 25) {
      count += 1;
      filterManager = new SVGDropShadowEffect(fil, elem.effectsManager.effectElements[i]);
    } else if (elem.data.ef[i].ty === 28) {
      // count += 1;
      filterManager = new SVGMatte3Effect(fil, elem.effectsManager.effectElements[i], elem);
    } else if (elem.data.ef[i].ty === 29) {
      count += 1;
      filterManager = new SVGGaussianBlurEffect(fil, elem.effectsManager.effectElements[i]);
    }
    if (filterManager) {
      this.filters.push(filterManager);
    }
  }
  if (count) {
    elem.globalData.defs.appendChild(fil);
    elem.layerElement.setAttribute('filter', 'url(' + locationHref + '#' + filId + ')');
  }
  if (this.filters.length) {
    elem.addRenderableComponent(this);
  }
}

SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
  var i;
  var len = this.filters.length;
  for (i = 0; i < len; i += 1) {
    this.filters[i].renderFrame(_isFirstFrame);
  }
};

/* global Matrix, createTypedArray */

function CVContextData() {
  this.saved = [];
  this.cArrPos = 0;
  this.cTr = new Matrix();
  this.cO = 1;
  var i;
  var len = 15;
  this.savedOp = createTypedArray('float32', len);
  for (i = 0; i < len; i += 1) {
    this.saved[i] = createTypedArray('float32', 16);
  }
  this._length = len;
}

CVContextData.prototype.duplicate = function () {
  var newLength = this._length * 2;
  var currentSavedOp = this.savedOp;
  this.savedOp = createTypedArray('float32', newLength);
  this.savedOp.set(currentSavedOp);
  var i = 0;
  for (i = this._length; i < newLength; i += 1) {
    this.saved[i] = createTypedArray('float32', 16);
  }
  this._length = newLength;
};

CVContextData.prototype.reset = function () {
  this.cArrPos = 0;
  this.cTr.reset();
  this.cO = 1;
};

/* global CVEffects, getBlendMode, CVMaskElement, Matrix */

function CVBaseElement() {
}

CVBaseElement.prototype = {
  createElements: function () {},
  initRendererElement: function () {},
  createContainerElements: function () {
    this.canvasContext = this.globalData.canvasContext;
    this.renderableEffectsManager = new CVEffects(this);
  },
  createContent: function () {},
  setBlendMode: function () {
    var globalData = this.globalData;
    if (globalData.blendMode !== this.data.bm) {
      globalData.blendMode = this.data.bm;
      var blendModeValue = getBlendMode(this.data.bm);
      globalData.canvasContext.globalCompositeOperation = blendModeValue;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new CVMaskElement(this.data, this);
  },
  hideElement: function () {
    if (!this.hidden && (!this.isInRange || this.isTransparent)) {
      this.hidden = true;
    }
  },
  showElement: function () {
    if (this.isInRange && !this.isTransparent) {
      this.hidden = false;
      this._isFirstFrame = true;
      this.maskManager._isFirstFrame = true;
    }
  },
  renderFrame: function () {
    if (this.hidden || this.data.hd) {
      return;
    }
    this.renderTransform();
    this.renderRenderable();
    this.setBlendMode();
    var forceRealStack = this.data.ty === 0;
    this.globalData.renderer.save(forceRealStack);
    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
    this.renderInnerContent();
    this.globalData.renderer.restore(forceRealStack);
    if (this.maskManager.hasMasks) {
      this.globalData.renderer.restore(true);
    }
    if (this._isFirstFrame) {
      this._isFirstFrame = false;
    }
  },
  destroy: function () {
    this.canvasContext = null;
    this.data = null;
    this.globalData = null;
    this.maskManager.destroy();
  },
  mHelper: new Matrix(),
};
CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement,HierarchyElement, FrameElement,
RenderableElement, SVGShapeElement, IImageElement, createTag */

function CVImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.img = globalData.imageLoader.getImage(this.assetData);
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);

CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

CVImageElement.prototype.createContent = function () {
  if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
    var canvas = createTag('canvas');
    canvas.width = this.assetData.w;
    canvas.height = this.assetData.h;
    var ctx = canvas.getContext('2d');

    var imgW = this.img.width;
    var imgH = this.img.height;
    var imgRel = imgW / imgH;
    var canvasRel = this.assetData.w / this.assetData.h;
    var widthCrop;
    var heightCrop;
    var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
    if ((imgRel > canvasRel && par === 'xMidYMid slice') || (imgRel < canvasRel && par !== 'xMidYMid slice')) {
      heightCrop = imgH;
      widthCrop = heightCrop * canvasRel;
    } else {
      widthCrop = imgW;
      heightCrop = widthCrop / canvasRel;
    }
    ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
    this.img = canvas;
  }
};

CVImageElement.prototype.renderInnerContent = function () {
  this.canvasContext.drawImage(this.img, 0, 0);
};

CVImageElement.prototype.destroy = function () {
  this.img = null;
};

/* global createSizedArray, PropertyFactory, extendPrototype, CanvasRenderer, ICompElement, CVBaseElement */

function CVCompElement(data, globalData, comp) {
  this.completeLayers = false;
  this.layers = data.layers;
  this.pendingElements = [];
  this.elements = createSizedArray(this.layers.length);
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([CanvasRenderer, ICompElement, CVBaseElement], CVCompElement);

CVCompElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(this.data.w, 0);
  ctx.lineTo(this.data.w, this.data.h);
  ctx.lineTo(0, this.data.h);
  ctx.lineTo(0, 0);
  ctx.clip();
  var i;
  var len = this.layers.length;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.completeLayers || this.elements[i]) {
      this.elements[i].renderFrame();
    }
  }
};

CVCompElement.prototype.destroy = function () {
  var i;
  var len = this.layers.length;
  for (i = len - 1; i >= 0; i -= 1) {
    if (this.elements[i]) {
      this.elements[i].destroy();
    }
  }
  this.layers = null;
  this.elements = null;
};

/* global createSizedArray, ShapePropertyFactory, MaskElement */

function CVMaskElement(data, element) {
  this.data = data;
  this.element = element;
  this.masksProperties = this.data.masksProperties || [];
  this.viewData = createSizedArray(this.masksProperties.length);
  var i;
  var len = this.masksProperties.length;
  var hasMasks = false;
  for (i = 0; i < len; i += 1) {
    if (this.masksProperties[i].mode !== 'n') {
      hasMasks = true;
    }
    this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
  }
  this.hasMasks = hasMasks;
  if (hasMasks) {
    this.element.addRenderableComponent(this);
  }
}

CVMaskElement.prototype.renderFrame = function () {
  if (!this.hasMasks) {
    return;
  }
  var transform = this.element.finalTransform.mat;
  var ctx = this.element.canvasContext;
  var i;
  var len = this.masksProperties.length;
  var pt;
  var pts;
  var data;
  ctx.beginPath();
  for (i = 0; i < len; i += 1) {
    if (this.masksProperties[i].mode !== 'n') {
      if (this.masksProperties[i].inv) {
        ctx.moveTo(0, 0);
        ctx.lineTo(this.element.globalData.compSize.w, 0);
        ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
        ctx.lineTo(0, this.element.globalData.compSize.h);
        ctx.lineTo(0, 0);
      }
      data = this.viewData[i].v;
      pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
      ctx.moveTo(pt[0], pt[1]);
      var j;
      var jLen = data._length;
      for (j = 1; j < jLen; j += 1) {
        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
      }
      pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
      ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
    }
  }
  this.element.globalData.renderer.save(true);
  ctx.clip();
};

CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

CVMaskElement.prototype.destroy = function () {
  this.element = null;
};

/* global ShapeTransformManager, extendPrototype, BaseElement, TransformElement, CVBaseElement, IShapeElement,
HierarchyElement, FrameElement, RenderableElement, RenderableDOMElement, PropertyFactory, degToRads, GradientProperty,
DashProperty, TransformPropertyFactory, CVShapeData, ShapeModifiers, bmFloor */

function CVShapeElement(data, globalData, comp) {
  this.shapes = [];
  this.shapesData = data.shapes;
  this.stylesList = [];
  this.itemsData = [];
  this.prevViewData = [];
  this.shapeModifiers = [];
  this.processedElements = [];
  this.transformsManager = new ShapeTransformManager();
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);

CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;

CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: false };

CVShapeElement.prototype.dashResetter = [];

CVShapeElement.prototype.createContent = function () {
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
};

CVShapeElement.prototype.createStyleElement = function (data, transforms) {
  var styleElem = {
    data: data,
    type: data.ty,
    preTransforms: this.transformsManager.addTransformSequence(transforms),
    transforms: [],
    elements: [],
    closed: data.hd === true,
  };
  var elementData = {};
  if (data.ty === 'fl' || data.ty === 'st') {
    elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
    if (!elementData.c.k) {
      styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
    }
  } else if (data.ty === 'gf' || data.ty === 'gs') {
    elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
    elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
    elementData.h = PropertyFactory.getProp(this, data.h || { k: 0 }, 0, 0.01, this);
    elementData.a = PropertyFactory.getProp(this, data.a || { k: 0 }, 0, degToRads, this);
    elementData.g = new GradientProperty(this, data.g, this);
  }
  elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
  if (data.ty === 'st' || data.ty === 'gs') {
    styleElem.lc = this.lcEnum[data.lc] || 'round';
    styleElem.lj = this.ljEnum[data.lj] || 'round';
    if (data.lj == 1) { // eslint-disable-line eqeqeq
      styleElem.ml = data.ml;
    }
    elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
    if (!elementData.w.k) {
      styleElem.wi = elementData.w.v;
    }
    if (data.d) {
      var d = new DashProperty(this, data.d, 'canvas', this);
      elementData.d = d;
      if (!elementData.d.k) {
        styleElem.da = elementData.d.dashArray;
        styleElem.do = elementData.d.dashoffset[0];
      }
    }
  } else {
    styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
  }
  this.stylesList.push(styleElem);
  elementData.style = styleElem;
  return elementData;
};

CVShapeElement.prototype.createGroupElement = function () {
  var elementData = {
    it: [],
    prevViewData: [],
  };
  return elementData;
};

CVShapeElement.prototype.createTransformElement = function (data) {
  var elementData = {
    transform: {
      opacity: 1,
      _opMdf: false,
      key: this.transformsManager.getNewKey(),
      op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
      mProps: TransformPropertyFactory.getTransformProperty(this, data, this),
    },
  };
  return elementData;
};

CVShapeElement.prototype.createShapeElement = function (data) {
  var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);

  this.shapes.push(elementData);
  this.addShapeToModifiers(elementData);
  return elementData;
};

CVShapeElement.prototype.reloadShapes = function () {
  this._isFirstFrame = true;
  var i;
  var len = this.itemsData.length;
  for (i = 0; i < len; i += 1) {
    this.prevViewData[i] = this.itemsData[i];
  }
  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
  len = this.dynamicProperties.length;
  for (i = 0; i < len; i += 1) {
    this.dynamicProperties[i].getValue();
  }
  this.renderModifiers();
  this.transformsManager.processSequences(this._isFirstFrame);
};

CVShapeElement.prototype.addTransformToStyleList = function (transform) {
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    if (!this.stylesList[i].closed) {
      this.stylesList[i].transforms.push(transform);
    }
  }
};

CVShapeElement.prototype.removeTransformFromStyleList = function () {
  var i;
  var len = this.stylesList.length;
  for (i = 0; i < len; i += 1) {
    if (!this.stylesList[i].closed) {
      this.stylesList[i].transforms.pop();
    }
  }
};

CVShapeElement.prototype.closeStyles = function (styles) {
  var i;
  var len = styles.length;
  for (i = 0; i < len; i += 1) {
    styles[i].closed = true;
  }
};

CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
  var i;
  var len = arr.length - 1;
  var j;
  var jLen;
  var ownStyles = [];
  var ownModifiers = [];
  var processedPos;
  var modifier;
  var currentTransform;
  var ownTransforms = [].concat(transforms);
  for (i = len; i >= 0; i -= 1) {
    processedPos = this.searchProcessedElement(arr[i]);
    if (!processedPos) {
      arr[i]._shouldRender = shouldRender;
    } else {
      itemsData[i] = prevViewData[processedPos - 1];
    }
    if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
      if (!processedPos) {
        itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
      } else {
        itemsData[i].style.closed = false;
      }

      ownStyles.push(itemsData[i].style);
    } else if (arr[i].ty === 'gr') {
      if (!processedPos) {
        itemsData[i] = this.createGroupElement(arr[i]);
      } else {
        jLen = itemsData[i].it.length;
        for (j = 0; j < jLen; j += 1) {
          itemsData[i].prevViewData[j] = itemsData[i].it[j];
        }
      }
      this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
    } else if (arr[i].ty === 'tr') {
      if (!processedPos) {
        currentTransform = this.createTransformElement(arr[i]);
        itemsData[i] = currentTransform;
      }
      ownTransforms.push(itemsData[i]);
      this.addTransformToStyleList(itemsData[i]);
    } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
      if (!processedPos) {
        itemsData[i] = this.createShapeElement(arr[i]);
      }
    } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        modifier.init(this, arr[i]);
        itemsData[i] = modifier;
        this.shapeModifiers.push(modifier);
      } else {
        modifier = itemsData[i];
        modifier.closed = false;
      }
      ownModifiers.push(modifier);
    } else if (arr[i].ty === 'rp') {
      if (!processedPos) {
        modifier = ShapeModifiers.getModifier(arr[i].ty);
        itemsData[i] = modifier;
        modifier.init(this, arr, i, itemsData);
        this.shapeModifiers.push(modifier);
        shouldRender = false;
      } else {
        modifier = itemsData[i];
        modifier.closed = true;
      }
      ownModifiers.push(modifier);
    }
    this.addProcessedElement(arr[i], i + 1);
  }
  this.removeTransformFromStyleList();
  this.closeStyles(ownStyles);
  len = ownModifiers.length;
  for (i = 0; i < len; i += 1) {
    ownModifiers[i].closed = true;
  }
};

CVShapeElement.prototype.renderInnerContent = function () {
  this.transformHelper.opacity = 1;
  this.transformHelper._opMdf = false;
  this.renderModifiers();
  this.transformsManager.processSequences(this._isFirstFrame);
  this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
};

CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
  if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
    groupTransform.opacity = parentTransform.opacity;
    groupTransform.opacity *= groupTransform.op.v;
    groupTransform._opMdf = true;
  }
};

CVShapeElement.prototype.drawLayer = function () {
  var i;
  var len = this.stylesList.length;
  var j;
  var jLen;
  var k;
  var kLen;
  var elems;
  var nodes;
  var renderer = this.globalData.renderer;
  var ctx = this.globalData.canvasContext;
  var type;
  var currentStyle;
  for (i = 0; i < len; i += 1) {
    currentStyle = this.stylesList[i];
    type = currentStyle.type;

    // Skipping style when
    // Stroke width equals 0
    // style should not be rendered (extra unused repeaters)
    // current opacity equals 0
    // global opacity equals 0
    if (!(((type === 'st' || type === 'gs') && currentStyle.wi === 0) || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
      renderer.save();
      elems = currentStyle.elements;
      if (type === 'st' || type === 'gs') {
        ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
        ctx.lineWidth = currentStyle.wi;
        ctx.lineCap = currentStyle.lc;
        ctx.lineJoin = currentStyle.lj;
        ctx.miterLimit = currentStyle.ml || 0;
      } else {
        ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
      }
      renderer.ctxOpacity(currentStyle.coOp);
      if (type !== 'st' && type !== 'gs') {
        ctx.beginPath();
      }
      renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
      jLen = elems.length;
      for (j = 0; j < jLen; j += 1) {
        if (type === 'st' || type === 'gs') {
          ctx.beginPath();
          if (currentStyle.da) {
            ctx.setLineDash(currentStyle.da);
            ctx.lineDashOffset = currentStyle.do;
          }
        }
        nodes = elems[j].trNodes;
        kLen = nodes.length;

        for (k = 0; k < kLen; k += 1) {
          if (nodes[k].t === 'm') {
            ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
          } else if (nodes[k].t === 'c') {
            ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
          } else {
            ctx.closePath();
          }
        }
        if (type === 'st' || type === 'gs') {
          ctx.stroke();
          if (currentStyle.da) {
            ctx.setLineDash(this.dashResetter);
          }
        }
      }
      if (type !== 'st' && type !== 'gs') {
        ctx.fill(currentStyle.r);
      }
      renderer.restore();
    }
  }
};

CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
  var i;
  var len = items.length - 1;
  var groupTransform;
  groupTransform = parentTransform;
  for (i = len; i >= 0; i -= 1) {
    if (items[i].ty === 'tr') {
      groupTransform = data[i].transform;
      this.renderShapeTransform(parentTransform, groupTransform);
    } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
      this.renderPath(items[i], data[i]);
    } else if (items[i].ty === 'fl') {
      this.renderFill(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'st') {
      this.renderStroke(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
      this.renderGradientFill(items[i], data[i], groupTransform);
    } else if (items[i].ty === 'gr') {
      this.renderShape(groupTransform, items[i].it, data[i].it);
    } else if (items[i].ty === 'tm') {
      //
    }
  }
  if (isMain) {
    this.drawLayer();
  }
};

CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
  if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
    var shapeNodes = styledShape.trNodes;
    var paths = shape.paths;
    var i;
    var len;
    var j;
    var jLen = paths._length;
    shapeNodes.length = 0;
    var groupTransformMat = styledShape.transforms.finalTransform;
    for (j = 0; j < jLen; j += 1) {
      var pathNodes = paths.shapes[j];
      if (pathNodes && pathNodes.v) {
        len = pathNodes._length;
        for (i = 1; i < len; i += 1) {
          if (i === 1) {
            shapeNodes.push({
              t: 'm',
              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0),
            });
          }
          shapeNodes.push({
            t: 'c',
            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i]),
          });
        }
        if (len === 1) {
          shapeNodes.push({
            t: 'm',
            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0),
          });
        }
        if (pathNodes.c && len) {
          shapeNodes.push({
            t: 'c',
            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0]),
          });
          shapeNodes.push({
            t: 'z',
          });
        }
      }
    }
    styledShape.trNodes = shapeNodes;
  }
};

CVShapeElement.prototype.renderPath = function (pathData, itemData) {
  if (pathData.hd !== true && pathData._shouldRender) {
    var i;
    var len = itemData.styledShapes.length;
    for (i = 0; i < len; i += 1) {
      this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
    }
  }
};

CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;

  if (itemData.c._mdf || this._isFirstFrame) {
    styleElem.co = 'rgb('
        + bmFloor(itemData.c.v[0]) + ','
        + bmFloor(itemData.c.v[1]) + ','
        + bmFloor(itemData.c.v[2]) + ')';
  }
  if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  }
};

CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;
  var grd;
  if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || (styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf))) {
    var ctx = this.globalData.canvasContext;
    var pt1 = itemData.s.v;
    var pt2 = itemData.e.v;
    if (styleData.t === 1) {
      grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
    } else {
      var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
      var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);

      var percent = itemData.h.v;
      if (percent >= 1) {
        percent = 0.99;
      } else if (percent <= -1) {
        percent = -0.99;
      }
      var dist = rad * percent;
      var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
      var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
      grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
    }

    var i;
    var len = styleData.g.p;
    var cValues = itemData.g.c;
    var opacity = 1;

    for (i = 0; i < len; i += 1) {
      if (itemData.g._hasOpacity && itemData.g._collapsable) {
        opacity = itemData.g.o[i * 2 + 1];
      }
      grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
    }
    styleElem.grd = grd;
  }
  styleElem.coOp = itemData.o.v * groupTransform.opacity;
};

CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
  var styleElem = itemData.style;
  var d = itemData.d;
  if (d && (d._mdf || this._isFirstFrame)) {
    styleElem.da = d.dashArray;
    styleElem.do = d.dashoffset[0];
  }
  if (itemData.c._mdf || this._isFirstFrame) {
    styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
  }
  if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  }
  if (itemData.w._mdf || this._isFirstFrame) {
    styleElem.wi = itemData.w.v;
  }
};

CVShapeElement.prototype.destroy = function () {
  this.shapesData = null;
  this.globalData = null;
  this.canvasContext = null;
  this.stylesList.length = 0;
  this.itemsData.length = 0;
};

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement,
SVGShapeElement, IImageElement */

function CVSolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);

CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

CVSolidElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.fillStyle = this.data.sc;
  ctx.fillRect(0, 0, this.data.sw, this.data.sh);
  //
};

/* global extendPrototype, BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement,
RenderableElement, ITextElement, createTag, createSizedArray */

function CVTextElement(data, globalData, comp) {
  this.textSpans = [];
  this.yOffset = 0;
  this.fillColorAnim = false;
  this.strokeColorAnim = false;
  this.strokeWidthAnim = false;
  this.stroke = false;
  this.fill = false;
  this.justifyOffset = 0;
  this.currentRender = null;
  this.renderType = 'canvas';
  this.values = {
    fill: 'rgba(0,0,0,0)',
    stroke: 'rgba(0,0,0,0)',
    sWidth: 0,
    fValue: '',
  };
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);

CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

CVTextElement.prototype.buildNewText = function () {
  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);

  var hasFill = false;
  if (documentData.fc) {
    hasFill = true;
    this.values.fill = this.buildColor(documentData.fc);
  } else {
    this.values.fill = 'rgba(0,0,0,0)';
  }
  this.fill = hasFill;
  var hasStroke = false;
  if (documentData.sc) {
    hasStroke = true;
    this.values.stroke = this.buildColor(documentData.sc);
    this.values.sWidth = documentData.sw;
  }
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  var i;
  var len;
  var letters = documentData.l;
  var matrixHelper = this.mHelper;
  this.stroke = hasStroke;
  this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
  len = documentData.finalText.length;
  // this.tHelper.font = this.values.fValue;
  var charData;
  var shapeData;
  var k;
  var kLen;
  var shapes;
  var j;
  var jLen;
  var pathNodes;
  var commands;
  var pathArr;
  var singleShape = this.data.singleShape;
  var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
  var xPos = 0;
  var yPos = 0;
  var firstLine = true;
  var cnt = 0;
  for (i = 0; i < len; i += 1) {
    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
    shapeData = (charData && charData.data) || {};
    matrixHelper.reset();
    if (singleShape && letters[i].n) {
      xPos = -trackingOffset;
      yPos += documentData.yOffset;
      yPos += firstLine ? 1 : 0;
      firstLine = false;
    }

    shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
    jLen = shapes.length;
    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
    if (singleShape) {
      this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
    }
    commands = createSizedArray(jLen);
    for (j = 0; j < jLen; j += 1) {
      kLen = shapes[j].ks.k.i.length;
      pathNodes = shapes[j].ks.k;
      pathArr = [];
      for (k = 1; k < kLen; k += 1) {
        if (k === 1) {
          pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
        }
        pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
      }
      pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
      commands[j] = pathArr;
    }
    if (singleShape) {
      xPos += letters[i].l;
      xPos += trackingOffset;
    }
    if (this.textSpans[cnt]) {
      this.textSpans[cnt].elem = commands;
    } else {
      this.textSpans[cnt] = { elem: commands };
    }
    cnt += 1;
  }
};

CVTextElement.prototype.renderInnerContent = function () {
  var ctx = this.canvasContext;
  ctx.font = this.values.fValue;
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;

  if (!this.data.singleShape) {
    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  }

  var i;
  var len;
  var j;
  var jLen;
  var k;
  var kLen;
  var renderedLetters = this.textAnimator.renderedLetters;

  var letters = this.textProperty.currentData.l;

  len = letters.length;
  var renderedLetter;
  var lastFill = null;
  var lastStroke = null;
  var lastStrokeW = null;
  var commands;
  var pathArr;
  for (i = 0; i < len; i += 1) {
    if (!letters[i].n) {
      renderedLetter = renderedLetters[i];
      if (renderedLetter) {
        this.globalData.renderer.save();
        this.globalData.renderer.ctxTransform(renderedLetter.p);
        this.globalData.renderer.ctxOpacity(renderedLetter.o);
      }
      if (this.fill) {
        if (renderedLetter && renderedLetter.fc) {
          if (lastFill !== renderedLetter.fc) {
            lastFill = renderedLetter.fc;
            ctx.fillStyle = renderedLetter.fc;
          }
        } else if (lastFill !== this.values.fill) {
          lastFill = this.values.fill;
          ctx.fillStyle = this.values.fill;
        }
        commands = this.textSpans[i].elem;
        jLen = commands.length;
        this.globalData.canvasContext.beginPath();
        for (j = 0; j < jLen; j += 1) {
          pathArr = commands[j];
          kLen = pathArr.length;
          this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
          for (k = 2; k < kLen; k += 6) {
            this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
          }
        }
        this.globalData.canvasContext.closePath();
        this.globalData.canvasContext.fill();
        /// ctx.fillText(this.textSpans[i].val,0,0);
      }
      if (this.stroke) {
        if (renderedLetter && renderedLetter.sw) {
          if (lastStrokeW !== renderedLetter.sw) {
            lastStrokeW = renderedLetter.sw;
            ctx.lineWidth = renderedLetter.sw;
          }
        } else if (lastStrokeW !== this.values.sWidth) {
          lastStrokeW = this.values.sWidth;
          ctx.lineWidth = this.values.sWidth;
        }
        if (renderedLetter && renderedLetter.sc) {
          if (lastStroke !== renderedLetter.sc) {
            lastStroke = renderedLetter.sc;
            ctx.strokeStyle = renderedLetter.sc;
          }
        } else if (lastStroke !== this.values.stroke) {
          lastStroke = this.values.stroke;
          ctx.strokeStyle = this.values.stroke;
        }
        commands = this.textSpans[i].elem;
        jLen = commands.length;
        this.globalData.canvasContext.beginPath();
        for (j = 0; j < jLen; j += 1) {
          pathArr = commands[j];
          kLen = pathArr.length;
          this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
          for (k = 2; k < kLen; k += 6) {
            this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
          }
        }
        this.globalData.canvasContext.closePath();
        this.globalData.canvasContext.stroke();
        /// ctx.strokeText(letters[i].val,0,0);
      }
      if (renderedLetter) {
        this.globalData.renderer.restore();
      }
    }
  }
};

function CVEffects() {

}
CVEffects.prototype.renderFrame = function () {};

/* global createTag, createNS, styleDiv, CVEffects, MaskElement, SVGBaseElement, HybridRenderer */

function HBaseElement() {}
HBaseElement.prototype = {
  checkBlendMode: function () {},
  initRendererElement: function () {
    this.baseElement = createTag(this.data.tg || 'div');
    if (this.data.hasMask) {
      this.svgElement = createNS('svg');
      this.layerElement = createNS('g');
      this.maskedElement = this.layerElement;
      this.svgElement.appendChild(this.layerElement);
      this.baseElement.appendChild(this.svgElement);
    } else {
      this.layerElement = this.baseElement;
    }
    styleDiv(this.baseElement);
  },
  createContainerElements: function () {
    this.renderableEffectsManager = new CVEffects(this);
    this.transformedElement = this.baseElement;
    this.maskedElement = this.layerElement;
    if (this.data.ln) {
      this.layerElement.setAttribute('id', this.data.ln);
    }
    if (this.data.cl) {
      this.layerElement.setAttribute('class', this.data.cl);
    }
    if (this.data.bm !== 0) {
      this.setBlendMode();
    }
  },
  renderElement: function () {
    var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
    if (this.finalTransform._matMdf) {
      var matrixValue = this.finalTransform.mat.toCSS();
      transformedElementStyle.transform = matrixValue;
      transformedElementStyle.webkitTransform = matrixValue;
    }
    if (this.finalTransform._opMdf) {
      transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
    }
  },
  renderFrame: function () {
    // If it is exported as hidden (data.hd === true) no need to render
    // If it is not visible no need to render
    if (this.data.hd || this.hidden) {
      return;
    }
    this.renderTransform();
    this.renderRenderable();
    this.renderElement();
    this.renderInnerContent();
    if (this._isFirstFrame) {
      this._isFirstFrame = false;
    }
  },
  destroy: function () {
    this.layerElement = null;
    this.transformedElement = null;
    if (this.matteElement) {
      this.matteElement = null;
    }
    if (this.maskManager) {
      this.maskManager.destroy();
      this.maskManager = null;
    }
  },
  createRenderableComponents: function () {
    this.maskManager = new MaskElement(this.data, this, this.globalData);
  },
  addEffects: function () {
  },
  setMatte: function () {},
};
HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, createNS, createTag */

function HSolidElement(data, globalData, comp) {
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);

HSolidElement.prototype.createContent = function () {
  var rect;
  if (this.data.hasMask) {
    rect = createNS('rect');
    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.svgElement.setAttribute('width', this.data.sw);
    this.svgElement.setAttribute('height', this.data.sh);
  } else {
    rect = createTag('div');
    rect.style.width = this.data.sw + 'px';
    rect.style.height = this.data.sh + 'px';
    rect.style.backgroundColor = this.data.sc;
  }
  this.layerElement.appendChild(rect);
};

/* global createSizedArray, PropertyFactory, extendPrototype, HybridRenderer, ICompElement, HBaseElement */

function HCompElement(data, globalData, comp) {
  this.layers = data.layers;
  this.supports3d = !data.hasMask;
  this.completeLayers = false;
  this.pendingElements = [];
  this.elements = this.layers ? createSizedArray(this.layers.length) : [];
  this.initElement(data, globalData, comp);
  this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : { _placeholder: true };
}

extendPrototype([HybridRenderer, ICompElement, HBaseElement], HCompElement);
HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

HCompElement.prototype.createContainerElements = function () {
  this._createBaseContainerElements();
  // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
  if (this.data.hasMask) {
    this.svgElement.setAttribute('width', this.data.w);
    this.svgElement.setAttribute('height', this.data.h);
    this.transformedElement = this.baseElement;
  } else {
    this.transformedElement = this.layerElement;
  }
};

HCompElement.prototype.addTo3dContainer = function (elem, pos) {
  var j = 0;
  var nextElement;
  while (j < pos) {
    if (this.elements[j] && this.elements[j].getBaseElement) {
      nextElement = this.elements[j].getBaseElement();
    }
    j += 1;
  }
  if (nextElement) {
    this.layerElement.insertBefore(elem, nextElement);
  } else {
    this.layerElement.appendChild(elem);
  }
};

/* global createNS, extendPrototype, BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement,
HierarchyElement, FrameElement, RenderableElement, createNS, bmMin, bmSqrt, bmMin, bmMax, bmPow */

function HShapeElement(data, globalData, comp) {
  // List of drawable elements
  this.shapes = [];
  // Full shape data
  this.shapesData = data.shapes;
  // List of styles that will be applied to shapes
  this.stylesList = [];
  // List of modifiers that will be applied to shapes
  this.shapeModifiers = [];
  // List of items in shape tree
  this.itemsData = [];
  // List of items in previous shape tree
  this.processedElements = [];
  // List of animated components
  this.animatedContents = [];
  this.shapesContainer = createNS('g');
  this.initElement(data, globalData, comp);
  // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  // List of elements that have been created
  this.prevViewData = [];
  this.currentBBox = {
    x: 999999,
    y: -999999,
    h: 0,
    w: 0,
  };
}
extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

HShapeElement.prototype.createContent = function () {
  var cont;
  this.baseElement.style.fontSize = 0;
  if (this.data.hasMask) {
    this.layerElement.appendChild(this.shapesContainer);
    cont = this.svgElement;
  } else {
    cont = createNS('svg');
    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
    cont.setAttribute('width', size.w);
    cont.setAttribute('height', size.h);
    cont.appendChild(this.shapesContainer);
    this.layerElement.appendChild(cont);
  }

  this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
  this.filterUniqueShapes();
  this.shapeCont = cont;
};

HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
  var i;
  var len = transformers.length;
  for (i = 0; i < len; i += 1) {
    point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
  }
  return point;
};

HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
  var shape = item.sh.v;
  var transformers = item.transformers;
  var i;
  var len = shape._length;
  var vPoint;
  var oPoint;
  var nextIPoint;
  var nextVPoint;
  if (len <= 1) {
    return;
  }
  for (i = 0; i < len - 1; i += 1) {
    vPoint = this.getTransformedPoint(transformers, shape.v[i]);
    oPoint = this.getTransformedPoint(transformers, shape.o[i]);
    nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
    nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
    this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
  }
  if (shape.c) {
    vPoint = this.getTransformedPoint(transformers, shape.v[i]);
    oPoint = this.getTransformedPoint(transformers, shape.o[i]);
    nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
    nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
    this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
  }
};

HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
  this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
  var bounds = this.shapeBoundingBox;
  boundingBox.x = bmMin(bounds.left, boundingBox.x);
  boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
  boundingBox.y = bmMin(bounds.top, boundingBox.y);
  boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
};

HShapeElement.prototype.shapeBoundingBox = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
};

HShapeElement.prototype.tempBoundingBox = {
  x: 0,
  xMax: 0,
  y: 0,
  yMax: 0,
  width: 0,
  height: 0,
};

HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
  var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];

  for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) { // eslint-disable-line no-plusplus
    b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
    a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
    c = 3 * p1[i] - 3 * p0[i];

    b |= 0; // eslint-disable-line no-bitwise
    a |= 0; // eslint-disable-line no-bitwise
    c |= 0; // eslint-disable-line no-bitwise

    if (a === 0 && b === 0) {
      //
    } else if (a === 0) {
      t = -c / b;

      if (t > 0 && t < 1) {
        bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
      }
    } else {
      b2ac = b * b - 4 * c * a;

      if (b2ac >= 0) {
        t1 = (-b + bmSqrt(b2ac)) / (2 * a);
        if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
        t2 = (-b - bmSqrt(b2ac)) / (2 * a);
        if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
      }
    }
  }

  this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
  this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
  this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
  this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
};

HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
  return bmPow(1 - t, 3) * p0[i]
        + 3 * bmPow(1 - t, 2) * t * p1[i]
        + 3 * (1 - t) * bmPow(t, 2) * p2[i]
        + bmPow(t, 3) * p3[i];
};

HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
  var i;
  var len = itemsData.length;
  for (i = 0; i < len; i += 1) {
    if (itemsData[i] && itemsData[i].sh) {
      this.calculateShapeBoundingBox(itemsData[i], boundingBox);
    } else if (itemsData[i] && itemsData[i].it) {
      this.calculateBoundingBox(itemsData[i].it, boundingBox);
    }
  }
};

HShapeElement.prototype.currentBoxContains = function (box) {
  return this.currentBBox.x <= box.x
    && this.currentBBox.y <= box.y
    && this.currentBBox.width + this.currentBBox.x >= box.x + box.width
    && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
};

HShapeElement.prototype.renderInnerContent = function () {
  this._renderShapeFrame();

  if (!this.hidden && (this._isFirstFrame || this._mdf)) {
    var tempBoundingBox = this.tempBoundingBox;
    var max = 999999;
    tempBoundingBox.x = max;
    tempBoundingBox.xMax = -max;
    tempBoundingBox.y = max;
    tempBoundingBox.yMax = -max;
    this.calculateBoundingBox(this.itemsData, tempBoundingBox);
    tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
    tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
    // var tempBoundingBox = this.shapeCont.getBBox();
    if (this.currentBoxContains(tempBoundingBox)) {
      return;
    }
    var changed = false;
    if (this.currentBBox.w !== tempBoundingBox.width) {
      this.currentBBox.w = tempBoundingBox.width;
      this.shapeCont.setAttribute('width', tempBoundingBox.width);
      changed = true;
    }
    if (this.currentBBox.h !== tempBoundingBox.height) {
      this.currentBBox.h = tempBoundingBox.height;
      this.shapeCont.setAttribute('height', tempBoundingBox.height);
      changed = true;
    }
    if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
      this.currentBBox.w = tempBoundingBox.width;
      this.currentBBox.h = tempBoundingBox.height;
      this.currentBBox.x = tempBoundingBox.x;
      this.currentBBox.y = tempBoundingBox.y;

      this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
      var shapeStyle = this.shapeCont.style;
      var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
      shapeStyle.transform = shapeTransform;
      shapeStyle.webkitTransform = shapeTransform;
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement,
RenderableDOMElement, ITextElement, createSizedArray, createTag, styleDiv, createNS */

function HTextElement(data, globalData, comp) {
  this.textSpans = [];
  this.textPaths = [];
  this.currentBBox = {
    x: 999999,
    y: -999999,
    h: 0,
    w: 0,
  };
  this.renderType = 'svg';
  this.isMasked = false;
  this.initElement(data, globalData, comp);
}
extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);

HTextElement.prototype.createContent = function () {
  this.isMasked = this.checkMasks();
  if (this.isMasked) {
    this.renderType = 'svg';
    this.compW = this.comp.data.w;
    this.compH = this.comp.data.h;
    this.svgElement.setAttribute('width', this.compW);
    this.svgElement.setAttribute('height', this.compH);
    var g = createNS('g');
    this.maskedElement.appendChild(g);
    this.innerElem = g;
  } else {
    this.renderType = 'html';
    this.innerElem = this.layerElement;
  }

  this.checkParenting();
};

HTextElement.prototype.buildNewText = function () {
  var documentData = this.textProperty.currentData;
  this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
  var innerElemStyle = this.innerElem.style;
  var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
  innerElemStyle.fill = textColor;
  innerElemStyle.color = textColor;
  if (documentData.sc) {
    innerElemStyle.stroke = this.buildColor(documentData.sc);
    innerElemStyle.strokeWidth = documentData.sw + 'px';
  }
  var fontData = this.globalData.fontManager.getFontByName(documentData.f);
  if (!this.globalData.fontManager.chars) {
    innerElemStyle.fontSize = documentData.finalSize + 'px';
    innerElemStyle.lineHeight = documentData.finalSize + 'px';
    if (fontData.fClass) {
      this.innerElem.className = fontData.fClass;
    } else {
      innerElemStyle.fontFamily = fontData.fFamily;
      var fWeight = documentData.fWeight;
      var fStyle = documentData.fStyle;
      innerElemStyle.fontStyle = fStyle;
      innerElemStyle.fontWeight = fWeight;
    }
  }
  var i;
  var len;

  var letters = documentData.l;
  len = letters.length;
  var tSpan;
  var tParent;
  var tCont;
  var matrixHelper = this.mHelper;
  var shapes;
  var shapeStr = '';
  var cnt = 0;
  for (i = 0; i < len; i += 1) {
    if (this.globalData.fontManager.chars) {
      if (!this.textPaths[cnt]) {
        tSpan = createNS('path');
        tSpan.setAttribute('stroke-linecap', 'butt');
        tSpan.setAttribute('stroke-linejoin', 'round');
        tSpan.setAttribute('stroke-miterlimit', '4');
      } else {
        tSpan = this.textPaths[cnt];
      }
      if (!this.isMasked) {
        if (this.textSpans[cnt]) {
          tParent = this.textSpans[cnt];
          tCont = tParent.children[0];
        } else {
          tParent = createTag('div');
          tParent.style.lineHeight = 0;
          tCont = createNS('svg');
          tCont.appendChild(tSpan);
          styleDiv(tParent);
        }
      }
    } else if (!this.isMasked) {
      if (this.textSpans[cnt]) {
        tParent = this.textSpans[cnt];
        tSpan = this.textPaths[cnt];
      } else {
        tParent = createTag('span');
        styleDiv(tParent);
        tSpan = createTag('span');
        styleDiv(tSpan);
        tParent.appendChild(tSpan);
      }
    } else {
      tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
    }
    // tSpan.setAttribute('visibility', 'hidden');
    if (this.globalData.fontManager.chars) {
      var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
      var shapeData;
      if (charData) {
        shapeData = charData.data;
      } else {
        shapeData = null;
      }
      matrixHelper.reset();
      if (shapeData && shapeData.shapes) {
        shapes = shapeData.shapes[0].it;
        matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
        shapeStr = this.createPathShape(matrixHelper, shapes);
        tSpan.setAttribute('d', shapeStr);
      }
      if (!this.isMasked) {
        this.innerElem.appendChild(tParent);
        if (shapeData && shapeData.shapes) {
          // document.body.appendChild is needed to get exact measure of shape
          document.body.appendChild(tCont);
          var boundingBox = tCont.getBBox();
          tCont.setAttribute('width', boundingBox.width + 2);
          tCont.setAttribute('height', boundingBox.height + 2);
          tCont.setAttribute('viewBox', (boundingBox.x - 1) + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
          var tContStyle = tCont.style;
          var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
          tContStyle.transform = tContTranslation;
          tContStyle.webkitTransform = tContTranslation;

          letters[i].yOffset = boundingBox.y - 1;
        } else {
          tCont.setAttribute('width', 1);
          tCont.setAttribute('height', 1);
        }
        tParent.appendChild(tCont);
      } else {
        this.innerElem.appendChild(tSpan);
      }
    } else {
      tSpan.textContent = letters[i].val;
      tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
      if (!this.isMasked) {
        this.innerElem.appendChild(tParent);
        //
        var tStyle = tSpan.style;
        var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
        tStyle.transform = tSpanTranslation;
        tStyle.webkitTransform = tSpanTranslation;
      } else {
        this.innerElem.appendChild(tSpan);
      }
    }
    //
    if (!this.isMasked) {
      this.textSpans[cnt] = tParent;
    } else {
      this.textSpans[cnt] = tSpan;
    }
    this.textSpans[cnt].style.display = 'block';
    this.textPaths[cnt] = tSpan;
    cnt += 1;
  }
  while (cnt < this.textSpans.length) {
    this.textSpans[cnt].style.display = 'none';
    cnt += 1;
  }
};

HTextElement.prototype.renderInnerContent = function () {
  var svgStyle;
  if (this.data.singleShape) {
    if (!this._isFirstFrame && !this.lettersChangedFlag) {
      return;
    } if (this.isMasked && this.finalTransform._matMdf) {
      // Todo Benchmark if using this is better than getBBox
      this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
      svgStyle = this.svgElement.style;
      var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
      svgStyle.transform = translation;
      svgStyle.webkitTransform = translation;
    }
  }

  this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
  if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
    return;
  }
  var i;
  var len;
  var count = 0;
  var renderedLetters = this.textAnimator.renderedLetters;

  var letters = this.textProperty.currentData.l;

  len = letters.length;
  var renderedLetter;
  var textSpan;
  var textPath;
  for (i = 0; i < len; i += 1) {
    if (letters[i].n) {
      count += 1;
    } else {
      textSpan = this.textSpans[i];
      textPath = this.textPaths[i];
      renderedLetter = renderedLetters[count];
      count += 1;
      if (renderedLetter._mdf.m) {
        if (!this.isMasked) {
          textSpan.style.webkitTransform = renderedLetter.m;
          textSpan.style.transform = renderedLetter.m;
        } else {
          textSpan.setAttribute('transform', renderedLetter.m);
        }
      }
      /// /textSpan.setAttribute('opacity',renderedLetter.o);
      textSpan.style.opacity = renderedLetter.o;
      if (renderedLetter.sw && renderedLetter._mdf.sw) {
        textPath.setAttribute('stroke-width', renderedLetter.sw);
      }
      if (renderedLetter.sc && renderedLetter._mdf.sc) {
        textPath.setAttribute('stroke', renderedLetter.sc);
      }
      if (renderedLetter.fc && renderedLetter._mdf.fc) {
        textPath.setAttribute('fill', renderedLetter.fc);
        textPath.style.color = renderedLetter.fc;
      }
    }
  }

  if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
    var boundingBox = this.innerElem.getBBox();

    if (this.currentBBox.w !== boundingBox.width) {
      this.currentBBox.w = boundingBox.width;
      this.svgElement.setAttribute('width', boundingBox.width);
    }
    if (this.currentBBox.h !== boundingBox.height) {
      this.currentBBox.h = boundingBox.height;
      this.svgElement.setAttribute('height', boundingBox.height);
    }

    var margin = 1;
    if (this.currentBBox.w !== (boundingBox.width + margin * 2) || this.currentBBox.h !== (boundingBox.height + margin * 2) || this.currentBBox.x !== (boundingBox.x - margin) || this.currentBBox.y !== (boundingBox.y - margin)) {
      this.currentBBox.w = boundingBox.width + margin * 2;
      this.currentBBox.h = boundingBox.height + margin * 2;
      this.currentBBox.x = boundingBox.x - margin;
      this.currentBBox.y = boundingBox.y - margin;

      this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
      svgStyle = this.svgElement.style;
      var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
      svgStyle.transform = svgTransform;
      svgStyle.webkitTransform = svgTransform;
    }
  }
};

/* global extendPrototype, BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement,
FrameElement, RenderableElement, createNS */

function HImageElement(data, globalData, comp) {
  this.assetData = globalData.getAssetData(data.refId);
  this.initElement(data, globalData, comp);
}

extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);

HImageElement.prototype.createContent = function () {
  var assetPath = this.globalData.getAssetsPath(this.assetData);
  var img = new Image();

  if (this.data.hasMask) {
    this.imageElem = createNS('image');
    this.imageElem.setAttribute('width', this.assetData.w + 'px');
    this.imageElem.setAttribute('height', this.assetData.h + 'px');
    this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.imageElem);
    this.baseElement.setAttribute('width', this.assetData.w);
    this.baseElement.setAttribute('height', this.assetData.h);
  } else {
    this.layerElement.appendChild(img);
  }
  img.crossOrigin = 'anonymous';
  img.src = assetPath;
  if (this.data.ln) {
    this.baseElement.setAttribute('id', this.data.ln);
  }
};

/* global PropertyFactory, degToRads, Matrix, extendPrototype, BaseElement, FrameElement, HierarchyElement */

function HCameraElement(data, globalData, comp) {
  this.initFrame();
  this.initBaseData(data, globalData, comp);
  this.initHierarchy();
  var getProp = PropertyFactory.getProp;
  this.pe = getProp(this, data.pe, 0, 0, this);
  if (data.ks.p.s) {
    this.px = getProp(this, data.ks.p.x, 1, 0, this);
    this.py = getProp(this, data.ks.p.y, 1, 0, this);
    this.pz = getProp(this, data.ks.p.z, 1, 0, this);
  } else {
    this.p = getProp(this, data.ks.p, 1, 0, this);
  }
  if (data.ks.a) {
    this.a = getProp(this, data.ks.a, 1, 0, this);
  }
  if (data.ks.or.k.length && data.ks.or.k[0].to) {
    var i;
    var len = data.ks.or.k.length;
    for (i = 0; i < len; i += 1) {
      data.ks.or.k[i].to = null;
      data.ks.or.k[i].ti = null;
    }
  }
  this.or = getProp(this, data.ks.or, 1, degToRads, this);
  this.or.sh = true;
  this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
  this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
  this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
  this.mat = new Matrix();
  this._prevMat = new Matrix();
  this._isFirstFrame = true;

  // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
  this.finalTransform = {
    mProp: this,
  };
}
extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

HCameraElement.prototype.setup = function () {
  var i;
  var len = this.comp.threeDElements.length;
  var comp;
  var perspectiveStyle;
  var containerStyle;
  for (i = 0; i < len; i += 1) {
    // [perspectiveElem,container]
    comp = this.comp.threeDElements[i];
    if (comp.type === '3d') {
      perspectiveStyle = comp.perspectiveElem.style;
      containerStyle = comp.container.style;
      var perspective = this.pe.v + 'px';
      var origin = '0px 0px 0px';
      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
      perspectiveStyle.perspective = perspective;
      perspectiveStyle.webkitPerspective = perspective;
      containerStyle.transformOrigin = origin;
      containerStyle.mozTransformOrigin = origin;
      containerStyle.webkitTransformOrigin = origin;
      perspectiveStyle.transform = matrix;
      perspectiveStyle.webkitTransform = matrix;
    }
  }
};

HCameraElement.prototype.createElements = function () {
};

HCameraElement.prototype.hide = function () {
};

HCameraElement.prototype.renderFrame = function () {
  var _mdf = this._isFirstFrame;
  var i;
  var len;
  if (this.hierarchy) {
    len = this.hierarchy.length;
    for (i = 0; i < len; i += 1) {
      _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
    }
  }
  if (_mdf || this.pe._mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
    this.mat.reset();

    if (this.hierarchy) {
      len = this.hierarchy.length - 1;
      for (i = len; i >= 0; i -= 1) {
        var mTransf = this.hierarchy[i].finalTransform.mProp;
        this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
        this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
        this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
        this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
        this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
      }
    }
    if (this.p) {
      this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
    } else {
      this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
    }
    if (this.a) {
      var diffVector;
      if (this.p) {
        diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
      } else {
        diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
      }
      var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2));
      // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
      var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
      var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
      var mRotationX = (Math.atan2(lookDir[1], lookLengthOnXZ));
      var mRotationY = (Math.atan2(lookDir[0], -lookDir[2]));
      this.mat.rotateY(mRotationY).rotateX(-mRotationX);
    }
    this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
    this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
    this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
    this.mat.translate(0, 0, this.pe.v);

    var hasMatrixChanged = !this._prevMat.equals(this.mat);
    if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
      len = this.comp.threeDElements.length;
      var comp;
      var perspectiveStyle;
      var containerStyle;
      for (i = 0; i < len; i += 1) {
        comp = this.comp.threeDElements[i];
        if (comp.type === '3d') {
          if (hasMatrixChanged) {
            var matValue = this.mat.toCSS();
            containerStyle = comp.container.style;
            containerStyle.transform = matValue;
            containerStyle.webkitTransform = matValue;
          }
          if (this.pe._mdf) {
            perspectiveStyle = comp.perspectiveElem.style;
            perspectiveStyle.perspective = this.pe.v + 'px';
            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
          }
        }
      }
      this.mat.clone(this._prevMat);
    }
  }
  this._isFirstFrame = false;
};

HCameraElement.prototype.prepareFrame = function (num) {
  this.prepareProperties(num, true);
};

HCameraElement.prototype.destroy = function () {
};
HCameraElement.prototype.getBaseElement = function () { return null; };

function HEffects() {
}
HEffects.prototype.renderFrame = function () {};

/* global createTag, AnimationItem */
/* exported animationManager */

var animationManager = (function () {
  var moduleOb = {};
  var registeredAnimations = [];
  var initTime = 0;
  var len = 0;
  var playingAnimationsNum = 0;
  var _stopped = true;
  var _isFrozen = false;

  function removeElement(ev) {
    var i = 0;
    var animItem = ev.target;
    while (i < len) {
      if (registeredAnimations[i].animation === animItem) {
        registeredAnimations.splice(i, 1);
        i -= 1;
        len -= 1;
        if (!animItem.isPaused) {
          subtractPlayingCount();
        }
      }
      i += 1;
    }
  }

  function registerAnimation(element, animationData) {
    if (!element) {
      return null;
    }
    var i = 0;
    while (i < len) {
      if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
        return registeredAnimations[i].animation;
      }
      i += 1;
    }
    var animItem = new AnimationItem();
    setupAnimation(animItem, element);
    animItem.setData(element, animationData);
    return animItem;
  }

  function getRegisteredAnimations() {
    var i;
    var lenAnims = registeredAnimations.length;
    var animations = [];
    for (i = 0; i < lenAnims; i += 1) {
      animations.push(registeredAnimations[i].animation);
    }
    return animations;
  }

  function addPlayingCount() {
    playingAnimationsNum += 1;
    activate();
  }

  function subtractPlayingCount() {
    playingAnimationsNum -= 1;
  }

  function setupAnimation(animItem, element) {
    animItem.addEventListener('destroy', removeElement);
    animItem.addEventListener('_active', addPlayingCount);
    animItem.addEventListener('_idle', subtractPlayingCount);
    registeredAnimations.push({ elem: element, animation: animItem });
    len += 1;
  }

  function loadAnimation(params) {
    var animItem = new AnimationItem();
    setupAnimation(animItem, null);
    animItem.setParams(params);
    return animItem;
  }

  function setSpeed(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setSpeed(val, animation);
    }
  }

  function setDirection(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setDirection(val, animation);
    }
  }

  function play(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.play(animation);
    }
  }
  function resume(nowTime) {
    var elapsedTime = nowTime - initTime;
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.advanceTime(elapsedTime);
    }
    initTime = nowTime;
    if (playingAnimationsNum && !_isFrozen) {
      window.requestAnimationFrame(resume);
    } else {
      _stopped = true;
    }
  }

  function first(nowTime) {
    initTime = nowTime;
    window.requestAnimationFrame(resume);
  }

  function pause(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.pause(animation);
    }
  }

  function goToAndStop(value, isFrame, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
    }
  }

  function stop(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.stop(animation);
    }
  }

  function togglePause(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.togglePause(animation);
    }
  }

  function destroy(animation) {
    var i;
    for (i = (len - 1); i >= 0; i -= 1) {
      registeredAnimations[i].animation.destroy(animation);
    }
  }

  function searchAnimations(animationData, standalone, renderer) {
    var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
      [].slice.call(document.getElementsByClassName('bodymovin')));
    var i;
    var lenAnims = animElements.length;
    for (i = 0; i < lenAnims; i += 1) {
      if (renderer) {
        animElements[i].setAttribute('data-bm-type', renderer);
      }
      registerAnimation(animElements[i], animationData);
    }
    if (standalone && lenAnims === 0) {
      if (!renderer) {
        renderer = 'svg';
      }
      var body = document.getElementsByTagName('body')[0];
      body.innerText = '';
      var div = createTag('div');
      div.style.width = '100%';
      div.style.height = '100%';
      div.setAttribute('data-bm-type', renderer);
      body.appendChild(div);
      registerAnimation(div, animationData);
    }
  }

  function resize() {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.resize();
    }
  }

  function activate() {
    if (!_isFrozen && playingAnimationsNum) {
      if (_stopped) {
        window.requestAnimationFrame(first);
        _stopped = false;
      }
    }
  }

  function freeze() {
    _isFrozen = true;
  }

  function unfreeze() {
    _isFrozen = false;
    activate();
  }

  function setVolume(val, animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.setVolume(val, animation);
    }
  }

  function mute(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.mute(animation);
    }
  }

  function unmute(animation) {
    var i;
    for (i = 0; i < len; i += 1) {
      registeredAnimations[i].animation.unmute(animation);
    }
  }

  moduleOb.registerAnimation = registerAnimation;
  moduleOb.loadAnimation = loadAnimation;
  moduleOb.setSpeed = setSpeed;
  moduleOb.setDirection = setDirection;
  moduleOb.play = play;
  moduleOb.pause = pause;
  moduleOb.stop = stop;
  moduleOb.togglePause = togglePause;
  moduleOb.searchAnimations = searchAnimations;
  moduleOb.resize = resize;
  // moduleOb.start = start;
  moduleOb.goToAndStop = goToAndStop;
  moduleOb.destroy = destroy;
  moduleOb.freeze = freeze;
  moduleOb.unfreeze = unfreeze;
  moduleOb.setVolume = setVolume;
  moduleOb.mute = mute;
  moduleOb.unmute = unmute;
  moduleOb.getRegisteredAnimations = getRegisteredAnimations;
  return moduleOb;
}());

/* global createElementID, subframeEnabled, ProjectInterface, ImagePreloader, audioControllerFactory, extendPrototype, BaseEvent,
CanvasRenderer, SVGRenderer, HybridRenderer, assetLoader, dataManager, expressionsPlugin, BMEnterFrameEvent, BMCompleteLoopEvent,
BMCompleteEvent, BMSegmentStartEvent, BMDestroyEvent, BMEnterFrameEvent, BMCompleteLoopEvent, BMCompleteEvent, BMSegmentStartEvent,
BMDestroyEvent, BMRenderFrameErrorEvent, BMConfigErrorEvent */

var AnimationItem = function () {
  this._cbs = [];
  this.name = '';
  this.path = '';
  this.isLoaded = false;
  this.currentFrame = 0;
  this.currentRawFrame = 0;
  this.firstFrame = 0;
  this.totalFrames = 0;
  this.frameRate = 0;
  this.frameMult = 0;
  this.playSpeed = 1;
  this.playDirection = 1;
  this.playCount = 0;
  this.animationData = {};
  this.assets = [];
  this.isPaused = true;
  this.autoplay = false;
  this.loop = true;
  this.renderer = null;
  this.animationID = createElementID();
  this.assetsPath = '';
  this.timeCompleted = 0;
  this.segmentPos = 0;
  this.isSubframeEnabled = subframeEnabled;
  this.segments = [];
  this._idle = true;
  this._completedLoop = false;
  this.projectInterface = ProjectInterface();
  this.imagePreloader = new ImagePreloader();
  this.audioController = audioControllerFactory();
};

extendPrototype([BaseEvent], AnimationItem);

AnimationItem.prototype.setParams = function (params) {
  if (params.wrapper || params.container) {
    this.wrapper = params.wrapper || params.container;
  }
  var animType = 'svg';
  if (params.animType) {
    animType = params.animType;
  } else if (params.renderer) {
    animType = params.renderer;
  }
  switch (animType) {
    case 'canvas':
      this.renderer = new CanvasRenderer(this, params.rendererSettings);
      break;
    case 'svg':
      this.renderer = new SVGRenderer(this, params.rendererSettings);
      break;
    default:
      this.renderer = new HybridRenderer(this, params.rendererSettings);
      break;
  }
  this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
  this.renderer.setProjectInterface(this.projectInterface);
  this.animType = animType;
  if (params.loop === ''
        || params.loop === null
        || params.loop === undefined
        || params.loop === true) {
    this.loop = true;
  } else if (params.loop === false) {
    this.loop = false;
  } else {
    this.loop = parseInt(params.loop, 10);
  }
  this.autoplay = 'autoplay' in params ? params.autoplay : true;
  this.name = params.name ? params.name : '';
  this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
  this.assetsPath = params.assetsPath;
  this.initialSegment = params.initialSegment;
  if (params.audioFactory) {
    this.audioController.setAudioFactory(params.audioFactory);
  }
  if (params.animationData) {
    this.configAnimation(params.animationData);
  } else if (params.path) {
    if (params.path.lastIndexOf('\\') !== -1) {
      this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
    } else {
      this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
    }
    this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
    this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));

    assetLoader.load(params.path, this.configAnimation.bind(this), function () {
      this.trigger('data_failed');
    }.bind(this));
  }
};

AnimationItem.prototype.setData = function (wrapper, animationData) {
  if (animationData) {
    if (typeof animationData !== 'object') {
      animationData = JSON.parse(animationData);
    }
  }
  var params = {
    wrapper: wrapper,
    animationData: animationData,
  };
  var wrapperAttributes = wrapper.attributes;

  params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-animation-path').value
    : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-path').value
      : wrapperAttributes.getNamedItem('bm-path')
        ? wrapperAttributes.getNamedItem('bm-path').value
        : '';
  params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-type').value
    : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-type').value
      : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
        ? wrapperAttributes.getNamedItem('bm-type').value
        : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
          ? wrapperAttributes.getNamedItem('data-bm-renderer').value
          : wrapperAttributes.getNamedItem('bm-renderer')
            ? wrapperAttributes.getNamedItem('bm-renderer').value
            : 'canvas';

  var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-loop').value
    : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-loop').value
      : wrapperAttributes.getNamedItem('bm-loop')
        ? wrapperAttributes.getNamedItem('bm-loop').value
        : '';
  if (loop === 'false') {
    params.loop = false;
  } else if (loop === 'true') {
    params.loop = true;
  } else if (loop !== '') {
    params.loop = parseInt(loop, 10);
  }
  var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value
    : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-autoplay').value
      : wrapperAttributes.getNamedItem('bm-autoplay')
        ? wrapperAttributes.getNamedItem('bm-autoplay').value
        : true;
  params.autoplay = autoplay !== 'false';

  params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-name').value
    : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-name').value
      : wrapperAttributes.getNamedItem('bm-name')
        ? wrapperAttributes.getNamedItem('bm-name').value
        : '';
  var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-prerender').value
    : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
      ? wrapperAttributes.getNamedItem('data-bm-prerender').value
      : wrapperAttributes.getNamedItem('bm-prerender')
        ? wrapperAttributes.getNamedItem('bm-prerender').value
        : '';

  if (prerender === 'false') {
    params.prerender = false;
  }
  this.setParams(params);
};

AnimationItem.prototype.includeLayers = function (data) {
  if (data.op > this.animationData.op) {
    this.animationData.op = data.op;
    this.totalFrames = Math.floor(data.op - this.animationData.ip);
  }
  var layers = this.animationData.layers;
  var i;
  var len = layers.length;
  var newLayers = data.layers;
  var j;
  var jLen = newLayers.length;
  for (j = 0; j < jLen; j += 1) {
    i = 0;
    while (i < len) {
      if (layers[i].id === newLayers[j].id) {
        layers[i] = newLayers[j];
        break;
      }
      i += 1;
    }
  }
  if (data.chars || data.fonts) {
    this.renderer.globalData.fontManager.addChars(data.chars);
    this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
  }
  if (data.assets) {
    len = data.assets.length;
    for (i = 0; i < len; i += 1) {
      this.animationData.assets.push(data.assets[i]);
    }
  }
  this.animationData.__complete = false;
  dataManager.completeData(this.animationData, this.renderer.globalData.fontManager);
  this.renderer.includeLayers(data.layers);
  if (expressionsPlugin) {
    expressionsPlugin.initExpressions(this);
  }
  this.loadNextSegment();
};

AnimationItem.prototype.loadNextSegment = function () {
  var segments = this.animationData.segments;
  if (!segments || segments.length === 0 || !this.autoloadSegments) {
    this.trigger('data_ready');
    this.timeCompleted = this.totalFrames;
    return;
  }
  var segment = segments.shift();
  this.timeCompleted = segment.time * this.frameRate;
  var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
  this.segmentPos += 1;
  assetLoader.load(segmentPath, this.includeLayers.bind(this), function () {
    this.trigger('data_failed');
  }.bind(this));
};

AnimationItem.prototype.loadSegments = function () {
  var segments = this.animationData.segments;
  if (!segments) {
    this.timeCompleted = this.totalFrames;
  }
  this.loadNextSegment();
};

AnimationItem.prototype.imagesLoaded = function () {
  this.trigger('loaded_images');
  this.checkLoaded();
};

AnimationItem.prototype.preloadImages = function () {
  this.imagePreloader.setAssetsPath(this.assetsPath);
  this.imagePreloader.setPath(this.path);
  this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
};

AnimationItem.prototype.configAnimation = function (animData) {
  if (!this.renderer) {
    return;
  }
  try {
    this.animationData = animData;

    if (this.initialSegment) {
      this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
      this.firstFrame = Math.round(this.initialSegment[0]);
    } else {
      this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
      this.firstFrame = Math.round(this.animationData.ip);
    }
    this.renderer.configAnimation(animData);
    if (!animData.assets) {
      animData.assets = [];
    }

    this.assets = this.animationData.assets;
    this.frameRate = this.animationData.fr;
    this.frameMult = this.animationData.fr / 1000;
    this.renderer.searchExtraCompositions(animData.assets);
    this.trigger('config_ready');
    this.preloadImages();
    this.loadSegments();
    this.updaFrameModifier();
    this.waitForFontsLoaded();
    if (this.isPaused) {
      this.audioController.pause();
    }
  } catch (error) {
    this.triggerConfigError(error);
  }
};

AnimationItem.prototype.waitForFontsLoaded = function () {
  if (!this.renderer) {
    return;
  }
  if (this.renderer.globalData.fontManager.isLoaded) {
    this.checkLoaded();
  } else {
    setTimeout(this.waitForFontsLoaded.bind(this), 20);
  }
};

AnimationItem.prototype.checkLoaded = function () {
  if (!this.isLoaded
        && this.renderer.globalData.fontManager.isLoaded
        && (this.imagePreloader.loaded() || this.renderer.rendererType !== 'canvas')
  ) {
    this.isLoaded = true;
    dataManager.completeData(this.animationData, this.renderer.globalData.fontManager);
    if (expressionsPlugin) {
      expressionsPlugin.initExpressions(this);
    }
    this.renderer.initItems();
    setTimeout(function () {
      this.trigger('DOMLoaded');
    }.bind(this), 0);
    this.gotoFrame();
    if (this.autoplay) {
      this.play();
    }
  }
};

AnimationItem.prototype.resize = function () {
  this.renderer.updateContainerSize();
};

AnimationItem.prototype.setSubframe = function (flag) {
  this.isSubframeEnabled = !!flag;
};

AnimationItem.prototype.gotoFrame = function () {
  this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

  if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
    this.currentFrame = this.timeCompleted;
  }
  this.trigger('enterFrame');
  this.renderFrame();
};

AnimationItem.prototype.renderFrame = function () {
  if (this.isLoaded === false) {
    return;
  }
  try {
    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
  } catch (error) {
    this.triggerRenderFrameError(error);
  }
};

AnimationItem.prototype.play = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === true) {
    this.isPaused = false;
    this.audioController.resume();
    if (this._idle) {
      this._idle = false;
      this.trigger('_active');
    }
  }
};

AnimationItem.prototype.pause = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === false) {
    this.isPaused = true;
    this._idle = true;
    this.trigger('_idle');
    this.audioController.pause();
  }
};

AnimationItem.prototype.togglePause = function (name) {
  if (name && this.name !== name) {
    return;
  }
  if (this.isPaused === true) {
    this.play();
  } else {
    this.pause();
  }
};

AnimationItem.prototype.stop = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.pause();
  this.playCount = 0;
  this._completedLoop = false;
  this.setCurrentRawFrameValue(0);
};

AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
  if (name && this.name !== name) {
    return;
  }
  if (isFrame) {
    this.setCurrentRawFrameValue(value);
  } else {
    this.setCurrentRawFrameValue(value * this.frameModifier);
  }
  this.pause();
};

AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
  this.goToAndStop(value, isFrame, name);
  this.play();
};

AnimationItem.prototype.advanceTime = function (value) {
  if (this.isPaused === true || this.isLoaded === false) {
    return;
  }
  var nextValue = this.currentRawFrame + value * this.frameModifier;
  var _isComplete = false;
  // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
  // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
  if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
    if (!this.loop || this.playCount === this.loop) {
      if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
        _isComplete = true;
        nextValue = this.totalFrames - 1;
      }
    } else if (nextValue >= this.totalFrames) {
      this.playCount += 1;
      if (!this.checkSegments(nextValue % this.totalFrames)) {
        this.setCurrentRawFrameValue(nextValue % this.totalFrames);
        this._completedLoop = true;
        this.trigger('loopComplete');
      }
    } else {
      this.setCurrentRawFrameValue(nextValue);
    }
  } else if (nextValue < 0) {
    if (!this.checkSegments(nextValue % this.totalFrames)) {
      if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) { // eslint-disable-line no-plusplus
        this.setCurrentRawFrameValue(this.totalFrames + (nextValue % this.totalFrames));
        if (!this._completedLoop) {
          this._completedLoop = true;
        } else {
          this.trigger('loopComplete');
        }
      } else {
        _isComplete = true;
        nextValue = 0;
      }
    }
  } else {
    this.setCurrentRawFrameValue(nextValue);
  }
  if (_isComplete) {
    this.setCurrentRawFrameValue(nextValue);
    this.pause();
    this.trigger('complete');
  }
};

AnimationItem.prototype.adjustSegment = function (arr, offset) {
  this.playCount = 0;
  if (arr[1] < arr[0]) {
    if (this.frameModifier > 0) {
      if (this.playSpeed < 0) {
        this.setSpeed(-this.playSpeed);
      } else {
        this.setDirection(-1);
      }
    }
    this.totalFrames = arr[0] - arr[1];
    this.timeCompleted = this.totalFrames;
    this.firstFrame = arr[1];
    this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
  } else if (arr[1] > arr[0]) {
    if (this.frameModifier < 0) {
      if (this.playSpeed < 0) {
        this.setSpeed(-this.playSpeed);
      } else {
        this.setDirection(1);
      }
    }
    this.totalFrames = arr[1] - arr[0];
    this.timeCompleted = this.totalFrames;
    this.firstFrame = arr[0];
    this.setCurrentRawFrameValue(0.001 + offset);
  }
  this.trigger('segmentStart');
};
AnimationItem.prototype.setSegment = function (init, end) {
  var pendingFrame = -1;
  if (this.isPaused) {
    if (this.currentRawFrame + this.firstFrame < init) {
      pendingFrame = init;
    } else if (this.currentRawFrame + this.firstFrame > end) {
      pendingFrame = end - init;
    }
  }

  this.firstFrame = init;
  this.totalFrames = end - init;
  this.timeCompleted = this.totalFrames;
  if (pendingFrame !== -1) {
    this.goToAndStop(pendingFrame, true);
  }
};

AnimationItem.prototype.playSegments = function (arr, forceFlag) {
  if (forceFlag) {
    this.segments.length = 0;
  }
  if (typeof arr[0] === 'object') {
    var i;
    var len = arr.length;
    for (i = 0; i < len; i += 1) {
      this.segments.push(arr[i]);
    }
  } else {
    this.segments.push(arr);
  }
  if (this.segments.length && forceFlag) {
    this.adjustSegment(this.segments.shift(), 0);
  }
  if (this.isPaused) {
    this.play();
  }
};

AnimationItem.prototype.resetSegments = function (forceFlag) {
  this.segments.length = 0;
  this.segments.push([this.animationData.ip, this.animationData.op]);
  // this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
  if (forceFlag) {
    this.checkSegments(0);
  }
};
AnimationItem.prototype.checkSegments = function (offset) {
  if (this.segments.length) {
    this.adjustSegment(this.segments.shift(), offset);
    return true;
  }
  return false;
};

AnimationItem.prototype.destroy = function (name) {
  if ((name && this.name !== name) || !this.renderer) {
    return;
  }
  this.renderer.destroy();
  this.imagePreloader.destroy();
  this.trigger('destroy');
  this._cbs = null;
  this.onEnterFrame = null;
  this.onLoopComplete = null;
  this.onComplete = null;
  this.onSegmentStart = null;
  this.onDestroy = null;
  this.renderer = null;
  this.renderer = null;
  this.imagePreloader = null;
  this.projectInterface = null;
};

AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
  this.currentRawFrame = value;
  this.gotoFrame();
};

AnimationItem.prototype.setSpeed = function (val) {
  this.playSpeed = val;
  this.updaFrameModifier();
};

AnimationItem.prototype.setDirection = function (val) {
  this.playDirection = val < 0 ? -1 : 1;
  this.updaFrameModifier();
};

AnimationItem.prototype.setVolume = function (val, name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.setVolume(val);
};

AnimationItem.prototype.getVolume = function () {
  return this.audioController.getVolume();
};

AnimationItem.prototype.mute = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.mute();
};

AnimationItem.prototype.unmute = function (name) {
  if (name && this.name !== name) {
    return;
  }
  this.audioController.unmute();
};

AnimationItem.prototype.updaFrameModifier = function () {
  this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
  this.audioController.setRate(this.playSpeed * this.playDirection);
};

AnimationItem.prototype.getPath = function () {
  return this.path;
};

AnimationItem.prototype.getAssetsPath = function (assetData) {
  var path = '';
  if (assetData.e) {
    path = assetData.p;
  } else if (this.assetsPath) {
    var imagePath = assetData.p;
    if (imagePath.indexOf('images/') !== -1) {
      imagePath = imagePath.split('/')[1];
    }
    path = this.assetsPath + imagePath;
  } else {
    path = this.path;
    path += assetData.u ? assetData.u : '';
    path += assetData.p;
  }
  return path;
};

AnimationItem.prototype.getAssetData = function (id) {
  var i = 0;
  var len = this.assets.length;
  while (i < len) {
    if (id === this.assets[i].id) {
      return this.assets[i];
    }
    i += 1;
  }
  return null;
};

AnimationItem.prototype.hide = function () {
  this.renderer.hide();
};

AnimationItem.prototype.show = function () {
  this.renderer.show();
};

AnimationItem.prototype.getDuration = function (isFrame) {
  return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
};

AnimationItem.prototype.trigger = function (name) {
  if (this._cbs && this._cbs[name]) {
    switch (name) {
      case 'enterFrame':
        this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
        break;
      case 'loopComplete':
        this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        break;
      case 'complete':
        this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
        break;
      case 'segmentStart':
        this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        break;
      case 'destroy':
        this.triggerEvent(name, new BMDestroyEvent(name, this));
        break;
      default:
        this.triggerEvent(name);
    }
  }
  if (name === 'enterFrame' && this.onEnterFrame) {
    this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
  }
  if (name === 'loopComplete' && this.onLoopComplete) {
    this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
  }
  if (name === 'complete' && this.onComplete) {
    this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
  }
  if (name === 'segmentStart' && this.onSegmentStart) {
    this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
  }
  if (name === 'destroy' && this.onDestroy) {
    this.onDestroy.call(this, new BMDestroyEvent(name, this));
  }
};

AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
  var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
  this.triggerEvent('error', error);

  if (this.onError) {
    this.onError.call(this, error);
  }
};

AnimationItem.prototype.triggerConfigError = function (nativeError) {
  var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
  this.triggerEvent('error', error);

  if (this.onError) {
    this.onError.call(this, error);
  }
};

/* global CompExpressionInterface, expressionsPlugin: writable */
/* exported expressionsPlugin */

var Expressions = (function () {
  var ob = {};
  ob.initExpressions = initExpressions;

  function initExpressions(animation) {
    var stackCount = 0;
    var registers = [];

    function pushExpression() {
      stackCount += 1;
    }

    function popExpression() {
      stackCount -= 1;
      if (stackCount === 0) {
        releaseInstances();
      }
    }

    function registerExpressionProperty(expression) {
      if (registers.indexOf(expression) === -1) {
        registers.push(expression);
      }
    }

    function releaseInstances() {
      var i;
      var len = registers.length;
      for (i = 0; i < len; i += 1) {
        registers[i].release();
      }
      registers.length = 0;
    }

    animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
    animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
    animation.renderer.globalData.pushExpression = pushExpression;
    animation.renderer.globalData.popExpression = popExpression;
    animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
  }
  return ob;
}());

expressionsPlugin = Expressions;

/* eslint-disable camelcase, no-unused-vars */
/* global BMMath, BezierFactory, createTypedArray, degToRads, shapePool */

var ExpressionManager = (function () {
  'use strict';

  var ob = {};
  var Math = BMMath;
  var window = null;
  var document = null;

  function $bm_isInstanceOfArray(arr) {
    return arr.constructor === Array || arr.constructor === Float32Array;
  }

  function isNumerable(tOfV, v) {
    return tOfV === 'number' || tOfV === 'boolean' || tOfV === 'string' || v instanceof Number;
  }

  function $bm_neg(a) {
    var tOfA = typeof a;
    if (tOfA === 'number' || tOfA === 'boolean' || a instanceof Number) {
      return -a;
    }
    if ($bm_isInstanceOfArray(a)) {
      var i;
      var lenA = a.length;
      var retArr = [];
      for (i = 0; i < lenA; i += 1) {
        retArr[i] = -a[i];
      }
      return retArr;
    }
    if (a.propType) {
      return a.v;
    }
    return -a;
  }

  var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
  var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
  var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;

  function sum(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    if (tOfA === 'string' || tOfB === 'string') {
      return a + b;
    }
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a + b;
    }
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      a = a.slice(0);
      a[0] += b;
      return a;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      b = b.slice(0);
      b[0] = a + b[0];
      return b;
    }
    if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
      var i = 0;
      var lenA = a.length;
      var lenB = b.length;
      var retArr = [];
      while (i < lenA || i < lenB) {
        if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
          retArr[i] = a[i] + b[i];
        } else {
          retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
        }
        i += 1;
      }
      return retArr;
    }
    return 0;
  }
  var add = sum;

  function sub(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      if (tOfA === 'string') {
        a = parseInt(a, 10);
      }
      if (tOfB === 'string') {
        b = parseInt(b, 10);
      }
      return a - b;
    }
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      a = a.slice(0);
      a[0] -= b;
      return a;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      b = b.slice(0);
      b[0] = a - b[0];
      return b;
    }
    if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
      var i = 0;
      var lenA = a.length;
      var lenB = b.length;
      var retArr = [];
      while (i < lenA || i < lenB) {
        if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
          retArr[i] = a[i] - b[i];
        } else {
          retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
        }
        i += 1;
      }
      return retArr;
    }
    return 0;
  }

  function mul(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    var arr;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a * b;
    }

    var i;
    var len;
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      len = a.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a[i] * b;
      }
      return arr;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      len = b.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a * b[i];
      }
      return arr;
    }
    return 0;
  }

  function div(a, b) {
    var tOfA = typeof a;
    var tOfB = typeof b;
    var arr;
    if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
      return a / b;
    }
    var i;
    var len;
    if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
      len = a.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a[i] / b;
      }
      return arr;
    }
    if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
      len = b.length;
      arr = createTypedArray('float32', len);
      for (i = 0; i < len; i += 1) {
        arr[i] = a / b[i];
      }
      return arr;
    }
    return 0;
  }
  function mod(a, b) {
    if (typeof a === 'string') {
      a = parseInt(a, 10);
    }
    if (typeof b === 'string') {
      b = parseInt(b, 10);
    }
    return a % b;
  }
  var $bm_sum = sum;
  var $bm_sub = sub;
  var $bm_mul = mul;
  var $bm_div = div;
  var $bm_mod = mod;

  function clamp(num, min, max) {
    if (min > max) {
      var mm = max;
      max = min;
      min = mm;
    }
    return Math.min(Math.max(num, min), max);
  }

  function radiansToDegrees(val) {
    return val / degToRads;
  }
  var radians_to_degrees = radiansToDegrees;

  function degreesToRadians(val) {
    return val * degToRads;
  }
  var degrees_to_radians = radiansToDegrees;

  var helperLengthArray = [0, 0, 0, 0, 0, 0];

  function length(arr1, arr2) {
    if (typeof arr1 === 'number' || arr1 instanceof Number) {
      arr2 = arr2 || 0;
      return Math.abs(arr1 - arr2);
    }
    if (!arr2) {
      arr2 = helperLengthArray;
    }
    var i;
    var len = Math.min(arr1.length, arr2.length);
    var addedLength = 0;
    for (i = 0; i < len; i += 1) {
      addedLength += Math.pow(arr2[i] - arr1[i], 2);
    }
    return Math.sqrt(addedLength);
  }

  function normalize(vec) {
    return div(vec, length(vec));
  }

  function rgbToHsl(val) {
    var r = val[0]; var g = val[1]; var b = val[2];
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h;
    var s;
    var l = (max + min) / 2;

    if (max === min) {
      h = 0; // achromatic
      s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        default: break;
      }
      h /= 6;
    }

    return [h, s, l, val[3]];
  }

  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }

  function hslToRgb(val) {
    var h = val[0];
    var s = val[1];
    var l = val[2];

    var r;
    var g;
    var b;

    if (s === 0) {
      r = l; // achromatic
      b = l; // achromatic
      g = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [r, g, b, val[3]];
  }

  function linear(t, tMin, tMax, value1, value2) {
    if (value1 === undefined || value2 === undefined) {
      value1 = tMin;
      value2 = tMax;
      tMin = 0;
      tMax = 1;
    }
    if (tMax < tMin) {
      var _tMin = tMax;
      tMax = tMin;
      tMin = _tMin;
    }
    if (t <= tMin) {
      return value1;
    } if (t >= tMax) {
      return value2;
    }
    var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
    if (!value1.length) {
      return value1 + (value2 - value1) * perc;
    }
    var i;
    var len = value1.length;
    var arr = createTypedArray('float32', len);
    for (i = 0; i < len; i += 1) {
      arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
    }
    return arr;
  }
  function random(min, max) {
    if (max === undefined) {
      if (min === undefined) {
        min = 0;
        max = 1;
      } else {
        max = min;
        min = undefined;
      }
    }
    if (max.length) {
      var i;
      var len = max.length;
      if (!min) {
        min = createTypedArray('float32', len);
      }
      var arr = createTypedArray('float32', len);
      var rnd = BMMath.random();
      for (i = 0; i < len; i += 1) {
        arr[i] = min[i] + rnd * (max[i] - min[i]);
      }
      return arr;
    }
    if (min === undefined) {
      min = 0;
    }
    var rndm = BMMath.random();
    return min + rndm * (max - min);
  }

  function createPath(points, inTangents, outTangents, closed) {
    var i;
    var len = points.length;
    var path = shapePool.newElement();
    path.setPathData(!!closed, len);
    var arrPlaceholder = [0, 0];
    var inVertexPoint;
    var outVertexPoint;
    for (i = 0; i < len; i += 1) {
      inVertexPoint = (inTangents && inTangents[i]) ? inTangents[i] : arrPlaceholder;
      outVertexPoint = (outTangents && outTangents[i]) ? outTangents[i] : arrPlaceholder;
      path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
    }
    return path;
  }

  function initiateExpression(elem, data, property) {
    var val = data.x;
    var needsVelocity = /velocity(?![\w\d])/.test(val);
    var _needsRandom = val.indexOf('random') !== -1;
    var elemType = elem.data.ty;
    var transform;
    var $bm_transform;
    var content;
    var effect;
    var thisProperty = property;
    thisProperty.valueAtTime = thisProperty.getValueAtTime;
    Object.defineProperty(thisProperty, 'value', {
      get: function () {
        return thisProperty.v;
      },
    });
    elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
    elem.comp.displayStartTime = 0;
    var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
    var outPoint = elem.data.op / elem.comp.globalData.frameRate;
    var width = elem.data.sw ? elem.data.sw : 0;
    var height = elem.data.sh ? elem.data.sh : 0;
    var name = elem.data.nm;
    var loopIn;
    var loop_in;
    var loopOut;
    var loop_out;
    var smooth;
    var toWorld;
    var fromWorld;
    var fromComp;
    var toComp;
    var fromCompToSurface;
    var position;
    var rotation;
    var anchorPoint;
    var scale;
    var thisLayer;
    var thisComp;
    var mask;
    var valueAtTime;
    var velocityAtTime;

    var scoped_bm_rt;
    var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
    var numKeys = property.kf ? data.k.length : 0;

    var active = !this.data || this.data.hd !== true;

    var wiggle = function wiggle(freq, amp) {
      var iWiggle;
      var j;
      var lenWiggle = this.pv.length ? this.pv.length : 1;
      var addedAmps = createTypedArray('float32', lenWiggle);
      freq = 5;
      var iterations = Math.floor(time * freq);
      iWiggle = 0;
      j = 0;
      while (iWiggle < iterations) {
        // var rnd = BMMath.random();
        for (j = 0; j < lenWiggle; j += 1) {
          addedAmps[j] += -amp + amp * 2 * BMMath.random();
          // addedAmps[j] += -amp + amp*2*rnd;
        }
        iWiggle += 1;
      }
      // var rnd2 = BMMath.random();
      var periods = time * freq;
      var perc = periods - Math.floor(periods);
      var arr = createTypedArray('float32', lenWiggle);
      if (lenWiggle > 1) {
        for (j = 0; j < lenWiggle; j += 1) {
          arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc;
          // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
          // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
        }
        return arr;
      }
      return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
    }.bind(this);

    if (thisProperty.loopIn) {
      loopIn = thisProperty.loopIn.bind(thisProperty);
      loop_in = loopIn;
    }

    if (thisProperty.loopOut) {
      loopOut = thisProperty.loopOut.bind(thisProperty);
      loop_out = loopOut;
    }

    if (thisProperty.smooth) {
      smooth = thisProperty.smooth.bind(thisProperty);
    }

    function loopInDuration(type, duration) {
      return loopIn(type, duration, true);
    }

    function loopOutDuration(type, duration) {
      return loopOut(type, duration, true);
    }

    if (this.getValueAtTime) {
      valueAtTime = this.getValueAtTime.bind(this);
    }

    if (this.getVelocityAtTime) {
      velocityAtTime = this.getVelocityAtTime.bind(this);
    }

    var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

    function lookAt(elem1, elem2) {
      var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
      var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
      var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
      return [yaw, pitch, 0];
    }

    function easeOut(t, tMin, tMax, val1, val2) {
      return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
    }

    function easeIn(t, tMin, tMax, val1, val2) {
      return applyEase(easeInBez, t, tMin, tMax, val1, val2);
    }

    function ease(t, tMin, tMax, val1, val2) {
      return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
    }

    function applyEase(fn, t, tMin, tMax, val1, val2) {
      if (val1 === undefined) {
        val1 = tMin;
        val2 = tMax;
      } else {
        t = (t - tMin) / (tMax - tMin);
      }
      if (t > 1) {
        t = 1;
      } else if (t < 0) {
        t = 0;
      }
      var mult = fn(t);
      if ($bm_isInstanceOfArray(val1)) {
        var iKey;
        var lenKey = val1.length;
        var arr = createTypedArray('float32', lenKey);
        for (iKey = 0; iKey < lenKey; iKey += 1) {
          arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
        }
        return arr;
      }
      return (val2 - val1) * mult + val1;
    }

    function nearestKey(time) {
      var iKey;
      var lenKey = data.k.length;
      var index;
      var keyTime;
      if (!data.k.length || typeof (data.k[0]) === 'number') {
        index = 0;
        keyTime = 0;
      } else {
        index = -1;
        time *= elem.comp.globalData.frameRate;
        if (time < data.k[0].t) {
          index = 1;
          keyTime = data.k[0].t;
        } else {
          for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
            if (time === data.k[iKey].t) {
              index = iKey + 1;
              keyTime = data.k[iKey].t;
              break;
            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
              if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                index = iKey + 2;
                keyTime = data.k[iKey + 1].t;
              } else {
                index = iKey + 1;
                keyTime = data.k[iKey].t;
              }
              break;
            }
          }
          if (index === -1) {
            index = iKey + 1;
            keyTime = data.k[iKey].t;
          }
        }
      }
      var obKey = {};
      obKey.index = index;
      obKey.time = keyTime / elem.comp.globalData.frameRate;
      return obKey;
    }

    function key(ind) {
      var obKey;
      var iKey;
      var lenKey;
      if (!data.k.length || typeof (data.k[0]) === 'number') {
        throw new Error('The property has no keyframe at index ' + ind);
      }
      ind -= 1;
      obKey = {
        time: data.k[ind].t / elem.comp.globalData.frameRate,
        value: [],
      };
      var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;

      lenKey = arr.length;
      for (iKey = 0; iKey < lenKey; iKey += 1) {
        obKey[iKey] = arr[iKey];
        obKey.value[iKey] = arr[iKey];
      }
      return obKey;
    }

    function framesToTime(frames, fps) {
      if (!fps) {
        fps = elem.comp.globalData.frameRate;
      }
      return frames / fps;
    }

    function timeToFrames(t, fps) {
      if (!t && t !== 0) {
        t = time;
      }
      if (!fps) {
        fps = elem.comp.globalData.frameRate;
      }
      return t * fps;
    }

    function seedRandom(seed) {
      BMMath.seedrandom(randSeed + seed);
    }

    function sourceRectAtTime() {
      return elem.sourceRectAtTime();
    }

    function substring(init, end) {
      if (typeof value === 'string') {
        if (end === undefined) {
          return value.substring(init);
        }
        return value.substring(init, end);
      }
      return '';
    }

    function substr(init, end) {
      if (typeof value === 'string') {
        if (end === undefined) {
          return value.substr(init);
        }
        return value.substr(init, end);
      }
      return '';
    }

    function posterizeTime(framesPerSecond) {
      time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
      value = valueAtTime(time);
    }

    var time;
    var velocity;
    var value;
    var text;
    var textIndex;
    var textTotal;
    var selectorValue;
    var index = elem.data.ind;
    var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
    var parent;
    var randSeed = Math.floor(Math.random() * 1000000);
    var globalData = elem.globalData;
    function executeExpression(_value) {
      // globalData.pushExpression();
      value = _value;
      if (_needsRandom) {
        seedRandom(randSeed);
      }
      if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
        return value;
      }
      if (this.propType === 'textSelector') {
        textIndex = this.textIndex;
        textTotal = this.textTotal;
        selectorValue = this.selectorValue;
      }
      if (!thisLayer) {
        text = elem.layerInterface.text;
        thisLayer = elem.layerInterface;
        thisComp = elem.comp.compInterface;
        toWorld = thisLayer.toWorld.bind(thisLayer);
        fromWorld = thisLayer.fromWorld.bind(thisLayer);
        fromComp = thisLayer.fromComp.bind(thisLayer);
        toComp = thisLayer.toComp.bind(thisLayer);
        mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
        fromCompToSurface = fromComp;
      }
      if (!transform) {
        transform = elem.layerInterface('ADBE Transform Group');
        $bm_transform = transform;
        if (transform) {
          anchorPoint = transform.anchorPoint;
          /* position = transform.position;
                    rotation = transform.rotation;
                    scale = transform.scale; */
        }
      }

      if (elemType === 4 && !content) {
        content = thisLayer('ADBE Root Vectors Group');
      }
      if (!effect) {
        effect = thisLayer(4);
      }
      hasParent = !!(elem.hierarchy && elem.hierarchy.length);
      if (hasParent && !parent) {
        parent = elem.hierarchy[0].layerInterface;
      }
      time = this.comp.renderedFrame / this.comp.globalData.frameRate;
      if (needsVelocity) {
        velocity = velocityAtTime(time);
      }
      expression_function();
      this.frameExpressionId = elem.globalData.frameId;

      // TODO: Check if it's possible to return on ShapeInterface the .v value
      if (scoped_bm_rt.propType === 'shape') {
        scoped_bm_rt = scoped_bm_rt.v;
      }
      // globalData.popExpression();
      return scoped_bm_rt;
    }
    return executeExpression;
  }

  ob.initiateExpression = initiateExpression;
  return ob;
}());

/* global ExpressionManager, createTypedArray */
/* exported expressionHelpers */

var expressionHelpers = (function () {
  function searchExpressions(elem, data, prop) {
    if (data.x) {
      prop.k = true;
      prop.x = true;
      prop.initiateExpression = ExpressionManager.initiateExpression;
      prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
    }
  }

  function getValueAtTime(frameNum) {
    frameNum *= this.elem.globalData.frameRate;
    frameNum -= this.offsetTime;
    if (frameNum !== this._cachingAtTime.lastFrame) {
      this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
      this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
      this._cachingAtTime.lastFrame = frameNum;
    }
    return this._cachingAtTime.value;
  }

  function getSpeedAtTime(frameNum) {
    var delta = -0.01;
    var v1 = this.getValueAtTime(frameNum);
    var v2 = this.getValueAtTime(frameNum + delta);
    var speed = 0;
    if (v1.length) {
      var i;
      for (i = 0; i < v1.length; i += 1) {
        speed += Math.pow(v2[i] - v1[i], 2);
      }
      speed = Math.sqrt(speed) * 100;
    } else {
      speed = 0;
    }
    return speed;
  }

  function getVelocityAtTime(frameNum) {
    if (this.vel !== undefined) {
      return this.vel;
    }
    var delta = -0.001;
    // frameNum += this.elem.data.st;
    var v1 = this.getValueAtTime(frameNum);
    var v2 = this.getValueAtTime(frameNum + delta);
    var velocity;
    if (v1.length) {
      velocity = createTypedArray('float32', v1.length);
      var i;
      for (i = 0; i < v1.length; i += 1) {
        // removing frameRate
        // if needed, don't add it here
        // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
        velocity[i] = (v2[i] - v1[i]) / delta;
      }
    } else {
      velocity = (v2 - v1) / delta;
    }
    return velocity;
  }

  function getStaticValueAtTime() {
    return this.pv;
  }

  function setGroupProperty(propertyGroup) {
    this.propertyGroup = propertyGroup;
  }

  return {
    searchExpressions: searchExpressions,
    getSpeedAtTime: getSpeedAtTime,
    getVelocityAtTime: getVelocityAtTime,
    getValueAtTime: getValueAtTime,
    getStaticValueAtTime: getStaticValueAtTime,
    setGroupProperty: setGroupProperty,
  };
}());

/* global createTypedArray, Matrix, TransformPropertyFactory, expressionHelpers, PropertyFactory, expressionHelpers,
initialDefaultFrame, shapePool, ShapePropertyFactory, bez, extendPrototype, ExpressionManager, createSizedArray */

(function addPropertyDecorator() {
  function loopOut(type, duration, durationFlag) {
    if (!this.k || !this.keyframes) {
      return this.pv;
    }
    type = type ? type.toLowerCase() : '';
    var currentFrame = this.comp.renderedFrame;
    var keyframes = this.keyframes;
    var lastKeyFrame = keyframes[keyframes.length - 1].t;
    if (currentFrame <= lastKeyFrame) {
      return this.pv;
    }
    var cycleDuration;
    var firstKeyFrame;
    if (!durationFlag) {
      if (!duration || duration > keyframes.length - 1) {
        duration = keyframes.length - 1;
      }
      firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
      cycleDuration = lastKeyFrame - firstKeyFrame;
    } else {
      if (!duration) {
        cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
      } else {
        cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
      }
      firstKeyFrame = lastKeyFrame - cycleDuration;
    }
    var i;
    var len;
    var ret;
    if (type === 'pingpong') {
      var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
      if (iterations % 2 !== 0) {
          return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      }
    } else if (type === 'offset') {
      var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
      if (this.pv.length) {
        ret = new Array(initV.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = (endV[i] - initV[i]) * repeats + current[i];
        }
        return ret;
      }
      return (endV - initV) * repeats + current;
    } else if (type === 'continue') {
      var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
      var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        ret = new Array(lastValue.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
        }
        return ret;
      }
      return lastValue + (lastValue - nextLastValue) * (((currentFrame - lastKeyFrame)) / 0.001);
    }
      return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line

  }

  function loopIn(type, duration, durationFlag) {
    if (!this.k) {
      return this.pv;
    }
    type = type ? type.toLowerCase() : '';
    var currentFrame = this.comp.renderedFrame;
    var keyframes = this.keyframes;
    var firstKeyFrame = keyframes[0].t;
    if (currentFrame >= firstKeyFrame) {
      return this.pv;
    }
    var cycleDuration;
    var lastKeyFrame;
    if (!durationFlag) {
      if (!duration || duration > keyframes.length - 1) {
        duration = keyframes.length - 1;
      }
      lastKeyFrame = keyframes[duration].t;
      cycleDuration = lastKeyFrame - firstKeyFrame;
    } else {
      if (!duration) {
        cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
      } else {
        cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
      }
      lastKeyFrame = firstKeyFrame + cycleDuration;
    }
    var i;
    var len;
    var ret;
    if (type === 'pingpong') {
      var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
      if (iterations % 2 === 0) {
          return this.getValueAtTime((((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
      }
    } else if (type === 'offset') {
      var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
      var current = this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration) + firstKeyFrame) / this.comp.globalData.frameRate, 0);
      var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
      if (this.pv.length) {
        ret = new Array(initV.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
        }
        return ret;
      }
      return current - (endV - initV) * repeats;
    } else if (type === 'continue') {
      var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
      var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
      if (this.pv.length) {
        ret = new Array(firstValue.length);
        len = ret.length;
        for (i = 0; i < len; i += 1) {
          ret[i] = firstValue[i] + ((firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame)) / 0.001;
        }
        return ret;
      }
      return firstValue + ((firstValue - nextFirstValue) * (firstKeyFrame - currentFrame)) / 0.001;
    }
      return this.getValueAtTime(((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame))) / this.comp.globalData.frameRate, 0); // eslint-disable-line

  }

  function smooth(width, samples) {
    if (!this.k) {
      return this.pv;
    }
    width = (width || 0.4) * 0.5;
    samples = Math.floor(samples || 5);
    if (samples <= 1) {
      return this.pv;
    }
    var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
    var initFrame = currentTime - width;
    var endFrame = currentTime + width;
    var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
    var i = 0;
    var j = 0;
    var value;
    if (this.pv.length) {
      value = createTypedArray('float32', this.pv.length);
    } else {
      value = 0;
    }
    var sampleValue;
    while (i < samples) {
      sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
      if (this.pv.length) {
        for (j = 0; j < this.pv.length; j += 1) {
          value[j] += sampleValue[j];
        }
      } else {
        value += sampleValue;
      }
      i += 1;
    }
    if (this.pv.length) {
      for (j = 0; j < this.pv.length; j += 1) {
        value[j] /= samples;
      }
    } else {
      value /= samples;
    }
    return value;
  }

  function getTransformValueAtTime(time) {
    if (!this._transformCachingAtTime) {
      this._transformCachingAtTime = {
        v: new Matrix(),
      };
    }
    /// /
    var matrix = this._transformCachingAtTime.v;
    matrix.cloneFromProps(this.pre.props);
    if (this.appliedTransformations < 1) {
      var anchor = this.a.getValueAtTime(time);
      matrix.translate(
        -anchor[0] * this.a.mult,
        -anchor[1] * this.a.mult,
        anchor[2] * this.a.mult
      );
    }
    if (this.appliedTransformations < 2) {
      var scale = this.s.getValueAtTime(time);
      matrix.scale(
        scale[0] * this.s.mult,
        scale[1] * this.s.mult,
        scale[2] * this.s.mult
      );
    }
    if (this.sk && this.appliedTransformations < 3) {
      var skew = this.sk.getValueAtTime(time);
      var skewAxis = this.sa.getValueAtTime(time);
      matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
    }
    if (this.r && this.appliedTransformations < 4) {
      var rotation = this.r.getValueAtTime(time);
      matrix.rotate(-rotation * this.r.mult);
    } else if (!this.r && this.appliedTransformations < 4) {
      var rotationZ = this.rz.getValueAtTime(time);
      var rotationY = this.ry.getValueAtTime(time);
      var rotationX = this.rx.getValueAtTime(time);
      var orientation = this.or.getValueAtTime(time);
      matrix.rotateZ(-rotationZ * this.rz.mult)
        .rotateY(rotationY * this.ry.mult)
        .rotateX(rotationX * this.rx.mult)
        .rotateZ(-orientation[2] * this.or.mult)
        .rotateY(orientation[1] * this.or.mult)
        .rotateX(orientation[0] * this.or.mult);
    }
    if (this.data.p && this.data.p.s) {
      var positionX = this.px.getValueAtTime(time);
      var positionY = this.py.getValueAtTime(time);
      if (this.data.p.z) {
        var positionZ = this.pz.getValueAtTime(time);
        matrix.translate(
          positionX * this.px.mult,
          positionY * this.py.mult,
          -positionZ * this.pz.mult
        );
      } else {
        matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
      }
    } else {
      var position = this.p.getValueAtTime(time);
      matrix.translate(
        position[0] * this.p.mult,
        position[1] * this.p.mult,
        -position[2] * this.p.mult
      );
    }
    return matrix;
    /// /
  }

  function getTransformStaticValueAtTime() {
    return this.v.clone(new Matrix());
  }

  var getTransformProperty = TransformPropertyFactory.getTransformProperty;
  TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
    var prop = getTransformProperty(elem, data, container);
    if (prop.dynamicProperties.length) {
      prop.getValueAtTime = getTransformValueAtTime.bind(prop);
    } else {
      prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
    }
    prop.setGroupProperty = expressionHelpers.setGroupProperty;
    return prop;
  };

  var propertyGetProp = PropertyFactory.getProp;
  PropertyFactory.getProp = function (elem, data, type, mult, container) {
    var prop = propertyGetProp(elem, data, type, mult, container);
    // prop.getVelocityAtTime = getVelocityAtTime;
    // prop.loopOut = loopOut;
    // prop.loopIn = loopIn;
    if (prop.kf) {
      prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
    } else {
      prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
    }
    prop.setGroupProperty = expressionHelpers.setGroupProperty;
    prop.loopOut = loopOut;
    prop.loopIn = loopIn;
    prop.smooth = smooth;
    prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
    prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
    prop.numKeys = data.a === 1 ? data.k.length : 0;
    prop.propertyIndex = data.ix;
    var value = 0;
    if (type !== 0) {
      value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
    }
    prop._cachingAtTime = {
      lastFrame: initialDefaultFrame,
      lastIndex: 0,
      value: value,
    };
    expressionHelpers.searchExpressions(elem, data, prop);
    if (prop.k) {
      container.addDynamicProperty(prop);
    }

    return prop;
  };

  function getShapeValueAtTime(frameNum) {
    // For now this caching object is created only when needed instead of creating it when the shape is initialized.
    if (!this._cachingAtTime) {
      this._cachingAtTime = {
        shapeValue: shapePool.clone(this.pv),
        lastIndex: 0,
        lastTime: initialDefaultFrame,
      };
    }

    frameNum *= this.elem.globalData.frameRate;
    frameNum -= this.offsetTime;
    if (frameNum !== this._cachingAtTime.lastTime) {
      this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
      this._cachingAtTime.lastTime = frameNum;
      this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
    }
    return this._cachingAtTime.shapeValue;
  }

  var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
  var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

  function ShapeExpressions() {}
  ShapeExpressions.prototype = {
    vertices: function (prop, time) {
      if (this.k) {
        this.getValue();
      }
      var shapePath = this.v;
      if (time !== undefined) {
        shapePath = this.getValueAtTime(time, 0);
      }
      var i;
      var len = shapePath._length;
      var vertices = shapePath[prop];
      var points = shapePath.v;
      var arr = createSizedArray(len);
      for (i = 0; i < len; i += 1) {
        if (prop === 'i' || prop === 'o') {
          arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
        } else {
          arr[i] = [vertices[i][0], vertices[i][1]];
        }
      }
      return arr;
    },
    points: function (time) {
      return this.vertices('v', time);
    },
    inTangents: function (time) {
      return this.vertices('i', time);
    },
    outTangents: function (time) {
      return this.vertices('o', time);
    },
    isClosed: function () {
      return this.v.c;
    },
    pointOnPath: function (perc, time) {
      var shapePath = this.v;
      if (time !== undefined) {
        shapePath = this.getValueAtTime(time, 0);
      }
      if (!this._segmentsLength) {
        this._segmentsLength = bez.getSegmentsLength(shapePath);
      }

      var segmentsLength = this._segmentsLength;
      var lengths = segmentsLength.lengths;
      var lengthPos = segmentsLength.totalLength * perc;
      var i = 0;
      var len = lengths.length;
      var accumulatedLength = 0;
      var pt;
      while (i < len) {
        if (accumulatedLength + lengths[i].addedLength > lengthPos) {
          var initIndex = i;
          var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
          var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
          pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
          break;
        } else {
          accumulatedLength += lengths[i].addedLength;
        }
        i += 1;
      }
      if (!pt) {
        pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
      }
      return pt;
    },
    vectorOnPath: function (perc, time, vectorType) {
      // perc doesn't use triple equality because it can be a Number object as well as a primitive.
      if (perc == 1) { // eslint-disable-line eqeqeq
        perc = this.v.c;
      } else if (perc == 0) { // eslint-disable-line eqeqeq
        perc = 0.999;
      }
      var pt1 = this.pointOnPath(perc, time);
      var pt2 = this.pointOnPath(perc + 0.001, time);
      var xLength = pt2[0] - pt1[0];
      var yLength = pt2[1] - pt1[1];
      var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
      if (magnitude === 0) {
        return [0, 0];
      }
      var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
      return unitVector;
    },
    tangentOnPath: function (perc, time) {
      return this.vectorOnPath(perc, time, 'tangent');
    },
    normalOnPath: function (perc, time) {
      return this.vectorOnPath(perc, time, 'normal');
    },
    setGroupProperty: expressionHelpers.setGroupProperty,
    getValueAtTime: expressionHelpers.getStaticValueAtTime,
  };
  extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
  extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
  KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
  KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;

  var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
  ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
    var prop = propertyGetShapeProp(elem, data, type, arr, trims);
    prop.propertyIndex = data.ix;
    prop.lock = false;
    if (type === 3) {
      expressionHelpers.searchExpressions(elem, data.pt, prop);
    } else if (type === 4) {
      expressionHelpers.searchExpressions(elem, data.ks, prop);
    }
    if (prop.k) {
      elem.addDynamicProperty(prop);
    }
    return prop;
  };
}());

/* global ExpressionManager, TextProperty */

(function addDecorator() {
  function searchExpressions() {
    if (this.data.d.x) {
      this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
      this.addEffect(this.getExpressionValue.bind(this));
      return true;
    }
    return null;
  }

  TextProperty.prototype.getExpressionValue = function (currentValue, text) {
    var newValue = this.calculateExpression(text);
    if (currentValue.t !== newValue) {
      var newData = {};
      this.copyData(newData, currentValue);
      newData.t = newValue.toString();
      newData.__complete = false;
      return newData;
    }
    return currentValue;
  };

  TextProperty.prototype.searchProperty = function () {
    var isKeyframed = this.searchKeyframes();
    var hasExpressions = this.searchExpressions();
    this.kf = isKeyframed || hasExpressions;
    return this.kf;
  };

  TextProperty.prototype.searchExpressions = searchExpressions;
}());

/* global propertyGroupFactory, PropertyInterface */
/* exported ShapePathInterface */

var ShapePathInterface = (

  function () {
    return function pathInterfaceFactory(shape, view, propertyGroup) {
      var prop = view.sh;

      function interfaceFunction(val) {
        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
          return interfaceFunction.path;
        }
        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        path: {
          get: function () {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          },
        },
        shape: {
          get: function () {
            if (prop.k) {
              prop.getValue();
            }
            return prop;
          },
        },
        _name: { value: shape.nm },
        ix: { value: shape.ix },
        propertyIndex: { value: shape.ix },
        mn: { value: shape.mn },
        propertyGroup: { value: propertyGroup },
      });
      return interfaceFunction;
    };
  }()
);

/* exported propertyGroupFactory */

var propertyGroupFactory = (function () {
  return function (interfaceFunction, parentPropertyGroup) {
    return function (val) {
      val = val === undefined ? 1 : val;
      if (val <= 0) {
        return interfaceFunction;
      }
      return parentPropertyGroup(val - 1);
    };
  };
}());

/* exported PropertyInterface */

var PropertyInterface = (function () {
  return function (propertyName, propertyGroup) {
    var interfaceFunction = {
      _name: propertyName,
    };

    function _propertyGroup(val) {
      val = val === undefined ? 1 : val;
      if (val <= 0) {
        return interfaceFunction;
      }
      return propertyGroup(val - 1);
    }

    return _propertyGroup;
  };
}());

/* global ExpressionPropertyInterface, PropertyInterface, propertyGroupFactory, ShapePathInterface */
/* exported ShapeExpressionInterface */

var ShapeExpressionInterface = (function () {
  function iterateElements(shapes, view, propertyGroup) {
    var arr = [];
    var i;
    var len = shapes ? shapes.length : 0;
    for (i = 0; i < len; i += 1) {
      if (shapes[i].ty === 'gr') {
        arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'fl') {
        arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'st') {
        arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'tm') {
        arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'tr') {
        // arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
      } else if (shapes[i].ty === 'el') {
        arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'sr') {
        arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'sh') {
        arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rc') {
        arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rd') {
        arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
      } else if (shapes[i].ty === 'rp') {
        arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
      }
    }
    return arr;
  }

  function contentsInterfaceFactory(shape, view, propertyGroup) {
    var interfaces;
    var interfaceFunction = function _interfaceFunction(value) {
      var i = 0;
      var len = interfaces.length;
      while (i < len) {
        if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
          return interfaces[i];
        }
        i += 1;
      }
      if (typeof value === 'number') {
        return interfaces[value - 1];
      }
      return null;
    };

    interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
    interfaceFunction.numProperties = interfaces.length;
    var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
    interfaceFunction.transform = transformInterface;
    interfaceFunction.propertyIndex = shape.cix;
    interfaceFunction._name = shape.nm;

    return interfaceFunction;
  }

  function groupInterfaceFactory(shape, view, propertyGroup) {
    var interfaceFunction = function _interfaceFunction(value) {
      switch (value) {
        case 'ADBE Vectors Group':
        case 'Contents':
        case 2:
          return interfaceFunction.content;
          // Not necessary for now. Keeping them here in case a new case appears
          // case 'ADBE Vector Transform Group':
          // case 3:
        default:
          return interfaceFunction.transform;
      }
    };
    interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
    var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
    interfaceFunction.content = content;
    interfaceFunction.transform = transformInterface;
    Object.defineProperty(interfaceFunction, '_name', {
      get: function () {
        return shape.nm;
      },
    });
    // interfaceFunction.content = interfaceFunction;
    interfaceFunction.numProperties = shape.np;
    interfaceFunction.propertyIndex = shape.ix;
    interfaceFunction.nm = shape.nm;
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function fillInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === 'Color' || val === 'color') {
        return interfaceFunction.color;
      } if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      color: {
        get: ExpressionPropertyInterface(view.c),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
    return interfaceFunction;
  }

  function strokeInterfaceFactory(shape, view, propertyGroup) {
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
    function addPropertyToDashOb(i) {
      Object.defineProperty(dashOb, shape.d[i].nm, {
        get: ExpressionPropertyInterface(view.d.dataProps[i].p),
      });
    }
    var i;
    var len = shape.d ? shape.d.length : 0;
    var dashOb = {};
    for (i = 0; i < len; i += 1) {
      addPropertyToDashOb(i);
      view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
    }

    function interfaceFunction(val) {
      if (val === 'Color' || val === 'color') {
        return interfaceFunction.color;
      } if (val === 'Opacity' || val === 'opacity') {
        return interfaceFunction.opacity;
      } if (val === 'Stroke Width' || val === 'stroke width') {
        return interfaceFunction.strokeWidth;
      }
      return null;
    }
    Object.defineProperties(interfaceFunction, {
      color: {
        get: ExpressionPropertyInterface(view.c),
      },
      opacity: {
        get: ExpressionPropertyInterface(view.o),
      },
      strokeWidth: {
        get: ExpressionPropertyInterface(view.w),
      },
      dash: {
        get: function () {
          return dashOb;
        },
      },
      _name: { value: shape.nm },
      mn: { value: shape.mn },
    });

    view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
    return interfaceFunction;
  }

  function trimInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(val) {
      if (val === shape.e.ix || val === 'End' || val === 'end') {
        return interfaceFunction.end;
      }
      if (val === shape.s.ix) {
        return interfaceFunction.start;
      }
      if (val === shape.o.ix) {
        return interfaceFunction.offset;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaceFunction.propertyIndex = shape.ix;

    view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
    view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
    view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
    interfaceFunction.propertyIndex = shape.ix;
    interfaceFunction.propertyGroup = propertyGroup;

    Object.defineProperties(interfaceFunction, {
      start: {
        get: ExpressionPropertyInterface(view.s),
      },
      end: {
        get: ExpressionPropertyInterface(view.e),
      },
      offset: {
        get: ExpressionPropertyInterface(view.o),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function transformInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.a.ix === value || value === 'Anchor Point') {
        return interfaceFunction.anchorPoint;
      }
      if (shape.o.ix === value || value === 'Opacity') {
        return interfaceFunction.opacity;
      }
      if (shape.p.ix === value || value === 'Position') {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
        return interfaceFunction.rotation;
      }
      if (shape.s.ix === value || value === 'Scale') {
        return interfaceFunction.scale;
      }
      if ((shape.sk && shape.sk.ix === value) || value === 'Skew') {
        return interfaceFunction.skew;
      }
      if ((shape.sa && shape.sa.ix === value) || value === 'Skew Axis') {
        return interfaceFunction.skewAxis;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
    view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
    view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
    if (view.transform.mProps.sk) {
      view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
      view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
    }
    view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
    Object.defineProperties(interfaceFunction, {
      opacity: {
        get: ExpressionPropertyInterface(view.transform.mProps.o),
      },
      position: {
        get: ExpressionPropertyInterface(view.transform.mProps.p),
      },
      anchorPoint: {
        get: ExpressionPropertyInterface(view.transform.mProps.a),
      },
      scale: {
        get: ExpressionPropertyInterface(view.transform.mProps.s),
      },
      rotation: {
        get: ExpressionPropertyInterface(view.transform.mProps.r),
      },
      skew: {
        get: ExpressionPropertyInterface(view.transform.mProps.sk),
      },
      skewAxis: {
        get: ExpressionPropertyInterface(view.transform.mProps.sa),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.ty = 'tr';
    interfaceFunction.mn = shape.mn;
    interfaceFunction.propertyGroup = propertyGroup;
    return interfaceFunction;
  }

  function ellipseInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.s.ix === value) {
        return interfaceFunction.size;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    interfaceFunction.propertyIndex = shape.ix;
    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      size: {
        get: ExpressionPropertyInterface(prop.s),
      },
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function starInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value) {
        return interfaceFunction.rotation;
      }
      if (shape.pt.ix === value) {
        return interfaceFunction.points;
      }
      if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
        return interfaceFunction.outerRadius;
      }
      if (shape.os.ix === value) {
        return interfaceFunction.outerRoundness;
      }
      if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
        return interfaceFunction.innerRadius;
      }
      if (shape.is && shape.is.ix === value) {
        return interfaceFunction.innerRoundness;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    interfaceFunction.propertyIndex = shape.ix;
    prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
    prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
    prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
    if (shape.ir) {
      prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
      prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
    }

    Object.defineProperties(interfaceFunction, {
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      rotation: {
        get: ExpressionPropertyInterface(prop.r),
      },
      points: {
        get: ExpressionPropertyInterface(prop.pt),
      },
      outerRadius: {
        get: ExpressionPropertyInterface(prop.or),
      },
      outerRoundness: {
        get: ExpressionPropertyInterface(prop.os),
      },
      innerRadius: {
        get: ExpressionPropertyInterface(prop.ir),
      },
      innerRoundness: {
        get: ExpressionPropertyInterface(prop.is),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function rectInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.p.ix === value) {
        return interfaceFunction.position;
      }
      if (shape.r.ix === value) {
        return interfaceFunction.roundness;
      }
      if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
        return interfaceFunction.size;
      }
      return null;
    }
    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

    var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
    interfaceFunction.propertyIndex = shape.ix;
    prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
    prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
    prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      position: {
        get: ExpressionPropertyInterface(prop.p),
      },
      roundness: {
        get: ExpressionPropertyInterface(prop.r),
      },
      size: {
        get: ExpressionPropertyInterface(prop.s),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function roundedInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.r.ix === value || value === 'Round Corners 1') {
        return interfaceFunction.radius;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view;
    interfaceFunction.propertyIndex = shape.ix;
    prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));

    Object.defineProperties(interfaceFunction, {
      radius: {
        get: ExpressionPropertyInterface(prop.rd),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  function repeaterInterfaceFactory(shape, view, propertyGroup) {
    function interfaceFunction(value) {
      if (shape.c.ix === value || value === 'Copies') {
        return interfaceFunction.copies;
      } if (shape.o.ix === value || value === 'Offset') {
        return interfaceFunction.offset;
      }
      return null;
    }

    var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
    var prop = view;
    interfaceFunction.propertyIndex = shape.ix;
    prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
    prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
    Object.defineProperties(interfaceFunction, {
      copies: {
        get: ExpressionPropertyInterface(prop.c),
      },
      offset: {
        get: ExpressionPropertyInterface(prop.o),
      },
      _name: { value: shape.nm },
    });
    interfaceFunction.mn = shape.mn;
    return interfaceFunction;
  }

  return function (shapes, view, propertyGroup) {
    var interfaces;
    function _interfaceFunction(value) {
      if (typeof value === 'number') {
        value = value === undefined ? 1 : value;
        if (value === 0) {
          return propertyGroup;
        }
        return interfaces[value - 1];
      }
      var i = 0;
      var len = interfaces.length;
      while (i < len) {
        if (interfaces[i]._name === value) {
          return interfaces[i];
        }
        i += 1;
      }
      return null;
    }
    function parentGroupWrapper() {
      return propertyGroup;
    }
    _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
    interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
    _interfaceFunction.numProperties = interfaces.length;
    _interfaceFunction._name = 'Contents';
    return _interfaceFunction;
  };
}());

/* exported TextExpressionInterface */

var TextExpressionInterface = (function () {
  return function (elem) {
    var _prevValue;
    var _sourceText;
    function _thisLayerFunction(name) {
      switch (name) {
        case 'ADBE Text Document':
          return _thisLayerFunction.sourceText;
        default:
          return null;
      }
    }
    Object.defineProperty(_thisLayerFunction, 'sourceText', {
      get: function () {
        elem.textProperty.getValue();
        var stringValue = elem.textProperty.currentData.t;
        if (stringValue !== _prevValue) {
          elem.textProperty.currentData.t = _prevValue;
          _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
          // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
          _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
        }
        return _sourceText;
      },
    });
    return _thisLayerFunction;
  };
}());

/* global Matrix, MaskManagerInterface, TransformExpressionInterface, getDescriptor */
/* exported LayerExpressionInterface */

var LayerExpressionInterface = (function () {
  function getMatrix(time) {
    var toWorldMat = new Matrix();
    if (time !== undefined) {
      var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
      propMatrix.clone(toWorldMat);
    } else {
      var transformMat = this._elem.finalTransform.mProp;
      transformMat.applyToMatrix(toWorldMat);
    }
    return toWorldMat;
  }

  function toWorldVec(arr, time) {
    var toWorldMat = this.getMatrix(time);
    toWorldMat.props[12] = 0;
    toWorldMat.props[13] = 0;
    toWorldMat.props[14] = 0;
    return this.applyPoint(toWorldMat, arr);
  }

  function toWorld(arr, time) {
    var toWorldMat = this.getMatrix(time);
    return this.applyPoint(toWorldMat, arr);
  }

  function fromWorldVec(arr, time) {
    var toWorldMat = this.getMatrix(time);
    toWorldMat.props[12] = 0;
    toWorldMat.props[13] = 0;
    toWorldMat.props[14] = 0;
    return this.invertPoint(toWorldMat, arr);
  }

  function fromWorld(arr, time) {
    var toWorldMat = this.getMatrix(time);
    return this.invertPoint(toWorldMat, arr);
  }

  function applyPoint(matrix, arr) {
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
      }
    }
    return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
  }

  function invertPoint(matrix, arr) {
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
      }
    }
    return matrix.inversePoint(arr);
  }

  function fromComp(arr) {
    var toWorldMat = new Matrix();
    toWorldMat.reset();
    this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
    if (this._elem.hierarchy && this._elem.hierarchy.length) {
      var i;
      var len = this._elem.hierarchy.length;
      for (i = 0; i < len; i += 1) {
        this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
      }
      return toWorldMat.inversePoint(arr);
    }
    return toWorldMat.inversePoint(arr);
  }

  function sampleImage() {
    return [1, 1, 1, 1];
  }

  return function (elem) {
    var transformInterface;

    function _registerMaskInterface(maskManager) {
      _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
    }
    function _registerEffectsInterface(effects) {
      _thisLayerFunction.effect = effects;
    }

    function _thisLayerFunction(name) {
      switch (name) {
        case 'ADBE Root Vectors Group':
        case 'Contents':
        case 2:
          return _thisLayerFunction.shapeInterface;
        case 1:
        case 6:
        case 'Transform':
        case 'transform':
        case 'ADBE Transform Group':
          return transformInterface;
        case 4:
        case 'ADBE Effect Parade':
        case 'effects':
        case 'Effects':
          return _thisLayerFunction.effect;
        case 'ADBE Text Properties':
          return _thisLayerFunction.textInterface;
        default:
          return null;
      }
    }
    _thisLayerFunction.getMatrix = getMatrix;
    _thisLayerFunction.invertPoint = invertPoint;
    _thisLayerFunction.applyPoint = applyPoint;
    _thisLayerFunction.toWorld = toWorld;
    _thisLayerFunction.toWorldVec = toWorldVec;
    _thisLayerFunction.fromWorld = fromWorld;
    _thisLayerFunction.fromWorldVec = fromWorldVec;
    _thisLayerFunction.toComp = toWorld;
    _thisLayerFunction.fromComp = fromComp;
    _thisLayerFunction.sampleImage = sampleImage;
    _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
    _thisLayerFunction._elem = elem;
    transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
    var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
    Object.defineProperties(_thisLayerFunction, {
      hasParent: {
        get: function () {
          return elem.hierarchy.length;
        },
      },
      parent: {
        get: function () {
          return elem.hierarchy[0].layerInterface;
        },
      },
      rotation: getDescriptor(transformInterface, 'rotation'),
      scale: getDescriptor(transformInterface, 'scale'),
      position: getDescriptor(transformInterface, 'position'),
      opacity: getDescriptor(transformInterface, 'opacity'),
      anchorPoint: anchorPointDescriptor,
      anchor_point: anchorPointDescriptor,
      transform: {
        get: function () {
          return transformInterface;
        },
      },
      active: {
        get: function () {
          return elem.isInRange;
        },
      },
    });

    _thisLayerFunction.startTime = elem.data.st;
    _thisLayerFunction.index = elem.data.ind;
    _thisLayerFunction.source = elem.data.refId;
    _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
    _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
    _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
    _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
    _thisLayerFunction._name = elem.data.nm;

    _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
    _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
    return _thisLayerFunction;
  };
}());

/* exported CompExpressionInterface */

var CompExpressionInterface = (function () {
  return function (comp) {
    function _thisLayerFunction(name) {
      var i = 0;
      var len = comp.layers.length;
      while (i < len) {
        if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
          return comp.elements[i].layerInterface;
        }
        i += 1;
      }
      return null;
      // return {active:false};
    }
    Object.defineProperty(_thisLayerFunction, '_name', { value: comp.data.nm });
    _thisLayerFunction.layer = _thisLayerFunction;
    _thisLayerFunction.pixelAspect = 1;
    _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
    _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
    _thisLayerFunction.pixelAspect = 1;
    _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
    _thisLayerFunction.displayStartTime = 0;
    _thisLayerFunction.numLayers = comp.layers.length;
    return _thisLayerFunction;
  };
}());

/* global ExpressionPropertyInterface */
/* exported TransformExpressionInterface */

var TransformExpressionInterface = (function () {
  return function (transform) {
    function _thisFunction(name) {
      switch (name) {
        case 'scale':
        case 'Scale':
        case 'ADBE Scale':
        case 6:
          return _thisFunction.scale;
        case 'rotation':
        case 'Rotation':
        case 'ADBE Rotation':
        case 'ADBE Rotate Z':
        case 10:
          return _thisFunction.rotation;
        case 'ADBE Rotate X':
          return _thisFunction.xRotation;
        case 'ADBE Rotate Y':
          return _thisFunction.yRotation;
        case 'position':
        case 'Position':
        case 'ADBE Position':
        case 2:
          return _thisFunction.position;
        case 'ADBE Position_0':
          return _thisFunction.xPosition;
        case 'ADBE Position_1':
          return _thisFunction.yPosition;
        case 'ADBE Position_2':
          return _thisFunction.zPosition;
        case 'anchorPoint':
        case 'AnchorPoint':
        case 'Anchor Point':
        case 'ADBE AnchorPoint':
        case 1:
          return _thisFunction.anchorPoint;
        case 'opacity':
        case 'Opacity':
        case 11:
          return _thisFunction.opacity;
        default:
          return null;
      }
    }
    Object.defineProperty(_thisFunction, 'rotation', {
      get: ExpressionPropertyInterface(transform.r || transform.rz),
    });

    Object.defineProperty(_thisFunction, 'zRotation', {
      get: ExpressionPropertyInterface(transform.rz || transform.r),
    });

    Object.defineProperty(_thisFunction, 'xRotation', {
      get: ExpressionPropertyInterface(transform.rx),
    });

    Object.defineProperty(_thisFunction, 'yRotation', {
      get: ExpressionPropertyInterface(transform.ry),
    });
    Object.defineProperty(_thisFunction, 'scale', {
      get: ExpressionPropertyInterface(transform.s),
    });
    var _px;
    var _py;
    var _pz;
    var _transformFactory;
    if (transform.p) {
      _transformFactory = ExpressionPropertyInterface(transform.p);
    } else {
      _px = ExpressionPropertyInterface(transform.px);
      _py = ExpressionPropertyInterface(transform.py);
      if (transform.pz) {
        _pz = ExpressionPropertyInterface(transform.pz);
      }
    }
    Object.defineProperty(_thisFunction, 'position', {
      get: function () {
        if (transform.p) {
          return _transformFactory();
        }
        return [
          _px(),
          _py(),
          _pz ? _pz() : 0];
      },
    });

    Object.defineProperty(_thisFunction, 'xPosition', {
      get: ExpressionPropertyInterface(transform.px),
    });

    Object.defineProperty(_thisFunction, 'yPosition', {
      get: ExpressionPropertyInterface(transform.py),
    });

    Object.defineProperty(_thisFunction, 'zPosition', {
      get: ExpressionPropertyInterface(transform.pz),
    });

    Object.defineProperty(_thisFunction, 'anchorPoint', {
      get: ExpressionPropertyInterface(transform.a),
    });

    Object.defineProperty(_thisFunction, 'opacity', {
      get: ExpressionPropertyInterface(transform.o),
    });

    Object.defineProperty(_thisFunction, 'skew', {
      get: ExpressionPropertyInterface(transform.sk),
    });

    Object.defineProperty(_thisFunction, 'skewAxis', {
      get: ExpressionPropertyInterface(transform.sa),
    });

    Object.defineProperty(_thisFunction, 'orientation', {
      get: ExpressionPropertyInterface(transform.or),
    });

    return _thisFunction;
  };
}());

/* exported ProjectInterface */

var ProjectInterface = (function () {
  function registerComposition(comp) {
    this.compositions.push(comp);
  }

  return function () {
    function _thisProjectFunction(name) {
      var i = 0;
      var len = this.compositions.length;
      while (i < len) {
        if (this.compositions[i].data && this.compositions[i].data.nm === name) {
          if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
            this.compositions[i].prepareFrame(this.currentFrame);
          }
          return this.compositions[i].compInterface;
        }
        i += 1;
      }
      return null;
    }

    _thisProjectFunction.compositions = [];
    _thisProjectFunction.currentFrame = 0;

    _thisProjectFunction.registerComposition = registerComposition;

    return _thisProjectFunction;
  };
}());

/* global propertyGroupFactory, ExpressionPropertyInterface, PropertyInterface */
/* exported EffectsExpressionInterface */

var EffectsExpressionInterface = (function () {
  var ob = {
    createEffectsInterface: createEffectsInterface,
  };

  function createEffectsInterface(elem, propertyGroup) {
    if (elem.effectsManager) {
      var effectElements = [];
      var effectsData = elem.data.ef;
      var i;
      var len = elem.effectsManager.effectElements.length;
      for (i = 0; i < len; i += 1) {
        effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
      }

      var effects = elem.data.ef || [];
      var groupInterface = function (name) {
        i = 0;
        len = effects.length;
        while (i < len) {
          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
            return effectElements[i];
          }
          i += 1;
        }
        return null;
      };
      Object.defineProperty(groupInterface, 'numProperties', {
        get: function () {
          return effects.length;
        },
      });
      return groupInterface;
    }
    return null;
  }

  function createGroupInterface(data, elements, propertyGroup, elem) {
    function groupInterface(name) {
      var effects = data.ef;
      var i = 0;
      var len = effects.length;
      while (i < len) {
        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
          if (effects[i].ty === 5) {
            return effectElements[i];
          }
          return effectElements[i]();
        }
        i += 1;
      }
      throw new Error();
    }
    var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);

    var effectElements = [];
    var i;
    var len = data.ef.length;
    for (i = 0; i < len; i += 1) {
      if (data.ef[i].ty === 5) {
        effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
      } else {
        effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
      }
    }

    if (data.mn === 'ADBE Color Control') {
      Object.defineProperty(groupInterface, 'color', {
        get: function () {
          return effectElements[0]();
        },
      });
    }
    Object.defineProperties(groupInterface, {
      numProperties: {
        get: function () {
          return data.np;
        },
      },
      _name: { value: data.nm },
      propertyGroup: { value: _propertyGroup },
    });
    groupInterface.enabled = data.en !== 0;
    groupInterface.active = groupInterface.enabled;
    return groupInterface;
  }

  function createValueInterface(element, type, elem, propertyGroup) {
    var expressionProperty = ExpressionPropertyInterface(element.p);
    function interfaceFunction() {
      if (type === 10) {
        return elem.comp.compInterface(element.p.v);
      }
      return expressionProperty();
    }

    if (element.p.setGroupProperty) {
      element.p.setGroupProperty(PropertyInterface('', propertyGroup));
    }

    return interfaceFunction;
  }

  return ob;
}());

/* global createSizedArray */
/* exported MaskManagerInterface */

var MaskManagerInterface = (function () {
  function MaskInterface(mask, data) {
    this._mask = mask;
    this._data = data;
  }
  Object.defineProperty(MaskInterface.prototype, 'maskPath', {
    get: function () {
      if (this._mask.prop.k) {
        this._mask.prop.getValue();
      }
      return this._mask.prop;
    },
  });
  Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
    get: function () {
      if (this._mask.op.k) {
        this._mask.op.getValue();
      }
      return this._mask.op.v * 100;
    },
  });

  var MaskManager = function (maskManager) {
    var _masksInterfaces = createSizedArray(maskManager.viewData.length);
    var i;
    var len = maskManager.viewData.length;
    for (i = 0; i < len; i += 1) {
      _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
    }

    var maskFunction = function (name) {
      i = 0;
      while (i < len) {
        if (maskManager.masksProperties[i].nm === name) {
          return _masksInterfaces[i];
        }
        i += 1;
      }
      return null;
    };
    return maskFunction;
  };
  return MaskManager;
}());

/* global createTypedArray */
/* exported ExpressionPropertyInterface */

var ExpressionPropertyInterface = (function () {
  var defaultUnidimensionalValue = { pv: 0, v: 0, mult: 1 };
  var defaultMultidimensionalValue = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };

  function completeProperty(expressionValue, property, type) {
    Object.defineProperty(expressionValue, 'velocity', {
      get: function () {
        return property.getVelocityAtTime(property.comp.currentFrame);
      },
    });
    expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
    expressionValue.key = function (pos) {
      if (!expressionValue.numKeys) {
        return 0;
      }
      var value = '';
      if ('s' in property.keyframes[pos - 1]) {
        value = property.keyframes[pos - 1].s;
      } else if ('e' in property.keyframes[pos - 2]) {
        value = property.keyframes[pos - 2].e;
      } else {
        value = property.keyframes[pos - 2].s;
      }
      var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
      valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
      valueProp.value = type === 'unidimensional' ? value[0] : value;
      return valueProp;
    };
    expressionValue.valueAtTime = property.getValueAtTime;
    expressionValue.speedAtTime = property.getSpeedAtTime;
    expressionValue.velocityAtTime = property.getVelocityAtTime;
    expressionValue.propertyGroup = property.propertyGroup;
  }

  function UnidimensionalPropertyInterface(property) {
    if (!property || !('pv' in property)) {
      property = defaultUnidimensionalValue;
    }
    var mult = 1 / property.mult;
    var val = property.pv * mult;
    var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
    expressionValue.value = val;
    completeProperty(expressionValue, property, 'unidimensional');

    return function () {
      if (property.k) {
        property.getValue();
      }
      val = property.v * mult;
      if (expressionValue.value !== val) {
        expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
        expressionValue.value = val;
        completeProperty(expressionValue, property, 'unidimensional');
      }
      return expressionValue;
    };
  }

  function MultidimensionalPropertyInterface(property) {
    if (!property || !('pv' in property)) {
      property = defaultMultidimensionalValue;
    }
    var mult = 1 / property.mult;
    var len = (property.data && property.data.l) || property.pv.length;
    var expressionValue = createTypedArray('float32', len);
    var arrValue = createTypedArray('float32', len);
    expressionValue.value = arrValue;
    completeProperty(expressionValue, property, 'multidimensional');

    return function () {
      if (property.k) {
        property.getValue();
      }
      for (var i = 0; i < len; i += 1) {
        arrValue[i] = property.v[i] * mult;
        expressionValue[i] = arrValue[i];
      }
      return expressionValue;
    };
  }

  // TODO: try to avoid using this getter
  function defaultGetter() {
    return defaultUnidimensionalValue;
  }

  return function (property) {
    if (!property) {
      return defaultGetter;
    } if (property.propType === 'unidimensional') {
      return UnidimensionalPropertyInterface(property);
    }
    return MultidimensionalPropertyInterface(property);
  };
}());

/* global expressionHelpers, TextSelectorProp, ExpressionManager */
/* exported TextExpressionSelectorProp */

(function () {
  var TextExpressionSelectorProp = (function () { // eslint-disable-line no-unused-vars
    function getValueProxy(index, total) {
      this.textIndex = index + 1;
      this.textTotal = total;
      this.v = this.getValue() * this.mult;
      return this.v;
    }

    return function TextExpressionSelectorPropFactory(elem, data) {
      this.pv = 1;
      this.comp = elem.comp;
      this.elem = elem;
      this.mult = 0.01;
      this.propType = 'textSelector';
      this.textTotal = data.totalChars;
      this.selectorValue = 100;
      this.lastValue = [1, 1, 1];
      this.k = true;
      this.x = true;
      this.getValue = ExpressionManager.initiateExpression.bind(this)(elem, data, this);
      this.getMult = getValueProxy;
      this.getVelocityAtTime = expressionHelpers.getVelocityAtTime;
      if (this.kf) {
        this.getValueAtTime = expressionHelpers.getValueAtTime.bind(this);
      } else {
        this.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(this);
      }
      this.setGroupProperty = expressionHelpers.setGroupProperty;
    };
  }());

  var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
  TextSelectorProp.getTextSelectorProp = function (elem, data, arr) {
    if (data.t === 1) {
      return new TextExpressionSelectorPropFactory(elem, data, arr); // eslint-disable-line no-undef
    }
    return propertyGetTextProp(elem, data, arr);
  };
}());

/* global PropertyFactory */
/* exported SliderEffect, AngleEffect, ColorEffect, PointEffect, LayerIndexEffect, MaskIndexEffect, CheckboxEffect, NoValueEffect */

function SliderEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function AngleEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function ColorEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function PointEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function LayerIndexEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function MaskIndexEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function CheckboxEffect(data, elem, container) {
  this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function NoValueEffect() {
  this.p = {};
}

/* global extendPrototype, SliderEffect, AngleEffect, ColorEffect, PointEffect, CheckboxEffect, LayerIndexEffect,
MaskIndexEffect, NoValueEffect, DynamicPropertyContainer */

function EffectsManager(data, element) {
  var effects = data.ef || [];
  this.effectElements = [];
  var i;
  var len = effects.length;
  var effectItem;
  for (i = 0; i < len; i += 1) {
    effectItem = new GroupEffect(effects[i], element);
    this.effectElements.push(effectItem);
  }
}

function GroupEffect(data, element) {
  this.init(data, element);
}

extendPrototype([DynamicPropertyContainer], GroupEffect);

GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

GroupEffect.prototype.init = function (data, element) {
  this.data = data;
  this.effectElements = [];
  this.initDynamicPropertyContainer(element);
  var i;
  var len = this.data.ef.length;
  var eff;
  var effects = this.data.ef;
  for (i = 0; i < len; i += 1) {
    eff = null;
    switch (effects[i].ty) {
      case 0:
        eff = new SliderEffect(effects[i], element, this);
        break;
      case 1:
        eff = new AngleEffect(effects[i], element, this);
        break;
      case 2:
        eff = new ColorEffect(effects[i], element, this);
        break;
      case 3:
        eff = new PointEffect(effects[i], element, this);
        break;
      case 4:
      case 7:
        eff = new CheckboxEffect(effects[i], element, this);
        break;
      case 10:
        eff = new LayerIndexEffect(effects[i], element, this);
        break;
      case 11:
        eff = new MaskIndexEffect(effects[i], element, this);
        break;
      case 5:
        eff = new EffectsManager(effects[i], element, this);
        break;
        // case 6:
      default:
        eff = new NoValueEffect(effects[i], element, this);
        break;
    }
    if (eff) {
      this.effectElements.push(eff);
    }
  }
};


var lottie = {};

function setLocationHref(href) {
  locationHref = href;
}

function searchAnimations() {
  if (standalone === true) {
    animationManager.searchAnimations(animationData, standalone, renderer);
  } else {
    animationManager.searchAnimations();
  }
}

function setSubframeRendering(flag) {
  subframeEnabled = flag;
}

function loadAnimation(params) {
  if (standalone === true) {
    params.animationData = JSON.parse(animationData);
  }
  return animationManager.loadAnimation(params);
}

function setQuality(value) {
  if (typeof value === 'string') {
    switch (value) {
      case 'high':
        defaultCurveSegments = 200;
        break;
      default:
      case 'medium':
        defaultCurveSegments = 50;
        break;
      case 'low':
        defaultCurveSegments = 10;
        break;
    }
  } else if (!isNaN(value) && value > 1) {
    defaultCurveSegments = value;
  }
  if (defaultCurveSegments >= 50) {
    roundValues(false);
  } else {
    roundValues(true);
  }
}

function inBrowser() {
  return typeof navigator !== 'undefined';
}

function installPlugin(type, plugin) {
  if (type === 'expressions') {
    expressionsPlugin = plugin;
  }
}

function getFactory(name) {
  switch (name) {
    case 'propertyFactory':
      return PropertyFactory;
    case 'shapePropertyFactory':
      return ShapePropertyFactory;
    case 'matrix':
      return Matrix;
    default:
      return null;
  }
}

lottie.play = animationManager.play;
lottie.pause = animationManager.pause;
lottie.setLocationHref = setLocationHref;
lottie.togglePause = animationManager.togglePause;
lottie.setSpeed = animationManager.setSpeed;
lottie.setDirection = animationManager.setDirection;
lottie.stop = animationManager.stop;
lottie.searchAnimations = searchAnimations;
lottie.registerAnimation = animationManager.registerAnimation;
lottie.loadAnimation = loadAnimation;
lottie.setSubframeRendering = setSubframeRendering;
lottie.resize = animationManager.resize;
// lottie.start = start;
lottie.goToAndStop = animationManager.goToAndStop;
lottie.destroy = animationManager.destroy;
lottie.setQuality = setQuality;
lottie.inBrowser = inBrowser;
lottie.installPlugin = installPlugin;
lottie.freeze = animationManager.freeze;
lottie.unfreeze = animationManager.unfreeze;
lottie.setVolume = animationManager.setVolume;
lottie.mute = animationManager.mute;
lottie.unmute = animationManager.unmute;
lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
lottie.__getFactory = getFactory;
lottie.version = '5.7.6';

function checkReady() {
  if (document.readyState === 'complete') {
    clearInterval(readyStateCheckInterval);
    searchAnimations();
  }
}

function getQueryVariable(variable) {
  var vars = queryString.split('&');
  for (var i = 0; i < vars.length; i += 1) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) { // eslint-disable-line eqeqeq
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}
var standalone = '__[STANDALONE]__';
var animationData = '__[ANIMATIONDATA]__';
var renderer = '';
var queryString;
if (standalone) {
  var scripts = document.getElementsByTagName('script');
  var index = scripts.length - 1;
  var myScript = scripts[index] || {
    src: '',
  };
  queryString = myScript.src.replace(/^[^\?]+\??/, ''); // eslint-disable-line no-useless-escape
  renderer = getQueryVariable('renderer');
}
var readyStateCheckInterval = setInterval(checkReady, 100);

return lottie;
}));

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(360);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".AnimatedIcon-classic-2_3_6-3J6E- a{color:#079bb3}.AnimatedIcon-classic-2_3_6-3J6E-{display:inline-block}.AnimatedIcon-classic-2_3_6-3J6E-.AnimatedIcon-padRight-2_3_6-3LQCb{margin-right:.3333333333em}.AnimatedIcon-classic-2_3_6-3J6E-.AnimatedIcon-loader-2_3_6-2uEz5 path{stroke:#999}.AnimatedIcon-classic-2_3_6-3J6E-.AnimatedIcon-checkmark-2_3_6-KWxHh path{stroke:#a2b00c}.AnimatedIcon-blueSteel-2_3_6-2AKtL a{color:#08088c}.AnimatedIcon-blueSteel-2_3_6-2AKtL{display:inline-block}.AnimatedIcon-blueSteel-2_3_6-2AKtL.AnimatedIcon-padRight-2_3_6-3LQCb{margin-right:.3333333333em}.AnimatedIcon-blueSteel-2_3_6-2AKtL.AnimatedIcon-loader-2_3_6-2uEz5 path{stroke:#4d5056}.AnimatedIcon-blueSteel-2_3_6-2AKtL.AnimatedIcon-checkmark-2_3_6-KWxHh path{stroke:#009e4f}", ""]);

// exports
exports.locals = {
	"classic": "AnimatedIcon-classic-2_3_6-3J6E-",
	"padRight": "AnimatedIcon-padRight-2_3_6-3LQCb",
	"loader": "AnimatedIcon-loader-2_3_6-2uEz5",
	"checkmark": "AnimatedIcon-checkmark-2_3_6-KWxHh",
	"blueSteel": "AnimatedIcon-blueSteel-2_3_6-2AKtL"
};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _lotties_loader_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(362);
var _lotties_loader_json__WEBPACK_IMPORTED_MODULE_0___namespace = /*#__PURE__*/__webpack_require__.t(362, 1);
/* harmony import */ var _lotties_checkmark_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(363);
var _lotties_checkmark_json__WEBPACK_IMPORTED_MODULE_1___namespace = /*#__PURE__*/__webpack_require__.t(363, 1);


/* harmony default export */ __webpack_exports__["default"] = ({
  loader: _lotties_loader_json__WEBPACK_IMPORTED_MODULE_0__,
  checkmark: _lotties_checkmark_json__WEBPACK_IMPORTED_MODULE_1__
});

/***/ }),
/* 362 */
/***/ (function(module) {

module.exports = JSON.parse("{\"v\":\"5.7.0\",\"fr\":60,\"ip\":0,\"op\":40,\"w\":16,\"h\":16,\"nm\":\"spinner\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"spinner\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[8,8,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[7.332,7.332,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[11.332,7.332],[13.999,7.332]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.301999986172,0.31400001049,0.337000012398,1],\"ix\":3},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":35,\"s\":[30]},{\"t\":40,\"s\":[30]}],\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-0.943,0.943],[0.943,-0.943]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.301999986172,0.31400001049,0.337000012398,1],\"ix\":3},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[90]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":30,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":34,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":35,\"s\":[100]},{\"t\":40,\"s\":[90]}],\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[11.102,3.561],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[7.332,0.665],[7.332,3.332]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.301999986172,0.31400001049,0.337000012398,1],\"ix\":3},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[80]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":25,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":29,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":30,\"s\":[100]},{\"t\":40,\"s\":[80]}],\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-0.943,-0.943],[0.943,0.943]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.301999986172,0.31400001049,0.337000012398,1],\"ix\":3},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[70]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":20,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":24,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":25,\"s\":[100]},{\"t\":40,\"s\":[70]}],\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[3.562,3.562],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[0.665,7.332],[3.332,7.332]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.301999978458,0.313999998803,0.337000020345,1],\"ix\":3},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[60]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":15,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":19,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":20,\"s\":[100]},{\"t\":40,\"s\":[60]}],\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-0.943,0.943],[0.943,-0.943]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.301999978458,0.313999998803,0.337000020345,1],\"ix\":3},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[50]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":10,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":14,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":15,\"s\":[100]},{\"t\":40,\"s\":[50]}],\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[3.562,11.102],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[7.332,11.332],[7.332,13.999]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.301999978458,0.313999998803,0.337000020345,1],\"ix\":3},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":0,\"s\":[40]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":5,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":9,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":10,\"s\":[100]},{\"t\":40,\"s\":[40]}],\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-0.943,-0.943],[0.943,0.943]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0.301999986172,0.31400001049,0.337000012398,1],\"ix\":3},\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":4,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":5,\"s\":[100]},{\"t\":40,\"s\":[30]}],\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[11.102,11.102],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":41,\"st\":0,\"bm\":0}],\"markers\":[]}");

/***/ }),
/* 363 */
/***/ (function(module) {

module.exports = JSON.parse("{\"v\":\"5.7.0\",\"fr\":60,\"ip\":0,\"op\":61,\"w\":16,\"h\":16,\"nm\":\"saved\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Check\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[8,8,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[8,8,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[4.333,-3.337],[-2.333,3.337],[-4.333,1.337]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0.689999988032,0.340999977261,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[10.333,6.67],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tm\",\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":10,\"s\":[100]},{\"t\":20,\"s\":[0]}],\"ix\":1},\"e\":{\"a\":0,\"k\":100,\"ix\":2},\"o\":{\"a\":0,\"k\":0,\"ix\":3},\"m\":1,\"ix\":2,\"nm\":\"Trim Paths 1\",\"mn\":\"ADBE Vector Filter - Trim\",\"hd\":false}],\"ip\":0,\"op\":50,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Circle\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[8,8,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[8,8,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[2.831,-0.837],[1.607,2.478],[-1.918,2.244],[-2.696,-1.202]],\"o\":[[0,0],[-0.002,2.952],[-2.832,0.837],[-1.607,-2.476],[1.919,-2.245],[0,0]],\"v\":[[6.934,-0.579],[6.934,0.035],[2.158,6.424],[-5.327,3.658],[-4.801,-4.301],[2.979,-6.059]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0.689999988032,0.340999977261,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":1.33,\"ix\":5},\"lc\":2,\"lj\":2,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[7.734,8.632],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833],\"y\":[0.833,0.833]},\"o\":{\"x\":[0.167,0.167],\"y\":[0.167,0.167]},\"t\":50,\"s\":[100,100]},{\"t\":60,\"s\":[86,86]}],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tm\",\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":50,\"s\":[0]},{\"t\":60,\"s\":[100]}],\"ix\":1},\"e\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":13,\"s\":[100]}],\"ix\":2},\"o\":{\"a\":0,\"k\":0,\"ix\":3},\"m\":1,\"ix\":2,\"nm\":\"Trim Paths 1\",\"mn\":\"ADBE Vector Filter - Trim\",\"hd\":false}],\"ip\":0,\"op\":61,\"st\":0,\"bm\":0}],\"markers\":[]}");

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(365);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Autosave-classic-2_3_6-1R2kI a{color:#079bb3}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a{position:relative}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a.Autosave-inputGroup-2_3_6-25A75:not(:hover):not(.Autosave-isSaving-2_3_6-7gEfp):not(.Autosave-activeState-2_3_6-p3C4L):not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-focusedState-2_3_6-mr1b3) .Autosave-action-2_3_6-3Ah4w:not(.Autosave-select-2_3_6-2H2Cu),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a.Autosave-inputGroup-2_3_6-25A75:not(:hover):not(.Autosave-isSaving-2_3_6-7gEfp):not(.Autosave-activeState-2_3_6-p3C4L):not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-focusedState-2_3_6-mr1b3) .Autosave-action-2_3_6-3Ah4w:not(.Autosave-select-2_3_6-2H2Cu){display:none}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a.Autosave-isSaving-2_3_6-7gEfp label,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a.Autosave-isSaving-2_3_6-7gEfp label{pointer-events:none}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ{outline:none}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ fieldset,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ fieldset{padding-bottom:0}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ .Autosave-select-2_3_6-2H2Cu:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ .Autosave-select-2_3_6-2H2Cu:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ .Autosave-taglist-2_3_6-1_hKt:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ .Autosave-taglist-2_3_6-1_hKt:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ input[type=text]:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ input[type=text]:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ select:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ select:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ textarea:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ textarea:not(.Autosave-focusedState-2_3_6-mr1b3){outline:none}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp .Autosave-select-2_3_6-2H2Cu,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp .Autosave-select-2_3_6-2H2Cu,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp .Autosave-taglist-2_3_6-1_hKt,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp .Autosave-taglist-2_3_6-1_hKt,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp select:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp select:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){pointer-events:none}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig .Autosave-select-2_3_6-2H2Cu,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig .Autosave-select-2_3_6-2H2Cu,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){border-color:#ba2453}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L .Autosave-select-2_3_6-2H2Cu,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L .Autosave-select-2_3_6-2H2Cu,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){color:#444;border-color:#777}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 .Autosave-select-2_3_6-2H2Cu,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 .Autosave-select-2_3_6-2H2Cu,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){color:#444;border-color:#08b0cc}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) .Autosave-select-2_3_6-2H2Cu:hover,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) .Autosave-select-2_3_6-2H2Cu:hover,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) .Autosave-taglist-2_3_6-1_hKt:hover,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) .Autosave-taglist-2_3_6-1_hKt:hover,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW):hover,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW):hover,.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW):hover,.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW):hover{color:#444;border-color:#999}.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-classic-2_3_6-1R2kI .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){border-width:1px}.Autosave-blueSteel-2_3_6-Vo-oz a{color:#08088c}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a{position:relative}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a.Autosave-inputGroup-2_3_6-25A75:not(:hover):not(.Autosave-isSaving-2_3_6-7gEfp):not(.Autosave-activeState-2_3_6-p3C4L):not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-focusedState-2_3_6-mr1b3) .Autosave-action-2_3_6-3Ah4w:not(.Autosave-select-2_3_6-2H2Cu),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a.Autosave-inputGroup-2_3_6-25A75:not(:hover):not(.Autosave-isSaving-2_3_6-7gEfp):not(.Autosave-activeState-2_3_6-p3C4L):not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-focusedState-2_3_6-mr1b3) .Autosave-action-2_3_6-3Ah4w:not(.Autosave-select-2_3_6-2H2Cu){display:none}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a.Autosave-isSaving-2_3_6-7gEfp label,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a.Autosave-isSaving-2_3_6-7gEfp label{pointer-events:none}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ{outline:none}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ fieldset,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ fieldset{padding-bottom:0}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ .Autosave-select-2_3_6-2H2Cu:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ .Autosave-select-2_3_6-2H2Cu:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ .Autosave-taglist-2_3_6-1_hKt:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ .Autosave-taglist-2_3_6-1_hKt:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ input[type=text]:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ input[type=text]:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ select:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ select:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ textarea:not(.Autosave-focusedState-2_3_6-mr1b3),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ textarea:not(.Autosave-focusedState-2_3_6-mr1b3){outline:none}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp select:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp select:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-isSaving-2_3_6-7gEfp textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){pointer-events:none}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ.Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){border-color:#d33d00}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB).Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){color:#01050e;border-color:#8e9093}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L).Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){color:#01050e;border-color:#092dbd}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) .Autosave-select-2_3_6-2H2Cu:hover,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) .Autosave-select-2_3_6-2H2Cu:hover,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) .Autosave-taglist-2_3_6-1_hKt:hover,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) .Autosave-taglist-2_3_6-1_hKt:hover,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW):hover,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW):hover,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW):hover,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-stateWrapper-2_3_6-1UlVQ:not(.Autosave-hasError-2_3_6-FUWig):not(.Autosave-disabled-2_3_6-pLVcB):not(.Autosave-activeState-2_3_6-p3C4L) textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW):hover{color:#01050e;border-color:#8e9093}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L:not(.Autosave-disabled-2_3_6-pLVcB),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L:not(.Autosave-disabled-2_3_6-pLVcB),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3:not(.Autosave-disabled-2_3_6-pLVcB),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3:not(.Autosave-disabled-2_3_6-pLVcB),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig:not(.Autosave-disabled-2_3_6-pLVcB),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig:not(.Autosave-disabled-2_3_6-pLVcB),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW),.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW){margin:0;border-width:2px}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu{border-width:2px}.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-activeState-2_3_6-p3C4L textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3 textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-focusedState-2_3_6-mr1b3:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig .Autosave-taglist-2_3_6-1_hKt .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig:not(.Autosave-disabled-2_3_6-pLVcB) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig input[type=text]:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz.Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select,.Autosave-blueSteel-2_3_6-Vo-oz .Autosave-autosave-2_3_6-23k9a .Autosave-hasError-2_3_6-FUWig textarea:not(.Autosave-disabled-2_3_6-pLVcB):not(:disabled):not([readonly]):not(.Autosave-readonly-2_3_6-QZBHW) .Autosave-select-2_3_6-2H2Cu select{padding:0 27px 0 9px}", ""]);

// exports
exports.locals = {
	"classic": "Autosave-classic-2_3_6-1R2kI",
	"autosave": "Autosave-autosave-2_3_6-23k9a",
	"inputGroup": "Autosave-inputGroup-2_3_6-25A75",
	"isSaving": "Autosave-isSaving-2_3_6-7gEfp",
	"activeState": "Autosave-activeState-2_3_6-p3C4L",
	"hasError": "Autosave-hasError-2_3_6-FUWig",
	"focusedState": "Autosave-focusedState-2_3_6-mr1b3",
	"action": "Autosave-action-2_3_6-3Ah4w",
	"select": "Autosave-select-2_3_6-2H2Cu",
	"stateWrapper": "Autosave-stateWrapper-2_3_6-1UlVQ",
	"taglist": "Autosave-taglist-2_3_6-1_hKt",
	"disabled": "Autosave-disabled-2_3_6-pLVcB",
	"readonly": "Autosave-readonly-2_3_6-QZBHW",
	"blueSteel": "Autosave-blueSteel-2_3_6-Vo-oz"
};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(367);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Autosave__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(235);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(369);






function AutosaveInput(_ref) {
  var autosaveProps = Object.assign({}, _ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Autosave__WEBPACK_IMPORTED_MODULE_3__["Autosave"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    Component: _Input__WEBPACK_IMPORTED_MODULE_4__["PlainInput"],
    fieldType: "input"
  }, autosaveProps));
}

/* harmony default export */ __webpack_exports__["default"] = (AutosaveInput);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(7);
var assign = __webpack_require__(368);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var fails = __webpack_require__(12);
var objectKeys = __webpack_require__(82);
var getOwnPropertySymbolsModule = __webpack_require__(49);
var propertyIsEnumerableModule = __webpack_require__(13);
var toObject = __webpack_require__(77);
var IndexedObject = __webpack_require__(16);

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  /* global Symbol -- required for testing */
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(370);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return _Input__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _PlainInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(371);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainInput", function() { return _PlainInput__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return Input; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var js_components_InputGroup__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(249);
/* harmony import */ var js_components_RemainingChars__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(262);
/* harmony import */ var _PlainInput__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(371);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(155);















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







/**
A basic text input wrapped in an `InputGroup` for use in forms.

This component accepts all props passed to `PlainInput` and `InputGroup`.

All form inputs in this library must be implemented as [controlled
components](https://reactjs.org/docs/forms.html#controlled-components).
 */

var Input = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, Input);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(Input, [{
    key: "focus",
    value:
    /**
     * Focuses the underlying PlainInput component
     */
    function focus() {
      this.instance.focus();
    }
    /**
     * Selects the underlying PlainInput component
     */

  }, {
    key: "select",
    value: function select() {
      this.instance.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          inputClassName = _this$props.inputClassName,
          inputTestName = _this$props.inputTestName,
          contentRight = _this$props.contentRight,
          className = _this$props.className,
          description = _this$props.description,
          error = _this$props.error,
          helperText = _this$props.helperText,
          label = _this$props.label,
          maxChars = _this$props.maxChars,
          required = _this$props.required,
          style = _this$props.style,
          testName = _this$props.testName,
          theme = _this$props.theme,
          tooltip = _this$props.tooltip,
          inputProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8___default()(_this$props, ["inputClassName", "inputTestName", "contentRight", "className", "description", "error", "helperText", "label", "maxChars", "required", "style", "testName", "theme", "tooltip"]);

      var value = inputProps.value,
          disabled = inputProps.disabled;
      var labelRight = contentRight;

      if (maxChars && value != null && !disabled) {
        labelRight = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement(js_components_RemainingChars__WEBPACK_IMPORTED_MODULE_19__["CharCountDisplay"], {
          max: maxChars,
          count: value.length
        });
      }

      var controlProps = {
        contentRight: labelRight,
        className: className,
        description: description,
        error: error,
        helperText: helperText,
        label: label,
        readOnly: inputProps.readOnly,
        required: required,
        style: style,
        tooltip: tooltip,
        testName: testName,
        theme: theme
      };
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement(js_components_InputGroup__WEBPACK_IMPORTED_MODULE_18__["InputGroup"], controlProps, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement(_PlainInput__WEBPACK_IMPORTED_MODULE_20__["default"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_7___default()({
        className: inputClassName,
        testName: inputTestName,
        hasError: Boolean(error),
        theme: theme,
        ref: function ref(node) {
          _this.instance = node;
        }
      }, inputProps)));
    }
  }]);

  return Input;
}(react__WEBPACK_IMPORTED_MODULE_16___default.a.Component);
Input.propTypes = _objectSpread(_objectSpread({}, _PlainInput__WEBPACK_IMPORTED_MODULE_20__["default"].propTypes), {}, {
  /** This component accepts all props passed to [`<PlainInput>`](#!/PlainInput) and [`<InputGroup>`](#!/InputGroup). Please refer to the propTypes documentation for those components. */
  __NOTE__: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.any,

  /** @ignore - See `InputGroup` docs */
  contentRight: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.node,

  /** @ignore - See `InputGroup` docs */
  description: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.node,

  /** @ignore - See `InputGroup` docs */
  error: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** @ignore - See `InputGroup` docs */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.node,

  /** `className` attribute to pass to `PlainInput` */
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** PlainInput test name for automation */
  inputTestName: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** @ignore - See `InputGroup` docs */
  label: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** If provided the number of remaining characters will be passed in the `InputGroup` `contentRight` prop. If value is longer than maxLength then the remaining character count will be rendered in error color. */
  maxChars: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.number,

  /** @ignore - See `InputGroup` docs */
  readOnly: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.bool,

  /** @ignore - See `InputGroup` docs */
  required: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.bool,

  /** @ignore - See `InputGroup` docs */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string
});
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_21__["provideTheme"])()(Input));

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlainInput", function() { return PlainInput; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Input_sass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(372);
/* harmony import */ var _Input_sass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_Input_sass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(155);











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







/**
 * A basic input without an `<InputGroup>` wrapper around it to support
 * `label`, `error`, etc.
 *
 * All form inputs in this library must be implemented as [controlled
 * components](https://reactjs.org/docs/forms.html#controlled-components).
 */

var PlainInput = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(PlainInput, _React$Component);

  var _super = _createSuper(PlainInput);

  function PlainInput() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, PlainInput);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(PlainInput, [{
    key: "focus",
    value:
    /**
     * Focuses the underlying text input component
     */
    function focus() {
      this.instance.focus();
    }
    /**
     * Selects the underlying text input component
     */

  }, {
    key: "select",
    value: function select() {
      this.instance.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          dir = _this$props.dir,
          disabled = _this$props.disabled,
          hasError = _this$props.hasError,
          id = _this$props.id,
          maxLength = _this$props.maxLength,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          placeholder = _this$props.placeholder,
          autoFocus = _this$props.autoFocus,
          readOnly = _this$props.readOnly,
          style = _this$props.style,
          testName = _this$props.testName,
          theme = _this$props.theme,
          type = _this$props.type,
          value = _this$props.value,
          rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default()(_this$props, ["className", "dir", "disabled", "hasError", "id", "maxLength", "name", "onBlur", "onChange", "onClick", "onFocus", "placeholder", "autoFocus", "readOnly", "style", "testName", "theme", "type", "value"]);

      var classes = classnames__WEBPACK_IMPORTED_MODULE_13___default()(_Input_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme], _Input_sass__WEBPACK_IMPORTED_MODULE_14___default.a.input, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_cx, _Input_sass__WEBPACK_IMPORTED_MODULE_14___default.a.hasError, hasError), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_cx, _Input_sass__WEBPACK_IMPORTED_MODULE_14___default.a.readOnly, readOnly), _cx));
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("input", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
        className: classes,
        "data-test-name": testName,
        dir: dir,
        disabled: disabled,
        id: id,
        maxLength: maxLength,
        name: name,
        onBlur: onBlur ? function (evt) {
          return onBlur(evt.target.value, evt);
        } : null,
        onChange: onChange ? function (evt) {
          return onChange(evt.target.value, evt);
        } : null,
        onClick: onClick,
        onFocus: onFocus ? function (evt) {
          return onFocus(evt.target.value, evt);
        } : null,
        placeholder: placeholder,
        autoFocus: autoFocus,
        readOnly: readOnly,
        style: style,
        type: type,
        value: String(value),
        ref: function ref(node) {
          _this.instance = node;
        }
      }, rest));
    }
  }]);

  return PlainInput;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);
PlainInput.defaultProps = {
  readOnly: false,
  dir: 'auto',
  disabled: false,
  hasError: false,
  type: 'text'
};
PlainInput.propTypes = {
  /** Class name for the input */
  className: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Direction for the dir attribute*/
  dir: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOf(['auto', 'ltr', 'rtl']),

  /** whether or not to disable the input */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to render an error border around the input */
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** id attribute for the input */
  id: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** maxLength attribute for the input */
  maxLength: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.number,

  /** name attribute for the input */
  name: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /**
   * Your blur handler.
   * @param {string} value - Current value of the input.
   * @param {SyntheticEvent} event - The event.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /**
   * Your change handler. Update your state here.
   * @param {string} value - Current value of the input.
   * @param {SyntheticEvent} event - The event.
   */
  onChange: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default()(prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func, function (props) {
    return !(props.readOnly || props.disabled);
  }),

  /**
   * Your click handler.
   * @param {SyntheticEvent} event - The click event.
   */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /**
   * Your focus handler.
   * @param {string} value - Current value of the input.
   * @param {SyntheticEvent} event - The event.
   */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /** Placeholder text for the input */
  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Whether the input is initially focused when mounted */
  autoFocus: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not the input is readOnly.
  Note: readOnly inputs have a different visual treatment */
  readOnly: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** type attribute for the input */
  type: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOf(['text', 'password', 'email', 'url', 'number']),

  /** Current value of the field. */
  value: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.number]).isRequired,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_15__["provideTheme"])(_Input_sass__WEBPACK_IMPORTED_MODULE_14___default.a)(PlainInput));

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(373);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Input-classic-2_3_6-3jVee a{color:#079bb3}.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK{border:1px solid #aaa;font-size:1rem;font-family:Lato,Helvetica,Arial,sans-serif;background-color:#fff}.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK .Input-disabled-2_3_6-1l0gW:not([readonly]):not(.Input-readOnly-2_3_6-wr6pK),.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK .Input-disabled-2_3_6-1l0gW:not([readonly]):not(.Input-readOnly-2_3_6-wr6pK),.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:disabled:not([readonly]):not(.Input-readOnly-2_3_6-wr6pK),.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:disabled:not([readonly]):not(.Input-readOnly-2_3_6-wr6pK){background-color:#f4f4f4;border:1px solid #ccc;color:#999}.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK).Input-hasError-2_3_6-1RwJG,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK).Input-hasError-2_3_6-1RwJG,.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) .Input-hasError-2_3_6-1RwJG,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) .Input-hasError-2_3_6-1RwJG{border-color:#ba2453;outline:none}.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):active,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):active,.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):active,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):active,.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):focus,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):focus,.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):focus,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):focus,.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):hover,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):hover,.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):hover,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):hover{border-color:#999;color:#444}.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK.Input-readOnly-2_3_6-wr6pK,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK.Input-readOnly-2_3_6-wr6pK,.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK[readonly],.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK[readonly]{color:#666;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK{color:#444;border-radius:0;padding:8px;width:100%;max-width:100%;line-height:18px}.Input-classic-2_3_6-3jVee.Input-input-2_3_6-394TK::-ms-clear,.Input-classic-2_3_6-3jVee .Input-input-2_3_6-394TK::-ms-clear{display:none}.Input-blueSteel-2_3_6-3dIiv a{color:#08088c}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK{border:1px solid #e5e6e6;font-size:1rem;font-family:Public Sans,sans-serif;background-color:#fff}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK .Input-disabled-2_3_6-1l0gW:not([readonly]):not(.Input-readOnly-2_3_6-wr6pK),.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK .Input-disabled-2_3_6-1l0gW:not([readonly]):not(.Input-readOnly-2_3_6-wr6pK),.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:disabled:not([readonly]):not(.Input-readOnly-2_3_6-wr6pK),.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:disabled:not([readonly]):not(.Input-readOnly-2_3_6-wr6pK){background-color:#f2f2f3;border:1px solid #f2f2f3;color:#8e9093}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK).Input-hasError-2_3_6-1RwJG,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK).Input-hasError-2_3_6-1RwJG,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) .Input-hasError-2_3_6-1RwJG,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) .Input-hasError-2_3_6-1RwJG{border-color:#d33d00;outline:none}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):active,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):active,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):active,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):active,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):focus,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):focus,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):focus,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):focus,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):hover,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):not(.Input-hasError-2_3_6-1RwJG):hover,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):hover,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK) :not(.Input-hasError-2_3_6-1RwJG):hover{border-color:#8e9093;color:#01050e}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK.Input-readOnly-2_3_6-wr6pK,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK.Input-readOnly-2_3_6-wr6pK,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK[readonly],.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK[readonly]{color:#4d5056;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK{color:#4d5056;border-radius:3px;margin:1px;padding:11px}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK).Input-hasError-2_3_6-1RwJG,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK).Input-hasError-2_3_6-1RwJG,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):active,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):active,.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):focus,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK:not(:disabled):not(.Input-disabled-2_3_6-1l0gW):not([readonly]):not(.Input-readOnly-2_3_6-wr6pK):focus{border-width:2px;margin:0}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK{width:100%;max-width:100%;line-height:24px}.Input-blueSteel-2_3_6-3dIiv.Input-input-2_3_6-394TK::-ms-clear,.Input-blueSteel-2_3_6-3dIiv .Input-input-2_3_6-394TK::-ms-clear{display:none}", ""]);

// exports
exports.locals = {
	"classic": "Input-classic-2_3_6-3jVee",
	"input": "Input-input-2_3_6-394TK",
	"readOnly": "Input-readOnly-2_3_6-wr6pK",
	"disabled": "Input-disabled-2_3_6-1l0gW",
	"hasError": "Input-hasError-2_3_6-1RwJG",
	"blueSteel": "Input-blueSteel-2_3_6-3dIiv"
};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(367);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Autosave__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(235);
/* harmony import */ var _RadioGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(375);






function AutosaveRadioGroup(_ref) {
  var autosaveProps = Object.assign({}, _ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Autosave__WEBPACK_IMPORTED_MODULE_3__["Autosave"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    Component: _RadioGroup__WEBPACK_IMPORTED_MODULE_4__["RadioGroup"],
    fieldType: "radio"
  }, autosaveProps));
}

/* harmony default export */ __webpack_exports__["default"] = (AutosaveRadioGroup);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _RadioGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(376);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return _RadioGroup__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _PlainRadioGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(377);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainRadioGroup", function() { return _PlainRadioGroup__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _RadioOption__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(385);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioOption", function() { return _RadioOption__WEBPACK_IMPORTED_MODULE_2__["default"]; });








/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return RadioGroup; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var js_components_InputGroup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(249);
/* harmony import */ var _PlainRadioGroup__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(377);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(155);
/* harmony import */ var _RadioInput_RadioInput_sass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(383);
/* harmony import */ var _RadioInput_RadioInput_sass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_RadioInput_RadioInput_sass__WEBPACK_IMPORTED_MODULE_15__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














/**
A collection of radio inputs wrapped in an `InputGroup` for use in forms.

This component accepts all props passed to `PlainRadioGroup` and `InputGroup`.

All form inputs in this library must be implemented as [controlled
components](https://reactjs.org/docs/forms.html#controlled-components).
*/

function RadioGroup(props) {
  var inputClassName = props.inputClassName,
      contentRight = props.contentRight,
      className = props.className,
      description = props.description,
      error = props.error,
      helperText = props.helperText,
      label = props.label,
      required = props.required,
      tooltip = props.tooltip,
      testName = props.testName,
      style = props.style,
      theme = props.theme,
      inputProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(props, ["inputClassName", "contentRight", "className", "description", "error", "helperText", "label", "required", "tooltip", "testName", "style", "theme"]);

  var controlProps = {
    className: className,
    contentRight: contentRight,
    description: description,
    error: error,
    helperText: helperText,
    label: label,
    required: required,
    style: style,
    testName: testName,
    tooltip: tooltip
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(js_components_InputGroup__WEBPACK_IMPORTED_MODULE_12__["InputGroup"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
    asFieldset: true,
    theme: theme
  }, controlProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_PlainRadioGroup__WEBPACK_IMPORTED_MODULE_13__["default"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
    className: inputClassName,
    theme: theme
  }, inputProps)));
}
RadioGroup.propTypes = _objectSpread(_objectSpread({}, _PlainRadioGroup__WEBPACK_IMPORTED_MODULE_13__["default"].PropTypes), {}, {
  /** This component accepts all props passed to [`<PlainRadioGroup>`](#!/PlainRadioGroup) and [`<InputGroup>`](#!/InputGroup). Please refer to the propTypes documentation for those components. */
  __NOTE__: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.any,

  /** @ignore - See `InputGroup` docs */
  contentRight: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** `className` attribute to be passed to `PlainRadioGroup` */
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  description: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** @ignore - See `InputGroup` docs */
  error: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** @ignore - See `InputGroup` docs */
  label: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node]),

  /** @ignore - See `InputGroup` docs */
  required: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** @ignore - See `InputGroup` docs */
  style: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** @ignore - See `InputGroup` docs */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string
});
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_14__["provideTheme"])(_RadioInput_RadioInput_sass__WEBPACK_IMPORTED_MODULE_15___default.a)(RadioGroup));

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlainRadioGroup", function() { return PlainRadioGroup; });
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(378);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _RadioGroup_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(379);
/* harmony import */ var _RadioGroup_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_RadioGroup_sass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var js_util_normalizeOptionsArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(381);
/* harmony import */ var js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(0);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(155);













function handleEvent(options, callback) {
  if (!callback) return null;
  return function (index, evt) {
    return callback(options[index].value, evt);
  };
}
/**
 * A RadioGroup without an `<InputGroup>` wrapper around it to support
 * `label`, `error`, etc.
 *
 * All form inputs in this library must be implemented as [controlled
 * components](https://reactjs.org/docs/forms.html#controlled-components).
 */


function PlainRadioGroup(_ref) {
  var children = _ref.children,
      value = _ref.value,
      options = _ref.options,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      className = _ref.className,
      disabled = _ref.disabled,
      name = _ref.name,
      inline = _ref.inline,
      testName = _ref.testName,
      id = _ref.id,
      style = _ref.style,
      theme = _ref.theme;
  var normalizedOptions = children ? Object(js_util_normalizeOptionsArray__WEBPACK_IMPORTED_MODULE_9__["normalizeChildrenOptionsArray"])(children) : Object(js_util_normalizeOptionsArray__WEBPACK_IMPORTED_MODULE_9__["default"])(options);
  var selectedIndex = normalizedOptions.findIndex(function (option) {
    return option.value === value;
  });

  if (value != null && value !== '' && selectedIndex === -1) {
    if (true) {
      console.warn("Invalid value '".concat(value, "' supplied to <PlainRadioGroup> with options ").concat(JSON.stringify(options), "."));
    }
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(className, _RadioGroup_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme]),
    "data-test-name": testName,
    id: id,
    style: style
  }, normalizedOptions.map(function (option, index) {
    var input = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(js__WEBPACK_IMPORTED_MODULE_10__["RadioInput"], {
      key: index,
      checked: index === selectedIndex,
      inline: inline,
      disabled: disabled || option.disabled,
      name: name,
      onBlur: handleEvent(normalizedOptions, onBlur),
      onChange: handleEvent(normalizedOptions, onChange),
      onFocus: handleEvent(normalizedOptions, onFocus),
      value: index,
      testName: option.testName,
      theme: theme
    }, option.label);
    return option.render ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(option.className),
      key: index
    }, input, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
      className: _RadioGroup_sass__WEBPACK_IMPORTED_MODULE_7___default.a.groupContents
    }, option.render(index === selectedIndex, disabled || option.disabled))) : option.className ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(option.className),
      key: index
    }, input) : input;
  }));
}
PlainRadioGroup.propTypes = {
  disabled: false,
  inline: false
};
PlainRadioGroup.propTypes = {
  /** Class name attribute */
  className: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** whether or not to disabled all radio inputs */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** id attribute for the outer `<div>` tag */
  id: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Whether or not to render each radio input inline with each other */
  inline: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** name attribute for the `<input>` tags */
  name: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string.isRequired,

  /**
   * Your blur handler.
   * @param {*} value - Current selected value.
   * @param {SyntheticEvent} event - The event.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func,

  /**
   * Your change handler. Update your state here.
   * @param {*} value - Current selected value.
   * @param {SyntheticEvent} event - The event.
   */
  onChange: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_8___default()(prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func, function (props) {
    return !props.disabled;
  }),

  /**
   * Your focus handler.
   * @param {*} value - Current selected value.
   * @param {SyntheticEvent} event - The event.
   */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func,

  /** Options to render as radio inputs. See the docs site for working examples */
  options: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_8___default()(prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object, prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string), prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.shape({
    label: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.node.isRequired,
    value: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.any,
    // not required since we allow null as a value
    disabled: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,
    testName: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string
  }))]), function (props) {
    return props.children === null;
  }),

  /** Children <RadioOption> components for rendering complex inputs */
  children: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.node,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Current selected value. This must match one of the values supplied in `options`. */
  value: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.any,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_11__["provideTheme"])(_RadioGroup_sass__WEBPACK_IMPORTED_MODULE_7___default.a)(PlainRadioGroup));

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $findIndex = __webpack_require__(75).findIndex;
var addToUnscopables = __webpack_require__(118);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(380);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".RadioGroup-classic-2_3_6-3xmEq a{color:#079bb3}.RadioGroup-classic-2_3_6-3xmEq .RadioGroup-groupContents-2_3_6-2pYgY{padding-top:.6666666667rem;padding-left:1.37rem}.RadioGroup-blueSteel-2_3_6-3cQFi a{color:#08088c}.RadioGroup-blueSteel-2_3_6-3cQFi .RadioGroup-groupContents-2_3_6-2pYgY{padding-top:.6666666667rem;padding-left:1.37rem}", ""]);

// exports
exports.locals = {
	"classic": "RadioGroup-classic-2_3_6-3xmEq",
	"groupContents": "RadioGroup-groupContents-2_3_6-2pYgY",
	"blueSteel": "RadioGroup-blueSteel-2_3_6-3cQFi"
};

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return normalizeOptionsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeChildrenOptionsArray", function() { return normalizeChildrenOptionsArray; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(178);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(382);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);




 //
// Convenience function for converting options shorthands:
//   ['one', 'two']
// to
//   [{label: 'one', value: 'one'}, {label: 'two', value: 'two'}]
//
// and
//   { one: 'ONE', two: 'TWO'}
// to
//   [{label: 'ONE', value: 'one'}, {label: 'TWO', value: 'two'}]
//
// These structures are currently supported by Select and RadioGroup inputs
//

function normalizeOptionsArray(options) {
  if (Array.isArray(options)) {
    if (typeof options[0] === 'string') {
      return options.map(function (option) {
        return {
          label: option,
          value: option
        };
      });
    } else {
      return options;
    }
  } else if (options != null && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(options) === 'object') {
    if (true) {
      console.warn('Deprecation warning: Passing `options` as an object to <RadioGroup> and <Select> will be removed in the next studio-components release.');
    }

    return Object.keys(options).map(function (key) {
      return {
        label: options[key],
        value: key
      };
    });
  } else {
    throw Error('Invalid options array.');
  }
} // Convienence function for converting a React child list to
// a form of [{label, value, render}]
// for example <Option label="test", value="test">{() => <div/>}</Option>
// would become {label: 'test', value='test', render: () => <div/>}
// This structure is supported by RadioGroup inputs

function normalizeChildrenOptionsArray(children) {
  var optionsArray = react__WEBPACK_IMPORTED_MODULE_4___default.a.Children.map(children, function (radioInput, index) {
    var _radioInput$props = radioInput.props,
        value = _radioInput$props.value,
        label = _radioInput$props.label,
        children = _radioInput$props.children,
        className = _radioInput$props.className;

    if (!value && !label && "none" !== 'production') {
      console.warn('Either value or label must be specified for RadioInput children');
    }

    return {
      render: children,
      value: value ? value : index,
      label: label ? label : value,
      className: className
    };
  });

  if (!optionsArray.find(function (option) {
    return option.render;
  })) {
    if (true) {
      console.warn('No child render functions found. It is recommended to use `options` property instead');
    }
  }

  return optionsArray;
}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var $find = __webpack_require__(75).find;
var addToUnscopables = __webpack_require__(118);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(384);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".RadioInput-classic-2_3_6-1dVnH a{color:#079bb3}.RadioInput-classic-2_3_6-1dVnH.RadioInput-radioInput-2_3_6-39vIA,.RadioInput-classic-2_3_6-1dVnH .RadioInput-radioInput-2_3_6-39vIA{position:relative}.RadioInput-classic-2_3_6-1dVnH.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg)+.RadioInput-classic-2_3_6-1dVnH.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg),.RadioInput-classic-2_3_6-1dVnH.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg)+.RadioInput-classic-2_3_6-1dVnH .RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg),.RadioInput-classic-2_3_6-1dVnH .RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg)+.RadioInput-classic-2_3_6-1dVnH.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg),.RadioInput-classic-2_3_6-1dVnH .RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg)+.RadioInput-classic-2_3_6-1dVnH .RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg){margin-top:.4rem}.RadioInput-classic-2_3_6-1dVnH.RadioInput-inline-2_3_6-1kGkg,.RadioInput-classic-2_3_6-1dVnH .RadioInput-inline-2_3_6-1kGkg{display:inline-block;margin-right:1.3333333333rem;margin-top:0}.RadioInput-classic-2_3_6-1dVnH.RadioInput-inline-2_3_6-1kGkg:last-child,.RadioInput-classic-2_3_6-1dVnH .RadioInput-inline-2_3_6-1kGkg:last-child{margin-right:0}.RadioInput-classic-2_3_6-1dVnH.RadioInput-disabled-2_3_6-1c_6q,.RadioInput-classic-2_3_6-1dVnH .RadioInput-disabled-2_3_6-1c_6q{pointer-events:none}.RadioInput-classic-2_3_6-1dVnH.RadioInput-label-2_3_6-1fIuC,.RadioInput-classic-2_3_6-1dVnH .RadioInput-label-2_3_6-1fIuC{position:relative;cursor:pointer;display:block;color:#444;padding-left:1.37rem}.RadioInput-disabled-2_3_6-1c_6q .RadioInput-classic-2_3_6-1dVnH.RadioInput-label-2_3_6-1fIuC,.RadioInput-disabled-2_3_6-1c_6q .RadioInput-classic-2_3_6-1dVnH .RadioInput-label-2_3_6-1fIuC{opacity:.5;cursor:default}.RadioInput-classic-2_3_6-1dVnH.RadioInput-input-2_3_6-3m80y,.RadioInput-classic-2_3_6-1dVnH .RadioInput-input-2_3_6-3m80y{cursor:pointer;opacity:0;position:absolute;left:0;width:1.25rem;height:1.25rem;margin:0}.RadioInput-classic-2_3_6-1dVnH.RadioInput-input-2_3_6-3m80y+span,.RadioInput-classic-2_3_6-1dVnH .RadioInput-input-2_3_6-3m80y+span{border-left:1.37rem solid transparent;margin-left:-1.37rem}.RadioInput-classic-2_3_6-1dVnH.RadioInput-input-2_3_6-3m80y:focus+*,.RadioInput-classic-2_3_6-1dVnH .RadioInput-input-2_3_6-3m80y:focus+*{outline:auto;outline-color:#079bb3}.hide-focus-outlines .RadioInput-classic-2_3_6-1dVnH.RadioInput-input-2_3_6-3m80y:focus+*,.hide-focus-outlines .RadioInput-classic-2_3_6-1dVnH .RadioInput-input-2_3_6-3m80y:focus+*{outline:none}.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ{position:absolute;left:0;width:1rem;height:1rem;border-radius:.5rem;box-shadow:inset 0 0 0 1px #919191;text-align:center;padding:1px;background-color:#fff;transition:background-color .3s ease,box-shadow .3s ease}.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ>div,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ>div{width:100%;height:100%;background-color:#fff;border-radius:.5rem;transition:transform .4s ease;transform:scale(1);transform-origin:center}.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ{background-color:#079bb3;box-shadow:none!important}.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ>div,.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ>div{transform:scale(.4)}.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ{box-shadow:inset 0 0 0 1px gray}.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ{box-shadow:inset 0 0 0 1px #b3b3b3!important}.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ{background-color:#888!important}.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-label-2_3_6-1fIuC,.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-label-2_3_6-1fIuC,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-label-2_3_6-1fIuC,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-label-2_3_6-1fIuC{line-height:1.25}.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-classic-2_3_6-1dVnH .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ{top:.125rem}.RadioInput-blueSteel-2_3_6-3EQrx a{color:#08088c}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-radioInput-2_3_6-39vIA,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-radioInput-2_3_6-39vIA{position:relative}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg)+.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg),.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg)+.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg),.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg)+.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg),.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg)+.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-inline-2_3_6-1kGkg){margin-top:.4rem}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-inline-2_3_6-1kGkg,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-inline-2_3_6-1kGkg{display:inline-block;margin-right:1.3333333333rem;margin-top:0}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-inline-2_3_6-1kGkg:last-child,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-inline-2_3_6-1kGkg:last-child{margin-right:0}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-disabled-2_3_6-1c_6q,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-disabled-2_3_6-1c_6q{pointer-events:none}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-label-2_3_6-1fIuC,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-label-2_3_6-1fIuC{position:relative;cursor:pointer;display:block;color:#01050e;padding-left:1.37rem}.RadioInput-disabled-2_3_6-1c_6q .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-label-2_3_6-1fIuC,.RadioInput-disabled-2_3_6-1c_6q .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-label-2_3_6-1fIuC{opacity:.5;cursor:default}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-input-2_3_6-3m80y,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-input-2_3_6-3m80y{cursor:pointer;opacity:0;position:absolute;left:0;width:1.25rem;height:1.25rem;margin:0}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-input-2_3_6-3m80y+span,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-input-2_3_6-3m80y+span{border-left:1.37rem solid transparent;margin-left:-1.37rem}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-input-2_3_6-3m80y:focus+*,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-input-2_3_6-3m80y:focus+*{outline:auto;outline-color:#08088c}.hide-focus-outlines .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-input-2_3_6-3m80y:focus+*,.hide-focus-outlines .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-input-2_3_6-3m80y:focus+*{outline:none}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ{position:absolute;left:0;width:1rem;height:1rem;border-radius:.5rem;box-shadow:inset 0 0 0 1px #cbcdcd;text-align:center;padding:1px;background-color:#fff;transition:background-color .3s ease,box-shadow .3s ease}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ>div,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ>div{width:100%;height:100%;background-color:#fff;border-radius:.5rem;transition:transform .4s ease;transform:scale(1);transform-origin:center}.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ{background-color:#08088c;box-shadow:none!important}.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ>div,.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ>div{transform:scale(.4)}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-radioInput-2_3_6-39vIA:not(.RadioInput-selected-2_3_6-2NK-2):hover .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ{box-shadow:inset 0 0 0 1px #74767a}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q:not(.RadioInput-selected-2_3_6-2NK-2) .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ{box-shadow:inset 0 0 0 1px #d7d7db!important}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ{background-color:#4d5056!important}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ{top:.2rem}.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx.RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ.RadioInput-bullet-2_3_6-1nLkQ,.RadioInput-disabled-2_3_6-1c_6q.RadioInput-selected-2_3_6-2NK-2 .RadioInput-blueSteel-2_3_6-3EQrx .RadioInput-bullet-2_3_6-1nLkQ .RadioInput-bullet-2_3_6-1nLkQ{background-color:#8e9093!important}", ""]);

// exports
exports.locals = {
	"classic": "RadioInput-classic-2_3_6-1dVnH",
	"radioInput": "RadioInput-radioInput-2_3_6-39vIA",
	"inline": "RadioInput-inline-2_3_6-1kGkg",
	"disabled": "RadioInput-disabled-2_3_6-1c_6q",
	"label": "RadioInput-label-2_3_6-1fIuC",
	"input": "RadioInput-input-2_3_6-3m80y",
	"bullet": "RadioInput-bullet-2_3_6-1nLkQ",
	"selected": "RadioInput-selected-2_3_6-2NK-2",
	"blueSteel": "RadioInput-blueSteel-2_3_6-3EQrx"
};

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RadioOption; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

function RadioOption() {}
RadioOption.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  value: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.any,
  className: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func
};

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(367);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Autosave__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(235);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387);






function AutosaveSelect(_ref) {
  var autosaveProps = Object.assign({}, _ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Autosave__WEBPACK_IMPORTED_MODULE_3__["Autosave"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    Component: _Select__WEBPACK_IMPORTED_MODULE_4__["PlainSelect"],
    fieldType: "select"
  }, autosaveProps));
}

/* harmony default export */ __webpack_exports__["default"] = (AutosaveSelect);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(388);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return _Select__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _PlainSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(389);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainSelect", function() { return _PlainSelect__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return Select; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var js_components_InputGroup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(249);
/* harmony import */ var _PlainSelect__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(389);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(155);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/**
A select input wrapped in an `InputGroup` for use in forms.

This component accepts all props passed to `PlainSelect` and `InputGroup`.

All form inputs in this library must be implemented as [controlled
components](https://reactjs.org/docs/forms.html#controlled-components).
*/

function Select(_ref) {
  var inputClassName = _ref.inputClassName,
      contentRight = _ref.contentRight,
      className = _ref.className,
      description = _ref.description,
      error = _ref.error,
      helperText = _ref.helperText,
      label = _ref.label,
      required = _ref.required,
      tooltip = _ref.tooltip,
      testName = _ref.testName,
      theme = _ref.theme,
      style = _ref.style,
      selectProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["inputClassName", "contentRight", "className", "description", "error", "helperText", "label", "required", "tooltip", "testName", "theme", "style"]);

  var controlProps = {
    className: className,
    contentRight: contentRight,
    description: description,
    error: error,
    helperText: helperText,
    label: label,
    required: required,
    style: style,
    testName: testName,
    tooltip: tooltip
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(js_components_InputGroup__WEBPACK_IMPORTED_MODULE_12__["InputGroup"], controlProps, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_PlainSelect__WEBPACK_IMPORTED_MODULE_13__["default"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
    className: inputClassName,
    hasError: Boolean(error),
    theme: theme
  }, selectProps)));
}
Select.propTypes = _objectSpread(_objectSpread({}, _PlainSelect__WEBPACK_IMPORTED_MODULE_13__["default"].propTypes), {}, {
  /** This component accepts all props passed to `PlainTagListInput` and `InputGroup`. Please refer to the propTypes documentation for those components. */
  __NOTE__: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.any,

  /** @ignore - See `InputGroup` docs */
  contentRight: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** @ignore - See `InputGroup` docs */
  description: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** @ignore - See `InputGroup` docs */
  error: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** `className` attribute to pass to `PlainSelect` */
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  label: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  required: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** @ignore A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string
});
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_14__["provideTheme"])()(Select));

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlainSelect", function() { return PlainSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeOptions", function() { return normalizeOptions; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(390);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(397);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(378);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var js_util_normalizeOptionsArray__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(381);
/* harmony import */ var _Select_sass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(398);
/* harmony import */ var _Select_sass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_Select_sass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(155);





















/**
 * A Select without an `<InputGroup>` wrapper around it to support
 * `label`, `error`, etc.
 *
 * All form inputs in this library must be implemented as [controlled
 * components](https://reactjs.org/docs/forms.html#controlled-components).
 */

function PlainSelect(_ref) {
  var _classNames;

  var block = _ref.block,
      className = _ref.className,
      disabled = _ref.disabled,
      hasError = _ref.hasError,
      id = _ref.id,
      name = _ref.name,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      options = _ref.options,
      selectRef = _ref.selectRef,
      testName = _ref.testName,
      theme = _ref.theme,
      value = _ref.value,
      style = _ref.style,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4___default()(_ref, ["block", "className", "disabled", "hasError", "id", "name", "onBlur", "onChange", "onFocus", "options", "selectRef", "testName", "theme", "value", "style"]);

  var classes = classnames__WEBPACK_IMPORTED_MODULE_17___default()(_Select_sass__WEBPACK_IMPORTED_MODULE_19___default.a[theme], _Select_sass__WEBPACK_IMPORTED_MODULE_19___default.a.wrapper, className, (_classNames = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_classNames, _Select_sass__WEBPACK_IMPORTED_MODULE_19___default.a.block, block), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_classNames, _Select_sass__WEBPACK_IMPORTED_MODULE_19___default.a.hasError, hasError), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(_classNames, _Select_sass__WEBPACK_IMPORTED_MODULE_19___default.a.disabled, disabled), _classNames));
  var normalizedOptions = normalizeOptions(options);
  var selectedIndex = findOptionIndex(normalizedOptions, value);

  if (selectedIndex === -1) {
    if (true) {
      console.warn("Invalid value '".concat(value, "' supplied to <PlainSelect> with options ").concat(JSON.stringify(options), "."));
    }
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("span", {
    className: classes,
    "data-test-name": testName,
    style: style
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("select", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_2___default()({
    id: id,
    name: name,
    onChange: function onChange(evt) {
      return handleEvent(evt, normalizedOptions, _onChange);
    },
    onBlur: function onBlur(evt) {
      return handleEvent(evt, normalizedOptions, _onBlur);
    },
    onFocus: function onFocus(evt) {
      return handleEvent(evt, normalizedOptions, _onFocus);
    },
    className: _Select_sass__WEBPACK_IMPORTED_MODULE_19___default.a.select,
    disabled: disabled,
    value: selectedIndex,
    ref: selectRef
  }, rest), renderOptions(normalizedOptions)));
}
PlainSelect.defaultProps = {
  block: false,
  disabled: false,
  hasError: false
};
var optionsProps = prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.object, prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string), prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.shape({
  label: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string.isRequired,
  value: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.any,
  // not required since we allow null as a value
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.bool,
  testName: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string
}))]);
PlainSelect.propTypes = {
  /** Whether or not to render the select as full width */
  block: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.bool,

  /** Class name attribute */
  className: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** Whether or not to disable the whole input */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.bool,

  /** If true the input border will be rendered in the error color */
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.bool,

  /** id attribute for the `<select>` tag */
  id: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** name attribute for the `<select>` tag */
  name: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /**
   * Your blur handler.
   * @param {*} value - Current selected value.
   * @param {SyntheticEvent} event - The event.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func,

  /**
   * Your change handler. Update your state here.
   * @param {*} value - Current selected value.
   * @param {SyntheticEvent} event - The event.
   */
  onChange: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_16___default()(prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func, function (props) {
    return !props.disabled;
  }),

  /**
   * Your focus handler.
   * @param {*} value - Current selected value.
   * @param {SyntheticEvent} event - The event.
   */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func,

  /** Options to render in the dropdown. See the docs site for working examples */
  options: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.oneOfType([optionsProps, prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.shape({
    group: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string.isRequired,
    values: optionsProps.isRequired
  }))]).isRequired,

  /** Optional ref for attachment to the select node */
  selectRef: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.shape({
    current: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.object
  })]),

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** Current selected value. This must match one of the values supplied in `options`. */
  value: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.any
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_20__["provideTheme"])(_Select_sass__WEBPACK_IMPORTED_MODULE_19___default.a)(PlainSelect)); //
// Helper functions
//

function hasOptGroups(options) {
  return Array.isArray(options) && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(options[0]) === 'object' && options[0].hasOwnProperty('group');
}

function renderOptions(options) {
  if (hasOptGroups(options)) {
    // Need to parse out optgroups
    return options.map(function (_ref2, i) {
      var group = _ref2.group,
          values = _ref2.values;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("optgroup", {
        label: group,
        key: i
      }, values.map(function (_ref3, j) {
        var label = _ref3.label,
            disabled = _ref3.disabled,
            testName = _ref3.testName;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("option", {
          value: "".concat(i, ",").concat(j),
          disabled: disabled,
          key: "".concat(i, ",").concat(j),
          "data-test-name": testName
        }, label);
      }));
    });
  } else {
    return options.map(function (_ref4, index) {
      var label = _ref4.label,
          disabled = _ref4.disabled,
          testName = _ref4.testName;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("option", {
        value: index,
        disabled: disabled,
        key: index,
        "data-test-name": testName
      }, label);
    });
  }
}

function getOptionValue(options, index) {
  if (hasOptGroups(options)) {
    var _index$split$map = index.split(',').map(function (v) {
      return parseInt(v);
    }),
        _index$split$map2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_index$split$map, 2),
        groupIndex = _index$split$map2[0],
        valueIndex = _index$split$map2[1];

    return options[groupIndex].values[valueIndex].value;
  } else {
    return options[index].value;
  }
}

function handleEvent(evt, options, callback) {
  if (!callback) return null;
  return callback(getOptionValue(options, evt.target.value), evt);
} // Finds the index of the given value in a normalized options array
// if the options array contains optgroups the returned index will be
// a string formatted: 'groupIndex,valueIndex'


function findOptionIndex(options, value) {
  if (hasOptGroups(options)) {
    for (var groupIndex = 0; groupIndex < options.length; groupIndex++) {
      var values = options[groupIndex].values;
      var valueIndex = findOptionIndex(values, value);
      if (valueIndex > -1) return "".concat(groupIndex, ",").concat(valueIndex);
    }
  } else {
    return options.findIndex(function (option) {
      return option.value === value;
    });
  }
}

function normalizeOptions(options) {
  if (hasOptGroups(options)) {
    return options.map(function (_ref5) {
      var group = _ref5.group,
          values = _ref5.values;
      return {
        group: group,
        values: Object(js_util_normalizeOptionsArray__WEBPACK_IMPORTED_MODULE_18__["default"])(values)
      };
    });
  } else {
    return Object(js_util_normalizeOptionsArray__WEBPACK_IMPORTED_MODULE_18__["default"])(options);
  }
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(15);
var addToUnscopables = __webpack_require__(118);
var Iterators = __webpack_require__(391);
var InternalStateModule = __webpack_require__(31);
var defineIterator = __webpack_require__(392);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var createIteratorConstructor = __webpack_require__(393);
var getPrototypeOf = __webpack_require__(395);
var setPrototypeOf = __webpack_require__(97);
var setToStringTag = __webpack_require__(167);
var createNonEnumerableProperty = __webpack_require__(24);
var redefine = __webpack_require__(27);
var wellKnownSymbol = __webpack_require__(56);
var IS_PURE = __webpack_require__(35);
var Iterators = __webpack_require__(391);
var IteratorsCore = __webpack_require__(394);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(394).IteratorPrototype;
var create = __webpack_require__(119);
var createPropertyDescriptor = __webpack_require__(14);
var setToStringTag = __webpack_require__(167);
var Iterators = __webpack_require__(391);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);
var getPrototypeOf = __webpack_require__(395);
var createNonEnumerableProperty = __webpack_require__(24);
var has = __webpack_require__(21);
var wellKnownSymbol = __webpack_require__(56);
var IS_PURE = __webpack_require__(35);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(21);
var toObject = __webpack_require__(77);
var sharedKey = __webpack_require__(33);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(396);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var DOMIterables = __webpack_require__(170);
var ArrayIteratorMethods = __webpack_require__(390);
var createNonEnumerableProperty = __webpack_require__(24);
var wellKnownSymbol = __webpack_require__(56);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(399);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw{border:1px solid #aaa;font-size:1rem;font-family:Lato,Helvetica,Arial,sans-serif;background-color:#fff}.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw .Select-disabled-2_3_6-EIFVP:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw .Select-disabled-2_3_6-EIFVP:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:disabled:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:disabled:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz){background-color:#f4f4f4;border:1px solid #ccc;color:#999}.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) .Select-hasError-2_3_6-zmnup,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) .Select-hasError-2_3_6-zmnup{border-color:#ba2453;outline:none}.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):active,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):active,.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):active,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):active,.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):focus,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):focus,.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):focus,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):focus,.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):hover,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):hover,.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):hover,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):hover{border-color:#999;color:#444}.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw.Select-readOnly-2_3_6-3YOSz,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw.Select-readOnly-2_3_6-3YOSz,.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw[readonly],.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw[readonly]{color:#666;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw{color:#444;border-radius:0;padding:8px;width:100%;max-width:100%;line-height:18px}.Select-classic-2_3_6-1uO_q.Select-input-2_3_6-1dQEw::-ms-clear,.Select-classic-2_3_6-1uO_q .Select-input-2_3_6-1dQEw::-ms-clear{display:none}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw{border:1px solid #e5e6e6;font-size:1rem;font-family:Public Sans,sans-serif;background-color:#fff}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw .Select-disabled-2_3_6-EIFVP:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw .Select-disabled-2_3_6-EIFVP:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:disabled:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:disabled:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz){background-color:#f2f2f3;border:1px solid #f2f2f3;color:#8e9093}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) .Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) .Select-hasError-2_3_6-zmnup{border-color:#d33d00;outline:none}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):active,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):active,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):active,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):active,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):focus,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):focus,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):focus,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):focus,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):hover,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):hover,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):hover,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):hover{border-color:#8e9093;color:#01050e}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw.Select-readOnly-2_3_6-3YOSz,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw.Select-readOnly-2_3_6-3YOSz,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw[readonly],.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw[readonly]{color:#4d5056;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw{color:#4d5056;border-radius:3px;margin:1px;padding:11px}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):active,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):active,.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):focus,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):focus{border-width:2px;margin:0}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw{width:100%;max-width:100%;line-height:24px}.Select-blueSteel-2_3_6-c-JMg.Select-input-2_3_6-1dQEw::-ms-clear,.Select-blueSteel-2_3_6-c-JMg .Select-input-2_3_6-1dQEw::-ms-clear{display:none}.Select-classic-2_3_6-1uO_q a{color:#079bb3}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK{border:1px solid #aaa;font-size:1rem;font-family:Lato,Helvetica,Arial,sans-serif;background-color:#fff}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK .Select-disabled-2_3_6-EIFVP:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK .Select-disabled-2_3_6-EIFVP:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:disabled:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:disabled:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz){background-color:#f4f4f4;border:1px solid #ccc;color:#999}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) .Select-hasError-2_3_6-zmnup,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) .Select-hasError-2_3_6-zmnup{border-color:#ba2453;outline:none}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):active,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):active,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):active,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):active,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):focus,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):focus,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):focus,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):focus,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):hover,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):hover,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):hover,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):hover{border-color:#999;color:#444}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK.Select-readOnly-2_3_6-3YOSz,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK.Select-readOnly-2_3_6-3YOSz,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK[readonly],.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK[readonly]{color:#666;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK{color:#444;border-radius:0;position:relative;padding:0 28px 0 0;height:36px;display:inline-block}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK.Select-block-2_3_6-1nNl8,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK.Select-block-2_3_6-1nNl8{width:100%}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:after,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:after{content:\"\\25BC\";pointer-events:none;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;position:absolute;top:0;bottom:0;left:auto;right:0;width:28px;color:#999;font-size:.7rem}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK.Select-disabled-2_3_6-EIFVP:after,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK.Select-disabled-2_3_6-EIFVP:after,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:disabled:after,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:disabled:after{color:#999}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP),.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP){cursor:pointer}.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):active:after,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):active:after,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):focus:after,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):focus:after,.Select-classic-2_3_6-1uO_q.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):hover:after,.Select-classic-2_3_6-1uO_q .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):hover:after{color:#666}.Select-classic-2_3_6-1uO_q .Select-select-2_3_6-3BXN4{padding:0 28px 0 10px;height:100%;font-size:1rem;font-family:Lato,Helvetica,Arial,sans-serif;color:#666;width:calc(100% + 28px);border:none;box-shadow:none;background-color:transparent;background-image:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.Select-classic-2_3_6-1uO_q .Select-select-2_3_6-3BXN4:not(:disabled):not(.Select-disabled-2_3_6-EIFVP){cursor:pointer}.Select-classic-2_3_6-1uO_q .Select-select-2_3_6-3BXN4.Select-disabled-2_3_6-EIFVP,.Select-classic-2_3_6-1uO_q .Select-select-2_3_6-3BXN4:disabled{color:#999}.Select-classic-2_3_6-1uO_q .Select-select-2_3_6-3BXN4::-ms-expand{display:none}.Select-blueSteel-2_3_6-c-JMg a{color:#08088c}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK{border:1px solid #e5e6e6;font-size:1rem;font-family:Public Sans,sans-serif;background-color:#fff}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK .Select-disabled-2_3_6-EIFVP:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK .Select-disabled-2_3_6-EIFVP:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:disabled:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz),.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:disabled:not([readonly]):not(.Select-readOnly-2_3_6-3YOSz){background-color:#f2f2f3;border:1px solid #f2f2f3;color:#8e9093}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) .Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) .Select-hasError-2_3_6-zmnup{border-color:#d33d00;outline:none}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):active,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):active,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):active,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):active,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):focus,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):focus,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):focus,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):focus,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):hover,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):not(.Select-hasError-2_3_6-zmnup):hover,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):hover,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz) :not(.Select-hasError-2_3_6-zmnup):hover{border-color:#8e9093;color:#01050e}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK.Select-readOnly-2_3_6-3YOSz,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK.Select-readOnly-2_3_6-3YOSz,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK[readonly],.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK[readonly]{color:#4d5056;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK{color:#4d5056;border-radius:3px}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz).Select-hasError-2_3_6-zmnup,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):active,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):active,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):focus,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):not([readonly]):not(.Select-readOnly-2_3_6-3YOSz):focus{border-width:2px;margin:0}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK{position:relative;padding:0 28px 0 0;height:48px;display:inline-block}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK.Select-block-2_3_6-1nNl8,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK.Select-block-2_3_6-1nNl8{width:100%}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:after,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:after{content:\"\\25BC\";pointer-events:none;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;position:absolute;top:0;bottom:0;left:auto;right:0;width:28px;color:#8e9093;font-size:.7rem}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK.Select-disabled-2_3_6-EIFVP:after,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK.Select-disabled-2_3_6-EIFVP:after,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:disabled:after,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:disabled:after{color:#8e9093}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP),.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP){cursor:pointer}.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):active:after,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):active:after,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):focus:after,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):focus:after,.Select-blueSteel-2_3_6-c-JMg.Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):hover:after,.Select-blueSteel-2_3_6-c-JMg .Select-wrapper-2_3_6-1IcVK:not(:disabled):not(.Select-disabled-2_3_6-EIFVP):hover:after{color:#4d5056}.Select-blueSteel-2_3_6-c-JMg .Select-select-2_3_6-3BXN4{padding:0 28px 0 10px;height:100%;font-size:1rem;font-family:Public Sans,sans-serif;color:#4d5056;width:calc(100% + 28px);border:none;box-shadow:none;background-color:transparent;background-image:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.Select-blueSteel-2_3_6-c-JMg .Select-select-2_3_6-3BXN4:not(:disabled):not(.Select-disabled-2_3_6-EIFVP){cursor:pointer}.Select-blueSteel-2_3_6-c-JMg .Select-select-2_3_6-3BXN4.Select-disabled-2_3_6-EIFVP,.Select-blueSteel-2_3_6-c-JMg .Select-select-2_3_6-3BXN4:disabled{color:#8e9093}.Select-blueSteel-2_3_6-c-JMg .Select-select-2_3_6-3BXN4::-ms-expand{display:none}", ""]);

// exports
exports.locals = {
	"classic": "Select-classic-2_3_6-1uO_q",
	"input": "Select-input-2_3_6-1dQEw",
	"readOnly": "Select-readOnly-2_3_6-3YOSz",
	"disabled": "Select-disabled-2_3_6-EIFVP",
	"hasError": "Select-hasError-2_3_6-zmnup",
	"blueSteel": "Select-blueSteel-2_3_6-c-JMg",
	"wrapper": "Select-wrapper-2_3_6-1IcVK",
	"block": "Select-block-2_3_6-1nNl8",
	"select": "Select-select-2_3_6-3BXN4"
};

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(367);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Autosave__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(235);
/* harmony import */ var _TextArea__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(401);






function AutosaveTextArea(_ref) {
  var autosaveProps = Object.assign({}, _ref);

  if (autosaveProps.number) {
    console.warn('Invalid `number` prop value supplied to <AutosaveTextArea>. This component always treats values as strings.');
    autosaveProps.number = false;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Autosave__WEBPACK_IMPORTED_MODULE_3__["Autosave"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    Component: _TextArea__WEBPACK_IMPORTED_MODULE_4__["PlainTextArea"],
    fieldType: "textarea"
  }, autosaveProps));
}

/* harmony default export */ __webpack_exports__["default"] = (AutosaveTextArea);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TextArea__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(402);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextArea", function() { return _TextArea__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _PlainTextArea__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainTextArea", function() { return _PlainTextArea__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextArea", function() { return TextArea; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var js_components_InputGroup__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(249);
/* harmony import */ var js_components_RemainingChars__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(262);
/* harmony import */ var _PlainTextArea__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(403);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(155);















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







/**
A textarea input wrapped in an `InputGroup` for use in forms.

This component accepts all props passed to `PlainTextArea` and `InputGroup`.

All form inputs in this library must be implemented as [controlled
components](https://reactjs.org/docs/forms.html#controlled-components).
*/

var TextArea = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(TextArea, _React$Component);

  var _super = _createSuper(TextArea);

  function TextArea() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, TextArea);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(TextArea, [{
    key: "focus",
    value:
    /**
     * Focuses the underlying TextArea component
     */
    function focus() {
      this.instance.focus();
    }
    /**
     * Selects the underlying TextArea component
     */

  }, {
    key: "select",
    value: function select() {
      this.instance.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          contentRight = _this$props.contentRight,
          description = _this$props.description,
          error = _this$props.error,
          helperText = _this$props.helperText,
          inputClassName = _this$props.inputClassName,
          inputTestName = _this$props.inputTestName,
          label = _this$props.label,
          maxChars = _this$props.maxChars,
          required = _this$props.required,
          style = _this$props.style,
          testName = _this$props.testName,
          tooltip = _this$props.tooltip,
          theme = _this$props.theme,
          textareaProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8___default()(_this$props, ["className", "contentRight", "description", "error", "helperText", "inputClassName", "inputTestName", "label", "maxChars", "required", "style", "testName", "tooltip", "theme"]);

      var value = textareaProps.value,
          disabled = textareaProps.disabled;
      var labelRight = contentRight;

      if (maxChars && value != null && !disabled) {
        labelRight = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement(js_components_RemainingChars__WEBPACK_IMPORTED_MODULE_19__["CharCountDisplay"], {
          max: maxChars,
          count: value.length
        });
      }

      var controlProps = {
        contentRight: labelRight,
        className: className,
        description: description,
        error: error,
        helperText: helperText,
        label: label,
        required: required,
        style: style,
        testName: testName,
        tooltip: tooltip,
        theme: theme
      };
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement(js_components_InputGroup__WEBPACK_IMPORTED_MODULE_18__["InputGroup"], controlProps, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement(_PlainTextArea__WEBPACK_IMPORTED_MODULE_20__["default"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_7___default()({
        className: inputClassName,
        testName: inputTestName,
        hasError: Boolean(error),
        ref: function ref(node) {
          _this.instance = node;
        }
      }, textareaProps)));
    }
  }]);

  return TextArea;
}(react__WEBPACK_IMPORTED_MODULE_16___default.a.Component);
TextArea.propTypes = _objectSpread(_objectSpread({}, _PlainTextArea__WEBPACK_IMPORTED_MODULE_20__["default"].PropTypes), {}, {
  /** This component accepts all props passed to [`<PlainTextArea>`](#!/PlainTextArea) and [`<InputGroup>`](#!/InputGroup). Please refer to the propTypes documentation for those components. */
  __NOTE__: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.any,

  /** @ignore - See `InputGroup` docs */
  contentRight: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.node,

  /** @ignore - See `InputGroup` docs */
  description: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.node,

  /** @ignore - See `InputGroup` docs */
  error: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** @ignore - See `InputGroup` docs */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.node,

  /** `className` attribute to pass to `PlainTextArea` */
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** PlainTextArea test name for automation */
  inputTestName: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** @ignore - See `InputGroup` docs */
  label: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** If provided the number of remaining characters will be passed in the `InputGroup` `contentRight` prop. If value is longer than maxLength then the remaining character count will be rendered in error color. */
  maxChars: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.number,

  /** @ignore - See `InputGroup` docs */
  required: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.bool,

  /** @ignore - See `InputGroup` docs */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_17___default.a.string
});
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_21__["provideTheme"])()(TextArea));

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlainTextArea", function() { return PlainTextArea; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _TextArea_sass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(404);
/* harmony import */ var _TextArea_sass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_TextArea_sass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(155);











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







/**
 * A basic TextArea without an `<InputGroup>` wrapper around it.
 *
 * All form inputs in this library must be implemented as [controlled
 * components](https://reactjs.org/docs/forms.html#controlled-components).
 */

var PlainTextArea = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(PlainTextArea, _React$Component);

  var _super = _createSuper(PlainTextArea);

  function PlainTextArea() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, PlainTextArea);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(PlainTextArea, [{
    key: "focus",
    value:
    /**
     * Focuses the underlying textarea component
     */
    function focus() {
      this.instance.focus();
    }
    /**
     * Selects the underlying textarea component
     */

  }, {
    key: "select",
    value: function select() {
      this.instance.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          dir = _this$props.dir,
          disabled = _this$props.disabled,
          hasError = _this$props.hasError,
          id = _this$props.id,
          maxLength = _this$props.maxLength,
          name = _this$props.name,
          _onBlur = _this$props.onBlur,
          _onFocus = _this$props.onFocus,
          _onChange = _this$props.onChange,
          onClick = _this$props.onClick,
          placeholder = _this$props.placeholder,
          autoFocus = _this$props.autoFocus,
          readOnly = _this$props.readOnly,
          rows = _this$props.rows,
          testName = _this$props.testName,
          value = _this$props.value,
          style = _this$props.style,
          theme = _this$props.theme,
          rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default()(_this$props, ["className", "dir", "disabled", "hasError", "id", "maxLength", "name", "onBlur", "onFocus", "onChange", "onClick", "placeholder", "autoFocus", "readOnly", "rows", "testName", "value", "style", "theme"]);

      var classes = classnames__WEBPACK_IMPORTED_MODULE_13___default()(_TextArea_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme], _TextArea_sass__WEBPACK_IMPORTED_MODULE_14___default.a.textarea, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, _TextArea_sass__WEBPACK_IMPORTED_MODULE_14___default.a.hasError, hasError));
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("textarea", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
        className: classes,
        style: style,
        dir: dir,
        disabled: disabled,
        id: id,
        maxLength: maxLength,
        name: name,
        "data-test-name": testName,
        onBlur: function onBlur(evt) {
          return _onBlur ? _onBlur(evt.target.value, evt) : null;
        },
        onFocus: function onFocus(evt) {
          return _onFocus ? _onFocus(evt.target.value, evt) : null;
        },
        onChange: function onChange(evt) {
          return _onChange ? _onChange(evt.target.value, evt) : null;
        },
        onClick: onClick,
        placeholder: placeholder,
        autoFocus: autoFocus,
        readOnly: readOnly,
        rows: rows,
        value: value,
        ref: function ref(node) {
          _this.instance = node;
        }
      }, rest));
    }
  }]);

  return PlainTextArea;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);
PlainTextArea.defaultProps = {
  dir: 'auto',
  disabled: false,
  hasError: false,
  readOnly: false,
  rows: 3
};
PlainTextArea.propTypes = {
  /** Class name for the textarea */
  className: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Direction for the dir attribute*/
  dir: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOf(['auto', 'ltr', 'rtl']),

  /** whether or not to disable the textarea */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to render an error border around the textarea */
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** id attribute for the textarea */
  id: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** maxLength attribute for the textarea */
  maxLength: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.number,

  /** name attribute for the textarea */
  name: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /**
   * Your blur handler.
   * @param {string} value - Current textarea value.
   * @param {SyntheticEvent} event - The event.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /**
   * Your change handler. Update your state here.
   * @param {string} value - Current textarea value.
   * @param {SyntheticEvent} event - The event.
   */
  onChange: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default()(prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func, function (props) {
    return !(props.readOnly || props.disabled);
  }),

  /**
   * Your click handler.
   * @param {SyntheticEvent} event - The click event.
   */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /**
   * Your focus handler.
   * @param {string} value - Current textarea value.
   * @param {SyntheticEvent} event - The event.
   */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /** Placeholder text for the textarea */
  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Whether the input is initially focused when mounted */
  autoFocus: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not the textarea is readOnly */
  readOnly: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Rows attribute for the textarea. (Sets the height in rows) */
  rows: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.number,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Current value of the field. */
  value: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_15__["provideTheme"])(_TextArea_sass__WEBPACK_IMPORTED_MODULE_14___default.a)(PlainTextArea));

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(405);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N{border:1px solid #aaa;font-size:1rem;font-family:Lato,Helvetica,Arial,sans-serif;background-color:#fff}.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N .TextArea-disabled-2_3_6-392lC:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N .TextArea-disabled-2_3_6-392lC:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:disabled:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:disabled:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM){background-color:#f4f4f4;border:1px solid #ccc;color:#999}.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) .TextArea-hasError-2_3_6-1oW9N,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) .TextArea-hasError-2_3_6-1oW9N{border-color:#ba2453;outline:none}.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):hover{border-color:#999;color:#444}.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N.TextArea-readOnly-2_3_6-2KiJM,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N.TextArea-readOnly-2_3_6-2KiJM,.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N[readonly],.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N[readonly]{color:#666;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N{color:#444;border-radius:0;padding:8px;width:100%;max-width:100%;line-height:18px}.TextArea-classic-2_3_6-3zMUR.TextArea-input-2_3_6-2El0N::-ms-clear,.TextArea-classic-2_3_6-3zMUR .TextArea-input-2_3_6-2El0N::-ms-clear{display:none}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N{border:1px solid #e5e6e6;font-size:1rem;font-family:Public Sans,sans-serif;background-color:#fff}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N .TextArea-disabled-2_3_6-392lC:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N .TextArea-disabled-2_3_6-392lC:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:disabled:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:disabled:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM){background-color:#f2f2f3;border:1px solid #f2f2f3;color:#8e9093}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) .TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) .TextArea-hasError-2_3_6-1oW9N{border-color:#d33d00;outline:none}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):hover{border-color:#8e9093;color:#01050e}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N.TextArea-readOnly-2_3_6-2KiJM,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N.TextArea-readOnly-2_3_6-2KiJM,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N[readonly],.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N[readonly]{color:#4d5056;background-color:transparent;border:none;margin:0;padding:0;word-break:break-word;height:32px}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N{color:#4d5056;border-radius:3px;margin:1px;padding:11px}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):active,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):active,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):focus,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):focus{border-width:2px;margin:0}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N{width:100%;max-width:100%;line-height:24px}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-input-2_3_6-2El0N::-ms-clear,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-input-2_3_6-2El0N::-ms-clear{display:none}.TextArea-classic-2_3_6-3zMUR a{color:#079bb3}.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0{border:1px solid #aaa;font-size:1rem;font-family:Lato,Helvetica,Arial,sans-serif;background-color:#fff}.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0 .TextArea-disabled-2_3_6-392lC:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0 .TextArea-disabled-2_3_6-392lC:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:disabled:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:disabled:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM){background-color:#f4f4f4;border:1px solid #ccc;color:#999}.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) .TextArea-hasError-2_3_6-1oW9N,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) .TextArea-hasError-2_3_6-1oW9N{border-color:#ba2453;outline:none}.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):hover{border-color:#999;color:#444}.TextArea-classic-2_3_6-3zMUR.TextArea-textarea-2_3_6-2Q4p0,.TextArea-classic-2_3_6-3zMUR .TextArea-textarea-2_3_6-2Q4p0{color:#444;border-radius:0;padding:8px;display:block;width:100%;max-width:100%}.TextArea-blueSteel-2_3_6-3RxzZ a{color:#08088c}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0{border:1px solid #e5e6e6;font-size:1rem;font-family:Public Sans,sans-serif;background-color:#fff}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0 .TextArea-disabled-2_3_6-392lC:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0 .TextArea-disabled-2_3_6-392lC:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:disabled:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM),.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:disabled:not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM){background-color:#f2f2f3;border:1px solid #f2f2f3;color:#8e9093}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) .TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) .TextArea-hasError-2_3_6-1oW9N{border-color:#d33d00;outline:none}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):active,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):focus,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):not(.TextArea-hasError-2_3_6-1oW9N):hover,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM) :not(.TextArea-hasError-2_3_6-1oW9N):hover{border-color:#8e9093;color:#01050e}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0{color:#4d5056;border-radius:3px;margin:1px;padding:11px}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM).TextArea-hasError-2_3_6-1oW9N,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):active,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):active,.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):focus,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0:not(:disabled):not(.TextArea-disabled-2_3_6-392lC):not([readonly]):not(.TextArea-readOnly-2_3_6-2KiJM):focus{border-width:2px;margin:0}.TextArea-blueSteel-2_3_6-3RxzZ.TextArea-textarea-2_3_6-2Q4p0,.TextArea-blueSteel-2_3_6-3RxzZ .TextArea-textarea-2_3_6-2Q4p0{display:block;width:100%;max-width:100%}", ""]);

// exports
exports.locals = {
	"classic": "TextArea-classic-2_3_6-3zMUR",
	"input": "TextArea-input-2_3_6-2El0N",
	"readOnly": "TextArea-readOnly-2_3_6-2KiJM",
	"disabled": "TextArea-disabled-2_3_6-392lC",
	"hasError": "TextArea-hasError-2_3_6-1oW9N",
	"blueSteel": "TextArea-blueSteel-2_3_6-3RxzZ",
	"textarea": "TextArea-textarea-2_3_6-2Q4p0"
};

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(367);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Autosave__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(235);
/* harmony import */ var _TagListInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(407);






function AutosaveTagList(_ref) {
  var autosaveProps = Object.assign({}, _ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Autosave__WEBPACK_IMPORTED_MODULE_3__["Autosave"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    Component: _TagListInput__WEBPACK_IMPORTED_MODULE_4__["PlainTagListInput"],
    fieldType: "taglist"
  }, autosaveProps));
}

/* harmony default export */ __webpack_exports__["default"] = (AutosaveTagList);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TagListInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(408);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagListInput", function() { return _TagListInput__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _PlainTagListInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(409);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainTagListInput", function() { return _PlainTagListInput__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _AutosuggestTagListInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(455);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AutosuggestTagListInput", function() { return _AutosuggestTagListInput__WEBPACK_IMPORTED_MODULE_2__["default"]; });








/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TagListInput", function() { return TagListInput; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var js_components_InputGroup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(249);
/* harmony import */ var _PlainTagListInput__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(409);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(155);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/**
An input for editing an array of tags wrapped in an `InputGroup` for use in forms.

This component accepts all props passed to `PlainTagListInput` and `InputGroup`.

All form inputs in this library must be implemented as [controlled
components](https://reactjs.org/docs/forms.html#controlled-components).
*/

function TagListInput(_ref) {
  var className = _ref.className,
      contentRight = _ref.contentRight,
      description = _ref.description,
      error = _ref.error,
      helperText = _ref.helperText,
      inputClassName = _ref.inputClassName,
      label = _ref.label,
      required = _ref.required,
      style = _ref.style,
      testName = _ref.testName,
      tooltip = _ref.tooltip,
      theme = _ref.theme,
      inputProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["className", "contentRight", "description", "error", "helperText", "inputClassName", "label", "required", "style", "testName", "tooltip", "theme"]);

  var controlProps = {
    className: className,
    contentRight: contentRight,
    description: description,
    error: error,
    helperText: helperText,
    label: label,
    required: required,
    style: style,
    testName: testName,
    theme: theme,
    tooltip: tooltip
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(js_components_InputGroup__WEBPACK_IMPORTED_MODULE_12__["InputGroup"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
    theme: theme
  }, controlProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_PlainTagListInput__WEBPACK_IMPORTED_MODULE_13__["default"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
    theme: theme,
    className: inputClassName,
    testName: testName,
    hasError: Boolean(error)
  }, inputProps)));
}
TagListInput.propTypes = _objectSpread(_objectSpread({}, _PlainTagListInput__WEBPACK_IMPORTED_MODULE_13__["default"].propTypes), {}, {
  /** This component accepts all props passed to [`<PlainTagListInput>`](#!/PlainTagListInput) and [`<InputGroup>`](#!/InputGroup). Please refer to the propTypes documentation for those components. */
  __NOTE__: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.any,

  /** @ignore - See `InputGroup` docs */
  contentRight: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** @ignore - See `InputGroup` docs */
  description: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** @ignore - See `InputGroup` docs */
  error: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** className prop to pass to `PlainInputGroup` */
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  label: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  required: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** @ignore - See `InputGroup` docs */
  style: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** @ignore - See `InputGroup` docs */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** @ignore - See `InputGroup` docs */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string
});
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_14__["provideTheme"])()(TagListInput));

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlainTagListInput", function() { return PlainTagListInput; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(178);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(410);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(414);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(426);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(428);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(430);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(431);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(434);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(435);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(436);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(437);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(438);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(439);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(440);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(441);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(442);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(443);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(444);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(445);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(54);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(446);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(390);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(397);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(447);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(2);
/* harmony import */ var js_components_Tag__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(448);
/* harmony import */ var _Placeholder__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(452);
/* harmony import */ var _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(453);
/* harmony import */ var _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_TagListInput_sass__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(155);










































function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










/**
 * A TagList combined with an input for entering new tags.
 * `<InputGroup>` not included.
 *
 * All form inputs in this library must be implemented as [controlled
 * components](https://reactjs.org/docs/forms.html#controlled-components).
 */

var PlainTagListInput = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(PlainTagListInput, _React$Component);

  var _super = _createSuper(PlainTagListInput);

  function PlainTagListInput() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, PlainTagListInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "state", {
      inputValue: '',
      isInputFocused: false,
      isTagFocused: false
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "inputRef", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "containerRef", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "addTags", function () {
      _this.setState({
        inputValue: ''
      });

      _this.props.onChange(_this.generateCombinedTags());
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "formatTag", function (value) {
      if (_this.tagFormat === 'string') {
        return value;
      }

      return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()({}, _this.props.labelKey, value);
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "generateCombinedTags", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          allowDuplicateTags = _this$props.allowDuplicateTags,
          labelKey = _this$props.labelKey;
      var combinedTags = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default()(value), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default()(_this.parsedInputTags));

      if (allowDuplicateTags) {
        return combinedTags;
      }

      var uniqueTags = new Set();
      var callbackTags = [];
      combinedTags.forEach(function (tag) {
        var tagValue = _this.tagFormat === 'string' ? tag : tag[labelKey];

        if (uniqueTags.has(tagValue)) {
          return;
        }

        uniqueTags.add(tagValue);
        callbackTags.push(tag);
      });
      return callbackTags;
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleChange", function (evt) {
      _this.setState({
        inputValue: evt.currentTarget.value
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleKeyUp", function (evt) {
      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_45__["default"])(evt).is('comma')) {
        _this.addTags();
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleKeyDown", function (evt) {
      var inputValue = _this.state.inputValue;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          value = _this$props2.value,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          _this$props2$onKeyDow = _this$props2.onKeyDown,
          onKeyDown = _this$props2$onKeyDow === void 0 ? function () {
        return null;
      } : _this$props2$onKeyDow;
      if (disabled || readOnly) return;

      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_45__["default"])(evt).is('enter') && !!inputValue.trim().length) {
        evt.preventDefault(); // Prevents submit if in a form

        _this.addTags();
      } else if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_45__["default"])(evt).is('backspace') && inputValue === '') {
        onChange(value.slice(0, value.length - 1));
      }

      onKeyDown(evt);
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleInputFocus", function (evt) {
      // NOTE: It should be impossible to have any text in the input
      // when this function is called since it's cleared onBlur.
      _this.setState({
        isInputFocused: true
      });

      if (_this.props.inputProps.onFocus) {
        return _this.props.inputProps.onFocus(evt);
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(_this.props.value, evt);
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleContainerFocus", function () {
      _this.setState({
        isInputFocused: true
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleContainerBlur", function (evt) {
      var relatedTarget = evt.nativeEvent.relatedTarget; //Only blur if we are not focusing an element within the container

      if (!relatedTarget || !_this.containerRef.contains(relatedTarget)) {
        _this.setState({
          isInputFocused: false
        });
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleInputBlur", function (evt) {
      if (_this.props.inputProps.onBlur) {
        return _this.props.inputProps.onBlur(evt);
      }

      var combinedTags = _this.generateCombinedTags();

      if (_this.state.inputValue.trim().length > 0) {
        _this.props.onChange(combinedTags);

        _this.setState({
          inputValue: ''
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(combinedTags, evt);
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleRemoveItem", function (item, index) {
      var value = _this.props.value;

      _this.props.onChange([].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default()(value.slice(0, index)), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default()(value.slice(index + 1, value.length))));
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "setInputRef", function (element) {
      _this.inputRef = element;

      if (_this.props.inputProps && _this.props.inputProps.ref) {
        _this.props.inputProps.ref(element);
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "focusInput", function () {
      setTimeout(function () {
        return _this.inputRef.focus();
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6___default()(_this), "handleClick", function () {
      if (_this.props.onClick) _this.props.onClick();

      _this.focusInput();
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(PlainTagListInput, [{
    key: "tagFormat",
    get: function get() {
      return _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(this.props.value[0]) === 'object' ? 'object' : 'string';
    }
  }, {
    key: "parsedInputTags",
    get: function get() {
      var _this2 = this;

      return this.state.inputValue.split(',').map(function (v) {
        var text = v.trim();

        if (!text) {
          return null;
        }

        return _this2.formatTag(text);
      }).filter(Boolean); // strip empty values
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var _this$props3 = this.props,
          dir = _this$props3.dir,
          disabled = _this$props3.disabled,
          hasError = _this$props3.hasError,
          value = _this$props3.value,
          name = _this$props3.name,
          className = _this$props3.className,
          testName = _this$props3.testName,
          maxLength = _this$props3.maxLength,
          id = _this$props3.id,
          style = _this$props3.style,
          autoFocus = _this$props3.autoFocus,
          labelKey = _this$props3.labelKey,
          inputProps = _this$props3.inputProps,
          theme = _this$props3.theme,
          placeholder = _this$props3.placeholder,
          readOnly = _this$props3.readOnly,
          inputBlock = _this$props3.inputBlock,
          allowAddingTags = _this$props3.allowAddingTags,
          alwaysShowPlaceholder = _this$props3.alwaysShowPlaceholder,
          fixedTags = _this$props3.fixedTags;
      var _this$state = this.state,
          isInputFocused = _this$state.isInputFocused,
          isTagFocused = _this$state.isTagFocused;
      var classes = classnames__WEBPACK_IMPORTED_MODULE_44___default()(_TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a[theme], _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.container, className, (_classNames = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_classNames, _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.hasError, hasError), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_classNames, _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_classNames, _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.isInputFocused, isInputFocused), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()(_classNames, _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.readonly, readOnly), _classNames));
      var hasPlaceholder = Boolean(placeholder) && !isInputFocused && (alwaysShowPlaceholder || value.length === 0);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_41___default.a.createElement("div", {
        tabIndex: "-1" //Allows for event to have relatedTarget on focus change
        ,
        className: classes,
        "data-test-name": testName,
        style: style,
        onClick: this.handleClick,
        onBlur: this.handleContainerBlur,
        onFocus: this.handleContainerFocus,
        onMouseDown: this.handleMouseDown,
        ref: function ref(element) {
          return _this3.containerRef = element;
        }
      }, fixedTags && fixedTags.map(function (item, index) {
        var label = typeof item === 'string' ? item : item[labelKey];
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_41___default.a.createElement(js_components_Tag__WEBPACK_IMPORTED_MODULE_46__["Tag"], {
          key: "fixed-".concat(index),
          className: _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.tag,
          color: "primary",
          theme: theme
        }, label);
      }), value.map(function (item, index) {
        var label = typeof item === 'string' ? item : item[labelKey];
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_41___default.a.createElement(js_components_Tag__WEBPACK_IMPORTED_MODULE_46__["Tag"], {
          key: index,
          className: _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.tag,
          onRemove: disabled || readOnly ? null : function () {
            return _this3.handleRemoveItem(item, index);
          },
          color: "primary",
          theme: theme,
          onFocus: function onFocus() {
            return _this3.setState({
              isTagFocused: true
            });
          },
          onBlur: function onBlur() {
            return _this3.setState({
              isTagFocused: false
            });
          }
        }, label);
      }), hasPlaceholder && !readOnly ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_41___default.a.createElement(_Placeholder__WEBPACK_IMPORTED_MODULE_47__["default"], {
        theme: theme
      }, placeholder) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_41___default.a.createElement("input", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
        id: id,
        name: name,
        dir: dir,
        disabled: disabled || readOnly,
        className: classnames__WEBPACK_IMPORTED_MODULE_44___default()(_TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.input, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10___default()({}, _TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a.noCursor, !allowAddingTags)),
        value: this.state.inputValue,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        maxLength: !allowAddingTags ? 0 : maxLength,
        autoFocus: autoFocus
      }, inputProps, {
        onBlur: this.handleInputBlur,
        onFocus: this.handleInputFocus,
        ref: this.setInputRef
      })));
    }
  }]);

  return PlainTagListInput;
}(react__WEBPACK_IMPORTED_MODULE_41___default.a.Component);
PlainTagListInput.defaultProps = {
  allowDuplicateTags: false,
  allowAddingTags: true,
  dir: 'auto',
  labelKey: 'label',
  inputProps: {},
  readOnly: false,
  inputBlock: false,
  hidePlaceholder: false
};
PlainTagListInput.propTypes = {
  /** Whether or not to allow duplicate tags. */
  allowDuplicateTags: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.bool,

  /** Wheter or not to allow adding new tags. */
  allowAddingTags: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.bool,

  /** Whether the input field should be full-width. */
  inputBlock: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.bool,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.string,

  /** Direction for the dir attribute*/
  dir: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.oneOf(['auto', 'ltr', 'rtl']),

  /** Disables the input and removes x links from all `Tag` components. */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.bool,

  /** Whether or not to outline this field in magenta. */
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.bool,

  /** When true, placeholder appears even when value is not empty */
  alwaysShowPlaceholder: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.bool,

  /** Sets the id attribute on the inner `<input>` */
  id: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.string,

  /** Additional props to set on the inner `<input>`. These will take precedence over other props on `<input>`. */
  inputProps: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.any,

  /** If provided this attribute will be set on the inner `<input>` which will make it impossible to type more than maxLength characters. */
  maxLength: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.number,

  /** Sets the name attribute on the inner `<input>` */
  name: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.string,

  /**
   * Your blur handler. Note that if the input has text in it an
   * `onChange` event will be triggered immediately before `onBlur`.
   * If you intend to validate the field at this point you should use
   * the value returned by this function
   * @param {string[]} value - An array of your tags.
   * @param {SyntheticEvent} event - The event.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.func,

  /**
   * Change handler for your tag list. Called whenever a tag is added to the
   * list. This can happen when the user types a comma, ENTER, DELETE, or blurs
   * the input field while text is in it. (Update your state here)
   * @param {value} string[] - An array of strings no longer than 128 chars.
   */
  onChange: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_43___default()(prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.func, function (props) {
    return !props.disabled;
  }),

  /** Callback that is fired when the user clicks the item */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.func,

  /**
   * Your focus handler.
   * @param {string[]} value - An array of your tags.
   * @param {SyntheticEvent} event - The event.
   */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.func,

  /** Whether or not the input is readOnly.
  Note: readOnly inputs have a different visual treatment */
  readOnly: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.object,

  /** Whether the input is initially focused when mounted */
  autoFocus: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.bool,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.string,

  /**
   * A list of tags as strings or objects that can be passed into a Tag as props.
   * You should update this value onChange.
   */
  value: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.string), prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.object)]).isRequired,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.string,

  /**
   * When a tag is specified in the value as an object, this tells which key in
   * the item object to use for the `Tag` text.
   */
  labelKey: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.string,

  /** Placeholder tag content - renders as a `Tag` */
  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.node,

  /** Tags that cannot be interacted with or removed */
  fixedTags: prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.string), prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_42___default.a.object)])
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_49__["provideTheme"])(_TagListInput_sass__WEBPACK_IMPORTED_MODULE_48___default.a)(PlainTagListInput));

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(411);

var iterableToArray = __webpack_require__(412);

var unsupportedIterableToArray = __webpack_require__(150);

var nonIterableSpread = __webpack_require__(413);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(151);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 412 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 413 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(415);
var collectionStrong = __webpack_require__(424);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var global = __webpack_require__(8);
var isForced = __webpack_require__(50);
var redefine = __webpack_require__(27);
var InternalMetadataModule = __webpack_require__(416);
var iterate = __webpack_require__(418);
var anInstance = __webpack_require__(422);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(12);
var checkCorrectnessOfIteration = __webpack_require__(423);
var setToStringTag = __webpack_require__(167);
var inheritIfRequired = __webpack_require__(96);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(37);
var isObject = __webpack_require__(20);
var has = __webpack_require__(21);
var defineProperty = __webpack_require__(25).f;
var uid = __webpack_require__(36);
var FREEZING = __webpack_require__(417);

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(26);
var isArrayIteratorMethod = __webpack_require__(419);
var toLength = __webpack_require__(45);
var bind = __webpack_require__(76);
var getIteratorMethod = __webpack_require__(420);
var iteratorClose = __webpack_require__(421);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(56);
var Iterators = __webpack_require__(391);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(63);
var Iterators = __webpack_require__(391);
var wellKnownSymbol = __webpack_require__(56);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(26);

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(56);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(25).f;
var create = __webpack_require__(119);
var redefineAll = __webpack_require__(425);
var bind = __webpack_require__(76);
var anInstance = __webpack_require__(422);
var iterate = __webpack_require__(418);
var defineIterator = __webpack_require__(392);
var setSpecies = __webpack_require__(99);
var DESCRIPTORS = __webpack_require__(11);
var fastKey = __webpack_require__(416).fastKey;
var InternalStateModule = __webpack_require__(31);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(27);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var collectionAddAll = __webpack_require__(427);

// `Set.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  addAll: function addAll(/* ...elements */) {
    return collectionAddAll.apply(this, arguments);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);

// https://github.com/tc39/collection-methods
module.exports = function (/* ...elements */) {
  var set = anObject(this);
  var adder = aFunction(set.add);
  for (var k = 0, len = arguments.length; k < len; k++) {
    adder.call(set, arguments[k]);
  }
  return set;
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var collectionDeleteAll = __webpack_require__(429);

// `Set.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  deleteAll: function deleteAll(/* ...elements */) {
    return collectionDeleteAll.apply(this, arguments);
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);

// https://github.com/tc39/collection-methods
module.exports = function (/* ...elements */) {
  var collection = anObject(this);
  var remover = aFunction(collection['delete']);
  var allDeleted = true;
  var wasDeleted;
  for (var k = 0, len = arguments.length; k < len; k++) {
    wasDeleted = remover.call(collection, arguments[k]);
    allDeleted = allDeleted && wasDeleted;
  }
  return !!allDeleted;
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var speciesConstructor = __webpack_require__(69);
var iterate = __webpack_require__(418);

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  difference: function difference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    var remover = aFunction(newSet['delete']);
    iterate(iterable, function (value) {
      remover.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var bind = __webpack_require__(76);
var getSetIterator = __webpack_require__(432);
var iterate = __webpack_require__(418);

// `Set.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  every: function every(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return !iterate(iterator, function (value, stop) {
      if (!boundFunction(value, value, set)) return stop();
    }, { IS_ITERATOR: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(35);
var getIterator = __webpack_require__(433);

module.exports = IS_PURE ? getIterator : function (it) {
  // eslint-disable-next-line no-undef -- safe
  return Set.prototype.values.call(it);
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(26);
var getIteratorMethod = __webpack_require__(420);

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var bind = __webpack_require__(76);
var speciesConstructor = __webpack_require__(69);
var getSetIterator = __webpack_require__(432);
var iterate = __webpack_require__(418);

// `Set.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  filter: function filter(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var adder = aFunction(newSet.add);
    iterate(iterator, function (value) {
      if (boundFunction(value, value, set)) adder.call(newSet, value);
    }, { IS_ITERATOR: true });
    return newSet;
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var bind = __webpack_require__(76);
var getSetIterator = __webpack_require__(432);
var iterate = __webpack_require__(418);

// `Set.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  find: function find(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (value, stop) {
      if (boundFunction(value, value, set)) return stop(value);
    }, { IS_ITERATOR: true, INTERRUPTED: true }).result;
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var speciesConstructor = __webpack_require__(69);
var iterate = __webpack_require__(418);

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  intersection: function intersection(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var hasCheck = aFunction(set.has);
    var adder = aFunction(newSet.add);
    iterate(iterable, function (value) {
      if (hasCheck.call(set, value)) adder.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var iterate = __webpack_require__(418);

// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  isDisjointFrom: function isDisjointFrom(iterable) {
    var set = anObject(this);
    var hasCheck = aFunction(set.has);
    return !iterate(iterable, function (value, stop) {
      if (hasCheck.call(set, value) === true) return stop();
    }, { INTERRUPTED: true }).stopped;
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var getIterator = __webpack_require__(433);
var iterate = __webpack_require__(418);

// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  isSubsetOf: function isSubsetOf(iterable) {
    var iterator = getIterator(this);
    var otherSet = anObject(iterable);
    var hasCheck = otherSet.has;
    if (typeof hasCheck != 'function') {
      otherSet = new (getBuiltIn('Set'))(iterable);
      hasCheck = aFunction(otherSet.has);
    }
    return !iterate(iterator, function (value, stop) {
      if (hasCheck.call(otherSet, value) === false) return stop();
    }, { IS_ITERATOR: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var iterate = __webpack_require__(418);

// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  isSupersetOf: function isSupersetOf(iterable) {
    var set = anObject(this);
    var hasCheck = aFunction(set.has);
    return !iterate(iterable, function (value, stop) {
      if (hasCheck.call(set, value) === false) return stop();
    }, { INTERRUPTED: true }).stopped;
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var getSetIterator = __webpack_require__(432);
var iterate = __webpack_require__(418);

// `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  join: function join(separator) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var sep = separator === undefined ? ',' : String(separator);
    var result = [];
    iterate(iterator, result.push, { that: result, IS_ITERATOR: true });
    return result.join(sep);
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var bind = __webpack_require__(76);
var speciesConstructor = __webpack_require__(69);
var getSetIterator = __webpack_require__(432);
var iterate = __webpack_require__(418);

// `Set.prototype.map` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  map: function map(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var adder = aFunction(newSet.add);
    iterate(iterator, function (value) {
      adder.call(newSet, boundFunction(value, value, set));
    }, { IS_ITERATOR: true });
    return newSet;
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var getSetIterator = __webpack_require__(432);
var iterate = __webpack_require__(418);

// `Set.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    aFunction(callbackfn);
    iterate(iterator, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = callbackfn(accumulator, value, value, set);
      }
    }, { IS_ITERATOR: true });
    if (noInitial) throw TypeError('Reduce of empty set with no initial value');
    return accumulator;
  }
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var bind = __webpack_require__(76);
var getSetIterator = __webpack_require__(432);
var iterate = __webpack_require__(418);

// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  some: function some(callbackfn /* , thisArg */) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (value, stop) {
      if (boundFunction(value, value, set)) return stop();
    }, { IS_ITERATOR: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var speciesConstructor = __webpack_require__(69);
var iterate = __webpack_require__(418);

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  symmetricDifference: function symmetricDifference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    var remover = aFunction(newSet['delete']);
    var adder = aFunction(newSet.add);
    iterate(iterable, function (value) {
      remover.call(newSet, value) || adder.call(newSet, value);
    });
    return newSet;
  }
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var speciesConstructor = __webpack_require__(69);
var iterate = __webpack_require__(418);

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: IS_PURE }, {
  union: function union(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    iterate(iterable, aFunction(newSet.add), { that: newSet });
    return newSet;
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(72).charAt;
var InternalStateModule = __webpack_require__(31);
var defineIterator = __webpack_require__(392);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var isObject = __webpack_require__(20);
var isArray = __webpack_require__(79);
var toAbsoluteIndex = __webpack_require__(47);
var toLength = __webpack_require__(45);
var toIndexedObject = __webpack_require__(15);
var createProperty = __webpack_require__(173);
var wellKnownSymbol = __webpack_require__(56);
var arrayMethodHasSpeciesSupport = __webpack_require__(80);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(449);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tag", function() { return _Tag__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tag", function() { return Tag; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2);
/* harmony import */ var js_components_Hideable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(231);
/* harmony import */ var _Tag_sass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(450);
/* harmony import */ var _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_Tag_sass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(155);
/* harmony import */ var _util_deprecationWarning__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(216);
/* harmony import */ var _ToolTip__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(198);
















var isOverflowing = function isOverflowing(node) {
  return node.scrollWidth - node.getBoundingClientRect().width > 1;
};
/** A simple Tag component. */


function Tag(_ref) {
  var _classNames;

  var onRemove = _ref.onRemove,
      block = _ref.block,
      fixedWidth = _ref.fixedWidth,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      dir = _ref.dir,
      testName = _ref.testName,
      style = _ref.style,
      theme = _ref.theme,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default()(_ref, ["onRemove", "block", "fixedWidth", "children", "className", "color", "dir", "testName", "style", "theme"]);

  var measuredRef = Object(react__WEBPACK_IMPORTED_MODULE_5__["useRef"])();

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_5__["useState"])(false),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_useState, 2),
      overflowing = _useState2[0],
      setOverflowing = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_5__["useEffect"])(function () {
    if (!overflowing && isOverflowing(measuredRef.current)) {
      setOverflowing(true);
    }
  }, []);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_7___default()(_Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a[theme], _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a.tag, className, _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a[color], (_classNames = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_classNames, _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a.withClose, Boolean(onRemove)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_classNames, _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a.block, block), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_classNames, _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a.inline, !block), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_classNames, _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a.fixedWidth, fixedWidth), _classNames));
  checkDeprecationWarnings(color);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement("div", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    className: classes,
    style: style,
    "data-test-name": testName
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement(_ToolTip__WEBPACK_IMPORTED_MODULE_14__["ToolTip"], {
    placement: "top",
    portal: true,
    block: true,
    content: children,
    active: overflowing
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement("div", {
    ref: measuredRef,
    dir: dir,
    className: _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a.content
  }, children)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_9__["Hideable"], {
    show: Boolean(onRemove)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement("div", {
    "aria-label": "remove",
    tabIndex: 0,
    className: _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a.remove,
    onClick: onRemove,
    onKeyDown: function onKeyDown(evt) {
      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_8__["default"])(evt).is('space enter backspace delete')) {
        onRemove(evt);
      }
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_13__["Icon"], {
    name: "CANCEL",
    className: _Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a.icon
  }))));
}

var checkDeprecationWarnings = function checkDeprecationWarnings(color) {
  var message = function message(type) {
    return "`".concat(color, "` prop on a Tag is deprecated, use `").concat(type, "` instead");
  };

  if (color === 'pink') {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_12__["default"])(message('danger'));
  }

  if (color === 'green') {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_12__["default"])(message('success'));
  }

  if (color === 'orange') {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_12__["default"])(message('alert'));
  }

  if (color === 'teal') {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_12__["default"])(message('primary'));
  }
};

Tag.defaultProps = {
  color: 'primary',
  dir: 'auto'
};
Tag.propTypes = {
  /** Direction for the dir attribute*/
  dir: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.oneOf(['auto', 'ltr', 'rtl']),

  /** Whether to render the tag as a block level element (full width). */
  block: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,

  /** Tag content */
  children: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.node.isRequired,

  /** Optional classname to apply to the outermost element. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string,

  /** Background color of the tag. */
  color: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.oneOf(['primary', 'danger', 'alert', 'success', 'gray']),

  /** Whether to render the tag at a fixed width (10rem) */
  fixedWidth: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.bool,

  /** Callback function. If provided an x will be rendered that calls this function on click and on keyboard enter, space, delete, or backspace. */
  onRemove: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_6___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_11__["provideTheme"])(_Tag_sass__WEBPACK_IMPORTED_MODULE_10___default.a)(Tag));

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(451);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Tag-classic-2_3_6-1JvRH a{color:#079bb3}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x{position:relative;padding:2px 8px;color:#fff;font-size:.875rem;font-weight:700;line-height:1.3em;border:1px solid}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-withClose-2_3_6-tP8ss,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-withClose-2_3_6-tP8ss{padding-right:22px}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-primary-2_3_6-11FQ7,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-primary-2_3_6-11FQ7,.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-teal-2_3_6-2YSkk,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-teal-2_3_6-2YSkk{border-color:#079bb3;background-color:#079bb3}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-alert-2_3_6-1OnFf,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-alert-2_3_6-1OnFf,.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-orange-2_3_6-1F5Fv,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-orange-2_3_6-1F5Fv{border-color:#ef6c2a;background-color:#ef6c2a}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-danger-2_3_6-1AmEZ,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-danger-2_3_6-1AmEZ,.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-pink-2_3_6-382CW,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-pink-2_3_6-382CW{border-color:#d32781;background-color:#d32781}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-green-2_3_6-2HrWn,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-green-2_3_6-2HrWn,.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-success-2_3_6-2BD3O,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-success-2_3_6-2BD3O{border-color:#a2b00c;background-color:#a2b00c}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok{color:#666;border-color:#ccc;background-color:#eee}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X,.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X:focus,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X:focus,.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X:hover,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X:hover{color:#666}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz{display:inline-block;max-width:20rem}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz .Tag-content-2_3_6-37sPu,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz .Tag-content-2_3_6-37sPu{max-width:20rem}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz:not(:last-child),.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz:not(:last-child){margin-right:.3333333333rem}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-block-2_3_6-3XfQ1,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-block-2_3_6-3XfQ1{display:block}.Tag-classic-2_3_6-1JvRH.Tag-tag-2_3_6-1D53x.Tag-fixedWidth-2_3_6-6pcmV,.Tag-classic-2_3_6-1JvRH .Tag-tag-2_3_6-1D53x.Tag-fixedWidth-2_3_6-6pcmV{max-width:100%;width:10rem}.Tag-classic-2_3_6-1JvRH .Tag-content-2_3_6-37sPu{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.Tag-classic-2_3_6-1JvRH .Tag-remove-2_3_6-3x-5X{opacity:.82;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;position:absolute;right:4px;top:50%;margin-top:-.5rem;font-size:1rem;font-weight:400;line-height:1;color:#fff;transition:transform .15s ease,opacity .15s ease}.Tag-classic-2_3_6-1JvRH .Tag-remove-2_3_6-3x-5X .Tag-icon-2_3_6-3aF4y{opacity:1;height:1em;width:1em}.Tag-classic-2_3_6-1JvRH .Tag-remove-2_3_6-3x-5X:focus,.Tag-classic-2_3_6-1JvRH .Tag-remove-2_3_6-3x-5X:hover{opacity:1;cursor:pointer;color:#fff}.Tag-blueSteel-2_3_6-k0kDY a{color:#08088c}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x{position:relative;padding:2px 8px;color:#fff;font-size:.875rem;font-weight:700;line-height:1.3em;border:1px solid}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-withClose-2_3_6-tP8ss,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-withClose-2_3_6-tP8ss{padding-right:22px}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-primary-2_3_6-11FQ7,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-primary-2_3_6-11FQ7,.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-teal-2_3_6-2YSkk,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-teal-2_3_6-2YSkk{border-color:#092dbd;background-color:#092dbd}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-alert-2_3_6-1OnFf,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-alert-2_3_6-1OnFf,.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-orange-2_3_6-1F5Fv,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-orange-2_3_6-1F5Fv{border-color:#ffba00;background-color:#ffba00}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-danger-2_3_6-1AmEZ,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-danger-2_3_6-1AmEZ,.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-pink-2_3_6-382CW,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-pink-2_3_6-382CW{border-color:#d33d00;background-color:#d33d00}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-green-2_3_6-2HrWn,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-green-2_3_6-2HrWn,.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-success-2_3_6-2BD3O,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-success-2_3_6-2BD3O{border-color:#009e4f;background-color:#009e4f}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok{color:#4d5056;border-color:#ccc;background-color:#f9f9f9}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X,.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X:focus,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X:focus,.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X:hover,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-gray-2_3_6-HrAok .Tag-remove-2_3_6-3x-5X:hover{color:#4d5056}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz{display:inline-block;max-width:20rem}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz .Tag-content-2_3_6-37sPu,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz .Tag-content-2_3_6-37sPu{max-width:20rem}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz:not(:last-child),.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-inline-2_3_6-AqQdz:not(:last-child){margin-right:.3333333333rem}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-block-2_3_6-3XfQ1,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-block-2_3_6-3XfQ1{display:block}.Tag-blueSteel-2_3_6-k0kDY.Tag-tag-2_3_6-1D53x.Tag-fixedWidth-2_3_6-6pcmV,.Tag-blueSteel-2_3_6-k0kDY .Tag-tag-2_3_6-1D53x.Tag-fixedWidth-2_3_6-6pcmV{max-width:100%;width:10rem}.Tag-blueSteel-2_3_6-k0kDY .Tag-content-2_3_6-37sPu{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.Tag-blueSteel-2_3_6-k0kDY .Tag-remove-2_3_6-3x-5X{opacity:.82;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;position:absolute;right:4px;top:50%;margin-top:-.5rem;font-size:1rem;font-weight:400;line-height:1;color:#fff;transition:transform .15s ease,opacity .15s ease}.Tag-blueSteel-2_3_6-k0kDY .Tag-remove-2_3_6-3x-5X .Tag-icon-2_3_6-3aF4y{opacity:1;height:1em;width:1em}.Tag-blueSteel-2_3_6-k0kDY .Tag-remove-2_3_6-3x-5X:focus,.Tag-blueSteel-2_3_6-k0kDY .Tag-remove-2_3_6-3x-5X:hover{opacity:1;cursor:pointer;color:#fff}", ""]);

// exports
exports.locals = {
	"classic": "Tag-classic-2_3_6-1JvRH",
	"tag": "Tag-tag-2_3_6-1D53x",
	"withClose": "Tag-withClose-2_3_6-tP8ss",
	"teal": "Tag-teal-2_3_6-2YSkk",
	"primary": "Tag-primary-2_3_6-11FQ7",
	"orange": "Tag-orange-2_3_6-1F5Fv",
	"alert": "Tag-alert-2_3_6-1OnFf",
	"pink": "Tag-pink-2_3_6-382CW",
	"danger": "Tag-danger-2_3_6-1AmEZ",
	"green": "Tag-green-2_3_6-2HrWn",
	"success": "Tag-success-2_3_6-2BD3O",
	"gray": "Tag-gray-2_3_6-HrAok",
	"remove": "Tag-remove-2_3_6-3x-5X",
	"inline": "Tag-inline-2_3_6-AqQdz",
	"content": "Tag-content-2_3_6-37sPu",
	"block": "Tag-block-2_3_6-3XfQ1",
	"fixedWidth": "Tag-fixedWidth-2_3_6-6pcmV",
	"icon": "Tag-icon-2_3_6-3aF4y",
	"blueSteel": "Tag-blueSteel-2_3_6-k0kDY"
};

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(448);
/* harmony import */ var _TagListInput_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(453);
/* harmony import */ var _TagListInput_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_TagListInput_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(216);







var Placeholder = function Placeholder(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Tag__WEBPACK_IMPORTED_MODULE_3__["Tag"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_TagListInput_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme], _TagListInput_sass__WEBPACK_IMPORTED_MODULE_4___default.a.placeholder),
    theme: theme,
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_5__["Icon"], {
    className: _TagListInput_sass__WEBPACK_IMPORTED_MODULE_4___default.a.placeholderIcon,
    name: _Icon__WEBPACK_IMPORTED_MODULE_5__["ICONS"].PLUS_SQUARE,
    padRight: true
  }), children);
};

Placeholder.propTypes = {
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (Placeholder);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(454);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".TagListInput-classic-2_3_6-1gRK3 a{color:#079bb3}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p{cursor:text;font-size:.9333333333rem;padding:.5rem .5rem .25rem;background-color:#fff;border:1px solid #aaa;border-radius:2px;transition:background-color .2s ease-in-out,border-color .2s ease-in-out}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p.TagListInput-disabled-2_3_6-3aUxv,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p.TagListInput-disabled-2_3_6-3aUxv{background-color:#f4f4f4;border:1px solid #ccc;color:#888}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p.TagListInput-readonly-2_3_6-2lSK2,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p.TagListInput-readonly-2_3_6-2lSK2{background:none;border:none;padding:0}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC{vertical-align:top;border:none;background:transparent;font-size:1rem;line-height:24px;color:#444;margin-bottom:0;-ms-flex:1 1 auto;flex:1 1 auto}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC:focus,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC:focus{display:inline-block;outline:none}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC::-ms-clear,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC::-ms-clear{display:none}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC.TagListInput-noCursor-2_3_6-1bXsy,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC.TagListInput-noCursor-2_3_6-1bXsy{caret-color:transparent}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-suggestionsList-2_3_6-11MBm{max-height:11rem;overflow-y:auto}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-suggestionsButton-2_3_6-6j8zR.TagListInput-suggestionsButton-2_3_6-6j8zR{border-width:1px 0 0!important;border-top-color:#ccc!important;border-radius:0;text-align:left;transform:none;outline-color:#079bb3}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-noSuggestionsMessage-2_3_6-3eMP_{color:#aaa!important}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-tag-2_3_6-1-eYJ{font-weight:400;transition:color .2s ease-in-out,background-color .2s ease-in-out}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-placeholderIcon-2_3_6-3GEXn{height:1rem;width:1rem}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-classic-2_3_6-1gRK3.TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf{background-color:transparent;border:1px dashed #999;border-radius:1px;color:#666}.TagListInput-disabled-2_3_6-3aUxv .TagListInput-classic-2_3_6-1gRK3 .TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-disabled-2_3_6-3aUxv .TagListInput-classic-2_3_6-1gRK3.TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf{color:#999}.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p:hover:not(.TagListInput-disabled-2_3_6-3aUxv).TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-classic-2_3_6-1gRK3 .TagListInput-container-2_3_6-1ZZ_p:hover:not(.TagListInput-disabled-2_3_6-3aUxv) .TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p:hover:not(.TagListInput-disabled-2_3_6-3aUxv).TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-classic-2_3_6-1gRK3.TagListInput-container-2_3_6-1ZZ_p:hover:not(.TagListInput-disabled-2_3_6-3aUxv) .TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf{border:1px dashed #000;color:#444}.TagListInput-blueSteel-2_3_6-Zt-Kq a{color:#08088c}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p{cursor:text;font-size:.9333333333rem;padding:.5rem .5rem .25rem;background-color:#fff;border:1px solid #e5e6e6;border-radius:2px;transition:background-color .2s ease-in-out,border-color .2s ease-in-out}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p.TagListInput-disabled-2_3_6-3aUxv,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p.TagListInput-disabled-2_3_6-3aUxv{background-color:#f2f2f3;border:1px solid #f2f2f3;color:#4d5056}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p.TagListInput-readonly-2_3_6-2lSK2,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p.TagListInput-readonly-2_3_6-2lSK2{background:none;border:none;padding:0}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC{vertical-align:top;border:none;background:transparent;font-size:1rem;line-height:24px;color:#01050e;margin-bottom:0;-ms-flex:1 1 auto;flex:1 1 auto}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC:focus,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC:focus{display:inline-block;outline:none}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC::-ms-clear,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC::-ms-clear{display:none}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC.TagListInput-noCursor-2_3_6-1bXsy,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p .TagListInput-input-2_3_6-dpNUC.TagListInput-noCursor-2_3_6-1bXsy{caret-color:transparent}.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-suggestionsList-2_3_6-11MBm{max-height:11rem;overflow-y:auto}.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-suggestionsButton-2_3_6-6j8zR.TagListInput-suggestionsButton-2_3_6-6j8zR{border-width:1px 0 0!important;border-top-color:#f2f2f3!important;border-radius:0;text-align:left;transform:none;outline-color:#08088c}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;box-sizing:border-box;margin:1px;padding:10px;pointer-events:all}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv) .TagListInput-tag-2_3_6-1-eYJ [aria-label=remove],.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv) .TagListInput-tag-2_3_6-1-eYJ [aria-label=remove]{display:none}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv):hover,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv):hover{border-color:#8e9093}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv):hover .TagListInput-tag-2_3_6-1-eYJ,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv):hover .TagListInput-tag-2_3_6-1-eYJ{padding-right:8px;background-color:#f2f4f9;color:#01050e;border-color:#e5e6e6;border-radius:1px}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv):hover .TagListInput-tag-2_3_6-1-eYJ [aria-label=remove],.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv):hover .TagListInput-tag-2_3_6-1-eYJ [aria-label=remove]{display:none}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv).TagListInput-isInputFocused-2_3_6-3XRYS,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv).TagListInput-isInputFocused-2_3_6-3XRYS{margin:0;border-width:2px;border-color:#8e9093}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p.TagListInput-hasError-2_3_6-1mmH8.TagListInput-hasError-2_3_6-1mmH8.TagListInput-hasError-2_3_6-1mmH8,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p.TagListInput-hasError-2_3_6-1mmH8.TagListInput-hasError-2_3_6-1mmH8.TagListInput-hasError-2_3_6-1mmH8{border-color:#d33d00}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p.TagListInput-disabled-2_3_6-3aUxv .TagListInput-tag-2_3_6-1-eYJ,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p.TagListInput-disabled-2_3_6-3aUxv .TagListInput-tag-2_3_6-1-eYJ,.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p.TagListInput-readonly-2_3_6-2lSK2 .TagListInput-tag-2_3_6-1-eYJ,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p.TagListInput-readonly-2_3_6-2lSK2 .TagListInput-tag-2_3_6-1-eYJ,.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv) .TagListInput-tag-2_3_6-1-eYJ,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p:not(.TagListInput-isInputFocused-2_3_6-3XRYS):not(.TagListInput-readonly-2_3_6-2lSK2):not(.TagListInput-disabled-2_3_6-3aUxv) .TagListInput-tag-2_3_6-1-eYJ{background-color:#f9f9f9;border-color:#e5e6e6;border-radius:1px;color:#4d5056;padding-right:8px}.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-noSuggestionsMessage-2_3_6-3eMP_{color:#8e9093!important}.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-tag-2_3_6-1-eYJ{font-weight:400;transition:color .2s ease-in-out,background-color .2s ease-in-out}.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-placeholderIcon-2_3_6-3GEXn{height:1rem;width:1rem}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf{background-color:transparent;border:1px dashed #8e9093;border-radius:1px;color:#4d5056}.TagListInput-disabled-2_3_6-3aUxv .TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-disabled-2_3_6-3aUxv .TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf{color:#8e9093}.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p:hover:not(.TagListInput-disabled-2_3_6-3aUxv).TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-blueSteel-2_3_6-Zt-Kq.TagListInput-container-2_3_6-1ZZ_p:hover:not(.TagListInput-disabled-2_3_6-3aUxv) .TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p:hover:not(.TagListInput-disabled-2_3_6-3aUxv).TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf,.TagListInput-blueSteel-2_3_6-Zt-Kq .TagListInput-container-2_3_6-1ZZ_p:hover:not(.TagListInput-disabled-2_3_6-3aUxv) .TagListInput-placeholder-2_3_6-2wKaf.TagListInput-placeholder-2_3_6-2wKaf{border:1px dashed #01050e;color:#01050e}", ""]);

// exports
exports.locals = {
	"classic": "TagListInput-classic-2_3_6-1gRK3",
	"container": "TagListInput-container-2_3_6-1ZZ_p",
	"disabled": "TagListInput-disabled-2_3_6-3aUxv",
	"readonly": "TagListInput-readonly-2_3_6-2lSK2",
	"input": "TagListInput-input-2_3_6-dpNUC",
	"noCursor": "TagListInput-noCursor-2_3_6-1bXsy",
	"suggestionsList": "TagListInput-suggestionsList-2_3_6-11MBm",
	"suggestionsButton": "TagListInput-suggestionsButton-2_3_6-6j8zR",
	"noSuggestionsMessage": "TagListInput-noSuggestionsMessage-2_3_6-3eMP_",
	"tag": "TagListInput-tag-2_3_6-1-eYJ",
	"placeholderIcon": "TagListInput-placeholderIcon-2_3_6-3GEXn",
	"placeholder": "TagListInput-placeholder-2_3_6-2wKaf",
	"blueSteel": "TagListInput-blueSteel-2_3_6-Zt-Kq",
	"isInputFocused": "TagListInput-isInputFocused-2_3_6-3XRYS",
	"hasError": "TagListInput-hasError-2_3_6-1mmH8"
};

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutosuggestTagListInput", function() { return AutosuggestTagListInput; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(410);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_ends_with_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(456);
/* harmony import */ var core_js_modules_es_string_ends_with_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_ends_with_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(447);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(382);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(117);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(122);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(457);
/* harmony import */ var react_autosuggest__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(react_autosuggest__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(2);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(469);
/* harmony import */ var _MenuItem__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(478);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(216);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(407);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(155);
/* harmony import */ var _TagListInput_sass__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(453);
/* harmony import */ var _TagListInput_sass__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_TagListInput_sass__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_31__);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





























var getAutosuggestTheme = function getAutosuggestTheme(theme) {
  return {
    container: {
      position: 'relative'
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: '11000',
      marginTop: '2px',
      left: '0',
      right: '0',
      border: "0.5px solid ".concat(Object(_Theme__WEBPACK_IMPORTED_MODULE_29__["themePalette"])(theme).inputBorderHover),
      borderRadius: 2,
      boxShadow: '0 10px 16px 0px rgba(0, 0, 0, 0.05)',
      backgroundColor: '#fff'
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none'
    }
  };
};

var parseStringToTags = function parseStringToTags(input) {
  return input.split(',').map(function (v) {
    var text = v.trim();

    if (!text) {
      return null;
    }

    return text;
  }).filter(Boolean);
};

var normalizeTagInput = function normalizeTagInput(tagInput) {
  var normalizedLabel = tagInput.trim().toLocaleLowerCase(); //Remove trailing commas, which indicate end of a tag input

  return normalizedLabel.endsWith(',') ? normalizedLabel.slice(0, normalizedLabel.length - 1) : normalizedLabel;
};

var getStringMatchParts = function getStringMatchParts(label, matchValue) {
  var matchIndex = label.toLowerCase().indexOf(matchValue.toLowerCase());
  return [label.substr(0, matchIndex), label.substr(matchIndex, matchValue.length), label.substr(matchIndex + matchValue.length)];
};

function AutosuggestTagListInput(_ref) {
  var afterSuggestionsButtonProps = _ref.afterSuggestionsButtonProps,
      className = _ref.className,
      highlightFirstSuggestion = _ref.highlightFirstSuggestion,
      inputProps = _ref.inputProps,
      inputRef = _ref.inputRef,
      labelKey = _ref.labelKey,
      valueKey = _ref.valueKey,
      maxSuggestions = _ref.maxSuggestions,
      noSuggestionsMessage = _ref.noSuggestionsMessage,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      _onClick = _ref.onClick,
      onError = _ref.onError,
      onKeyDown = _ref.onKeyDown,
      placeholder = _ref.placeholder,
      requireSuggestionMatch = _ref.requireSuggestionMatch,
      suggestions = _ref.suggestions,
      suggestMinChars = _ref.suggestMinChars,
      theme = _ref.theme,
      value = _ref.value,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4___default()(_ref, ["afterSuggestionsButtonProps", "className", "highlightFirstSuggestion", "inputProps", "inputRef", "labelKey", "valueKey", "maxSuggestions", "noSuggestionsMessage", "onBlur", "onChange", "onClick", "onError", "onKeyDown", "placeholder", "requireSuggestionMatch", "suggestions", "suggestMinChars", "theme", "value"]);

  var autosuggestTheme = Object(react__WEBPACK_IMPORTED_MODULE_21__["useMemo"])(function () {
    return getAutosuggestTheme(theme);
  }, [theme]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_21__["useState"])(''),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_21__["useState"])(null),
      _useState4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(_useState3, 2),
      highlightedSuggestion = _useState4[0],
      setHighlightedSuggestion = _useState4[1];

  var _useState5 = Object(react__WEBPACK_IMPORTED_MODULE_21__["useState"])([]),
      _useState6 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(_useState5, 2),
      activeSuggestions = _useState6[0],
      setActiveSuggestions = _useState6[1];

  var getValue = function getValue(suggestion) {
    return suggestion[valueKey] || suggestion;
  };

  var getLabel = function getLabel(suggestion) {
    return suggestion[labelKey] || suggestion;
  };

  var findTagFor = function findTagFor(tagLabel) {
    var normalizedLabel = normalizeTagInput(tagLabel);
    var match = suggestions.find(function (suggestion) {
      return getLabel(suggestion).toLocaleLowerCase() === normalizedLabel;
    }) || tagLabel;
    return match[valueKey] || match;
  };

  var addTag = function addTag() {
    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : inputValue;
    setInputValue('');
    var newTags = parseStringToTags(tag);
    var fullTags = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default()(value), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default()(newTags));
    handleSuggestionsClearRequested();
    onChange(fullTags);
  };

  var getActiveSuggestions = function getActiveSuggestions(inputValue, currentTags) {
    currentTags = currentTags || value;

    var highlightLabelMatch = function highlightLabelMatch(suggestion, value) {
      var label = getLabel(suggestion);
      var suggestionValue = getValue(suggestion);

      var _getStringMatchParts = getStringMatchParts(label || suggestion, value),
          _getStringMatchParts2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(_getStringMatchParts, 3),
          beforeMatch = _getStringMatchParts2[0],
          match = _getStringMatchParts2[1],
          afterMatch = _getStringMatchParts2[2];

      var highlightedLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_21___default.a.Fragment, null, beforeMatch, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement("span", {
        style: {
          fontWeight: 700
        }
      }, match), afterMatch);
      return {
        label: label,
        value: suggestionValue,
        highlightedLabel: highlightedLabel
      };
    };

    var normalizedInputValue = normalizeTagInput(inputValue);

    if (normalizedInputValue.length < suggestMinChars) {
      setActiveSuggestions([]);
      return;
    }

    var filteredSuggestions = suggestions.filter(function (suggestion) {
      return !currentTags.includes(getValue(suggestion)) && getLabel(suggestion).toLocaleLowerCase().includes(normalizedInputValue);
    }).slice(0, maxSuggestions).map(function (suggestion) {
      return highlightLabelMatch(suggestion, inputValue);
    });
    setActiveSuggestions(filteredSuggestions);
  };

  var handleSuggestionsFetchRequested = function handleSuggestionsFetchRequested(_ref2) {
    var inputValue = _ref2.value,
        reason = _ref2.reason;

    if (reason === 'suggestion-selected') {
      handleSuggestionsClearRequested();
    } else {
      getActiveSuggestions(inputValue);
    }
  };

  var handleSuggestionsClearRequested = function handleSuggestionsClearRequested() {
    return setActiveSuggestions([]);
  };

  var handleSuggestionSelected = function handleSuggestionSelected(evt, _ref3) {
    var suggestion = _ref3.suggestion;
    addTag(suggestion.value);
  };

  var handleSuggestionHighlighted = function handleSuggestionHighlighted(_ref4) {
    var suggestion = _ref4.suggestion;
    setHighlightedSuggestion(suggestion);
  };

  var handleInputChange = function handleInputChange(_, _ref5) {
    var newValue = _ref5.newValue;
    setInputValue(getLabel(newValue));
  };

  var handleBlur = function handleBlur(_, evt) {
    var elementCausedBlur = function elementCausedBlur(dataAttribute) {
      return !!evt.relatedTarget && evt.relatedTarget.getAttribute(dataAttribute);
    };

    if (!evt) {
      setInputValue('');
      handleSuggestionsClearRequested();
      return;
    }

    if (elementCausedBlur('data-after-suggestions-button')) {
      return;
    }

    if (onBlur) {
      onBlur(_, evt);
    }

    if (!elementCausedBlur('data-autosuggest-option')) {
      setInputValue('');
      handleSuggestionsClearRequested();
    }
  };

  var handleSuggestionsButtonMouseDown = function handleSuggestionsButtonMouseDown() {
    if (afterSuggestionsButtonProps.onClick) {
      afterSuggestionsButtonProps.onClick();
    }

    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  var handleAfterSuggestionsButtonKeyDown = function handleAfterSuggestionsButtonKeyDown(evt) {
    if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_24__["default"])(evt).is('enter')) {
      handleSuggestionsClearRequested();
      setInputValue('');
      handleSuggestionsButtonMouseDown();
    }
  };

  var addTagFromKeyInput = function addTagFromKeyInput() {
    if (highlightedSuggestion) {
      addTag(getValue(highlightedSuggestion));
    } else {
      if (requireSuggestionMatch) {
        if (activeSuggestions.length) {
          var bestMatch = activeSuggestions[0];
          addTag(getValue(bestMatch));
        } else if (onError) {
          onError(inputValue);
        }
      } else {
        addTag(findTagFor(inputValue));
      }
    }
  };

  var renderInput = function renderInput(_ref6) {
    var autoSuggestOnBlur = _ref6.onBlur,
        propsFromAutosuggest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4___default()(_ref6, ["onBlur"]);

    var handleKeyUp = function handleKeyUp(evt) {
      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_24__["default"])(evt).is('comma')) {
        if (inputValue.trim().length > 0) {
          addTagFromKeyInput();
        } else {
          setInputValue('');
        }
      }
    };

    var handleKeyDown = function handleKeyDown(evt, autoSuggestOnKeyDown) {
      if (onKeyDown) {
        onKeyDown(evt);
      } // Remove last tag on backspace if the input is empty


      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_24__["default"])(evt).is('backspace') && inputValue === '') {
        evt.preventDefault();

        if (value.length === 0) {
          // No tags to remove
          return;
        }

        onChange(value.slice(0, value.length - 1));
      }

      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_24__["default"])(evt).is('tab') || Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_24__["default"])(evt).is('enter')) {
        if (inputValue === '') {
          handleSuggestionsClearRequested();
        } else {
          addTagFromKeyInput();
        }
      } else {
        autoSuggestOnKeyDown(evt);
      }
    };

    var autoSuggestOnKeyDown = propsFromAutosuggest.onKeyDown,
        props = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4___default()(propsFromAutosuggest, ["onKeyDown"]);

    var displayTags = value.map(function (tag) {
      var match = suggestions.find(function (suggestion) {
        return getValue(suggestion) === tag;
      });
      return match ? getLabel(match) : tag;
    });
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement(___WEBPACK_IMPORTED_MODULE_28__["PlainTagListInput"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
      className: className,
      inputProps: _objectSpread({
        onKeyDown: function onKeyDown(evt) {
          return handleKeyDown(evt, autoSuggestOnKeyDown);
        },
        onKeyUp: handleKeyUp
      }, props),
      onBlur: handleBlur,
      onClick: function onClick() {
        getActiveSuggestions('');
        _onClick && _onClick();
      },
      onChange: onChange,
      placeholder: placeholder,
      theme: theme,
      value: displayTags
    }, inputRef && {
      ref: inputRef,
      inputBlock: true
    }, rest));
  };

  var renderSuggestion = function renderSuggestion(suggestion, _ref7) {
    var isHighlighted = _ref7.isHighlighted;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement(_MenuItem__WEBPACK_IMPORTED_MODULE_26__["MenuItem"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
      Component: "div",
      selected: isHighlighted,
      theme: theme,
      tabIndex: "-1",
      isAutosuggest: true,
      className: _TagListInput_sass__WEBPACK_IMPORTED_MODULE_30___default.a.suggestionsMenuItem
    }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, 'data-autosuggest-option', true)), suggestion.highlightedLabel);
  };

  var renderNoSuggestionsFoundItem = function renderNoSuggestionsFoundItem() {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement(_MenuItem__WEBPACK_IMPORTED_MODULE_26__["MenuItem"], {
      Component: "div",
      theme: theme,
      tabIndex: "-1",
      isAutosuggest: true,
      className: _TagListInput_sass__WEBPACK_IMPORTED_MODULE_30___default.a.noSuggestionsMessage
    }, noSuggestionsMessage);
  };

  var renderAfterSuggestionsButton = function renderAfterSuggestionsButton() {
    var _ref9 = afterSuggestionsButtonProps || {},
        text = _ref9.text,
        className = _ref9.className,
        remainingAfterProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4___default()(_ref9, ["text", "className"]);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement(_Button__WEBPACK_IMPORTED_MODULE_25__["Button"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, remainingAfterProps, {
      invert: true,
      primary: false,
      block: true // AutoSuggest hides suggestions when the input is blurred which forces the button upwards
      // by the time the mouse is realeased and the click handler would be invoked, the mouse
      // wont be over the button anymore, so we call click onMouseDown.
      ,
      onClick: function onClick() {
        return null;
      },
      onMouseDown: handleSuggestionsButtonMouseDown,
      onKeyDown: handleAfterSuggestionsButtonKeyDown,
      className: classnames__WEBPACK_IMPORTED_MODULE_31___default()(_TagListInput_sass__WEBPACK_IMPORTED_MODULE_30___default.a.suggestionsButton, className)
    }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, 'data-after-suggestions-button', true)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_27__["Icon"], {
      name: _Icon__WEBPACK_IMPORTED_MODULE_27__["ICONS"].PLUS_SQUARE,
      padRight: true
    }), text);
  };

  var renderSuggestionsContainer = function renderSuggestionsContainer(_ref11) {
    var containerProps = _ref11.containerProps,
        children = _ref11.children;

    var containerStyle = containerProps.style,
        props = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4___default()(containerProps, ["style"]);

    var containerIsClosed = !!containerStyle.position;
    var inputLength = inputValue.trim().length;
    var hasMinChars = inputLength >= suggestMinChars && inputLength > 0;
    var hasNoSuggestions = activeSuggestions.length === 0;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement("div", {
      style: hasMinChars > 0 ? autosuggestTheme.suggestionsContainerOpen : containerStyle,
      className: _TagListInput_sass__WEBPACK_IMPORTED_MODULE_30___default.a[theme]
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement("div", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
      className: _TagListInput_sass__WEBPACK_IMPORTED_MODULE_30___default.a.suggestionsList
    }, props), children), (containerIsClosed || hasMinChars) && hasNoSuggestions && noSuggestionsMessage && renderNoSuggestionsFoundItem(), (containerIsClosed || hasMinChars) && afterSuggestionsButtonProps && renderAfterSuggestionsButton());
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21___default.a.createElement(react_autosuggest__WEBPACK_IMPORTED_MODULE_23___default.a, {
    highlightFirstSuggestion: highlightFirstSuggestion,
    renderInputComponent: renderInput,
    suggestions: activeSuggestions,
    onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
    onSuggestionsClearRequested: handleSuggestionsClearRequested,
    onSuggestionSelected: handleSuggestionSelected,
    onSuggestionHighlighted: handleSuggestionHighlighted,
    getSuggestionValue: function getSuggestionValue(suggestion) {
      return suggestion;
    },
    renderSuggestion: renderSuggestion,
    renderSuggestionsContainer: renderSuggestionsContainer,
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      value: inputValue,
      onChange: handleInputChange
    }),
    theme: autosuggestTheme,
    shouldRenderSuggestions: function shouldRenderSuggestions() {
      return true;
    }
  });
}
AutosuggestTagListInput.defaultProps = {
  inputProps: {},
  maxSuggestions: 50,
  suggestMinChars: 0,
  labelKey: 'label',
  valueKey: 'value',
  highlightFirstSuggestion: false,
  requireSuggestionMatch: false
};
AutosuggestTagListInput.propTypes = {
  /**
   * Optional set of props to pass through to a studio-components Button which will be rendered
   * after the suggestions in the suggestions list when its open. onSave or onCancel will be dispatched
   * before onClick is called
   */
  afterSuggestionsButtonProps: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.shape({
    text: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.node]),
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.func
  }),

  /** PlainTagListInput class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string,

  /**
   * First suggestion is highlighted by default
   */
  highlightFirstSuggestion: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.bool,

  /**
   * Additional props to set on the inner `<input>`. These will take precedence over other props on `<input>`.
   */
  inputProps: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.object,

  /**
   * Optional ref for attachment to the PlanTagListInput div node
   */
  inputRef: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.object,

  /**
   * Key that contains the suggestion label, when suggestions is an array of objects
   */
  labelKey: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string,

  /**
   * Key that contains the suggestion value, when suggestions is an array of objects
   */
  valueKey: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string,

  /**
   * Maximum number of suggestions that will be displayed on the list. Shows from index 0 to the maximum
   * */
  maxSuggestions: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.number,

  /**
   * Message to display when there are no suggestions.
   * Use 'No results found' text when possible, translations may modify it as required
   */
  noSuggestionsMessage: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string,

  /**
   * Your blur handler.
   * */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.func,

  /**
   * Your change handler. Update your state here.
   */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.func.isRequired,

  /**
   * Your click handler
   */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.func,

  /**
   * Callback fired whenever an invalid tag is attempted
   * */
  onError: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.func,

  /**
   * Your key down handler
   */
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.func,

  /**
   * React node with a Placeholder Tag
   * */
  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.node,

  /**
   * Requires an input match in order to add a new tag
   */
  requireSuggestionMatch: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.bool,

  /**
   * Array with suggestions
   */
  suggestions: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.object, prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string])).isRequired,

  /**
   * Minimum characters needed to display the suggestions
   */
  suggestMinChars: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.number,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string,

  /**
   * A theme name to apply on this component
   */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string,

  /**
   * Array with current tags values
   */
  value: prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_22___default.a.string).isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_29__["provideTheme"])()(AutosuggestTagListInput));

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var getOwnPropertyDescriptor = __webpack_require__(10).f;
var toLength = __webpack_require__(45);
var notARegExp = __webpack_require__(123);
var requireObjectCoercible = __webpack_require__(18);
var correctIsRegExpLogic = __webpack_require__(124);
var IS_PURE = __webpack_require__(35);

var nativeEndsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = String(searchString);
    return nativeEndsWith
      ? nativeEndsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(458)["default"];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(125));

var _propTypes = _interopRequireDefault(__webpack_require__(130));

var _arrays = _interopRequireDefault(__webpack_require__(459));

var _Autowhatever = _interopRequireDefault(__webpack_require__(460));

var _theme = __webpack_require__(468);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alwaysTrue = function alwaysTrue() {
  return true;
};

var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};

var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
};

var REASON_SUGGESTIONS_REVEALED = 'suggestions-revealed';
var REASON_SUGGESTIONS_UPDATED = 'suggestions-updated';
var REASON_SUGGESTION_SELECTED = 'suggestion-selected';
var REASON_INPUT_FOCUSED = 'input-focused';
var REASON_INPUT_CHANGED = 'input-changed';
var REASON_INPUT_BLURRED = 'input-blurred';
var REASON_ESCAPE_PRESSED = 'escape-pressed';

var Autosuggest = /*#__PURE__*/function (_Component) {
  _inherits(Autosuggest, _Component);

  var _super = _createSuper(Autosuggest);

  function Autosuggest(_ref2) {
    var _this;

    var _alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseDown", function (event) {
      _this.justClickedOnSuggestionsContainer = false;
      var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
      event.target;

      while (node !== null && node !== document) {
        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
          // Suggestion was clicked
          return;
        }

        if (node === _this.suggestionsContainer) {
          // Something else inside suggestions container was clicked
          _this.justClickedOnSuggestionsContainer = true;
          return;
        }

        node = node.parentNode;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "storeAutowhateverRef", function (autowhatever) {
      if (autowhatever !== null) {
        _this.autowhatever = autowhatever;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseEnter", function (event, _ref3) {
      var sectionIndex = _ref3.sectionIndex,
          itemIndex = _ref3.itemIndex;

      _this.updateHighlightedSuggestion(sectionIndex, itemIndex);

      if (event.target === _this.pressedSuggestion) {
        _this.justSelectedSuggestion = true;
      }

      _this.justMouseEntered = true;
      setTimeout(function () {
        _this.justMouseEntered = false;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "highlightFirstSuggestion", function () {
      _this.updateHighlightedSuggestion(_this.props.multiSection ? 0 : null, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseUp", function () {
      if (_this.pressedSuggestion && !_this.justSelectedSuggestion) {
        _this.input.focus();
      }

      _this.pressedSuggestion = null;
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseDown", function (event) {
      // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
      // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
      if (!_this.justSelectedSuggestion) {
        _this.justSelectedSuggestion = true;
        _this.pressedSuggestion = event.target;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsClearRequested", function () {
      var onSuggestionsClearRequested = _this.props.onSuggestionsClearRequested;
      onSuggestionsClearRequested && onSuggestionsClearRequested();
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionSelected", function (event, data) {
      var _this$props = _this.props,
          alwaysRenderSuggestions = _this$props.alwaysRenderSuggestions,
          onSuggestionSelected = _this$props.onSuggestionSelected,
          onSuggestionsFetchRequested = _this$props.onSuggestionsFetchRequested;
      onSuggestionSelected && onSuggestionSelected(event, data);

      var keepSuggestionsOnSelect = _this.props.shouldKeepSuggestionsOnSelect(data.suggestion);

      if (alwaysRenderSuggestions || keepSuggestionsOnSelect) {
        onSuggestionsFetchRequested({
          value: data.suggestionValue,
          reason: REASON_SUGGESTION_SELECTED
        });
      } else {
        _this.onSuggestionsClearRequested();
      }

      _this.resetHighlightedSuggestion();
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionClick", function (event) {
      var _this$props2 = _this.props,
          alwaysRenderSuggestions = _this$props2.alwaysRenderSuggestions,
          focusInputOnSuggestionClick = _this$props2.focusInputOnSuggestionClick;

      var _this$getSuggestionIn = _this.getSuggestionIndices(_this.findSuggestionElement(event.target)),
          sectionIndex = _this$getSuggestionIn.sectionIndex,
          suggestionIndex = _this$getSuggestionIn.suggestionIndex;

      var clickedSuggestion = _this.getSuggestion(sectionIndex, suggestionIndex);

      var clickedSuggestionValue = _this.props.getSuggestionValue(clickedSuggestion);

      _this.maybeCallOnChange(event, clickedSuggestionValue, 'click');

      _this.onSuggestionSelected(event, {
        suggestion: clickedSuggestion,
        suggestionValue: clickedSuggestionValue,
        suggestionIndex: suggestionIndex,
        sectionIndex: sectionIndex,
        method: 'click'
      });

      var keepSuggestionsOnSelect = _this.props.shouldKeepSuggestionsOnSelect(clickedSuggestion);

      if (!(alwaysRenderSuggestions || keepSuggestionsOnSelect)) {
        _this.closeSuggestions();
      }

      if (focusInputOnSuggestionClick === true) {
        _this.input.focus();
      } else {
        _this.onBlur();
      }

      setTimeout(function () {
        _this.justSelectedSuggestion = false;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      var _this$props3 = _this.props,
          inputProps = _this$props3.inputProps,
          shouldRenderSuggestions = _this$props3.shouldRenderSuggestions;
      var value = inputProps.value,
          onBlur = inputProps.onBlur;

      var highlightedSuggestion = _this.getHighlightedSuggestion();

      var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_BLURRED);

      _this.setState({
        isFocused: false,
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: !shouldRender
      });

      onBlur && onBlur(_this.blurEvent, {
        highlightedSuggestion: highlightedSuggestion
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseLeave", function (event) {
      _this.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown


      if (_this.justSelectedSuggestion && event.target === _this.pressedSuggestion) {
        _this.justSelectedSuggestion = false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchStart", function () {
      _this.justSelectedSuggestion = true; // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
      // todo: gets released so onSuggestionMouseDown won't fire in chrome
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchMove", function () {
      _this.justSelectedSuggestion = false;
      _this.pressedSuggestion = null;

      _this.input.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "itemProps", function (_ref4) {
      var sectionIndex = _ref4.sectionIndex,
          itemIndex = _ref4.itemIndex;
      return {
        'data-section-index': sectionIndex,
        'data-suggestion-index': itemIndex,
        onMouseEnter: _this.onSuggestionMouseEnter,
        onMouseLeave: _this.onSuggestionMouseLeave,
        onMouseDown: _this.onSuggestionMouseDown,
        onTouchStart: _this.onSuggestionTouchStart,
        onTouchMove: _this.onSuggestionTouchMove,
        onClick: _this.onSuggestionClick
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuggestionsContainer", function (_ref5) {
      var containerProps = _ref5.containerProps,
          children = _ref5.children;
      var renderSuggestionsContainer = _this.props.renderSuggestionsContainer;
      return renderSuggestionsContainer({
        containerProps: containerProps,
        children: children,
        query: _this.getQuery()
      });
    });

    _this.state = {
      isFocused: false,
      isCollapsed: !_alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };
    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;
    _this.pressedSuggestion = null;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);
      document.addEventListener('mouseup', this.onDocumentMouseUp);
      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    } // eslint-disable-next-line camelcase, react/sort-comp

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // When highlightFirstSuggestion becomes deactivated, if the first suggestion was
      // set, we should reset the suggestion back to the unselected default state.
      var shouldResetHighlighting = this.state.highlightedSuggestionIndex === 0 && this.props.highlightFirstSuggestion && !nextProps.highlightFirstSuggestion;

      if ((0, _arrays["default"])(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        } else if (shouldResetHighlighting) {
          this.resetHighlightedSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps, REASON_SUGGESTIONS_UPDATED)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }

          if (shouldResetHighlighting) {
            this.resetHighlightedSuggestion();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props4 = this.props,
          suggestions = _this$props4.suggestions,
          onSuggestionHighlighted = _this$props4.onSuggestionHighlighted,
          highlightFirstSuggestion = _this$props4.highlightFirstSuggestion;

      if (!(0, _arrays["default"])(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: "updateHighlightedSuggestion",
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;

        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: "resetHighlightedSuggestion",
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;
        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: "revealSuggestions",
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: "closeSuggestions",
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: "getSuggestion",
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _this$props5 = this.props,
          suggestions = _this$props5.suggestions,
          multiSection = _this$props5.multiSection,
          getSectionSuggestions = _this$props5.getSectionSuggestions;

      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: "getHighlightedSuggestion",
    value: function getHighlightedSuggestion() {
      var _this$state = this.state,
          highlightedSectionIndex = _this$state.highlightedSectionIndex,
          highlightedSuggestionIndex = _this$state.highlightedSuggestionIndex;

      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: "getSuggestionValueByIndex",
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;
      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: "getSuggestionIndices",
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: "findSuggestionElement",
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console

      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: "maybeCallOnChange",
    value: function maybeCallOnChange(event, newValue, method) {
      var _this$props$inputProp = this.props.inputProps,
          value = _this$props$inputProp.value,
          onChange = _this$props$inputProp.onChange;

      if (newValue !== value) {
        onChange(event, {
          newValue: newValue,
          method: method
        });
      }
    }
  }, {
    key: "willRenderSuggestions",
    value: function willRenderSuggestions(props, reason) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;
      return suggestions.length > 0 && shouldRenderSuggestions(value, reason);
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;
      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props6 = this.props,
          suggestions = _this$props6.suggestions,
          renderInputComponent = _this$props6.renderInputComponent,
          onSuggestionsFetchRequested = _this$props6.onSuggestionsFetchRequested,
          renderSuggestion = _this$props6.renderSuggestion,
          inputProps = _this$props6.inputProps,
          multiSection = _this$props6.multiSection,
          renderSectionTitle = _this$props6.renderSectionTitle,
          id = _this$props6.id,
          getSectionSuggestions = _this$props6.getSectionSuggestions,
          theme = _this$props6.theme,
          getSuggestionValue = _this$props6.getSuggestionValue,
          alwaysRenderSuggestions = _this$props6.alwaysRenderSuggestions,
          highlightFirstSuggestion = _this$props6.highlightFirstSuggestion,
          containerProps = _this$props6.containerProps;
      var _this$state2 = this.state,
          isFocused = _this$state2.isFocused,
          isCollapsed = _this$state2.isCollapsed,
          highlightedSectionIndex = _this$state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _this$state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _this$state2.valueBeforeUpDown;
      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;
      var willRenderSuggestions = this.willRenderSuggestions(this.props, 'render');
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];

      var autowhateverInputProps = _objectSpread({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_FOCUSED);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({
                value: value,
                reason: REASON_INPUT_FOCUSED
              });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();

            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();

            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;
          var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_CHANGED);

          _this3.maybeCallOnChange(event, value, 'type');

          if (_this3.suggestionsContainer) {
            _this3.suggestionsContainer.scrollTop = 0;
          }

          _this3.setState(_objectSpread({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({
              value: value,
              reason: REASON_INPUT_CHANGED
            });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;

          switch (keyCode) {
            case 40: // ArrowDown

            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value, REASON_SUGGESTIONS_REVEALED)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: REASON_SUGGESTIONS_REVEALED
                  });

                  _this3.revealSuggestions();

                  event.preventDefault(); // We act on the key.
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;
                var newValue;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);

                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');

                event.preventDefault(); // We act on the key.
              }

              _this3.justPressedUpDown = true;
              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });
              break;
            // Enter

            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  event.preventDefault();

                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;
                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }
            // Escape

            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2, REASON_ESCAPE_PRESSED)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: REASON_ESCAPE_PRESSED
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();

                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });

      var renderSuggestionData = {
        query: this.getQuery()
      };
      return /*#__PURE__*/_react["default"].createElement(_Autowhatever["default"], {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        containerProps: containerProps,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

exports["default"] = Autosuggest;

_defineProperty(Autosuggest, "propTypes", {
  suggestions: _propTypes["default"].array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  shouldKeepSuggestionsOnSelect: _propTypes["default"].func,
  onSuggestionSelected: _propTypes["default"].func,
  onSuggestionHighlighted: _propTypes["default"].func,
  renderInputComponent: _propTypes["default"].func,
  renderSuggestionsContainer: _propTypes["default"].func,
  getSuggestionValue: _propTypes["default"].func.isRequired,
  renderSuggestion: _propTypes["default"].func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps) {
      throw new Error("'inputProps' must be passed.");
    }

    if (!Object.prototype.hasOwnProperty.call(inputProps, 'value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!Object.prototype.hasOwnProperty.call(inputProps, 'onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes["default"].func,
  alwaysRenderSuggestions: _propTypes["default"].bool,
  multiSection: _propTypes["default"].bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes["default"].bool,
  highlightFirstSuggestion: _propTypes["default"].bool,
  theme: _propTypes["default"].object,
  id: _propTypes["default"].string,
  containerProps: _propTypes["default"].object // Arbitrary container props

});

_defineProperty(Autosuggest, "defaultProps", {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  shouldKeepSuggestionsOnSelect: function shouldKeepSuggestionsOnSelect() {
    return false;
  },
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1',
  containerProps: {}
});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqualArrays;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(125));

var _propTypes = _interopRequireDefault(__webpack_require__(130));

var _sectionIterator = _interopRequireDefault(__webpack_require__(461));

var _reactThemeable = _interopRequireDefault(__webpack_require__(462));

var _SectionTitle = _interopRequireDefault(__webpack_require__(464));

var _ItemList = _interopRequireDefault(__webpack_require__(466));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var emptyObject = {};

var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("input", props);
};

var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
};

var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = /*#__PURE__*/function (_Component) {
  _inherits(Autowhatever, _Component);

  var _super = _createSuper(Autowhatever);

  function Autowhatever(props) {
    var _this;

    _classCallCheck(this, Autowhatever);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "storeInputReference", function (input) {
      if (input !== null) {
        _this.input = input;
      }

      var userRef = _this.props.inputProps.ref;

      if (userRef) {
        if (typeof userRef === 'function') {
          userRef(input);
        } else if (_typeof(userRef) === 'object' && Object.prototype.hasOwnProperty.call(userRef, 'current')) {
          userRef.current = input;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "storeItemsContainerReference", function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHighlightedItemChange", function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    });

    _defineProperty(_assertThisInitialized(_this), "getItemId", function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;
      var section = sectionIndex === null ? '' : "section-".concat(sectionIndex);
      return "react-autowhatever-".concat(id, "-").concat(section, "-item-").concat(itemIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
      var inputProps = _this.props.inputProps;

      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      var inputProps = _this.props.inputProps;

      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;
      var keyCode = event.keyCode;

      switch (keyCode) {
        case 40: // ArrowDown

        case 38:
          {
            // ArrowUp
            var nextPrev = keyCode === 40 ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, {
              newHighlightedSectionIndex: newHighlightedSectionIndex,
              newHighlightedItemIndex: newHighlightedItemIndex
            });
            break;
          }

        default:
          inputProps.onKeyDown(event, {
            highlightedSectionIndex: highlightedSectionIndex,
            highlightedItemIndex: highlightedItemIndex
          });
      }
    });

    _this.highlightedItem = null;
    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);

    _this.setSectionIterator(props);

    _this.setTheme(props);

    return _this;
  }

  _createClass(Autowhatever, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    } // eslint-disable-next-line camelcase, react/sort-comp

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: "setSectionsItems",
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: "setSectionIterator",
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator["default"])({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: "setTheme",
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable["default"])(props.theme);
    }
  }, {
    key: "renderSections",
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _this$props2 = this.props,
          id = _this$props2.id,
          items = _this$props2.items,
          renderItem = _this$props2.renderItem,
          renderItemData = _this$props2.renderItemData,
          renderSectionTitle = _this$props2.renderSectionTitle,
          highlightedSectionIndex = _this$props2.highlightedSectionIndex,
          highlightedItemIndex = _this$props2.highlightedItemIndex,
          itemProps = _this$props2.itemProps;
      return items.map(function (section, sectionIndex) {
        var keyPrefix = "react-autowhatever-".concat(id, "-");
        var sectionKeyPrefix = "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
        var isFirstSection = sectionIndex === 0; // `key` is provided by theme()

        /* eslint-disable react/jsx-key */

        return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "container"), 'sectionContainer', isFirstSection && 'sectionContainerFirst'), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
          section: section,
          renderSectionTitle: renderSectionTitle,
          theme: theme,
          sectionKeyPrefix: sectionKeyPrefix
        }), /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
          items: _this2.sectionsItems[sectionIndex],
          itemProps: itemProps,
          renderItem: renderItem,
          renderItemData: renderItemData,
          sectionIndex: sectionIndex,
          highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
          onHighlightedItemChange: _this2.onHighlightedItemChange,
          getItemId: _this2.getItemId,
          theme: theme,
          keyPrefix: keyPrefix,
          ref: _this2.storeItemsListReference
        }));
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var items = this.props.items;

      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _this$props3 = this.props,
          id = _this$props3.id,
          renderItem = _this$props3.renderItem,
          renderItemData = _this$props3.renderItemData,
          highlightedSectionIndex = _this$props3.highlightedSectionIndex,
          highlightedItemIndex = _this$props3.highlightedItemIndex,
          itemProps = _this$props3.itemProps;
      return /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: "react-autowhatever-".concat(id, "-")
      });
    }
  }, {
    key: "ensureHighlightedItemIsVisible",
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;

      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;
      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var theme = this.theme;
      var _this$props4 = this.props,
          id = _this$props4.id,
          multiSection = _this$props4.multiSection,
          renderInputComponent = _this$props4.renderInputComponent,
          renderItemsContainer = _this$props4.renderItemsContainer,
          highlightedSectionIndex = _this$props4.highlightedSectionIndex,
          highlightedItemIndex = _this$props4.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;
      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = "react-autowhatever-".concat(id);

      var containerProps = _objectSpread({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme("react-autowhatever-".concat(id, "-container"), 'container', isOpen && 'containerOpen'), {}, this.props.containerProps);

      var inputComponent = renderInputComponent(_objectSpread({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme("react-autowhatever-".concat(id, "-input"), 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), {}, this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _objectSpread({
          id: itemsContainerId,
          role: 'listbox'
        }, theme("react-autowhatever-".concat(id, "-items-container"), 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });
      return /*#__PURE__*/_react["default"].createElement("div", containerProps, inputComponent, itemsContainer);
    }
  }]);

  return Autowhatever;
}(_react.Component);

exports["default"] = Autowhatever;

_defineProperty(Autowhatever, "propTypes", {
  id: _propTypes["default"].string,
  // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes["default"].bool,
  // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes["default"].func,
  // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes["default"].func,
  // Renders the items container.
  items: _propTypes["default"].array.isRequired,
  // Array of items or sections to render.
  renderItem: _propTypes["default"].func,
  // This function renders a single item.
  renderItemData: _propTypes["default"].object,
  // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes["default"].func,
  // This function gets a section and renders its title.
  getSectionItems: _propTypes["default"].func,
  // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  containerProps: _propTypes["default"].object,
  // Arbitrary container props
  inputProps: _propTypes["default"].object,
  // Arbitrary input props
  itemProps: _propTypes["default"].oneOfType([// Arbitrary item props
  _propTypes["default"].object, _propTypes["default"].func]),
  highlightedSectionIndex: _propTypes["default"].number,
  // Section index of the highlighted item
  highlightedItemIndex: _propTypes["default"].number,
  // Highlighted item index (within a section)
  theme: _propTypes["default"].oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes["default"].object, _propTypes["default"].array])
});

_defineProperty(Autowhatever, "defaultProps", {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  containerProps: emptyObject,
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__(463);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(125));

var _propTypes = _interopRequireDefault(__webpack_require__(130));

var _compareObjects = _interopRequireDefault(__webpack_require__(465));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SectionTitle = /*#__PURE__*/function (_Component) {
  _inherits(SectionTitle, _Component);

  var _super = _createSuper(SectionTitle);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _super.apply(this, arguments);
  }

  _createClass(SectionTitle, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects["default"])(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          section = _this$props.section,
          renderSectionTitle = _this$props.renderSectionTitle,
          theme = _this$props.theme,
          sectionKeyPrefix = _this$props.sectionKeyPrefix;
      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "title"), 'sectionTitle'), sectionTitle);
    }
  }]);

  return SectionTitle;
}(_react.Component);

exports["default"] = SectionTitle;

_defineProperty(SectionTitle, "propTypes", {
  section: _propTypes["default"].any.isRequired,
  renderSectionTitle: _propTypes["default"].func.isRequired,
  theme: _propTypes["default"].func.isRequired,
  sectionKeyPrefix: _propTypes["default"].string.isRequired
});

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = compareObjects;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i, len;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || _typeof(aValue) !== 'object' || _typeof(bValue) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(125));

var _propTypes = _interopRequireDefault(__webpack_require__(130));

var _Item = _interopRequireDefault(__webpack_require__(467));

var _compareObjects = _interopRequireDefault(__webpack_require__(465));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ItemsList = /*#__PURE__*/function (_Component) {
  _inherits(ItemsList, _Component);

  var _super = _createSuper(ItemsList);

  function ItemsList() {
    var _this;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "storeHighlightedItemReference", function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    });

    return _this;
  }

  _createClass(ItemsList, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects["default"])(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          itemProps = _this$props.itemProps,
          renderItem = _this$props.renderItem,
          renderItemData = _this$props.renderItemData,
          sectionIndex = _this$props.sectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex,
          getItemId = _this$props.getItemId,
          theme = _this$props.theme,
          keyPrefix = _this$props.keyPrefix;
      var sectionPrefix = sectionIndex === null ? keyPrefix : "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
      var isItemPropsFunction = typeof itemProps === 'function';
      return /*#__PURE__*/_react["default"].createElement("ul", _extends({
        role: "listbox"
      }, theme("".concat(sectionPrefix, "items-list"), 'itemsList')), items.map(function (item, itemIndex) {
        var isFirst = itemIndex === 0;
        var isHighlighted = itemIndex === highlightedItemIndex;
        var itemKey = "".concat(sectionPrefix, "item-").concat(itemIndex);
        var itemPropsObj = isItemPropsFunction ? itemProps({
          sectionIndex: sectionIndex,
          itemIndex: itemIndex
        }) : itemProps;

        var allItemProps = _objectSpread({
          id: getItemId(sectionIndex, itemIndex),
          'aria-selected': isHighlighted
        }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), {}, itemPropsObj);

        if (isHighlighted) {
          allItemProps.ref = _this2.storeHighlightedItemReference;
        } // `key` is provided by theme()

        /* eslint-disable react/jsx-key */


        return /*#__PURE__*/_react["default"].createElement(_Item["default"], _extends({}, allItemProps, {
          sectionIndex: sectionIndex,
          isHighlighted: isHighlighted,
          itemIndex: itemIndex,
          item: item,
          renderItem: renderItem,
          renderItemData: renderItemData
        }));
        /* eslint-enable react/jsx-key */
      }));
    }
  }]);

  return ItemsList;
}(_react.Component);

exports["default"] = ItemsList;

_defineProperty(ItemsList, "propTypes", {
  items: _propTypes["default"].array.isRequired,
  itemProps: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  renderItem: _propTypes["default"].func.isRequired,
  renderItemData: _propTypes["default"].object.isRequired,
  sectionIndex: _propTypes["default"].number,
  highlightedItemIndex: _propTypes["default"].number,
  onHighlightedItemChange: _propTypes["default"].func.isRequired,
  getItemId: _propTypes["default"].func.isRequired,
  theme: _propTypes["default"].func.isRequired,
  keyPrefix: _propTypes["default"].string.isRequired
});

_defineProperty(ItemsList, "defaultProps", {
  sectionIndex: null
});

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(125));

var _propTypes = _interopRequireDefault(__webpack_require__(130));

var _compareObjects = _interopRequireDefault(__webpack_require__(465));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Item = /*#__PURE__*/function (_Component) {
  _inherits(Item, _Component);

  var _super = _createSuper(Item);

  function Item() {
    var _this;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "storeItemReference", function (item) {
      if (item !== null) {
        _this.item = item;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;

      _this.props.onMouseEnter(event, {
        sectionIndex: sectionIndex,
        itemIndex: itemIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;

      _this.props.onMouseLeave(event, {
        sectionIndex: sectionIndex,
        itemIndex: itemIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;

      _this.props.onMouseDown(event, {
        sectionIndex: sectionIndex,
        itemIndex: itemIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;

      _this.props.onClick(event, {
        sectionIndex: sectionIndex,
        itemIndex: itemIndex
      });
    });

    return _this;
  }

  _createClass(Item, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects["default"])(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          isHighlighted = _this$props5.isHighlighted,
          item = _this$props5.item,
          renderItem = _this$props5.renderItem,
          renderItemData = _this$props5.renderItemData,
          restProps = _objectWithoutProperties(_this$props5, ["isHighlighted", "item", "renderItem", "renderItemData"]);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return /*#__PURE__*/_react["default"].createElement("li", _extends({
        role: "option"
      }, restProps, {
        ref: this.storeItemReference
      }), renderItem(item, _objectSpread({
        isHighlighted: isHighlighted
      }, renderItemData)));
    }
  }]);

  return Item;
}(_react.Component);

exports["default"] = Item;

_defineProperty(Item, "propTypes", {
  sectionIndex: _propTypes["default"].number,
  isHighlighted: _propTypes["default"].bool.isRequired,
  itemIndex: _propTypes["default"].number.isRequired,
  item: _propTypes["default"].any.isRequired,
  renderItem: _propTypes["default"].func.isRequired,
  renderItemData: _propTypes["default"].object.isRequired,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onClick: _propTypes["default"].func
});

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapToAutowhateverTheme = exports.defaultTheme = void 0;
var defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};
exports.defaultTheme = defaultTheme;

var mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

exports.mapToAutowhateverTheme = mapToAutowhateverTheme;

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(470);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _Button__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return Button; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(471);
/* harmony import */ var core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_small_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(155);
/* harmony import */ var _util_keycode__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2);
/* harmony import */ var _Loader__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(472);
/* harmony import */ var _ToolTip__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(198);
/* harmony import */ var _Button_sass__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(476);
/* harmony import */ var _Button_sass__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_Button_sass__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _util_deprecationWarning__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(83);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















/**
The only Button you'll ever need.

__Accessibility notes:__
- The button is focusable regardless of whether it is disabled or what kind of
  tag it is rendered as.
- The button can be clicked via the keyboard enter key.
- Screen readers recognize it as a button unless it's rendered as a link with
  an `href`, in which case it is recognized as a link.
- The button is recognized by screen readers as disabled if it is disabled.
*/

function Button(_ref) {
  var _cx;

  var block = _ref.block,
      children = _ref.children,
      className = _ref.className,
      Component = _ref.Component,
      componentProps = _ref.componentProps,
      disabled = _ref.disabled,
      green = _ref.green,
      href = _ref.href,
      invert = _ref.invert,
      onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      orange = _ref.orange,
      pill = _ref.pill,
      pink = _ref.pink,
      role = _ref.role,
      selected = _ref.selected,
      small = _ref.small,
      large = _ref.large,
      spinner = _ref.spinner,
      style = _ref.style,
      target = _ref.target,
      testName = _ref.testName,
      text = _ref.text,
      type = _ref.type,
      primary = _ref.primary,
      success = _ref.success,
      danger = _ref.danger,
      alert = _ref.alert,
      theme = _ref.theme,
      toggle = _ref.toggle,
      tooltip = _ref.tooltip,
      tooltipProps = _ref.tooltipProps,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["block", "children", "className", "Component", "componentProps", "disabled", "green", "href", "invert", "onClick", "onBlur", "onFocus", "onKeyDown", "orange", "pill", "pink", "role", "selected", "small", "large", "spinner", "style", "target", "testName", "text", "type", "primary", "success", "danger", "alert", "theme", "toggle", "tooltip", "tooltipProps"]);

  var classes = classnames__WEBPACK_IMPORTED_MODULE_13___default()(_Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a[theme], className, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.btn, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.block, block), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.spinner, spinner), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.green, green), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.invert, invert), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.orange, orange), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.pill, pill), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.pink, pink), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.selected, selected), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.small, small), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.teal, !pink && !green), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.primary, primary), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.success, success), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.danger, danger), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.alert, alert), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.large, large), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.toggle, toggle), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.href, href), _cx));
  checkDeprecationWarnings({
    pink: pink,
    green: green,
    orange: orange
  });
  var spinnerTag = null;

  if (spinner) {
    spinnerTag = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_Loader__WEBPACK_IMPORTED_MODULE_16__["Loader"], {
      className: _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.spinner,
      color: theme === 'classic' || primary && !danger ? 'white' : undefined,
      size: "inline"
    });
  }

  var btnTextClass = classnames__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.hideBtnText, spinner));

  if (role == null) {
    role = href ? 'link' : 'button';
  }

  var handleClick = !disabled && !spinner ? onClick : null;
  var handleKeyDown;

  if (!disabled && !spinner) {
    handleKeyDown = function handleKeyDown(evt) {
      // Call onClick handler on space/enter for custom components.
      if (Component && Object(_util_keycode__WEBPACK_IMPORTED_MODULE_15__["default"])(evt).is('space enter') && onClick) {
        // If Component is rendered as an <a> with an href or a <button> the
        // browser will interpret these keyboard actions as clicks and fire the
        // onClick callback. We call preventDefault here to prevent calling
        // onClick twice for these cases. This has the added benefit of
        // preventing the page from scrolling when the space key is pressed.
        evt.preventDefault();
        onClick(evt);
      }

      if (onKeyDown) {
        onKeyDown(evt);
      }
    };
  }

  var buttonComponent;

  if (Component) {
    buttonComponent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, rest, {
      "aria-disabled": disabled || spinner,
      className: classes,
      "data-test-name": testName,
      onBlur: onBlur,
      onClick: handleClick,
      onFocus: onFocus,
      onKeyDown: handleKeyDown,
      role: role,
      style: style,
      tabIndex: disabled ? -1 : 0
    }, componentProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", {
      className: btnTextClass
    }, text || children), spinnerTag);
  } else if (!href) {
    buttonComponent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("button", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, rest, {
      className: classes,
      "data-test-name": testName,
      "aria-disabled": disabled || spinner,
      onBlur: onBlur,
      onClick: handleClick,
      onFocus: onFocus,
      onKeyDown: handleKeyDown,
      role: role,
      style: style,
      tabIndex: disabled ? -1 : 0,
      type: type,
      "aria-pressed": onClick && toggle && theme === 'blueSteel'
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", {
      className: btnTextClass
    }, text || children), spinnerTag);
  } else {
    buttonComponent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("a", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, rest, {
      "aria-disabled": disabled || spinner,
      className: classes,
      "data-test-name": testName,
      href: href,
      onBlur: onBlur,
      onClick: handleClick,
      onFocus: onFocus,
      onKeyDown: handleKeyDown,
      role: role,
      style: style,
      tabIndex: disabled ? -1 : 0,
      target: target
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("span", {
      className: btnTextClass
    }, text || children), spinnerTag);
  }

  if (tooltip) {
    var defaultPlacement = 'top';

    var props = _objectSpread({
      placement: tooltipProps ? tooltipProps.placement : defaultPlacement,
      block: block,
      active: !disabled,
      content: tooltip
    }, tooltipProps);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement(_ToolTip__WEBPACK_IMPORTED_MODULE_17__["ToolTip"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, props, {
      className: _Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a.tooltipContainer,
      addMargin: true
    }), buttonComponent);
  } else {
    return buttonComponent;
  }
}

var checkDeprecationWarnings = function checkDeprecationWarnings(props) {
  if (props.pink) {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_19__["default"])('`pink` prop on a Button is deprecated, use `danger` instead');
  }

  if (props.green) {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_19__["default"])('`green` prop on a Button is deprecated, use `success` instead');
  }

  if (props.orange) {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_19__["default"])('`orange` prop on a Button is deprecated, use `alert` instead');
  }
};

Button.defaultProps = {
  type: 'button',
  primary: true
};
Button.propTypes = {
  /** Whether or not to render the button as a full-width block level node. */
  block: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Button contents. You may alternately use the `text` prop. */
  children: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default()(prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node, function (props) {
    return !props.text;
  }),

  /** Class name attribute for the button */
  className: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** If provided the button will be rendered as the given component instead of
  as a `button` tag. Use `componentProps` to pass any necessary props to this
  component. eg: `<Button Component={Router.Link} componentProps={{to: foo}}>`
  See docs site for more examples. */
  Component: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default()(prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.any, function (props) {
    return props.componentProps;
  }),

  /** Props to forward to the component passed in the `Component` prop. */
  componentProps: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** Whether or not to disable the button */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to render the button green
   * @deprecated Use `success` instead
   */
  green: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** If provided the button will be rendered in an `a` tag instead of a `button` tag. */
  href: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Whether or not to invert the colors on the button. */
  invert: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Your blur handler. */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /** Your click handler. */
  onClick: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default()(prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func, function (props) {
    return !(props.disabled || props.href || props.spinner || props.Component || props.type === 'submit');
  }),

  /** Your focus handler. */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /** Your keyDown handler. */
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /** Whether or not to render the button orange
   * @deprecated Use `alert` instead
   */
  orange: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to render as a pill button */
  pill: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to render the button pink
   * @deprecated Use `danger` instead
   * */
  pink: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Role attribute. Defaulted to `button` unless `href` is provided in which
  case it is defaulted to `link`  */
  role: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Whether or not to use an 'on' state - works alongside 'pill' only */
  selected: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to use small button styles */
  small: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to use large button styles [blue steel only] */
  large: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** If true the button will be disabled and show a spinner */
  spinner: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** Anchor target attribute (only used if `href` is set) */
  target: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Text content of the button. You may alternately pass this in through children */
  text: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** button type attribute */
  type: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOf(['button', 'submit', 'reset']),

  /** Whether or not to style the button as a primary button */
  primary: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to style the button as a success button */
  success: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to style the button as an alert button */
  alert: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to style the button as a danger button */
  danger: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Whether or not to style the button as a toggle button [blue steel only]  */
  toggle: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Wraps the Button in a Tooltip with the specified content. Default placement is `top`*/
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Additional Props for the tooltip. */
  tooltipProps: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_14__["provideTheme"])(_Button_sass__WEBPACK_IMPORTED_MODULE_18___default.a)(Button));

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var createHTML = __webpack_require__(245);
var forcedStringHTMLMethod = __webpack_require__(246);

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(473);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Loader", function() { return _Loader__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Loader", function() { return Loader; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _util_deprecationWarning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83);
/* harmony import */ var _Loader_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(474);
/* harmony import */ var _Loader_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Loader_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(155);
/* harmony import */ var _AnimatedIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(265);








var sizes = {
  basic: {
    height: 48,
    width: 48
  },
  inline: {
    height: 16,
    width: 16
  }
};
/**
 * **Proposed** | This component is not yet approved by UX and may change.
 *
 * A loading spinner. Use `Progress` for a progress bar style loader.
 *
 * This component is not fully supported in React 0.14 due to use of certain
 * svg tags and attributes. See https://github.com/facebook/react/issues/1657
 */

function Loader(_ref) {
  var _cx;

  var className = _ref.className,
      size = _ref.size,
      testName = _ref.testName,
      style = _ref.style,
      color = _ref.color,
      theme = _ref.theme;
  var loaderClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()((_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Loader_sass__WEBPACK_IMPORTED_MODULE_5___default.a.primary, color === 'primary' || color === 'teal'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Loader_sass__WEBPACK_IMPORTED_MODULE_5___default.a.white, color === 'white'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Loader_sass__WEBPACK_IMPORTED_MODULE_5___default.a.inline, color === 'inline'), _cx));

  if (color === 'teal') {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_4__["default"])('`teal` color on a Loader is deprecated, use `primary` instead');
  }

  var width = sizes.basic.width;
  var height = sizes.basic.height;

  if (size === 'inline') {
    width = sizes.inline.width;
    height = sizes.inline.height;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Loader_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], className, _Loader_sass__WEBPACK_IMPORTED_MODULE_5___default.a.container),
    style: style,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_AnimatedIcon__WEBPACK_IMPORTED_MODULE_7__["AnimatedIcon"], {
    name: "loader",
    width: width,
    height: height,
    className: loaderClassName
  }));
}
Loader.defaultProps = {
  size: 'basic',
  color: 'primary'
};
Loader.propTypes = {
  /** Class name for the loader. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Color of the loader. */
  color: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(['primary', 'white', 'inline']),

  /** Size of the spinner in pixels. */
  size: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_6__["provideTheme"])(_Loader_sass__WEBPACK_IMPORTED_MODULE_5___default.a)(Loader));

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(475);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Loader-classic-2_3_6-3p3hL a{color:#079bb3}.Loader-classic-2_3_6-3p3hL.Loader-container-2_3_6-1HGYI,.Loader-classic-2_3_6-3p3hL .Loader-container-2_3_6-1HGYI{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.Loader-classic-2_3_6-3p3hL .Loader-primary-2_3_6-2PMfg path{stroke:#aaa}.Loader-classic-2_3_6-3p3hL .Loader-white-2_3_6-2PeWx path{stroke:#fff}.Loader-classic-2_3_6-3p3hL .Loader-inline-2_3_6-20-Z4 path{stroke:#999}.Loader-classic-2_3_6-3p3hL .Loader-rotate-2_3_6-qTI6H{animation:Loader-spin-2_3_6-2_A8a 1s linear infinite;transform-origin:center}.Loader-blueSteel-2_3_6-3lROv a{color:#08088c}.Loader-blueSteel-2_3_6-3lROv.Loader-container-2_3_6-1HGYI,.Loader-blueSteel-2_3_6-3lROv .Loader-container-2_3_6-1HGYI{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.Loader-blueSteel-2_3_6-3lROv .Loader-primary-2_3_6-2PMfg path{stroke:#8e9093}.Loader-blueSteel-2_3_6-3lROv .Loader-white-2_3_6-2PeWx path{stroke:#fff}.Loader-blueSteel-2_3_6-3lROv .Loader-inline-2_3_6-20-Z4 path{stroke:#4d5056}.Loader-blueSteel-2_3_6-3lROv .Loader-rotate-2_3_6-qTI6H{animation:Loader-spin-2_3_6-2_A8a 1s linear infinite;transform-origin:center}@keyframes Loader-spin-2_3_6-2_A8a{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"classic": "Loader-classic-2_3_6-3p3hL",
	"container": "Loader-container-2_3_6-1HGYI",
	"primary": "Loader-primary-2_3_6-2PMfg",
	"white": "Loader-white-2_3_6-2PeWx",
	"inline": "Loader-inline-2_3_6-20-Z4",
	"rotate": "Loader-rotate-2_3_6-qTI6H",
	"spin": "Loader-spin-2_3_6-2_A8a",
	"blueSteel": "Loader-blueSteel-2_3_6-3lROv"
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(477);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Button-classic-2_3_6-2ITQB a{color:#079bb3}.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe{position:relative;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:4px;font-family:Lato,Helvetica,Arial,sans-serif;font-size:1rem;display:inline-block;padding:0 1rem;line-height:34px;text-align:center;transition:transform .15s ease-out;font-weight:700;text-decoration:none!important;margin:0;white-space:nowrap}.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe+.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe+.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe+.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe+.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe{margin-left:.3333333333rem}.Button-block-2_3_6-25GRD+.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe,.Button-block-2_3_6-25GRD+.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe{margin-left:0;margin-top:.5rem}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-disabled-2_3_6-2RG11,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-spinner-2_3_6-2SVSu,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-disabled-2_3_6-2RG11,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-spinner-2_3_6-2SVSu{pointer-events:none;background-color:#ccc!important;border-color:#ccc!important;color:#fff!important}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-disabled-2_3_6-2RG11):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe:not(.Button-disabled-2_3_6-2RG11):hover{transform:translateY(-1px)}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-disabled-2_3_6-2RG11):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe:not(.Button-disabled-2_3_6-2RG11):active{transform:translateY(1px)}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU{color:#079bb3;font-weight:400}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:hover{background-color:transparent!important;border-color:transparent!important;color:#079bb3!important;transform:none}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU.Button-disabled-2_3_6-2RG11,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU.Button-disabled-2_3_6-2RG11{pointer-events:none;background-color:transparent!important;border-color:transparent!important;color:#aaa!important}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU){color:#fff;background-color:#079bb3;border:1px solid #079bb3}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU):visited{color:#fff}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU):hover{background-color:#08b0cc;border-color:#08b0cc}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x{color:#079bb3;background-color:#fff;border:1px solid #079bb3}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited{color:#057182}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-teal-2_3_6-3FCfz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover{color:#057182;background-color:#fff;border-color:#057182}.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU){color:#fff;background-color:#ef6c2a;border:1px solid #ef6c2a}.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU):hover{background-color:#f17c42;border-color:#f17c42}.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU):visited{color:#fff}.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x{color:#ef6c2a;background-color:#fff;border:1px solid #ef6c2a}.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited{color:#ef6c2a}.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-alert-2_3_6-1FIj9:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-orange-2_3_6-ND5Kz:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover{color:#d65210;background-color:#fff;border-color:#d65210}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg{border:none!important;border-radius:20px;padding:10px 15px;line-height:1em;font-size:.9333333333rem;font-weight:600;background-color:#dcf3fb!important;color:#079bb3!important}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg.Button-disabled-2_3_6-2RG11,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg.Button-disabled-2_3_6-2RG11{background-color:#ccc!important;color:#fff!important}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg.Button-selected-2_3_6-32IiW,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg.Button-selected-2_3_6-32IiW{pointer-events:none;background-color:#079bb3!important;color:#fff!important}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg:not(.Button-disabled-2_3_6-2RG11):not(.Button-selected-2_3_6-32IiW):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg:not(.Button-disabled-2_3_6-2RG11):not(.Button-selected-2_3_6-32IiW):hover{background-color:#08b0cc!important;color:#fff!important;transform:translateY(0)}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg:not(.Button-disabled-2_3_6-2RG11):not(.Button-selected-2_3_6-32IiW):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pill-2_3_6-27Qfg:not(.Button-disabled-2_3_6-2RG11):not(.Button-selected-2_3_6-32IiW):active{transform:translateY(0)}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt{color:#fff;background-color:#d32781;border:1px solid #d32781}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:hover{background-color:#da398e;border-color:#da398e}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:visited{color:#fff}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x{color:#d32781;background-color:#fff;border:1px solid #d32781}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:visited{color:#d32781}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk.Button-primary-2_3_6-2YCmt.Button-invert-2_3_6-2zF8x:hover{color:#a81f67;background-color:#fff;border-color:#a81f67}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU),.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU){color:#fff;background-color:#a2b00c;border:1px solid #a2b00c}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU):active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU):focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU):hover{background-color:#b8c80e;border-color:#b8c80e}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU):visited{color:#fff}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x{color:#a2b00c;background-color:#fff;border:1px solid #a2b00c}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:visited{color:#a2b00c}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-green-2_3_6-1nvWM:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:active,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:focus,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-success-2_3_6-rhHhW:not(.Button-href-2_3_6-34BhU).Button-invert-2_3_6-2zF8x:hover{color:#768009;background-color:#fff;border-color:#768009}.Button-classic-2_3_6-2ITQB .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-small-2_3_6-1Wurh,.Button-classic-2_3_6-2ITQB.Button-btn-2_3_6-QuPwe.Button-small-2_3_6-1Wurh{padding:0 .9rem;line-height:26px;font-size:.9rem}.Button-classic-2_3_6-2ITQB .Button-hideBtnText-2_3_6-2UUf2{visibility:hidden}.Button-classic-2_3_6-2ITQB .Button-spinner-2_3_6-2SVSu{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);line-height:normal}.Button-classic-2_3_6-2ITQB.Button-block-2_3_6-25GRD{display:block;width:100%}.Button-btn-2_3_6-QuPwe+.Button-classic-2_3_6-2ITQB.Button-block-2_3_6-25GRD,.Button-classic-2_3_6-2ITQB.Button-block-2_3_6-25GRD+.Button-tooltipContainer-2_3_6-RyuCs,.Button-tooltipContainer-2_3_6-RyuCs+.Button-classic-2_3_6-2ITQB.Button-block-2_3_6-25GRD{margin-left:0;margin-top:.5rem}.Button-blueSteel-2_3_6-3Skod a{color:#08088c}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-href-2_3_6-34BhU),.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe:not(.Button-href-2_3_6-34BhU){background-color:#fff;border:1px solid #fff}.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe{position:relative;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:1px;font-family:Public Sans,sans-serif;font-size:14px;display:inline-block;padding:0 12px;line-height:32px;text-align:center;transition:transform .15s ease-out;font-weight:700;text-decoration:none!important;margin:0;white-space:nowrap;height:36px;color:#08088c}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-primary-2_3_6-2YCmt),.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe:not(.Button-primary-2_3_6-2YCmt){border:1px solid #e5e6e6}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-primary-2_3_6-2YCmt):focus-visible,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe:not(.Button-primary-2_3_6-2YCmt):focus-visible{outline:1px solid #092dbd;outline-offset:1px}.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe+.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe+.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe+.Button-tooltipContainer-2_3_6-RyuCs,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe+.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe+.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe+.Button-tooltipContainer-2_3_6-RyuCs,.Button-tooltipContainer-2_3_6-RyuCs+.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe,.Button-tooltipContainer-2_3_6-RyuCs+.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe{margin-left:.3333333333rem}.Button-block-2_3_6-25GRD+.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe,.Button-block-2_3_6-25GRD+.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe{margin-left:0;margin-top:.5rem}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-spinner-2_3_6-2SVSu,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-spinner-2_3_6-2SVSu{color:#8e9093;pointer-events:none;background-color:#f2f2f3;border-color:#f2f2f3}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-spinner-2_3_6-2SVSu:focus-visible,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-spinner-2_3_6-2SVSu:focus-visible{outline:1px solid #092dbd;outline-offset:1px}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-disabled-2_3_6-2RG11,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-disabled-2_3_6-2RG11{pointer-events:none;background-color:#f2f2f3!important;border-color:#f2f2f3!important;color:#8e9093!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-disabled-2_3_6-2RG11:not(.Button-primary-2_3_6-2YCmt),.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-disabled-2_3_6-2RG11:not(.Button-primary-2_3_6-2YCmt){border-color:#f2f2f3!important;background-color:#f9f9f9!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-disabled-2_3_6-2RG11):hover,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-href-2_3_6-34BhU):hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe:not(.Button-disabled-2_3_6-2RG11):hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe:not(.Button-href-2_3_6-34BhU):hover{background-color:#d7dbea!important;border-color:#d7dbea!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-disabled-2_3_6-2RG11):active,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe:not(.Button-href-2_3_6-34BhU):active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe:not(.Button-disabled-2_3_6-2RG11):active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe:not(.Button-href-2_3_6-34BhU):active{transform:translateY(1px);background-color:#d7dbea!important;border-color:#d7dbea!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU{color:#08088c;font-weight:400}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:active,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:hover{background-color:transparent!important;border-color:transparent!important;color:#08088c!important;transform:none}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:focus-visible,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU:focus-visible{outline:1px solid #092dbd;outline-offset:1px}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU.Button-disabled-2_3_6-2RG11,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-href-2_3_6-34BhU.Button-disabled-2_3_6-2RG11{pointer-events:none;background-color:transparent!important;border-color:transparent!important;color:#8e9093!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU),.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU){color:#fff;background-color:#092dbd;border:1px solid #092dbd}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-spinner-2_3_6-2SVSu,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-spinner-2_3_6-2SVSu{color:#fff;background-color:#08088c;border-color:#08088c}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-spinner-2_3_6-2SVSu.Button-danger-2_3_6-17vLS,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-spinner-2_3_6-2SVSu.Button-pink-2_3_6-1e0lk,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-spinner-2_3_6-2SVSu.Button-danger-2_3_6-17vLS,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-spinner-2_3_6-2SVSu.Button-pink-2_3_6-1e0lk{color:#8e9093;background-color:#fdf6f3!important;border-color:#fdf6f3!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):visited,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):visited{color:#fff}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):active,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):hover{background-color:#08088c!important;border-color:#08088c!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):focus-visible,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU):focus-visible{outline:1px solid #092dbd;outline-offset:1px}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk{color:#d33d00;background-color:#fff;border:1px solid #fff}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS:active,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS:hover,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk:active,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk:hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS:active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS:hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk:active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk:hover{background-color:#fdf6f3!important;border-color:#fdf6f3!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS:visited,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk:visited,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS:visited,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk:visited{color:#fff}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS:focus-visible,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk:focus-visible,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-danger-2_3_6-17vLS:focus-visible,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-primary-2_3_6-2YCmt:not(.Button-href-2_3_6-34BhU).Button-pink-2_3_6-1e0lk:focus-visible{outline:1px solid #d33d00;outline-offset:1px}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk{color:#d33d00;background-color:#fff;border:1px solid #fff}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:active,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:hover,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:active,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:hover{background-color:#fdf6f3!important;border-color:#fdf6f3!important}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:visited,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:visited,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:visited,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:visited{color:#fff}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:focus-visible,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:focus-visible,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-danger-2_3_6-17vLS:focus-visible,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-pink-2_3_6-1e0lk:focus-visible{outline:1px solid #d33d00;outline-offset:1px}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-small-2_3_6-1Wurh,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-small-2_3_6-1Wurh{padding:0 8px;line-height:20px;height:24px;font-size:14px}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-large-2_3_6-18gYv,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-large-2_3_6-18gYv{padding:0 16px;line-height:48px;height:48px;font-size:16px}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-toggle-2_3_6-1hqpF,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-toggle-2_3_6-1hqpF{color:#01050e;background-color:#cccdcd;border-color:#cccdcd}.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-toggle-2_3_6-1hqpF:active,.Button-blueSteel-2_3_6-3Skod .Button-btn-2_3_6-QuPwe.Button-btn-2_3_6-QuPwe.Button-toggle-2_3_6-1hqpF:hover,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-toggle-2_3_6-1hqpF:active,.Button-blueSteel-2_3_6-3Skod.Button-btn-2_3_6-QuPwe.Button-toggle-2_3_6-1hqpF:hover{background-color:#d7dbea;border-color:#cccdcd}.Button-blueSteel-2_3_6-3Skod .Button-hideBtnText-2_3_6-2UUf2{visibility:hidden}.Button-blueSteel-2_3_6-3Skod .Button-spinner-2_3_6-2SVSu{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);line-height:normal}.Button-blueSteel-2_3_6-3Skod.Button-block-2_3_6-25GRD{display:block;width:100%}.Button-blueSteel-2_3_6-3Skod.Button-block-2_3_6-25GRD+.Button-tooltipContainer-2_3_6-RyuCs,.Button-btn-2_3_6-QuPwe+.Button-blueSteel-2_3_6-3Skod.Button-block-2_3_6-25GRD,.Button-tooltipContainer-2_3_6-RyuCs+.Button-blueSteel-2_3_6-3Skod.Button-block-2_3_6-25GRD{margin-left:0;margin-top:.5rem}", ""]);

// exports
exports.locals = {
	"classic": "Button-classic-2_3_6-2ITQB",
	"btn": "Button-btn-2_3_6-QuPwe",
	"block": "Button-block-2_3_6-25GRD",
	"disabled": "Button-disabled-2_3_6-2RG11",
	"spinner": "Button-spinner-2_3_6-2SVSu",
	"href": "Button-href-2_3_6-34BhU",
	"teal": "Button-teal-2_3_6-3FCfz",
	"primary": "Button-primary-2_3_6-2YCmt",
	"invert": "Button-invert-2_3_6-2zF8x",
	"orange": "Button-orange-2_3_6-ND5Kz",
	"alert": "Button-alert-2_3_6-1FIj9",
	"pill": "Button-pill-2_3_6-27Qfg",
	"selected": "Button-selected-2_3_6-32IiW",
	"pink": "Button-pink-2_3_6-1e0lk",
	"danger": "Button-danger-2_3_6-17vLS",
	"green": "Button-green-2_3_6-1nvWM",
	"success": "Button-success-2_3_6-rhHhW",
	"small": "Button-small-2_3_6-1Wurh",
	"hideBtnText": "Button-hideBtnText-2_3_6-2UUf2",
	"tooltipContainer": "Button-tooltipContainer-2_3_6-RyuCs",
	"blueSteel": "Button-blueSteel-2_3_6-3Skod",
	"large": "Button-large-2_3_6-18gYv",
	"toggle": "Button-toggle-2_3_6-1hqpF"
};

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _MenuItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(479);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return _MenuItem__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return MenuItem; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2);
/* harmony import */ var _MenuItem_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(480);
/* harmony import */ var _MenuItem_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_MenuItem_sass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(155);









/**
A menu item with supporting disabled and selected states.
*/

function MenuItem(_ref) {
  var _cx;

  var className = _ref.className,
      testName = _ref.testName,
      style = _ref.style,
      children = _ref.children,
      selected = _ref.selected,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect,
      Component = _ref.Component,
      invert = _ref.invert,
      theme = _ref.theme,
      isAutosuggest = _ref.isAutosuggest,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["className", "testName", "style", "children", "selected", "disabled", "onSelect", "Component", "invert", "theme", "isAutosuggest"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    style: style,
    tabIndex: 0,
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_MenuItem_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme], _MenuItem_sass__WEBPACK_IMPORTED_MODULE_7___default.a.menuItem, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _MenuItem_sass__WEBPACK_IMPORTED_MODULE_7___default.a.selected, selected), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _MenuItem_sass__WEBPACK_IMPORTED_MODULE_7___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _MenuItem_sass__WEBPACK_IMPORTED_MODULE_7___default.a.invert, invert), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _MenuItem_sass__WEBPACK_IMPORTED_MODULE_7___default.a.autosuggest, isAutosuggest), _cx)),
    "aria-disabled": disabled,
    "data-test-name": testName,
    onClick: onSelect,
    onKeyDown: Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_6__["handleKeyboardClick"])(onSelect)
  }, rest), children);
}
MenuItem.defaultProps = {
  Component: 'li',
  isAutosuggest: false
};
MenuItem.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
  Component: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func]),
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  isAutosuggest: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  selected: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_8__["provideTheme"])(_MenuItem_sass__WEBPACK_IMPORTED_MODULE_7___default.a)(MenuItem));

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(481);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".MenuItem-menu-2_3_6-2bbV4{padding:0;margin:0}.MenuItem-classic-2_3_6-37sfh a{color:#079bb3}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG{display:block;list-style-type:none;font-weight:600;padding:.5rem .6666666667rem;color:#444;background-color:#fff;transition:color .2s ease,background-color .2s ease}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-disabled-2_3_6-2VkdD,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-disabled-2_3_6-2VkdD{pointer-events:none;color:#a2a2a2}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG:not(.MenuItem-disabled-2_3_6-2VkdD),.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG:not(.MenuItem-disabled-2_3_6-2VkdD){cursor:pointer}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG:not(.MenuItem-disabled-2_3_6-2VkdD):hover,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG:not(.MenuItem-disabled-2_3_6-2VkdD):hover{background-color:#eee}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-selected-2_3_6-1Dleu,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-selected-2_3_6-1Dleu{color:#fff;background-color:#079bb3}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-selected-2_3_6-1Dleu:hover,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-selected-2_3_6-1Dleu:hover{background-color:#079bb3}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO{background-color:#444;color:#fff}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-disabled-2_3_6-2VkdD,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-disabled-2_3_6-2VkdD{color:gray}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO:not(.MenuItem-disabled-2_3_6-2VkdD):hover,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO:not(.MenuItem-disabled-2_3_6-2VkdD):hover{background-color:#333}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-selected-2_3_6-1Dleu,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-selected-2_3_6-1Dleu{color:#fff;background-color:#079bb3}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-selected-2_3_6-1Dleu:hover,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-selected-2_3_6-1Dleu:hover{background-color:#079bb3}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS{color:#666;font-weight:400;font-size:1rem;background-color:hsla(0,0%,100%,.8)}.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS.MenuItem-selected-2_3_6-1Dleu,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS.MenuItem-selected-2_3_6-1Dleu,.MenuItem-classic-2_3_6-37sfh.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS:hover,.MenuItem-classic-2_3_6-37sfh .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS:hover{background-color:#dcf3fb;color:#444}.MenuItem-blueSteel-2_3_6-1taGn a{color:#08088c}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG{display:block;list-style-type:none;font-weight:600;padding:.5rem .6666666667rem;color:#01050e;background-color:#fff;transition:color .2s ease,background-color .2s ease}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-disabled-2_3_6-2VkdD,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-disabled-2_3_6-2VkdD{pointer-events:none;color:#656971}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG:not(.MenuItem-disabled-2_3_6-2VkdD),.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG:not(.MenuItem-disabled-2_3_6-2VkdD){cursor:pointer}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG:not(.MenuItem-disabled-2_3_6-2VkdD):hover,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG:not(.MenuItem-disabled-2_3_6-2VkdD):hover{background-color:#f9f9f9}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-selected-2_3_6-1Dleu,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-selected-2_3_6-1Dleu{color:#fff;background-color:#08088c}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-selected-2_3_6-1Dleu:hover,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-selected-2_3_6-1Dleu:hover{background-color:#08088c}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO{background-color:#01050e;color:#fff}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-disabled-2_3_6-2VkdD,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-disabled-2_3_6-2VkdD{color:#d7d7db}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO:not(.MenuItem-disabled-2_3_6-2VkdD):hover,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO:not(.MenuItem-disabled-2_3_6-2VkdD):hover{background-color:#030d28}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-selected-2_3_6-1Dleu,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-selected-2_3_6-1Dleu{color:#fff;background-color:#08088c}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-selected-2_3_6-1Dleu:hover,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-invert-2_3_6-1vXXO.MenuItem-selected-2_3_6-1Dleu:hover{background-color:#08088c}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS{color:#4d5056;font-weight:400;font-size:1rem;background-color:#f9f9f9}.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS.MenuItem-selected-2_3_6-1Dleu,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS.MenuItem-selected-2_3_6-1Dleu,.MenuItem-blueSteel-2_3_6-1taGn.MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS:hover,.MenuItem-blueSteel-2_3_6-1taGn .MenuItem-menuItem-2_3_6-1YNUG.MenuItem-autosuggest-2_3_6-16OtS:hover{background-color:#d7dbea;color:#01050e}", ""]);

// exports
exports.locals = {
	"menu": "MenuItem-menu-2_3_6-2bbV4",
	"classic": "MenuItem-classic-2_3_6-37sfh",
	"menuItem": "MenuItem-menuItem-2_3_6-1YNUG",
	"disabled": "MenuItem-disabled-2_3_6-2VkdD",
	"selected": "MenuItem-selected-2_3_6-1Dleu",
	"invert": "MenuItem-invert-2_3_6-1vXXO",
	"autosuggest": "MenuItem-autosuggest-2_3_6-16OtS",
	"blueSteel": "MenuItem-blueSteel-2_3_6-1taGn"
};

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(367);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Autosave__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(235);
/* harmony import */ var _TagListInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(407);






function AutosaveTagListSuggestions(_ref) {
  var autosaveProps = Object.assign({}, _ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Autosave__WEBPACK_IMPORTED_MODULE_3__["Autosave"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    Component: _TagListInput__WEBPACK_IMPORTED_MODULE_4__["AutosuggestTagListInput"],
    fieldType: "autosuggest-taglist"
  }, autosaveProps));
}

/* harmony default export */ __webpack_exports__["default"] = (AutosaveTagListSuggestions);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(484);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return _Async__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var js_components_Loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(472);
/* harmony import */ var js_components_Hideable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(231);
/* harmony import */ var js_components_Fadeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(201);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);
/* harmony import */ var _Loader_Loader_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(474);
/* harmony import */ var _Loader_Loader_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Loader_Loader_sass__WEBPACK_IMPORTED_MODULE_8__);









/**
 * **Proposed** | This component is not yet approved by UX and may change.
 *
 * A container for presenting a spinner while asynchronous content loads.
 *
 * This component is not fully supported in React 0.14 due to use of certain
 * svg tags and attributes. See https://github.com/facebook/react/issues/1657
 */

function Async(_ref) {
  var children = _ref.children,
      className = _ref.className,
      fadeableProps = _ref.fadeableProps,
      loaderProps = _ref.loaderProps,
      loading = _ref.loading,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Loader_Loader_sass__WEBPACK_IMPORTED_MODULE_8___default.a[theme], className);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classes,
    style: style,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(js_components_Fadeable__WEBPACK_IMPORTED_MODULE_6__["Fadeable"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    show: !loading
  }, fadeableProps), children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_5__["Hideable"], {
    show: loading
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(js_components_Loader__WEBPACK_IMPORTED_MODULE_4__["Loader"], loaderProps)));
}
Async.propTypes = {
  /** Content to render once loading is true */
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,

  /** Container className */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** props to pass along to the `Fadeable` wrapper around your content */
  fadeableProps: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,

  /** props to pass along to `Loader` */
  loaderProps: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,

  /** Whether or not to show the `Loader` */
  loading: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_Loader_Loader_sass__WEBPACK_IMPORTED_MODULE_8___default.a)(Async));

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Blast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(486);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Blast", function() { return _Blast__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Blast", function() { return Blast; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(229);
/* harmony import */ var _Blast_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(487);
/* harmony import */ var _Blast_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Blast_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(155);






/**
 * Blasts are used for persistent warnings, such as breaking updates to Gallery
 * templates and restricted trials. They use the orange warning color. They
 * extend the full width of the main page area and appear just under the header.
 */

function Blast(props) {
  var className = props.className,
      testName = props.testName,
      style = props.style,
      children = props.children,
      onClose = props.onClose,
      theme = props.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Alert__WEBPACK_IMPORTED_MODULE_3__["Alert"], {
    theme: theme,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Blast_sass__WEBPACK_IMPORTED_MODULE_4___default.a.blast, className),
    block: true,
    onClose: onClose,
    type: "warning",
    style: style,
    "data-test-name": testName
  }, children);
}
Blast.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /**
   * Handler for when the close button is clicked. If this function is not
   * provided, the close button will not be shown.
   */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_5__["provideTheme"])(_Blast_sass__WEBPACK_IMPORTED_MODULE_4___default.a)(Blast));

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(488);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Blast-blast-2_3_6-2fJVa{border-radius:0}", ""]);

// exports
exports.locals = {
	"blast": "Blast-blast-2_3_6-2fJVa"
};

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Breadcrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(490);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return _Breadcrumbs__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(493);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return Breadcrumbs; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(491);
/* harmony import */ var _Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);





/**
 * The Breadcrumbs component is a container for BreadcrumbItem components. It
 * should be positioned within the page header above the header text. The
 * BreadcrumbItems should link back to parent-level pages in hierarchical order
 * with the top-most hierarchical link listed as the first child of the
 * Breadcrumbs component. The breadcrumb links should not include the current
 * page.
 */

function Breadcrumbs(props) {
  var className = props.className,
      testName = props.testName,
      style = props.style,
      theme = props.theme,
      children = props.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("nav", {
    "aria-label": "Breadcrumb",
    className: className,
    style: style,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("ol", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_2___default.a[theme], _Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_2___default.a.container)
  }, children));
}
Breadcrumbs.propTypes = {
  /** Component contents. This should be a list of `BreadcrumbItem`s */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_4__["provideTheme"])(_Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_2___default.a)(Breadcrumbs));

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(492);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Breadcrumbs-classic-2_3_6-1ly-b a{color:#079bb3}.Breadcrumbs-classic-2_3_6-1ly-b.Breadcrumbs-container-2_3_6-1ehV3,.Breadcrumbs-classic-2_3_6-1ly-b .Breadcrumbs-container-2_3_6-1ehV3{margin:0;padding:0}.Breadcrumbs-classic-2_3_6-1ly-b.Breadcrumbs-breadcrumbItem-2_3_6-2MMeB,.Breadcrumbs-classic-2_3_6-1ly-b .Breadcrumbs-breadcrumbItem-2_3_6-2MMeB{display:inline-block;list-style-type:none;font-size:.9333333333rem}.Breadcrumbs-classic-2_3_6-1ly-b.Breadcrumbs-breadcrumbItem-2_3_6-2MMeB:not(:last-child),.Breadcrumbs-classic-2_3_6-1ly-b .Breadcrumbs-breadcrumbItem-2_3_6-2MMeB:not(:last-child){margin-right:.5rem}.Breadcrumbs-classic-2_3_6-1ly-b.Breadcrumbs-breadcrumbItem-2_3_6-2MMeB:not(:last-child):after,.Breadcrumbs-classic-2_3_6-1ly-b .Breadcrumbs-breadcrumbItem-2_3_6-2MMeB:not(:last-child):after{content:\"\\203A\";margin-left:.5rem;font-size:1.2em;font-weight:700}.Breadcrumbs-classic-2_3_6-1ly-b.Breadcrumbs-breadcrumbItem-2_3_6-2MMeB a,.Breadcrumbs-classic-2_3_6-1ly-b .Breadcrumbs-breadcrumbItem-2_3_6-2MMeB a{text-decoration:none}.Breadcrumbs-blueSteel-2_3_6-xjRA_ a{color:#08088c}.Breadcrumbs-blueSteel-2_3_6-xjRA_.Breadcrumbs-container-2_3_6-1ehV3,.Breadcrumbs-blueSteel-2_3_6-xjRA_ .Breadcrumbs-container-2_3_6-1ehV3{margin:0;padding:0}.Breadcrumbs-blueSteel-2_3_6-xjRA_.Breadcrumbs-breadcrumbItem-2_3_6-2MMeB,.Breadcrumbs-blueSteel-2_3_6-xjRA_ .Breadcrumbs-breadcrumbItem-2_3_6-2MMeB{display:inline-block;list-style-type:none;font-size:.9333333333rem}.Breadcrumbs-blueSteel-2_3_6-xjRA_.Breadcrumbs-breadcrumbItem-2_3_6-2MMeB:not(:last-child),.Breadcrumbs-blueSteel-2_3_6-xjRA_ .Breadcrumbs-breadcrumbItem-2_3_6-2MMeB:not(:last-child){margin-right:.5rem}.Breadcrumbs-blueSteel-2_3_6-xjRA_.Breadcrumbs-breadcrumbItem-2_3_6-2MMeB:not(:last-child):after,.Breadcrumbs-blueSteel-2_3_6-xjRA_ .Breadcrumbs-breadcrumbItem-2_3_6-2MMeB:not(:last-child):after{content:\"\\203A\";margin-left:.5rem;font-size:1.2em;font-weight:700}.Breadcrumbs-blueSteel-2_3_6-xjRA_.Breadcrumbs-breadcrumbItem-2_3_6-2MMeB a,.Breadcrumbs-blueSteel-2_3_6-xjRA_ .Breadcrumbs-breadcrumbItem-2_3_6-2MMeB a{text-decoration:none}", ""]);

// exports
exports.locals = {
	"classic": "Breadcrumbs-classic-2_3_6-1ly-b",
	"container": "Breadcrumbs-container-2_3_6-1ehV3",
	"breadcrumbItem": "Breadcrumbs-breadcrumbItem-2_3_6-2MMeB",
	"blueSteel": "Breadcrumbs-blueSteel-2_3_6-xjRA_"
};

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return BreadcrumbItem; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(491);
/* harmony import */ var _Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);





/**
 * The BreadcrumbItem component is meant to be used as a child to a Breadcrumbs
 * container component. The BreadcrumbItem should contain a link back to a
 * previous, parent-level view.
 */

function BreadcrumbItem(props) {
  var children = props.children,
      className = props.className,
      style = props.style,
      theme = props.theme,
      testName = props.testName;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", {
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_3___default.a[theme], _Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_3___default.a.breadcrumbItem, className),
    "data-test-name": testName
  }, children);
}
BreadcrumbItem.propTypes = {
  /** Component contents. This should ultimately render to an `a` tag */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_4__["provideTheme"])(_Breadcrumbs_sass__WEBPACK_IMPORTED_MODULE_3___default.a)(BreadcrumbItem));

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ButtonGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(495);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return _ButtonGroup__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ButtonGroup; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ButtonGroup_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(496);
/* harmony import */ var _ButtonGroup_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ButtonGroup_sass__WEBPACK_IMPORTED_MODULE_4__);





/**
 * A container for arranging multiple buttons and/or inputs horizontally. If
 * you need to layout other types of content or if ButtonGroup doesn't support
 * your particular layout see [`<Flex>`](/#!/Flex).
 */

function ButtonGroup(props) {
  var _classNames;

  var alignRight = props.alignRight,
      alignCenter = props.alignCenter,
      style = props.style,
      className = props.className,
      testName = props.testName;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    style: style,
    "data-test-name": testName,
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_ButtonGroup_sass__WEBPACK_IMPORTED_MODULE_4___default.a.wrapper, className, (_classNames = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_classNames, _ButtonGroup_sass__WEBPACK_IMPORTED_MODULE_4___default.a.alignRight, alignRight), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_classNames, _ButtonGroup_sass__WEBPACK_IMPORTED_MODULE_4___default.a.alignCenter, alignCenter), _classNames))
  }, props.children);
}
ButtonGroup.defaultProps = {
  alignRight: false,
  alignCenter: false
};
ButtonGroup.propTypes = {
  /** Center content. */
  alignCenter: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Align content to the right. */
  alignRight: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Items to group together. Usually Buttons. */
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node.isRequired,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(497);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".ButtonGroup-wrapper-2_3_6-3RtS3{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.ButtonGroup-wrapper-2_3_6-3RtS3>*{margin-bottom:0!important}.ButtonGroup-wrapper-2_3_6-3RtS3>:not(:first-child){margin-left:.3333333333rem}.ButtonGroup-alignRight-2_3_6-1G3bA{-ms-flex-pack:end;justify-content:flex-end;width:100%}.ButtonGroup-alignCenter-2_3_6-3YQMV{-ms-flex-pack:center;justify-content:center;width:100%}", ""]);

// exports
exports.locals = {
	"wrapper": "ButtonGroup-wrapper-2_3_6-3RtS3",
	"alignRight": "ButtonGroup-alignRight-2_3_6-1G3bA",
	"alignCenter": "ButtonGroup-alignCenter-2_3_6-3YQMV"
};

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Card__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(499);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return _Card__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _CardHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(502);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return _CardHeader__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _CardBody__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(510);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardBody", function() { return _CardBody__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _CardFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(511);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CardFooter", function() { return _CardFooter__WEBPACK_IMPORTED_MODULE_3__["default"]; });










/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return Card; });
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(382);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(155);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(195);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(500);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Card_sass__WEBPACK_IMPORTED_MODULE_8__);









/**
 * Card is a flexible content container for a housing related information.
 * A card is made up of 3 sections - header, content area, and footer.
 */

function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;
  var childrenArr = react__WEBPACK_IMPORTED_MODULE_3___default.a.Children.toArray(children);
  var header = childrenArr.find(function (child) {
    return child && child.type.name === 'CardHeader';
  });
  var hasActions = header && ('actions' in header.props || 'mainAction' in header.props);

  if (hasActions) {
    childrenArr = childrenArr.filter(function (child) {
      return child.type.name !== 'CardFooter';
    });
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_7__["Flex"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(_Card_sass__WEBPACK_IMPORTED_MODULE_8___default.a[theme], _Card_sass__WEBPACK_IMPORTED_MODULE_8___default.a.card, className),
    flexDirection: "column",
    "data-test-name": testName,
    style: style
  }, childrenArr);
}
Card.propTypes = {
  /** Content to be displayed within the Card*/
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Apply a custom class to the outermost element */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_5__["provideTheme"])(_Card_sass__WEBPACK_IMPORTED_MODULE_8___default.a)(Card));

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(501);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Card-classic-2_3_6-1ma7T a{color:#079bb3}.Card-blueSteel-2_3_6-pRVi2 a{color:#08088c}.Card-card-2_3_6-VeJGN{background:#fff;padding:24px;border:1px solid #e5e6e6;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;min-width:304px}@media screen and (max-width:320px){.Card-card-2_3_6-VeJGN{padding:16px;margin-left:8px;margin-right:8px}}.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-content-2_3_6-34Ncs{font-weight:700;font-size:1rem}.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-title-2_3_6-_8nAg{-ms-flex:0 1 auto;flex:0 1 auto;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;word-wrap:break-word;min-width:0;margin:0}.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-tooltip-2_3_6-2GC3h{margin-left:8px}.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-description-2_3_6-2xxG2{margin-top:8px}.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-actions-2_3_6-C3mBL{display:-ms-flexbox;display:flex;white-space:nowrap;-ms-flex-pack:end;justify-content:flex-end;-ms-flex:1 1 auto;flex:1 1 auto}.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-actions-2_3_6-C3mBL .Card-iconButton-2_3_6-3kDvY,.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-actions-2_3_6-C3mBL .Card-iconButton-2_3_6-3kDvY div[role=button]{padding:0}.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-actions-2_3_6-C3mBL .Card-dropdownMenu-2_3_6-25Iwm{margin-left:12px}.Card-card-2_3_6-VeJGN .Card-header-2_3_6-2JhDI .Card-truncate-2_3_6-1QUBk .Card-content-2_3_6-34Ncs{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.Card-card-2_3_6-VeJGN .Card-body-2_3_6-ZaCnV{margin-top:24px}.Card-card-2_3_6-VeJGN .Card-footer-2_3_6-CAu1X{margin-top:16px;width:100%;color:#08088c}.Card-card-2_3_6-VeJGN .Card-footer-2_3_6-CAu1X a,.Card-card-2_3_6-VeJGN .Card-footer-2_3_6-CAu1X div{text-decoration:none;font-size:.875rem;font-weight:700;cursor:pointer}.Card-card-2_3_6-VeJGN .Card-footer-2_3_6-CAu1X .Card-icon-2_3_6-1w-P3{margin-right:8px}", ""]);

// exports
exports.locals = {
	"classic": "Card-classic-2_3_6-1ma7T",
	"card": "Card-card-2_3_6-VeJGN",
	"header": "Card-header-2_3_6-2JhDI",
	"content": "Card-content-2_3_6-34Ncs",
	"title": "Card-title-2_3_6-_8nAg",
	"tooltip": "Card-tooltip-2_3_6-2GC3h",
	"description": "Card-description-2_3_6-2xxG2",
	"actions": "Card-actions-2_3_6-C3mBL",
	"iconButton": "Card-iconButton-2_3_6-3kDvY",
	"dropdownMenu": "Card-dropdownMenu-2_3_6-25Iwm",
	"truncate": "Card-truncate-2_3_6-1QUBk",
	"body": "Card-body-2_3_6-ZaCnV",
	"footer": "Card-footer-2_3_6-CAu1X",
	"icon": "Card-icon-2_3_6-1w-P3",
	"blueSteel": "Card-blueSteel-2_3_6-pRVi2"
};

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CardHeader; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(195);
/* harmony import */ var _ToolTip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(198);
/* harmony import */ var _Hideable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(231);
/* harmony import */ var _CardHeaderAction__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(503);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(500);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Card_sass__WEBPACK_IMPORTED_MODULE_9__);










/**
 * Header section for the Card component
 *
 */

function CardHeader(_ref) {
  var actions = _ref.actions,
      description = _ref.description,
      mainAction = _ref.mainAction,
      testName = _ref.testName,
      title = _ref.title,
      tooltipText = _ref.tooltipText;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(false),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState, 2),
      isOverflow = _useState2[0],
      setOverflowing = _useState2[1];

  var measuredRef = Object(react__WEBPACK_IMPORTED_MODULE_3__["useCallback"])(function (node) {
    if (node !== null) {
      setOverflowing(node.scrollWidth - node.getBoundingClientRect().width > 1);
    }
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_5__["Flex"], {
    flexDirection: "column",
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_9___default.a.header,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_5__["Flex"], {
    alignItems: "center",
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_9___default.a.truncate
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_ToolTip__WEBPACK_IMPORTED_MODULE_6__["ToolTip"], {
    placement: "top",
    portal: true,
    block: true,
    content: title,
    active: isOverflow,
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_9___default.a.title
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_9___default.a.content,
    ref: measuredRef
  }, title)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_7__["Hideable"], {
    show: Boolean(tooltipText)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_ToolTip__WEBPACK_IMPORTED_MODULE_6__["ToolTip"], {
    content: tooltipText,
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_9___default.a.tooltip
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_7__["Hideable"], {
    show: Boolean(actions || mainAction)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_CardHeaderAction__WEBPACK_IMPORTED_MODULE_8__["default"], {
    mainAction: mainAction,
    actions: actions
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_7__["Hideable"], {
    show: Boolean(description)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_9___default.a.description
  }, description)));
}
CardHeader.propTypes = {
  /** Text for Card's description*/
  description: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Actions for the header.
   * When two or less, they will be displayed as IconButtons.
   * Three or more are collapsed into a dropdown menu
   */
  actions: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.shape({
    iconName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string.isRequired,
    label: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string.isRequired,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func.isRequired
  })),

  /**
   * Additional action that will not be collapsed in the dropdown menu.
   * Styling may be required to offset the action's internal padding to match design spacing
   * */
  mainAction: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.element,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Title for the card. Always required*/
  title: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node.isRequired,

  /** Text for the information tooltip next to the title*/
  tooltipText: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CardHeaderAction; });
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _DropdownMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(504);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(242);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(500);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Card_sass__WEBPACK_IMPORTED_MODULE_6__);







/**
 * Helper component for the Header Actions
 *
 */

function CardHeaderAction(_ref) {
  var mainAction = _ref.mainAction,
      actions = _ref.actions;

  var renderActions = function renderActions() {
    if (!actions && !mainAction) return null;

    if (!actions && mainAction) {
      return mainAction;
    }

    if (actions.length <= 2 && !mainAction) {
      return actions.map(function (action, index) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_4__["IconButton"], {
          name: action.iconName,
          label: action.label,
          key: index,
          onClick: action.onClick,
          className: _Card_sass__WEBPACK_IMPORTED_MODULE_6___default.a.iconButton
        });
      });
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, mainAction, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_DropdownMenu__WEBPACK_IMPORTED_MODULE_3__["DropdownMenu"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Card_sass__WEBPACK_IMPORTED_MODULE_6___default.a.iconButton, _Card_sass__WEBPACK_IMPORTED_MODULE_6___default.a.dropdownMenu),
      label: "Actions",
      iconName: 'more_horizontal'
    }, actions.map(function (action, index) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_DropdownMenu__WEBPACK_IMPORTED_MODULE_3__["DropdownMenuItem"], {
        onClick: action.onClick,
        key: index
      }, action.label);
    })));
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_6___default.a.actions
  }, renderActions());
}
CardHeaderAction.propTypes = {
  /** Actions for the header.
   * When two or less, they will be displayed as IconButtons.
   * Three or more are collapsed into a dropdown menu
   */
  actions: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    iconName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string.isRequired,
    label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string.isRequired,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired
  })),

  /** Additional action that will not be collapsed in the dropdown menu */
  mainAction: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.element
};

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _DropdownMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(505);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return _DropdownMenu__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _DropdownMenuItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(509);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownMenuItem", function() { return _DropdownMenuItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return DropdownMenu; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(506);
/* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(tabbable__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(155);
/* harmony import */ var js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(0);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2);
/* harmony import */ var _DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(507);
/* harmony import */ var _DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_9__);










/**
 A dropdown menu triggered by a button.

 __Accessibility notes:__
 - The menu can be toggled with the down arrow, space or enter keys.
 - When the menu is shown it will focus the entire menu by default.
 - When the menu is dismissed the button is refocused automatically.
 - When the menu is shown the down and up arrow keys can be used to move focus
 up and down through menu items (wrapping from the last to the first and first
 to last).
 - When the menu is shown, pressing the tab key will advance focus through the
 menu items. Shift+tab moves focus backwards through the tab order.
 - Focus is trapped within the menu (moving from last to first and first to last
 when moving in reverse).
 - Pressing the escape key dismisses the menu.
 - Screen readers identify the menu button has having a popup.
 - Screen readers identify the menu as a menu.
 - Screen readers identify menu items as menu items.
 - Screen readers detect when the menu is expanded.
 - Screen readers do not attempt to read the dropdown caret.
 */

function DropdownMenu(_ref) {
  var alignRight = _ref.alignRight,
      buttonProps = _ref.buttonProps,
      children = _ref.children,
      className = _ref.className,
      convertSingletonToButton = _ref.convertSingletonToButton,
      disabled = _ref.disabled,
      iconName = _ref.iconName,
      label = _ref.label,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(null),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_useState, 2),
      contentEl = _useState2[0],
      setContentEl = _useState2[1];

  var handleKeyDown = function handleKeyDown(evt) {
    Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_8__["default"])(evt).on({
      down: function down() {
        // Move focus down to next item (or wrap to first)
        var tabbables = getTabbableElements();
        var tabbableIndex = tabbables.indexOf(evt.target);

        if (tabbableIndex > -1) {
          var first = tabbables[0];
          var last = tabbables[tabbables.length - 1];
          evt.target === last ? first.focus() : tabbables[tabbableIndex + 1].focus();
          evt.preventDefault();
        } else if (tabbables.length > 0) {
          // target is outside of menu (probably the menu container)
          // focus the first item
          tabbables[0].focus();
        }
      },
      up: function up() {
        // Move focus up to previous item (or wrap to last)
        var tabbables = getTabbableElements();
        var tabbableIndex = tabbables.indexOf(evt.target);

        if (tabbableIndex > -1) {
          var first = tabbables[0];
          var last = tabbables[tabbables.length - 1];
          evt.target === first ? last.focus() : tabbables[tabbableIndex - 1].focus();
          evt.preventDefault();
        } else if (tabbables.length > 0) {
          // target is outside of menu (probably the menu container)
          // focus the last item
          tabbables[tabbables.length - 1].focus();
        }
      },
      home: function home() {
        // Focus first element
        var tabbables = getTabbableElements();

        if (tabbables.length > 0) {
          tabbables[0].focus();
        }
      },
      end: function end() {
        // Focus last element
        var tabbables = getTabbableElements();

        if (tabbables.length > 0) {
          tabbables[tabbables.length - 1].focus();
        }
      }
    });
  };

  var getTabbableElements = function getTabbableElements() {
    return tabbable__WEBPACK_IMPORTED_MODULE_4___default()(contentEl);
  };

  if (convertSingletonToButton && children && !children.length) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(js__WEBPACK_IMPORTED_MODULE_7__["Button"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, buttonProps, {
      onClick: children.props.onClick,
      className: className,
      testName: testName,
      style: style,
      disabled: disabled,
      theme: theme
    }), children.props.children);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(js__WEBPACK_IMPORTED_MODULE_7__["DropdownButton"], {
    Component: iconName ? js__WEBPACK_IMPORTED_MODULE_7__["IconButton"] : null,
    componentProps: iconName ? {
      name: iconName
    } : null,
    alignRight: alignRight,
    buttonProps: buttonProps,
    className: className,
    testName: testName,
    dropdownRole: "menu",
    onKeyDown: handleKeyDown,
    style: style,
    label: label,
    disabled: disabled,
    theme: theme
  }, function (dismiss) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("ul", {
      ref: function ref(node) {
        return setContentEl(node);
      },
      onClick: dismiss,
      onKeyDown: function onKeyDown(evt) {
        if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_8__["default"])(evt).is('space enter')) {
          evt.preventDefault();
          dismiss();
        }
      },
      className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_9___default.a[theme], _DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_9___default.a.menu)
    }, children);
  });
}
DropdownMenu.propTypes = {
  /**
   * By default the dropdown will open with the content left-aligned with the
   * button. Setting `alignRight` to `true` will cause the dropdown to open with
   * the content right-aligned to the button.
   */
  alignRight: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Optional props to be applied to the Button. See [Button](#button). */
  buttonProps: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Component contents. These should each be wrapped in a `DropdownMenuItem` */
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Text displayed on the dropdown button */
  label: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node.isRequired,

  /** If passed the DropDownButton will be rendered as IconButton */
  iconName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Whether or not to disable the DropdownMenu */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** If set to true, and there is only one menu item, render that item as a button */
  convertSingletonToButton: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};
DropdownMenu.defaultProps = {
  alignRight: false,
  convertSingletonToButton: false
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_6__["provideTheme"])(_DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_9___default.a)(DropdownMenu));

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = function(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var basicTabbables = [];
  var orderedTabbables = [];

  // A node is "available" if
  // - it's computed style
  var isUnavailable = createIsUnavailable(elementDocument);

  var candidateSelectors = [
    'input',
    'select',
    'a[href]',
    'textarea',
    'button',
    '[tabindex]',
  ];

  var candidates = el.querySelectorAll(candidateSelectors.join(','));

  if (options.includeContainer) {
    var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

    if (
      candidateSelectors.some(function(candidateSelector) {
        return matches.call(el, candidateSelector);
      })
    ) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var candidate, candidateIndexAttr, candidateIndex;
  for (var i = 0, l = candidates.length; i < l; i++) {
    candidate = candidates[i];
    candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10)
    candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;

    if (
      candidateIndex < 0
      || (candidate.tagName === 'INPUT' && candidate.type === 'hidden')
      || candidate.disabled
      || isUnavailable(candidate, elementDocument)
    ) {
      continue;
    }

    if (candidateIndex === 0) {
      basicTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        index: i,
        tabIndex: candidateIndex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(function(a, b) {
      return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    })
    .map(function(a) {
      return a.node
    });

  Array.prototype.push.apply(tabbableNodes, basicTabbables);

  return tabbableNodes;
}

function createIsUnavailable(elementDocument) {
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed
  var isOffCache = [];

  // "off" means `display: none;`, as opposed to "hidden",
  // which means `visibility: hidden;`. getComputedStyle
  // accurately reflects visiblity in context but not
  // "off" state, so we need to recursively check parents.

  function isOff(node, nodeComputedStyle) {
    if (node === elementDocument.documentElement) return false;

    // Find the cached node (Array.prototype.find not available in IE9)
    for (var i = 0, length = isOffCache.length; i < length; i++) {
      if (isOffCache[i][0] === node) return isOffCache[i][1];
    }

    nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = isOff(node.parentNode);
    }

    isOffCache.push([node, result]);

    return result;
  }

  return function isUnavailable(node) {
    if (node === elementDocument.documentElement) return false;

    var computedStyle = elementDocument.defaultView.getComputedStyle(node);

    if (isOff(node, computedStyle)) return true;

    return computedStyle.visibility === 'hidden';
  }
}


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(508);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".DropdownMenu-classic-2_3_6-TpqcT a{color:#079bb3}.DropdownMenu-classic-2_3_6-TpqcT.DropdownMenu-menu-2_3_6-1ArwZ,.DropdownMenu-classic-2_3_6-TpqcT .DropdownMenu-menu-2_3_6-1ArwZ{color:#fff;background-color:#333;margin:0;border-radius:4px;min-width:10rem;max-height:17.2rem;overflow-y:auto;padding:.5rem 0}.DropdownMenu-classic-2_3_6-TpqcT.DropdownMenu-menu-2_3_6-1ArwZ:hover,.DropdownMenu-classic-2_3_6-TpqcT .DropdownMenu-menu-2_3_6-1ArwZ:hover{color:#999}.DropdownMenu-classic-2_3_6-TpqcT .DropdownMenu-menuItem-2_3_6-2z0s8{cursor:pointer;padding:.5rem 1rem;list-style-type:none;line-height:1.25;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.DropdownMenu-classic-2_3_6-TpqcT .DropdownMenu-menuItem-2_3_6-2z0s8:hover{color:#fff}.DropdownMenu-blueSteel-2_3_6-3dP4G a{color:#08088c}.DropdownMenu-blueSteel-2_3_6-3dP4G.DropdownMenu-menu-2_3_6-1ArwZ,.DropdownMenu-blueSteel-2_3_6-3dP4G .DropdownMenu-menu-2_3_6-1ArwZ{color:#fff;background-color:#030d28;margin:0;border-radius:4px;min-width:10rem;max-height:17.2rem;overflow-y:auto;padding:.5rem 0}.DropdownMenu-blueSteel-2_3_6-3dP4G.DropdownMenu-menu-2_3_6-1ArwZ:hover,.DropdownMenu-blueSteel-2_3_6-3dP4G .DropdownMenu-menu-2_3_6-1ArwZ:hover{color:#8e9093}.DropdownMenu-blueSteel-2_3_6-3dP4G .DropdownMenu-menuItem-2_3_6-2z0s8{cursor:pointer;padding:.5rem 1rem;list-style-type:none;line-height:1.25;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.DropdownMenu-blueSteel-2_3_6-3dP4G .DropdownMenu-menuItem-2_3_6-2z0s8:hover{color:#fff}", ""]);

// exports
exports.locals = {
	"classic": "DropdownMenu-classic-2_3_6-TpqcT",
	"menu": "DropdownMenu-menu-2_3_6-1ArwZ",
	"menuItem": "DropdownMenu-menuItem-2_3_6-2z0s8",
	"blueSteel": "DropdownMenu-blueSteel-2_3_6-3dP4G"
};

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DropdownMenuItem; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);
/* harmony import */ var _DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(507);
/* harmony import */ var _DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_4__);





function DropdownMenuItem(props) {
  var className = props.className,
      testName = props.testName,
      style = props.style,
      children = props.children,
      onClick = props.onClick;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_DropdownMenu_sass__WEBPACK_IMPORTED_MODULE_4___default.a.menuItem, className),
    "data-test-name": testName,
    onClick: onClick,
    onKeyDown: Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_3__["handleKeyboardClick"])(onClick),
    role: "menuitem",
    tabIndex: 0,
    style: style
  }, children);
}
DropdownMenuItem.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Callback that is fired when the user clicks the item */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CardBody; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(500);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Card_sass__WEBPACK_IMPORTED_MODULE_3__);




/**
 * Content area section fo the Card Component
 */

function CardBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Card_sass__WEBPACK_IMPORTED_MODULE_3___default.a.body, className)
  }, children);
}
CardBody.propTypes = {
  /** Content to be displayed within the Card Body*/
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Apply a custom class to the outermost element */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CardFooter; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(195);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(216);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(500);
/* harmony import */ var _Card_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Card_sass__WEBPACK_IMPORTED_MODULE_4__);





/**
 * Footer section for the Card component
 *
 */

function CardFooter(_ref) {
  var href = _ref.href,
      iconName = _ref.iconName,
      label = _ref.label,
      onClick = _ref.onClick,
      testName = _ref.testName,
      testNameAction = _ref.testNameAction;
  var footerActionProps = {
    tabIndex: 0,
    'data-test-name': testNameAction
  };
  var Container;

  if (href) {
    footerActionProps.href = href;
    Container = 'a';
  } else {
    footerActionProps.onClick = onClick;
    Container = 'div';
  }

  var footerAction = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Container, footerActionProps, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_3__["Icon"], {
    name: iconName,
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_4___default.a.icon
  }), label);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_2__["Flex"], {
    className: _Card_sass__WEBPACK_IMPORTED_MODULE_4___default.a.footer,
    alignItems: "center",
    "data-test-name": testName
  }, footerAction);
}
CardFooter.propTypes = {
  /** If provided the element will be rendered in a 'a' tag*/
  href: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Name for the icon displayed next to the label*/
  iconName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,

  /** Text for the footer action*/
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,

  /** Your click handler. */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /** Test name for footer action automation */
  testNameAction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Test name for container automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(513);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _Checkbox__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return Checkbox; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var js_components_ToolTip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(198);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(155);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(216);
/* harmony import */ var _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(514);
/* harmony import */ var _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14__);















/**
 * A simple checkbox component.
 *
 * To include an error or helper text, wrap the `Checkbox` in a
 * [`<CheckboxGroup>`](/#!/CheckboxGroup).
 *
 * All form inputs in this library must be implemented as [controlled
 * components](https://reactjs.org/docs/forms.html#controlled-components).
 *
 * **NOTE:** The checkbox element of this component is hidden via CSS in order
 * to achieve the style and behavior of this component. This may affect the
 * ability of automation testing to modify the checkbox. As a workaround,
 * the automation test should set the `opacity` to `1` on the checkbox's style
 * before attempting to interact with the checkbox. This style should not have
 * an impact on screenreader or keyboard accessibility.
 */

function Checkbox(_ref) {
  var _cx;

  var checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      inputClassName = _ref.inputClassName,
      label = _ref.label,
      labelClassName = _ref.labelClassName,
      name = _ref.name,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      single = _ref.single,
      spanClassName = _ref.spanClassName,
      large = _ref.large,
      noLabel = _ref.noLabel,
      style = _ref.style,
      testName = _ref.testName,
      description = _ref.description,
      tooltip = _ref.tooltip,
      theme = _ref.theme,
      horizontal = _ref.horizontal,
      includeIndeterminate = _ref.includeIndeterminate,
      isIndeterminate = _ref.isIndeterminate,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["checked", "children", "className", "disabled", "id", "inputClassName", "label", "labelClassName", "name", "onBlur", "onChange", "onFocus", "single", "spanClassName", "large", "noLabel", "style", "testName", "description", "tooltip", "theme", "horizontal", "includeIndeterminate", "isIndeterminate"]);

  var containerClasses = classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme], className, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.control, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.checkbox, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.checked, checked), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.single, single), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.large, large), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.noLabel, noLabel), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.horizontal, horizontal), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.includeIndeterminate, includeIndeterminate), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.isIndeterminate, isIndeterminate), _cx));
  var descriptionTag = description ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.description, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme])
  }, "(", description, ")") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("noscript", null);
  var tooltipTag = tooltip ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.tooltip, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(js_components_ToolTip__WEBPACK_IMPORTED_MODULE_10__["ToolTip"], {
    theme: theme,
    content: tooltip,
    style: {
      marginLeft: '5px'
    }
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("noscript", null);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
    className: containerClasses,
    style: style,
    "data-test-name": testName
  }, isIndeterminate && theme === 'blueSteel' && !disabled ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme], _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.checkIcon)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_13__["Icon"], {
    theme: theme,
    name: 'minus'
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme], _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.checkIcon)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_13__["Icon"], {
    theme: theme,
    name: 'check2'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.label, labelClassName, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("input", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    type: "checkbox",
    id: id,
    disabled: disabled,
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a.input, inputClassName, _Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme]),
    name: name,
    checked: checked,
    onBlur: function onBlur(evt) {
      return _onBlur ? _onBlur(evt.target.checked, evt) : null;
    },
    onFocus: function onFocus(evt) {
      return _onFocus ? _onFocus(evt.target.checked, evt) : null;
    },
    onChange: function onChange(evt) {
      return _onChange ? _onChange(evt.target.checked, evt) : null;
    }
  }, rest)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(spanClassName)
  }, children || label), descriptionTag, tooltipTag));
}
Checkbox.propTypes = {
  /** whether or not the checkbox is checked */
  checked: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /** checkbox label text (can optionally be passed through `label` prop) */
  children: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9___default()(prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.node, function (props) {
    return !props.label && !props.noLabel;
  }),

  /** class to put on the outermost container */
  className: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /** whether or not the checkbox should be disabled */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /** name attribute for the checkbox `<input>` */
  id: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /** class to put on the checkbox `<input>` itself */
  inputClassName: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /** checkbox label text (can optionally be passed through `children`) */
  label: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9___default()(prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string, function (props) {
    return !props.children && !props.noLabel;
  }),

  /** class to put on the checkbox `<label>` (this wraps the whole checkbox) */
  labelClassName: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /** name attribute for the checkbox `<input>` */
  name: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /**
   * Your blur handler.
   * @param {boolean} value - Current input value.
   * @param {SyntheticEvent} event - The event.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func,

  /**
   * Your change handler. Update your state here.
   * @param {boolean} value - Current input value.
   * @param {SyntheticEvent} event - The event.
   */
  onChange: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9___default()(prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func, function (props) {
    return !props.disabled;
  }),

  /**
   * Your focus handler.
   * @param {boolean} value - Current input value.
   * @param {SyntheticEvent} event - The event.
   */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.func,

  /**
   * Add `single` if the checkbox does not appear in a group of multiple
   * checkboxes. This gives the checkbox a larger vertical margin, which makes
   * it more pronounced within the form.
   */
  single: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /** will render a larger sized checkbox if set to true */
  large: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /** Allows checkbox to be used without a label */
  noLabel: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /** class to put on the checkbox label `<span>` (rendered beside the `<input>`) */
  spanClassName: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /** Hint text to be rendered in parentheses beside the label */
  description: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.node,

  /** A tooltip to be rendered beside the description */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.node,

  /** A theme name to apply on this component  */
  theme: function theme(props, propName, componentName) {
    if (props['includeIndeterminate'] && !props[propName]) {
      return new Error("".concat(propName, " is required to be blueSteel when includeIndeterminate is true in ").concat(componentName, "."));
    }
  },

  /** Used to display checkbox groups horizontally */
  horizontal: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /** To use Indeterminate Checkboxes [blue steel only] */
  includeIndeterminate: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /** Used to display the indeterminate sign for checkbox groups [blue steel only] */
  isIndeterminate: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool
};
Checkbox.defaultProps = {
  single: true,
  large: false
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_11__["provideTheme"])(_Checkbox_sass__WEBPACK_IMPORTED_MODULE_14___default.a)(Checkbox));

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(515);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Checkbox-classic-2_3_6-2iJMe a{color:#079bb3}.Checkbox-classic-2_3_6-2iJMe.Checkbox-control-2_3_6-1qseF,.Checkbox-classic-2_3_6-2iJMe .Checkbox-control-2_3_6-1qseF{position:relative;display:block;margin-bottom:0;color:#444}.Checkbox-classic-2_3_6-2iJMe.Checkbox-control-2_3_6-1qseF+.Checkbox-classic-2_3_6-2iJMe.Checkbox-control-2_3_6-1qseF,.Checkbox-classic-2_3_6-2iJMe.Checkbox-control-2_3_6-1qseF+.Checkbox-classic-2_3_6-2iJMe .Checkbox-control-2_3_6-1qseF,.Checkbox-classic-2_3_6-2iJMe .Checkbox-control-2_3_6-1qseF+.Checkbox-classic-2_3_6-2iJMe.Checkbox-control-2_3_6-1qseF,.Checkbox-classic-2_3_6-2iJMe .Checkbox-control-2_3_6-1qseF+.Checkbox-classic-2_3_6-2iJMe .Checkbox-control-2_3_6-1qseF{margin-top:.4rem}.Checkbox-classic-2_3_6-2iJMe.Checkbox-disabled-2_3_6-ZCsLn,.Checkbox-classic-2_3_6-2iJMe .Checkbox-disabled-2_3_6-ZCsLn{pointer-events:none}.Checkbox-classic-2_3_6-2iJMe.Checkbox-horizontal-2_3_6-ZOzwy{display:inline-block;padding-right:16px}.Checkbox-classic-2_3_6-2iJMe.Checkbox-label-2_3_6-2Oa1z,.Checkbox-classic-2_3_6-2iJMe .Checkbox-label-2_3_6-2Oa1z{position:relative;cursor:pointer;display:block;padding-left:1.37rem;line-height:1.2}.Checkbox-large-2_3_6-3lMvu .Checkbox-classic-2_3_6-2iJMe.Checkbox-label-2_3_6-2Oa1z,.Checkbox-large-2_3_6-3lMvu .Checkbox-classic-2_3_6-2iJMe .Checkbox-label-2_3_6-2Oa1z{padding-left:1.8366666667rem}.Checkbox-noLabel-2_3_6-2igrl .Checkbox-classic-2_3_6-2iJMe.Checkbox-label-2_3_6-2Oa1z,.Checkbox-noLabel-2_3_6-2igrl .Checkbox-classic-2_3_6-2iJMe .Checkbox-label-2_3_6-2Oa1z{padding-left:1rem}.Checkbox-large-2_3_6-3lMvu.Checkbox-noLabel-2_3_6-2igrl .Checkbox-classic-2_3_6-2iJMe.Checkbox-label-2_3_6-2Oa1z,.Checkbox-large-2_3_6-3lMvu.Checkbox-noLabel-2_3_6-2igrl .Checkbox-classic-2_3_6-2iJMe .Checkbox-label-2_3_6-2Oa1z{padding-left:1.4666666667rem}.Checkbox-disabled-2_3_6-ZCsLn .Checkbox-classic-2_3_6-2iJMe.Checkbox-label-2_3_6-2Oa1z,.Checkbox-disabled-2_3_6-ZCsLn .Checkbox-classic-2_3_6-2iJMe .Checkbox-label-2_3_6-2Oa1z{color:#888}.Checkbox-classic-2_3_6-2iJMe.Checkbox-input-2_3_6-1zD1T,.Checkbox-classic-2_3_6-2iJMe .Checkbox-input-2_3_6-1zD1T{cursor:pointer;opacity:0;position:absolute;left:0;width:1rem;height:1rem}.Checkbox-large-2_3_6-3lMvu .Checkbox-classic-2_3_6-2iJMe.Checkbox-input-2_3_6-1zD1T,.Checkbox-large-2_3_6-3lMvu .Checkbox-classic-2_3_6-2iJMe .Checkbox-input-2_3_6-1zD1T{width:1.4666666667rem;height:1.4666666667rem}.Checkbox-classic-2_3_6-2iJMe.Checkbox-input-2_3_6-1zD1T+span,.Checkbox-classic-2_3_6-2iJMe .Checkbox-input-2_3_6-1zD1T+span{border-left:1.37rem solid transparent;margin-left:-1.37rem}.Checkbox-large-2_3_6-3lMvu .Checkbox-classic-2_3_6-2iJMe.Checkbox-input-2_3_6-1zD1T+span,.Checkbox-large-2_3_6-3lMvu .Checkbox-classic-2_3_6-2iJMe .Checkbox-input-2_3_6-1zD1T+span{border-left:1.8366666667rem solid transparent;margin-left:-1.8366666667rem}.Checkbox-classic-2_3_6-2iJMe.Checkbox-input-2_3_6-1zD1T:focus+span,.Checkbox-classic-2_3_6-2iJMe .Checkbox-input-2_3_6-1zD1T:focus+span{outline:auto;outline-color:#079bb3}.hide-focus-outlines .Checkbox-classic-2_3_6-2iJMe.Checkbox-input-2_3_6-1zD1T:focus+span,.hide-focus-outlines .Checkbox-classic-2_3_6-2iJMe .Checkbox-input-2_3_6-1zD1T:focus+span{outline:none}.Checkbox-classic-2_3_6-2iJMe.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-classic-2_3_6-2iJMe .Checkbox-checkIcon-2_3_6-2r-L4{position:absolute;left:0;border-radius:2px;box-shadow:inset 0 0 0 1px #919191;text-align:center;transition:background-color .2s ease,box-shadow .2s ease;background-color:#fff;color:#fff;width:1rem;height:1rem;margin-top:.1rem;font-size:.7rem;padding-top:.15rem}.Checkbox-large-2_3_6-3lMvu .Checkbox-classic-2_3_6-2iJMe.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-large-2_3_6-3lMvu .Checkbox-classic-2_3_6-2iJMe .Checkbox-checkIcon-2_3_6-2r-L4{width:1.4666666667rem;height:1.4666666667rem;margin-top:-.1333333333rem;font-size:1.0266666667rem;padding-top:.22rem}.Checkbox-classic-2_3_6-2iJMe.Checkbox-checkIcon-2_3_6-2r-L4>svg,.Checkbox-classic-2_3_6-2iJMe .Checkbox-checkIcon-2_3_6-2r-L4>svg{transition:opacity .2s ease,transform .25s ease;opacity:0;transform:scale(.7) rotate(-110deg)}.Checkbox-checked-2_3_6-1E2D- .Checkbox-classic-2_3_6-2iJMe.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-checked-2_3_6-1E2D- .Checkbox-classic-2_3_6-2iJMe .Checkbox-checkIcon-2_3_6-2r-L4{box-shadow:none;background-color:#079bb3}.Checkbox-checked-2_3_6-1E2D- .Checkbox-classic-2_3_6-2iJMe.Checkbox-checkIcon-2_3_6-2r-L4>svg,.Checkbox-checked-2_3_6-1E2D- .Checkbox-classic-2_3_6-2iJMe .Checkbox-checkIcon-2_3_6-2r-L4>svg{opacity:1;transform:scale(1) rotate(0)}.Checkbox-control-2_3_6-1qseF:not(.Checkbox-checked-2_3_6-1E2D-):hover .Checkbox-classic-2_3_6-2iJMe.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-control-2_3_6-1qseF:not(.Checkbox-checked-2_3_6-1E2D-):hover .Checkbox-classic-2_3_6-2iJMe .Checkbox-checkIcon-2_3_6-2r-L4{box-shadow:inset 0 0 0 1px gray}.Checkbox-disabled-2_3_6-ZCsLn:not(.Checkbox-checked-2_3_6-1E2D-) .Checkbox-classic-2_3_6-2iJMe.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-disabled-2_3_6-ZCsLn:not(.Checkbox-checked-2_3_6-1E2D-) .Checkbox-classic-2_3_6-2iJMe .Checkbox-checkIcon-2_3_6-2r-L4{box-shadow:inset 0 0 0 1px #b3b3b3}.Checkbox-disabled-2_3_6-ZCsLn.Checkbox-checked-2_3_6-1E2D- .Checkbox-classic-2_3_6-2iJMe.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-disabled-2_3_6-ZCsLn.Checkbox-checked-2_3_6-1E2D- .Checkbox-classic-2_3_6-2iJMe .Checkbox-checkIcon-2_3_6-2r-L4{background-color:#888}.Checkbox-classic-2_3_6-2iJMe.Checkbox-single-2_3_6-3-z0q,.Checkbox-classic-2_3_6-2iJMe .Checkbox-single-2_3_6-3-z0q{margin:2rem 0}.Checkbox-classic-2_3_6-2iJMe .Checkbox-description-2_3_6-1qS_c{margin-left:.2em;color:#888;font-weight:400}.Checkbox-classic-2_3_6-2iJMe .Checkbox-description-2_3_6-1qS_c a{color:#079bb3;text-decoration:none}.Checkbox-classic-2_3_6-2iJMe .Checkbox-description-2_3_6-1qS_c a:active,.Checkbox-classic-2_3_6-2iJMe .Checkbox-description-2_3_6-1qS_c a:focus,.Checkbox-classic-2_3_6-2iJMe .Checkbox-description-2_3_6-1qS_c a:hover{text-decoration:underline}.Checkbox-classic-2_3_6-2iJMe.Checkbox-tooltip-2_3_6-1CjBw,.Checkbox-classic-2_3_6-2iJMe .Checkbox-tooltip-2_3_6-1CjBw{pointer-events:auto}.Checkbox-blueSteel-2_3_6-3WlFY a{color:#08088c}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-control-2_3_6-1qseF,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-control-2_3_6-1qseF{position:relative;display:block;margin-bottom:0;color:#01050e}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-control-2_3_6-1qseF+.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-control-2_3_6-1qseF,.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-control-2_3_6-1qseF+.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-control-2_3_6-1qseF,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-control-2_3_6-1qseF+.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-control-2_3_6-1qseF,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-control-2_3_6-1qseF+.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-control-2_3_6-1qseF{margin-top:16px}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-disabled-2_3_6-ZCsLn,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-disabled-2_3_6-ZCsLn{pointer-events:none}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-disabled-2_3_6-ZCsLn .Checkbox-description-2_3_6-1qS_c,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-disabled-2_3_6-ZCsLn .Checkbox-description-2_3_6-1qS_c{color:#8e9093}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-horizontal-2_3_6-ZOzwy{display:inline-block;padding-right:16px}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-includeIndeterminate-2_3_6-3h7Dc{left:10px}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-label-2_3_6-2Oa1z,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-label-2_3_6-2Oa1z{position:relative;cursor:pointer;display:block;padding-left:1.5rem;padding-top:2px;font-size:.875rem;line-height:1.2}.Checkbox-large-2_3_6-3lMvu .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-label-2_3_6-2Oa1z,.Checkbox-large-2_3_6-3lMvu .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-label-2_3_6-2Oa1z{padding-left:1.9666666667rem}.Checkbox-noLabel-2_3_6-2igrl .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-label-2_3_6-2Oa1z,.Checkbox-noLabel-2_3_6-2igrl .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-label-2_3_6-2Oa1z{padding-left:1rem}.Checkbox-large-2_3_6-3lMvu.Checkbox-noLabel-2_3_6-2igrl .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-label-2_3_6-2Oa1z,.Checkbox-large-2_3_6-3lMvu.Checkbox-noLabel-2_3_6-2igrl .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-label-2_3_6-2Oa1z{padding-left:1.4666666667rem}.Checkbox-disabled-2_3_6-ZCsLn .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-label-2_3_6-2Oa1z,.Checkbox-disabled-2_3_6-ZCsLn .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-label-2_3_6-2Oa1z{color:#8e9093}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-input-2_3_6-1zD1T,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-input-2_3_6-1zD1T{cursor:pointer;opacity:0;position:absolute;left:0;width:1rem;height:1rem;margin:0}.Checkbox-large-2_3_6-3lMvu .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-input-2_3_6-1zD1T,.Checkbox-large-2_3_6-3lMvu .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-input-2_3_6-1zD1T{width:1.4666666667rem;height:1.4666666667rem}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-input-2_3_6-1zD1T+span,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-input-2_3_6-1zD1T+span{border-left:1.5rem solid transparent;margin-left:-1.5rem}.Checkbox-large-2_3_6-3lMvu .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-input-2_3_6-1zD1T+span,.Checkbox-large-2_3_6-3lMvu .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-input-2_3_6-1zD1T+span{border-left:1.9666666667rem solid transparent;margin-left:-1.9666666667rem}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-input-2_3_6-1zD1T:focus+span,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-input-2_3_6-1zD1T:focus+span{outline:auto;outline-color:#08088c}.hide-focus-outlines .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-input-2_3_6-1zD1T:focus+span,.hide-focus-outlines .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-input-2_3_6-1zD1T:focus+span{outline:none}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4{position:absolute;left:0;border-radius:2px;box-shadow:inset 0 0 0 1px #cbcdcd;text-align:center;transition:background-color .2s ease,box-shadow .2s ease;background-color:#fff;color:#fff;width:1rem;height:1rem;margin-top:.1rem}.Checkbox-isIndeterminate-2_3_6-2uQwj .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-isIndeterminate-2_3_6-2uQwj .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4{box-shadow:none;background-color:#08088c}.Checkbox-isIndeterminate-2_3_6-2uQwj .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4>svg,.Checkbox-isIndeterminate-2_3_6-2uQwj .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4>svg{opacity:1;width:80%;transform:scale(1) rotate(0)}.Checkbox-large-2_3_6-3lMvu .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-large-2_3_6-3lMvu .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4{width:1.4666666667rem;height:1.4666666667rem;margin-top:-.1333333333rem}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4>svg,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4>svg{transition:opacity .2s ease,transform .25s ease;margin-top:1px;width:100%;height:100%;opacity:0;transform:scale(.7) rotate(-110deg)}.Checkbox-checked-2_3_6-1E2D- .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-checked-2_3_6-1E2D- .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4{box-shadow:none;background-color:#092dbd}.Checkbox-checked-2_3_6-1E2D- .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4>svg,.Checkbox-checked-2_3_6-1E2D- .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4>svg{opacity:1;transform:scale(1) rotate(0) translateY(-1px)}.Checkbox-control-2_3_6-1qseF:not(.Checkbox-checked-2_3_6-1E2D-):hover .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-control-2_3_6-1qseF:not(.Checkbox-checked-2_3_6-1E2D-):hover .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4{box-shadow:inset 0 0 0 2px #08088c}.Checkbox-control-2_3_6-1qseF.Checkbox-checked-2_3_6-1E2D-:hover .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-control-2_3_6-1qseF.Checkbox-checked-2_3_6-1E2D-:hover .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4{box-shadow:inset 0 0 0 2px #08088c;background-color:#08088c}.Checkbox-disabled-2_3_6-ZCsLn:not(.Checkbox-checked-2_3_6-1E2D-) .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-disabled-2_3_6-ZCsLn:not(.Checkbox-checked-2_3_6-1E2D-) .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4{box-shadow:none;background-color:#8e9093}.Checkbox-disabled-2_3_6-ZCsLn.Checkbox-checked-2_3_6-1E2D- .Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-checkIcon-2_3_6-2r-L4,.Checkbox-disabled-2_3_6-ZCsLn.Checkbox-checked-2_3_6-1E2D- .Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-checkIcon-2_3_6-2r-L4{background-color:#8e9093}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-single-2_3_6-3-z0q,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-single-2_3_6-3-z0q{margin:1rem 0}.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-description-2_3_6-1qS_c{margin-left:.2em;color:#4d5056;font-weight:400}.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-description-2_3_6-1qS_c a{color:#08088c;text-decoration:none}.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-description-2_3_6-1qS_c a:active,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-description-2_3_6-1qS_c a:focus,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-description-2_3_6-1qS_c a:hover{text-decoration:underline}.Checkbox-blueSteel-2_3_6-3WlFY.Checkbox-tooltip-2_3_6-1CjBw,.Checkbox-blueSteel-2_3_6-3WlFY .Checkbox-tooltip-2_3_6-1CjBw{pointer-events:auto}", ""]);

// exports
exports.locals = {
	"classic": "Checkbox-classic-2_3_6-2iJMe",
	"control": "Checkbox-control-2_3_6-1qseF",
	"disabled": "Checkbox-disabled-2_3_6-ZCsLn",
	"horizontal": "Checkbox-horizontal-2_3_6-ZOzwy",
	"label": "Checkbox-label-2_3_6-2Oa1z",
	"large": "Checkbox-large-2_3_6-3lMvu",
	"noLabel": "Checkbox-noLabel-2_3_6-2igrl",
	"input": "Checkbox-input-2_3_6-1zD1T",
	"checkIcon": "Checkbox-checkIcon-2_3_6-2r-L4",
	"checked": "Checkbox-checked-2_3_6-1E2D-",
	"single": "Checkbox-single-2_3_6-3-z0q",
	"description": "Checkbox-description-2_3_6-1qS_c",
	"tooltip": "Checkbox-tooltip-2_3_6-1CjBw",
	"blueSteel": "Checkbox-blueSteel-2_3_6-3WlFY",
	"includeIndeterminate": "Checkbox-includeIndeterminate-2_3_6-3h7Dc",
	"isIndeterminate": "Checkbox-isIndeterminate-2_3_6-2uQwj"
};

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _CheckboxGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(517);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxGroup", function() { return _CheckboxGroup__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxGroup", function() { return CheckboxGroup; });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var js_components_InputGroup__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(249);
/* harmony import */ var _CheckboxGroup_sass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(518);
/* harmony import */ var _CheckboxGroup_sass__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_CheckboxGroup_sass__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(155);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * A wrapper for checkbox form controls that includes all the InputGroup
 * functionality and automatically applies UI treatments for single checkboxes
 * and groups of checkboxes.
 *
 * A `CheckboxGroup` will automatically adjust the UI for single or multiple
 * checkboxes depending on how many children it is given.
 */

function CheckboxGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      theme = _ref.theme,
      horizontal = _ref.horizontal,
      includeIndeterminate = _ref.includeIndeterminate,
      props = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7___default()(_ref, ["className", "children", "theme", "horizontal", "includeIndeterminate"]);

  var hasSingleCheckbox = react__WEBPACK_IMPORTED_MODULE_11___default.a.Children.count(children) === 1;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_12___default()(_CheckboxGroup_sass__WEBPACK_IMPORTED_MODULE_15___default.a.checkboxGroup, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()({}, _CheckboxGroup_sass__WEBPACK_IMPORTED_MODULE_15___default.a.single, hasSingleCheckbox));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(js_components_InputGroup__WEBPACK_IMPORTED_MODULE_14__["InputGroup"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_5___default()({
    asFieldset: true,
    theme: theme,
    className: classes
  }, props), react__WEBPACK_IMPORTED_MODULE_11___default.a.Children.map(children, function (child, i) {
    var checkboxNewProps;
    var checkboxProps = {
      single: false,
      // Single presentation is handled by group instead
      key: i,
      theme: theme,
      horizontal: horizontal,
      // To display checkbox horizontally
      includeIndeterminate: i !== 0 && theme === 'blueSteel' ? includeIndeterminate : false
    };

    if (Array.isArray(children) && theme === 'blueSteel' && includeIndeterminate) {
      var currentCheckedValues = children.map(function (child) {
        return child.props.checked;
      });
      var currentCheckedValueForFirstCheckbox = currentCheckedValues.shift();
      var currentCheckedValuesSubList = currentCheckedValues;
      var allCurrentSubListCheckedValuesAreTrue = currentCheckedValuesSubList.every(function (value) {
        return value === true;
      });
      var allCurrentSubListCheckedValuesAreFalse = currentCheckedValuesSubList.every(function (value) {
        return value === false;
      });
      var someCurrentSubListCheckedValuesAreTrue = currentCheckedValuesSubList.some(function (value) {
        return value === true;
      });
      /**
        checking the first checkbox should automatically check the sublist
        checkboxes
        unchecking the first checkbox should automatically uncheck sublist
        checkboxes
      **/

      if (i === 0 && !currentCheckedValueForFirstCheckbox && allCurrentSubListCheckedValuesAreFalse) {
        checkboxNewProps = _objectSpread(_objectSpread({}, checkboxProps), {}, {
          onChange: function onChange() {
            children.forEach(function (child) {
              return child.props.onChange(true);
            });
          }
        });
      } else if (i === 0 && currentCheckedValueForFirstCheckbox && allCurrentSubListCheckedValuesAreTrue) {
        checkboxNewProps = _objectSpread(_objectSpread({}, checkboxProps), {}, {
          onChange: function onChange() {
            children.forEach(function (child) {
              return child.props.onChange(false);
            });
          }
        });
        /**
        If any checkbox is checked, check if the sublists are
        all checked, then check the primary checkbox as well
        Otherwise, add the indeterminate icon to the first checkbox
        */
      } else if (child.props.checked) {
        if (allCurrentSubListCheckedValuesAreTrue) {
          if (!currentCheckedValueForFirstCheckbox) {
            children[0].props.onChange(true);
          }

          checkboxNewProps = checkboxProps;
        } else if (i === 0 && someCurrentSubListCheckedValuesAreTrue) {
          checkboxNewProps = _objectSpread(_objectSpread({}, checkboxProps), {}, {
            isIndeterminate: true,
            onChange: function onChange() {
              children.forEach(function (child) {
                return child.props.onChange(false);
              });
            }
          });
        } else {
          checkboxNewProps = checkboxProps;
        }
        /**
        If any checkbox is unchecked, check if the sublists are
        all checked, then uncheck the primary checkbox as well
        Otherwise, add the indeterminate icon to the first checkbox if
        some of the sublists are checked
        */

      } else if (!child.props.checked) {
        if (allCurrentSubListCheckedValuesAreFalse) {
          if (currentCheckedValueForFirstCheckbox) {
            children[0].props.onChange(false);
          }

          checkboxNewProps = checkboxProps;
        } else if (i === 0 && someCurrentSubListCheckedValuesAreTrue) {
          checkboxNewProps = _objectSpread(_objectSpread({}, checkboxProps), {}, {
            isIndeterminate: true,
            onChange: function onChange() {
              children.forEach(function (child) {
                return child.props.onChange(true);
              });
            }
          });
        } else {
          checkboxNewProps = checkboxProps;
        }
      } else {
        checkboxNewProps = checkboxProps;
      }
    } else {
      checkboxNewProps = checkboxProps;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.cloneElement(child, checkboxNewProps);
  }));
}
CheckboxGroup.propTypes = {
  /** Your Checkbox or Checkboxes */
  children: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node,

  /** Apply a custom class to the outermost element. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Content justified to the right of the label. This space is used for remaining characters and sometimes actions. */
  contentRight: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node,

  /** Hint text to be rendered in parentheses beside the label */
  description: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node,

  /** An error message to be rendered beneath the field. */
  error: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Rendered beneath the field (except when an error is present) */
  helperText: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node,

  /** Label text. */
  label: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node]),

  /** Whether or not to render an asterisk beside the label */
  required: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** A tooltip to be rendered beside the label */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.node,

  /** A theme name to apply on this component */
  theme: function theme(props, propName, componentName) {
    if (props['includeIndeterminate'] && !props[propName]) {
      return new Error("".concat(propName, " is required to be blueSteel when includeIndeterminate is true in ").concat(componentName, "."));
    }
  },

  /** Display Checkboxes horizontally */
  horizontal: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool,

  /** To use Indeterminate Checkboxes [blue steel only] */
  includeIndeterminate: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.bool
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_16__["provideTheme"])(_CheckboxGroup_sass__WEBPACK_IMPORTED_MODULE_15___default.a)(CheckboxGroup));

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(519);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".CheckboxGroup-classic-2_3_6-3B96M a{color:#079bb3}.CheckboxGroup-classic-2_3_6-3B96M .CheckboxGroup-checkboxGroup-2_3_6-DFqyt{border:0;padding:.01em 0 0;margin:0 0 1.3333333333rem;min-width:0;line-height:1.25}.CheckboxGroup-classic-2_3_6-3B96M .CheckboxGroup-checkboxGroup-2_3_6-DFqyt.CheckboxGroup-single-2_3_6-WbSR0{margin:2rem 0}.CheckboxGroup-classic-2_3_6-3B96M .CheckboxGroup-error-2_3_6-2YBt6{margin-top:.4rem}.CheckboxGroup-blueSteel-2_3_6-3uXTH a{color:#08088c}.CheckboxGroup-blueSteel-2_3_6-3uXTH .CheckboxGroup-checkboxGroup-2_3_6-DFqyt{border:5;padding:.01em 0 0;margin:0 0 1.3333333333rem;min-width:5;line-height:1.25;color:green}.CheckboxGroup-blueSteel-2_3_6-3uXTH .CheckboxGroup-checkboxGroup-2_3_6-DFqyt.CheckboxGroup-single-2_3_6-WbSR0{margin:2rem 0}.CheckboxGroup-blueSteel-2_3_6-3uXTH .CheckboxGroup-error-2_3_6-2YBt6{margin-top:.4rem}", ""]);

// exports
exports.locals = {
	"classic": "CheckboxGroup-classic-2_3_6-3B96M",
	"checkboxGroup": "CheckboxGroup-checkboxGroup-2_3_6-DFqyt",
	"single": "CheckboxGroup-single-2_3_6-WbSR0",
	"error": "CheckboxGroup-error-2_3_6-2YBt6",
	"blueSteel": "CheckboxGroup-blueSteel-2_3_6-3uXTH"
};

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _CopyField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(521);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CopyField", function() { return _CopyField__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CopyField", function() { return CopyField; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(469);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(242);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(195);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _TextArea_PlainTextArea__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(403);
/* harmony import */ var _CopyField_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(522);
/* harmony import */ var _CopyField_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_CopyField_sass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(155);











/**
 A component to copy the text.

 __Notes__:
  - Only when componentProps readOnly is true, onClick on the input area functionality is available.
  - PlainInput and Input component has visual difference when readOnly is true.
**/

function CopyField(_ref) {
  var Component = _ref.Component,
      componentProps = _ref.componentProps,
      buttonProps = _ref.buttonProps,
      className = _ref.className,
      testName = _ref.testName,
      style = _ref.style,
      flexProps = _ref.flexProps,
      label = _ref.label,
      value = _ref.value,
      onCopy = _ref.onCopy,
      onError = _ref.onError,
      labelClassName = _ref.labelClassName,
      theme = _ref.theme,
      useIconButton = _ref.useIconButton,
      iconButtonProps = _ref.iconButtonProps;
  var instance = null;

  var copyText = function copyText() {
    instance.select();

    try {
      if (document.execCommand('copy') && value.length <= 0) {
        throw "Value cannot be empty";
      }

      if (document.execCommand('copy') && value.length > 0) {
        onCopy();
      }
    } catch (e) {
      onError(e);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_8___default()(_CopyField_sass__WEBPACK_IMPORTED_MODULE_7___default.a.componentStyle, className),
    "data-test-name": testName,
    style: style
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_4__["Flex"], null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_8___default()(_CopyField_sass__WEBPACK_IMPORTED_MODULE_7___default.a.label, labelClassName, _CopyField_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme])
  }, label)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_4__["Flex"], {
    gap: "sm",
    flexDirection: "column"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_4__["Flex"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    gap: "sm"
  }, flexProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    value: value,
    ref: function ref(node) {
      instance = node;
    },
    onChange: componentProps.onChange,
    onClick: componentProps.readOnly ? copyText : null
  }, componentProps)), useIconButton ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_3__["IconButton"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    theme: theme
  }, iconButtonProps, buttonProps, {
    onClick: copyText,
    name: "duplicate",
    "aria-label": "Copy the text"
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Button__WEBPACK_IMPORTED_MODULE_2__["Button"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    "aria-label": "Copy the text",
    onClick: copyText
  }, buttonProps, {
    theme: theme
  })))));
}
CopyField.propTypes = {
  /** Class name for the copyField */
  className: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object,

  /**  Render passed component */
  Component: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func, prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object]),

  /** Props of passed component */
  componentProps: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.shape({
    onChange: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_9___default()(prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.any, function (props) {
      return props && !props.readOnly;
    })
  }),

  /** On Success the function is called and the message gets rendered */
  onCopy: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func.isRequired,

  /** On Error the function is called and the message gets rendered */
  onError: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func.isRequired,

  /** Props to pass along to `Button` component */
  buttonProps: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object,

  /** Props to pass along to `Flex` component */
  flexProps: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object,

  /** Pass the value to display in the input area */
  value: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string.isRequired,

  /** Label of the component */
  label: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Custom style for label */
  labelClassName: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Props to use `IconButton` component */
  useIconButton: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** Props to pass along to `IconButton` component */
  iconButtonProps: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object
};
CopyField.defaultProps = {
  Component: _TextArea_PlainTextArea__WEBPACK_IMPORTED_MODULE_6__["default"],
  componentProps: {
    readOnly: true,
    rows: 1
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_10__["provideTheme"])(_CopyField_sass__WEBPACK_IMPORTED_MODULE_7___default.a)(CopyField));

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(523);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".CopyField-classic-2_3_6-23uMW a{color:#079bb3}.CopyField-classic-2_3_6-23uMW.CopyField-label-2_3_6-Wl6J1,.CopyField-classic-2_3_6-23uMW .CopyField-label-2_3_6-Wl6J1{color:#666;font-size:.9333333333rem;font-weight:700;margin-bottom:2px}.CopyField-componentStyle-2_3_6-1Fm0c{margin:12px 0}.CopyField-blueSteel-2_3_6-3cXGc a{color:#08088c}.CopyField-blueSteel-2_3_6-3cXGc.CopyField-label-2_3_6-Wl6J1,.CopyField-blueSteel-2_3_6-3cXGc .CopyField-label-2_3_6-Wl6J1{color:#4d5056;font-size:.9333333333rem;font-weight:700;margin-bottom:2px}", ""]);

// exports
exports.locals = {
	"classic": "CopyField-classic-2_3_6-23uMW",
	"label": "CopyField-label-2_3_6-Wl6J1",
	"componentStyle": "CopyField-componentStyle-2_3_6-1Fm0c",
	"blueSteel": "CopyField-blueSteel-2_3_6-3cXGc"
};

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _DragContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(525);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContainer", function() { return _DragContainer__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return _DragContainer__WEBPACK_IMPORTED_MODULE_0__["DragContext"]; });

/* harmony import */ var _DragItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(529);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragItem", function() { return _DragItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });




/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragContext", function() { return DragContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ItemContext", function() { return ItemContext; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(447);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(526);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _util_deprecationWarning__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83);







var DndProvider;
var HTML5Backend;

try {
  DndProvider = __webpack_require__(527).DndProvider;
  HTML5Backend = __webpack_require__(528).HTML5Backend;
} catch (err) {// optional module not installed
}

var DragContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createContext({
  collectionSize: 0,
  isDragActive: false,
  activeKeyboardItem: null,
  setDragActive: function setDragActive() {},
  setActiveKeyboardItem: function setActiveKeyboardItem() {}
}); // This is used to tell Items their index within the container

var ItemContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createContext({
  id: null,
  index: 0
});

var fillArray = function fillArray(length) {
  var array = [];

  for (var i = 0; i < length; i++) {
    array.push(i);
  }

  return array;
};

var ItemContextWrapper = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.memo(function (_ref) {
  var id = _ref.id,
      index = _ref.index,
      children = _ref.children;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])({
    id: id,
    index: index
  }),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_4__["useEffect"])(function () {
    if (id !== value.id || index !== value.index) {
      setValue({
        id: id,
        index: index
      });
    }
  }, [id, index]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(ItemContext.Provider, {
    value: value
  }, children);
}, function (prevProps, newProps) {
  return prevProps.children === newProps.children && prevProps.id === newProps.id && prevProps.index === newProps.index;
});
ItemContextWrapper.propTypes = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.number,
  index: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.number,
  children: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.node
};
/**
 * A DragContainer encapsulates a region in which it's child contents can be
 * re-organized by vertically dragging an item above or below another item. Drag
 * and drop re-ordering is only supported for vertical gestures. The DragContainer
 * is meant to contain DragItems as its immediate children.
 *
 * **NOTE** This component requires react v16.14.0 or later
 *
 * The DragContainer also provides a `DragContext` that child components can consume.
 * `isDragActive` - flag that indicates whether a DragItem is currently being dragged
 * `dragY` - Current vertical drag position of an active DragItem
 */

var DragContainer = function DragContainer(_ref2) {
  var propsChildren = _ref2.children;

  if (!DndProvider) {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_6__["default"])('DragContainer requires missing dependency "react-dnd"');
    return null;
  }

  if (!HTML5Backend) {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_6__["default"])('DragContainer requires missing dependency "react-dnd-html5-backend"');
    return null;
  }

  var animationRef = Object(react__WEBPACK_IMPORTED_MODULE_4__["useRef"])(null);
  var hoverRef = Object(react__WEBPACK_IMPORTED_MODULE_4__["useRef"])([null, null]);

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(null),
      _useState4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState3, 2),
      startIndex = _useState4[0],
      setStartIndex = _useState4[1];

  var _useState5 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(null),
      _useState6 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState5, 2),
      endIndex = _useState6[0],
      setEndIndex = _useState6[1];

  var _useState7 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(react__WEBPACK_IMPORTED_MODULE_4___default.a.Children.toArray(propsChildren)),
      _useState8 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState7, 2),
      children = _useState8[0],
      setChildren = _useState8[1];

  var _useState9 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(fillArray(children.length)),
      _useState10 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState9, 2),
      initialIds = _useState10[0],
      setInitialIds = _useState10[1];

  var _useState11 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(initialIds),
      _useState12 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState11, 2),
      currentIds = _useState12[0],
      setCurrentIds = _useState12[1];

  var _useState13 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(false),
      _useState14 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState13, 2),
      isDragActive = _useState14[0],
      setDragActive = _useState14[1];

  var _useState15 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(null),
      _useState16 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState15, 2),
      activeKeyboardIndex = _useState16[0],
      setActiveKeyboardIndex = _useState16[1];

  var _useState17 = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(false),
      _useState18 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState17, 2),
      isKeyboardDragActive = _useState18[0],
      setKeyboardDragActive = _useState18[1];

  Object(react__WEBPACK_IMPORTED_MODULE_4__["useEffect"])(function () {
    var children = react__WEBPACK_IMPORTED_MODULE_4___default.a.Children.toArray(propsChildren);
    setChildren(children);
    setInitialIds(fillArray(children.length));
    setCurrentIds(fillArray(children.length));
    hoverRef.current = [null, null];
  }, [propsChildren]);

  var handleHover = function handleHover(dragIndex, hoverIndex) {
    var isRepeatEvent = hoverRef.current[0] === dragIndex && hoverRef.current[1] === hoverIndex;

    if (animationRef.current == null && !isRepeatEvent) {
      hoverRef.current = [dragIndex, hoverIndex];
      animationRef.current = requestAnimationFrame(function () {
        // We copy initial ids, but set current ids, because dragIndex and
        // hoverIndex are relative to the initial order, while the currentIds
        // list keeps track of the preview order during a drag and drop operation
        var idsCopy = initialIds.slice();

        var _idsCopy$splice = idsCopy.splice(dragIndex, 1),
            _idsCopy$splice2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_idsCopy$splice, 1),
            movedId = _idsCopy$splice2[0];

        idsCopy.splice(hoverIndex, 0, movedId);
        setCurrentIds(idsCopy);
        animationRef.current = null;
        hoverRef.current = [null, null];
      });
    }
  };

  var dragContext = {
    collection: currentIds,
    collectionSize: currentIds.length,
    isDragActive: isDragActive,
    setDragActive: setDragActive,
    onDragHover: handleHover,
    activeKeyboardIndex: activeKeyboardIndex,
    setActiveKeyboardIndex: setActiveKeyboardIndex,
    isKeyboardDragActive: isKeyboardDragActive,
    setKeyboardDragActive: setKeyboardDragActive,
    dragStartIndex: startIndex,
    dragEndIndex: endIndex,
    setDragStartIndex: setStartIndex,
    setDragEndIndex: setEndIndex
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(DragContext.Provider, {
    value: dragContext
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(DndProvider, {
    backend: HTML5Backend
  }, currentIds.map(function (id, index) {
    var child = children[id];
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(ItemContextWrapper, {
      key: id,
      id: id,
      index: index
    }, child);
  })));
};

DragContainer.propTypes = {
  /** Container contents. For best results, these should be DragItems */
  children: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.node
};
/* harmony default export */ __webpack_exports__["default"] = (DragContainer);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var toAbsoluteIndex = __webpack_require__(47);
var toInteger = __webpack_require__(46);
var toLength = __webpack_require__(45);
var toObject = __webpack_require__(77);
var arraySpeciesCreate = __webpack_require__(78);
var createProperty = __webpack_require__(173);
var arrayMethodHasSpeciesSupport = __webpack_require__(80);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports) {

if(typeof __WEBPACK_EXTERNAL_MODULE__527__ === 'undefined') {var e = new Error("Cannot find module 'react-dnd'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE__527__;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

if(typeof __WEBPACK_EXTERNAL_MODULE__528__ === 'undefined') {var e = new Error("Cannot find module 'react-dnd-html5-backend'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE__528__;

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _util_deprecationWarning__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(216);
/* harmony import */ var _Target__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(530);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(155);
/* harmony import */ var _DragContainer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(525);
/* harmony import */ var _DragNudge__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(534);
/* harmony import */ var _Draggable_sass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(535);
/* harmony import */ var _Draggable_sass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_Draggable_sass__WEBPACK_IMPORTED_MODULE_13__);














var useDrag;
var useDrop;

try {
  var dndLib = __webpack_require__(527);

  useDrag = dndLib.useDrag;
  useDrop = dndLib.useDrop;
} catch (err) {// optional module not installed
}

var ITEM_TYPE = 'DragItem';

var DragItemContextWrapper = function DragItemContextWrapper(props) {
  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_DragContainer__WEBPACK_IMPORTED_MODULE_11__["DragContext"]),
      activeKeyboardIndex = _useContext.activeKeyboardIndex,
      isKeyboardDragActive = _useContext.isKeyboardDragActive,
      dragStartIndex = _useContext.dragStartIndex,
      dragEndIndex = _useContext.dragEndIndex,
      setDragStartIndex = _useContext.setDragStartIndex,
      setDragEndIndex = _useContext.setDragEndIndex,
      onDragHover = _useContext.onDragHover,
      collectionSize = _useContext.collectionSize,
      setKeyboardDragActive = _useContext.setKeyboardDragActive,
      setActiveKeyboardIndex = _useContext.setActiveKeyboardIndex;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(DragItemWrapper, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_2___default()({}, props, {
    activeKeyboardIndex: activeKeyboardIndex,
    isKeyboardDragActive: isKeyboardDragActive,
    dragStartIndex: dragStartIndex,
    dragEndIndex: dragEndIndex,
    setDragStartIndex: setDragStartIndex,
    setDragEndIndex: setDragEndIndex,
    onDragHover: onDragHover,
    collectionSize: collectionSize,
    setKeyboardDragActive: setKeyboardDragActive,
    setActiveKeyboardIndex: setActiveKeyboardIndex
  }));
};
/**
 * DragItems should be the immediate children of a DragContainer and encapsulate
 * items that can be rearranged by drag and drop gestures.
 *
 * __Accessiblity Notes__
 *
 * 1. The DragItem can be focused using the Tab key.
 * 1. Pressing the space bar can toggle entering and exiting a keyboard reorder mode
 * 1. Use the up arrow key to move an item up in the order during keyboard reorder mode or focus the item above when not in keyboard reorder mode
 * 1. Use the down arrow key to move an item down in the order during keyboard reorder mode or focus the item below when not in keyboard reorder mode
 */


var DragItemWrapper = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.memo(function (_ref) {
  var onDrag = _ref.onDrag,
      activeKeyboardIndex = _ref.activeKeyboardIndex,
      isKeyboardDragActive = _ref.isKeyboardDragActive,
      dragStartIndex = _ref.dragStartIndex,
      dragEndIndex = _ref.dragEndIndex,
      setDragStartIndex = _ref.setDragStartIndex,
      setDragEndIndex = _ref.setDragEndIndex,
      onDragHover = _ref.onDragHover,
      collectionSize = _ref.collectionSize,
      setKeyboardDragActive = _ref.setKeyboardDragActive,
      setActiveKeyboardIndex = _ref.setActiveKeyboardIndex,
      children = _ref.children,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;

  if (!useDrag || !useDrop) {
    Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_6__["default"])('DragItem requires missing dependency "react-dnd"');
    return null;
  }

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_3__["useRef"])(null);
  var itemContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_DragContainer__WEBPACK_IMPORTED_MODULE_11__["ItemContext"]);
  var isDraggable = Boolean(onDrag);
  var isKeyboardFocus = itemContext.index === activeKeyboardIndex;
  var isKeyboardActiveFocus = isKeyboardFocus && isKeyboardDragActive;
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var node = ref.current;
    var hasFocus = document.activeElement === node;

    if (itemContext.index === activeKeyboardIndex) {
      if (node && !hasFocus) {
        node.focus();
      }
    }
  }, [itemContext.index, activeKeyboardIndex, ref.current]);

  var _useDrop = useDrop({
    accept: ITEM_TYPE,
    collect: function collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    drop: function drop() {
      onDrag(dragStartIndex, dragEndIndex);
      setDragStartIndex(null);
      setDragEndIndex(null);
    },
    hover: function hover(item, monitor) {
      if (monitor.isOver() && item.id !== itemContext.id) {
        if (dragStartIndex === null) {
          setDragStartIndex(item.index);
        }

        setDragEndIndex(itemContext.index);
        onDragHover(item.index, itemContext.index);
      }
    }
  }),
      _useDrop2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_useDrop, 2),
      handlerId = _useDrop2[0].handlerId,
      drop = _useDrop2[1];

  var _useDrag = useDrag({
    type: ITEM_TYPE,
    item: itemContext,
    isDragging: function isDragging(monitor) {
      return itemContext.id === monitor.getItem().id;
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    },
    end: function end(item, monitor) {
      // Make sure a drop event happens event if the item was dropped
      // over something that was not droppable.
      if (!monitor.didDrop()) {
        onDrag(dragStartIndex, dragEndIndex);
        setDragStartIndex(null);
        setDragEndIndex(null);
      }
    }
  }),
      _useDrag2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_useDrag, 2),
      isDragging = _useDrag2[0].isDragging,
      drag = _useDrag2[1];

  var handleKeyPress = Object(react__WEBPACK_IMPORTED_MODULE_3__["useCallback"])(function (event) {
    if (Object(_util__WEBPACK_IMPORTED_MODULE_7__["keycode"])(event).is('space')) {
      event.preventDefault();
      return setKeyboardDragActive(!isKeyboardDragActive);
    }

    if (Object(_util__WEBPACK_IMPORTED_MODULE_7__["keycode"])(event).is('up') && itemContext.index > 0) {
      event.preventDefault(); // Stop scrolling

      setActiveKeyboardIndex(Math.max(0, itemContext.index - 1));

      if (isKeyboardDragActive) {
        onDrag(itemContext.index, itemContext.index - 1);
      }

      return;
    }

    if (Object(_util__WEBPACK_IMPORTED_MODULE_7__["keycode"])(event).is('down') && itemContext.index < collectionSize - 1) {
      event.preventDefault(); // Stop scrolling

      setActiveKeyboardIndex(Math.min(itemContext.index + 1, collectionSize - 1));

      if (isKeyboardDragActive) {
        onDrag(itemContext.index, itemContext.index + 1);
      }

      return;
    }
  });
  drag(drop(ref));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(DragItem, {
    theme: theme,
    isKeyboardActiveFocus: isKeyboardActiveFocus,
    style: style,
    ref: ref,
    handleKeyPress: handleKeyPress,
    isKeyboardFocus: isKeyboardFocus,
    testName: testName,
    handlerId: handlerId,
    isDraggable: isDraggable,
    isDragging: isDragging
  }, children);
}, function (prevProps, newProps) {
  return prevProps.children === newProps.children && prevProps.dragStartIndex === newProps.dragStartIndex && prevProps.dragEndIndex === newProps.dragEndIndex && prevProps.collectionSize === newProps.collectionSize && prevProps.activeKeyboardIndex === newProps.activeKeyboardIndex;
});
DragItemWrapper.propTypes = {
  /**
   * Callback for onDrag behavior. It will be called when the user has released
   * the drag operation (at "drop" time). If this function is specified, the
   * item will be draggable alongside any adjacent items. If not specified,
   * the item will not be draggable.
   *
   * The onDrag callback will be called with two arguments:
   * 1. The original index of the nav item within the parent DragContainer
   * 2. The next/desired index of the item within the parent DragContainer
   */
  onDrag: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,

  /** Draggable contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Style overrides */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string.isRequired,

  /** vaues taken from DragContext */
  activeKeyboardIndex: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number,
  isKeyboardDragActive: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  dragStartIndex: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number,
  dragEndIndex: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number,
  setDragStartIndex: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
  setDragEndIndex: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
  onDragHover: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
  collectionSize: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number,
  setKeyboardDragActive: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
  setActiveKeyboardIndex: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func
};
var DragItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.memo( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      theme = _ref2.theme,
      isKeyboardActiveFocus = _ref2.isKeyboardActiveFocus,
      style = _ref2.style,
      handleKeyPress = _ref2.handleKeyPress,
      isKeyboardFocus = _ref2.isKeyboardFocus,
      testName = _ref2.testName,
      handlerId = _ref2.handlerId,
      isDraggable = _ref2.isDraggable,
      isDragging = _ref2.isDragging;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Draggable_sass__WEBPACK_IMPORTED_MODULE_13___default.a[theme], _Draggable_sass__WEBPACK_IMPORTED_MODULE_13___default.a.dragItem, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Draggable_sass__WEBPACK_IMPORTED_MODULE_13___default.a.keyboardActive, isKeyboardActiveFocus)),
    style: style,
    ref: ref,
    tabIndex: 0,
    onKeyUp: handleKeyPress,
    "aria-selected": isKeyboardFocus,
    "data-test-name": testName,
    "data-handler-id": handlerId
  }, isDraggable || isDragging ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Target__WEBPACK_IMPORTED_MODULE_9__["Target"], {
    onClick: function onClick() {}
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_8__["Icon"], {
    className: _Draggable_sass__WEBPACK_IMPORTED_MODULE_13___default.a.dragHandle,
    name: _Icon__WEBPACK_IMPORTED_MODULE_8__["ICONS"].GRIP
  })) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Draggable_sass__WEBPACK_IMPORTED_MODULE_13___default.a.dragging, isDragging))
  }, children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_DragNudge__WEBPACK_IMPORTED_MODULE_12__["default"], {
    expanded: isDragging
  }));
}), function (prevProps, newProps) {
  return prevProps.children === newProps.children && prevProps.isDragging === newProps.isDragging && prevProps.isKeyboardActiveFocus === newProps.isKeyboardActiveFocus && prevProps.isKeyboardFocus === newProps.isKeyboardFocus;
});
DragItem.propTypes = {
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string.isRequired,
  isKeyboardActiveFocus: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,
  handleKeyPress: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
  isKeyboardFocus: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
  handlerId: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
  isDraggable: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  isDragging: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_10__["provideTheme"])(_Draggable_sass__WEBPACK_IMPORTED_MODULE_13___default.a)(DragItemContextWrapper));

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Target__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(531);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Target", function() { return _Target__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Target_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(532);
/* harmony import */ var _Target_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Target_sass__WEBPACK_IMPORTED_MODULE_6__);







/**
 * Helper component to make things clickable. The Target wraps its content in an
 * `<a>` tag and prevents the default behavior of its click event. Targets DO
 * NOT take on default link styles and should NOT be used in place of traditional
 * Links. An example use for Targets could be to make the close icon of a modal
 * clickable.
 */

var Target = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      _onClick = _ref.onClick,
      block = _ref.block,
      disabled = _ref.disabled,
      testName = _ref.testName,
      anchorProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["children", "className", "style", "onClick", "block", "disabled", "testName"]);

  var wrapperClass = classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Target_sass__WEBPACK_IMPORTED_MODULE_6___default.a.unstyledLink, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Target_sass__WEBPACK_IMPORTED_MODULE_6___default.a.block, block), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Target_sass__WEBPACK_IMPORTED_MODULE_6___default.a.disabled, disabled), _cx));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("a", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, anchorProps, {
    className: wrapperClass,
    style: style,
    ref: ref,
    href: !disabled ? '#' : null,
    disabled: disabled,
    onClick: function onClick(event) {
      event.preventDefault();

      if (!disabled) {
        _onClick();
      }
    },
    "data-test-name": testName
  }), children);
});
Target.propTypes = {
  /** Optional classname to apply to the `<a>` tag. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Style overrides */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Callback function fired when the Target is clicked */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func.isRequired,

  /** Clickable Target contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /**
   * Flag to determine whether the Target should display as a block. By default
   * the Target will display inline. If the Target includes any block element
   * children, `block` should be `true`
   */
  block: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /**
   * Flag to prevent the click behavior of the Target. When `disabled` is `true`
   * the `onClick` callback will not fire when clicked.
   */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};
Target.defaultProps = {
  block: false,
  disabled: false
};
/* harmony default export */ __webpack_exports__["default"] = (Target);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(533);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Target-unstyledLink-2_3_6-13fYo.Target-unstyledLink-2_3_6-13fYo{color:currentColor;text-decoration:inherit}.Target-unstyledLink-2_3_6-13fYo.Target-unstyledLink-2_3_6-13fYo.Target-block-2_3_6-vCZEn{display:block}.Target-unstyledLink-2_3_6-13fYo.Target-unstyledLink-2_3_6-13fYo.Target-disabled-2_3_6-25JSp{cursor:inherit}", ""]);

// exports
exports.locals = {
	"unstyledLink": "Target-unstyledLink-2_3_6-13fYo",
	"block": "Target-block-2_3_6-vCZEn",
	"disabled": "Target-disabled-2_3_6-25JSp"
};

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var _Draggable_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(535);
/* harmony import */ var _Draggable_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Draggable_sass__WEBPACK_IMPORTED_MODULE_5__);







var DragNudge = function DragNudge(_ref) {
  var expanded = _ref.expanded,
      theme = _ref.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Draggable_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], _Draggable_sass__WEBPACK_IMPORTED_MODULE_5___default.a.dragItem, _Draggable_sass__WEBPACK_IMPORTED_MODULE_5___default.a.dragNudge, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Draggable_sass__WEBPACK_IMPORTED_MODULE_5___default.a.expanded, expanded))
  });
};

DragNudge.propTypes = {
  expanded: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_4__["provideTheme"])(_Draggable_sass__WEBPACK_IMPORTED_MODULE_5___default.a)(DragNudge));

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(536);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Draggable-classic-2_3_6-1A4rk a{color:#079bb3}.Draggable-classic-2_3_6-1A4rk.Draggable-dragItem-2_3_6-1fzDt,.Draggable-classic-2_3_6-1A4rk .Draggable-dragItem-2_3_6-1fzDt{position:relative}.Draggable-classic-2_3_6-1A4rk.Draggable-dragItem-2_3_6-1fzDt:focus:not(.Draggable-disabled-2_3_6-21GqH) .Draggable-dragHandle-2_3_6-1bi7o,.Draggable-classic-2_3_6-1A4rk .Draggable-dragItem-2_3_6-1fzDt:focus:not(.Draggable-disabled-2_3_6-21GqH) .Draggable-dragHandle-2_3_6-1bi7o,.Draggable-classic-2_3_6-1A4rk.Draggable-dragItem-2_3_6-1fzDt:hover:not(.Draggable-disabled-2_3_6-21GqH) .Draggable-dragHandle-2_3_6-1bi7o,.Draggable-classic-2_3_6-1A4rk .Draggable-dragItem-2_3_6-1fzDt:hover:not(.Draggable-disabled-2_3_6-21GqH) .Draggable-dragHandle-2_3_6-1bi7o{opacity:1}.Draggable-classic-2_3_6-1A4rk.Draggable-dragItem-2_3_6-1fzDt.Draggable-keyboardActive-2_3_6-mMmr5,.Draggable-classic-2_3_6-1A4rk .Draggable-dragItem-2_3_6-1fzDt.Draggable-keyboardActive-2_3_6-mMmr5{font-weight:700}.Draggable-classic-2_3_6-1A4rk.Draggable-dragItem-2_3_6-1fzDt .Draggable-dragHandle-2_3_6-1bi7o,.Draggable-classic-2_3_6-1A4rk .Draggable-dragItem-2_3_6-1fzDt .Draggable-dragHandle-2_3_6-1bi7o{position:absolute;left:.5333333333rem;top:.67rem;font-size:.67em;cursor:grab;color:#079bb3;opacity:0;transition:opacity .3s cubic-bezier(.77,0,.18,1)}.Draggable-classic-2_3_6-1A4rk .Draggable-dragNudge-2_3_6-3P0QJ{display:none;position:absolute;top:0;right:0;bottom:0;left:0;margin:.2666666667rem 1.0666666667rem;height:2.6666666667rem;background-color:#ccc;border-radius:1px;z-index:1}.Draggable-classic-2_3_6-1A4rk .Draggable-dragNudge-2_3_6-3P0QJ.Draggable-expanded-2_3_6-7WCkt{display:block}.Draggable-classic-2_3_6-1A4rk .Draggable-dragging-2_3_6-1B_Gz{margin-bottom:1rem;opacity:0}.Draggable-blueSteel-2_3_6-3D7ji a{color:#08088c}.Draggable-blueSteel-2_3_6-3D7ji.Draggable-dragItem-2_3_6-1fzDt,.Draggable-blueSteel-2_3_6-3D7ji .Draggable-dragItem-2_3_6-1fzDt{position:relative}.Draggable-blueSteel-2_3_6-3D7ji.Draggable-dragItem-2_3_6-1fzDt:focus:not(.Draggable-disabled-2_3_6-21GqH) .Draggable-dragHandle-2_3_6-1bi7o,.Draggable-blueSteel-2_3_6-3D7ji .Draggable-dragItem-2_3_6-1fzDt:focus:not(.Draggable-disabled-2_3_6-21GqH) .Draggable-dragHandle-2_3_6-1bi7o,.Draggable-blueSteel-2_3_6-3D7ji.Draggable-dragItem-2_3_6-1fzDt:hover:not(.Draggable-disabled-2_3_6-21GqH) .Draggable-dragHandle-2_3_6-1bi7o,.Draggable-blueSteel-2_3_6-3D7ji .Draggable-dragItem-2_3_6-1fzDt:hover:not(.Draggable-disabled-2_3_6-21GqH) .Draggable-dragHandle-2_3_6-1bi7o{opacity:1}.Draggable-blueSteel-2_3_6-3D7ji.Draggable-dragItem-2_3_6-1fzDt.Draggable-keyboardActive-2_3_6-mMmr5,.Draggable-blueSteel-2_3_6-3D7ji .Draggable-dragItem-2_3_6-1fzDt.Draggable-keyboardActive-2_3_6-mMmr5{font-weight:700}.Draggable-blueSteel-2_3_6-3D7ji.Draggable-dragItem-2_3_6-1fzDt .Draggable-dragHandle-2_3_6-1bi7o,.Draggable-blueSteel-2_3_6-3D7ji .Draggable-dragItem-2_3_6-1fzDt .Draggable-dragHandle-2_3_6-1bi7o{position:absolute;left:.5333333333rem;top:.67rem;font-size:.67em;cursor:grab;color:#08088c;opacity:0;transition:opacity .3s cubic-bezier(.77,0,.18,1)}.Draggable-blueSteel-2_3_6-3D7ji .Draggable-dragNudge-2_3_6-3P0QJ{display:none;position:absolute;top:0;right:0;bottom:0;left:0;margin:.2666666667rem 1.0666666667rem;height:2.6666666667rem;background-color:#e5e6e6;border-radius:1px;z-index:1}.Draggable-blueSteel-2_3_6-3D7ji .Draggable-dragNudge-2_3_6-3P0QJ.Draggable-expanded-2_3_6-7WCkt{display:block}.Draggable-blueSteel-2_3_6-3D7ji .Draggable-dragging-2_3_6-1B_Gz{margin-bottom:1rem;opacity:0}", ""]);

// exports
exports.locals = {
	"classic": "Draggable-classic-2_3_6-1A4rk",
	"dragItem": "Draggable-dragItem-2_3_6-1fzDt",
	"disabled": "Draggable-disabled-2_3_6-21GqH",
	"dragHandle": "Draggable-dragHandle-2_3_6-1bi7o",
	"keyboardActive": "Draggable-keyboardActive-2_3_6-mMmr5",
	"dragNudge": "Draggable-dragNudge-2_3_6-3P0QJ",
	"expanded": "Draggable-expanded-2_3_6-7WCkt",
	"dragging": "Draggable-dragging-2_3_6-1B_Gz",
	"blueSteel": "Draggable-blueSteel-2_3_6-3D7ji"
};

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _DropdownButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(538);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownButton", function() { return _DropdownButton__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownButton", function() { return DropdownButton; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(200);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(155);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2);
/* harmony import */ var react_onclickoutside__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(539);
/* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(506);
/* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(tabbable__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(469);
/* harmony import */ var _Fadeable__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(201);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(216);
/* harmony import */ var _DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(540);
/* harmony import */ var _DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21__);










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }














var dropdownCounter = 0;
/**
A dropdown button that allows you to provide a custom dropdown.

__Accessibility notes:__
- The dropdown can be toggled with the down arrow, space or enter keys.
- When the dropdown is shown it will focus the entire dropdown container by
default.
- When the dropdown is dismissed the button is refocused automatically.
- When the dropdown is shown the tab key will only focus tabbable elements
within the dropdown (wrapping from the last to the first and first to last).
Shift+tab moves focus backwards through the tab order.
- Pressing the escape key dismisses the dropdown.
- Screen readers identify the button as having a popup.
- Screen readers identify the dropdown as a dialog.
- Screen readers detect when the dropdown is expanded.
- Screen readers do not attempt to read the dropdown caret.
*/

var DropdownButton = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DropdownButton, _React$Component);

  var _super = _createSuper(DropdownButton);

  function DropdownButton(props) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, DropdownButton);

    _this = _super.call(this, props);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "handleClickOutside", function () {
      _this.hide();
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "hide", function () {
      if (_this.state.isOpen) {
        _this.setState({
          isOpen: false
        });
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "dismiss", function () {
      _this.hide();

      _this.refocusButton();
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "toggle", function () {
      return _this.setState({
        isOpen: !_this.state.isOpen
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "refocusButton", function () {
      try {
        var toggle = react_dom__WEBPACK_IMPORTED_MODULE_10___default.a.findDOMNode(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this)).children[0];
        toggle.focus();
      } catch (err) {
        console.warn('<DropdownButton> button could not be focused');
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "handleButtonKeyDown", function (evt) {
      var key = Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_15__["default"])(evt);

      if (!_this.state.isOpen && key.is('down')) {
        _this.setState({
          isOpen: true
        });
      } else if (_this.state.isOpen && key.is('esc')) {
        _this.hide();
      } else if (key.is('space')) {
        evt.preventDefault(); // prevent spacebar scroll
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "handleContentKeyDown", function (evt) {
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(evt);
      }

      if (_this.state.isOpen) {
        Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_15__["default"])(evt).on({
          esc: _this.dismiss,
          // NB: we must match shift+tab first because keycode.on is greedy
          'shift+tab': function shiftTab() {
            // Move focus up to previous item (or wrap to last)
            var tabbables = _this.getTabbableElements();

            var tabbableIndex = tabbables.indexOf(evt.target);

            if (tabbableIndex > -1) {
              var first = tabbables[0];
              var last = tabbables[tabbables.length - 1];
              evt.target === first ? last.focus() : tabbables[tabbableIndex - 1].focus();
              evt.preventDefault();
            }
          },
          tab: function tab() {
            // Move focus down to next item (or wrap to first)
            var tabbables = _this.getTabbableElements();

            var tabbableIndex = tabbables.indexOf(evt.target);

            if (tabbableIndex > -1) {
              var first = tabbables[0];
              var last = tabbables[tabbables.length - 1];
              evt.target === last ? first.focus() : tabbables[tabbableIndex + 1].focus();
              evt.preventDefault();
            }
          }
        });
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "getTabbableElements", function () {
      return tabbable__WEBPACK_IMPORTED_MODULE_17___default()(_this.contentEl);
    });

    _this.state = {
      isOpen: props.defaultOpen
    };
    dropdownCounter = dropdownCounter + 1;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(DropdownButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.isOpen && this.state.isOpen) {
        this.contentEl.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          alignRight = _this$props.alignRight,
          buttonProps = _this$props.buttonProps,
          children = _this$props.children,
          className = _this$props.className,
          Component = _this$props.Component,
          componentProps = _this$props.componentProps,
          disabled = _this$props.disabled,
          dropdownClassName = _this$props.dropdownClassName,
          dropdownRole = _this$props.dropdownRole,
          label = _this$props.label,
          style = _this$props.style,
          testName = _this$props.testName,
          theme = _this$props.theme;
      var isOpen = this.state.isOpen;
      var dropdownClasses = classnames__WEBPACK_IMPORTED_MODULE_13___default()(_DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21___default.a.dropdown, dropdownClassName, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()({}, _DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21___default.a.right, alignRight));
      var dropdownId = "sc-button-menu-".concat(dropdownCounter);
      var iconName = isOpen ? 'CARET_UP' : 'CARET_DOWN';

      var renderButton = function renderButton() {
        if (Component) {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
            onClick: _this2.toggle,
            onKeyDown: _this2.handleButtonKeyDown,
            "aria-haspopup": true,
            "aria-controls": dropdownId,
            "aria-expanded": isOpen,
            theme: theme
          }, componentProps), label);
        }

        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(_Button__WEBPACK_IMPORTED_MODULE_18__["Button"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
          disabled: disabled,
          onClick: _this2.toggle,
          onKeyDown: _this2.handleButtonKeyDown,
          "aria-haspopup": true,
          "aria-controls": dropdownId,
          "aria-expanded": isOpen,
          theme: theme
        }, buttonProps), label, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_20__["Icon"], {
          className: _DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21___default.a.caret,
          name: iconName
        }));
      };

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement("div", {
        style: style,
        className: classnames__WEBPACK_IMPORTED_MODULE_13___default()(_DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21___default.a.container, className),
        "data-test-name": testName
      }, renderButton(), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement("div", {
        className: _DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21___default.a.dropdownContainer
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(_Fadeable__WEBPACK_IMPORTED_MODULE_19__["Fadeable"], {
        show: isOpen,
        slideIn: "down",
        slideOut: "up"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement("div", {
        className: dropdownClasses,
        id: dropdownId,
        onKeyDown: this.handleContentKeyDown,
        role: dropdownRole,
        tabIndex: 0,
        ref: function ref(node) {
          return _this2.contentEl = node;
        }
      }, typeof children === 'function' ? children(this.dismiss) : children))));
    }
  }]);

  return DropdownButton;
}(react__WEBPACK_IMPORTED_MODULE_9___default.a.Component);
var Component = Object(react_onclickoutside__WEBPACK_IMPORTED_MODULE_16__["default"])(DropdownButton);
Component.Component = DropdownButton;
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_14__["provideTheme"])(_DropdownButton_sass__WEBPACK_IMPORTED_MODULE_21___default.a)(Component));
DropdownButton.propTypes = {
  /**
   * By default the dropdown will open with the content left-aligned with the
   * button. Setting `alignRight` to `true` will cause the dropdown to open with
   * the content right-aligned to the button.
   */
  alignRight: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /**
   * Optional props to be applied to the Button. See [Button](#button).
   */
  buttonProps: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node, prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func]),

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /**
   * Determines whether the dropdown should be open by default. Normally user
   * interaction is required to open the dropdown.
   */
  defaultOpen: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** Specify whether the dropdown can be toggled. */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /** className applied to the dropdown */
  dropdownClassName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Role attribute to place on the dropdown */
  dropdownRole: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Text displayed on the dropdown button */
  label: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default()(prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node, function (props) {
    return !props.Component;
  }),

  /** If provided the button will be rendered as the given component instead of
   as a `Button` component. Use `componentProps` to pass any necessary props to this
   component. eg: `<DropdownButton Component={Router.Link} componentProps={{to: foo}} />`
   See docs site for more examples. */
  Component: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_12___default()(prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.any, function (props) {
    return props.componentProps;
  }),

  /** Props to forward to the component passed in the `Component` prop. */
  componentProps: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** Whether or not to disable the button */

  /** KeyDown callback for the dropdown */
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string
};
DropdownButton.defaultProps = {
  alignRight: false,
  defaultOpen: false,
  dropdownRole: 'dialog'
};

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(200);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(541);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".DropdownButton-container-2_3_6-20HO2{display:inline-block;position:relative}.DropdownButton-container-2_3_6-20HO2+.DropdownButton-container-2_3_6-20HO2{margin-left:.3333333333rem}.DropdownButton-dropdownContainer-2_3_6-ydbUD{z-index:11010;position:relative}.DropdownButton-dropdown-2_3_6-3ZsVY{position:absolute;top:.6666666667rem;display:inline-block}.DropdownButton-dropdown-2_3_6-3ZsVY>*{margin:0;box-shadow:0 2px 8px rgba(0,0,0,.2)}.DropdownButton-caret-2_3_6-x2am9{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;height:16px;width:16px;margin-left:8px;transform:translateY(2px);opacity:1}.DropdownButton-right-2_3_6-8F1XL{right:0}", ""]);

// exports
exports.locals = {
	"container": "DropdownButton-container-2_3_6-20HO2",
	"dropdownContainer": "DropdownButton-dropdownContainer-2_3_6-ydbUD",
	"dropdown": "DropdownButton-dropdown-2_3_6-3ZsVY",
	"caret": "DropdownButton-caret-2_3_6-x2am9",
	"right": "DropdownButton-right-2_3_6-8F1XL"
};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ExpandableSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(543);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpandableSection", function() { return _ExpandableSection__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpandableSection", function() { return ExpandableSection; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2);
/* harmony import */ var _Panel_PanelTitleBar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(544);
/* harmony import */ var js_components_Collapse__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(159);
/* harmony import */ var _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(547);
/* harmony import */ var _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(155);










/**
ExpandableSections are used to hide / show advanced functionality to avoid
overwhelming users with too many options. They may be open or closed by
default, depending on the context.

__Accessibility notes:__
- The titlebar can be focused and toggled with the keyboard and is recognized
  as a button.
- Screen readers detect when the section is expanded.
- Screen readers do not attempt to read the dropdown caret.
- The section is recognized by screen readers as a section.
*/

function ExpandableSection(_ref) {
  var _cx;

  var actions = _ref.actions,
      className = _ref.className,
      children = _ref.children,
      contentClassName = _ref.contentClassName,
      defaultCollapsed = _ref.defaultCollapsed,
      _onClick = _ref.onClick,
      style = _ref.style,
      testName = _ref.testName,
      title = _ref.title,
      titleOverflow = _ref.titleOverflow,
      theme = _ref.theme,
      toggleOpen = _ref.toggleOpen;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(defaultCollapsed),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_useState, 2),
      isCollapsed = _useState2[0],
      setIsCollapsed = _useState2[1];

  var isFirstRun = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(true);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (!isFirstRun.current) {
      setIsCollapsed(!toggleOpen);
    }

    isFirstRun.current = false;
  }, [toggleOpen]);

  var handleKeyCollapse = function handleKeyCollapse(evt) {
    if (evt.currentTarget === evt.target) {
      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_5__["default"])(evt).is('enter space')) {
        evt.preventDefault();
        setIsCollapsed(!isCollapsed);
      }
    }
  };

  var caretClassName = classnames__WEBPACK_IMPORTED_MODULE_4___default()(_ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.caret, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.collapsed, isCollapsed), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.expanded, !isCollapsed), _cx));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("section", {
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a[theme], _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.container, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.collapsed, isCollapsed)),
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    "aria-expanded": String(!isCollapsed),
    "aria-label": title,
    className: _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.titleWrapper,
    onClick: function onClick() {
      if (_onClick) {
        _onClick(!isCollapsed);
      }

      setIsCollapsed(!isCollapsed);
    },
    role: "button",
    tabIndex: "0",
    onKeyDown: handleKeyCollapse
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Panel_PanelTitleBar__WEBPACK_IMPORTED_MODULE_6__["default"], {
    className: _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.titleBar,
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
      className: _ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.title
    }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
      className: caretClassName,
      "aria-hidden": true
    }, "\u25BC")),
    titleOverflow: titleOverflow
  }, actions ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    onClick: function onClick(evt) {
      return evt.stopPropagation();
    }
  }, actions) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("noscript", null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(js_components_Collapse__WEBPACK_IMPORTED_MODULE_7__["Collapse"], {
    show: !isCollapsed
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a.innerContent, contentClassName)
  }, children)));
}
ExpandableSection.propTypes = {
  /** Action buttons rendered to the right of the title. */
  actions: _Panel_PanelTitleBar__WEBPACK_IMPORTED_MODULE_6__["default"].propTypes.children,

  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /**
   * Optional class name to be applied to the wrapper element surrounding the
   * collabsible content
   */
  contentClassName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Determines whether to start with content expanded or collapsed. */
  defaultCollapsed: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Toggles whether the component is expanded or collapsed. */
  toggleOpen: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Your click handler */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Text to be displayed in the title bar. */
  title: _Panel_PanelTitleBar__WEBPACK_IMPORTED_MODULE_6__["default"].propTypes.title,

  /** How to handle titles too long to fit in on one line. */
  titleOverflow: _Panel_PanelTitleBar__WEBPACK_IMPORTED_MODULE_6__["default"].propTypes.titleOverflow,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};
ExpandableSection.defaultProps = {
  actions: null,
  children: null,
  defaultCollapsed: false,
  titleOverflow: 'wrap',
  toggleOpen: false
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_9__["provideTheme"])(_ExpandableSection_sass__WEBPACK_IMPORTED_MODULE_8___default.a)(ExpandableSection));

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PanelTitleBar; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Panel_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(545);
/* harmony import */ var _Panel_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Panel_sass__WEBPACK_IMPORTED_MODULE_4__);





/** The titlebar used in [`<Panel>`](/#!/Panel). */

function PanelTitleBar(_ref) {
  var className = _ref.className,
      title = _ref.title,
      titleOverflow = _ref.titleOverflow,
      children = _ref.children,
      testName = _ref.testName,
      theme = _ref.theme,
      style = _ref.style;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    style: style,
    "data-test-name": testName,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_Panel_sass__WEBPACK_IMPORTED_MODULE_4___default.a.titleBar, className, _Panel_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Panel_sass__WEBPACK_IMPORTED_MODULE_4___default.a.truncate, titleOverflow === 'truncate'))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("h2", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_Panel_sass__WEBPACK_IMPORTED_MODULE_4___default.a.title, _Panel_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme])
  }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_Panel_sass__WEBPACK_IMPORTED_MODULE_4___default.a.contentRight, _Panel_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme])
  }, children));
}
PanelTitleBar.defaultProps = {
  titleOverflow: 'wrap'
};
PanelTitleBar.propTypes = {
  /** Action buttons rendered to the right of the title. */
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Apply a custom class to the outermost element. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Text to be displayed in the title bar. */
  title: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** How to handle titles too long to fit in on one line. */
  titleOverflow: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOf(['wrap', 'truncate']),

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(546);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Panel-classic-2_3_6-1knCq a{color:#079bb3}.Panel-classic-2_3_6-1knCq.Panel-panel-2_3_6-2itng,.Panel-classic-2_3_6-1knCq .Panel-panel-2_3_6-2itng{background:#fff;border:1px solid #ddd;padding:16px;margin-bottom:1.3333333333rem}.Panel-classic-2_3_6-1knCq .Panel-titleBar-2_3_6-13NDe{background:#f4f4f4;padding:.6rem 1rem;margin:-16px -16px 16px}.Panel-classic-2_3_6-1knCq .Panel-title-2_3_6-A2mwD{color:#444;font-family:Lato,Helvetica,Arial,sans-serif;font-size:1rem;line-height:1.25;font-weight:400;letter-spacing:0;text-transform:uppercase}.Panel-classic-2_3_6-1knCq .Panel-contentRight-2_3_6-1UJQE{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;white-space:nowrap;padding-left:.5rem}.Panel-blueSteel-2_3_6-3OpkI a{color:#08088c}.Panel-blueSteel-2_3_6-3OpkI.Panel-panel-2_3_6-2itng,.Panel-blueSteel-2_3_6-3OpkI .Panel-panel-2_3_6-2itng{background:#fff;border:1px solid #e5e6e6;padding:24px;margin-bottom:24px}.Panel-blueSteel-2_3_6-3OpkI .Panel-titleBar-2_3_6-13NDe{background:#f2f2f3;padding:.625rem 24px;margin:-24px -24px 24px}.Panel-blueSteel-2_3_6-3OpkI .Panel-title-2_3_6-A2mwD{color:#01050e;font-family:Public Sans,sans-serif;font-size:1.333rem;line-height:28px;letter-spacing:-.25px;font-weight:800}.Panel-blueSteel-2_3_6-3OpkI .Panel-contentRight-2_3_6-1UJQE{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;white-space:nowrap;padding-left:.5rem}.Panel-titleBar-2_3_6-13NDe{display:-ms-flexbox;display:flex;min-height:50px}.Panel-title-2_3_6-A2mwD{-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;word-wrap:break-word;min-width:0;margin:0}.Panel-truncate-2_3_6-38IJQ .Panel-title-2_3_6-A2mwD:not(:hover){text-overflow:ellipsis;white-space:nowrap;overflow:hidden}", ""]);

// exports
exports.locals = {
	"classic": "Panel-classic-2_3_6-1knCq",
	"panel": "Panel-panel-2_3_6-2itng",
	"titleBar": "Panel-titleBar-2_3_6-13NDe",
	"title": "Panel-title-2_3_6-A2mwD",
	"contentRight": "Panel-contentRight-2_3_6-1UJQE",
	"truncate": "Panel-truncate-2_3_6-38IJQ",
	"blueSteel": "Panel-blueSteel-2_3_6-3OpkI"
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(548);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".ExpandableSection-classic-2_3_6-2hIMD a{color:#079bb3}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-titleBar-2_3_6-tevmo{background:#f4f4f4;padding-left:1.3333333333rem;padding-right:1.3333333333rem}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-titleBar-2_3_6-tevmo:hover{background:#eee}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-titleBar-2_3_6-tevmo>div{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-title-2_3_6-ArNh7{display:inline;color:#444;font-family:Lato,Helvetica,Arial,sans-serif;font-size:1rem;line-height:1.25;font-weight:400;letter-spacing:0;text-transform:uppercase}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-innerContent-2_3_6-34-HD{padding:1rem 1.3333333333rem 0}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-innerContent-2_3_6-34-HD>:first-child{margin-top:0}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-innerContent-2_3_6-34-HD>:last-child{margin-bottom:0}.ExpandableSection-classic-2_3_6-2hIMD.ExpandableSection-container-2_3_6-1V7Hm,.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-container-2_3_6-1V7Hm{transition:margin .2s ease-out;margin-bottom:2rem}.ExpandableSection-classic-2_3_6-2hIMD.ExpandableSection-container-2_3_6-1V7Hm.ExpandableSection-collapsed-2_3_6-3vdLx+.ExpandableSection-classic-2_3_6-2hIMD.ExpandableSection-container-2_3_6-1V7Hm,.ExpandableSection-classic-2_3_6-2hIMD.ExpandableSection-container-2_3_6-1V7Hm.ExpandableSection-collapsed-2_3_6-3vdLx+.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-container-2_3_6-1V7Hm,.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-container-2_3_6-1V7Hm.ExpandableSection-collapsed-2_3_6-3vdLx+.ExpandableSection-classic-2_3_6-2hIMD.ExpandableSection-container-2_3_6-1V7Hm,.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-container-2_3_6-1V7Hm.ExpandableSection-collapsed-2_3_6-3vdLx+.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-container-2_3_6-1V7Hm{margin-top:-.6666666667rem}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-titleWrapper-2_3_6-1IK0E{cursor:pointer}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-caret-2_3_6-IjnD7{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;font-size:.8rem;margin-left:.5rem;position:relative;top:-.1333333333rem;transition:transform .2s ease-out}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-caret-2_3_6-IjnD7.ExpandableSection-collapsed-2_3_6-3vdLx{transform:rotate(-90deg)}.ExpandableSection-classic-2_3_6-2hIMD .ExpandableSection-caret-2_3_6-IjnD7.ExpandableSection-expanded-2_3_6-2F1CB{transform:rotate(0deg)}.ExpandableSection-blueSteel-2_3_6-2yE34 a{color:#08088c}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-titleBar-2_3_6-tevmo{background:#f2f2f3;padding-left:24px;padding-right:24px}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-titleBar-2_3_6-tevmo:hover{background:#f2f2f3}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-titleBar-2_3_6-tevmo>div{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-title-2_3_6-ArNh7{display:inline;color:#01050e;font-family:Public Sans,sans-serif;font-size:1.333rem;font-weight:800;letter-spacing:-.25px;line-height:28px}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-innerContent-2_3_6-34-HD{padding:24px 24px 0}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-innerContent-2_3_6-34-HD>:first-child{margin-top:0}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-innerContent-2_3_6-34-HD>:last-child{margin-bottom:0}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-container-2_3_6-1V7Hm,.ExpandableSection-blueSteel-2_3_6-2yE34.ExpandableSection-container-2_3_6-1V7Hm{transition:margin .2s ease-out;margin-bottom:24px}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-container-2_3_6-1V7Hm.ExpandableSection-collapsed-2_3_6-3vdLx+.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-container-2_3_6-1V7Hm,.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-container-2_3_6-1V7Hm.ExpandableSection-collapsed-2_3_6-3vdLx+.ExpandableSection-blueSteel-2_3_6-2yE34.ExpandableSection-container-2_3_6-1V7Hm,.ExpandableSection-blueSteel-2_3_6-2yE34.ExpandableSection-container-2_3_6-1V7Hm.ExpandableSection-collapsed-2_3_6-3vdLx+.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-container-2_3_6-1V7Hm,.ExpandableSection-blueSteel-2_3_6-2yE34.ExpandableSection-container-2_3_6-1V7Hm.ExpandableSection-collapsed-2_3_6-3vdLx+.ExpandableSection-blueSteel-2_3_6-2yE34.ExpandableSection-container-2_3_6-1V7Hm{margin-top:-12px}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-titleWrapper-2_3_6-1IK0E{cursor:pointer}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-caret-2_3_6-IjnD7{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;font-size:.8rem;margin-left:.5rem;position:relative;top:-.1333333333rem;transition:transform .2s ease-out}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-caret-2_3_6-IjnD7.ExpandableSection-collapsed-2_3_6-3vdLx{transform:rotate(-90deg)}.ExpandableSection-blueSteel-2_3_6-2yE34 .ExpandableSection-caret-2_3_6-IjnD7.ExpandableSection-expanded-2_3_6-2F1CB{transform:rotate(0deg)}", ""]);

// exports
exports.locals = {
	"classic": "ExpandableSection-classic-2_3_6-2hIMD",
	"titleBar": "ExpandableSection-titleBar-2_3_6-tevmo",
	"title": "ExpandableSection-title-2_3_6-ArNh7",
	"innerContent": "ExpandableSection-innerContent-2_3_6-34-HD",
	"container": "ExpandableSection-container-2_3_6-1V7Hm",
	"collapsed": "ExpandableSection-collapsed-2_3_6-3vdLx",
	"titleWrapper": "ExpandableSection-titleWrapper-2_3_6-1IK0E",
	"caret": "ExpandableSection-caret-2_3_6-IjnD7",
	"expanded": "ExpandableSection-expanded-2_3_6-2F1CB",
	"blueSteel": "ExpandableSection-blueSteel-2_3_6-2yE34"
};

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(550);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return _Form__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Helper component for forms. Captures the onSubmit event to prevent full-page
 * loads
 */

var Form = function Form(_ref) {
  var className = _ref.className,
      onSubmit = _ref.onSubmit,
      children = _ref.children,
      testName = _ref.testName,
      style = _ref.style;

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    onSubmit();
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("form", {
    className: className,
    style: style,
    onSubmit: handleSubmit,
    "data-test-name": testName
  }, children);
};

Form.propTypes = {
  /** An optional class name to add to the form */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Style overrides */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Callback function fired when the form is submitted */
  onSubmit: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,

  /** Form contents - should include any input or form elements */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node
};
/* harmony default export */ __webpack_exports__["default"] = (Form);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Label__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(552);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return _Label__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return Label; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(155);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(216);
/* harmony import */ var _ToolTip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(198);
/* harmony import */ var _Label_sass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(553);
/* harmony import */ var _Label_sass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Label_sass__WEBPACK_IMPORTED_MODULE_9__);










var MAX_WIDTH = 140;

var calcWidth = function calcWidth(node) {
  if (!node) {
    return 0;
  }

  var rect = node.getBoundingClientRect();
  return rect.width;
};
/**
 * Status labels are used to communicate the status or state of entities within
 * BEACON, such as: Plans, videos, trailers etc. They are generally used to show
 * Publish vs. Unpublished states, in the case of BEACON Plans they can also be
 * used to denote when a plan is in a draft state.
 */


function Label(_ref) {
  var _cx;

  var className = _ref.className,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme,
      type = _ref.type,
      children = _ref.children,
      icon = _ref.icon,
      secondary = _ref.secondary,
      compact = _ref.compact,
      padRight = _ref.padRight;
  var container = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])();

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(0),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var hasOverflow = width > MAX_WIDTH;
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    setWidth(calcWidth(container.current));
  }, [container.current]);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a[theme], className, _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.label, _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a[type], (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.padRight, padRight), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.secondary, secondary), _cx));

  if (typeof icon === 'string') {
    icon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_7__["Icon"], {
      name: icon
    });
  }

  if (compact) {
    var body = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
      className: _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.icon
    }, icon);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(classes, _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.compact),
      style: style,
      "data-test-name": testName
    }, children ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_ToolTip__WEBPACK_IMPORTED_MODULE_8__["ToolTip"], {
      content: children,
      position: "bottom"
    }, body) : body);
  }

  var Wrapper = react__WEBPACK_IMPORTED_MODULE_2___default.a.Fragment;
  var wrapperProps = {};

  if (hasOverflow) {
    Wrapper = _ToolTip__WEBPACK_IMPORTED_MODULE_8__["ToolTip"];
    wrapperProps = {
      content: children,
      position: 'bottom'
    };
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_2___default.a.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.measure
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: classes,
    style: style,
    "data-test-name": testName,
    ref: container
  }, icon ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
    className: _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.icon
  }, icon) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.text, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.padText, Boolean(icon)))
  }, children))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(Wrapper, wrapperProps, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: classes,
    style: style,
    "data-test-name": testName
  }, icon ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
    className: _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.icon
  }, icon) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.text, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a.padText, Boolean(icon)))
  }, children))));
}
Label.propTypes = {
  /** Class name for the Label */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /**
   * The label text. The `icon` prop should be used for any icon as opposed to
   * adding an `<Icon>` as part of the `children`
   */
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /**
   * The label icon. Supports either the icon name as a string or an `Icon`
   * component. Required if the label is displayed as `compact`
   */
  icon: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_5___default()(prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node, function (props) {
    return props.compact;
  }),

  /**
   * The status or urgency that the label should convey
   */
  type: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.oneOf(['success', 'notice', 'info', 'error', 'default', 'warning']),

  /**
   * Display the label with "secondary" treatments, makes the label appear less
   * prominently on the page.
   */
  secondary: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /**
   * Display just the label icon on the page with a tooltip that displays the
   * label text.
   */
  compact: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /**
   * Adds spacing to the right side of the label. This can be useful when the
   * label is used inline with content immediately to the right.
   */
  padRight: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool
};
Label.defaultProps = {
  type: 'default',
  secondary: false,
  compact: false,
  padRight: false
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_6__["provideTheme"])(_Label_sass__WEBPACK_IMPORTED_MODULE_9___default.a)(Label));

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(554);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Label-measure-2_3_6-1SZRy{position:absolute;left:-1000px}.Label-classic-2_3_6-pShg4 a{color:#079bb3}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;height:1.5rem;max-width:8.75rem;padding:5px 8px 3px;border-radius:1px;border:1px solid #ccc;color:#079bb3}.Label-measure-2_3_6-1SZRy .Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW,.Label-measure-2_3_6-1SZRy .Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW{max-width:none}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-padRight-2_3_6-36FgS,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-padRight-2_3_6-36FgS{margin-right:.25rem}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-success-2_3_6-3OOlq,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-success-2_3_6-3OOlq{border:1px solid #b6e1cb;color:#666}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-success-2_3_6-3OOlq .Label-icon-2_3_6-22pnk,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-success-2_3_6-3OOlq .Label-icon-2_3_6-22pnk{color:#a2b00c}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-notice-2_3_6-33If8,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-notice-2_3_6-33If8{border:1px solid #ffd56b;color:#666;background-color:#ffeab2}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-info-2_3_6-u81je,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-info-2_3_6-u81je{border:1px solid #a0e3ff;color:#666;background-color:#d4f2ff}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-error-2_3_6-28WkZ,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-error-2_3_6-28WkZ{border:1px solid #f6d8cc;color:#666;background-color:#f6d8cc}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-error-2_3_6-28WkZ .Label-icon-2_3_6-22pnk,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-error-2_3_6-28WkZ .Label-icon-2_3_6-22pnk{color:#ba2453}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-warning-2_3_6-2Ll0Y,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-warning-2_3_6-2Ll0Y{border:1px solid;color:#666}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-secondary-2_3_6-VqK_e,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-secondary-2_3_6-VqK_e{border:1px solid;color:#666;background-color:#f4f4f4}.Label-classic-2_3_6-pShg4 .Label-label-2_3_6-290cW.Label-compact-2_3_6-2yOpr,.Label-classic-2_3_6-pShg4.Label-label-2_3_6-290cW.Label-compact-2_3_6-2yOpr{border:none;background-color:transparent}.Label-classic-2_3_6-pShg4 .Label-text-2_3_6-1XwWa,.Label-classic-2_3_6-pShg4.Label-text-2_3_6-1XwWa{min-width:0;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-transform:uppercase;font-weight:700}.Label-classic-2_3_6-pShg4 .Label-text-2_3_6-1XwWa.Label-padText-2_3_6-qnKUY,.Label-classic-2_3_6-pShg4.Label-text-2_3_6-1XwWa.Label-padText-2_3_6-qnKUY{margin-left:.25rem}.Label-blueSteel-2_3_6-2Ycrx a{color:#08088c}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;height:1.5rem;max-width:8.75rem;padding:5px 8px 3px;border-radius:1px;border:1px solid #e5e6e6;color:#08088c;background-color:#f2f4f9}.Label-measure-2_3_6-1SZRy .Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW,.Label-measure-2_3_6-1SZRy .Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW{max-width:none}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-padRight-2_3_6-36FgS,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-padRight-2_3_6-36FgS{margin-right:.25rem}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-success-2_3_6-3OOlq,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-success-2_3_6-3OOlq{border:1px solid #b6e1cb;color:#4d5056;background-color:#d7f6e6}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-success-2_3_6-3OOlq .Label-icon-2_3_6-22pnk,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-success-2_3_6-3OOlq .Label-icon-2_3_6-22pnk{color:#009e4f}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-notice-2_3_6-33If8,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-notice-2_3_6-33If8{border:1px solid #ffd56b;color:#4d5056;background-color:#ffeab2}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-info-2_3_6-u81je,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-info-2_3_6-u81je{border:1px solid #a0e3ff;color:#4d5056;background-color:#d4f2ff}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-info-2_3_6-u81je .Label-icon-2_3_6-22pnk,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-info-2_3_6-u81je .Label-icon-2_3_6-22pnk{color:#2ac1ff}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-error-2_3_6-28WkZ,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-error-2_3_6-28WkZ{border:1px solid #f6d8cc;color:#4d5056;background-color:#f6d8cc}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-error-2_3_6-28WkZ .Label-icon-2_3_6-22pnk,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-error-2_3_6-28WkZ .Label-icon-2_3_6-22pnk{color:#d33d00}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-warning-2_3_6-2Ll0Y,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-warning-2_3_6-2Ll0Y{border:1px solid #e5e6e6;color:#4d5056;background-color:#ffba00}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-secondary-2_3_6-VqK_e,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-secondary-2_3_6-VqK_e{border:1px solid #e5e6e6;color:#4d5056;background-color:#f9f9f9}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-secondary-2_3_6-VqK_e.Label-warning-2_3_6-2Ll0Y .Label-icon-2_3_6-22pnk,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-secondary-2_3_6-VqK_e.Label-warning-2_3_6-2Ll0Y .Label-icon-2_3_6-22pnk{color:#ffba00}.Label-blueSteel-2_3_6-2Ycrx.Label-label-2_3_6-290cW.Label-compact-2_3_6-2yOpr,.Label-blueSteel-2_3_6-2Ycrx .Label-label-2_3_6-290cW.Label-compact-2_3_6-2yOpr{border:none;background-color:transparent}.Label-blueSteel-2_3_6-2Ycrx.Label-text-2_3_6-1XwWa,.Label-blueSteel-2_3_6-2Ycrx .Label-text-2_3_6-1XwWa{min-width:0;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;letter-spacing:1px;text-transform:uppercase;line-height:16px;font-size:.75rem;font-weight:700}.Label-blueSteel-2_3_6-2Ycrx.Label-text-2_3_6-1XwWa.Label-padText-2_3_6-qnKUY,.Label-blueSteel-2_3_6-2Ycrx .Label-text-2_3_6-1XwWa.Label-padText-2_3_6-qnKUY{margin-left:.25rem}", ""]);

// exports
exports.locals = {
	"measure": "Label-measure-2_3_6-1SZRy",
	"classic": "Label-classic-2_3_6-pShg4",
	"label": "Label-label-2_3_6-290cW",
	"padRight": "Label-padRight-2_3_6-36FgS",
	"success": "Label-success-2_3_6-3OOlq",
	"icon": "Label-icon-2_3_6-22pnk",
	"notice": "Label-notice-2_3_6-33If8",
	"info": "Label-info-2_3_6-u81je",
	"error": "Label-error-2_3_6-28WkZ",
	"warning": "Label-warning-2_3_6-2Ll0Y",
	"secondary": "Label-secondary-2_3_6-VqK_e",
	"compact": "Label-compact-2_3_6-2yOpr",
	"text": "Label-text-2_3_6-1XwWa",
	"padText": "Label-padText-2_3_6-qnKUY",
	"blueSteel": "Label-blueSteel-2_3_6-2Ycrx"
};

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Pill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(556);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pill", function() { return _Pill__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pill", function() { return Pill; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var _Pill_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(557);
/* harmony import */ var _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Pill_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_components_Hideable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(231);
/* harmony import */ var js_components_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(216);








/**
 * A pill button
 *
 * This component should be used to display state within the context of a particular view.
 * An example would be displaying the current state of filters in the Analytics Module.
 *
 * Note: This component should only be used with Blue Steel
 */

function Pill(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      icon = _ref.icon,
      label = _ref.label,
      onBlur = _ref.onBlur,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      onRemove = _ref.onRemove,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme,
      title = _ref.title,
      type = _ref.type;
  var classNames = classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a.btn, _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a[type], className, testName, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a.disabled, disabled));
  var handleClick = !disabled ? onClick : null;
  var handleKeyDown = !disabled ? onKeyDown : null;
  var handleOnRemove = !disabled ? onRemove : null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    tabIndex: 0,
    className: classNames,
    role: 'button',
    "aria-disabled": disabled,
    "data-test-name": testName,
    style: style,
    onClick: function onClick(evt) {
      evt.currentTarget.blur();
      if (handleClick) handleClick(evt);
    },
    onKeyDown: function onKeyDown(evt) {
      evt.currentTarget.blur();
      if (handleKeyDown) handleKeyDown(evt);
    },
    onBlur: onBlur,
    onFocus: onFocus
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a.content
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_6__["Hideable"], {
    show: Boolean(icon)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a.icon
  }, icon)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_6__["Hideable"], {
    show: Boolean(title)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a.title
  }, title)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_6__["Hideable"], {
    show: Boolean(label)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a.label
  }, label)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_6__["Hideable"], {
    show: Boolean(onRemove) && type === 'default'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a.remove
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    tabIndex: 0,
    role: 'button',
    "aria-disabled": disabled,
    "aria-label": 'remove',
    onClick: function onClick(evt) {
      evt.currentTarget.blur();
      if (handleOnRemove) onRemove({
        title: title,
        label: label
      });
    },
    onKeyDown: function onKeyDown(evt) {
      evt.currentTarget.blur();
      if (handleOnRemove) onRemove({
        title: title,
        label: label
      });
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(js_components_Icon__WEBPACK_IMPORTED_MODULE_7__["Icon"], {
    className: _Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a.removeIcon,
    name: "cancel",
    theme: theme
  }))))));
}
Pill.defaultProps = {
  type: 'default',
  disabled: false
};
Pill.propTypes = {
  /** Checks if one of the three required content props are present */
  contentProps: function contentProps(props) {
    if (!props.title && !props.label && !props.icon) {
      return new Error('<Pill/>: You must provide one of the following props: title, text, or icon');
    }
  },

  /** Class name attribute for the pill */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Whether or not to disable the pill */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** An <Icon /> component to be displayed within the pill */
  icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,

  /** label text */
  label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Your blur handler. */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,

  /** Your click handler. */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired,

  /** Your focus handler. */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,

  /** Your keyDown handler. */
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,

  /** Callback function. If provided an x will be rendered that calls this function on click and on keyboard enter, space, delete, or backspace. */
  onRemove: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Title text */
  title: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Type of pill */
  type: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(['default', 'action'])
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_4__["provideTheme"])(_Pill_sass__WEBPACK_IMPORTED_MODULE_5___default.a)(Pill));

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(558);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Pill-classic-2_3_6-2R2gS a{color:#079bb3}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3{border-radius:16px;height:36px;color:#000;line-height:24px;font-size:14px;position:relative;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-family:Lato,Helvetica,Arial,sans-serif;display:inline-block;text-align:center;transition:transform .15s ease-out;text-decoration:none!important;white-space:nowrap;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;outline:0}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3+.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3{margin-left:16px}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-disabled-2_3_6-3oIFE{pointer-events:none;background-color:#ccc!important;border-color:#ccc!important}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-disabled-2_3_6-3oIFE div{color:#999}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8{border:1px solid #777;padding:0 12px 0 16px}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8:hover{border:1px solid #777;background-color:#ccc}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8:focus{border:2px solid #777;top:-1px;left:-1px}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8:active{border:1px solid #777;top:0;left:0}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM{color:#8e9093;transform:scale(1.1)}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM:active,.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM:focus,.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM:hover{cursor:pointer;color:#01050e}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM div{outline:0}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM div:focus .Pill-removeIcon-2_3_6-2VMLT{border:2px solid #777}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM div:active .Pill-removeIcon-2_3_6-2VMLT{border:none}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-action-2_3_6-1FvwE{border:1px dashed #aaa;background-color:#fff;padding:0 16px 0 12px}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-action-2_3_6-1FvwE:hover{border:1px solid #999;background-color:#ccc}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-action-2_3_6-1FvwE:focus{border:2px solid #777;top:-1px;left:-1px}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3.Pill-action-2_3_6-1FvwE:active{border:1px solid #777;background-color:#fff;top:0;left:0}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-weight:400;padding-top:.333rem}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj div{display:inline-block}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj .Pill-icon-2_3_6-2n8yI{margin-right:8px}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj .Pill-title-2_3_6-1cIUO{font-weight:700;padding-right:8px}.Pill-classic-2_3_6-2R2gS.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj .Pill-label-2_3_6-ZIWYU{color:#666;padding-right:8px}.Pill-blueSteel-2_3_6-1ZS3w a{color:#08088c}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3{border-radius:16px;height:32px;color:#01050e;line-height:20px;font-size:14px;position:relative;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-family:Public Sans,sans-serif;display:inline-block;text-align:center;transition:transform .15s ease-out;font-weight:700;text-decoration:none!important;white-space:nowrap;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;outline:0}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3+.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3{margin-left:16px}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-disabled-2_3_6-3oIFE{pointer-events:none;background-color:#f2f2f3!important;border-color:#f2f2f3!important}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-disabled-2_3_6-3oIFE div{color:#8e9093}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8{border:1px solid #092dbd;background-color:#f2f4f9;padding:0 12px 0 16px}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8:hover{border:1px solid #092dbd;background-color:#e5e6e6}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8:focus{border:2px solid #092dbd;background-color:#f2f4f9;top:-1px;left:-1px}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8:active{border:1px solid #092dbd;background-color:#f2f4f9;top:0;left:0}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM{color:#8e9093;transform:scale(1.1)}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM:active,.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM:focus,.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM:hover{cursor:pointer;color:#01050e}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM div{outline:0}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM div:focus .Pill-removeIcon-2_3_6-2VMLT{border:2px solid #092dbd}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-default-2_3_6-3RbQ8 .Pill-remove-2_3_6-PmLWM div:active .Pill-removeIcon-2_3_6-2VMLT{border:none}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-action-2_3_6-1FvwE{border:1px dashed #8e9093;background-color:#fff;padding:0 16px 0 12px}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-action-2_3_6-1FvwE:hover{border:1px solid #8e9093;background-color:#e5e6e6}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-action-2_3_6-1FvwE:focus{border:2px solid #092dbd;background-color:#f2f4f9;top:-1px;left:-1px}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3.Pill-action-2_3_6-1FvwE:active{border:1px solid #8e9093;background-color:#fff;top:0;left:0}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-weight:400;padding-top:.333rem}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj div{display:inline-block}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj .Pill-icon-2_3_6-2n8yI{margin-right:8px}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj .Pill-title-2_3_6-1cIUO{font-weight:700;padding-right:8px}.Pill-blueSteel-2_3_6-1ZS3w.Pill-btn-2_3_6-3jRQ3 .Pill-content-2_3_6-3Ewkj .Pill-label-2_3_6-ZIWYU{color:#4d5056;padding-right:8px}", ""]);

// exports
exports.locals = {
	"classic": "Pill-classic-2_3_6-2R2gS",
	"btn": "Pill-btn-2_3_6-3jRQ3",
	"disabled": "Pill-disabled-2_3_6-3oIFE",
	"default": "Pill-default-2_3_6-3RbQ8",
	"remove": "Pill-remove-2_3_6-PmLWM",
	"removeIcon": "Pill-removeIcon-2_3_6-2VMLT",
	"action": "Pill-action-2_3_6-1FvwE",
	"content": "Pill-content-2_3_6-3Ewkj",
	"icon": "Pill-icon-2_3_6-2n8yI",
	"title": "Pill-title-2_3_6-1cIUO",
	"label": "Pill-label-2_3_6-ZIWYU",
	"blueSteel": "Pill-blueSteel-2_3_6-1ZS3w"
};

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _PlusMinusButtons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(560);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlusMinusButtons", function() { return _PlusMinusButtons__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlusMinusButtons", function() { return PlusMinusButtons; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2);
/* harmony import */ var _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(561);
/* harmony import */ var _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);








/**
Plus & Minus buttons commonly used for adding and removing form fields.
*/

function PlusMinusButtons(props) {
  var className = props.className,
      testName = props.testName,
      style = props.style,
      plusDisabled = props.plusDisabled,
      minusDisabled = props.minusDisabled,
      onPlus = props.onPlus,
      onMinus = props.onMinus,
      plusAriaLabel = props.plusAriaLabel,
      minusAriaLabel = props.minusAriaLabel,
      theme = props.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.container, className, _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme]),
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    role: "button",
    "aria-label": minusAriaLabel,
    "aria-disabled": minusDisabled,
    tabIndex: 0,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.btn, _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.disabled, minusDisabled)),
    onClick: minusDisabled ? null : onMinus,
    onKeyDown: minusDisabled ? null : Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_5__["handleKeyboardClick"])(onMinus)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.symbol, _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.minus, _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme])
  }, "\u2013")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    role: "button",
    "aria-label": plusAriaLabel,
    "aria-disabled": plusDisabled,
    tabIndex: 0,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.btn, _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme], _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.plus, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.disabled, plusDisabled)),
    onClick: plusDisabled ? null : onPlus,
    onKeyDown: plusDisabled ? null : Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_5__["handleKeyboardClick"])(onPlus)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a.symbol, _PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme])
  }, "+")));
}
PlusMinusButtons.defaultProps = {
  plusDisabled: false,
  minusDisabled: false,
  plusAriaLabel: 'add control',
  minusAriaLabel: 'remove control'
};
PlusMinusButtons.propTypes = {
  /** Callback to invoke when plus is clicked. */
  onPlus: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default()(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func, function (props) {
    return !props.plusDisabled;
  }),

  /** Callback to invoke when minus is clicked. */
  onMinus: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default()(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func, function (props) {
    return !props.minusDisabled;
  }),

  /** Whether or not to disable the plus button. */
  plusDisabled: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Whether or not to disable the minus button. */
  minusDisabled: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Aria label for the plus button. */
  plusAriaLabel: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Aria label for the minus button. */
  minusAriaLabel: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_PlusMinusButtons_sass__WEBPACK_IMPORTED_MODULE_6___default.a)(PlusMinusButtons));

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(562);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".PlusMinusButtons-classic-2_3_6-16ziZ a{color:#079bb3}.PlusMinusButtons-classic-2_3_6-16ziZ.PlusMinusButtons-container-2_3_6-1cSsB,.PlusMinusButtons-classic-2_3_6-16ziZ .PlusMinusButtons-container-2_3_6-1cSsB{display:inline-block;margin:0 .5rem;line-height:36px;white-space:nowrap}.PlusMinusButtons-classic-2_3_6-16ziZ.PlusMinusButtons-btn-2_3_6-3jj23,.PlusMinusButtons-classic-2_3_6-16ziZ .PlusMinusButtons-btn-2_3_6-3jj23{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;overflow:hidden;background-color:#079bb3;color:#fff;border-radius:50%;width:1.0666666667rem;height:1.0666666667rem;margin:0 .25rem;text-align:center;font-weight:700;line-height:1.0666666667rem;transition:transform .15s ease,background-color .15s ease}.PlusMinusButtons-classic-2_3_6-16ziZ.PlusMinusButtons-btn-2_3_6-3jj23 .PlusMinusButtons-symbol-2_3_6-3S3BX,.PlusMinusButtons-classic-2_3_6-16ziZ .PlusMinusButtons-btn-2_3_6-3jj23 .PlusMinusButtons-symbol-2_3_6-3S3BX,.PlusMinusButtons-classic-2_3_6-16ziZ.PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-symbol-2_3_6-3S3BX,.PlusMinusButtons-classic-2_3_6-16ziZ .PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-symbol-2_3_6-3S3BX{font-size:1.2rem;margin-top:-1px}.PlusMinusButtons-classic-2_3_6-16ziZ.PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv),.PlusMinusButtons-classic-2_3_6-16ziZ .PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv){cursor:pointer}.PlusMinusButtons-classic-2_3_6-16ziZ.PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv):hover,.PlusMinusButtons-classic-2_3_6-16ziZ .PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv):hover{background-color:#08b0cc;transform:scale(1.2)}.PlusMinusButtons-classic-2_3_6-16ziZ.PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv):active,.PlusMinusButtons-classic-2_3_6-16ziZ .PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv):active{background-color:#06869a;transform:scale(1.1)}.PlusMinusButtons-classic-2_3_6-16ziZ.PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-disabled-2_3_6-Iyxmv,.PlusMinusButtons-classic-2_3_6-16ziZ .PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-disabled-2_3_6-Iyxmv{pointer-events:none;background-color:#ccc}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 a{color:#08088c}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-container-2_3_6-1cSsB,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-container-2_3_6-1cSsB{display:inline-block;margin:0 .5rem;line-height:32px;white-space:nowrap}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;overflow:hidden;background-color:#08088c;color:#fff;border-radius:50%;width:1.0666666667rem;height:1.0666666667rem;margin:0 .25rem;text-align:center;font-weight:700;line-height:1.0666666667rem;transition:transform .15s ease,background-color .15s ease}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23 .PlusMinusButtons-symbol-2_3_6-3S3BX,.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-symbol-2_3_6-3S3BX,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23 .PlusMinusButtons-symbol-2_3_6-3S3BX,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-symbol-2_3_6-3S3BX{font-size:1.2rem}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23 .PlusMinusButtons-minus-2_3_6-3n395,.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23 .PlusMinusButtons-plus-2_3_6-36NNt,.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-minus-2_3_6-3n395,.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-plus-2_3_6-36NNt,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23 .PlusMinusButtons-minus-2_3_6-3n395,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23 .PlusMinusButtons-plus-2_3_6-36NNt,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-minus-2_3_6-3n395,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-plus-2_3_6-36NNt{margin-top:-2px}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv),.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv){cursor:pointer}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv):hover,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv):hover{background-color:#0909a4;transform:scale(1.2)}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv):active,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23:not(.PlusMinusButtons-disabled-2_3_6-Iyxmv):active{background-color:#070774;transform:scale(1.1)}.PlusMinusButtons-blueSteel-2_3_6-2vyb4 .PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-disabled-2_3_6-Iyxmv,.PlusMinusButtons-blueSteel-2_3_6-2vyb4.PlusMinusButtons-btn-2_3_6-3jj23.PlusMinusButtons-disabled-2_3_6-Iyxmv{pointer-events:none;background-color:#f2f2f3}", ""]);

// exports
exports.locals = {
	"classic": "PlusMinusButtons-classic-2_3_6-16ziZ",
	"container": "PlusMinusButtons-container-2_3_6-1cSsB",
	"btn": "PlusMinusButtons-btn-2_3_6-3jj23",
	"symbol": "PlusMinusButtons-symbol-2_3_6-3S3BX",
	"disabled": "PlusMinusButtons-disabled-2_3_6-Iyxmv",
	"blueSteel": "PlusMinusButtons-blueSteel-2_3_6-2vyb4",
	"plus": "PlusMinusButtons-plus-2_3_6-36NNt",
	"minus": "PlusMinusButtons-minus-2_3_6-3n395"
};

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Progress__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(564);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return _Progress__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return Progress; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Progress_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(565);
/* harmony import */ var _Progress_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Progress_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(155);






/**
 * A progress indicator showing both determinant (percentage-like) or
 * indeterminate (loader-like) progress. For a more compact loading
 * indicator see `Loader`.
 */

function Progress(props) {
  var className = props.className,
      testName = props.testName,
      complete = props.complete,
      hasError = props.hasError,
      label = props.label,
      style = props.style,
      theme = props.theme;
  var determinate = complete != null;
  var width = '100%';
  var description = label || 'In progress.';
  var percentage = Math.min(Math.max(parseInt(complete), 0), 100);
  var valuemin, valuemax;

  if (hasError) {
    width = determinate ? "".concat(percentage, "%") : '100%';
    description = 'Progress halted due to error.';
  } else if (determinate) {
    width = "".concat(percentage, "%");
    description = "".concat(percentage, " percent");
    valuemin = 0;
    valuemax = 100;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: className,
    "data-test-name": testName,
    role: "progressbar",
    "aria-valuetext": description,
    tabIndex: "0",
    "aria-valuenow": complete,
    "aria-valuemin": valuemin,
    "aria-valuemax": valuemax,
    style: style
  }, label ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a.label, _Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme])
  }, label) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a.progress, _Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: determinate || hasError ? classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a.determinate, _Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a.hasError, hasError)) : classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a.indeterminate, _Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme]),
    style: {
      width: width
    }
  })));
}
Progress.defaultProps = {
  hasError: false
};
Progress.propTypes = {
  /** Progress className */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Percent completion. Omit for indeterminate progress. */
  complete: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,

  /** Whether or not to color determinate progress in error/magenta. Default is false. */
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Optional text above the progress bar to describe what's happening. */
  label: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_5__["provideTheme"])(_Progress_sass__WEBPACK_IMPORTED_MODULE_4___default.a)(Progress));

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(566);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Progress-classic-2_3_6-3dH_Y a{color:#079bb3}.Progress-classic-2_3_6-3dH_Y.Progress-progress-2_3_6-17ccM,.Progress-classic-2_3_6-3dH_Y .Progress-progress-2_3_6-17ccM{overflow:hidden;width:100%;height:8px;background-color:#f4f4f4;border-radius:8px}.Progress-classic-2_3_6-3dH_Y.Progress-label-2_3_6-2iOPt,.Progress-classic-2_3_6-3dH_Y .Progress-label-2_3_6-2iOPt{font-size:1rem;line-height:1.25;margin-bottom:.6666666667rem;text-align:left;padding:0}.Progress-classic-2_3_6-3dH_Y.Progress-determinate-2_3_6-3Tehh,.Progress-classic-2_3_6-3dH_Y .Progress-determinate-2_3_6-3Tehh{position:relative;max-width:100%;height:100%;background-color:#a2b00c}.Progress-classic-2_3_6-3dH_Y.Progress-determinate-2_3_6-3Tehh.Progress-hasError-2_3_6-ZQUMC,.Progress-classic-2_3_6-3dH_Y .Progress-determinate-2_3_6-3Tehh.Progress-hasError-2_3_6-ZQUMC{background-color:#ba2453}.Progress-classic-2_3_6-3dH_Y.Progress-indeterminate-2_3_6-TYnxS,.Progress-classic-2_3_6-3dH_Y .Progress-indeterminate-2_3_6-TYnxS{position:relative;width:100%;height:100%}.Progress-classic-2_3_6-3dH_Y.Progress-indeterminate-2_3_6-TYnxS:before,.Progress-classic-2_3_6-3dH_Y .Progress-indeterminate-2_3_6-TYnxS:before{content:\"\";position:absolute;height:100%;background-color:#a2b00c;animation:Progress-indeterminate_first-2_3_6-WkKgw 2s infinite ease-out}.Progress-classic-2_3_6-3dH_Y.Progress-indeterminate-2_3_6-TYnxS:after,.Progress-classic-2_3_6-3dH_Y .Progress-indeterminate-2_3_6-TYnxS:after{content:\"\";position:absolute;height:100%;background-color:#a2b00c;animation:Progress-indeterminate_second-2_3_6-SKK-Y 2s infinite ease-out}.Progress-blueSteel-2_3_6-1Duk2 a{color:#08088c}.Progress-blueSteel-2_3_6-1Duk2 .Progress-progress-2_3_6-17ccM,.Progress-blueSteel-2_3_6-1Duk2.Progress-progress-2_3_6-17ccM{overflow:hidden;width:100%;height:8px;background-color:#f2f2f3;border-radius:8px}.Progress-blueSteel-2_3_6-1Duk2 .Progress-label-2_3_6-2iOPt,.Progress-blueSteel-2_3_6-1Duk2.Progress-label-2_3_6-2iOPt{font-size:1rem;line-height:1.25;margin-bottom:.6666666667rem;text-align:left;padding:0}.Progress-blueSteel-2_3_6-1Duk2 .Progress-determinate-2_3_6-3Tehh,.Progress-blueSteel-2_3_6-1Duk2.Progress-determinate-2_3_6-3Tehh{position:relative;max-width:100%;height:100%;background-color:#009e4f}.Progress-blueSteel-2_3_6-1Duk2 .Progress-determinate-2_3_6-3Tehh.Progress-hasError-2_3_6-ZQUMC,.Progress-blueSteel-2_3_6-1Duk2.Progress-determinate-2_3_6-3Tehh.Progress-hasError-2_3_6-ZQUMC{background-color:#d33d00}.Progress-blueSteel-2_3_6-1Duk2 .Progress-indeterminate-2_3_6-TYnxS,.Progress-blueSteel-2_3_6-1Duk2.Progress-indeterminate-2_3_6-TYnxS{position:relative;width:100%;height:100%}.Progress-blueSteel-2_3_6-1Duk2 .Progress-indeterminate-2_3_6-TYnxS:before,.Progress-blueSteel-2_3_6-1Duk2.Progress-indeterminate-2_3_6-TYnxS:before{content:\"\";position:absolute;height:100%;background-color:#009e4f;animation:Progress-indeterminate_first-2_3_6-WkKgw 2s infinite ease-out}.Progress-blueSteel-2_3_6-1Duk2 .Progress-indeterminate-2_3_6-TYnxS:after,.Progress-blueSteel-2_3_6-1Duk2.Progress-indeterminate-2_3_6-TYnxS:after{content:\"\";position:absolute;height:100%;background-color:#009e4f;animation:Progress-indeterminate_second-2_3_6-SKK-Y 2s infinite ease-out}@keyframes Progress-indeterminate_first-2_3_6-WkKgw{0%{left:-100%;width:100%}to{left:100%;width:10%}}@keyframes Progress-indeterminate_second-2_3_6-SKK-Y{0%{left:-150%;width:100%}to{left:100%;width:10%}}", ""]);

// exports
exports.locals = {
	"classic": "Progress-classic-2_3_6-3dH_Y",
	"progress": "Progress-progress-2_3_6-17ccM",
	"label": "Progress-label-2_3_6-2iOPt",
	"determinate": "Progress-determinate-2_3_6-3Tehh",
	"hasError": "Progress-hasError-2_3_6-ZQUMC",
	"indeterminate": "Progress-indeterminate-2_3_6-TYnxS",
	"indeterminate_first": "Progress-indeterminate_first-2_3_6-WkKgw",
	"indeterminate_second": "Progress-indeterminate_second-2_3_6-SKK-Y",
	"blueSteel": "Progress-blueSteel-2_3_6-1Duk2"
};

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Rule__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(568);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rule", function() { return _Rule__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(155);
/* harmony import */ var _Rule_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(569);
/* harmony import */ var _Rule_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Rule_sass__WEBPACK_IMPORTED_MODULE_4__);





/**
 * Styled horizontal rule
 */

var Rule = function Rule(_ref) {
  var className = _ref.className,
      style = _ref.style,
      theme = _ref.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("hr", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Rule_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme], _Rule_sass__WEBPACK_IMPORTED_MODULE_4___default.a.rule, className),
    style: style
  });
};

Rule.propTypes = {
  /** Optional class name to apply to the rule */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Style overrides */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_3__["provideTheme"])(_Rule_sass__WEBPACK_IMPORTED_MODULE_4___default.a)(Rule));

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(570);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Rule-classic-2_3_6-EL3az a{color:#079bb3}.Rule-classic-2_3_6-EL3az.Rule-rule-2_3_6-1bm1o,.Rule-classic-2_3_6-EL3az .Rule-rule-2_3_6-1bm1o{border:none;border-bottom:1px solid #ccc}.Rule-blueSteel-2_3_6-3cD5J a{color:#08088c}.Rule-blueSteel-2_3_6-3cD5J.Rule-rule-2_3_6-1bm1o,.Rule-blueSteel-2_3_6-3cD5J .Rule-rule-2_3_6-1bm1o{border:none;border-bottom:1px solid #e5e6e6}", ""]);

// exports
exports.locals = {
	"classic": "Rule-classic-2_3_6-EL3az",
	"rule": "Rule-rule-2_3_6-1bm1o",
	"blueSteel": "Rule-blueSteel-2_3_6-3cD5J"
};

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(572);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return _Modal__WEBPACK_IMPORTED_MODULE_0__["default"]; });



/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return Modal; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_window__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(181);
/* harmony import */ var global_window__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(global_window__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var global_document__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(207);
/* harmony import */ var global_document__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(global_document__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(573);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2);
/* harmony import */ var js_components_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(469);
/* harmony import */ var js_components_Hideable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(231);
/* harmony import */ var js_components_Icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(216);
/* harmony import */ var _Modal_sass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(586);
/* harmony import */ var _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Modal_sass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ModalContents__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(588);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(155);














var isTest = "none" === 'test';
/**
 * Finds the app element in the document
 * @param appElement HTML Element or string to use as the app element
 * @returns {HTMLElement} App element
 */

function getAppElement(appElement) {
  if (typeof appElement === 'string') {
    // Support server side rendering by checking if document.querySelector is a function before calling it
    if (typeof global_document__WEBPACK_IMPORTED_MODULE_2___default.a.querySelector === 'function') {
      return global_document__WEBPACK_IMPORTED_MODULE_2___default.a.querySelector(appElement);
    }

    return null;
  }

  return appElement;
}
/**
 * A responsive and WCAG compliant Modal dialog.
 *
 * This component locks scrolling on the page in order to scroll its content.
 *
 * It traps focus (tabbing will only advanced focus to elements within the modal), and can be closed with the escape key.
 */


function Modal(_ref) {
  var _cx;

  var appElement = _ref.appElement,
      buttons = _ref.buttons,
      children = _ref.children,
      className = _ref.className,
      contentLabel = _ref.contentLabel,
      isOpen = _ref.isOpen,
      onAfterOpen = _ref.onAfterOpen,
      onClose = _ref.onClose,
      role = _ref.role,
      shrink = _ref.shrink,
      testName = _ref.testName,
      theme = _ref.theme,
      title = _ref.title,
      large = _ref.large;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(react_modal__WEBPACK_IMPORTED_MODULE_5___default.a, {
    role: role,
    isOpen: isOpen,
    onRequestClose: onClose,
    onAfterOpen: onAfterOpen,
    contentLabel: contentLabel || title || '',
    className: {
      base: !isTest ? classnames__WEBPACK_IMPORTED_MODULE_6___default()(_Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.content, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.large, large), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.shrink, shrink), _cx)) : 'content',
      afterOpen: !isTest ? classnames__WEBPACK_IMPORTED_MODULE_6___default()(_Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.contentOpen) : 'contentOpen',
      beforeClose: !isTest ? classnames__WEBPACK_IMPORTED_MODULE_6___default()(_Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.contentClose) : 'contentClose'
    },
    overlayClassName: {
      base: !isTest ? classnames__WEBPACK_IMPORTED_MODULE_6___default()(_Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.overlay) : 'overlay',
      afterOpen: !isTest ? classnames__WEBPACK_IMPORTED_MODULE_6___default()(_Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.overlayOpen) : 'overlayOpen',
      beforeClose: !isTest ? classnames__WEBPACK_IMPORTED_MODULE_6___default()(_Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.overlayClose) : 'overlayClose'
    },
    closeTimeoutMS: 200,
    appElement: getAppElement(appElement),
    shouldCloseOnOverlayClick: false
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(_Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a[theme], className, _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.wrapper),
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_9__["Hideable"], {
    show: Boolean(title)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.header
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.title
  }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    "aria-label": "close modal",
    role: "button",
    tabIndex: 0,
    className: _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.close,
    onClick: onClose,
    onKeyPress: function onKeyPress(evt) {
      return Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_7__["default"])(evt).handleClickIntent(onClose);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(js_components_Icon__WEBPACK_IMPORTED_MODULE_10__["Icon"], {
    name: "cancel"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_ModalContents__WEBPACK_IMPORTED_MODULE_12__["default"], {
    isOpen: isOpen
  }, children), buttons !== null ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: _Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a.actions
  }, buttons || /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(js_components_Button__WEBPACK_IMPORTED_MODULE_8__["Button"], {
    theme: theme,
    onClick: onClose,
    text: "Close"
  })) : null));
}
Modal.defaultProps = {
  role: 'dialog',
  appElement: '#bc-content',
  testName: 'modal',
  shrink: true
};
Modal.propTypes = {
  /** Portion of the app to hide from screen readers while modal is active. See http://reactcommunity.org/react-modal/accessibility/ */
  appElement: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.instanceOf(global_window__WEBPACK_IMPORTED_MODULE_1___default.a.HTMLElement)]),

  /** Content to be rendered in the footer of the modal. _Should_ be one or more `Button`s */
  buttons: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Contents of the modal */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** class to put on the wrapper */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /**
   * Text used by screenreaders to describe the modal content. This should be
   * the text value of the title in most cases.
   */
  contentLabel: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Whether or not this modal is shown. */
  isOpen: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool.isRequired,

  /** Function that will be run after the modal has opened. */
  onAfterOpen: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,

  /** Callback method to handle closing this modal. */
  onClose: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func.isRequired,

  /** `role` attribute for screenreaders */
  role: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /**
   * By default, the modal will be 75% of the height of the viewport. This can
   * be undesirable for certain cases, such as confirm dialogs. Use `shrink=true`
   * to set the modal's min-height to the height of its content as opposed to
   * 75% of the viewport height.
   */
  shrink: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Text to display in the title bar */
  title: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /**
   * Whether the modal should be wider - useful for more broad editing contexts
   * or if the modal contains vertical tabs
   */
  large: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_13__["provideTheme"])(_Modal_sass__WEBPACK_IMPORTED_MODULE_11___default.a)(Modal));

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(574);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(125);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(200);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(130);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(575);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(579);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(581);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(204);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(125);

var _propTypes = __webpack_require__(130);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(576);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(578);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(579);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(583);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(581);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(584);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(585);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (true) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(577);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(577);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(580);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(581);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "none" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(582);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (true) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (true) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (true) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _portalOpenInstances = __webpack_require__(584);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (true) {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(587);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Modal-wrapper-2_3_6-1J53f{margin-bottom:1.3333333333rem}.ReactModal__Body--open{overflow-y:hidden}.Modal-classic-2_3_6-31NLO a{color:#079bb3}.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi{min-width:768px;max-width:800px;padding:.5rem;margin:0 auto;margin-top:0;opacity:0;transform:translateY(-1.3rem);transition:opacity .2s ease-in-out,transform .2s ease-in-out}@media screen and (min-width:500px){.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi{padding:1.3rem}}@media screen and (min-width:640px){.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi{padding:1.3rem}}@media screen and (min-width:1025px){.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi{padding:1.3rem}}@media screen and (min-width:500px){.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi{margin-top:2.6rem}}@media screen and (min-width:640px){.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi{margin-top:100px}}@media screen and (min-width:1025px){.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi{margin-top:100px}}.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi.Modal-contentOpen-2_3_6-1guht,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi.Modal-contentOpen-2_3_6-1guht{opacity:1;transform:none}.Modal-classic-2_3_6-31NLO.Modal-content-2_3_6-XiDRi.Modal-contentClose-2_3_6-1zgdb,.Modal-classic-2_3_6-31NLO .Modal-content-2_3_6-XiDRi.Modal-contentClose-2_3_6-1zgdb{opacity:0}.Modal-classic-2_3_6-31NLO.Modal-body-2_3_6-GuHU9,.Modal-classic-2_3_6-31NLO .Modal-body-2_3_6-GuHU9{background:#fff;padding:1.3333333333rem 1.3333333333rem 0;position:relative}.Modal-classic-2_3_6-31NLO .Modal-header-2_3_6-gCotW{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;background:#079bb3;color:#fff;padding:1rem 1rem 1rem 1.3333333333rem}.Modal-classic-2_3_6-31NLO .Modal-title-2_3_6-3RILU{-ms-flex:1 1;flex:1 1;word-break:break-word;overflow-wrap:break-word;font-size:18px}.Modal-classic-2_3_6-31NLO .Modal-actions-2_3_6-3qQFT{text-align:center;padding:.6666666667rem 0;background:#ddd}.Modal-classic-2_3_6-31NLO.Modal-overlay-2_3_6-2Y7lR,.Modal-classic-2_3_6-31NLO .Modal-overlay-2_3_6-2Y7lR{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10010;background:rgba(47,79,79,.6);overflow:scroll;opacity:0;transition:opacity .2s ease-in-out}.Modal-classic-2_3_6-31NLO.Modal-overlay-2_3_6-2Y7lR.Modal-overlayOpen-2_3_6-1VRbs,.Modal-classic-2_3_6-31NLO .Modal-overlay-2_3_6-2Y7lR.Modal-overlayOpen-2_3_6-1VRbs{opacity:1}.Modal-classic-2_3_6-31NLO.Modal-overlay-2_3_6-2Y7lR.Modal-overlayClose-2_3_6-1qDIU,.Modal-classic-2_3_6-31NLO .Modal-overlay-2_3_6-2Y7lR.Modal-overlayClose-2_3_6-1qDIU{opacity:0}.Modal-classic-2_3_6-31NLO .Modal-close-2_3_6-22LXF{font-size:1.4rem;margin:-.4rem -.5rem -.4rem 1rem;padding:.4rem;cursor:pointer;transition:transform .1s ease-in-out}.Modal-classic-2_3_6-31NLO .Modal-close-2_3_6-22LXF:focus,.Modal-classic-2_3_6-31NLO .Modal-close-2_3_6-22LXF:hover{transform:scale(1.2)}.Modal-classic-2_3_6-31NLO .Modal-close-2_3_6-22LXF svg{display:block;height:1em;width:1em;max-height:100%;max-width:100%;margin:auto}.Modal-blueSteel-2_3_6-2iPtS a{color:#08088c}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi{min-width:768px;max-width:800px;padding:.5rem;margin:0 auto;margin-top:0;opacity:0;transform:translateY(-1.3rem);transition:opacity .2s ease-in-out,transform .2s ease-in-out}@media screen and (min-width:500px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi{padding:1.3rem}}@media screen and (min-width:640px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi{padding:1.3rem}}@media screen and (min-width:1025px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi{padding:1.3rem}}@media screen and (min-width:500px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi{margin-top:2.6rem}}@media screen and (min-width:640px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi{margin-top:100px}}@media screen and (min-width:1025px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi{margin-top:100px}}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-contentOpen-2_3_6-1guht,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-contentOpen-2_3_6-1guht{opacity:1;transform:none}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-contentClose-2_3_6-1zgdb,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-contentClose-2_3_6-1zgdb{opacity:0}.Modal-blueSteel-2_3_6-2iPtS.Modal-body-2_3_6-GuHU9,.Modal-blueSteel-2_3_6-2iPtS .Modal-body-2_3_6-GuHU9{background:#f9f9f9;padding:1.3333333333rem 1.3333333333rem 0;position:relative}.Modal-blueSteel-2_3_6-2iPtS .Modal-header-2_3_6-gCotW{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;background:#fff;color:#fff;padding:1rem 1rem 1rem 1.3333333333rem}.Modal-blueSteel-2_3_6-2iPtS .Modal-title-2_3_6-3RILU{-ms-flex:1 1;flex:1 1;word-break:break-word;overflow-wrap:break-word;font-size:18px}.Modal-blueSteel-2_3_6-2iPtS .Modal-actions-2_3_6-3qQFT{text-align:center;padding:.6666666667rem 0;background:#fff}.Modal-blueSteel-2_3_6-2iPtS.Modal-overlay-2_3_6-2Y7lR,.Modal-blueSteel-2_3_6-2iPtS .Modal-overlay-2_3_6-2Y7lR{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10010;background:rgba(0,0,0,.7);overflow:scroll;opacity:0;transition:opacity .2s ease-in-out}.Modal-blueSteel-2_3_6-2iPtS.Modal-overlay-2_3_6-2Y7lR.Modal-overlayOpen-2_3_6-1VRbs,.Modal-blueSteel-2_3_6-2iPtS .Modal-overlay-2_3_6-2Y7lR.Modal-overlayOpen-2_3_6-1VRbs{opacity:1}.Modal-blueSteel-2_3_6-2iPtS.Modal-overlay-2_3_6-2Y7lR.Modal-overlayClose-2_3_6-1qDIU,.Modal-blueSteel-2_3_6-2iPtS .Modal-overlay-2_3_6-2Y7lR.Modal-overlayClose-2_3_6-1qDIU{opacity:0}.Modal-blueSteel-2_3_6-2iPtS .Modal-close-2_3_6-22LXF{font-size:1.4rem;margin:-.4rem -.5rem -.4rem 1rem;padding:.4rem;cursor:pointer;transition:transform .1s ease-in-out}.Modal-blueSteel-2_3_6-2iPtS .Modal-close-2_3_6-22LXF:focus,.Modal-blueSteel-2_3_6-2iPtS .Modal-close-2_3_6-22LXF:hover{transform:scale(1.2)}.Modal-blueSteel-2_3_6-2iPtS .Modal-close-2_3_6-22LXF svg{display:block;height:1em;width:1em;max-height:100%;max-width:100%;margin:auto}.Modal-blueSteel-2_3_6-2iPtS.Modal-overlay-2_3_6-2Y7lR,.Modal-blueSteel-2_3_6-2iPtS .Modal-overlay-2_3_6-2Y7lR{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:start;align-items:flex-start}@media screen and (min-height:600px){.Modal-blueSteel-2_3_6-2iPtS.Modal-overlay-2_3_6-2Y7lR,.Modal-blueSteel-2_3_6-2iPtS .Modal-overlay-2_3_6-2Y7lR{-ms-flex-align:center;align-items:center;overflow:hidden}}.Modal-blueSteel-2_3_6-2iPtS .Modal-wrapper-2_3_6-1J53f{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:75vh}.Modal-blueSteel-2_3_6-2iPtS .Modal-header-2_3_6-gCotW{padding:1.75rem 1rem 1.75rem 1.3333333333rem}.Modal-blueSteel-2_3_6-2iPtS .Modal-actions-2_3_6-3qQFT{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding:1.3333333333rem;background:#f9f9f9}.Modal-blueSteel-2_3_6-2iPtS .Modal-body-2_3_6-GuHU9{overflow:auto;-ms-flex-positive:1;flex-grow:1}.Modal-blueSteel-2_3_6-2iPtS .Modal-title-2_3_6-3RILU,.Modal-blueSteel-2_3_6-2iPtS .Modal-title-2_3_6-3RILU h1,.Modal-blueSteel-2_3_6-2iPtS .Modal-title-2_3_6-3RILU h2{color:#01050e;font-size:2.369rem;font-weight:800;line-height:40px;letter-spacing:-.5px}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi{padding:0;margin:0 .5rem 75px;max-width:768px}@media screen and (min-width:500px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi{margin:0 1.3rem 75px}}@media screen and (min-width:640px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi{margin:0 1.3rem 75px}}@media screen and (min-width:1025px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi{margin:0 1.3rem 75px}}@media screen and (min-height:600px){.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi{height:75vh}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi.Modal-shrink-2_3_6-_I7gc,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi.Modal-shrink-2_3_6-_I7gc{display:block;max-height:75vh;height:auto}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi.Modal-shrink-2_3_6-_I7gc .Modal-wrapper-2_3_6-1J53f,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi.Modal-shrink-2_3_6-_I7gc .Modal-wrapper-2_3_6-1J53f{height:auto;max-height:75vh}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi.Modal-shrink-2_3_6-_I7gc .Modal-body-2_3_6-GuHU9,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi.Modal-shrink-2_3_6-_I7gc .Modal-body-2_3_6-GuHU9{-ms-flex-positive:0;flex-grow:0}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi .Modal-wrapper-2_3_6-1J53f,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi .Modal-wrapper-2_3_6-1J53f{margin-bottom:0}}.Modal-blueSteel-2_3_6-2iPtS.Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi.Modal-large-2_3_6-2LL1d,.Modal-blueSteel-2_3_6-2iPtS .Modal-content-2_3_6-XiDRi.Modal-content-2_3_6-XiDRi.Modal-large-2_3_6-2LL1d{min-width:1024px;max-width:1024px}.Modal-blueSteel-2_3_6-2iPtS.Modal-close-2_3_6-22LXF,.Modal-blueSteel-2_3_6-2iPtS .Modal-close-2_3_6-22LXF{position:relative;top:-1.4rem;right:-.7rem;margin:0;color:#01050e;font-size:16px;transition:color .1s ease-in-out}.Modal-blueSteel-2_3_6-2iPtS.Modal-close-2_3_6-22LXF:focus,.Modal-blueSteel-2_3_6-2iPtS .Modal-close-2_3_6-22LXF:focus,.Modal-blueSteel-2_3_6-2iPtS.Modal-close-2_3_6-22LXF:hover,.Modal-blueSteel-2_3_6-2iPtS .Modal-close-2_3_6-22LXF:hover{transform:none;color:#092dbd}", ""]);

// exports
exports.locals = {
	"wrapper": "Modal-wrapper-2_3_6-1J53f",
	"classic": "Modal-classic-2_3_6-31NLO",
	"content": "Modal-content-2_3_6-XiDRi",
	"contentOpen": "Modal-contentOpen-2_3_6-1guht",
	"contentClose": "Modal-contentClose-2_3_6-1zgdb",
	"body": "Modal-body-2_3_6-GuHU9",
	"header": "Modal-header-2_3_6-gCotW",
	"title": "Modal-title-2_3_6-3RILU",
	"actions": "Modal-actions-2_3_6-3qQFT",
	"overlay": "Modal-overlay-2_3_6-2Y7lR",
	"overlayOpen": "Modal-overlayOpen-2_3_6-1VRbs",
	"overlayClose": "Modal-overlayClose-2_3_6-1qDIU",
	"close": "Modal-close-2_3_6-22LXF",
	"blueSteel": "Modal-blueSteel-2_3_6-2iPtS",
	"shrink": "Modal-shrink-2_3_6-_I7gc",
	"large": "Modal-large-2_3_6-2LL1d"
};

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ModalContents; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Modal_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(586);
/* harmony import */ var _Modal_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Modal_sass__WEBPACK_IMPORTED_MODULE_8__);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




/**
 * Wraps the modal body content in a conditional shouldComponentUpdate
 * this allows the onClose handler of Modal to clean up information
 * related to the modal's rendering without affecting the fade-out
 * rendering of the modal.
 */

var ModalContents = /*#__PURE__*/function (_Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(ModalContents, _Component);

  var _super = _createSuper(ModalContents);

  function ModalContents() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ModalContents);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ModalContents, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.isOpen;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement("div", {
        className: _Modal_sass__WEBPACK_IMPORTED_MODULE_8___default.a.body
      }, this.props.children);
    }
  }]);

  return ModalContents;
}(react__WEBPACK_IMPORTED_MODULE_6__["Component"]);


ModalContents.propTypes = {
  /** Whether or not this modal is shown. */
  isOpen: prop_types__WEBPACK_IMPORTED_MODULE_7___default.a.bool.isRequired,

  /** Contents of the modal */
  children: prop_types__WEBPACK_IMPORTED_MODULE_7___default.a.node
};

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Notice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(590);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Notice", function() { return _Notice__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Notice; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(229);
/* harmony import */ var _util_deprecationWarning__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83);






/**
 * A Notice.
 * @deprecated Use [Alert](#alert) instead
 */

function Notice(props) {
  Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_5__["default"])('Notice is deprecated, use Alert instead');
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Alert__WEBPACK_IMPORTED_MODULE_4__["Alert"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, props, {
    type: "notice"
  }));
}
Notice.propTypes = {
  /** Whether this component should be full-width. */
  block: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Notice html. You may alternately use the `text` prop for plain text. */
  children: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default()(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node, function (props) {
    return !props.text;
  }),

  /** Container className */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Notice text. You can also pass this in via `children` */
  text: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_3___default()(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string, function (props) {
    return !props.children;
  })
};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Pager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(592);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pager", function() { return _Pager__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pager", function() { return Pager; });
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(469);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(216);
/* harmony import */ var _PageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(593);
/* harmony import */ var _Pager_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(594);
/* harmony import */ var _Pager_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Pager_sass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(155);









/**
 * Pagination controls are used to help users navigate through a list of items
 * that may be too large to display all at once. Controls are provided to allow
 * users to change the current subset of items that are visible in the list and
 * indicate the subset of items in the list the user is currently viewing.
 */

function Pager(props) {
  var className = props.className,
      currentPage = props.currentPage,
      onChange = props.onChange,
      itemsPerPage = props.itemsPerPage,
      totalItemCount = props.totalItemCount,
      style = props.style,
      testName = props.testName,
      theme = props.theme;
  var pageCount = Math.ceil(totalItemCount / itemsPerPage) || 1;
  var lastPage = pageCount - 1;
  var firstItemIndex = currentPage * itemsPerPage;
  var itemsAfterFirst = totalItemCount - firstItemIndex;
  var visibleItemCount = Math.min(itemsPerPage, itemsAfterFirst);
  var lastItemIndex = firstItemIndex + visibleItemCount;
  var ariaLabel = props['aria-label'] || ["Showing items ".concat(firstItemIndex + 1), "through ".concat(lastItemIndex), "of ".concat(totalItemCount), 'pagination'].join(' ');
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a.container, className, _Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme]),
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("nav", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a.controls, _Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme]),
    "aria-label": ariaLabel,
    role: "navigation"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Button__WEBPACK_IMPORTED_MODULE_4__["Button"], {
    "aria-label": "Beginning",
    small: true,
    onClick: function onClick() {
      return onChange(0);
    },
    disabled: currentPage === 0,
    theme: theme
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_5__["Icon"], {
    className: _Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a.icon,
    theme: theme,
    color: "currentColor",
    name: "beginning"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Button__WEBPACK_IMPORTED_MODULE_4__["Button"], {
    "aria-label": "Previous",
    small: true,
    onClick: function onClick() {
      return onChange(currentPage - 1);
    },
    disabled: currentPage === 0,
    theme: theme
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_5__["Icon"], {
    className: _Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a.icon,
    color: "currentColor",
    name: "triangle_left",
    theme: theme
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_PageContext__WEBPACK_IMPORTED_MODULE_6__["default"], {
    firstItemIndex: firstItemIndex,
    itemsPerPage: itemsPerPage,
    visibleItemCount: visibleItemCount,
    totalItemCount: totalItemCount,
    theme: theme
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Button__WEBPACK_IMPORTED_MODULE_4__["Button"], {
    "aria-label": "Next",
    small: true,
    onClick: function onClick() {
      return onChange(currentPage + 1);
    },
    disabled: currentPage === lastPage,
    theme: theme
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_5__["Icon"], {
    className: _Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a.icon,
    color: "currentColor",
    name: "triangle_right",
    theme: theme
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Button__WEBPACK_IMPORTED_MODULE_4__["Button"], {
    "aria-label": "End",
    small: true,
    onClick: function onClick() {
      return onChange(lastPage);
    },
    disabled: currentPage === lastPage,
    theme: theme
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_5__["Icon"], {
    className: _Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a.icon,
    theme: theme,
    color: "currentColor",
    name: "end"
  }))));
}
Pager.propTypes = {
  /**
   * A descriptive label for the pager navigation that can be used by screen
   * readers to better-convey the pager's purpose to users
   */
  'aria-label': prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** The active page displayed */
  currentPage: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number.isRequired,

  /** The page size, or maximum number of items that can be displayed at once */
  itemsPerPage: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number.isRequired,

  /**
   * Callback function invoked with the desired page index (0-based) when
   * the user interacts with pagination controls
   */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** The total number of items across all pages of the list */
  totalItemCount: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number.isRequired,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_8__["provideTheme"])(_Pager_sass__WEBPACK_IMPORTED_MODULE_7___default.a)(Pager));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PageContext", function() { return PageContext; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(222);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Pager_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(594);
/* harmony import */ var _Pager_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Pager_sass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);








function PageContext(_ref) {
  var firstItemIndex = _ref.firstItemIndex,
      visibleItemCount = _ref.visibleItemCount,
      totalItemCount = _ref.totalItemCount,
      theme = _ref.theme,
      props = _ref.props;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(''),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_useState, 2),
      role = _useState2[0],
      setRole = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var hasChanges = Object.keys(PageContext.propTypes).reduce(function (hasChanges) {
      return hasChanges;
    }, false);

    if (hasChanges) {
      setRole('alert');
    }
  }, [props]);
  var startNumber = !totalItemCount ? 0 : firstItemIndex + 1;
  var endNumber = startNumber + visibleItemCount - 1;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Pager_sass__WEBPACK_IMPORTED_MODULE_6___default.a.pageContext, _Pager_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme]),
    role: role
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    "aria-hidden": "true"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", null, startNumber), "\u2013", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", null, totalItemCount && endNumber), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Pager_sass__WEBPACK_IMPORTED_MODULE_6___default.a.normalText, _Pager_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme])
  }, "\xA0of\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", null, totalItemCount)));
}
PageContext.propTypes = {
  firstItemIndex: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number.isRequired,
  visibleItemCount: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number.isRequired,
  totalItemCount: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number.isRequired,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
  props: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.any
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_Pager_sass__WEBPACK_IMPORTED_MODULE_6___default.a)(PageContext));

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(595);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Pager-classic-2_3_6-tAGIh a{color:#079bb3}.Pager-classic-2_3_6-tAGIh.Pager-container-2_3_6-2Vf9K,.Pager-classic-2_3_6-tAGIh .Pager-container-2_3_6-2Vf9K{text-align:center}.Pager-classic-2_3_6-tAGIh.Pager-controls-2_3_6-3N5VF,.Pager-classic-2_3_6-tAGIh .Pager-controls-2_3_6-3N5VF{margin:auto}.Pager-classic-2_3_6-tAGIh.Pager-icon-2_3_6-14t5e,.Pager-classic-2_3_6-tAGIh .Pager-icon-2_3_6-14t5e{height:1.0666666667rem;vertical-align:-.2rem;width:1.0666666667rem}.Pager-classic-2_3_6-tAGIh.Pager-normalText-2_3_6-2fH3P,.Pager-classic-2_3_6-tAGIh .Pager-normalText-2_3_6-2fH3P{font-weight:400}.Pager-classic-2_3_6-tAGIh.Pager-pageContext-2_3_6-1ys1K,.Pager-classic-2_3_6-tAGIh .Pager-pageContext-2_3_6-1ys1K{color:#444;display:inline-block;font-size:.9333333333rem;font-weight:700;margin:0 1rem;min-width:6rem;text-align:center}.Pager-blueSteel-2_3_6-2kO6I a{color:#08088c}.Pager-blueSteel-2_3_6-2kO6I.Pager-container-2_3_6-2Vf9K,.Pager-blueSteel-2_3_6-2kO6I .Pager-container-2_3_6-2Vf9K{text-align:center}.Pager-blueSteel-2_3_6-2kO6I.Pager-controls-2_3_6-3N5VF,.Pager-blueSteel-2_3_6-2kO6I .Pager-controls-2_3_6-3N5VF{margin:auto}.Pager-blueSteel-2_3_6-2kO6I.Pager-icon-2_3_6-14t5e,.Pager-blueSteel-2_3_6-2kO6I .Pager-icon-2_3_6-14t5e{height:1.0666666667rem;vertical-align:-.2rem;width:1.0666666667rem}.Pager-blueSteel-2_3_6-2kO6I.Pager-normalText-2_3_6-2fH3P,.Pager-blueSteel-2_3_6-2kO6I .Pager-normalText-2_3_6-2fH3P{font-weight:400}.Pager-blueSteel-2_3_6-2kO6I.Pager-pageContext-2_3_6-1ys1K,.Pager-blueSteel-2_3_6-2kO6I .Pager-pageContext-2_3_6-1ys1K{color:#01050e;display:inline-block;font-size:.9333333333rem;font-weight:700;margin:0 1rem;min-width:6rem;text-align:center}", ""]);

// exports
exports.locals = {
	"classic": "Pager-classic-2_3_6-tAGIh",
	"container": "Pager-container-2_3_6-2Vf9K",
	"controls": "Pager-controls-2_3_6-3N5VF",
	"icon": "Pager-icon-2_3_6-14t5e",
	"normalText": "Pager-normalText-2_3_6-2fH3P",
	"pageContext": "Pager-pageContext-2_3_6-1ys1K",
	"blueSteel": "Pager-blueSteel-2_3_6-2kO6I"
};

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Panel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(597);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _Panel__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _PanelTitleBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(544);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelTitleBar", function() { return _PanelTitleBar__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return Panel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_components_Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(155);
/* harmony import */ var js_components_Hideable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(231);
/* harmony import */ var _PanelTitleBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(544);
/* harmony import */ var _Panel_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(545);
/* harmony import */ var _Panel_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Panel_sass__WEBPACK_IMPORTED_MODULE_6__);







/** A content Panel with an optional title. */

function Panel(props) {
  var title = props.title,
      titleOverflow = props.titleOverflow,
      className = props.className,
      testName = props.testName,
      style = props.style,
      theme = props.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Panel_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme], _Panel_sass__WEBPACK_IMPORTED_MODULE_6___default.a.panel, className),
    "data-test-name": testName,
    style: style
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(js_components_Hideable__WEBPACK_IMPORTED_MODULE_4__["Hideable"], {
    show: Boolean(title)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_PanelTitleBar__WEBPACK_IMPORTED_MODULE_5__["default"], {
    title: title,
    titleOverflow: titleOverflow,
    theme: theme
  })), props.children);
}
Panel.defaultProps = {
  titleOverflow: 'wrap'
};
Panel.propTypes = {
  /** Content to be displayed within the panel */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Apply a custom class to the outermost element. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Text to be displayed in the title bar */
  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** How to handle titles too long to fit in on one line. */
  titleOverflow: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['wrap', 'truncate']),

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(js_components_Theme__WEBPACK_IMPORTED_MODULE_3__["provideTheme"])(_Panel_sass__WEBPACK_IMPORTED_MODULE_6___default.a)(Panel));

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _RadioInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(599);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioInput", function() { return _RadioInput__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioInput", function() { return RadioInput; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(383);
/* harmony import */ var _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_RadioInput_sass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(155);










function handleEvent(value, callback) {
  if (!callback) return null;
  return function (evt) {
    return callback(value, evt);
  };
}
/**
RadioInput is the component used by [`<RadioGroup>`](#!/RadioGroup) to render
individual inputs. It may be also be used by itself to create radio groups with
custom-rendered content.

All form inputs in this library must be implemented as [controlled
 components](https://reactjs.org/docs/forms.html#controlled-components).

 __Accessibility notes:__
 - [Smart focus outlines](#!/EnableSmartFocusOutlines) are rendered around the
   focused radio content.
 - Screen readers recognize radio buttons as such and read their contents and
   report whether it is selected or unselected.
*/


function RadioInput(_ref) {
  var _cx;

  var checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      inline = _ref.inline,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      style = _ref.style,
      testName = _ref.testName,
      value = _ref.value,
      theme = _ref.theme,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["checked", "children", "className", "disabled", "inline", "name", "onBlur", "onChange", "onFocus", "style", "testName", "value", "theme"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(className, _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a.radioInput, _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme], (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a.inline, inline), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a.selected, checked), _cx)),
    "data-test-name": testName,
    style: style
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(_RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a.bullet, _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", null)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(_RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a.label, _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("input", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    checked: checked,
    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(_RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a.input, _RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme]),
    disabled: disabled,
    name: name,
    onBlur: handleEvent(value, onBlur),
    onChange: handleEvent(value, onChange),
    onFocus: handleEvent(value, onFocus),
    type: "radio",
    value: value
  }, rest)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", null, children)));
}
RadioInput.propTypes = {
  /** Container class attribute */
  className: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Whether or not the radio input is selected */
  checked: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** Text/nodes to render alongside the radio input */
  children: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.node,

  /** Whether or not to disable this input */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** Name attribute for the `<input>` */
  name: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string.isRequired,

  /** Your blur handler */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func,

  /** Your change handler */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func,

  /** Your focus handler */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object,

  /** Test name for automation. */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** The value associated with this radio input */
  value: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.any,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_8__["provideTheme"])(_RadioInput_sass__WEBPACK_IMPORTED_MODULE_7___default.a)(RadioInput));

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _SearchInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(601);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SearchInput", function() { return _SearchInput__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SearchInput", function() { return SearchInput; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(602);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _util_keycode__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2);
/* harmony import */ var _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(604);
/* harmony import */ var _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_SearchInput_sass__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(216);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(155);















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









/**
 * A search input
 *
 * This component should be used in place of an Input or PlainInput component when the input is used for searching or
 * filtering items in a list. For whole-page searches (i.e. on the index page) it should be placed in the upper-right
 * corner. For list searches, it should be placed above the item list and span the full width of the list component.
 * Searching should be performed as the user is typing, no additional action should be required to search or filter
 * the items in the list. For client-side filtering, this should be done instantaneously. For server-side searches,
 * the requests should be debounced or throttled so as to not overwhelm the backend service.
 *
 * For more use cases, please see the specs: https://50npcc.axshare.com/#g=1&p=search_specs
 *
 * All form inputs in this library must be implemented as [controlled
 * components](https://reactjs.org/docs/forms.html#controlled-components).
 */

var SearchInput = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(SearchInput, _React$Component);

  var _super = _createSuper(SearchInput);

  function SearchInput() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SearchInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this), "onSubmit", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var _this$props = _this.props,
          onSubmit = _this$props.onSubmit,
          value = _this$props.value;

      if (onSubmit) {
        onSubmit(value, evt);
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this), "handleClear", function (evt) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onChange = _this$props2.onChange,
          onClear = _this$props2.onClear,
          disabled = _this$props2.disabled;

      if (!disabled) {
        if (value) {
          onChange('', evt);
        }

        _this.focus();

        if (onClear) {
          onClear(value, evt);
        }
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this), "handleIconKeyDown", function (evt) {
      var key = Object(_util_keycode__WEBPACK_IMPORTED_MODULE_18__["default"])(evt);

      if (key.is('space') || key.is('enter')) {
        evt.preventDefault(); // prevent scrolling due to space

        _this.handleClear();
      }
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(SearchInput, [{
    key: "focus",
    value:
    /**
     * Focuses the underlying text input component
     */
    function focus() {
      this.instance.focus();
    }
    /**
     * Selects the underlying text input component
     */

  }, {
    key: "select",
    value: function select() {
      this.instance.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _cx2,
          _cx3,
          _this2 = this,
          _cx4;

      var _this$props3 = this.props,
          className = _this$props3.className,
          contentBottom = _this$props3.contentBottom,
          dir = _this$props3.dir,
          disabled = _this$props3.disabled,
          hasError = _this$props3.hasError,
          id = _this$props3.id,
          maxLength = _this$props3.maxLength,
          name = _this$props3.name,
          noPad = _this$props3.noPad,
          onBlur = _this$props3.onBlur,
          onChange = _this$props3.onChange,
          onClear = _this$props3.onClear,
          onClick = _this$props3.onClick,
          onFocus = _this$props3.onFocus,
          onSubmit = _this$props3.onSubmit,
          placeholder = _this$props3.placeholder,
          autoFocus = _this$props3.autoFocus,
          style = _this$props3.style,
          testName = _this$props3.testName,
          theme = _this$props3.theme,
          value = _this$props3.value,
          rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_this$props3, ["className", "contentBottom", "dir", "disabled", "hasError", "id", "maxLength", "name", "noPad", "onBlur", "onChange", "onClear", "onClick", "onFocus", "onSubmit", "placeholder", "autoFocus", "style", "testName", "theme", "value"]);

      var removeIcon = theme === 'classic' ? 'remove_outline' : 'cancel';
      var parentClasses = classnames__WEBPACK_IMPORTED_MODULE_17___default()(_SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a[theme], _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.form, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()({}, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.noPad, noPad));
      var containerClasses = classnames__WEBPACK_IMPORTED_MODULE_17___default()(_SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.control, (_cx2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_cx2, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.hasValue, value), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_cx2, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_cx2, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.hasError, hasError), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_cx2, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.noPad, noPad && !contentBottom), _cx2));
      var iconClasses = classnames__WEBPACK_IMPORTED_MODULE_17___default()(_SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.icon, (_cx3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_cx3, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_cx3, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.empty, !value), _cx3));
      var renderSearch = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_14___default.a.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("div", {
        className: containerClasses
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_20__["Icon"], {
        name: 'search',
        className: classnames__WEBPACK_IMPORTED_MODULE_17___default()(_SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.search, iconClasses)
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("input", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
        className: _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.input,
        "data-test-name": testName,
        dir: dir,
        disabled: disabled,
        id: id,
        maxLength: maxLength,
        name: name,
        onBlur: onBlur ? function (evt) {
          return onBlur(evt.target.value, evt);
        } : null,
        onChange: onChange ? function (evt) {
          return onChange(evt.target.value, evt);
        } : null,
        onClick: onClick,
        onFocus: onFocus ? function (evt) {
          return onFocus(evt.target.value, evt);
        } : null,
        placeholder: placeholder,
        autoFocus: autoFocus,
        style: style,
        type: "search",
        value: String(value),
        ref: function ref(node) {
          _this2.instance = node;
        }
      }, rest)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("a", {
        onClick: this.handleClear,
        tabIndex: value && !disabled ? 0 : -1,
        onKeyDown: this.handleIconKeyDown,
        role: "button",
        "aria-disabled": disabled,
        "aria-label": value ? 'Clear Search' : 'Search'
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_20__["Icon"], {
        name: value ? removeIcon : 'search',
        className: classnames__WEBPACK_IMPORTED_MODULE_17___default()(iconClasses, (_cx4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_cx4, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.rightSearch, !value), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9___default()(_cx4, _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.remove, value), _cx4))
      }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("div", {
        className: _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.bottom
      }, contentBottom));
      var hideFormTag = onSubmit != null;

      if (hideFormTag) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("form", {
          className: parentClasses,
          role: "search",
          onSubmit: this.onSubmit
        }, renderSearch, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("div", {
          className: _SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a.bottom
        }, contentBottom));
      } else return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_14___default.a.createElement("div", {
        className: parentClasses
      }, renderSearch);
    }
  }]);

  return SearchInput;
}(react__WEBPACK_IMPORTED_MODULE_14___default.a.Component);
SearchInput.defaultProps = {
  dir: 'auto',
  disabled: false,
  noPad: false
};
SearchInput.propTypes = {
  /** Class name for the input */
  className: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** Content placed underneath the search input and justified right. This space is used for advanced search options. */
  contentBottom: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.node,

  /** Direction for the dir attribute*/
  dir: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.oneOf(['auto', 'ltr', 'rtl']),

  /** whether or not to disable the input */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.bool,

  /** Whether or not to render an error border around the input */
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.bool,

  /** id attribute for the input */
  id: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** maxLength attribute for the input */
  maxLength: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.number,

  /** name attribute for the input */
  name: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** Specifies that bottom margin should not be applied */
  noPad: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.bool,

  /**
   * Your blur handler.
   * @param {string} value - Current value of the input.
   * @param {SyntheticEvent} event - The event.
   */
  onBlur: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func,

  /**
   * Your change handler. Update your state here.
   * @param {string} value - Current value of the input.
   * @param {SyntheticEvent} event - The event.
   */
  onChange: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_16___default()(prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func, function (props) {
    return !(props.readOnly || props.disabled);
  }),

  /**
   * Your click handler.
   * @param {SyntheticEvent} event - The click event.
   */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func,

  /**
   * Your focus handler.
   * @param {string} value - Current value of the input.
   * @param {SyntheticEvent} event - The event.
   */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func,

  /**
   * Your submit handler. Called by pressing Enter.
   * @param {string} value - Current value of the input.
   * @param {SyntheticEvent} event - The event.
   */
  onSubmit: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func,

  /** Your clear search handler */
  onClear: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.func,

  /** Placeholder text for the input */
  placeholder: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** Whether the input is initially focused when mounted */
  autoFocus: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string,

  /** Current value of the field. */
  value: prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_15___default.a.number]).isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_21__["provideTheme"])(_SearchInput_sass__WEBPACK_IMPORTED_MODULE_19___default.a)(SearchInput));

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(67);
var anObject = __webpack_require__(26);
var requireObjectCoercible = __webpack_require__(18);
var sameValue = __webpack_require__(603);
var regExpExec = __webpack_require__(73);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 603 */
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(605);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".SearchInput-classic-2_3_6-1YI5q a{color:#079bb3}.SearchInput-classic-2_3_6-1YI5q.SearchInput-form-2_3_6-2bdgM,.SearchInput-classic-2_3_6-1YI5q .SearchInput-form-2_3_6-2bdgM{margin-bottom:.3333333333rem}.SearchInput-classic-2_3_6-1YI5q.SearchInput-form-2_3_6-2bdgM.SearchInput-noPad-2_3_6-2rMDe,.SearchInput-classic-2_3_6-1YI5q .SearchInput-form-2_3_6-2bdgM.SearchInput-noPad-2_3_6-2rMDe{margin-bottom:0}.SearchInput-classic-2_3_6-1YI5q .SearchInput-control-2_3_6-DpH7b{display:-ms-flexbox;display:flex;margin-bottom:.3333333333rem}.SearchInput-classic-2_3_6-1YI5q .SearchInput-control-2_3_6-DpH7b.SearchInput-disabled-2_3_6-19zvn{background-color:#f2f2f2;border:1px solid #ccc}.SearchInput-classic-2_3_6-1YI5q .SearchInput-control-2_3_6-DpH7b.SearchInput-disabled-2_3_6-19zvn.SearchInput-hasError-2_3_6-36O92{border-color:#ba2453}.SearchInput-classic-2_3_6-1YI5q .SearchInput-control-2_3_6-DpH7b.SearchInput-noPad-2_3_6-2rMDe{margin-bottom:0}.SearchInput-classic-2_3_6-1YI5q .SearchInput-control-2_3_6-DpH7b{border-radius:4px;border:1px solid #aaa;background-color:#fff}.SearchInput-classic-2_3_6-1YI5q .SearchInput-control-2_3_6-DpH7b:not(.SearchInput-disabled-2_3_6-19zvn):hover{border-color:#999}.SearchInput-classic-2_3_6-1YI5q .SearchInput-control-2_3_6-DpH7b:not(.SearchInput-disabled-2_3_6-19zvn):focus-within{border-color:#777}.SearchInput-classic-2_3_6-1YI5q .SearchInput-input-2_3_6-Wf-QI{font-size:1rem;line-height:18px;padding:8px;border-radius:4px}.SearchInput-classic-2_3_6-1YI5q .SearchInput-icon-2_3_6-1IGif{padding:10px;height:34px;width:34px}.SearchInput-classic-2_3_6-1YI5q .SearchInput-icon-2_3_6-1IGif.SearchInput-search-2_3_6-3KNSB{display:none}.SearchInput-classic-2_3_6-1YI5q .SearchInput-icon-2_3_6-1IGif.SearchInput-empty-2_3_6-2C3lB{padding:8px;cursor:text}.SearchInput-classic-2_3_6-1YI5q .SearchInput-input-2_3_6-Wf-QI{-webkit-appearance:none;-ms-flex:1 1 auto;flex:1 1 auto;background:transparent;font-family:Lato,Helvetica,Arial,sans-serif;border:none;color:#444;font-size:14px}.SearchInput-classic-2_3_6-1YI5q .SearchInput-input-2_3_6-Wf-QI:disabled{color:#888}.SearchInput-classic-2_3_6-1YI5q .SearchInput-input-2_3_6-Wf-QI::-ms-clear{display:none}.SearchInput-classic-2_3_6-1YI5q .SearchInput-input-2_3_6-Wf-QI::-webkit-search-cancel-button{-webkit-appearance:none}.SearchInput-classic-2_3_6-1YI5q .SearchInput-icon-2_3_6-1IGif{color:#888;cursor:pointer}.SearchInput-classic-2_3_6-1YI5q .SearchInput-icon-2_3_6-1IGif.SearchInput-disabled-2_3_6-19zvn,.SearchInput-classic-2_3_6-1YI5q .SearchInput-icon-2_3_6-1IGif.SearchInput-search-2_3_6-3KNSB{cursor:default}.SearchInput-classic-2_3_6-1YI5q .SearchInput-bottom-2_3_6-3sBrE{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end}.SearchInput-blueSteel-2_3_6-MQYmy a{color:#08088c}.SearchInput-blueSteel-2_3_6-MQYmy.SearchInput-form-2_3_6-2bdgM,.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-form-2_3_6-2bdgM{margin-bottom:.3333333333rem}.SearchInput-blueSteel-2_3_6-MQYmy.SearchInput-form-2_3_6-2bdgM.SearchInput-noPad-2_3_6-2rMDe,.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-form-2_3_6-2bdgM.SearchInput-noPad-2_3_6-2rMDe{margin-bottom:0}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b{display:-ms-flexbox;display:flex;margin-bottom:.3333333333rem}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b.SearchInput-disabled-2_3_6-19zvn{background-color:#f2f2f2;border:1px solid #f2f2f3}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b.SearchInput-disabled-2_3_6-19zvn.SearchInput-hasError-2_3_6-36O92{border-color:#d33d00}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b.SearchInput-noPad-2_3_6-2rMDe{margin-bottom:0}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b{border-radius:2px;border:1px solid transparent;border-bottom:1px solid #8e9093}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b.SearchInput-hasValue-2_3_6-fTbxL{background:#fff}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b.SearchInput-hasValue-2_3_6-fTbxL.SearchInput-typing-2_3_6-2lr7B{border-color:#8e9093;box-shadow:0 0 0 1px #8e9093}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b:hover{border-color:#8e9093}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b:focus-within{border-color:#092dbd;box-shadow:0 0 0 1px #092dbd}.hide-focus-outlines .SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-control-2_3_6-DpH7b:focus-within{border-color:#8e9093;box-shadow:0 0 0 1px #8e9093}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-input-2_3_6-Wf-QI{outline:none;line-height:20px;padding:9px 0;font-size:.875rem;letter-spacing:auto;font-weight:400}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-icon-2_3_6-1IGif{padding:0;height:16px;width:16px;margin:11px 12px 0}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-icon-2_3_6-1IGif.SearchInput-rightSearch-2_3_6-13ULK{display:none}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-icon-2_3_6-1IGif.SearchInput-remove-2_3_6-1E28z{color:#08088c}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-input-2_3_6-Wf-QI{-webkit-appearance:none;-ms-flex:1 1 auto;flex:1 1 auto;background:transparent;font-family:Public Sans,sans-serif;border:none;color:#01050e;font-size:14px}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-input-2_3_6-Wf-QI:disabled{color:#4d5056}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-input-2_3_6-Wf-QI::-ms-clear{display:none}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-input-2_3_6-Wf-QI::-webkit-search-cancel-button{-webkit-appearance:none}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-icon-2_3_6-1IGif{color:#4d5056;cursor:pointer}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-icon-2_3_6-1IGif.SearchInput-disabled-2_3_6-19zvn,.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-icon-2_3_6-1IGif.SearchInput-search-2_3_6-3KNSB{cursor:default}.SearchInput-blueSteel-2_3_6-MQYmy .SearchInput-bottom-2_3_6-3sBrE{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"classic": "SearchInput-classic-2_3_6-1YI5q",
	"form": "SearchInput-form-2_3_6-2bdgM",
	"noPad": "SearchInput-noPad-2_3_6-2rMDe",
	"control": "SearchInput-control-2_3_6-DpH7b",
	"disabled": "SearchInput-disabled-2_3_6-19zvn",
	"hasError": "SearchInput-hasError-2_3_6-36O92",
	"input": "SearchInput-input-2_3_6-Wf-QI",
	"icon": "SearchInput-icon-2_3_6-1IGif",
	"search": "SearchInput-search-2_3_6-3KNSB",
	"empty": "SearchInput-empty-2_3_6-2C3lB",
	"bottom": "SearchInput-bottom-2_3_6-3sBrE",
	"blueSteel": "SearchInput-blueSteel-2_3_6-MQYmy",
	"hasValue": "SearchInput-hasValue-2_3_6-fTbxL",
	"typing": "SearchInput-typing-2_3_6-2lr7B",
	"rightSearch": "SearchInput-rightSearch-2_3_6-13ULK",
	"remove": "SearchInput-remove-2_3_6-1E28z"
};

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(607);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _Slider__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return Slider; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(608);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Slider_sass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(609);
/* harmony import */ var _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_Slider_sass__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(195);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(155);













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









/**
 Slider component with a range control.
 The default step value for slider range is 1.

__Accessibility notes: __
  - The slider is keyboard focusable and operable.
  - When the user tab focus to the slider it lands on the thumb, and can control the range value using arrow keys.
  - Screen readers recognize it as a slider range and also get information on the min, max and current value of the slider.
*/

var Slider = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "state", {
      isFocus: false
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "handleKeyUp", function (e) {
      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_16__["default"])(e).is('tab')) {
        _this.setState({
          isFocus: true
        });
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "handleBlur", function (e) {
      _this.setState({
        isFocus: false
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "renderCurrentValueText", function () {
      if (_this.props.currentValueText) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", null, _this.props.currentValueText, ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("span", {
          className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.currentValue
        }, _this.props.value));
      }
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "renderLabels", function () {
      if (_this.props.minLabel && _this.props.maxLabel) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_17__["Flex"], {
          className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.labelContainer
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("span", {
          className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.minlabel
        }, _this.props.minLabel), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("span", {
          className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.maxlabel
        }, _this.props.maxLabel));
      }

      return null;
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Slider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max,
          _onChange = _this$props.onChange,
          value = _this$props.value,
          step = _this$props.step,
          testName = _this$props.testName,
          className = _this$props.className,
          style = _this$props.style,
          recommendedValueText = _this$props.recommendedValueText,
          theme = _this$props.theme;
      var leftPercent = (value - min) / (max - min) * 100;
      var thumbOffset = -1 * ((value - min) / (max - min) * 20);
      var invalidRange = min >= max;
      var production = "none" === 'production';

      if (production) {
        if (invalidRange) {
          console.warn("Invalid  min '".concat(min, "' & max '").concat(max, "' values supplied to <Slider>."));
        }

        if (value < min) {
          leftPercent = min;
        } else if (value > max) {
          leftPercent = max;
        }

        if (step && step < 0) {
          console.warn("Invalid step value '".concat(step, "' supplied to <Slider>.") + " Step value should be a positive number.");
        }
      }

      if (!production) {
        if (invalidRange) {
          throw new Error("Invalid  min '".concat(min, "' & max '").concat(max, "' values supplied to <Slider>."));
        }

        if (value < min || value > max) {
          throw new Error("RangeValue '".concat(value, "' is not within range."));
        }

        if (step && step < 0) {
          throw new Error("Invalid step value '".concat(step, "' supplied to <Slider>.") + " Step value should be a positive number.");
        }
      }

      var thumbClass = classnames__WEBPACK_IMPORTED_MODULE_15___default()(_Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.thumb, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()({}, _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.focus, this.state.isFocus));
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_15___default()(_Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a[theme], _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.container, className),
        "data-test-name": testName,
        style: style
      }, this.renderLabels(), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.sliderContainer
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.slider
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.track
      }, " "), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.progress,
        style: {
          width: "".concat(leftPercent, "%")
        }
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        className: thumbClass,
        style: {
          left: "".concat(leftPercent, "%"),
          marginLeft: "".concat(thumbOffset, "px")
        }
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_17__["Flex"], {
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.labelContainer
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("span", {
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.minlabel
      }, min), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("span", {
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.maxlabel
      }, max)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("input", {
        type: "range",
        min: min,
        max: max,
        value: value,
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.input,
        onChange: function onChange(event) {
          return _onChange(Number(event.target.value), event);
        },
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur,
        step: step,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-orientation": "horizontal",
        "aria-labelledby": "Slider range",
        tabIndex: 0
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", {
        className: _Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a.description
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement("div", null, recommendedValueText), this.renderCurrentValueText()));
    }
  }]);

  return Slider;
}(react__WEBPACK_IMPORTED_MODULE_12___default.a.Component);
Slider.propTypes = {
  /** Starting range of the slider control */
  min: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.number.isRequired,

  /** Ending range of the slider control */
  max: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.number.isRequired,

  /** Change handler updates your current value. */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.func.isRequired,

  /** Current value of slider control */
  value: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.number.isRequired,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Optional Minimum label toward left side. */
  minLabel: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_18___default()(prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string, function (props) {
    return props.maxLabel;
  }),

  /** Optional Maximum label on right side */
  maxLabel: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_18___default()(prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string, function (props) {
    return props.minLabel;
  }),

  /** Step property specifies the size of each movement (an increment or jump between values) of the slider control */
  step: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.number]),

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.object,

  /** Optional text to display recommended value */
  recommendedValueText: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** Optional text to dislplay current value */
  currentValueText: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_19__["provideTheme"])(_Slider_sass__WEBPACK_IMPORTED_MODULE_14___default.a)(Slider));

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(11);
var global = __webpack_require__(8);
var isForced = __webpack_require__(50);
var redefine = __webpack_require__(27);
var has = __webpack_require__(21);
var classof = __webpack_require__(17);
var inheritIfRequired = __webpack_require__(96);
var toPrimitive = __webpack_require__(19);
var fails = __webpack_require__(12);
var create = __webpack_require__(119);
var getOwnPropertyNames = __webpack_require__(42).f;
var getOwnPropertyDescriptor = __webpack_require__(10).f;
var defineProperty = __webpack_require__(25).f;
var trim = __webpack_require__(101).trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(610);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Slider-classic-2_3_6-1PaR4 a{color:#079bb3}.Slider-classic-2_3_6-1PaR4 .Slider-container-2_3_6-1Ho4d,.Slider-classic-2_3_6-1PaR4.Slider-container-2_3_6-1Ho4d{width:100%}.Slider-classic-2_3_6-1PaR4 .Slider-labelContainer-2_3_6-3BNlB{-ms-flex-pack:justify;justify-content:space-between}.Slider-classic-2_3_6-1PaR4 .Slider-maxlabel-2_3_6-3IgGA,.Slider-classic-2_3_6-1PaR4 .Slider-minlabel-2_3_6-GS-0-{word-wrap:break-word;margin:1rem 0;font-family:Lato,Helvetica,Arial,sans-serif;color:#666;font-size:1rem;font-weight:700}.Slider-classic-2_3_6-1PaR4 .Slider-sliderContainer-2_3_6-2oxx7{width:100%;height:1.7333rem;position:relative}.Slider-classic-2_3_6-1PaR4 .Slider-progress-2_3_6-3TB2Y,.Slider-classic-2_3_6-1PaR4 .Slider-track-2_3_6-2vb0k{height:.6667rem;border-radius:.333rem;border:.06667rem solid #ccc;position:absolute}.Slider-classic-2_3_6-1PaR4 .Slider-track-2_3_6-2vb0k{width:100%;background:#fff}.Slider-classic-2_3_6-1PaR4 .Slider-progress-2_3_6-3TB2Y{background:#a2b00c}.Slider-classic-2_3_6-1PaR4 .Slider-thumb-2_3_6-1OCNz{background:#fff;height:1.3333333333rem;width:1.3333333333rem;border-radius:50%;position:absolute;margin-top:-.333rem;border:.06667rem solid #999;cursor:pointer;margin-left:-.6667rem}.Slider-classic-2_3_6-1PaR4 .Slider-focus-2_3_6-Sz329{outline:5px auto #079bb3}.Slider-classic-2_3_6-1PaR4 .Slider-input-2_3_6-2fjn9{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%;height:.6667rem;opacity:0;position:absolute;right:0;left:0;top:-1px;margin:.06667rem}.Slider-classic-2_3_6-1PaR4 .Slider-input-2_3_6-2fjn9::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:1.3333333333rem;height:1.3333333333rem;cursor:pointer}.Slider-classic-2_3_6-1PaR4 .Slider-input-2_3_6-2fjn9::-moz-range-thumb{-moz-appearance:none;appearance:none;width:1.3333333333rem;height:1.3333333333rem;cursor:pointer}.Slider-classic-2_3_6-1PaR4 .Slider-input-2_3_6-2fjn9::-ms-thumb{appearance:none;width:1.3333333333rem;height:1.3333333333rem;cursor:pointer}.Slider-classic-2_3_6-1PaR4 .Slider-description-2_3_6-28xMx{font-family:Lato,Helvetica,Arial,sans-serif;color:#666;font-size:1rem;font-weight:700;margin-top:1.5rem;font-weight:500}.Slider-classic-2_3_6-1PaR4 .Slider-currentValue-2_3_6-2DGZx{font-weight:700}.Slider-blueSteel-2_3_6-3bvn1 a{color:#08088c}.Slider-blueSteel-2_3_6-3bvn1 .Slider-container-2_3_6-1Ho4d,.Slider-blueSteel-2_3_6-3bvn1.Slider-container-2_3_6-1Ho4d{width:100%}.Slider-blueSteel-2_3_6-3bvn1 .Slider-labelContainer-2_3_6-3BNlB{-ms-flex-pack:justify;justify-content:space-between}.Slider-blueSteel-2_3_6-3bvn1 .Slider-maxlabel-2_3_6-3IgGA,.Slider-blueSteel-2_3_6-3bvn1 .Slider-minlabel-2_3_6-GS-0-{word-wrap:break-word;margin:1rem 0;font-family:Public Sans,sans-serif;color:#4d5056;font-size:1rem;font-weight:700}.Slider-blueSteel-2_3_6-3bvn1 .Slider-sliderContainer-2_3_6-2oxx7{width:100%;height:1.7333rem;position:relative}.Slider-blueSteel-2_3_6-3bvn1 .Slider-progress-2_3_6-3TB2Y,.Slider-blueSteel-2_3_6-3bvn1 .Slider-track-2_3_6-2vb0k{height:.6667rem;border-radius:.333rem;border:.06667rem solid #f2f2f3;position:absolute}.Slider-blueSteel-2_3_6-3bvn1 .Slider-track-2_3_6-2vb0k{width:100%;background:#fff}.Slider-blueSteel-2_3_6-3bvn1 .Slider-progress-2_3_6-3TB2Y{background:#009e4f}.Slider-blueSteel-2_3_6-3bvn1 .Slider-thumb-2_3_6-1OCNz{background:#fff;height:1.3333333333rem;width:1.3333333333rem;border-radius:50%;position:absolute;margin-top:-.333rem;border:.06667rem solid #8e9093;cursor:pointer;margin-left:-.6667rem}.Slider-blueSteel-2_3_6-3bvn1 .Slider-focus-2_3_6-Sz329{outline:5px auto #08088c}.Slider-blueSteel-2_3_6-3bvn1 .Slider-input-2_3_6-2fjn9{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%;height:.6667rem;opacity:0;position:absolute;right:0;left:0;top:-1px;margin:.06667rem}.Slider-blueSteel-2_3_6-3bvn1 .Slider-input-2_3_6-2fjn9::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:1.3333333333rem;height:1.3333333333rem;cursor:pointer}.Slider-blueSteel-2_3_6-3bvn1 .Slider-input-2_3_6-2fjn9::-moz-range-thumb{-moz-appearance:none;appearance:none;width:1.3333333333rem;height:1.3333333333rem;cursor:pointer}.Slider-blueSteel-2_3_6-3bvn1 .Slider-input-2_3_6-2fjn9::-ms-thumb{appearance:none;width:1.3333333333rem;height:1.3333333333rem;cursor:pointer}.Slider-blueSteel-2_3_6-3bvn1 .Slider-description-2_3_6-28xMx{font-family:Public Sans,sans-serif;color:#4d5056;font-size:1rem;font-weight:700;margin-top:1.5rem;font-weight:500}.Slider-blueSteel-2_3_6-3bvn1 .Slider-currentValue-2_3_6-2DGZx{font-weight:700}", ""]);

// exports
exports.locals = {
	"classic": "Slider-classic-2_3_6-1PaR4",
	"container": "Slider-container-2_3_6-1Ho4d",
	"labelContainer": "Slider-labelContainer-2_3_6-3BNlB",
	"minlabel": "Slider-minlabel-2_3_6-GS-0-",
	"maxlabel": "Slider-maxlabel-2_3_6-3IgGA",
	"sliderContainer": "Slider-sliderContainer-2_3_6-2oxx7",
	"track": "Slider-track-2_3_6-2vb0k",
	"progress": "Slider-progress-2_3_6-3TB2Y",
	"thumb": "Slider-thumb-2_3_6-1OCNz",
	"focus": "Slider-focus-2_3_6-Sz329",
	"input": "Slider-input-2_3_6-2fjn9",
	"description": "Slider-description-2_3_6-28xMx",
	"currentValue": "Slider-currentValue-2_3_6-2DGZx",
	"blueSteel": "Slider-blueSteel-2_3_6-3bvn1"
};

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(612);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Drawer", function() { return _Drawer__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _StreamIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(615);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StreamIcon", function() { return _StreamIcon__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _StreamPanel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(616);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StreamPanel", function() { return _StreamPanel__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _StreamStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(617);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StreamStatus", function() { return _StreamStatus__WEBPACK_IMPORTED_MODULE_3__["default"]; });










/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Drawer", function() { return Drawer; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(613);
/* harmony import */ var _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_5__);






function Drawer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      error = _ref.error,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;
  var drawerClass = classnames__WEBPACK_IMPORTED_MODULE_3___default()(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_5___default.a.drawer, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_5___default.a.error, error));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: drawerClass,
    style: style,
    "data-test-name": testName
  }, children);
}
Drawer.propTypes = {
  /** Drawer contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Indicates whether the content of the drawer is an error or informative */
  error: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};
Drawer.defaultProps = {
  error: false
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_4__["provideTheme"])(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_5___default.a)(Drawer));

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(614);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".StreamPanel-classic-2_3_6-1ekHa a{color:#079bb3}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamPanel-2_3_6-1KRtQ{border-radius:4px}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-drawer-2_3_6-N_fI2,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawer-2_3_6-N_fI2{border-radius:0}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-drawer-2_3_6-N_fI2:last-child,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawer-2_3_6-N_fI2:last-child{border-radius:0 0 4px 4px}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-streamStatus-2_3_6-1sIac,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamStatus-2_3_6-1sIac{border-radius:4px 0 0 4px}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorDefault-2_3_6-3fMZa,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorDefault-2_3_6-3fMZa{background-color:#e4e4e4}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorError-2_3_6-E8iPF,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorError-2_3_6-E8iPF{background-color:#f3d7e6}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorWarning-2_3_6-3MjPO,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorWarning-2_3_6-3MjPO{background-color:#f8e5d9}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorSuccess-2_3_6-3lYZZ,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorSuccess-2_3_6-3lYZZ{background-color:#ebf0db}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorNotice-2_3_6-TVVkR,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorNotice-2_3_6-TVVkR{background-color:#d8ebed}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-container-2_3_6-1VvAz:not(.StreamPanel-drawerMode-2_3_6-1eVZB),.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-container-2_3_6-1VvAz:not(.StreamPanel-drawerMode-2_3_6-1eVZB){margin-bottom:1rem}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamPanel-2_3_6-1KRtQ{background-color:#f4f4f4;border:1px solid #ddd;display:-ms-flexbox;display:flex}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-content-2_3_6-ojs6a{margin:1.3333333333rem;-ms-flex-positive:1;flex-grow:1;min-height:2.6666666667rem}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-content-2_3_6-ojs6a a{text-decoration:none}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB .StreamPanel-streamStatus-2_3_6-1sIac{-ms-flex:0 0 10rem;flex:0 0 10rem;margin-right:.5rem;background-color:transparent;min-height:1.8rem;padding:0}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB .StreamPanel-content-2_3_6-ojs6a{padding:.5rem;margin:0;min-height:1.8rem}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB .StreamPanel-streamPanel-2_3_6-1KRtQ{border-width:0}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorDefault-2_3_6-3fMZa,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorError-2_3_6-E8iPF,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorNotice-2_3_6-TVVkR,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorSuccess-2_3_6-3lYZZ,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorWarning-2_3_6-3MjPO{background-color:transparent}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-icon-2_3_6-1V7lU{width:1.8rem;height:1.8rem;display:inline-block;margin-right:.6666666667rem;color:#fff}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconCircle-2_3_6-Vt80U{border-radius:.9rem;height:1.8rem;line-height:1.8rem;text-align:center;width:1.8rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-streamStatus-2_3_6-1sIac,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-streamStatus-2_3_6-1sIac{-ms-flex:0 0 15.3333333333rem;flex:0 0 15.3333333333rem;overflow:hidden;padding:1rem;white-space:nowrap;-ms-flex-pack:stretch;justify-content:stretch;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-right:1.3333333333rem}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-statusPrimaryText-2_3_6-3ahH6{font-weight:700}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-statusSecondaryText-2_3_6-2paf6{font-size:.9333333333rem}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-centered-2_3_6-1fTpz{text-align:center}.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-alignLeft-2_3_6-3jVcR{padding-left:1.3333333333rem}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-icon-2_3_6-1V7lU,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-icon-2_3_6-1V7lU{display:inline-block;width:2.4rem;height:2.4rem;margin-right:.6666666667rem;color:#fff}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconCircle-2_3_6-Vt80U,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconCircle-2_3_6-Vt80U{border-radius:1.2rem;height:2.4rem;line-height:2.4rem;text-align:center;width:2.4rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorDefault-2_3_6-3dSI3,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorDefault-2_3_6-3dSI3{background-color:#888}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorError-2_3_6-3Y_z4,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorError-2_3_6-3Y_z4{background-color:#d32781}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorWarning-2_3_6-HV8t2,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorWarning-2_3_6-HV8t2{background-color:#ef6c2a}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorSuccess-2_3_6-3005i,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorSuccess-2_3_6-3005i{background-color:#a2b00c}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorNotice-2_3_6-2-2s7,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorNotice-2_3_6-2-2s7{background-color:#079bb3}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorInvert-2_3_6-d5q_H,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorInvert-2_3_6-d5q_H{background-color:#fff;color:#666}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-drawer-2_3_6-N_fI2,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-drawer-2_3_6-N_fI2{background-color:#f4f4f4;border:1px solid #ddd;border-top:none;margin:0 1.3333333333rem;font-size:.9333333333rem;min-height:2rem;padding:.3333333333rem .6666666667rem}.StreamPanel-classic-2_3_6-1ekHa.StreamPanel-error-2_3_6-3N1rz,.StreamPanel-classic-2_3_6-1ekHa .StreamPanel-error-2_3_6-3N1rz{color:#ba2453}.StreamPanel-blueSteel-2_3_6-1ZGec a{color:#08088c}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorDefault-2_3_6-3fMZa{background-color:#e5e6e6}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorError-2_3_6-E8iPF{background-color:#fdf6f3}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorWarning-2_3_6-3MjPO{background-color:#fffbf2}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorSuccess-2_3_6-3lYZZ{background-color:#d7f6e6}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-streamStatus-2_3_6-1sIac:not(.StreamPanel-drawerMode-2_3_6-1eVZB).StreamPanel-statusColorNotice-2_3_6-TVVkR{background-color:#f2f4f9}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-container-2_3_6-1VvAz:not(.StreamPanel-drawerMode-2_3_6-1eVZB),.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-container-2_3_6-1VvAz:not(.StreamPanel-drawerMode-2_3_6-1eVZB){margin-bottom:1rem}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-streamPanel-2_3_6-1KRtQ{background-color:#f2f2f3;border:1px solid #e5e6e6;display:-ms-flexbox;display:flex}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-content-2_3_6-ojs6a{margin:1.3333333333rem;-ms-flex-positive:1;flex-grow:1;min-height:2.6666666667rem}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-content-2_3_6-ojs6a a{text-decoration:none}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB .StreamPanel-streamStatus-2_3_6-1sIac{-ms-flex:0 0 10rem;flex:0 0 10rem;margin-right:.5rem;background-color:transparent;min-height:1.8rem;padding:0}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB .StreamPanel-content-2_3_6-ojs6a{padding:.5rem;margin:0;min-height:1.8rem}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB .StreamPanel-streamPanel-2_3_6-1KRtQ{border-width:0}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorDefault-2_3_6-3fMZa,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorError-2_3_6-E8iPF,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorNotice-2_3_6-TVVkR,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorSuccess-2_3_6-3lYZZ,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-statusColorWarning-2_3_6-3MjPO{background-color:transparent}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-icon-2_3_6-1V7lU{width:1.8rem;height:1.8rem;display:inline-block;margin-right:.6666666667rem;color:#fff}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawerMode-2_3_6-1eVZB.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconCircle-2_3_6-Vt80U{border-radius:.9rem;height:1.8rem;line-height:1.8rem;text-align:center;width:1.8rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-streamStatus-2_3_6-1sIac,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-streamStatus-2_3_6-1sIac{-ms-flex:0 0 15.3333333333rem;flex:0 0 15.3333333333rem;overflow:hidden;padding:1rem;white-space:nowrap;-ms-flex-pack:stretch;justify-content:stretch;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-right:1.3333333333rem}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-statusPrimaryText-2_3_6-3ahH6{font-weight:700}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-statusSecondaryText-2_3_6-2paf6{font-size:.9333333333rem}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-centered-2_3_6-1fTpz{text-align:center}.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-alignLeft-2_3_6-3jVcR{padding-left:1.3333333333rem}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-icon-2_3_6-1V7lU,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-icon-2_3_6-1V7lU{display:inline-block;width:2.4rem;height:2.4rem;margin-right:.6666666667rem;color:#fff}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconCircle-2_3_6-Vt80U,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconCircle-2_3_6-Vt80U{border-radius:1.2rem;height:2.4rem;line-height:2.4rem;text-align:center;width:2.4rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorDefault-2_3_6-3dSI3,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorDefault-2_3_6-3dSI3{background-color:#4d5056}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorError-2_3_6-3Y_z4,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorError-2_3_6-3Y_z4{background-color:#d33d00}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorWarning-2_3_6-HV8t2,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorWarning-2_3_6-HV8t2{background-color:#ffba00}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorSuccess-2_3_6-3005i,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorSuccess-2_3_6-3005i{background-color:#009e4f}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorNotice-2_3_6-2-2s7,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorNotice-2_3_6-2-2s7{background-color:#08088c}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorInvert-2_3_6-d5q_H,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-icon-2_3_6-1V7lU .StreamPanel-iconColorInvert-2_3_6-d5q_H{background-color:#fff;color:#4d5056}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-drawer-2_3_6-N_fI2,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-drawer-2_3_6-N_fI2{background-color:#f2f2f3;border:1px solid #e5e6e6;border-top:none;margin:0 1.3333333333rem;font-size:.9333333333rem;min-height:2rem;padding:.3333333333rem .6666666667rem}.StreamPanel-blueSteel-2_3_6-1ZGec.StreamPanel-error-2_3_6-3N1rz,.StreamPanel-blueSteel-2_3_6-1ZGec .StreamPanel-error-2_3_6-3N1rz{color:#d33d00}", ""]);

// exports
exports.locals = {
	"classic": "StreamPanel-classic-2_3_6-1ekHa",
	"streamPanel": "StreamPanel-streamPanel-2_3_6-1KRtQ",
	"drawer": "StreamPanel-drawer-2_3_6-N_fI2",
	"streamStatus": "StreamPanel-streamStatus-2_3_6-1sIac",
	"drawerMode": "StreamPanel-drawerMode-2_3_6-1eVZB",
	"statusColorDefault": "StreamPanel-statusColorDefault-2_3_6-3fMZa",
	"statusColorError": "StreamPanel-statusColorError-2_3_6-E8iPF",
	"statusColorWarning": "StreamPanel-statusColorWarning-2_3_6-3MjPO",
	"statusColorSuccess": "StreamPanel-statusColorSuccess-2_3_6-3lYZZ",
	"statusColorNotice": "StreamPanel-statusColorNotice-2_3_6-TVVkR",
	"container": "StreamPanel-container-2_3_6-1VvAz",
	"content": "StreamPanel-content-2_3_6-ojs6a",
	"icon": "StreamPanel-icon-2_3_6-1V7lU",
	"iconCircle": "StreamPanel-iconCircle-2_3_6-Vt80U",
	"statusPrimaryText": "StreamPanel-statusPrimaryText-2_3_6-3ahH6",
	"statusSecondaryText": "StreamPanel-statusSecondaryText-2_3_6-2paf6",
	"centered": "StreamPanel-centered-2_3_6-1fTpz",
	"alignLeft": "StreamPanel-alignLeft-2_3_6-3jVcR",
	"iconColorDefault": "StreamPanel-iconColorDefault-2_3_6-3dSI3",
	"iconColorError": "StreamPanel-iconColorError-2_3_6-3Y_z4",
	"iconColorWarning": "StreamPanel-iconColorWarning-2_3_6-HV8t2",
	"iconColorSuccess": "StreamPanel-iconColorSuccess-2_3_6-3005i",
	"iconColorNotice": "StreamPanel-iconColorNotice-2_3_6-2-2s7",
	"iconColorInvert": "StreamPanel-iconColorInvert-2_3_6-d5q_H",
	"error": "StreamPanel-error-2_3_6-3N1rz",
	"blueSteel": "StreamPanel-blueSteel-2_3_6-1ZGec"
};

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StreamIcon", function() { return StreamIcon; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(154);
/* harmony import */ var react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(216);
/* harmony import */ var _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(613);
/* harmony import */ var _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(155);










function StreamIcon(_ref) {
  var className = _ref.className,
      Component = _ref.Component,
      name = _ref.name,
      mode = _ref.mode,
      iconProps = _ref.iconProps,
      status = _ref.status,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;
  var statusClass = StreamIcon.statuses[status];
  var modeClass = StreamIcon.modes[mode];
  var circleStyle;

  if (status && !statusClass) {
    circleStyle = {
      backgroundColor: status
    };
  }

  var icon = name ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_7__["Icon"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    color: "currentColor",
    name: name
  }, iconProps)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, iconProps);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a[theme], _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.icon, modeClass, className),
    style: style,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    className: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconWrapper
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconCircle, statusClass),
    style: circleStyle
  }, icon)));
}
StreamIcon.statuses = {
  // Fallback statuses should only apply in test environment
  default: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconColorDefault || 'default',
  error: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconColorError || 'error',
  warning: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconColorWarning || 'warning',
  success: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconColorSuccess || 'success',
  notice: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconColorNotice || 'notice',
  invert: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.iconColorInvert || 'invert'
};
StreamIcon.modes = {
  drawer: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.drawerMode || 'drawerMode'
};
StreamIcon.propTypes = {
  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /**
   * The icon to use as a React component. Use this if the icon does not exist
   * within studio-icons.
   */
  Component: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_6___default()(prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func]), function (props) {
    return !props.name;
  }),

  /**
   * Props that are passed through to the underlying [`Icon`](#icon) component
   */
  iconProps: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /**
   * Optional property to set custom presentation. Use 'drawer' for a StreamIcon component
   * component inside a Drawer.
   */
  mode: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Name of the icon to use from studio-icons (case insensitive). */
  name: react_proptype_conditional_require__WEBPACK_IMPORTED_MODULE_6___default()(prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOf(Object.keys(_Icon__WEBPACK_IMPORTED_MODULE_7__["ICONS"])), function (props) {
    return !props.Component;
  }),

  /**
   * Determines the background color of the icon circle. Preset statuses are:
   * `default`, `error`, `warning`, `success`, `notice` and `invert`. Any valid CSS color
   * will also work.
   */
  status: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};
StreamIcon.defaultProps = {
  iconProps: {},
  status: 'default'
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_9__["provideTheme"])(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a)(StreamIcon));

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StreamPanel", function() { return StreamPanel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Hideable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(231);
/* harmony import */ var _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(613);
/* harmony import */ var _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(155);






/**
 * This component is useful for displaying a series of content that appears in
 * chronological order.
 */

function StreamPanel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      drawer = _ref.drawer,
      mode = _ref.mode,
      status = _ref.status,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;
  var modeClass = StreamPanel.modes[mode];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4___default.a[theme], _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4___default.a.container, modeClass, className),
    style: style,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4___default.a.streamPanel
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_3__["Hideable"], {
    show: Boolean(status)
  }, status), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4___default.a.content
  }, children)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_3__["Hideable"], {
    show: Boolean(drawer)
  }, drawer));
}
StreamPanel.modes = {
  drawer: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4___default.a.drawerMode || 'drawerMode'
};
StreamPanel.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /**
   * Optional container for a message that can show about the content within the
   * panel
   */
  drawer: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /**
   * Optional property to set custom presentation. Use 'drawer' for a StreamPanel
   * component inside a Drawer.
   */
  mode: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /**
   * Status section left-aligned within the panel. This should be composable
   * as a StreamStatus.
   */
  status: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_5__["provideTheme"])(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_4___default.a)(StreamPanel));

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StreamStatus", function() { return StreamStatus; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(195);
/* harmony import */ var _Hideable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(231);
/* harmony import */ var _Hint__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(256);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);
/* harmony import */ var _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(613);
/* harmony import */ var _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8__);









function StreamStatus(_ref) {
  var _cx;

  var className = _ref.className,
      details = _ref.details,
      icon = _ref.icon,
      message = _ref.message,
      mode = _ref.mode,
      status = _ref.status,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme;
  var statusClass = StreamStatus.statuses[status];
  var modeClass = StreamStatus.modes[mode];
  var containerStyle = style || {};

  if (status && !statusClass) {
    containerStyle.backgroundColor = status;
  }

  var containerStatusClass = classnames__WEBPACK_IMPORTED_MODULE_3___default()(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a[theme], _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.streamStatus, modeClass, statusClass, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.centered, !icon), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.alignLeft, Boolean(icon)), _cx));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: containerStatusClass,
    style: containerStyle,
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Hideable__WEBPACK_IMPORTED_MODULE_5__["Hideable"], {
    show: Boolean(icon)
  }, icon), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Flex__WEBPACK_IMPORTED_MODULE_4__["Flex"], {
    grow: 1,
    justifyContent: icon ? 'flex-start' : 'center',
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.statusPrimaryText
  }, message), details != null ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Hint__WEBPACK_IMPORTED_MODULE_6__["Hint"], {
    noPad: true,
    className: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.statusSecondaryText,
    theme: theme
  }, details) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("noscript", null))));
}
StreamStatus.statuses = {
  // Fallback statuses should only apply in test environment
  default: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.statusColorDefault || 'default',
  error: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.statusColorError || 'error',
  warning: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.statusColorWarning || 'warning',
  success: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.statusColorSuccess || 'success',
  notice: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.statusColorNotice || 'notice'
};
StreamStatus.modes = {
  drawer: _StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a.drawerMode || 'drawerMode'
};
StreamStatus.propTypes = {
  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /**
   * Supplemental text to provide (concise) details about the status. This
   * should all fit on one line.
   */
  details: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,

  /** Icon to show to better-convey the status */
  icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,

  /**
   * Primary text to indicate the status. This should all fit on one line
   * within the status.
   */
  message: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,

  /**
   * Optional property to set custom presentation. Use 'drawer' for a StreamStatus
   * component inside a Drawer.
   */
  mode: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /**
   * Determines the background color of the status area. Preset statuses are:
   * `default`, `error`, `warning`, `success`, `notice`. Any valid CSS color
   * should also work.
   */
  status: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
};
StreamStatus.defaultProps = {
  status: 'default'
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_StreamPanel_sass__WEBPACK_IMPORTED_MODULE_8___default.a)(StreamStatus));

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(619);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return _Table__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _TableHead__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(622);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableHead", function() { return _TableHead__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _TableBody__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(623);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableBody", function() { return _TableBody__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _TableRow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(624);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableRow", function() { return _TableRow__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _TableCell__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(625);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TableCell", function() { return _TableCell__WEBPACK_IMPORTED_MODULE_4__["default"]; });












/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return Table; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(620);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Table_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(155);







/**
 A basic table component that wraps the html `<table>` tag.

 This component is a simple wrapper over html table and can be used by other components to generate more complex tables.

 See [studio-tables](https://bithub.brightcove.com/studio-ui-kit/studio-tables) project for examples.
*/

function Table(_ref) {
  var className = _ref.className,
      testName = _ref.testName,
      style = _ref.style,
      theme = _ref.theme,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_ref, ["className", "testName", "style", "theme"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("table", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Table_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], _Table_sass__WEBPACK_IMPORTED_MODULE_5___default.a.container, className),
    "data-test-name": testName
  }, rest));
}
Table.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_6__["provideTheme"])(_Table_sass__WEBPACK_IMPORTED_MODULE_5___default.a)(Table));

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(621);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Table-classic-2_3_6-1Aggr a{color:#079bb3}.Table-classic-2_3_6-1Aggr.Table-container-2_3_6-2G2k9,.Table-classic-2_3_6-1Aggr .Table-container-2_3_6-2G2k9{border:1px solid #ddd;border-collapse:collapse}.Table-classic-2_3_6-1Aggr .Table-headerCell-2_3_6-2xwvM,.Table-classic-2_3_6-1Aggr .Table-tableHead-2_3_6-2L_4L .Table-tableCell-2_3_6-xxfU_{color:#666}.Table-classic-2_3_6-1Aggr .Table-tableCell-2_3_6-xxfU_{height:40px;padding:.6666666667rem}.Table-classic-2_3_6-1Aggr .Table-tableRow-2_3_6-86K3H{border-bottom:1px solid #ddd}.Table-classic-2_3_6-1Aggr .Table-tableCell-2_3_6-xxfU_{text-align:left;font-size:1rem;letter-spacing:normal;color:#444}.Table-classic-2_3_6-1Aggr .Table-headerCell-2_3_6-2xwvM,.Table-classic-2_3_6-1Aggr .Table-tableHead-2_3_6-2L_4L{background-color:#f4f4f4}.Table-classic-2_3_6-1Aggr .Table-tableBody-2_3_6-1qBya{background-color:#fff}.Table-blueSteel-2_3_6-1hvFQ a{color:#08088c}.Table-blueSteel-2_3_6-1hvFQ.Table-container-2_3_6-2G2k9,.Table-blueSteel-2_3_6-1hvFQ .Table-container-2_3_6-2G2k9{border:none;border-collapse:collapse}.Table-blueSteel-2_3_6-1hvFQ .Table-headerCell-2_3_6-2xwvM,.Table-blueSteel-2_3_6-1hvFQ .Table-tableHead-2_3_6-2L_4L .Table-tableCell-2_3_6-xxfU_{color:#01050e;font-weight:400;font-size:1rem;height:32px}.Table-blueSteel-2_3_6-1hvFQ .Table-tableCell-2_3_6-xxfU_{height:48px;padding:8px 24px}.Table-blueSteel-2_3_6-1hvFQ .Table-tableBody-2_3_6-1qBya .Table-tableCell-2_3_6-xxfU_{color:#4d5056;font-size:1rem}.Table-blueSteel-2_3_6-1hvFQ .Table-tableRow-2_3_6-86K3H.Table-compact-2_3_6-rzPkC .Table-tableCell-2_3_6-xxfU_{height:32px}.Table-blueSteel-2_3_6-1hvFQ .Table-tableRow-2_3_6-86K3H.Table-tall-2_3_6--w6IK .Table-tableCell-2_3_6-xxfU_{height:64px}.Table-blueSteel-2_3_6-1hvFQ .Table-tableRow-2_3_6-86K3H{border-bottom:1px solid #e5e6e6}.Table-blueSteel-2_3_6-1hvFQ .Table-tableCell-2_3_6-xxfU_{text-align:left;font-size:1rem;letter-spacing:auto;line-height:24px;color:#01050e}.Table-blueSteel-2_3_6-1hvFQ .Table-headerCell-2_3_6-2xwvM,.Table-blueSteel-2_3_6-1hvFQ .Table-tableHead-2_3_6-2L_4L{background-color:#e5e6e6}.Table-blueSteel-2_3_6-1hvFQ .Table-tableBody-2_3_6-1qBya{background-color:#fff}", ""]);

// exports
exports.locals = {
	"classic": "Table-classic-2_3_6-1Aggr",
	"container": "Table-container-2_3_6-2G2k9",
	"headerCell": "Table-headerCell-2_3_6-2xwvM",
	"tableHead": "Table-tableHead-2_3_6-2L_4L",
	"tableCell": "Table-tableCell-2_3_6-xxfU_",
	"tableRow": "Table-tableRow-2_3_6-86K3H",
	"tableBody": "Table-tableBody-2_3_6-1qBya",
	"blueSteel": "Table-blueSteel-2_3_6-1hvFQ",
	"compact": "Table-compact-2_3_6-rzPkC",
	"tall": "Table-tall-2_3_6--w6IK"
};

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TableHead; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(620);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Table_sass__WEBPACK_IMPORTED_MODULE_5__);






/**
 A table head component that wraps the html `<thead>` tag
 */

function TableHead(props) {
  var className = props.className,
      testName = props.testName,
      style = props.style,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, ["className", "testName", "style"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("thead", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Table_sass__WEBPACK_IMPORTED_MODULE_5___default.a.tableHead, className),
    "data-test-name": testName
  }, rest));
}
TableHead.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TableBody; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(620);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Table_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _TableRow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(624);







/**
 A table body component that wraps the html `<tbody>` tag
 */

function TableBody(props) {
  var className = props.className,
      testName = props.testName,
      style = props.style,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, ["className", "testName", "style"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("tbody", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_Table_sass__WEBPACK_IMPORTED_MODULE_5___default.a.tableBody, className),
    "data-test-name": testName
  }, rest));
}
TableBody.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TableRow; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(620);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Table_sass__WEBPACK_IMPORTED_MODULE_6__);







/**
 A table row component that wraps the html `<tr>` tag
 */

function TableRow(props) {
  var _cx;

  var className = props.className,
      testName = props.testName,
      style = props.style,
      tall = props.tall,
      compact = props.compact,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(props, ["className", "testName", "style", "tall", "compact"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("tr", _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Table_sass__WEBPACK_IMPORTED_MODULE_6___default.a.tableRow, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Table_sass__WEBPACK_IMPORTED_MODULE_6___default.a.compact, compact), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Table_sass__WEBPACK_IMPORTED_MODULE_6___default.a.tall, tall), _cx), className),
    "data-test-name": testName
  }, rest));
}
TableRow.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Specify using a tall rowHeight */
  tall: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Specify using a compact rowHeight */
  compact: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool
};

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TableCell; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(620);
/* harmony import */ var _Table_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Table_sass__WEBPACK_IMPORTED_MODULE_6__);







/**
 A table cell component that wraps the html `<td>` and `<th>` tags.
 */

function TableCell(props) {
  var children = props.children,
      className = props.className,
      testName = props.testName,
      style = props.style,
      header = props.header,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(props, ["children", "className", "testName", "style", "header"]);

  var Component = header ? 'th' : 'td';
  var classes = classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Table_sass__WEBPACK_IMPORTED_MODULE_6___default.a.tableCell, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, _Table_sass__WEBPACK_IMPORTED_MODULE_6___default.a.headerCell, header));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    style: style,
    className: classes,
    "data-test-name": testName
  }, rest), children);
}
TableCell.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Renders a table header (<th>) if true */
  header: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool
};
TableCell.defaultProps = {
  header: false
};

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Tabs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(627);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return _Tabs__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _Tab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(630);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _Tab__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _SmallTab__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(631);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SmallTab", function() { return _SmallTab__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _TabPanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(632);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _TabPanel__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _TabList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(633);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabList", function() { return _TabList__WEBPACK_IMPORTED_MODULE_4__["default"]; });












/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return Tabs; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(628);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_Tabs_sass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(155);











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






/**
Manages tab selection state for `<TabList>` and `<TabPanel>`.

Note that `TabList` is not fully supported in React 0.14. If you are using
React 0.14 tabs that are wrapped to the next line on narrow screens will not
be styled properly. If this is likely to be a problem for your application
you might consider using the `nowrap` prop to mitigate this.
*/

var Tabs = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), "state", {
      selectedId: 0
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Tabs, [{
    key: "isControlledComponent",
    get: function get() {
      return this.props.selectedId != null;
    }
  }, {
    key: "selectedId",
    get: function get() {
      return this.isControlledComponent ? this.props.selectedId : this.state.selectedId;
    }
  }, {
    key: "defaultSelectedId",
    get: function get() {
      if (this.props.defaultSelectedId != null) {
        return this.props.defaultSelectedId;
      } else {
        var _Children$toArray = react__WEBPACK_IMPORTED_MODULE_10__["Children"].toArray(this.props.children),
            _Children$toArray2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_Children$toArray, 2),
            tabList = _Children$toArray2[0],
            tabPanel = _Children$toArray2[1];

        if (tabList) {
          var tabs = react__WEBPACK_IMPORTED_MODULE_10__["Children"].toArray(tabList.props.children);

          if (tabs.length > 0 && tabs[0].props.tabId != null) {
            return tabs[0].props.tabId;
          } else {
            return 0;
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        selectedId: this.defaultSelectedId
      });
    }
  }, {
    key: "updateSelection",
    value: function updateSelection(selectedId) {
      if (this.isControlledComponent && this.props.onSelect) {
        this.props.onSelect(selectedId);
      } else {
        this.setState({
          selectedId: selectedId
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          testName = _this$props.testName,
          style = _this$props.style,
          children = _this$props.children,
          theme = _this$props.theme,
          vertical = _this$props.vertical,
          belowHeader = _this$props.belowHeader;

      var _Children$toArray3 = react__WEBPACK_IMPORTED_MODULE_10__["Children"].toArray(children),
          _Children$toArray4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_Children$toArray3, 2),
          tabList = _Children$toArray4[0],
          tabPanel = _Children$toArray4[1];

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("div", {
        style: style,
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()(_Tabs_sass__WEBPACK_IMPORTED_MODULE_13___default.a[theme], className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_13___default.a.vertical, vertical), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_13___default.a.belowHeader, belowHeader), _cx)),
        "data-test-name": testName
      }, tabList ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.cloneElement(tabList, {
        onSelect: function onSelect(id) {
          return _this2.updateSelection(id);
        },
        selectedId: this.selectedId,
        vertical: vertical
      }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("noscript", null), tabPanel ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.cloneElement(tabPanel, {
        tabId: this.selectedId
      }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement("noscript", null));
    }
  }]);

  return Tabs;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);
Tabs.propTypes = {
  /** `<TabList>` and `<TabPanel>` components to render */
  children: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Vertical Tabs */
  vertical: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /**
   * Only applies to vertical tabs. If the tabs are directly below a header, a
   * padding is applied above the tab list. If the tabs are further down the page,
   * then the padding is not applied.
   */
  belowHeader: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.bool,

  /**
  Which tabId should be selected by default.
  */
  defaultSelectedId: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.number]),

  /**
  Which tabId should be selected.
  Using this prop will put this component in controlled mode, use
  `defaultSelectedId` if you want Tabs to manage selection state for you.
  */
  selectedId: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.number]),

  /**
  Selection callback for using Tabs in controlled mode.
  (Called on keyboard and mouse navigation).
  @param {any} tabId - The index of the selected tab.
  */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.func,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.object,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_11___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_14__["provideTheme"])(_Tabs_sass__WEBPACK_IMPORTED_MODULE_13___default.a)(Tabs));

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(629);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Tabs-classic-2_3_6-DjZv5 a{color:#079bb3}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy{position:relative;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;margin-bottom:2rem;min-height:42px}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-nowrap-2_3_6-bnhIp .Tabs-spacer-2_3_6-iJuzU{min-width:5px}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy:not(.Tabs-nowrap-2_3_6-bnhIp){-ms-flex-wrap:wrap;flex-wrap:wrap}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy:not(.Tabs-nowrap-2_3_6-bnhIp) .Tabs-tab-2_3_6-b9FZ3{min-width:8rem;-ms-flex:1 1 auto;flex:1 1 auto}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf{margin-top:5px}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf .Tabs-tab-2_3_6-b9FZ3:first-child{margin-left:0}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf .Tabs-tab-2_3_6-b9FZ3{margin-top:-5px}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf .Tabs-tab-2_3_6-b9FZ3.Tabs-selected-2_3_6-AbY_d,.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d){margin-top:-9px}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTabList-2_3_6-3V2yo{margin-bottom:1rem;display:-ms-flexbox;display:flex}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTabList-2_3_6-3V2yo:not(.Tabs-nowrap-2_3_6-bnhIp){-ms-flex-wrap:wrap;flex-wrap:wrap}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTabList-2_3_6-3V2yo.Tabs-isWrapped-2_3_6-2Svhf .Tabs-smallTab-2_3_6-2bRvG{-ms-flex:1 0 auto;flex:1 0 auto}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-spacer-2_3_6-iJuzU{-ms-flex:9999 0 auto;flex:9999 0 auto}.Tabs-classic-2_3_6-DjZv5:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabPanel-2_3_6-17ve5{margin-bottom:1rem}.Tabs-classic-2_3_6-DjZv5 .Tabs-selectedOverlay-2_3_6-2pwGf{display:none;top:0;left:0;right:0;bottom:0}.Tabs-classic-2_3_6-DjZv5 .Tabs-tabList-2_3_6-295Xy{box-shadow:inset 0 -1px 0 #ccc;padding-left:calc(1.3333333333rem - 5px);padding-right:1.3333333333rem}.Tabs-classic-2_3_6-DjZv5 .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf{background:repeating-linear-gradient(0deg,#ccc,#d0d0d0 1px,#fff 0,#fff 33px)}.Tabs-classic-2_3_6-DjZv5 .Tabs-smallTabList-2_3_6-3V2yo .Tabs-spacer-2_3_6-iJuzU{border-bottom:3px solid #eee}.Tabs-classic-2_3_6-DjZv5 .Tabs-tab-2_3_6-b9FZ3{padding:11.5px .7rem;height:38px;border:1px solid #dde1e1;border-bottom-color:#ccc;border-top-left-radius:5px;border-top-right-radius:5px;background-color:#eef6f6;margin-left:5px;color:#079bb3;box-shadow:inset 0 -2px 2px -2px rgba(0,0,0,.15)}.Tabs-classic-2_3_6-DjZv5 .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d){border-color:#ccc;color:#057182;height:42px;margin-top:-4px}.Tabs-classic-2_3_6-DjZv5 .Tabs-tab-2_3_6-b9FZ3.Tabs-selected-2_3_6-AbY_d{background-color:#fff;border-color:#ccc;border-bottom:1px solid #fff;box-shadow:-3px 0 3px -3px rgba(0,0,0,.15),3px 0 3px -3px rgba(0,0,0,.15);color:#444;height:42px;margin-top:0}.Tabs-classic-2_3_6-DjZv5 .Tabs-smallTab-2_3_6-2bRvG{padding:.7rem;border-bottom:3px solid #ddd;margin-right:4px;font-size:.9333333333rem;color:#444}.Tabs-classic-2_3_6-DjZv5 .Tabs-smallTab-2_3_6-2bRvG>svg{margin-right:.3rem}.Tabs-classic-2_3_6-DjZv5 .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d){border-color:#079bb3}.Tabs-classic-2_3_6-DjZv5 .Tabs-smallTab-2_3_6-2bRvG.Tabs-selected-2_3_6-AbY_d{border-color:#079bb3;color:#079bb3}.Tabs-blueSteel-2_3_6-3THnE a{color:#08088c}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tab-2_3_6-b9FZ3,.Tabs-classic-2_3_6-DjZv5 .Tabs-smallTab-2_3_6-2bRvG,.Tabs-classic-2_3_6-DjZv5 .Tabs-tab-2_3_6-b9FZ3{position:relative;line-height:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;display:inline-block;white-space:nowrap;text-decoration:none;text-align:center;transition:all .15s ease,flex .08s ease .25s;transition:all .15s ease,flex .08s ease .25s,-ms-flex .08s ease .25s}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3,.Tabs-classic-2_3_6-DjZv5 .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG,.Tabs-classic-2_3_6-DjZv5 .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3,.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG,.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3,.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTab-2_3_6-2bRvG,.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tab-2_3_6-b9FZ3,.Tabs-nowrap-2_3_6-bnhIp .Tabs-classic-2_3_6-DjZv5 .Tabs-smallTab-2_3_6-2bRvG,.Tabs-nowrap-2_3_6-bnhIp .Tabs-classic-2_3_6-DjZv5 .Tabs-tab-2_3_6-b9FZ3{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-classic-2_3_6-DjZv5 .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-classic-2_3_6-DjZv5 .Tabs-nowrap-2_3_6-bnhIp .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-classic-2_3_6-DjZv5 .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-classic-2_3_6-DjZv5 .Tabs-nowrap-2_3_6-bnhIp .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTab-2_3_6-2bRvG:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tab-2_3_6-b9FZ3:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-classic-2_3_6-DjZv5 .Tabs-smallTab-2_3_6-2bRvG:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-classic-2_3_6-DjZv5 .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-classic-2_3_6-DjZv5 .Tabs-tab-2_3_6-b9FZ3:focus:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-nowrap-2_3_6-bnhIp .Tabs-classic-2_3_6-DjZv5 .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d){-ms-flex:1 0 auto;flex:1 0 auto}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3,.Tabs-classic-2_3_6-DjZv5 .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-classic-2_3_6-DjZv5 .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3{cursor:default}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-nowrap-2_3_6-bnhIp .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-nowrap-2_3_6-bnhIp .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-nowrap-2_3_6-bnhIp .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-nowrap-2_3_6-bnhIp .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3,.Tabs-classic-2_3_6-DjZv5 .Tabs-nowrap-2_3_6-bnhIp .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-classic-2_3_6-DjZv5 .Tabs-nowrap-2_3_6-bnhIp .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3,.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3,.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-nowrap-2_3_6-bnhIp .Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3,.Tabs-nowrap-2_3_6-bnhIp .Tabs-classic-2_3_6-DjZv5 .Tabs-selected-2_3_6-AbY_d.Tabs-smallTab-2_3_6-2bRvG,.Tabs-nowrap-2_3_6-bnhIp .Tabs-classic-2_3_6-DjZv5 .Tabs-selected-2_3_6-AbY_d.Tabs-tab-2_3_6-b9FZ3{-ms-flex:1 0 auto;flex:1 0 auto}body:not(.hide-focus-outlines) .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG:focus,body:not(.hide-focus-outlines) .Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3:focus{padding:16.5px 24px}body:not(.hide-focus-outlines) .Tabs-blueSteel-2_3_6-3THnE .Tabs-smallTab-2_3_6-2bRvG:focus,body:not(.hide-focus-outlines) .Tabs-blueSteel-2_3_6-3THnE .Tabs-tab-2_3_6-b9FZ3:focus{outline:2px solid #08088c;border:none;color:#08088c;font-weight:400}body:not(.hide-focus-outlines) .Tabs-blueSteel-2_3_6-3THnE .Tabs-smallTab-2_3_6-2bRvG:focus .Tabs-selectedOverlay-2_3_6-2pwGf,body:not(.hide-focus-outlines) .Tabs-blueSteel-2_3_6-3THnE .Tabs-tab-2_3_6-b9FZ3:focus .Tabs-selectedOverlay-2_3_6-2pwGf{display:none}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy{position:relative;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;margin-bottom:2rem;min-height:42px}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-nowrap-2_3_6-bnhIp .Tabs-spacer-2_3_6-iJuzU{min-width:5px}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy:not(.Tabs-nowrap-2_3_6-bnhIp){-ms-flex-wrap:wrap;flex-wrap:wrap}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy:not(.Tabs-nowrap-2_3_6-bnhIp) .Tabs-tab-2_3_6-b9FZ3{min-width:8rem;-ms-flex:1 1 auto;flex:1 1 auto}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf{margin-top:5px}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf .Tabs-tab-2_3_6-b9FZ3:first-child{margin-left:0}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf .Tabs-tab-2_3_6-b9FZ3{margin-top:-5px}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf .Tabs-tab-2_3_6-b9FZ3.Tabs-selected-2_3_6-AbY_d,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy.Tabs-isWrapped-2_3_6-2Svhf .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d){margin-top:-9px}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTabList-2_3_6-3V2yo{margin-bottom:1rem;display:-ms-flexbox;display:flex}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTabList-2_3_6-3V2yo:not(.Tabs-nowrap-2_3_6-bnhIp){-ms-flex-wrap:wrap;flex-wrap:wrap}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTabList-2_3_6-3V2yo.Tabs-isWrapped-2_3_6-2Svhf .Tabs-smallTab-2_3_6-2bRvG{-ms-flex:1 0 auto;flex:1 0 auto}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-spacer-2_3_6-iJuzU{-ms-flex:9999 0 auto;flex:9999 0 auto}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabPanel-2_3_6-17ve5{margin-bottom:1rem}.Tabs-blueSteel-2_3_6-3THnE .Tabs-selectedOverlay-2_3_6-2pwGf{display:none;top:0;left:0;right:0;bottom:0}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ{display:-ms-flexbox;display:flex}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tabPanel-2_3_6-17ve5{-ms-flex:1;flex:1;z-index:2;background-color:#f9f9f9}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTabList-2_3_6-3V2yo,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tabList-2_3_6-295Xy{position:relative;-ms-flex-direction:column;flex-direction:column;min-height:48px;width:14.8rem;min-width:14.8rem;background-color:#f9f9f9;box-shadow:inset -8px 0 8px -8px rgba(17,17,26,.1);overflow:hidden}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTabList-2_3_6-3V2yo.Tabs-nav-2_3_6-37w3X:before,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tabList-2_3_6-295Xy.Tabs-nav-2_3_6-37w3X:before{content:\"\";position:absolute;top:0;left:0;height:24px;width:100%;background:linear-gradient(-180deg,#fff,hsla(0,0%,100%,0))}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3{position:relative;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;transition:none;height:48px;margin-left:2px;padding:16.5px 24px 16.5px 20px;text-align:left;border-left:4px solid transparent;box-shadow:0 0 0 0 rgba(1,5,14,0);transition:box-shadow .3s ease}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d){color:#08088c}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG.Tabs-selected-2_3_6-AbY_d,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3.Tabs-selected-2_3_6-AbY_d{background-color:#f9f9f9;z-index:1;box-shadow:0 1px 5px 0 rgba(1,5,14,.13);border-color:#08088c;color:transparent}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG.Tabs-selected-2_3_6-AbY_d .Tabs-selectedOverlay-2_3_6-2pwGf,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3.Tabs-selected-2_3_6-AbY_d .Tabs-selectedOverlay-2_3_6-2pwGf{left:1.3333333333rem;top:2px;color:#01050e;display:-ms-flexbox;display:flex;-ms-flex-pack:left;justify-content:left;-ms-flex-align:center;align-items:center;position:absolute;font-weight:700}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG.Tabs-selected-2_3_6-AbY_d .Tabs-selectedOverlayContent-2_3_6-XX3K8,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3.Tabs-selected-2_3_6-AbY_d .Tabs-selectedOverlayContent-2_3_6-XX3K8{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG.Tabs-hasNotification-2_3_6-poJwO .Tabs-selectedOverlay-2_3_6-2pwGf,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3.Tabs-hasNotification-2_3_6-poJwO .Tabs-selectedOverlay-2_3_6-2pwGf{right:2.6666666667rem}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-smallTab-2_3_6-2bRvG .Tabs-content-2_3_6-rFYzT,.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ .Tabs-tab-2_3_6-b9FZ3 .Tabs-content-2_3_6-rFYzT{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.Tabs-blueSteel-2_3_6-3THnE.Tabs-vertical-2_3_6-20oUZ.Tabs-belowHeader-2_3_6-3wY3B .Tabs-tabList-2_3_6-295Xy:before{display:block;content:\" \";height:24px;background:linear-gradient(-180deg,#fff,hsla(0,0%,100%,0))}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTab-2_3_6-2bRvG,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tab-2_3_6-b9FZ3{position:relative;transition:none;padding:11.5px 24px;height:38px;border-bottom:4px solid #e5e6e6;margin-left:4px;color:#01050e}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTab-2_3_6-2bRvG:hover:not(.Tabs-selected-2_3_6-AbY_d),.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tab-2_3_6-b9FZ3:hover:not(.Tabs-selected-2_3_6-AbY_d){border-color:#4d5056;color:#08088c}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTab-2_3_6-2bRvG.Tabs-selected-2_3_6-AbY_d,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tab-2_3_6-b9FZ3.Tabs-selected-2_3_6-AbY_d{border-color:#08088c;color:transparent}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTab-2_3_6-2bRvG.Tabs-selected-2_3_6-AbY_d .Tabs-selectedOverlay-2_3_6-2pwGf,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tab-2_3_6-b9FZ3.Tabs-selected-2_3_6-AbY_d .Tabs-selectedOverlay-2_3_6-2pwGf{padding-top:4px;color:#01050e;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;position:absolute;font-weight:700}.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-smallTabList-2_3_6-3V2yo .Tabs-tab-2_3_6-b9FZ3:first-child,.Tabs-blueSteel-2_3_6-3THnE:not(.Tabs-vertical-2_3_6-20oUZ) .Tabs-tabList-2_3_6-295Xy .Tabs-tab-2_3_6-b9FZ3:first-child{margin-left:0}", ""]);

// exports
exports.locals = {
	"classic": "Tabs-classic-2_3_6-DjZv5",
	"blueSteel": "Tabs-blueSteel-2_3_6-3THnE",
	"vertical": "Tabs-vertical-2_3_6-20oUZ",
	"tab": "Tabs-tab-2_3_6-b9FZ3",
	"smallTab": "Tabs-smallTab-2_3_6-2bRvG",
	"nowrap": "Tabs-nowrap-2_3_6-bnhIp",
	"selected": "Tabs-selected-2_3_6-AbY_d",
	"tabList": "Tabs-tabList-2_3_6-295Xy",
	"spacer": "Tabs-spacer-2_3_6-iJuzU",
	"isWrapped": "Tabs-isWrapped-2_3_6-2Svhf",
	"smallTabList": "Tabs-smallTabList-2_3_6-3V2yo",
	"tabPanel": "Tabs-tabPanel-2_3_6-17ve5",
	"selectedOverlay": "Tabs-selectedOverlay-2_3_6-2pwGf",
	"nav": "Tabs-nav-2_3_6-37w3X",
	"selectedOverlayContent": "Tabs-selectedOverlayContent-2_3_6-XX3K8",
	"hasNotification": "Tabs-hasNotification-2_3_6-poJwO",
	"content": "Tabs-content-2_3_6-rFYzT",
	"belowHeader": "Tabs-belowHeader-2_3_6-3wY3B"
};

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tab; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(628);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Tabs_sass__WEBPACK_IMPORTED_MODULE_6__);







/**
Tab component to be used with [`Tabs`](#!/Tabs)
*/

function Tab(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      Component = _ref.Component,
      defaultSelected = _ref.defaultSelected,
      innerRef = _ref.innerRef,
      selected = _ref.selected,
      style = _ref.style,
      testName = _ref.testName,
      tabId = _ref.tabId,
      notification = _ref.notification,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["children", "className", "Component", "defaultSelected", "innerRef", "selected", "style", "testName", "tabId", "notification"]);

  //children are rendered twice 'selectedOverlay' renders a bold version
  //with absolute positioning on select (blueSteel only) so that the tab
  //doesn't change width, but has bold font (which is otherwise wider than normal)
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    style: style,
    role: "tab",
    "aria-selected": selected,
    tabIndex: selected || Component === 'a' ? 0 : -1,
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.tab, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.selected, selected), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.hasNotification, Boolean(notification)), _cx)),
    "data-test-name": testName,
    ref: innerRef
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    className: _Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.content
  }, children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    "aria-hidden": "true",
    className: _Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.selectedOverlay
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    className: _Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.selectedOverlayContent
  }, children))), notification ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", null, notification) : null);
}
Tab.defaultProps = {
  Component: 'div'
};
Tab.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Component to render as. e.g. 'a' or ReactRouter.Link */
  Component: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func]),

  /** Component ref. Used by `<Tabs>` to manage focus. */
  innerRef: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,

  /** Render the current tab in a selected state. Note that passing this prop directly to `<Tab>` will cause `<Tabs>` to behave as a controlled component. Use `defaultSelected` if you want `<Tabs>` to manage selection for you. */
  selected: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** A unique identifier used by `<Tabs>` and `<TabList>` to manage selection state. */
  tabId: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number]),

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Adds an indicator to the tab */
  notification: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node
};

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SmallTab; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(628);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Tabs_sass__WEBPACK_IMPORTED_MODULE_6__);







/**
SmallTab component to be used with [`Tabs`](#!/Tabs)
*/

function SmallTab(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Component = _ref.Component,
      defaultSelected = _ref.defaultSelected,
      innerRef = _ref.innerRef,
      selected = _ref.selected,
      style = _ref.style,
      testName = _ref.testName,
      tabId = _ref.tabId,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["children", "className", "Component", "defaultSelected", "innerRef", "selected", "style", "testName", "tabId"]);

  //children are rendered twice 'selectedOverlay' renders a bold version
  //with absolute positioning on select (blueSteel only) so that the tab
  //doesn't change width, but has bold font (which is otherwise wider than normal)
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({
    style: style,
    role: "tab",
    "aria-selected": selected,
    tabIndex: selected || Component === 'a' ? 0 : -1,
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.smallTab, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, _Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.selected, selected)),
    "data-test-name": testName,
    ref: innerRef
  }, rest), children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    "aria-hidden": "true",
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_Tabs_sass__WEBPACK_IMPORTED_MODULE_6___default.a.selectedOverlay)
  }, children));
}
SmallTab.defaultProps = {
  Component: 'div'
};
SmallTab.propTypes = {
  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Component to render as. e.g. 'a' or ReactRouter.Link */
  Component: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func]),

  /** Component ref. Used by `<Tabs>` to manage focus. */
  innerRef: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,

  /** Render the current tab in a selected state. Note that passing this prop directly to `<Tab>` will cause `<Tabs>` to behave as a controlled component. Use `defaultSelected` if you want `<Tabs>` to manage selection for you. */
  selected: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** A unique identifier used by `<Tabs>` and `<TabList>` to manage selection state. */
  tabId: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.number]),

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabPanel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(628);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Tabs_sass__WEBPACK_IMPORTED_MODULE_3__);




/**
Used with `<Tabs>` to wrap content for the selected tab.
The main purpose for this component is accessibility.
*/

function TabPanel(props) {
  var className = props.className,
      testName = props.testName,
      style = props.style,
      children = props.children,
      render = props.render,
      tabId = props.tabId;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    role: "tabpanel",
    tabIndex: 0,
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_Tabs_sass__WEBPACK_IMPORTED_MODULE_3___default.a.tabPanel, className),
    "data-test-name": testName
  }, render ? render(tabId) : children);
}
TabPanel.propTypes = {
  /** Component contents. You may alternately pass a `render` prop. */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /**
  Function to render the currently selected tab contents.
  @param {any} tabId - The index of the currently selected tab (provided via the `tabId` prop).
  */
  render: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Id of the currently selected tab. This will be passed back to the render prop */
  tabId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number]),

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TabList; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var js_util_compatibility__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(126);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(628);
/* harmony import */ var _Tabs_sass__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_Tabs_sass__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _SmallTab__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(631);
















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var ResizeDetector;

if (!Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_21__["isReact14"])()) {
  ResizeDetector = __webpack_require__(184).default;
}

Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_21__["warnReact14"])('TabList does not fully support React 0.14. See docs for more info.');
/**
A controlled component for managing a group of `<Tab>` components.
This component handles styling keyboard accessibility concerns.

This component is not fully supported in React 0.14. If you are using
React 0.14 tabs that are wrapped to the next line on narrow screens will not
be styled properly. If this is likely to be a problem for your application
you might consider using the `nowrap` prop to mitigate this.
*/

var TabList = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(TabList, _React$Component);

  var _super = _createSuper(TabList);

  function TabList() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, TabList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_10___default()(_this), "tabRefs", []);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_10___default()(_this), "state", {
      isWrapped: false
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_10___default()(_this), "checkForWrappedTabs", function () {
      if (_this.props.nowrap === true) {
        return;
      }

      if (_this.isWrapped != _this.state.isWrapped) {
        _this.setState({
          isWrapped: _this.isWrapped
        });
      }
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(TabList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.tabs !== this.props.tabs) {
        this.tabRefs = [];
      }
    }
  }, {
    key: "isWrapped",
    get: function get() {
      var _this2 = this;

      var maxDelta = 6; // accouts for different height

      return this.tabRefs.some(function (tab, i) {
        return i > 0 ? tab.getBoundingClientRect().y > _this2.tabRefs[i - 1].getBoundingClientRect().y + maxDelta : false;
      });
    }
  }, {
    key: "tabCount",
    get: function get() {
      return react__WEBPACK_IMPORTED_MODULE_17__["Children"].count(this.props.children);
    }
  }, {
    key: "hasSmallTabs",
    get: function get() {
      var children = this.props.children;

      if (this.tabCount > 0) {
        return react__WEBPACK_IMPORTED_MODULE_17__["Children"].toArray(children)[0].type === _SmallTab__WEBPACK_IMPORTED_MODULE_23__["default"];
      }
    }
  }, {
    key: "tabIds",
    get: function get() {
      return react__WEBPACK_IMPORTED_MODULE_17__["Children"].map(this.props.children, function (child, index) {
        return child.props.tabId != null ? child.props.tabId : index;
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(evt, selectedIndex) {
      var vertical = this.props.vertical;
      var keyCode = Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_19__["default"])(evt);

      if (!keyCode.is('left right up down')) {
        return;
      }

      var newselectedIndex = selectedIndex;

      if (vertical) {
        evt.preventDefault();

        if (keyCode.is('up')) {
          newselectedIndex = Math.max(selectedIndex - 1, 0);
        } else if (keyCode.is('down')) {
          newselectedIndex = Math.min(selectedIndex + 1, this.tabCount - 1);
        }
      } else {
        if (keyCode.is('left')) {
          newselectedIndex = Math.max(selectedIndex - 1, 0);
        } else if (keyCode.is('right')) {
          newselectedIndex = Math.min(selectedIndex + 1, this.tabCount - 1);
        }
      }

      var newselectedId = this.tabIds[newselectedIndex];

      if (newselectedId !== this.props.selectedId) {
        this.props.onSelect(newselectedId);
        this.tabRefs[newselectedIndex].focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _cx;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          nowrap = _this$props.nowrap,
          onSelect = _this$props.onSelect,
          selectedId = _this$props.selectedId,
          style = _this$props.style,
          testName = _this$props.testName,
          nav = _this$props.nav;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement("div", {
        role: "tablist",
        ref: function ref(node) {
          return _this3.el = node;
        },
        "data-test-name": testName,
        style: style,
        className: classnames__WEBPACK_IMPORTED_MODULE_20___default()(className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_22___default.a.nowrap, nowrap), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_22___default.a.tabList, !this.hasSmallTabs), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_22___default.a.smallTabList, this.hasSmallTabs), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_22___default.a.isWrapped, this.isWrapped), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_cx, _Tabs_sass__WEBPACK_IMPORTED_MODULE_22___default.a.nav, nav), _cx))
      }, react__WEBPACK_IMPORTED_MODULE_17__["Children"].map(children, function (child, index) {
        var _child$props = child.props,
            selected = _child$props.selected,
            tabProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7___default()(_child$props, ["selected"]);

        if ( true && selected != null && selectedId != null) {
          console.warn('`selected` was set on a <Tab> inside a <TabList> with `selectedId`. You must use one or the other. Not both.');
        }

        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.cloneElement(child, _objectSpread({
          key: index,
          selected: selectedId == null ? selected : _this3.tabIds[index] === selectedId,
          onClick: function onClick(evt) {
            onSelect(_this3.tabIds[index]);
          },
          onKeyDown: function onKeyDown(evt) {
            _this3.handleKeyDown(evt, index);
          },
          innerRef: function innerRef(ref) {
            return ref ? _this3.tabRefs[index] = ref : null;
          }
        }, tabProps));
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement("div", {
        className: _Tabs_sass__WEBPACK_IMPORTED_MODULE_22___default.a.spacer
      }), !Object(js_util_compatibility__WEBPACK_IMPORTED_MODULE_21__["isReact14"])() ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement(ResizeDetector, {
        handleWidth: true,
        onResize: this.checkForWrappedTabs
      }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement("noscript", null));
    }
  }]);

  return TabList;
}(react__WEBPACK_IMPORTED_MODULE_17___default.a.Component);


TabList.propTypes = {
  /** `<Tab>` components to render */
  children: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.string,

  /**
  Prevent tabs from wrapping when there are too many to fit on one line.
  Text overflow will be shown with ellipsis.
  */
  nowrap: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.bool,

  /**
  Tab selection handler. (Called on keyboard and mouse navigation).
  @param {any} tabId - The index of the selected tab.
  */
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.func,

  /** Currently selected id */
  selectedId: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.number]),

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.string,
  nav: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.bool
};

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TagList__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(635);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagList", function() { return _TagList__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TagList", function() { return TagList; });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var js_components_Tag__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(448);
/* harmony import */ var _TagList_sass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(636);
/* harmony import */ var _TagList_sass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_TagList_sass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(155);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








/** An ordered collection of Tags rendered inline. */

function TagList(props) {
  var onRemove = props.onRemove,
      items = props.items,
      labelKey = props.labelKey,
      style = props.style,
      testName = props.testName,
      theme = props.theme;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_11___default()(_TagList_sass__WEBPACK_IMPORTED_MODULE_13___default.a.tagList, props.className);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement("div", {
    className: classes,
    style: style,
    "data-test-name": testName
  }, items.map(function (item, index) {
    var handleRemove = onRemove ? function () {
      return onRemove(item, index);
    } : null;
    var label = typeof item === 'string' ? item : item[labelKey];
    var tagProps = typeof item === 'string' ? props.tagProps : _objectSpread(_objectSpread({}, props.tagProps), item);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(js_components_Tag__WEBPACK_IMPORTED_MODULE_12__["Tag"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_6___default()({
      key: index,
      onRemove: handleRemove,
      theme: theme
    }, tagProps), label);
  }));
}
TagList.defaultProps = {
  items: [],
  tagProps: {},
  labelKey: 'label'
};
TagList.propTypes = {
  /** Class name for the tag list */
  className: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,

  /** An array of items to render as tags */
  items: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string), prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object)]).isRequired,

  /** Required if items are provided as an array of objects. This tells which key in the item object to use for the `Tag` text. */
  labelKey: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,

  /** If provided an x will be rendered in each `Tag`. `onRemove` will be called with the corresponding item as the first parameter and the index of the item as the second parameter. */
  onRemove: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object,

  /** props to pass along to each Tag component */
  tagProps: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_14__["provideTheme"])(_TagList_sass__WEBPACK_IMPORTED_MODULE_13___default.a)(TagList));

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(637);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".TagList-tagList-2_3_6-3PMql{max-height:15rem;overflow:auto}", ""]);

// exports
exports.locals = {
	"tagList": "TagList-tagList-2_3_6-3PMql"
};

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Toaster__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(639);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toaster", function() { return _Toaster__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACTIONS", function() { return ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TYPES", function() { return TYPES; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(410);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(640);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(react_transition_group__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _util_deprecationWarning__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(83);
/* harmony import */ var _ToastMessage__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(649);
/* harmony import */ var _EventManager__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(652);
/* harmony import */ var _Toaster_sass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(650);
/* harmony import */ var _Toaster_sass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_Toaster_sass__WEBPACK_IMPORTED_MODULE_23__);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var ACTIONS = {
  SHOW: 'SHOW',
  DISMISS: 'DISMISS'
};
var TYPES = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success'
};
/**
 * A dispenser of ToastMessages aka flash messages. This component is meant to be used
 * in conjunction with the `toast` module.
 *
 * Simply place a `<Toaster/>` on the page and call `toast.error`,
 * `toast.warn`, or `toast.info` to pop up a message.
 *
 * **Alert Guidelines**
 *
 * The Toaster will attempt to account for auto-hiding guidelines if no `hideAfter` duration is specified.
 * To ensure that a toast message does not auto-hide after a duration, specify `hideAfter = -1`.
 *
 * * The minimum time to display an alert is 3 seconds (3000ms)
 * * If an auto-hiding alert has more than 12 words, add 0.25 seconds (250ms) per additional word.
 * * If an auto-hiding alert has more than 20 words, use a different component (modal) or shorten the text.
 * * If an auto-hiding alert has an action link, add 1.5 seconds (1500ms). Consider whether you must auto-hide the alert — this is a tradeoff between annoying users by making them click the &times; to dismiss the alert, vs annoying them by hiding the alert before they can click the link.
 *
 */

var Toaster = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Toaster, _React$Component);

  var _super = _createSuper(Toaster);

  function Toaster() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Toaster);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this), "state", {
      messages: []
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this), "handleShowMessage", function (messageParams) {
      _this.setState(function (prevState, props) {
        return {
          messages: [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default()(prevState.messages), [messageParams])
        };
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this), "handleDismissMessage", function (id) {
      _this.setState(function (prevState, props) {
        return {
          messages: prevState.messages.filter(function (msg) {
            return msg.id !== id;
          })
        };
      });
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Toaster, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _EventManager__WEBPACK_IMPORTED_MODULE_22__["default"].on(ACTIONS.SHOW, this.handleShowMessage).on(ACTIONS.DISMISS, this.handleDismissMessage);
      Toaster.queue.forEach(function (_ref) {
        var action = _ref.action,
            params = _ref.params;
        _EventManager__WEBPACK_IMPORTED_MODULE_22__["default"].emit(action, params);
      });
      Toaster.mounted = true;
      Toaster.queue = [];
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _EventManager__WEBPACK_IMPORTED_MODULE_22__["default"].off(ACTIONS.SHOW);
      _EventManager__WEBPACK_IMPORTED_MODULE_22__["default"].off(ACTIONS.DISMISS);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          testName = _this$props.testName,
          toastTestName = _this$props.toastTestName;
      var duration = 200;
      var defaultStyle = {
        transition: "opacity ".concat(duration, "ms ease-in-out, transform ").concat(duration, "ms ease-in-out"),
        opacity: 0,
        transform: "translate(0,-5px)"
      };
      var transitionStyles = {
        entered: {
          opacity: 1,
          transform: 'translate(0px, 0px)'
        },
        exiting: {
          opacity: 0,
          transform: 'translate(0px, 0px)'
        }
      };
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement("div", {
        className: _Toaster_sass__WEBPACK_IMPORTED_MODULE_23___default.a.flashQueue,
        "data-test-name": testName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement(react_transition_group__WEBPACK_IMPORTED_MODULE_19__["TransitionGroup"], null, this.state.messages.map(function (message) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement(react_transition_group__WEBPACK_IMPORTED_MODULE_19__["Transition"], {
          key: message.id,
          timeout: duration
        }, function (state) {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement(_ToastMessage__WEBPACK_IMPORTED_MODULE_21__["default"], {
            style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state]),
            id: message.id,
            type: message.type,
            title: message.title,
            message: message.message,
            details: message.details,
            hideAfter: message.hideAfter,
            testName: "".concat(toastTestName, "-").concat(message.id)
          });
        });
      })));
    }
  }], [{
    key: "queueToast",
    value: function queueToast(params) {
      if (Toaster.mounted) {
        _EventManager__WEBPACK_IMPORTED_MODULE_22__["default"].emit(ACTIONS.SHOW, params);
      } else {
        Toaster.queue.push({
          action: ACTIONS.SHOW,
          params: params
        });
      }
    }
  }, {
    key: "toast",
    value: function toast(params) {
      var id = Toaster.toastId++;
      Toaster.queueToast(_objectSpread({
        id: id
      }, params));
      return id;
    }
    /**
     * Use for critical errors. Do _not_ use for validation errors.
     * @public
     * @deprecated Use #error() instead
     */

  }, {
    key: "alert",
    value: function alert(_ref2) {
      var message = _ref2.message,
          details = _ref2.details,
          _ref2$hideAfter = _ref2.hideAfter,
          hideAfter = _ref2$hideAfter === void 0 ? 0 : _ref2$hideAfter;
      Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_20__["default"])('Toaster.alert() has been deprecated, use Toaster.error() instead');
      return Toaster.error({
        message: message,
        details: details,
        hideAfter: hideAfter
      });
    }
    /**
     * Use for critical errors. Do _not_ use for validation errors.
     * @public
     */

  }, {
    key: "error",
    value: function error(_ref3) {
      var message = _ref3.message,
          details = _ref3.details,
          _ref3$hideAfter = _ref3.hideAfter,
          hideAfter = _ref3$hideAfter === void 0 ? -1 : _ref3$hideAfter,
          title = _ref3.title;
      return Toaster.toast({
        type: TYPES.ERROR,
        message: message,
        details: details,
        hideAfter: hideAfter,
        title: title
      });
    }
    /**
     * Use for letting the user know that something was successfully executed.
     * @public
     */

  }, {
    key: "success",
    value: function success(_ref4) {
      var message = _ref4.message,
          details = _ref4.details,
          _ref4$hideAfter = _ref4.hideAfter,
          hideAfter = _ref4$hideAfter === void 0 ? 3 : _ref4$hideAfter,
          title = _ref4.title;
      return Toaster.toast({
        type: TYPES.SUCCESS,
        message: message,
        details: details,
        hideAfter: hideAfter,
        title: title
      });
    }
    /**
     * Use for warnings.
     * @public
     */

  }, {
    key: "warn",
    value: function warn(_ref5) {
      var message = _ref5.message,
          details = _ref5.details,
          _ref5$hideAfter = _ref5.hideAfter,
          hideAfter = _ref5$hideAfter === void 0 ? 3 : _ref5$hideAfter,
          title = _ref5.title;
      return Toaster.toast({
        type: TYPES.WARNING,
        message: message,
        details: details,
        hideAfter: hideAfter,
        title: title
      });
    }
    /**
     * Use for letting the user know that something happend and/or what will
     * happen next. Eg. A form was successfully submitted.
     * @public
     * @deprecated Use #info() instead
     */

  }, {
    key: "notice",
    value: function notice(_ref6) {
      var message = _ref6.message,
          details = _ref6.details,
          _ref6$hideAfter = _ref6.hideAfter,
          hideAfter = _ref6$hideAfter === void 0 ? 0 : _ref6$hideAfter;
      Object(_util_deprecationWarning__WEBPACK_IMPORTED_MODULE_20__["default"])('Toaster.notice() has been deprecated, use Toaster.info() instead');
      return Toaster.info({
        message: message,
        details: details,
        hideAfter: hideAfter
      });
    }
    /**
     * Use for letting the user know that something happend and/or what will
     * happen next. Eg. A form was successfully submitted.
     * @public
     */

  }, {
    key: "info",
    value: function info(_ref7) {
      var message = _ref7.message,
          details = _ref7.details,
          _ref7$hideAfter = _ref7.hideAfter,
          hideAfter = _ref7$hideAfter === void 0 ? 3 : _ref7$hideAfter,
          title = _ref7.title;
      return Toaster.toast({
        type: TYPES.INFO,
        message: message,
        details: details,
        hideAfter: hideAfter,
        title: title
      });
    }
    /**
     * Dismiss a particular toast message.
     * @param {number} id - Id of the toast to dismiss (returned by `notice`, `warn`, or `alert`)
     * @public
     */

  }, {
    key: "dismiss",
    value: function dismiss(id) {
      _EventManager__WEBPACK_IMPORTED_MODULE_22__["default"].emit(ACTIONS.DISMISS, id);
    }
  }]);

  return Toaster;
}(react__WEBPACK_IMPORTED_MODULE_17___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(Toaster, "mounted", false);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(Toaster, "queue", []);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_12___default()(Toaster, "toastId", 0);

Toaster.defaultProps = {
  testName: 'toaster',
  toastTestName: 'toast'
};
Toaster.propTypes = {
  /** Toaster test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.string,

  /** ToastMessage test name for automation */
  toastTestName: prop_types__WEBPACK_IMPORTED_MODULE_18___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Toaster);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(641));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(646));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(647));

var _Transition = _interopRequireDefault(__webpack_require__(203));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(130));

var _addClass = _interopRequireDefault(__webpack_require__(642));

var _removeClass = _interopRequireDefault(__webpack_require__(645));

var _react = _interopRequireDefault(__webpack_require__(125));

var _Transition = _interopRequireDefault(__webpack_require__(203));

var _PropTypes = __webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  true ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : undefined;
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(643);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(644));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 643 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(130));

var _react = _interopRequireDefault(__webpack_require__(125));

var _reactDom = __webpack_require__(200);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(647));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  true ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : undefined;
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(130));

var _react = _interopRequireDefault(__webpack_require__(125));

var _reactLifecyclesCompat = __webpack_require__(204);

var _ChildMapping = __webpack_require__(648);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  true ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : undefined;
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(125);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Toaster__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(639);
/* harmony import */ var _Alert__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(229);
/* harmony import */ var _Toaster_sass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(650);
/* harmony import */ var _Toaster_sass__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_Toaster_sass__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(155);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_15__);










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var ToastMessage = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ToastMessage, _React$Component);

  var _super = _createSuper(ToastMessage);

  function ToastMessage() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ToastMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "timeoutId", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "dismiss", function () {
      _Toaster__WEBPACK_IMPORTED_MODULE_11__["default"].dismiss(_this.props.id);
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ToastMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hideAfter = this.props.hideAfter;

      if (hideAfter >= 500) {
        if (true) {
          console.warn("Toast: Unexpectedly large hideAfter value: ".concat(hideAfter, " seconds"));
        }
      }

      if (hideAfter > 0) {
        this.timeoutId = setTimeout(this.dismiss, hideAfter * 1000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeoutId) clearTimeout(this.timeoutId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          details = _this$props.details,
          message = _this$props.message,
          testName = _this$props.testName,
          type = _this$props.type,
          style = _this$props.style,
          title = _this$props.title,
          theme = _this$props.theme;
      var classes = classnames__WEBPACK_IMPORTED_MODULE_15___default()(_Toaster_sass__WEBPACK_IMPORTED_MODULE_13___default.a[theme], _Toaster_sass__WEBPACK_IMPORTED_MODULE_13___default.a.flashMessage);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(_Alert__WEBPACK_IMPORTED_MODULE_12__["Alert"], {
        block: true,
        className: classes,
        testName: testName,
        details: details,
        title: title,
        onClose: this.dismiss,
        style: style,
        text: message,
        type: type
      });
    }
  }]);

  return ToastMessage;
}(react__WEBPACK_IMPORTED_MODULE_9___default.a.Component);

ToastMessage.propTypes = {
  /** Id so the message may be removed programmatically */
  id: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.any.isRequired,

  /** info, warning, or error */
  type: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.oneOf(['info', 'warning', 'error', 'success']),

  /** Title */
  title: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,

  /** The message text */
  message: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.node.isRequired,

  /** Technical details of the message. These are optional and hidden by default */
  details: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.object]),

  /** Seconds after which to auto-hide the message. Omit to disable auto-hiding. */
  hideAfter: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.number,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string,

  /** Container element styles */
  style: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.any
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_14__["provideTheme"])()(ToastMessage));

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(651);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Toaster-flashQueue-2_3_6-21EMW{position:fixed;z-index:10110;top:150px;left:0;right:0;width:500px;max-width:100%;margin:0 auto;color:#fff;font-size:1rem}@media screen and (max-width:499px){.Toaster-flashQueue-2_3_6-21EMW{top:2rem;left:1rem;right:1rem;width:auto;margin-left:0}}.Toaster-classic-2_3_6-MdZkr a{color:#079bb3}.Toaster-classic-2_3_6-MdZkr.Toaster-flashMessage-2_3_6-dwSIK{border:1px solid transparent;box-shadow:0 2px 5px rgba(0,0,0,.3)}.Toaster-blueSteel-2_3_6-36bTv a{color:#08088c}.Toaster-blueSteel-2_3_6-36bTv.Toaster-flashMessage-2_3_6-dwSIK{box-shadow:0 3px 8px 0 rgba(0,0,0,.1)}", ""]);

// exports
exports.locals = {
	"flashQueue": "Toaster-flashQueue-2_3_6-21EMW",
	"classic": "Toaster-classic-2_3_6-MdZkr",
	"flashMessage": "Toaster-flashMessage-2_3_6-dwSIK",
	"blueSteel": "Toaster-blueSteel-2_3_6-36bTv"
};

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(653);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(654);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(657);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(658);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(659);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(660);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(662);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(663);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(664);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(665);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(666);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(667);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(668);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(446);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(390);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(397);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_19__);




















var eventManager = {
  eventList: new Map(),
  on: function on(event, callback) {
    this.eventList.has(event) || this.eventList.set(event, []);
    this.eventList.get(event).push(callback);
    return this;
  },
  off: function off() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return this.eventList.delete(event);
  },
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!this.eventList.has(event)) {
      if (true) {
        console.warn("<".concat(event, "> Event is not registered. Did you forget to bind the event ?"));
      }

      return false;
    }

    this.eventList.get(event).forEach(function (callback) {
      return setTimeout(function () {
        return callback.call.apply(callback, [_this].concat(args));
      }, 0);
    });
    return this;
  }
};
/* harmony default export */ __webpack_exports__["default"] = (eventManager);

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(415);
var collectionStrong = __webpack_require__(424);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var collectionDeleteAll = __webpack_require__(429);

// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  deleteAll: function deleteAll(/* ...elements */) {
    return collectionDeleteAll.apply(this, arguments);
  }
});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var bind = __webpack_require__(76);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  every: function every(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return !iterate(iterator, function (key, value, stop) {
      if (!boundFunction(value, key, map)) return stop();
    }, { AS_ENTRIES: true, IS_ITERATOR: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(35);
var getIterator = __webpack_require__(433);

module.exports = IS_PURE ? getIterator : function (it) {
  // eslint-disable-next-line no-undef -- safe
  return Map.prototype.entries.call(it);
};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var bind = __webpack_require__(76);
var speciesConstructor = __webpack_require__(69);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  filter: function filter(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aFunction(newMap.set);
    iterate(iterator, function (key, value) {
      if (boundFunction(value, key, map)) setter.call(newMap, key, value);
    }, { AS_ENTRIES: true, IS_ITERATOR: true });
    return newMap;
  }
});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var bind = __webpack_require__(76);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  find: function find(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (key, value, stop) {
      if (boundFunction(value, key, map)) return stop(value);
    }, { AS_ENTRIES: true, IS_ITERATOR: true, INTERRUPTED: true }).result;
  }
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var bind = __webpack_require__(76);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  findKey: function findKey(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (key, value, stop) {
      if (boundFunction(value, key, map)) return stop(key);
    }, { AS_ENTRIES: true, IS_ITERATOR: true, INTERRUPTED: true }).result;
  }
});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var getMapIterator = __webpack_require__(656);
var sameValueZero = __webpack_require__(661);
var iterate = __webpack_require__(418);

// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  includes: function includes(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value, stop) {
      if (sameValueZero(value, searchElement)) return stop();
    }, { AS_ENTRIES: true, IS_ITERATOR: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),
/* 661 */
/***/ (function(module, exports) {

// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
module.exports = function (x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y || x != x && y != y;
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  keyOf: function keyOf(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value, stop) {
      if (value === searchElement) return stop(key);
    }, { AS_ENTRIES: true, IS_ITERATOR: true, INTERRUPTED: true }).result;
  }
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var bind = __webpack_require__(76);
var speciesConstructor = __webpack_require__(69);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  mapKeys: function mapKeys(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aFunction(newMap.set);
    iterate(iterator, function (key, value) {
      setter.call(newMap, boundFunction(value, key, map), value);
    }, { AS_ENTRIES: true, IS_ITERATOR: true });
    return newMap;
  }
});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var getBuiltIn = __webpack_require__(40);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var bind = __webpack_require__(76);
var speciesConstructor = __webpack_require__(69);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  mapValues: function mapValues(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aFunction(newMap.set);
    iterate(iterator, function (key, value) {
      setter.call(newMap, key, boundFunction(value, key, map));
    }, { AS_ENTRIES: true, IS_ITERATOR: true });
    return newMap;
  }
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var iterate = __webpack_require__(418);

// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  merge: function merge(iterable /* ...iterbles */) {
    var map = anObject(this);
    var setter = aFunction(map.set);
    var i = 0;
    while (i < arguments.length) {
      iterate(arguments[i++], setter, { that: map, AS_ENTRIES: true });
    }
    return map;
  }
});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    aFunction(callbackfn);
    iterate(iterator, function (key, value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = callbackfn(accumulator, value, key, map);
      }
    }, { AS_ENTRIES: true, IS_ITERATOR: true });
    if (noInitial) throw TypeError('Reduce of empty map with no initial value');
    return accumulator;
  }
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var bind = __webpack_require__(76);
var getMapIterator = __webpack_require__(656);
var iterate = __webpack_require__(418);

// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  some: function some(callbackfn /* , thisArg */) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    return iterate(iterator, function (key, value, stop) {
      if (boundFunction(value, key, map)) return stop();
    }, { AS_ENTRIES: true, IS_ITERATOR: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(7);
var IS_PURE = __webpack_require__(35);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(70);

// `Set.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$({ target: 'Map', proto: true, real: true, forced: IS_PURE }, {
  update: function update(key, callback /* , thunk */) {
    var map = anObject(this);
    var length = arguments.length;
    aFunction(callback);
    var isPresentInMap = map.has(key);
    if (!isPresentInMap && length < 3) {
      throw TypeError('Updating absent value');
    }
    var value = isPresentInMap ? map.get(key) : aFunction(length > 2 ? arguments[2] : undefined)(key, map);
    map.set(key, callback(value, key, map));
    return map;
  }
});


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Thumbnail__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(670);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return _Thumbnail__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return Thumbnail; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(216);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1);
/* harmony import */ var _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(671);
/* harmony import */ var _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(155);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








/**
 * Thumbnails are used to represent metadata about a video and give a concise
 * visual summary of the video and some of its properties.
 */

var Thumbnail = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(Thumbnail, _React$Component);

  var _super = _createSuper(Thumbnail);

  function Thumbnail(props) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Thumbnail);

    _this = _super.call(this, props);
    _this.state = {
      isValidImage: true
    };
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Thumbnail, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // triggers a re-render when image source is changed
      if (prevProps.hasOwnProperty('src') && this.props.hasOwnProperty('src') && prevProps.src !== this.props.src) {
        this.setState({
          isValidImage: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          alt = _this$props.alt,
          children = _this$props.children,
          className = _this$props.className,
          duration = _this$props.duration,
          live = _this$props.live,
          padRight = _this$props.padRight,
          remote = _this$props.remote,
          sharedIn = _this$props.sharedIn,
          sharedOut = _this$props.sharedOut,
          threeSixty = _this$props.threeSixty,
          offline = _this$props.offline,
          hasError = _this$props.hasError,
          src = _this$props.src,
          style = _this$props.style,
          testName = _this$props.testName,
          theme = _this$props.theme;
      var image = src && this.state.isValidImage ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("img", {
        className: _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.image,
        alt: alt,
        src: src,
        onError: function onError() {
          _this2.setState({
            isValidImage: false
          });
        }
      }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_10__["Icon"], {
        className: _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.placeholder,
        name: _Icon__WEBPACK_IMPORTED_MODULE_10__["ICONS"].PICTURE
      });

      if (hasError) {
        image = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_10__["Icon"], {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.placeholder, _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.errorImage),
          name: _Icon__WEBPACK_IMPORTED_MODULE_10__["ICONS"].WARNING
        });
      }

      var durationLabel = null;

      if (duration != null) {
        durationLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
          className: _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.duration
        }, Object(_util__WEBPACK_IMPORTED_MODULE_11__["formatDuration"])(duration));
      }

      if (live) {
        durationLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.duration, _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.live)
        }, live);
      }

      var threeSixtyLabel = null;

      if (threeSixty) {
        threeSixtyLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
          className: _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.threeSixty
        }, "360\xB0");
      }

      var remoteLabel = null;

      if (remote) {
        remoteLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
          className: _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.remote
        }, "R");
      }

      if (offline) {
        remoteLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
          className: _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.remote
        }, "O");
      }

      var sharedInLabel = null;

      if (sharedIn) {
        sharedInLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.share, _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.in)
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_10__["Icon"], {
          className: _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.shareIcon,
          name: _Icon__WEBPACK_IMPORTED_MODULE_10__["ICONS"].SHARE_IN
        }));
      }

      var sharedOutLabel = null;

      if (sharedOut) {
        sharedOutLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.share, _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.out)
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_10__["Icon"], {
          className: _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.shareIcon,
          name: _Icon__WEBPACK_IMPORTED_MODULE_10__["ICONS"].SHARE_OUT
        }));
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
        style: style,
        className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a[theme], _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.container, className, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.padRight, padRight)),
        "data-test-name": testName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.imageContainer, hasError ? _Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a.errorImageContainer : null)
      }, image, durationLabel, remoteLabel, threeSixtyLabel, sharedInLabel, sharedOutLabel, children));
    }
  }]);

  return Thumbnail;
}(react__WEBPACK_IMPORTED_MODULE_7___default.a.Component);
Thumbnail.propTypes = {
  /**
   * Optional alt text to provide to the thumbnail text to improve accessibility
   */
  alt: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /**
   * Optional component contents. This is useful when a custom overlay is
   * required to be rendered on top of the thumbnail content. The image
   * container is set to `position: relative` which can be helpful for
   * positioning custom overlays.
   */
  children: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /**
   * Duration of the video in milliseconds. If no duration is specified, the
   * duration badge will not be rendered.
   */
  duration: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.number,

  /**
   * Text that indicates that the video represented by the thumbnail is
   * currently streaming live. If specified, the LIVE badge will display with
   * this text in place of the duration badge
   */
  live: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /**
   * If true a right margin will be applied to separate this thumbnail from
   * adjacent inline content.
   */
  padRight: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /**
   * Indicates that the video is in an errored state.  Show an error icon
   * instead of the background image.
   */
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /**
   * Indicates that the video is remote. If set to `true`, will display the
   * Remote badge on top of the thumbnail image.
   */
  remote: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /**
   * Indicates that the video projection type 360. If set to `true`, will
   * display the 360 badge on top of the thumbnail image.
   */
  threeSixty: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /**
   * Indicates that the video is offline. If set to `true`, will display
   * the Offline badge on top of the thumbnail image.
   */
  offline: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /**
   * Indicates that the video has been shared in. If set to `true`, will display
   * the Shared-In icon badge on top of the thumbnail image.
   */
  sharedIn: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /**
   * Indicates that the video has been shared out. If set to `true`, will
   * display the Shared-Out icon badge on top of the thumbnail image.
   */
  sharedOut: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.bool,

  /**
   * URL of the thumbnail image source. The thumbnail should have a 16:9 aspect
   * ratio, but the image will attempt to fill the thumbnail space using the
   * "cover" approach.
   */
  src: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string
};
Thumbnail.defaultProps = {
  padRight: false,
  remote: false,
  threeSixty: false,
  offline: false,
  sharedIn: false,
  sharedOut: false
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_13__["provideTheme"])(_Thumbnail_sass__WEBPACK_IMPORTED_MODULE_12___default.a)(Thumbnail));

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(672);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".Thumbnail-classic-2_3_6-1WhkU a{color:#079bb3}.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-imageContainer-2_3_6-2LNGz{background-color:#717171}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-remote-2_3_6-365m1,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-remote-2_3_6-365m1{background-color:#293b70}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-share-2_3_6-1B9QS,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-share-2_3_6-1B9QS{background-color:#fff;color:#d32781}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-container-2_3_6-3qk-d,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-container-2_3_6-3qk-d{display:inline-block;position:relative;height:2.6666666667rem;width:3.8666666667rem;border:1px solid #ddd;color:#fff;background-color:#fff;text-align:center;overflow:hidden;padding:.0666666667rem}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-duration-2_3_6-izIw-,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-duration-2_3_6-izIw-{position:absolute;right:0;bottom:0;padding:0 2px;color:#ccc;font-size:.6666666667rem;text-transform:uppercase;background-color:#333}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-duration-2_3_6-izIw-.Thumbnail-live-2_3_6-2NsK5,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-duration-2_3_6-izIw-.Thumbnail-live-2_3_6-2NsK5{background-color:#a2b00c;color:#fff}.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-image-2_3_6-1xsfA{-ms-flex-positive:0;flex-grow:0;height:2.5333333333rem;width:3.7333333333rem;padding:.0666666667rem;-o-object-fit:cover;object-fit:cover}.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-imageContainer-2_3_6-2LNGz{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:100%}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-padRight-2_3_6-wM3W9,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-padRight-2_3_6-wM3W9{margin-right:.6666666667rem}.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-placeholder-2_3_6-3xZN1{height:1.6rem;width:auto}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-errorImageContainer-2_3_6-uMDvh,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-errorImageContainer-2_3_6-uMDvh{background-color:#da398e}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-errorImage-2_3_6-h99aV,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-errorImage-2_3_6-h99aV{color:#d32781}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-remote-2_3_6-365m1,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-remote-2_3_6-365m1{position:absolute;bottom:0;left:0;padding:0 2px;color:#ccc;font-size:.6666666667rem}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-threeSixty-2_3_6-2U0-J,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-threeSixty-2_3_6-2U0-J{position:absolute;center:0;top:0;padding:0 2px;color:#ccc;font-size:.6666666667rem;text-transform:uppercase}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-share-2_3_6-1B9QS,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-share-2_3_6-1B9QS{position:absolute;top:-.3333333333rem;padding:0}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-share-2_3_6-1B9QS.Thumbnail-in-2_3_6-147A5,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-share-2_3_6-1B9QS.Thumbnail-in-2_3_6-147A5{left:-1px}.Thumbnail-classic-2_3_6-1WhkU.Thumbnail-share-2_3_6-1B9QS.Thumbnail-out-2_3_6-25a-n,.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-share-2_3_6-1B9QS.Thumbnail-out-2_3_6-25a-n{right:-1px}.Thumbnail-classic-2_3_6-1WhkU .Thumbnail-shareIcon-2_3_6-2ZLje{height:.8rem}.Thumbnail-blueSteel-2_3_6-3ktpe a{color:#08088c}.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-imageContainer-2_3_6-2LNGz{background-color:#8e9093}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-remote-2_3_6-365m1,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-remote-2_3_6-365m1{background-color:#08088c}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-share-2_3_6-1B9QS,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-share-2_3_6-1B9QS{background-color:#fff;color:#d33d00}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-container-2_3_6-3qk-d,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-container-2_3_6-3qk-d{display:inline-block;position:relative;height:2.6666666667rem;width:3.8666666667rem;border:1px solid #e5e6e6;color:#fff;background-color:#fff;text-align:center;overflow:hidden;padding:.0666666667rem}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-duration-2_3_6-izIw-,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-duration-2_3_6-izIw-{position:absolute;right:0;bottom:0;padding:0 2px;color:#e5e6e6;font-size:.6666666667rem;text-transform:uppercase;background-color:#030d28}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-duration-2_3_6-izIw-.Thumbnail-live-2_3_6-2NsK5,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-duration-2_3_6-izIw-.Thumbnail-live-2_3_6-2NsK5{background-color:#009e4f;color:#fff}.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-image-2_3_6-1xsfA{-ms-flex-positive:0;flex-grow:0;height:2.5333333333rem;width:3.7333333333rem;padding:.0666666667rem;-o-object-fit:cover;object-fit:cover}.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-imageContainer-2_3_6-2LNGz{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:100%}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-padRight-2_3_6-wM3W9,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-padRight-2_3_6-wM3W9{margin-right:.6666666667rem}.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-placeholder-2_3_6-3xZN1{height:1.6rem;width:auto}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-errorImageContainer-2_3_6-uMDvh,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-errorImageContainer-2_3_6-uMDvh{background-color:#ed4400}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-errorImage-2_3_6-h99aV,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-errorImage-2_3_6-h99aV{color:#d33d00}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-remote-2_3_6-365m1,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-remote-2_3_6-365m1{position:absolute;bottom:0;left:0;padding:0 2px;color:#e5e6e6;font-size:.6666666667rem}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-threeSixty-2_3_6-2U0-J,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-threeSixty-2_3_6-2U0-J{position:absolute;center:0;top:0;padding:0 2px;color:#e5e6e6;font-size:.6666666667rem;text-transform:uppercase}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-share-2_3_6-1B9QS,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-share-2_3_6-1B9QS{position:absolute;top:-.3333333333rem;padding:0}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-share-2_3_6-1B9QS.Thumbnail-in-2_3_6-147A5,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-share-2_3_6-1B9QS.Thumbnail-in-2_3_6-147A5{left:-1px}.Thumbnail-blueSteel-2_3_6-3ktpe.Thumbnail-share-2_3_6-1B9QS.Thumbnail-out-2_3_6-25a-n,.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-share-2_3_6-1B9QS.Thumbnail-out-2_3_6-25a-n{right:-1px}.Thumbnail-blueSteel-2_3_6-3ktpe .Thumbnail-shareIcon-2_3_6-2ZLje{height:.8rem}", ""]);

// exports
exports.locals = {
	"classic": "Thumbnail-classic-2_3_6-1WhkU",
	"imageContainer": "Thumbnail-imageContainer-2_3_6-2LNGz",
	"remote": "Thumbnail-remote-2_3_6-365m1",
	"share": "Thumbnail-share-2_3_6-1B9QS",
	"container": "Thumbnail-container-2_3_6-3qk-d",
	"duration": "Thumbnail-duration-2_3_6-izIw-",
	"live": "Thumbnail-live-2_3_6-2NsK5",
	"image": "Thumbnail-image-2_3_6-1xsfA",
	"padRight": "Thumbnail-padRight-2_3_6-wM3W9",
	"placeholder": "Thumbnail-placeholder-2_3_6-3xZN1",
	"errorImageContainer": "Thumbnail-errorImageContainer-2_3_6-uMDvh",
	"errorImage": "Thumbnail-errorImage-2_3_6-h99aV",
	"threeSixty": "Thumbnail-threeSixty-2_3_6-2U0-J",
	"in": "Thumbnail-in-2_3_6-147A5",
	"out": "Thumbnail-out-2_3_6-25a-n",
	"shareIcon": "Thumbnail-shareIcon-2_3_6-2ZLje",
	"blueSteel": "Thumbnail-blueSteel-2_3_6-3ktpe"
};

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Wizard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(674);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Wizard", function() { return _Wizard__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _WizardControls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(676);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WizardControls", function() { return _WizardControls__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _WizardStep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(677);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WizardStep", function() { return _WizardStep__WEBPACK_IMPORTED_MODULE_2__["default"]; });






/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Wizard; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _util_compatibility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(126);
/* harmony import */ var _WizardContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(675);










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





/**
A Component that can be used to create sequential workflows where the user is able to navigate between steps.
*/

var Wizard = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(Wizard, _React$Component);

  var _super = _createSuper(Wizard);

  function Wizard() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Wizard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "state", {
      step: _this.props.initialStep
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "setStep", function (step) {
      return _this.setState({
        step: step
      });
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Wizard, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        currentStep: this.state.step,
        setStep: this.setStep
      };
    }
  }, {
    key: "render",
    value: function render() {
      if (Object(_util_compatibility__WEBPACK_IMPORTED_MODULE_11__["hasCreateContext"])()) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement(_WizardContext__WEBPACK_IMPORTED_MODULE_12__["default"].Provider, {
          value: {
            currentStep: this.state.step,
            setStep: this.setStep
          }
        }, this.props.children);
      } else {
        return this.props.children;
      }
    }
  }]);

  return Wizard;
}(react__WEBPACK_IMPORTED_MODULE_9___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(Wizard, "propTypes", {
  /** Child content of the Wizard */
  children: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.node,

  /** The initial step to render prior to user interaction */
  initialStep: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string])
});

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(Wizard, "childContextTypes", {
  setStep: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.func,
  currentStep: prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_10___default.a.string])
});



/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _util_compatibility__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(126);


/* harmony default export */ __webpack_exports__["default"] = (Object(_util_compatibility__WEBPACK_IMPORTED_MODULE_1__["hasCreateContext"])() ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({
  currentStep: -1,
  setStep: function setStep() {}
}) : null);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WizardControls; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _WizardContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(675);
/* harmony import */ var _util_compatibility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(126);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var WizardControls = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(WizardControls, _React$Component);

  var _super = _createSuper(WizardControls);

  function WizardControls() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, WizardControls);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(WizardControls, [{
    key: "render",
    value: function render() {
      var _this = this;

      var children = this.props.children;

      if (Object(_util_compatibility__WEBPACK_IMPORTED_MODULE_11__["hasCreateContext"])()) {
        if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.isValidElement(children)) {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement(_WizardContext__WEBPACK_IMPORTED_MODULE_10__["default"].Consumer, null, function (wizard) {
            return react__WEBPACK_IMPORTED_MODULE_8___default.a.Children.map(children, function (child) {
              return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.cloneElement(child, wizard);
            });
          });
        } else if (typeof children === 'function') {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement(_WizardContext__WEBPACK_IMPORTED_MODULE_10__["default"].Consumer, null, children);
        } else {
          return children;
        }
      } else {
        if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.isValidElement(children)) {
          return react__WEBPACK_IMPORTED_MODULE_8___default.a.Children.map(children, function (child) {
            return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.cloneElement(child, {
              setStep: _this.context.setStep,
              currentStep: _this.context.currentStep
            });
          });
        } else if (typeof children === 'function') {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement(children, {
            setStep: this.context.setStep
          });
        } else {
          return children;
        }
      }
    }
  }]);

  return WizardControls;
}(react__WEBPACK_IMPORTED_MODULE_8___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(WizardControls, "propTypes", {
  children: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.node), prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.node, prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.func])
});

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(WizardControls, "contextTypes", {
  setStep: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.func,
  currentStep: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string])
});



/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WizardStep; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _WizardContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(675);
/* harmony import */ var _util_compatibility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(126);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var WizardStep = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(WizardStep, _React$Component);

  var _super = _createSuper(WizardStep);

  function WizardStep() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, WizardStep);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(WizardStep, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          children = _this$props.children;

      if (Object(_util_compatibility__WEBPACK_IMPORTED_MODULE_11__["hasCreateContext"])()) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement(_WizardContext__WEBPACK_IMPORTED_MODULE_10__["default"].Consumer, null, function (_ref) {
          var currentStep = _ref.currentStep;
          return currentStep === name ? children : null;
        });
      } else {
        return this.context.currentStep === name ? children : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement("noscript", null);
      }
    }
  }]);

  return WizardStep;
}(react__WEBPACK_IMPORTED_MODULE_8___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(WizardStep, "propTypes", {
  name: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string]).isRequired,
  children: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.node
});

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(WizardStep, "contextTypes", {
  setStep: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.func,
  currentStep: prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_9___default.a.string])
});



/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _FileInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(679);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileInput", function() { return _FileInput__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileInput", function() { return FileInput; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _FileInput_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(680);
/* harmony import */ var _FileInput_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_FileInput_sass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);








/**
 * A basic single file input component.
 *
 */

function FileInput(_ref) {
  var _cx;

  var accept = _ref.accept,
      block = _ref.block,
      buttonClass = _ref.buttonClass,
      buttonLabel = _ref.buttonLabel,
      buttonStyle = _ref.buttonStyle,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      _onChange = _ref.onChange,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme,
      uploadedFileName = _ref.uploadedFileName;
  var buttonClasses = classnames__WEBPACK_IMPORTED_MODULE_5___default()(_FileInput_sass__WEBPACK_IMPORTED_MODULE_6___default.a.label, buttonClass, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _FileInput_sass__WEBPACK_IMPORTED_MODULE_6___default.a.block, block), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _FileInput_sass__WEBPACK_IMPORTED_MODULE_6___default.a.disabled, disabled), _cx));
  var uniqueId = id ? id : "".concat(Date.now(), "-").concat(Math.random());
  var idUpload = "".concat(uniqueId, "-UploadField");
  var inputId = "".concat(uniqueId, "-FileInput");
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", {
    style: style,
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_FileInput_sass__WEBPACK_IMPORTED_MODULE_6___default.a[theme], _FileInput_sass__WEBPACK_IMPORTED_MODULE_6___default.a.fileInput, className),
    "data-test-name": testName,
    id: idUpload
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("label", {
    className: buttonClasses,
    htmlFor: inputId,
    style: buttonStyle
  }, buttonLabel, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("input", {
    "aria-disabled": disabled,
    id: inputId,
    type: "file",
    accept: accept,
    onChange: function onChange(event) {
      return _onChange(event.target.files[0].name, event);
    },
    disabled: disabled
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_FileInput_sass__WEBPACK_IMPORTED_MODULE_6___default.a.fileName)
  }, uploadedFileName));
}
FileInput.IMAGE = 'image/*';
FileInput.AUDIO = 'audio/*';
FileInput.VIDEO = 'video/*';
FileInput.propTypes = {
  /** Accept attribute for the file type allowed */
  accept: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Button class name */
  buttonClass: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Label attribute for the input */
  buttonLabel: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Button style attribute */
  buttonStyle: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Block style attribute */
  block: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** Disabled attribute */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,

  /** ID attribute for the input */
  id: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /**
   * Your change handler. Update your state here.
   * @param {string} value - Current file name of the selected file.
   * @param {SyntheticEvent} event - The event.
   */
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func.isRequired,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** String value attribute of the current selected file */
  uploadedFileName: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_FileInput_sass__WEBPACK_IMPORTED_MODULE_6___default.a)(FileInput));

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(681);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".FileInput-classic-2_3_6-3VN5P a{color:#079bb3}.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx input,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx input{display:none}.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm{position:relative;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-family:Lato,Helvetica,Arial,sans-serif;display:inline-block;padding:0 1rem;line-height:34px;text-align:center;transition:transform .15s ease-out;font-weight:700;text-decoration:none!important;margin:0;white-space:nowrap;color:#fff;font-size:1rem;border-radius:4px;background-color:#079bb3;border:1px solid #079bb3}.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm+.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm+.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm+.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm+.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm{margin-left:.3333333333rem}.FileInput-block-2_3_6-2t9Og+.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-block-2_3_6-2t9Og+.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm{margin-left:0;margin-top:.5rem}.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm.FileInput-disabled-2_3_6-1eLRs,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm.FileInput-disabled-2_3_6-1eLRs{pointer-events:none;background-color:#ccc!important;border-color:#ccc!important;color:#fff!important}.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:not(.FileInput-disabled-2_3_6-1eLRs):hover,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:not(.FileInput-disabled-2_3_6-1eLRs):hover{transform:translateY(-1px)}.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:not(.FileInput-disabled-2_3_6-1eLRs):active,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:not(.FileInput-disabled-2_3_6-1eLRs):active{transform:translateY(1px)}.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:active,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:active,.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:focus,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:focus,.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:hover,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:hover{background-color:#08b0cc;border-color:#08b0cc}.FileInput-classic-2_3_6-3VN5P.FileInput-fileInput-2_3_6-_POQx .FileInput-fileName-2_3_6-1sCyx,.FileInput-classic-2_3_6-3VN5P .FileInput-fileInput-2_3_6-_POQx .FileInput-fileName-2_3_6-1sCyx{margin-left:8px;font-size:1rem;color:#999}.FileInput-blueSteel-2_3_6-2vfzq a{color:#08088c}.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx input,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx input{display:none}.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm{position:relative;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-family:Public Sans,sans-serif;display:inline-block;padding:0 1rem;line-height:30px;text-align:center;transition:transform .15s ease-out;font-weight:700;text-decoration:none!important;margin:0;white-space:nowrap;color:#fff;font-size:.875rem;letter-spacing:auto;border-radius:1px;background-color:#092dbd;border:1px solid #092dbd}.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm+.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm+.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm+.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm+.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm{margin-left:.3333333333rem}.FileInput-block-2_3_6-2t9Og+.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm,.FileInput-block-2_3_6-2t9Og+.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm{margin-left:0;margin-top:.5rem}.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm.FileInput-disabled-2_3_6-1eLRs,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm.FileInput-disabled-2_3_6-1eLRs{pointer-events:none;background-color:#f2f2f3!important;border-color:#f2f2f3!important;color:#8e9093!important}.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:not(.FileInput-disabled-2_3_6-1eLRs):hover,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:not(.FileInput-disabled-2_3_6-1eLRs):hover{transform:translateY(-1px)}.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:not(.FileInput-disabled-2_3_6-1eLRs):active,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:not(.FileInput-disabled-2_3_6-1eLRs):active{transform:translateY(1px)}.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:active,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:active,.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:focus,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:focus,.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:hover,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-label-2_3_6-35Hdm:hover{background-color:#08088c;border-color:#08088c}.FileInput-blueSteel-2_3_6-2vfzq.FileInput-fileInput-2_3_6-_POQx .FileInput-fileName-2_3_6-1sCyx,.FileInput-blueSteel-2_3_6-2vfzq .FileInput-fileInput-2_3_6-_POQx .FileInput-fileName-2_3_6-1sCyx{margin-left:8px;font-size:.875rem;letter-spacing:auto}", ""]);

// exports
exports.locals = {
	"classic": "FileInput-classic-2_3_6-3VN5P",
	"fileInput": "FileInput-fileInput-2_3_6-_POQx",
	"label": "FileInput-label-2_3_6-35Hdm",
	"block": "FileInput-block-2_3_6-2t9Og",
	"disabled": "FileInput-disabled-2_3_6-1eLRs",
	"fileName": "FileInput-fileName-2_3_6-1sCyx",
	"blueSteel": "FileInput-blueSteel-2_3_6-2vfzq"
};

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GaugeChart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(683);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GaugeChart", function() { return _GaugeChart__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaugeChart", function() { return GaugeChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_test", function() { return _test; });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _GaugeChartToolTip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684);
/* harmony import */ var _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(687);
/* harmony import */ var _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);








/**
 * A charting component that displays an arc drawn to represent a percentage
 * value within a specified range (e.g. 0.4 within range of 0 to 1, or
 * 250 within range of 0 to 1000). Setting the radius determines the height
 * of the component (80px default).
 *
 */

function GaugeChart(_ref) {
  var animated = _ref.animated,
      className = _ref.className,
      color = _ref.color,
      displayFontSize = _ref.displayFontSize,
      displayValue = _ref.displayValue,
      median = _ref.median,
      medianDisplayValue = _ref.medianDisplayValue,
      medianLineExtension = _ref.medianLineExtension,
      radius = _ref.radius,
      range = _ref.range,
      thickness = _ref.thickness,
      testName = _ref.testName,
      theme = _ref.theme,
      value = _ref.value;

  if (value < range.start || value > range.end) {
    throw new Error('Value out of range.');
  }

  var medianPercent;

  if (median || median === 0) {
    if (median < range.start || median > range.end) {
      throw new Error('Median value out of range.');
    }

    medianPercent = (median - range.start) / (range.end - range.start);
  }
  /** determine where the value should fall on the gauge based on the range */


  var percent = (value - range.start) / (range.end - range.start);
  /** translates svg in to accommodate median line drawn outside radius */

  var translate = "translate(".concat(medianLineExtension, ", ").concat(medianLineExtension, ")");
  /** only calculate if necessary */

  var medianLineCoordinates;

  if (median !== null) {
    medianLineCoordinates = getMedianLineCoordinates(radius, thickness, medianLineExtension, medianPercent);
  }

  var arcPath;
  /** animates the arc */

  if (animated) {
    var currentValue = 0;
    var time = 0;

    var redrawArc = function redrawArc() {
      time += 0.05;
      /** easing function */

      currentValue = percent * (time * (2 - time));

      if (time < 1) {
        window.requestAnimationFrame(redrawArc);
      } else {
        currentValue = percent;
      }

      if (arcPath) {
        arcPath.setAttribute('d', describeArc(currentValue, radius, thickness));
      }
    };

    window.requestAnimationFrame(redrawArc);
  }

  var width = radius * 2 + medianLineExtension * 2;
  var height = radius + medianLineExtension;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(_GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], className, _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a.gaugeChart),
    style: {
      width: width,
      height: height
    },
    tabIndex: "0",
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a.container,
    style: {
      height: height
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("svg", {
    width: width,
    height: height
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("g", {
    className: _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a.track,
    transform: translate,
    fill: "none",
    strokeWidth: thickness
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("path", {
    d: describeArc(1, radius, thickness)
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("g", {
    className: getClassFromValue(_GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a, percent, color),
    transform: translate,
    fill: "none",
    strokeWidth: thickness,
    stroke: color
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("path", {
    ref: function ref(p) {
      return arcPath = p;
    },
    d: animated ? null : describeArc(percent, radius, thickness)
  }))), median !== null && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_2___default.a.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("svg", {
    className: _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a.median,
    width: width,
    height: height
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("g", {
    transform: translate,
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("path", {
    className: _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a.hitArea,
    d: getMedianLine(medianLineCoordinates)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("path", {
    d: getMedianLine(medianLineCoordinates)
  }))), medianDisplayValue && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_GaugeChartToolTip__WEBPACK_IMPORTED_MODULE_4__["default"], {
    className: _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a.medianTooltip,
    position: getOuterMedianPoint(medianLineCoordinates.outer, medianLineExtension),
    theme: theme
  }, medianDisplayValue)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", {
    className: _GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a.value,
    style: getDisplayValueStyle(width, displayFontSize)
  }, displayValue)));
}
/** find the x/y based on angle and radius */

var polarToCartesian = function polarToCartesian(angleInDegrees, radius) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: radius * Math.cos(angleInRadians),
    y: radius * Math.sin(angleInRadians)
  };
};
/** offsets the position by the specified amount */


var offsetPosition = function offsetPosition(position, offset) {
  return {
    x: position.x + offset,
    y: position.y + offset
  };
};
/**
 * returns half arc svg path from -90 t0 -270 (i.e., 90) based on percentage
 * https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle
 */


var describeArc = function describeArc(percent, radius, thickness) {
  /* drawing from -90 is visual start of arc in chart */
  var startAngle = -90;
  /* -270 degress would be a half arc; we are drawing a percentage */

  var endAngle = -270 - (180 - percent * 180);
  /* radius is full radius of arc; */

  /* since we are drawing a stroke, we need to find middle of that thickness */

  var adjRadius = radius - thickness / 2;
  /* adjusts coordinates by radius, centering the arc */

  var drawFrom = offsetPosition(polarToCartesian(endAngle, adjRadius), radius);
  var drawTo = offsetPosition(polarToCartesian(startAngle, adjRadius), radius);
  /** returns string svg command for drawing arc from coordinate */

  return [
  /** svg command for moving to point */
  "M ".concat(drawFrom.x, " ").concat(drawFrom.y),
  /**
   * svg command for drawing arc
   * 2, 3 arguments define horizontal and vertical radii
   * three 0s are flags that allow drawing of arc in 1st and 4th quadrant
   * last two arguments are where the arc is drawn to
   */
  "A ".concat(adjRadius, " ").concat(adjRadius, " 0 0 0 ").concat(drawTo.x, " ").concat(drawTo.y)].join(' ');
};
/** creates line path of median based on inner/outer coordinates */


var getMedianLine = function getMedianLine(_ref2) {
  var inner = _ref2.inner,
      outer = _ref2.outer;
  return ["M ".concat(outer.x, " ").concat(outer.y), "L ".concat(inner.x, " ").concat(inner.y)].join(' ');
};
/** determines x/y of median based on median value and component radius */


var getMedianLineCoordinates = function getMedianLineCoordinates(radius, thickness, medianLineExtension, medianPercent) {
  var outerRadius = radius + medianLineExtension;
  var innerRadius = radius - thickness - medianLineExtension;
  var angleInDegrees = 180 * medianPercent - 90;
  var outer = polarToCartesian(angleInDegrees, outerRadius);
  var inner = polarToCartesian(angleInDegrees, innerRadius);
  return {
    inner: {
      x: inner.x + radius,
      y: inner.y + radius
    },
    outer: {
      x: outer.x + radius,
      y: outer.y + radius
    }
  };
};
/** returns outer median point */


var getOuterMedianPoint = function getOuterMedianPoint(point, extension) {
  var position = {
    x: point.x,
    y: point.y
  };
  position.x += extension;
  position.y -= 5; // places tooltip above line

  return position;
};
/** returns class name based on the value, changing the color */


var getClassFromValue = function getClassFromValue(css, percent, color) {
  if (color !== null) return null;
  if (percent < 0.2) return css.gaugePoor;
  if (percent < 0.4) return css.gaugeLow;
  if (percent < 0.6) return css.gaugeAverage;
  if (percent < 0.8) return css.gaugeGood;
  return css.gaugeGreat;
};
/** returns the style object for the value field */


var getDisplayValueStyle = function getDisplayValueStyle(width, displayFontSize) {
  return {
    width: width,
    height: displayFontSize ? displayFontSize + 4 + 'px' : null,
    fontSize: displayFontSize
  };
};

var _test = {
  polarToCartesian: polarToCartesian,
  describeArc: describeArc,
  offsetPosition: offsetPosition,
  getMedianLine: getMedianLine,
  getMedianLineCoordinates: getMedianLineCoordinates,
  getOuterMedianPoint: getOuterMedianPoint,
  getClassFromValue: getClassFromValue,
  getDisplayValueStyle: getDisplayValueStyle
};
GaugeChart.propTypes = {
  /** Pixel thickness of the bar gauge */
  thickness: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,

  /** Outer radius of the gauge */
  radius: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,

  /** Color override for filled bar */
  color: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Numeric range that the gauge represents */
  range: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.object,

  /** Value to display on the gauge */
  value: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,

  /** Value to display as text */
  displayValue: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Value for the median bar in the gauge */
  median: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,

  /** Value to display in median tooltip */
  medianDisplayValue: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** Pixels media bar is drawn outside of gauge */
  medianLineExtension: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,

  /** Override value for font size */
  displayFontSize: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.number,

  /** Whether to animate the drawing of the arc */
  animated: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.bool,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_3___default.a.string
};
GaugeChart.defaultProps = {
  thickness: 20,
  radius: 80,
  color: null,
  range: {
    start: 0,
    end: 1
  },
  value: 0,
  displayValue: null,
  median: null,
  medianDisplayValue: null,
  medianLineExtension: 8,
  displayFontSize: null,
  animated: true,
  testName: null
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_GaugeChart_sass__WEBPACK_IMPORTED_MODULE_5___default.a)(GaugeChart));

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GaugeChartToolTip; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _GaugeChartToolTip_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(685);
/* harmony import */ var _GaugeChartToolTip_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_GaugeChartToolTip_sass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);




function GaugeChartToolTip(props) {
  var className = props.className,
      children = props.children,
      position = props.position,
      theme = props.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, _GaugeChartToolTip_sass__WEBPACK_IMPORTED_MODULE_2___default.a.container, _GaugeChartToolTip_sass__WEBPACK_IMPORTED_MODULE_2___default.a[theme])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: _GaugeChartToolTip_sass__WEBPACK_IMPORTED_MODULE_2___default.a.outerTooltip,
    style: {
      top: position.y,
      left: position.x
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: _GaugeChartToolTip_sass__WEBPACK_IMPORTED_MODULE_2___default.a.tooltip
  }, children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: _GaugeChartToolTip_sass__WEBPACK_IMPORTED_MODULE_2___default.a.tooltipArrow
  }))));
}
GaugeChartToolTip.propTypes = {
  position: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
GaugeChartToolTip.defaultProps = {
  position: {
    x: 0,
    y: 0
  }
};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(686);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".GaugeChartToolTip-classic-2_3_6-17_Pq a{color:#079bb3}.GaugeChartToolTip-classic-2_3_6-17_Pq.GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h,.GaugeChartToolTip-classic-2_3_6-17_Pq .GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h{position:relative;margin-top:-50%}.GaugeChartToolTip-classic-2_3_6-17_Pq.GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h .GaugeChartToolTip-tooltip-2_3_6-2RYa-,.GaugeChartToolTip-classic-2_3_6-17_Pq .GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h .GaugeChartToolTip-tooltip-2_3_6-2RYa-{position:relative;padding:.5rem .7rem .6rem;background-color:#444;border-radius:4px;font-size:.9333333333rem;text-align:center;color:#eee;font-weight:700;bottom:0;left:-50%}.GaugeChartToolTip-classic-2_3_6-17_Pq.GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h .GaugeChartToolTip-tooltip-2_3_6-2RYa- .GaugeChartToolTip-tooltipArrow-2_3_6-14WaB,.GaugeChartToolTip-classic-2_3_6-17_Pq .GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h .GaugeChartToolTip-tooltip-2_3_6-2RYa- .GaugeChartToolTip-tooltipArrow-2_3_6-14WaB{position:absolute;width:0;height:0;border-color:transparent;border-style:solid;bottom:-5px;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#444}.GaugeChartToolTip-blueSteel-2_3_6-1jraL a{color:#08088c}.GaugeChartToolTip-blueSteel-2_3_6-1jraL.GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h,.GaugeChartToolTip-blueSteel-2_3_6-1jraL .GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h{position:relative;margin-top:-50%}.GaugeChartToolTip-blueSteel-2_3_6-1jraL.GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h .GaugeChartToolTip-tooltip-2_3_6-2RYa-,.GaugeChartToolTip-blueSteel-2_3_6-1jraL .GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h .GaugeChartToolTip-tooltip-2_3_6-2RYa-{position:relative;padding:.5rem .7rem .6rem;background-color:#01050e;border-radius:4px;font-size:.9333333333rem;text-align:center;color:#f9f9f9;font-weight:700;bottom:0;left:-50%}.GaugeChartToolTip-blueSteel-2_3_6-1jraL.GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h .GaugeChartToolTip-tooltip-2_3_6-2RYa- .GaugeChartToolTip-tooltipArrow-2_3_6-14WaB,.GaugeChartToolTip-blueSteel-2_3_6-1jraL .GaugeChartToolTip-container-2_3_6-kKEhX .GaugeChartToolTip-outerTooltip-2_3_6-1PG3h .GaugeChartToolTip-tooltip-2_3_6-2RYa- .GaugeChartToolTip-tooltipArrow-2_3_6-14WaB{position:absolute;width:0;height:0;border-color:transparent;border-style:solid;bottom:-5px;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#01050e}", ""]);

// exports
exports.locals = {
	"classic": "GaugeChartToolTip-classic-2_3_6-17_Pq",
	"container": "GaugeChartToolTip-container-2_3_6-kKEhX",
	"outerTooltip": "GaugeChartToolTip-outerTooltip-2_3_6-1PG3h",
	"tooltip": "GaugeChartToolTip-tooltip-2_3_6-2RYa-",
	"tooltipArrow": "GaugeChartToolTip-tooltipArrow-2_3_6-14WaB",
	"blueSteel": "GaugeChartToolTip-blueSteel-2_3_6-1jraL"
};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(688);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".GaugeChart-classic-2_3_6-xsIAU a{color:#079bb3}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A{width:180px;height:100px;pointer-events:none}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_{position:relative;width:100%}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg{position:absolute;top:0;left:0}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-track-2_3_6-2q3zX,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-track-2_3_6-2q3zX{stroke:#f8f8f8}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeGood-2_3_6-1rvAd,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeGood-2_3_6-1rvAd,.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeGreat-2_3_6-1GyRA,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeGreat-2_3_6-1GyRA{stroke:#a2b00c}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeAverage-2_3_6-2cWer,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeAverage-2_3_6-2cWer{stroke:#079bb3}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeLow-2_3_6-2Q1M7,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeLow-2_3_6-2Q1M7,.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugePoor-2_3_6-1eTJm,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugePoor-2_3_6-1eTJm{stroke:#d32781}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-medianTooltip-2_3_6-3dElY,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-medianTooltip-2_3_6-3dElY{opacity:0;pointer-events:none;position:absolute;top:0;left:0}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp{stroke:#979797;stroke-width:3px}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp path.GaugeChart-hitArea-2_3_6-ZemnC,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp path.GaugeChart-hitArea-2_3_6-ZemnC{stroke:transparent;stroke-width:15px;pointer-events:visiblestroke}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp:hover~.GaugeChart-medianTooltip-2_3_6-3dElY,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp:hover~.GaugeChart-medianTooltip-2_3_6-3dElY{opacity:1!important;top:-5px;transition:all .3s}.GaugeChart-classic-2_3_6-xsIAU.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-value-2_3_6-2XeH4,.GaugeChart-classic-2_3_6-xsIAU .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-value-2_3_6-2XeH4{height:30px;bottom:5px;position:absolute;font-size:26px;font-weight:700;text-align:center;color:#444}.GaugeChart-blueSteel-2_3_6-dYaIT a{color:#08088c}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A{width:180px;height:100px;pointer-events:none}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_{position:relative;width:100%}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg{position:absolute;top:0;left:0}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-track-2_3_6-2q3zX,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-track-2_3_6-2q3zX{stroke:#f8f8f8}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeGood-2_3_6-1rvAd,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeGood-2_3_6-1rvAd,.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeGreat-2_3_6-1GyRA,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeGreat-2_3_6-1GyRA{stroke:#009e4f}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeAverage-2_3_6-2cWer,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeAverage-2_3_6-2cWer{stroke:#08088c}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeLow-2_3_6-2Q1M7,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugeLow-2_3_6-2Q1M7,.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugePoor-2_3_6-1eTJm,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ svg g.GaugeChart-gaugePoor-2_3_6-1eTJm{stroke:#d33d00}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-medianTooltip-2_3_6-3dElY,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-medianTooltip-2_3_6-3dElY{opacity:0;pointer-events:none;position:absolute;top:0;left:0}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp{stroke:#979797;stroke-width:3px}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp path.GaugeChart-hitArea-2_3_6-ZemnC,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp path.GaugeChart-hitArea-2_3_6-ZemnC{stroke:transparent;stroke-width:15px;pointer-events:visiblestroke}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp:hover~.GaugeChart-medianTooltip-2_3_6-3dElY,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-median-2_3_6-soupp:hover~.GaugeChart-medianTooltip-2_3_6-3dElY{opacity:1!important;top:-5px;transition:all .3s}.GaugeChart-blueSteel-2_3_6-dYaIT.GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-value-2_3_6-2XeH4,.GaugeChart-blueSteel-2_3_6-dYaIT .GaugeChart-gaugeChart-2_3_6-2lh1A .GaugeChart-container-2_3_6-1Bb5_ .GaugeChart-value-2_3_6-2XeH4{height:30px;bottom:5px;position:absolute;font-size:26px;font-weight:700;text-align:center;color:#01050e}", ""]);

// exports
exports.locals = {
	"classic": "GaugeChart-classic-2_3_6-xsIAU",
	"gaugeChart": "GaugeChart-gaugeChart-2_3_6-2lh1A",
	"container": "GaugeChart-container-2_3_6-1Bb5_",
	"track": "GaugeChart-track-2_3_6-2q3zX",
	"gaugeGreat": "GaugeChart-gaugeGreat-2_3_6-1GyRA",
	"gaugeGood": "GaugeChart-gaugeGood-2_3_6-1rvAd",
	"gaugeAverage": "GaugeChart-gaugeAverage-2_3_6-2cWer",
	"gaugeLow": "GaugeChart-gaugeLow-2_3_6-2Q1M7",
	"gaugePoor": "GaugeChart-gaugePoor-2_3_6-1eTJm",
	"medianTooltip": "GaugeChart-medianTooltip-2_3_6-3dElY",
	"median": "GaugeChart-median-2_3_6-soupp",
	"hitArea": "GaugeChart-hitArea-2_3_6-ZemnC",
	"value": "GaugeChart-value-2_3_6-2XeH4",
	"blueSteel": "GaugeChart-blueSteel-2_3_6-dYaIT"
};

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _StatBox_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(690);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StatBox", function() { return _StatBox_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _StatBoxGroup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(697);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StatBoxGroup", function() { return _StatBoxGroup_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StatBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatTimelineValueDefaultFunc", function() { return formatTimelineValueDefaultFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatTimelineDateDefaultFunc", function() { return formatTimelineDateDefaultFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_testingExports", function() { return _testingExports; });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(54);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(64);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _ToolTip__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(198);
/* harmony import */ var _StatBoxTimelineChart__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(691);
/* harmony import */ var _StatBox_sass__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(694);
/* harmony import */ var _StatBox_sass__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_StatBox_sass__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _customPropTypeValidators__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(696);
/* harmony import */ var _StatBoxGroup__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(697);
















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












/**
 * A fixed-width value display for a statistic with the option to display a bar chart representing
 * values for particular number of days.
 *
 * The component has built in logic to decrease the font size of the value if it overflows. By default,
 * it will decrease the value in 2px increments until a minumum font size is reached, at which point
 * it will fallback to displaying ellipsis and wrapping the value in a `<ToolTip />`
 *
 */

function StatBox(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(DefaultGroupRenderer, props, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(ValueChangeNotifier, props, function (valueChangeNotifierProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(OverflowController, valueChangeNotifierProps, function (overflowControllerProps) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(StatBoxBase, overflowControllerProps);
    });
  }));
}
StatBox.propTypes = {
  /**
   * Note: Data will be passed through as is, so it should be normalized and/or localized by the calling application.
   * Optional array representing data for particular number of days where each
   * value = [non-negative number][y] listed in chronological order
   * non-negative number represents corresponding data value for a particular date or hour of the day
   * y is in string format and represents a `date` or `hour` or any other value
   * eg: timelineData = [[10,'2019-10-02'],[0,'2019-10-03'], [100,'2019-10-04'], [0,'2019-10-05']]
   * eg: timelineData = [[10,'1 AM'],[0,'2 AM'], [100,'3 AM'], [0,'4 AM']]
   * eg: timelineData = [[10,'Jan'],[0,'Feb']]
   * If this value is omitted a bar chart will not be displayed.
   */
  timelineData: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.array,

  /**
   * Optional classname applied to the StatBox container
   */
  className: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string,

  /**
   * Optional style object to apply to the StatBox container
   */
  style: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.object,

  /**
   * Optional font size (in pixels) to use for the value display,
   * must be >= the value of `minValueFontSizePx`
   */
  maxValueFontSizePx: _customPropTypeValidators__WEBPACK_IMPORTED_MODULE_24__["validateMaxValueFontSizePx"],

  /**
   * Optional minimum font size (in pixels)
   */
  minValueFontSizePx: _customPropTypeValidators__WEBPACK_IMPORTED_MODULE_24__["validateMinValueFontSizePx"],

  /**
   * Optional decrement px size to use when handling value overflow.
   * Must be a positive number
   */
  valueFontSizePxDecrement: _customPropTypeValidators__WEBPACK_IMPORTED_MODULE_24__["validateValueFontSizePxDecrement"],

  /**
   * String label for the stat
   */
  label: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string,

  /**
   * String formatted value for the stat
   */
  value: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string,

  /**
   * Optional fixed width override
   */
  widthPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number,

  /**
   * Optional formatting function (date => string) to use when displaying dates in the timeline ToolTips.
   */
  formatTimelineDate: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func,

  /**
   * Optional formatting function (number => string) to use when displaying values in the timeline ToolTips.
   */
  formatTimelineValue: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func,

  /**
   * Optional string to use for the timeline Tooltip components' "placement" prop values.
   */
  timelineToolTipPlacement: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string,

  /**
   * This prop is used by the StatBoxGroup component, you can ignore it
   * @ignore
   */
  onValueFontSizePxTooLarge: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func,

  /**
   * Optional fixed label font size override
   */
  labelFontPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string
};
StatBox.defaultProps = {
  timelineData: null,
  maxValueFontSizePx: 26,
  minValueFontSizePx: 20,
  valueFontSizePxDecrement: 2,
  onValueFontSizePxTooLarge: null,
  timelineToolTipPlacement: 'bottom',
  className: '',
  style: {},
  label: '',
  value: '',
  widthPx: 187,
  labelFontPx: 16,
  formatTimelineDate: formatTimelineDateDefaultFunc,
  formatTimelineValue: formatTimelineValueDefaultFunc
};
function formatTimelineValueDefaultFunc(value) {
  return value.toString();
}
function formatTimelineDateDefaultFunc(date) {
  return date;
}

function DefaultGroupRenderer(_ref) {
  var maxValueFontSizePx = _ref.maxValueFontSizePx,
      minValueFontSizePx = _ref.minValueFontSizePx,
      valueFontSizePxDecrement = _ref.valueFontSizePxDecrement,
      onValueFontSizePxTooLarge = _ref.onValueFontSizePxTooLarge,
      children = _ref.children,
      theme = _ref.theme;

  if (!onValueFontSizePxTooLarge) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(_StatBoxGroup__WEBPACK_IMPORTED_MODULE_25__["default"], _objectSpread({
      maxValueFontSizePx: maxValueFontSizePx,
      minValueFontSizePx: minValueFontSizePx,
      valueFontSizePxDecrement: valueFontSizePxDecrement,
      targetTypes: [ValueChangeNotifier, StatBox]
    }, theme && {
      theme: theme
    }), children);
  }

  return children;
}

DefaultGroupRenderer.propTypes = {
  maxValueFontSizePx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  minValueFontSizePx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  valueFontSizePxDecrement: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  onValueFontSizePxTooLarge: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func,
  children: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.any.isRequired
};
DefaultGroupRenderer.defaultProps = {
  onValueFontSizePxTooLarge: null
};

var ValueChangeNotifier = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(ValueChangeNotifier, _React$Component);

  var _super = _createSuper(ValueChangeNotifier);

  function ValueChangeNotifier() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, ValueChangeNotifier);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(ValueChangeNotifier, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.props.onValueChanged();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.props);
    }
  }]);

  return ValueChangeNotifier;
}(react__WEBPACK_IMPORTED_MODULE_18___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(ValueChangeNotifier, "propTypes", {
  value: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  children: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  onValueChanged: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func
});

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(ValueChangeNotifier, "defaultProps", {
  onValueChanged: null
});

var OverflowController = /*#__PURE__*/function (_React$Component2) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(OverflowController, _React$Component2);

  var _super2 = _createSuper(OverflowController);

  function OverflowController() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, OverflowController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this), "labelNode", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this), "valueNode", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this), "setValueNodeRef", function (element) {
      _this.valueNode = element;
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this), "setLabelNodeRef", function (element) {
      _this.labelNode = element;
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this), "state", {
      tooltipRequired: false,
      labelTooltipRequired: false
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(OverflowController, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handlePossibleOverflow(this.valueNode);
      this.handlePossibleOverflow(this.labelNode);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handlePossibleOverflow(this.valueNode);
      this.handlePossibleOverflow(this.labelNode);
    }
  }, {
    key: "handlePossibleOverflow",
    value: function handlePossibleOverflow(element) {
      var isLabelElement = element === this.labelNode;
      var labelTooltipRequired = this.state.labelTooltipRequired;
      var tooltipRequired = this.state.tooltipRequired;
      if (!element) return;

      if (element.offsetWidth < element.scrollWidth) {
        var _this$props = this.props,
            maxValueFontSizePx = _this$props.maxValueFontSizePx,
            minValueFontSizePx = _this$props.minValueFontSizePx,
            onValueFontSizePxTooLarge = _this$props.onValueFontSizePxTooLarge;

        if (!!onValueFontSizePxTooLarge && maxValueFontSizePx > minValueFontSizePx) {
          onValueFontSizePxTooLarge(maxValueFontSizePx);
        } else if (isLabelElement && !labelTooltipRequired) {
          this.setState({
            labelTooltipRequired: true
          });
        } else if (!isLabelElement && !tooltipRequired) {
          this.setState({
            tooltipRequired: true
          });
        }
      } else {
        if (isLabelElement && labelTooltipRequired) {
          this.setState({
            labelTooltipRequired: false
          });
        } else if (!isLabelElement && tooltipRequired) {
          this.setState({
            tooltipRequired: false
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          otherProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7___default()(_this$props2, ["children"]);

      return children(_objectSpread(_objectSpread({}, otherProps), {}, {
        tooltipRequired: this.state.tooltipRequired,
        labelTooltipRequired: this.state.labelTooltipRequired,
        setValueNodeRef: this.setValueNodeRef,
        setLabelNodeRef: this.setLabelNodeRef
      }));
    }
  }]);

  return OverflowController;
}(react__WEBPACK_IMPORTED_MODULE_18___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_14___default()(OverflowController, "propTypes", {
  onValueFontSizePxTooLarge: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func,
  minValueFontSizePx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  maxValueFontSizePx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  children: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired
});

function StatBoxBase(_ref2) {
  var className = _ref2.className,
      style = _ref2.style,
      maxValueFontSizePx = _ref2.maxValueFontSizePx,
      label = _ref2.label,
      value = _ref2.value,
      widthPx = _ref2.widthPx,
      timelineData = _ref2.timelineData,
      tooltipRequired = _ref2.tooltipRequired,
      labelTooltipRequired = _ref2.labelTooltipRequired,
      setValueNodeRef = _ref2.setValueNodeRef,
      setLabelNodeRef = _ref2.setLabelNodeRef,
      formatTimelineDate = _ref2.formatTimelineDate,
      formatTimelineValue = _ref2.formatTimelineValue,
      timelineToolTipPlacement = _ref2.timelineToolTipPlacement,
      labelFontPx = _ref2.labelFontPx,
      theme = _ref2.theme;
  var valueNode = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", {
    ref: setValueNodeRef,
    style: _objectSpread(_objectSpread({}, style), {}, {
      fontSize: maxValueFontSizePx
    }),
    className: _StatBox_sass__WEBPACK_IMPORTED_MODULE_23___default.a.value,
    tabIndex: "0"
  }, value);
  var labelNode = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", {
    ref: setLabelNodeRef,
    style: {
      fontSize: labelFontPx
    },
    className: _StatBox_sass__WEBPACK_IMPORTED_MODULE_23___default.a.label
  }, label);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", {
    style: {
      maxWidth: widthPx,
      width: widthPx
    },
    className: classnames__WEBPACK_IMPORTED_MODULE_20___default()(_StatBox_sass__WEBPACK_IMPORTED_MODULE_23___default.a[theme], className, _StatBox_sass__WEBPACK_IMPORTED_MODULE_23___default.a.statBox)
  }, labelTooltipRequired ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(_ToolTip__WEBPACK_IMPORTED_MODULE_21__["ToolTip"], {
    content: label
  }, labelNode) : labelNode, tooltipRequired ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(_ToolTip__WEBPACK_IMPORTED_MODULE_21__["ToolTip"], {
    content: value
  }, valueNode) : valueNode, timelineData && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(_StatBoxTimelineChart__WEBPACK_IMPORTED_MODULE_22__["default"], {
    timelineData: timelineData,
    label: label,
    formatTimelineDate: formatTimelineDate,
    formatTimelineValue: formatTimelineValue,
    timelineToolTipPlacement: timelineToolTipPlacement,
    theme: theme,
    className: _StatBox_sass__WEBPACK_IMPORTED_MODULE_23___default.a.timeline
  }));
}

StatBoxBase.propTypes = {
  timelineData: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.array,
  className: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  style: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.object.isRequired,
  maxValueFontSizePx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  minValueFontSizePx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  label: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  value: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  tooltipRequired: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.bool.isRequired,
  labelTooltipRequired: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.bool.isRequired,
  setValueNodeRef: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  setLabelNodeRef: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  widthPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  labelFontPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number,
  formatTimelineDate: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  formatTimelineValue: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired
};
StatBoxBase.defaultProps = {
  timelineData: null
};
var _testingExports = {
  components: {
    StatBoxBase: StatBoxBase,
    OverflowController: OverflowController,
    ValueChangeNotifier: ValueChangeNotifier,
    DefaultGroupRenderer: DefaultGroupRenderer
  }
};

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StatBoxTimelineChart; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(410);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var js_components_ToolTip__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(198);
/* harmony import */ var _StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(692);
/* harmony import */ var _StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_22__);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }















var barSpacingPx = 1;
/**
 * Timeline chart for the `<StatBox />` component
 */

function StatBoxTimelineChart(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(ChartMeasurementsProvider, props, function (chartMeasurementsProviderProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(StatBoxTimelineChartBase, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_8___default()({}, props, chartMeasurementsProviderProps));
  });
}
StatBoxTimelineChart.propTypes = {
  timelineData: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.array.isRequired,
  label: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  formatTimelineDate: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  formatTimelineValue: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  timelineToolTipPlacement: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  className: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string
};
StatBoxTimelineChart.defaultProps = {
  className: ''
};

function StatBoxTimelineChartBase(_ref) {
  var timelineData = _ref.timelineData,
      label = _ref.label,
      formatTimelineDate = _ref.formatTimelineDate,
      formatTimelineValue = _ref.formatTimelineValue,
      timelineToolTipPlacement = _ref.timelineToolTipPlacement,
      className = _ref.className,
      setContainerRef = _ref.setContainerRef,
      chartWidthPx = _ref.chartWidthPx,
      chartHeightPx = _ref.chartHeightPx,
      chartMeasurementsReady = _ref.chartMeasurementsReady,
      theme = _ref.theme;

  var renderBarsWrappedInToolTips = function renderBarsWrappedInToolTips() {
    var numberOfBars = timelineData.length;
    var numberOfSpaces = numberOfBars - 1;
    var barWidthPx = calculateBarWidthPx(chartWidthPx, numberOfBars, numberOfSpaces);
    var normalizedTimelineData = normalizeTimelineData({
      timelineData: timelineData,
      chartHeightPx: chartHeightPx
    }); // Returns a tooltip with data value and date when hovered over each bar in the bar chart

    return normalizedTimelineData.map(function (normalizedValue, i) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(js_components_ToolTip__WEBPACK_IMPORTED_MODULE_20__["ToolTip"], {
        key: "".concat(i, ": ").concat(normalizedValue, "}"),
        style: {
          marginRight: i === numberOfBars - 1 ? 0 : barSpacingPx
        },
        className: _StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21___default.a.barToolTipWrapper,
        placement: timelineToolTipPlacement,
        content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(ToolTipContent, {
          label: label,
          timelineData: timelineData,
          formatTimelineDate: formatTimelineDate,
          formatTimelineValue: formatTimelineValue,
          index: i
        })
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement(Bar, {
        chartHeightPx: chartHeightPx,
        heightPx: normalizedValue,
        widthPx: barWidthPx
      }));
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", {
    className: _StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21___default.a[theme]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", {
    ref: setContainerRef,
    className: classnames__WEBPACK_IMPORTED_MODULE_22___default()(_StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21___default.a.barChart, className)
  }, chartMeasurementsReady && renderBarsWrappedInToolTips()));
}

StatBoxTimelineChartBase.propTypes = {
  // external
  timelineData: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.array.isRequired,
  label: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  className: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  formatTimelineDate: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  formatTimelineValue: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  timelineToolTipPlacement: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  // ChartMeasurementsProvider
  setContainerRef: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  chartMeasurementsReady: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.bool.isRequired,
  chartWidthPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number,
  chartHeightPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number
};
StatBoxTimelineChartBase.defaultProps = {
  chartWidthPx: null,
  ChartHeightPx: null
};

function calculateBarWidthPx(chartWidthPx, numberOfBars, numberOfSpaces) {
  return (chartWidthPx - numberOfSpaces * barSpacingPx) / numberOfBars;
}

function normalizeTimelineData(_ref2) {
  var timelineData = _ref2.timelineData,
      chartHeightPx = _ref2.chartHeightPx;
  timelineData = timelineData.map(function (data) {
    return data[0];
  });
  var max = Math.max.apply(Math, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default()(timelineData));
  return timelineData.map(function (datum) {
    return max > 0 ? datum / max * chartHeightPx : 0;
  });
}

function Bar(_ref3) {
  var heightPx = _ref3.heightPx,
      widthPx = _ref3.widthPx,
      chartHeightPx = _ref3.chartHeightPx;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", {
    className: _StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21___default.a.bar,
    style: {
      width: widthPx,
      height: chartHeightPx
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", {
    className: _StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21___default.a.barFg,
    style: {
      height: heightPx
    }
  }));
}

Bar.propTypes = {
  heightPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  widthPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired,
  chartHeightPx: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired
};

function ToolTipContent(_ref4) {
  var label = _ref4.label,
      index = _ref4.index,
      timelineData = _ref4.timelineData,
      formatTimelineValue = _ref4.formatTimelineValue,
      formatTimelineDate = _ref4.formatTimelineDate;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", {
    className: _StatBoxTimelineChart_sass__WEBPACK_IMPORTED_MODULE_21___default.a.tooltipContent
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("span", null, formatTimelineDate(timelineData[index][1]))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("span", null, label, ":"), "\xA0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement("span", null, formatTimelineValue(timelineData[index][0]))));
}

ToolTipContent.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.string.isRequired,
  timelineData: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.array.isRequired,
  formatTimelineDate: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  formatTimelineValue: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired,
  index: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.number.isRequired
};

var ChartMeasurementsProvider = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(ChartMeasurementsProvider, _React$Component);

  var _super = _createSuper(ChartMeasurementsProvider);

  function ChartMeasurementsProvider() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ChartMeasurementsProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2___default()(_this), "state", {
      chartWidthPx: null,
      chartHeightPx: null
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2___default()(_this), "containerNode", null);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2___default()(_this), "setContainerRef", function (element) {
      _this.containerNode = element;
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ChartMeasurementsProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.measureChart();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.measureChart();
    }
  }, {
    key: "measureChart",
    value: function measureChart() {
      var node = this.containerNode;
      if (!node) return;

      var _window$getComputedSt = window.getComputedStyle(node),
          width = _window$getComputedSt.width,
          height = _window$getComputedSt.height;

      var chartWidthPx = parseFloat(width) || 0;
      var chartHeightPx = parseFloat(height) || 0;

      if (chartHeightPx !== this.state.chartHeightPx || chartWidthPx !== this.state.chartWidthPx) {
        this.setState({
          chartWidthPx: chartWidthPx,
          chartHeightPx: chartHeightPx
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(_objectSpread(_objectSpread({
        setContainerRef: this.setContainerRef
      }, this.state), {}, {
        chartMeasurementsReady: this.state.chartWidthPx !== null
      }));
    }
  }]);

  return ChartMeasurementsProvider;
}(react__WEBPACK_IMPORTED_MODULE_18___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(ChartMeasurementsProvider, "propTypes", {
  children: prop_types__WEBPACK_IMPORTED_MODULE_19___default.a.func.isRequired
});

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(693);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".StatBoxTimelineChart-classic-2_3_6-2bysP a{color:#079bb3}.StatBoxTimelineChart-classic-2_3_6-2bysP .StatBoxTimelineChart-barChart-2_3_6-1R35a{height:25px;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start}.StatBoxTimelineChart-classic-2_3_6-2bysP .StatBoxTimelineChart-barChart-2_3_6-1R35a .StatBoxTimelineChart-bar-2_3_6-2Xvbm{height:25px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:end;justify-content:flex-end;border-bottom:1px solid #999;box-sizing:content-box}.StatBoxTimelineChart-classic-2_3_6-2bysP .StatBoxTimelineChart-barChart-2_3_6-1R35a .StatBoxTimelineChart-bar-2_3_6-2Xvbm:hover{background:#999}.StatBoxTimelineChart-classic-2_3_6-2bysP .StatBoxTimelineChart-barChart-2_3_6-1R35a .StatBoxTimelineChart-bar-2_3_6-2Xvbm .StatBoxTimelineChart-barFg-2_3_6-JqWcP{background-color:#079bb3}.StatBoxTimelineChart-blueSteel-2_3_6-1Rz6B a{color:#08088c}.StatBoxTimelineChart-blueSteel-2_3_6-1Rz6B .StatBoxTimelineChart-barChart-2_3_6-1R35a{height:25px;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start}.StatBoxTimelineChart-blueSteel-2_3_6-1Rz6B .StatBoxTimelineChart-barChart-2_3_6-1R35a .StatBoxTimelineChart-bar-2_3_6-2Xvbm{height:25px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:end;justify-content:flex-end;border-bottom:1px solid #8e9093;box-sizing:content-box}.StatBoxTimelineChart-blueSteel-2_3_6-1Rz6B .StatBoxTimelineChart-barChart-2_3_6-1R35a .StatBoxTimelineChart-bar-2_3_6-2Xvbm:hover{background:#8e9093}.StatBoxTimelineChart-blueSteel-2_3_6-1Rz6B .StatBoxTimelineChart-barChart-2_3_6-1R35a .StatBoxTimelineChart-bar-2_3_6-2Xvbm .StatBoxTimelineChart-barFg-2_3_6-JqWcP{background-color:#08088c}", ""]);

// exports
exports.locals = {
	"classic": "StatBoxTimelineChart-classic-2_3_6-2bysP",
	"barChart": "StatBoxTimelineChart-barChart-2_3_6-1R35a",
	"bar": "StatBoxTimelineChart-bar-2_3_6-2Xvbm",
	"barFg": "StatBoxTimelineChart-barFg-2_3_6-JqWcP",
	"blueSteel": "StatBoxTimelineChart-blueSteel-2_3_6-1Rz6B"
};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(695);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".StatBox-classic-2_3_6-2o-bV a{color:#079bb3}.StatBox-classic-2_3_6-2o-bV.StatBox-statBox-2_3_6-1vhj5,.StatBox-classic-2_3_6-2o-bV .StatBox-statBox-2_3_6-1vhj5{padding:10px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;-ms-flex-pack:start;justify-content:flex-start;background:#f8f8f8;border-radius:6px}.StatBox-classic-2_3_6-2o-bV.StatBox-statBox-2_3_6-1vhj5 .StatBox-label-2_3_6-2wWVo,.StatBox-classic-2_3_6-2o-bV .StatBox-statBox-2_3_6-1vhj5 .StatBox-label-2_3_6-2wWVo{font-weight:700;text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.StatBox-classic-2_3_6-2o-bV.StatBox-statBox-2_3_6-1vhj5 .StatBox-value-2_3_6-1KGyX,.StatBox-classic-2_3_6-2o-bV .StatBox-statBox-2_3_6-1vhj5 .StatBox-value-2_3_6-1KGyX{text-align:center;margin-top:6px;font-weight:900;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.StatBox-classic-2_3_6-2o-bV.StatBox-statBox-2_3_6-1vhj5 .StatBox-timeline-2_3_6-2Ee_-,.StatBox-classic-2_3_6-2o-bV .StatBox-statBox-2_3_6-1vhj5 .StatBox-timeline-2_3_6-2Ee_-{margin-top:6px}.StatBox-blueSteel-2_3_6-3WWA9 a{color:#08088c}.StatBox-blueSteel-2_3_6-3WWA9 .StatBox-statBox-2_3_6-1vhj5,.StatBox-blueSteel-2_3_6-3WWA9.StatBox-statBox-2_3_6-1vhj5{padding:10px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;-ms-flex-pack:start;justify-content:flex-start;background:#f8f8f8;border-radius:6px}.StatBox-blueSteel-2_3_6-3WWA9 .StatBox-statBox-2_3_6-1vhj5 .StatBox-label-2_3_6-2wWVo,.StatBox-blueSteel-2_3_6-3WWA9.StatBox-statBox-2_3_6-1vhj5 .StatBox-label-2_3_6-2wWVo{font-weight:700;text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.StatBox-blueSteel-2_3_6-3WWA9 .StatBox-statBox-2_3_6-1vhj5 .StatBox-value-2_3_6-1KGyX,.StatBox-blueSteel-2_3_6-3WWA9.StatBox-statBox-2_3_6-1vhj5 .StatBox-value-2_3_6-1KGyX{text-align:center;margin-top:6px;font-weight:900;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.StatBox-blueSteel-2_3_6-3WWA9 .StatBox-statBox-2_3_6-1vhj5 .StatBox-timeline-2_3_6-2Ee_-,.StatBox-blueSteel-2_3_6-3WWA9.StatBox-statBox-2_3_6-1vhj5 .StatBox-timeline-2_3_6-2Ee_-{margin-top:6px}", ""]);

// exports
exports.locals = {
	"classic": "StatBox-classic-2_3_6-2o-bV",
	"statBox": "StatBox-statBox-2_3_6-1vhj5",
	"label": "StatBox-label-2_3_6-2wWVo",
	"value": "StatBox-value-2_3_6-1KGyX",
	"timeline": "StatBox-timeline-2_3_6-2Ee_-",
	"blueSteel": "StatBox-blueSteel-2_3_6-3WWA9"
};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateMaxValueFontSizePx", function() { return validateMaxValueFontSizePx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateMinValueFontSizePx", function() { return validateMinValueFontSizePx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateValueFontSizePxDecrement", function() { return validateValueFontSizePxDecrement; });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


function validateMaxValueFontSizePx(props, propName, componentName) {
  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.apply(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a, [props, propName, componentName].concat(rest));

  if (props[propName] <= 0) {
    return new Error("".concat(invalidPropPrefix({
      propName: propName,
      componentName: componentName
    }), " The value of \"").concat(propName, "\" must be > 0. Received ").concat(props[propName], "."));
  }

  if (props[propName] < props.minValueFontSizePx) {
    return new Error("".concat(invalidPropPrefix({
      propName: propName,
      componentName: componentName
    }), " The value of \"").concat(propName, "\" must be >= to the value of \"minValueFontSizePx\" (").concat(props.minValueFontSizePx, "). Received ").concat(props[propName], "."));
  }

  return null;
}
function validateMinValueFontSizePx(props, propName, componentName) {
  for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    rest[_key2 - 3] = arguments[_key2];
  }

  prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.apply(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a, [props, propName, componentName].concat(rest));

  if (props[propName] <= 0) {
    return new Error("".concat(invalidPropPrefix({
      propName: propName,
      componentName: componentName
    }), " The value of \"").concat(propName, "\" must be > 0. Received ").concat(props[propName], "."));
  }

  if (props[propName] > props.maxValueFontSizePx) {
    return new Error("".concat(invalidPropPrefix({
      propName: propName,
      componentName: componentName
    }), " The value of \"").concat(propName, "\" must be <= to the value of \"maxValueFontSizePx\" (").concat(props.maxValueFontSizePx, "). Received ").concat(props[propName], "."));
  }

  return null;
}
function validateValueFontSizePxDecrement(props, propName, componentName) {
  for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    rest[_key3 - 3] = arguments[_key3];
  }

  prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.apply(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a, [props, propName, componentName].concat(rest));

  if (props[propName] < 0) {
    return new Error("".concat(invalidPropPrefix({
      propName: propName,
      componentName: componentName
    }), " The value of \"").concat(propName, "\" must be > 0. Received ").concat(props[propName], "."));
  }

  return null;
}

function invalidPropPrefix(_ref) {
  var propName = _ref.propName,
      componentName = _ref.componentName;
  return "Invalid prop \"".concat(propName, "\" supplied to ").concat(componentName, ".");
}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StatBoxGroup", function() { return StatBoxGroup; });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(180);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(197);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(117);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(122);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _StatBox__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(690);
/* harmony import */ var _customPropTypeValidators__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(696);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(155);













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






/**
 * A React fragment, containing any number of StatBox components, which keeps their font sizes
 * in sync.
 */

var StatBoxGroup = /*#__PURE__*/function (_React$Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(StatBoxGroup, _React$Component);

  var _super = _createSuper(StatBoxGroup);

  function StatBoxGroup() {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, StatBoxGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "state", {
      valueFontSizePx: _this.props.maxValueFontSizePx
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "handleStatBoxValueChange", function () {
      _this.setState({
        valueFontSizePx: _this.props.maxValueFontSizePx
      });
    });

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3___default()(_this), "handleValueFontSizePxTooLarge", function (childsCurrentValueFontSizePx) {
      var valueFontSizePx = _this.state.valueFontSizePx;
      var _this$props = _this.props,
          minValueFontSizePx = _this$props.minValueFontSizePx,
          valueFontSizePxDecrement = _this$props.valueFontSizePxDecrement;

      if (childsCurrentValueFontSizePx === valueFontSizePx) {
        _this.setState({
          valueFontSizePx: Math.max(valueFontSizePx - valueFontSizePxDecrement, minValueFontSizePx)
        });
      }
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(StatBoxGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.minValueFontSizePx !== this.props.minValueFontSizePx || prevProps.maxValueFontSizePx !== this.props.maxValueFontSizePx || prevProps.valueFontSizePxDecrement !== this.props.valueFontSizePxDecrement) {
        this.setState({
          valueFontSizePx: prevProps.maxValueFontSizePx
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          minValueFontSizePx = _this$props2.minValueFontSizePx,
          valueFontSizePxDecrement = _this$props2.valueFontSizePxDecrement,
          targetTypes = _this$props2.targetTypes,
          theme = _this$props2.theme;
      var valueFontSizePx = this.state.valueFontSizePx;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_12___default.a.Fragment, null, react__WEBPACK_IMPORTED_MODULE_12___default.a.Children.map(children, function (child) {
        if (!targetTypes.includes(child.type)) return child;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_12___default.a.cloneElement(child, {
          valueFontSizePxDecrement: valueFontSizePxDecrement,
          minValueFontSizePx: minValueFontSizePx,
          maxValueFontSizePx: valueFontSizePx,
          onValueChanged: _this2.handleStatBoxValueChange,
          onValueFontSizePxTooLarge: _this2.handleValueFontSizePxTooLarge,
          theme: theme
        });
      }));
    }
  }]);

  return StatBoxGroup;
}(react__WEBPACK_IMPORTED_MODULE_12___default.a.Component);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(StatBoxGroup, "propTypes", {
  /**
   * Optional font size (in pixels) to use for the value display,
   * must be >= the value of `minValueFontSizePx`.
   */
  maxValueFontSizePx: _customPropTypeValidators__WEBPACK_IMPORTED_MODULE_15__["validateMaxValueFontSizePx"],

  /** Optional minimum font size (in pixels). */
  minValueFontSizePx: _customPropTypeValidators__WEBPACK_IMPORTED_MODULE_15__["validateMinValueFontSizePx"],

  /** Optional decrement px size to use when handling value overflow. Must be a positive number. */
  valueFontSizePxDecrement: _customPropTypeValidators__WEBPACK_IMPORTED_MODULE_15__["validateValueFontSizePxDecrement"],

  /* StatBox components */
  children: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.any.isRequired,

  /**
   * This prop should be ignored most of the time.
   * If you'd like to wrap a child StatBox in another component for some reason, then you can add the
   * wrapping component to the targetTypes array so that the StatBoxGroup knows to inject its custom props into
   * the wrapping component
   */
  targetTypes: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.array,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_13___default.a.string
});

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(StatBoxGroup, "defaultProps", {
  maxValueFontSizePx: 26,
  minValueFontSizePx: 20,
  valueFontSizePxDecrement: 2,
  targetTypes: [_StatBox__WEBPACK_IMPORTED_MODULE_14__["default"]]
});

/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_16__["provideTheme"])()(StatBoxGroup));

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ImageUpload__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(699);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageUpload", function() { return _ImageUpload__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _PlainImageUpload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(700);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PlainImageUpload", function() { return _PlainImageUpload__WEBPACK_IMPORTED_MODULE_1__["default"]; });






/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(237);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(155);
/* harmony import */ var _InputGroup__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(249);
/* harmony import */ var _PlainImageUpload__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(700);
/* harmony import */ var _Autosave_AutosaveLoader__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(264);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














/**
 * Allows users to input an image file.
 *
 * The component will take up 100% of the
 * width of its container and take the shape of a rectangle with the given aspect
 * ratio.
 *
 * Some common aspect ratios are provided as constants attached to the component:
 *
 * - 16:9 `PlainImageUpload.SIXTEEN_NINE`
 * - 4:3 `PlainImageUpload.FOUR_THREE`
 * - 2:3 (portrait) `PlainImageUpload.TWO_THREE`
 *
 * The following formula can be used to create a custom aspect ratio number:
 * `aspectRatio = height / width * 100`
 */

var ImageUpload = function ImageUpload(_ref) {
  var asAutosave = _ref.asAutosave,
      className = _ref.className,
      description = _ref.description,
      error = _ref.error,
      label = _ref.label,
      spinner = _ref.spinner,
      style = _ref.style,
      testName = _ref.testName,
      theme = _ref.theme,
      plainImageUploadProps = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default()(_ref, ["asAutosave", "className", "description", "error", "label", "spinner", "style", "testName", "theme"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_11__["useState"])(Boolean(spinner)),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_useState, 2),
      hasHadLoader = _useState2[0],
      setHadLoader = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_11__["useEffect"])(function () {
    if (spinner) {
      setHadLoader(true);
    }
  }, [spinner]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(_InputGroup__WEBPACK_IMPORTED_MODULE_14__["InputGroup"], {
    asAutosave: asAutosave,
    className: className,
    description: description,
    error: error,
    label: label,
    style: style,
    testName: testName,
    theme: theme,
    contentRight: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(_Autosave_AutosaveLoader__WEBPACK_IMPORTED_MODULE_16__["default"], {
      isSaving: spinner,
      isSaved: !spinner && hasHadLoader
    })
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(_PlainImageUpload__WEBPACK_IMPORTED_MODULE_15__["default"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default()({
    hasError: Boolean(error),
    theme: theme
  }, plainImageUploadProps)));
};

ImageUpload.propTypes = _objectSpread({
  /**
   * Whether the component is being used within an Autosave context. This
   * ensures the <label> is encapsulated separately from other clickable actions
   */
  asAutosave: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.bool,

  /** Apply a custom class to the outermost element. */
  className: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.string,

  /** Hint text to be rendered in parentheses beside the label */
  description: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.node,

  /** An error message to be rendered beneath the field. */
  error: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.node,

  /** Label text. */
  label: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.node,

  /**
   * Adds an AutosaveLoader to the input group. Saving and IsSaved states are
   * handled internally by the ImageUpload component.
   */
  spinner: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.bool,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.string,

  /** A theme name to apply on this component */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_12___default.a.string
}, _PlainImageUpload__WEBPACK_IMPORTED_MODULE_15__["default"].propTypes);
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_13__["provideTheme"])({})(ImageUpload));

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(155);
/* harmony import */ var _FileInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(678);
/* harmony import */ var _AspectRatio__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(701);
/* harmony import */ var _ContentUpload__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(704);
/* harmony import */ var _EmptyUpload__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(707);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(702);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7__);









var ImageUpload = function ImageUpload(_ref) {
  var className = _ref.className,
      testName = _ref.testName,
      style = _ref.style,
      theme = _ref.theme,
      onChange = _ref.onChange,
      onRemove = _ref.onRemove,
      actionText = _ref.actionText,
      hasError = _ref.hasError,
      accept = _ref.accept,
      value = _ref.value,
      aspectRatio = _ref.aspectRatio;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_AspectRatio__WEBPACK_IMPORTED_MODULE_4__["default"], {
    className: className,
    style: style,
    testName: testName,
    aspectRatio: aspectRatio
  }, value ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ContentUpload__WEBPACK_IMPORTED_MODULE_5__["default"], {
    onChange: onChange,
    onRemove: onRemove,
    hasError: hasError,
    accept: accept,
    image: value,
    theme: theme
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_EmptyUpload__WEBPACK_IMPORTED_MODULE_6__["default"], {
    onChange: onChange,
    hasError: hasError,
    accept: accept,
    actionText: actionText,
    theme: theme
  }));
};

ImageUpload.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  onRemove: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  actionText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  accept: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** src to use for image preview */
  value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Aspect ratio of the component */
  aspectRatio: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
};
var ThemedComponent = Object(_Theme__WEBPACK_IMPORTED_MODULE_2__["provideTheme"])(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7___default.a)(ImageUpload);
ThemedComponent.SIXTEEN_NINE = 9 / 16 * 100;
ThemedComponent.FOUR_THREE = 3 / 4 * 100;
ThemedComponent.TWO_THREE = 3 / 2 * 100;
ImageUpload.defaultProps = {
  accept: _FileInput__WEBPACK_IMPORTED_MODULE_3__["FileInput"].IMAGE,
  aspectRatio: ThemedComponent.SIXTEEN_NINE
};
/* harmony default export */ __webpack_exports__["default"] = (ThemedComponent);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(702);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_10__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var AspectRatio = function AspectRatio(_ref) {
  var className = _ref.className,
      style = _ref.style,
      testName = _ref.testName,
      aspectRatio = _ref.aspectRatio,
      children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_10___default.a.aspectRatioOutside, className),
    style: _objectSpread({
      paddingTop: "".concat(aspectRatio, "%")
    }, style),
    "data-test-name": testName
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
    className: _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_10___default.a.aspectRatioInside
  }, children));
};

AspectRatio.propTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
  style: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
  testName: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.node,
  aspectRatio: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.number.isRequired
};
AspectRatio.defaultProps = {
  style: {}
};
/* harmony default export */ __webpack_exports__["default"] = (AspectRatio);

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(703);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".ImageUpload-aspectRatioOutside-2_3_6-266-g{position:relative;height:0;overflow:hidden}.ImageUpload-aspectRatioInside-2_3_6-1DN67{position:absolute;top:0;bottom:0;left:0;right:0;width:100%;height:100%}.ImageUpload-contentControls-2_3_6-2AOAC{position:absolute;top:.6666666667rem;left:.6666666667rem;display:-ms-flexbox;display:flex}.ImageUpload-classic-2_3_6-27vCZ a{color:#079bb3}.ImageUpload-classic-2_3_6-27vCZ.ImageUpload-container-2_3_6-38f9V{display:block;position:relative;width:100%;height:100%;border:1px solid #777;color:#079bb3;transition:border .2s cubic-bezier(.77,0,.18,1),background-color .2s cubic-bezier(.77,0,.18,1)}.ImageUpload-classic-2_3_6-27vCZ.ImageUpload-container-2_3_6-38f9V.ImageUpload-pointer-2_3_6-1S3gH{cursor:pointer}.ImageUpload-classic-2_3_6-27vCZ.ImageUpload-container-2_3_6-38f9V.ImageUpload-pointer-2_3_6-1S3gH:hover{border:1px solid #999;background-color:#d7dbea}.ImageUpload-classic-2_3_6-27vCZ.ImageUpload-container-2_3_6-38f9V.ImageUpload-error-2_3_6--RH75{border:2px solid #ba2453}.ImageUpload-classic-2_3_6-27vCZ .ImageUpload-actionText-2_3_6-3N7-r{height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-weight:700;font-size:.9333333333rem;letter-spacing:-.22px}.ImageUpload-classic-2_3_6-27vCZ .ImageUpload-preview-2_3_6-1tngD{position:absolute;top:0;bottom:0;left:0;right:0;background-color:transparent;background-position:50%;background-size:contain;background-repeat:no-repeat}.ImageUpload-classic-2_3_6-27vCZ.ImageUpload-contentButton-2_3_6-wmqhB,.ImageUpload-classic-2_3_6-27vCZ .ImageUpload-contentButton-2_3_6-wmqhB{width:2em;height:2em;margin-right:.6666666667rem;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#079bb3;color:#fff;border-radius:1px;cursor:pointer;transition:background-color .2s cubic-bezier(.77,0,.18,1)}.ImageUpload-classic-2_3_6-27vCZ.ImageUpload-contentButton-2_3_6-wmqhB.ImageUpload-danger-2_3_6-1Nsz2,.ImageUpload-classic-2_3_6-27vCZ .ImageUpload-contentButton-2_3_6-wmqhB.ImageUpload-danger-2_3_6-1Nsz2{color:#d32781;background-color:#a2b00c}@media screen and (min-width:640px){.ImageUpload-classic-2_3_6-27vCZ.ImageUpload-contentButton-2_3_6-wmqhB,.ImageUpload-classic-2_3_6-27vCZ .ImageUpload-contentButton-2_3_6-wmqhB{width:1.5em;height:1.5em;margin-right:.3333333333rem}}.ImageUpload-blueSteel-2_3_6-2Fzj2 a{color:#08088c}.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-container-2_3_6-38f9V{display:block;position:relative;width:100%;height:100%;border:1px solid #8e9093;background-color:#f2f4f9;color:#08088c;transition:border .2s cubic-bezier(.77,0,.18,1),background-color .2s cubic-bezier(.77,0,.18,1)}.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-container-2_3_6-38f9V.ImageUpload-pointer-2_3_6-1S3gH{cursor:pointer}.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-container-2_3_6-38f9V.ImageUpload-pointer-2_3_6-1S3gH:hover{border:1px solid #4d5056;background-color:#d7dbea}.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-container-2_3_6-38f9V.ImageUpload-error-2_3_6--RH75{border:2px solid #d33d00}.ImageUpload-blueSteel-2_3_6-2Fzj2 .ImageUpload-actionText-2_3_6-3N7-r{height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;font-weight:700;font-size:.9333333333rem;letter-spacing:-.22px}.ImageUpload-blueSteel-2_3_6-2Fzj2 .ImageUpload-preview-2_3_6-1tngD{position:absolute;top:0;bottom:0;left:0;right:0;background-color:transparent;background-position:50%;background-size:contain;background-repeat:no-repeat}.ImageUpload-blueSteel-2_3_6-2Fzj2 .ImageUpload-contentButton-2_3_6-wmqhB,.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-contentButton-2_3_6-wmqhB{width:2em;height:2em;margin-right:.6666666667rem;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#08088c;color:#fff;border-radius:1px;cursor:pointer;transition:background-color .2s cubic-bezier(.77,0,.18,1)}.ImageUpload-blueSteel-2_3_6-2Fzj2 .ImageUpload-contentButton-2_3_6-wmqhB:hover,.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-contentButton-2_3_6-wmqhB:hover{background-color:#092dbd}.ImageUpload-blueSteel-2_3_6-2Fzj2 .ImageUpload-contentButton-2_3_6-wmqhB.ImageUpload-danger-2_3_6-1Nsz2,.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-contentButton-2_3_6-wmqhB.ImageUpload-danger-2_3_6-1Nsz2{color:#d33d00;background-color:#fff}.ImageUpload-blueSteel-2_3_6-2Fzj2 .ImageUpload-contentButton-2_3_6-wmqhB.ImageUpload-danger-2_3_6-1Nsz2:hover,.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-contentButton-2_3_6-wmqhB.ImageUpload-danger-2_3_6-1Nsz2:hover{background-color:#fdf6f3}@media screen and (min-width:640px){.ImageUpload-blueSteel-2_3_6-2Fzj2 .ImageUpload-contentButton-2_3_6-wmqhB,.ImageUpload-blueSteel-2_3_6-2Fzj2.ImageUpload-contentButton-2_3_6-wmqhB{width:1.5em;height:1.5em;margin-right:.3333333333rem}}", ""]);

// exports
exports.locals = {
	"aspectRatioOutside": "ImageUpload-aspectRatioOutside-2_3_6-266-g",
	"aspectRatioInside": "ImageUpload-aspectRatioInside-2_3_6-1DN67",
	"contentControls": "ImageUpload-contentControls-2_3_6-2AOAC",
	"classic": "ImageUpload-classic-2_3_6-27vCZ",
	"container": "ImageUpload-container-2_3_6-38f9V",
	"pointer": "ImageUpload-pointer-2_3_6-1S3gH",
	"error": "ImageUpload-error-2_3_6--RH75",
	"actionText": "ImageUpload-actionText-2_3_6-3N7-r",
	"preview": "ImageUpload-preview-2_3_6-1tngD",
	"contentButton": "ImageUpload-contentButton-2_3_6-wmqhB",
	"danger": "ImageUpload-danger-2_3_6-1Nsz2",
	"blueSteel": "ImageUpload-blueSteel-2_3_6-2Fzj2"
};

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(216);
/* harmony import */ var _Target__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(530);
/* harmony import */ var _imageLib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(705);
/* harmony import */ var _UploadButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(706);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(702);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8__);










var ContentUpload = function ContentUpload(_ref) {
  var onChange = _ref.onChange,
      onRemove = _ref.onRemove,
      hasError = _ref.hasError,
      accept = _ref.accept,
      image = _ref.image,
      theme = _ref.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default.a[theme], _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default.a.container, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default.a.error, hasError)),
    onDrop: function onDrop(event) {
      return Object(_imageLib__WEBPACK_IMPORTED_MODULE_6__["handleDrop"])(event, onChange);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default.a.preview,
    style: {
      backgroundImage: "url(".concat(image, ")")
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default.a.contentControls
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_UploadButton__WEBPACK_IMPORTED_MODULE_7__["default"], {
    onChange: onChange,
    accept: accept,
    theme: theme
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("a", {
    className: _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default.a.contentButton,
    href: image,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_4__["Icon"], {
    name: _Icon__WEBPACK_IMPORTED_MODULE_4__["ICONS"].EYE
  })), image && onRemove ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Target__WEBPACK_IMPORTED_MODULE_5__["Target"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default.a.contentButton, _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_8___default.a.danger),
    onClick: onRemove
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_4__["Icon"], {
    name: _Icon__WEBPACK_IMPORTED_MODULE_4__["ICONS"].TRASHCAN
  })) : null));
};

ContentUpload.propTypes = {
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired,
  onRemove: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  accept: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  image: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string.isRequired,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (ContentUpload);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isImage", function() { return isImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleDrop", function() { return handleDrop; });
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);


var isImage = function isImage(file) {
  return Boolean(file && file.type.match('image.*'));
};
var handleDrop = function handleDrop(event, onChange) {
  var file = event.dataTransfer.files[0];

  if (isImage(file)) {
    onChange(file, event);
  }
};

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(216);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(702);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_5__);






var uniqueId = 0;

var UploadButton = function UploadButton(_ref) {
  var onChange = _ref.onChange,
      accept = _ref.accept,
      theme = _ref.theme;
  var componentId = "imageUpload-".concat(uniqueId++, "-button");
  var inputRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])();

  var handleChange = function handleChange(event) {
    onChange(event.target.files[0], event);
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.currentTarget === event.target) {
      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_3__["default"])(event).is('enter space')) {
        event.preventDefault();
        inputRef.current.click();
      }
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_5___default.a[theme], _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_5___default.a.contentButton),
    htmlFor: componentId,
    tabIndex: 1,
    onKeyDown: handleKeyPress,
    "aria-label": "Select an image to upload"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", {
    hidden: true,
    type: "file",
    id: componentId,
    onInput: handleChange,
    accept: accept,
    ref: inputRef
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_4__["Icon"], {
    name: _Icon__WEBPACK_IMPORTED_MODULE_4__["ICONS"].UPLOAD
  }));
};

UploadButton.propTypes = {
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  accept: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (UploadButton);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var js_util_keycode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(216);
/* harmony import */ var _imageLib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(705);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(702);
/* harmony import */ var _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7__);








var uniqueId = 0;

var EmptyUpload = function EmptyUpload(_ref) {
  var onChange = _ref.onChange,
      theme = _ref.theme,
      hasError = _ref.hasError,
      accept = _ref.accept,
      actionText = _ref.actionText;
  var componentId = "imageUpload-".concat(uniqueId++, "-empty");
  var inputRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])();

  var handleChange = function handleChange(event) {
    onChange(event.target.files[0], event);
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.currentTarget === event.target) {
      if (Object(js_util_keycode__WEBPACK_IMPORTED_MODULE_4__["default"])(event).is('enter space')) {
        event.preventDefault();
        inputRef.current.click();
      }
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(_ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7___default.a[theme], _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7___default.a.container, _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7___default.a.pointer, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7___default.a.error, hasError)),
    htmlFor: componentId,
    tabIndex: 1,
    onKeyDown: handleKeyPress,
    onDrop: function onDrop(event) {
      return Object(_imageLib__WEBPACK_IMPORTED_MODULE_6__["handleDrop"])(event, onChange);
    },
    "aria-label": "Select an image to upload"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("input", {
    hidden: true,
    type: "file",
    id: componentId,
    onInput: handleChange,
    accept: accept,
    ref: inputRef
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
    className: _ImageUpload_sass__WEBPACK_IMPORTED_MODULE_7___default.a.actionText
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Icon__WEBPACK_IMPORTED_MODULE_5__["Icon"], {
    padRight: true,
    name: _Icon__WEBPACK_IMPORTED_MODULE_5__["ICONS"].UPLOAD
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", null, actionText)));
};

EmptyUpload.propTypes = {
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func.isRequired,
  hasError: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  accept: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  actionText: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  theme: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (EmptyUpload);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TileSelector__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(709);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileSelector", function() { return _TileSelector__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TileSelector", function() { return TileSelector; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(147);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(163);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);
/* harmony import */ var _Target__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(530);
/* harmony import */ var _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(710);
/* harmony import */ var _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_TileSelector_sass__WEBPACK_IMPORTED_MODULE_9__);










/**
  Select a item that looks like a Tile in a group of Tiles.
*/

function TileSelector(_ref) {
  var _cx;

  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      disabled = _ref.disabled,
      active = _ref.active,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      className = _ref.className,
      style = _ref.style,
      testName = _ref.testName;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_4__["useState"])(false),
      _useState2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_useState, 2),
      isTileSelectorFocused = _useState2[0],
      setIsTileSelectorFocused = _useState2[1];

  var handleClick = !disabled ? onClick : null;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_6___default()(_TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a.menuItem, className, (_cx = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a.disabled, disabled), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a.active, active), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_cx, _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a.isTileSelectorFocused, isTileSelectorFocused), _cx));

  var handleTileSelectorFocus = function handleTileSelectorFocus(evt) {
    setIsTileSelectorFocused(true);
    if (onFocus) return onFocus(evt);
  };

  var handleTileSelectorBlur = function handleTileSelectorBlur() {
    setIsTileSelectorFocused(false);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
    className: classes,
    style: style,
    "data-test-name": testName,
    onFocus: handleTileSelectorFocus,
    onBlur: handleTileSelectorBlur,
    tabIndex: 1
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement(_Target__WEBPACK_IMPORTED_MODULE_8__["Target"], {
    onClick: handleClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
    className: _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a.itemMediaObject
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
    className: _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a.media
  }, children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("div", {
    className: _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a.itemText
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("h4", {
    className: _TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a.itemTitle
  }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement("p", null, description)))));
}
TileSelector.propTypes = {
  /** Title for the tile Tile Selector */
  title: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Description for the Tile Selector */
  description: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Whether or not to disable the Tile Selector */
  disabled: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** Checks weather the tile selectetor is selected */
  active: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.bool,

  /** Click function that triggers tile selector */
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func,

  /** onFocus function that triggers if is focused */
  onFocus: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.func,

  /** Component contents */
  children: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.node,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string,

  /** A theme name to apply on this component  */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_5___default.a.string
};
/* harmony default export */ __webpack_exports__["default"] = (Object(_Theme__WEBPACK_IMPORTED_MODULE_7__["provideTheme"])(_TileSelector_sass__WEBPACK_IMPORTED_MODULE_9___default.a)(TileSelector));

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(711);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".TileSelector-classic-2_3_6-2d5mF a{color:#079bb3}.TileSelector-blueSteel-2_3_6-1CJ3p a{color:#08088c}.TileSelector-disabled-2_3_6-3EC7i,.TileSelector-itemContainer-2_3_6-1gmbe,.TileSelector-menuItem-2_3_6-3yr7e{height:auto;width:100%;border:1px solid #e5e6e6;border-radius:1px;padding:16px;background-color:#fff;transition:background-color .3s cubic-bezier(.77,0,.18,1),border-color .3s cubic-bezier(.77,0,.18,1)}.TileSelector-menuItem-2_3_6-3yr7e:hover:not(.TileSelector-active-2_3_6-JOuWw):not(.TileSelector-isTileSelectorFocused-2_3_6-dd7QZ):not(.TileSelector-disabled-2_3_6-3EC7i){border:1px solid #8e9093}.TileSelector-menuItem-2_3_6-3yr7e .TileSelector-itemMediaObject-2_3_6-2-Xom{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.TileSelector-menuItem-2_3_6-3yr7e .TileSelector-itemMediaObject-2_3_6-2-Xom .TileSelector-media-2_3_6-13exn>svg{width:48px;height:48px;min-width:48px;margin-right:16px;border-radius:1px;opacity:unset}.TileSelector-menuItem-2_3_6-3yr7e .TileSelector-itemTitle-2_3_6-wHTTp{margin:unset;color:#01050e;font-family:Public Sans,sans-serif;font-size:.875rem;font-weight:700;line-height:20px}.TileSelector-menuItem-2_3_6-3yr7e p{margin:0;color:#4d5056;font-family:Public Sans,sans-serif;font-size:.875rem;font-weight:400;line-height:20px}.TileSelector-isTileSelectorFocused-2_3_6-dd7QZ:not(.TileSelector-active-2_3_6-JOuWw){border:1px solid #092dbd}.TileSelector-disabled-2_3_6-3EC7i{border:1px solid #f2f2f3;background-color:#f2f2f3;pointer-events:none}.TileSelector-disabled-2_3_6-3EC7i .TileSelector-itemTitle-2_3_6-wHTTp{color:#8e9093}.TileSelector-disabled-2_3_6-3EC7i .TileSelector-media-2_3_6-13exn>svg{width:48px;height:48px;min-width:48px;margin-right:16px;border-radius:1px;color:#8e9093}.TileSelector-disabled-2_3_6-3EC7i:hover:not(.TileSelector-menuItem-2_3_6-3yr7e){border:0}.TileSelector-active-2_3_6-JOuWw{border:2px solid #092dbd}.TileSelector-active-2_3_6-JOuWw .TileSelector-media-2_3_6-13exn>svg{width:48px;height:48px;min-width:48px;margin-right:16px;border-radius:1px;color:#092dbd}.TileSelector-active-2_3_6-JOuWw p{margin:0;color:#01050e}.TileSelector-active-2_3_6-JOuWw:hover{border:2px solid #08088c}", ""]);

// exports
exports.locals = {
	"classic": "TileSelector-classic-2_3_6-2d5mF",
	"itemContainer": "TileSelector-itemContainer-2_3_6-1gmbe",
	"disabled": "TileSelector-disabled-2_3_6-3EC7i",
	"menuItem": "TileSelector-menuItem-2_3_6-3yr7e",
	"active": "TileSelector-active-2_3_6-JOuWw",
	"isTileSelectorFocused": "TileSelector-isTileSelectorFocused-2_3_6-dd7QZ",
	"itemMediaObject": "TileSelector-itemMediaObject-2_3_6-2-Xom",
	"media": "TileSelector-media-2_3_6-13exn",
	"itemTitle": "TileSelector-itemTitle-2_3_6-wHTTp",
	"blueSteel": "TileSelector-blueSteel-2_3_6-1CJ3p"
};

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TileSelectorGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(713);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileSelectorGroup", function() { return _TileSelectorGroup__WEBPACK_IMPORTED_MODULE_0__["default"]; });




/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TileSelectorGroup; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(130);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TileSelectorGroup_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(714);
/* harmony import */ var _TileSelectorGroup_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_TileSelectorGroup_sass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(199);





/**
 Group multiple Tiles together and allow for only one of them to be selected at a time.
 */

function TileSelectorGroup(props) {
  var style = props.style,
      className = props.className,
      testName = props.testName,
      label = props.label,
      tooltip = props.tooltip;
  var tooltipTag = tooltip ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
    className: _TileSelectorGroup_sass__WEBPACK_IMPORTED_MODULE_3___default.a.tooltip
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_4__["default"], {
    content: tooltip
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("noscript", null);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    style: style,
    "data-test-name": testName,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_TileSelectorGroup_sass__WEBPACK_IMPORTED_MODULE_3___default.a.wrapper, className)
  }, label ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
    className: _TileSelectorGroup_sass__WEBPACK_IMPORTED_MODULE_3___default.a.label
  }, label, tooltipTag) : null, props.children);
}
TileSelectorGroup.defaultProps = {
  label: false,
  tootip: false
};
TileSelectorGroup.propTypes = {
  /** Label for a quick description of the selector tiles. */
  label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool]),

  /** Tooltip to describe the tile group. */
  tooltip: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node]),

  /** Items to group together. Usually Tiles. */
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node.isRequired,

  /** Container class name */
  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,

  /** Container style attribute */
  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,

  /** Test name for automation */
  testName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(715);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"insertAt":"top","hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(89)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(88)();
// imports


// module
exports.push([module.i, ".TileSelectorGroup-wrapper-2_3_6-1qugK{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-direction:column;flex-direction:column;width:100%}.TileSelectorGroup-wrapper-2_3_6-1qugK>:not(:last-child){margin-bottom:8px}.TileSelectorGroup-wrapper-2_3_6-1qugK .TileSelectorGroup-label-2_3_6-10kvQ{font-family:Public Sans,sans-serif;font-weight:700;font-size:.75rem;line-height:16px;font-spacing:1px;text-transform:uppercase;color:#4d5056}.TileSelectorGroup-wrapper-2_3_6-1qugK .TileSelectorGroup-label-2_3_6-10kvQ .TileSelectorGroup-tooltip-2_3_6-sre8Y{margin-left:4px}", ""]);

// exports
exports.locals = {
	"wrapper": "TileSelectorGroup-wrapper-2_3_6-1qugK",
	"label": "TileSelectorGroup-label-2_3_6-10kvQ",
	"tooltip": "TileSelectorGroup-tooltip-2_3_6-sre8Y"
};

/***/ })
/******/ ]);
});